(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire806c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire806c"] = parcelRequire;
}
parcelRequire.register("1Lc06", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $14837d539cdd2655$export$ffb0004e005737fa; }, function (v) { return $14837d539cdd2655$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $14837d539cdd2655$export$5f8d39834fd61797; }, function (v) { return $14837d539cdd2655$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $14837d539cdd2655$export$e2c29f18771995cb; }, function (v) { return $14837d539cdd2655$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $14837d539cdd2655$export$74bf444e3cd11ea5; }, function (v) { return $14837d539cdd2655$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $14837d539cdd2655$export$dca3b0875bd9a954; }, function (v) { return $14837d539cdd2655$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $14837d539cdd2655$export$16fa2f45be04daa8; }, function (v) { return $14837d539cdd2655$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $14837d539cdd2655$export$221d75b3f55bb0bd; }, function (v) { return $14837d539cdd2655$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $14837d539cdd2655$export$ae55be85d98224ed; }, function (v) { return $14837d539cdd2655$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $14837d539cdd2655$export$e530037191fcd5d7; }, function (v) { return $14837d539cdd2655$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $14837d539cdd2655$export$fd42f52fd3ae1109; }, function (v) { return $14837d539cdd2655$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $14837d539cdd2655$export$c8a8987d4410bf2d; }, function (v) { return $14837d539cdd2655$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $14837d539cdd2655$export$d38cd72104c1f0e9; }, function (v) { return $14837d539cdd2655$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $14837d539cdd2655$export$7d1e3a5e95ceca43; }, function (v) { return $14837d539cdd2655$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $14837d539cdd2655$export$257a8862b851cb5b; }, function (v) { return $14837d539cdd2655$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $14837d539cdd2655$export$a8257692ac88316c; }, function (v) { return $14837d539cdd2655$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $14837d539cdd2655$export$488013bae63b21da; }, function (v) { return $14837d539cdd2655$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $14837d539cdd2655$export$7c73462e0d25e514; }, function (v) { return $14837d539cdd2655$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $14837d539cdd2655$export$35808ee640e87ca7; }, function (v) { return $14837d539cdd2655$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $14837d539cdd2655$export$fae74005e78b1a27; }, function (v) { return $14837d539cdd2655$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $14837d539cdd2655$export$dc8fbce3eb94dc1e; }, function (v) { return $14837d539cdd2655$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $14837d539cdd2655$export$6d9c69b0de29b591; }, function (v) { return $14837d539cdd2655$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $14837d539cdd2655$export$d5a552a76deda3c2; }, function (v) { return $14837d539cdd2655$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $14837d539cdd2655$export$e5c5a5f917a5871c; }, function (v) { return $14837d539cdd2655$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $14837d539cdd2655$export$1538c33de8887b59; }, function (v) { return $14837d539cdd2655$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $14837d539cdd2655$export$13e3392192263954; }, function (v) { return $14837d539cdd2655$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $14837d539cdd2655$export$b8f5890fc79d6aca; }, function (v) { return $14837d539cdd2655$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $14837d539cdd2655$export$60241385465d0a34; }, function (v) { return $14837d539cdd2655$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $14837d539cdd2655$export$83d89fbfd8236492; }, function (v) { return $14837d539cdd2655$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $14837d539cdd2655$export$ffb0004e005737fa;
var $14837d539cdd2655$export$5f8d39834fd61797;
var $14837d539cdd2655$export$e2c29f18771995cb;
var $14837d539cdd2655$export$74bf444e3cd11ea5;
var $14837d539cdd2655$export$dca3b0875bd9a954;
var $14837d539cdd2655$export$16fa2f45be04daa8;
var $14837d539cdd2655$export$221d75b3f55bb0bd;
var $14837d539cdd2655$export$ae55be85d98224ed;
var $14837d539cdd2655$export$e530037191fcd5d7;
var $14837d539cdd2655$export$fd42f52fd3ae1109;
var $14837d539cdd2655$export$c8a8987d4410bf2d;
var $14837d539cdd2655$export$d38cd72104c1f0e9;
var $14837d539cdd2655$export$7d1e3a5e95ceca43;
var $14837d539cdd2655$export$257a8862b851cb5b;
var $14837d539cdd2655$export$a8257692ac88316c;
var $14837d539cdd2655$export$488013bae63b21da;
var $14837d539cdd2655$export$7c73462e0d25e514;
var $14837d539cdd2655$export$35808ee640e87ca7;
var $14837d539cdd2655$export$fae74005e78b1a27;
var $14837d539cdd2655$export$dc8fbce3eb94dc1e;
var $14837d539cdd2655$export$6d9c69b0de29b591;
var $14837d539cdd2655$export$d5a552a76deda3c2;
var $14837d539cdd2655$export$e5c5a5f917a5871c;
var $14837d539cdd2655$export$1538c33de8887b59;
var $14837d539cdd2655$export$13e3392192263954;
var $14837d539cdd2655$export$b8f5890fc79d6aca;
var $14837d539cdd2655$export$60241385465d0a34;
var $14837d539cdd2655$export$83d89fbfd8236492;
"use strict";

var $9Rwgr = parcelRequire("9Rwgr");
var $14837d539cdd2655$var$n = 60103, $14837d539cdd2655$var$p = 60106;
$14837d539cdd2655$export$ffb0004e005737fa = 60107;
$14837d539cdd2655$export$5f8d39834fd61797 = 60108;
$14837d539cdd2655$export$e2c29f18771995cb = 60114;
var $14837d539cdd2655$var$q = 60109, $14837d539cdd2655$var$r = 60110, $14837d539cdd2655$var$t = 60112;
$14837d539cdd2655$export$74bf444e3cd11ea5 = 60113;
var $14837d539cdd2655$var$u = 60115, $14837d539cdd2655$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $14837d539cdd2655$var$w = Symbol.for;
    $14837d539cdd2655$var$n = $14837d539cdd2655$var$w("react.element");
    $14837d539cdd2655$var$p = $14837d539cdd2655$var$w("react.portal");
    $14837d539cdd2655$export$ffb0004e005737fa = $14837d539cdd2655$var$w("react.fragment");
    $14837d539cdd2655$export$5f8d39834fd61797 = $14837d539cdd2655$var$w("react.strict_mode");
    $14837d539cdd2655$export$e2c29f18771995cb = $14837d539cdd2655$var$w("react.profiler");
    $14837d539cdd2655$var$q = $14837d539cdd2655$var$w("react.provider");
    $14837d539cdd2655$var$r = $14837d539cdd2655$var$w("react.context");
    $14837d539cdd2655$var$t = $14837d539cdd2655$var$w("react.forward_ref");
    $14837d539cdd2655$export$74bf444e3cd11ea5 = $14837d539cdd2655$var$w("react.suspense");
    $14837d539cdd2655$var$u = $14837d539cdd2655$var$w("react.memo");
    $14837d539cdd2655$var$v = $14837d539cdd2655$var$w("react.lazy");
}
var $14837d539cdd2655$var$x = "function" === typeof Symbol && Symbol.iterator;
function $14837d539cdd2655$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $14837d539cdd2655$var$x && a[$14837d539cdd2655$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $14837d539cdd2655$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $14837d539cdd2655$var$A = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $14837d539cdd2655$var$B = {};
function $14837d539cdd2655$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $14837d539cdd2655$var$B;
    this.updater = c || $14837d539cdd2655$var$A;
}
$14837d539cdd2655$var$C.prototype.isReactComponent = {};
$14837d539cdd2655$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($14837d539cdd2655$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$14837d539cdd2655$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $14837d539cdd2655$var$D() {}
$14837d539cdd2655$var$D.prototype = $14837d539cdd2655$var$C.prototype;
function $14837d539cdd2655$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $14837d539cdd2655$var$B;
    this.updater = c || $14837d539cdd2655$var$A;
}
var $14837d539cdd2655$var$F = $14837d539cdd2655$var$E.prototype = new $14837d539cdd2655$var$D;
$14837d539cdd2655$var$F.constructor = $14837d539cdd2655$var$E;
$9Rwgr($14837d539cdd2655$var$F, $14837d539cdd2655$var$C.prototype);
$14837d539cdd2655$var$F.isPureReactComponent = !0;
var $14837d539cdd2655$var$G = {
    current: null
}, $14837d539cdd2655$var$H = Object.prototype.hasOwnProperty, $14837d539cdd2655$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $14837d539cdd2655$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$14837d539cdd2655$var$H.call(b, e) && !$14837d539cdd2655$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $14837d539cdd2655$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $14837d539cdd2655$var$G.current
    };
}
function $14837d539cdd2655$var$K(a, b) {
    return {
        $$typeof: $14837d539cdd2655$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $14837d539cdd2655$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $14837d539cdd2655$var$n;
}
function $14837d539cdd2655$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $14837d539cdd2655$var$M = /\/+/g;
function $14837d539cdd2655$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $14837d539cdd2655$var$escape("" + a.key) : b.toString(36);
}
function $14837d539cdd2655$var$O(a, b, c, e, d) {
    var k = typeof a === "undefined" ? "undefined" : (0, $5F2Q2._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $14837d539cdd2655$var$n:
                case $14837d539cdd2655$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $14837d539cdd2655$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($14837d539cdd2655$var$M, "$&/") + "/"), $14837d539cdd2655$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($14837d539cdd2655$var$L(d) && (d = $14837d539cdd2655$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($14837d539cdd2655$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $14837d539cdd2655$var$N(k, g);
        h += $14837d539cdd2655$var$O(k, b, c, f, d);
    }
    else if (f = $14837d539cdd2655$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $14837d539cdd2655$var$N(k, g++), h += $14837d539cdd2655$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($14837d539cdd2655$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $14837d539cdd2655$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $14837d539cdd2655$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $14837d539cdd2655$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $14837d539cdd2655$var$R = {
    current: null
};
function $14837d539cdd2655$var$S() {
    var a = $14837d539cdd2655$var$R.current;
    if (null === a) throw Error($14837d539cdd2655$var$z(321));
    return a;
}
var $14837d539cdd2655$var$T = {
    ReactCurrentDispatcher: $14837d539cdd2655$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $14837d539cdd2655$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $9Rwgr
};
$14837d539cdd2655$export$dca3b0875bd9a954 = {
    map: $14837d539cdd2655$var$P,
    forEach: function forEach(a, b, c) {
        $14837d539cdd2655$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function count(a) {
        var b = 0;
        $14837d539cdd2655$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $14837d539cdd2655$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$14837d539cdd2655$var$L(a)) throw Error($14837d539cdd2655$var$z(143));
        return a;
    }
};
$14837d539cdd2655$export$16fa2f45be04daa8 = $14837d539cdd2655$var$C;
$14837d539cdd2655$export$221d75b3f55bb0bd = $14837d539cdd2655$var$E;
$14837d539cdd2655$export$ae55be85d98224ed = $14837d539cdd2655$var$T;
$14837d539cdd2655$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($14837d539cdd2655$var$z(267, a));
    var e = $9Rwgr({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $14837d539cdd2655$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$14837d539cdd2655$var$H.call(b, f) && !$14837d539cdd2655$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $14837d539cdd2655$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$14837d539cdd2655$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $14837d539cdd2655$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $14837d539cdd2655$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$14837d539cdd2655$export$c8a8987d4410bf2d = $14837d539cdd2655$var$J;
$14837d539cdd2655$export$d38cd72104c1f0e9 = function(a) {
    var b = $14837d539cdd2655$var$J.bind(null, a);
    b.type = a;
    return b;
};
$14837d539cdd2655$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$14837d539cdd2655$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $14837d539cdd2655$var$t,
        render: a
    };
};
$14837d539cdd2655$export$a8257692ac88316c = $14837d539cdd2655$var$L;
$14837d539cdd2655$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $14837d539cdd2655$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $14837d539cdd2655$var$Q
    };
};
$14837d539cdd2655$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $14837d539cdd2655$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$14837d539cdd2655$export$35808ee640e87ca7 = function(a, b) {
    return $14837d539cdd2655$var$S().useCallback(a, b);
};
$14837d539cdd2655$export$fae74005e78b1a27 = function(a, b) {
    return $14837d539cdd2655$var$S().useContext(a, b);
};
$14837d539cdd2655$export$dc8fbce3eb94dc1e = function() {};
$14837d539cdd2655$export$6d9c69b0de29b591 = function(a, b) {
    return $14837d539cdd2655$var$S().useEffect(a, b);
};
$14837d539cdd2655$export$d5a552a76deda3c2 = function(a, b, c) {
    return $14837d539cdd2655$var$S().useImperativeHandle(a, b, c);
};
$14837d539cdd2655$export$e5c5a5f917a5871c = function(a, b) {
    return $14837d539cdd2655$var$S().useLayoutEffect(a, b);
};
$14837d539cdd2655$export$1538c33de8887b59 = function(a, b) {
    return $14837d539cdd2655$var$S().useMemo(a, b);
};
$14837d539cdd2655$export$13e3392192263954 = function(a, b, c) {
    return $14837d539cdd2655$var$S().useReducer(a, b, c);
};
$14837d539cdd2655$export$b8f5890fc79d6aca = function(a) {
    return $14837d539cdd2655$var$S().useRef(a);
};
$14837d539cdd2655$export$60241385465d0a34 = function(a) {
    return $14837d539cdd2655$var$S().useState(a);
};
$14837d539cdd2655$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("5F2Q2", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $41f2fbbad7f9ecd3$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $41f2fbbad7f9ecd3$export$5f0017c582d45a2d; });
function $41f2fbbad7f9ecd3$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRequire.register("9Rwgr", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $72e21747cf249997$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72e21747cf249997$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $72e21747cf249997$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $72e21747cf249997$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $72e21747cf249997$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $72e21747cf249997$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $72e21747cf249997$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($72e21747cf249997$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($72e21747cf249997$var$getOwnPropertySymbols) {
            symbols = $72e21747cf249997$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($72e21747cf249997$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRequire.register("iacei", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $fWhJe = parcelRequire("fWhJe");
function $d392a5b744198a27$var$emptyFunction() {}
function $d392a5b744198a27$var$emptyFunctionWithReset() {}
$d392a5b744198a27$var$emptyFunctionWithReset.resetWarningCache = $d392a5b744198a27$var$emptyFunction;
module.exports = function() {
    var shim = function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fWhJe) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    };
    var getShim = function getShim() {
        return shim;
    };
    shim.isRequired = shim;
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d392a5b744198a27$var$emptyFunctionWithReset,
        resetWarningCache: $d392a5b744198a27$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("fWhJe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $b9aa065273818400$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $b9aa065273818400$var$ReactPropTypesSecret;

});


parcelRequire.register("jMtYM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $e669c1461a5eb86b$export$1e511d4a378977f5; }, function (v) { return $e669c1461a5eb86b$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $e669c1461a5eb86b$export$2e2bcd8739ae039; }, function (v) { return $e669c1461a5eb86b$export$2e2bcd8739ae039 = v; });
var $e669c1461a5eb86b$export$1e511d4a378977f5;
var $e669c1461a5eb86b$export$2e2bcd8739ae039;
"use strict";
$e669c1461a5eb86b$export$1e511d4a378977f5 = true;
$e669c1461a5eb86b$export$2e2bcd8739ae039 = $e669c1461a5eb86b$var$createWebStorage;

var $e669c1461a5eb86b$var$_getStorage = $e669c1461a5eb86b$var$_interopRequireDefault((parcelRequire("gcllp")));
function $e669c1461a5eb86b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e669c1461a5eb86b$var$createWebStorage(type) {
    var storage = (0, $e669c1461a5eb86b$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRequire.register("gcllp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $bcae52e28e34fbf1$export$1e511d4a378977f5; }, function (v) { return $bcae52e28e34fbf1$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $bcae52e28e34fbf1$export$2e2bcd8739ae039; }, function (v) { return $bcae52e28e34fbf1$export$2e2bcd8739ae039 = v; });

var $5F2Q2 = parcelRequire("5F2Q2");
var $bcae52e28e34fbf1$export$1e511d4a378977f5;
var $bcae52e28e34fbf1$export$2e2bcd8739ae039;
"use strict";
$bcae52e28e34fbf1$export$1e511d4a378977f5 = true;
$bcae52e28e34fbf1$export$2e2bcd8739ae039 = $bcae52e28e34fbf1$var$getStorage;
function $bcae52e28e34fbf1$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $5F2Q2._)(Symbol.iterator) === "symbol") $bcae52e28e34fbf1$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    else $bcae52e28e34fbf1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    return $bcae52e28e34fbf1$var$_typeof(obj);
}
function $bcae52e28e34fbf1$var$noop() {}
var $bcae52e28e34fbf1$var$noopStorage = {
    getItem: $bcae52e28e34fbf1$var$noop,
    setItem: $bcae52e28e34fbf1$var$noop,
    removeItem: $bcae52e28e34fbf1$var$noop
};
function $bcae52e28e34fbf1$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $bcae52e28e34fbf1$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $bcae52e28e34fbf1$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($bcae52e28e34fbf1$var$hasStorage(storageType)) return self[storageType];
    else return $bcae52e28e34fbf1$var$noopStorage;
}

});


parcelRequire.register("iHreN", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $d9d15ef3cbbc3574$export$2b8d127b894957b9; }, function (v) { return $d9d15ef3cbbc3574$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $d9d15ef3cbbc3574$export$cea3a54a6425200c; }, function (v) { return $d9d15ef3cbbc3574$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $d9d15ef3cbbc3574$export$a7c73072b1a182ae; }, function (v) { return $d9d15ef3cbbc3574$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d9d15ef3cbbc3574$export$9f27bc3417b4524d; }, function (v) { return $d9d15ef3cbbc3574$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d9d15ef3cbbc3574$export$db77ccec0bb4ccac; }, function (v) { return $d9d15ef3cbbc3574$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d9d15ef3cbbc3574$export$8392c0c9d3dcbd35; }, function (v) { return $d9d15ef3cbbc3574$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d9d15ef3cbbc3574$export$ffb0004e005737fa; }, function (v) { return $d9d15ef3cbbc3574$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d9d15ef3cbbc3574$export$b624eff549462981; }, function (v) { return $d9d15ef3cbbc3574$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d9d15ef3cbbc3574$export$7897aa7841a5380c; }, function (v) { return $d9d15ef3cbbc3574$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d9d15ef3cbbc3574$export$602eac185826482c; }, function (v) { return $d9d15ef3cbbc3574$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d9d15ef3cbbc3574$export$e2c29f18771995cb; }, function (v) { return $d9d15ef3cbbc3574$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d9d15ef3cbbc3574$export$5f8d39834fd61797; }, function (v) { return $d9d15ef3cbbc3574$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d9d15ef3cbbc3574$export$74bf444e3cd11ea5; }, function (v) { return $d9d15ef3cbbc3574$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d9d15ef3cbbc3574$export$92387174baf9b227; }, function (v) { return $d9d15ef3cbbc3574$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d9d15ef3cbbc3574$export$ec112efeb987d9c6; }, function (v) { return $d9d15ef3cbbc3574$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d9d15ef3cbbc3574$export$b706b080d889d2c9; }, function (v) { return $d9d15ef3cbbc3574$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d9d15ef3cbbc3574$export$5be5a87408f70ddc; }, function (v) { return $d9d15ef3cbbc3574$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d9d15ef3cbbc3574$export$45a5e7f76e0caa8d; }, function (v) { return $d9d15ef3cbbc3574$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d9d15ef3cbbc3574$export$455c2e768291efa6; }, function (v) { return $d9d15ef3cbbc3574$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d9d15ef3cbbc3574$export$9522e17588c12572; }, function (v) { return $d9d15ef3cbbc3574$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d9d15ef3cbbc3574$export$2110ac352bb060b9; }, function (v) { return $d9d15ef3cbbc3574$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d9d15ef3cbbc3574$export$56885ab8b9c456ab; }, function (v) { return $d9d15ef3cbbc3574$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d9d15ef3cbbc3574$export$d927fcb6adf8f9de; }, function (v) { return $d9d15ef3cbbc3574$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d9d15ef3cbbc3574$export$b82d16f27459e05a; }, function (v) { return $d9d15ef3cbbc3574$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d9d15ef3cbbc3574$export$522c17b4f5e123e8; }, function (v) { return $d9d15ef3cbbc3574$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d9d15ef3cbbc3574$export$1aabd8a0274ecfd6; }, function (v) { return $d9d15ef3cbbc3574$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d9d15ef3cbbc3574$export$9b621391a187a31a; }, function (v) { return $d9d15ef3cbbc3574$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d9d15ef3cbbc3574$export$f5bbd400c2f4426f; }, function (v) { return $d9d15ef3cbbc3574$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9d15ef3cbbc3574$export$2b8d127b894957b9;
var $d9d15ef3cbbc3574$export$cea3a54a6425200c;
var $d9d15ef3cbbc3574$export$a7c73072b1a182ae;
var $d9d15ef3cbbc3574$export$9f27bc3417b4524d;
var $d9d15ef3cbbc3574$export$db77ccec0bb4ccac;
var $d9d15ef3cbbc3574$export$8392c0c9d3dcbd35;
var $d9d15ef3cbbc3574$export$ffb0004e005737fa;
var $d9d15ef3cbbc3574$export$b624eff549462981;
var $d9d15ef3cbbc3574$export$7897aa7841a5380c;
var $d9d15ef3cbbc3574$export$602eac185826482c;
var $d9d15ef3cbbc3574$export$e2c29f18771995cb;
var $d9d15ef3cbbc3574$export$5f8d39834fd61797;
var $d9d15ef3cbbc3574$export$74bf444e3cd11ea5;
var $d9d15ef3cbbc3574$export$92387174baf9b227;
var $d9d15ef3cbbc3574$export$ec112efeb987d9c6;
var $d9d15ef3cbbc3574$export$b706b080d889d2c9;
var $d9d15ef3cbbc3574$export$5be5a87408f70ddc;
var $d9d15ef3cbbc3574$export$45a5e7f76e0caa8d;
var $d9d15ef3cbbc3574$export$455c2e768291efa6;
var $d9d15ef3cbbc3574$export$9522e17588c12572;
var $d9d15ef3cbbc3574$export$2110ac352bb060b9;
var $d9d15ef3cbbc3574$export$56885ab8b9c456ab;
var $d9d15ef3cbbc3574$export$d927fcb6adf8f9de;
var $d9d15ef3cbbc3574$export$b82d16f27459e05a;
var $d9d15ef3cbbc3574$export$522c17b4f5e123e8;
var $d9d15ef3cbbc3574$export$1aabd8a0274ecfd6;
var $d9d15ef3cbbc3574$export$9b621391a187a31a;
var $d9d15ef3cbbc3574$export$f5bbd400c2f4426f;
"use strict";
var $d9d15ef3cbbc3574$var$b = "function" === typeof Symbol && Symbol.for, $d9d15ef3cbbc3574$var$c = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.element") : 60103, $d9d15ef3cbbc3574$var$d = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.portal") : 60106, $d9d15ef3cbbc3574$var$e = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.fragment") : 60107, $d9d15ef3cbbc3574$var$f = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.strict_mode") : 60108, $d9d15ef3cbbc3574$var$g = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.profiler") : 60114, $d9d15ef3cbbc3574$var$h = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.provider") : 60109, $d9d15ef3cbbc3574$var$k = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.context") : 60110, $d9d15ef3cbbc3574$var$l = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.async_mode") : 60111, $d9d15ef3cbbc3574$var$m = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.concurrent_mode") : 60111, $d9d15ef3cbbc3574$var$n = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.forward_ref") : 60112, $d9d15ef3cbbc3574$var$p = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.suspense") : 60113, $d9d15ef3cbbc3574$var$q = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.suspense_list") : 60120, $d9d15ef3cbbc3574$var$r = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.memo") : 60115, $d9d15ef3cbbc3574$var$t = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.lazy") : 60116, $d9d15ef3cbbc3574$var$v = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.block") : 60121, $d9d15ef3cbbc3574$var$w = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.fundamental") : 60117, $d9d15ef3cbbc3574$var$x = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.responder") : 60118, $d9d15ef3cbbc3574$var$y = $d9d15ef3cbbc3574$var$b ? Symbol.for("react.scope") : 60119;
function $d9d15ef3cbbc3574$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $d9d15ef3cbbc3574$var$c:
                switch(a = a.type, a){
                    case $d9d15ef3cbbc3574$var$l:
                    case $d9d15ef3cbbc3574$var$m:
                    case $d9d15ef3cbbc3574$var$e:
                    case $d9d15ef3cbbc3574$var$g:
                    case $d9d15ef3cbbc3574$var$f:
                    case $d9d15ef3cbbc3574$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d9d15ef3cbbc3574$var$k:
                            case $d9d15ef3cbbc3574$var$n:
                            case $d9d15ef3cbbc3574$var$t:
                            case $d9d15ef3cbbc3574$var$r:
                            case $d9d15ef3cbbc3574$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $d9d15ef3cbbc3574$var$d:
                return u;
        }
    }
}
function $d9d15ef3cbbc3574$var$A(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$m;
}
$d9d15ef3cbbc3574$export$2b8d127b894957b9 = $d9d15ef3cbbc3574$var$l;
$d9d15ef3cbbc3574$export$cea3a54a6425200c = $d9d15ef3cbbc3574$var$m;
$d9d15ef3cbbc3574$export$a7c73072b1a182ae = $d9d15ef3cbbc3574$var$k;
$d9d15ef3cbbc3574$export$9f27bc3417b4524d = $d9d15ef3cbbc3574$var$h;
$d9d15ef3cbbc3574$export$db77ccec0bb4ccac = $d9d15ef3cbbc3574$var$c;
$d9d15ef3cbbc3574$export$8392c0c9d3dcbd35 = $d9d15ef3cbbc3574$var$n;
$d9d15ef3cbbc3574$export$ffb0004e005737fa = $d9d15ef3cbbc3574$var$e;
$d9d15ef3cbbc3574$export$b624eff549462981 = $d9d15ef3cbbc3574$var$t;
$d9d15ef3cbbc3574$export$7897aa7841a5380c = $d9d15ef3cbbc3574$var$r;
$d9d15ef3cbbc3574$export$602eac185826482c = $d9d15ef3cbbc3574$var$d;
$d9d15ef3cbbc3574$export$e2c29f18771995cb = $d9d15ef3cbbc3574$var$g;
$d9d15ef3cbbc3574$export$5f8d39834fd61797 = $d9d15ef3cbbc3574$var$f;
$d9d15ef3cbbc3574$export$74bf444e3cd11ea5 = $d9d15ef3cbbc3574$var$p;
$d9d15ef3cbbc3574$export$92387174baf9b227 = function(a) {
    return $d9d15ef3cbbc3574$var$A(a) || $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$l;
};
$d9d15ef3cbbc3574$export$ec112efeb987d9c6 = $d9d15ef3cbbc3574$var$A;
$d9d15ef3cbbc3574$export$b706b080d889d2c9 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$k;
};
$d9d15ef3cbbc3574$export$5be5a87408f70ddc = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$h;
};
$d9d15ef3cbbc3574$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d9d15ef3cbbc3574$var$c;
};
$d9d15ef3cbbc3574$export$455c2e768291efa6 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$n;
};
$d9d15ef3cbbc3574$export$9522e17588c12572 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$e;
};
$d9d15ef3cbbc3574$export$2110ac352bb060b9 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$t;
};
$d9d15ef3cbbc3574$export$56885ab8b9c456ab = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$r;
};
$d9d15ef3cbbc3574$export$d927fcb6adf8f9de = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$d;
};
$d9d15ef3cbbc3574$export$b82d16f27459e05a = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$g;
};
$d9d15ef3cbbc3574$export$522c17b4f5e123e8 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$f;
};
$d9d15ef3cbbc3574$export$1aabd8a0274ecfd6 = function(a) {
    return $d9d15ef3cbbc3574$var$z(a) === $d9d15ef3cbbc3574$var$p;
};
$d9d15ef3cbbc3574$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d9d15ef3cbbc3574$var$e || a === $d9d15ef3cbbc3574$var$m || a === $d9d15ef3cbbc3574$var$g || a === $d9d15ef3cbbc3574$var$f || a === $d9d15ef3cbbc3574$var$p || a === $d9d15ef3cbbc3574$var$q || "object" === typeof a && null !== a && (a.$$typeof === $d9d15ef3cbbc3574$var$t || a.$$typeof === $d9d15ef3cbbc3574$var$r || a.$$typeof === $d9d15ef3cbbc3574$var$h || a.$$typeof === $d9d15ef3cbbc3574$var$k || a.$$typeof === $d9d15ef3cbbc3574$var$n || a.$$typeof === $d9d15ef3cbbc3574$var$w || a.$$typeof === $d9d15ef3cbbc3574$var$x || a.$$typeof === $d9d15ef3cbbc3574$var$y || a.$$typeof === $d9d15ef3cbbc3574$var$v);
};
$d9d15ef3cbbc3574$export$f5bbd400c2f4426f = $d9d15ef3cbbc3574$var$z;

});

parcelRequire.register("jIewG", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e59d64f5fda153a1$export$a7c73072b1a182ae; }, function (v) { return $e59d64f5fda153a1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e59d64f5fda153a1$export$9f27bc3417b4524d; }, function (v) { return $e59d64f5fda153a1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e59d64f5fda153a1$export$db77ccec0bb4ccac; }, function (v) { return $e59d64f5fda153a1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e59d64f5fda153a1$export$8392c0c9d3dcbd35; }, function (v) { return $e59d64f5fda153a1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e59d64f5fda153a1$export$ffb0004e005737fa; }, function (v) { return $e59d64f5fda153a1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e59d64f5fda153a1$export$b624eff549462981; }, function (v) { return $e59d64f5fda153a1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e59d64f5fda153a1$export$7897aa7841a5380c; }, function (v) { return $e59d64f5fda153a1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e59d64f5fda153a1$export$602eac185826482c; }, function (v) { return $e59d64f5fda153a1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e59d64f5fda153a1$export$e2c29f18771995cb; }, function (v) { return $e59d64f5fda153a1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e59d64f5fda153a1$export$5f8d39834fd61797; }, function (v) { return $e59d64f5fda153a1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e59d64f5fda153a1$export$74bf444e3cd11ea5; }, function (v) { return $e59d64f5fda153a1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e59d64f5fda153a1$export$92387174baf9b227; }, function (v) { return $e59d64f5fda153a1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e59d64f5fda153a1$export$ec112efeb987d9c6; }, function (v) { return $e59d64f5fda153a1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e59d64f5fda153a1$export$b706b080d889d2c9; }, function (v) { return $e59d64f5fda153a1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e59d64f5fda153a1$export$5be5a87408f70ddc; }, function (v) { return $e59d64f5fda153a1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e59d64f5fda153a1$export$45a5e7f76e0caa8d; }, function (v) { return $e59d64f5fda153a1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e59d64f5fda153a1$export$455c2e768291efa6; }, function (v) { return $e59d64f5fda153a1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e59d64f5fda153a1$export$9522e17588c12572; }, function (v) { return $e59d64f5fda153a1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e59d64f5fda153a1$export$2110ac352bb060b9; }, function (v) { return $e59d64f5fda153a1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e59d64f5fda153a1$export$56885ab8b9c456ab; }, function (v) { return $e59d64f5fda153a1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e59d64f5fda153a1$export$d927fcb6adf8f9de; }, function (v) { return $e59d64f5fda153a1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e59d64f5fda153a1$export$b82d16f27459e05a; }, function (v) { return $e59d64f5fda153a1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e59d64f5fda153a1$export$522c17b4f5e123e8; }, function (v) { return $e59d64f5fda153a1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e59d64f5fda153a1$export$1aabd8a0274ecfd6; }, function (v) { return $e59d64f5fda153a1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e59d64f5fda153a1$export$9b621391a187a31a; }, function (v) { return $e59d64f5fda153a1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e59d64f5fda153a1$export$f5bbd400c2f4426f; }, function (v) { return $e59d64f5fda153a1$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59d64f5fda153a1$export$a7c73072b1a182ae;
var $e59d64f5fda153a1$export$9f27bc3417b4524d;
var $e59d64f5fda153a1$export$db77ccec0bb4ccac;
var $e59d64f5fda153a1$export$8392c0c9d3dcbd35;
var $e59d64f5fda153a1$export$ffb0004e005737fa;
var $e59d64f5fda153a1$export$b624eff549462981;
var $e59d64f5fda153a1$export$7897aa7841a5380c;
var $e59d64f5fda153a1$export$602eac185826482c;
var $e59d64f5fda153a1$export$e2c29f18771995cb;
var $e59d64f5fda153a1$export$5f8d39834fd61797;
var $e59d64f5fda153a1$export$74bf444e3cd11ea5;
var $e59d64f5fda153a1$export$92387174baf9b227;
var $e59d64f5fda153a1$export$ec112efeb987d9c6;
var $e59d64f5fda153a1$export$b706b080d889d2c9;
var $e59d64f5fda153a1$export$5be5a87408f70ddc;
var $e59d64f5fda153a1$export$45a5e7f76e0caa8d;
var $e59d64f5fda153a1$export$455c2e768291efa6;
var $e59d64f5fda153a1$export$9522e17588c12572;
var $e59d64f5fda153a1$export$2110ac352bb060b9;
var $e59d64f5fda153a1$export$56885ab8b9c456ab;
var $e59d64f5fda153a1$export$d927fcb6adf8f9de;
var $e59d64f5fda153a1$export$b82d16f27459e05a;
var $e59d64f5fda153a1$export$522c17b4f5e123e8;
var $e59d64f5fda153a1$export$1aabd8a0274ecfd6;
var $e59d64f5fda153a1$export$9b621391a187a31a;
var $e59d64f5fda153a1$export$f5bbd400c2f4426f;
"use strict";
var $e59d64f5fda153a1$var$b = 60103, $e59d64f5fda153a1$var$c = 60106, $e59d64f5fda153a1$var$d = 60107, $e59d64f5fda153a1$var$e = 60108, $e59d64f5fda153a1$var$f = 60114, $e59d64f5fda153a1$var$g = 60109, $e59d64f5fda153a1$var$h = 60110, $e59d64f5fda153a1$var$k = 60112, $e59d64f5fda153a1$var$l = 60113, $e59d64f5fda153a1$var$m = 60120, $e59d64f5fda153a1$var$n = 60115, $e59d64f5fda153a1$var$p = 60116, $e59d64f5fda153a1$var$q = 60121, $e59d64f5fda153a1$var$r = 60122, $e59d64f5fda153a1$var$u = 60117, $e59d64f5fda153a1$var$v = 60129, $e59d64f5fda153a1$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $e59d64f5fda153a1$var$x = Symbol.for;
    $e59d64f5fda153a1$var$b = $e59d64f5fda153a1$var$x("react.element");
    $e59d64f5fda153a1$var$c = $e59d64f5fda153a1$var$x("react.portal");
    $e59d64f5fda153a1$var$d = $e59d64f5fda153a1$var$x("react.fragment");
    $e59d64f5fda153a1$var$e = $e59d64f5fda153a1$var$x("react.strict_mode");
    $e59d64f5fda153a1$var$f = $e59d64f5fda153a1$var$x("react.profiler");
    $e59d64f5fda153a1$var$g = $e59d64f5fda153a1$var$x("react.provider");
    $e59d64f5fda153a1$var$h = $e59d64f5fda153a1$var$x("react.context");
    $e59d64f5fda153a1$var$k = $e59d64f5fda153a1$var$x("react.forward_ref");
    $e59d64f5fda153a1$var$l = $e59d64f5fda153a1$var$x("react.suspense");
    $e59d64f5fda153a1$var$m = $e59d64f5fda153a1$var$x("react.suspense_list");
    $e59d64f5fda153a1$var$n = $e59d64f5fda153a1$var$x("react.memo");
    $e59d64f5fda153a1$var$p = $e59d64f5fda153a1$var$x("react.lazy");
    $e59d64f5fda153a1$var$q = $e59d64f5fda153a1$var$x("react.block");
    $e59d64f5fda153a1$var$r = $e59d64f5fda153a1$var$x("react.server.block");
    $e59d64f5fda153a1$var$u = $e59d64f5fda153a1$var$x("react.fundamental");
    $e59d64f5fda153a1$var$v = $e59d64f5fda153a1$var$x("react.debug_trace_mode");
    $e59d64f5fda153a1$var$w = $e59d64f5fda153a1$var$x("react.legacy_hidden");
}
function $e59d64f5fda153a1$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $e59d64f5fda153a1$var$b:
                switch(a = a.type, a){
                    case $e59d64f5fda153a1$var$d:
                    case $e59d64f5fda153a1$var$f:
                    case $e59d64f5fda153a1$var$e:
                    case $e59d64f5fda153a1$var$l:
                    case $e59d64f5fda153a1$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e59d64f5fda153a1$var$h:
                            case $e59d64f5fda153a1$var$k:
                            case $e59d64f5fda153a1$var$p:
                            case $e59d64f5fda153a1$var$n:
                            case $e59d64f5fda153a1$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $e59d64f5fda153a1$var$c:
                return t;
        }
    }
}
var $e59d64f5fda153a1$var$z = $e59d64f5fda153a1$var$g, $e59d64f5fda153a1$var$A = $e59d64f5fda153a1$var$b, $e59d64f5fda153a1$var$B = $e59d64f5fda153a1$var$k, $e59d64f5fda153a1$var$C = $e59d64f5fda153a1$var$d, $e59d64f5fda153a1$var$D = $e59d64f5fda153a1$var$p, $e59d64f5fda153a1$var$E = $e59d64f5fda153a1$var$n, $e59d64f5fda153a1$var$F = $e59d64f5fda153a1$var$c, $e59d64f5fda153a1$var$G = $e59d64f5fda153a1$var$f, $e59d64f5fda153a1$var$H = $e59d64f5fda153a1$var$e, $e59d64f5fda153a1$var$I = $e59d64f5fda153a1$var$l;
$e59d64f5fda153a1$export$a7c73072b1a182ae = $e59d64f5fda153a1$var$h;
$e59d64f5fda153a1$export$9f27bc3417b4524d = $e59d64f5fda153a1$var$z;
$e59d64f5fda153a1$export$db77ccec0bb4ccac = $e59d64f5fda153a1$var$A;
$e59d64f5fda153a1$export$8392c0c9d3dcbd35 = $e59d64f5fda153a1$var$B;
$e59d64f5fda153a1$export$ffb0004e005737fa = $e59d64f5fda153a1$var$C;
$e59d64f5fda153a1$export$b624eff549462981 = $e59d64f5fda153a1$var$D;
$e59d64f5fda153a1$export$7897aa7841a5380c = $e59d64f5fda153a1$var$E;
$e59d64f5fda153a1$export$602eac185826482c = $e59d64f5fda153a1$var$F;
$e59d64f5fda153a1$export$e2c29f18771995cb = $e59d64f5fda153a1$var$G;
$e59d64f5fda153a1$export$5f8d39834fd61797 = $e59d64f5fda153a1$var$H;
$e59d64f5fda153a1$export$74bf444e3cd11ea5 = $e59d64f5fda153a1$var$I;
$e59d64f5fda153a1$export$92387174baf9b227 = function() {
    return !1;
};
$e59d64f5fda153a1$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e59d64f5fda153a1$export$b706b080d889d2c9 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$h;
};
$e59d64f5fda153a1$export$5be5a87408f70ddc = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$g;
};
$e59d64f5fda153a1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e59d64f5fda153a1$var$b;
};
$e59d64f5fda153a1$export$455c2e768291efa6 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$k;
};
$e59d64f5fda153a1$export$9522e17588c12572 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$d;
};
$e59d64f5fda153a1$export$2110ac352bb060b9 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$p;
};
$e59d64f5fda153a1$export$56885ab8b9c456ab = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$n;
};
$e59d64f5fda153a1$export$d927fcb6adf8f9de = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$c;
};
$e59d64f5fda153a1$export$b82d16f27459e05a = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$f;
};
$e59d64f5fda153a1$export$522c17b4f5e123e8 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$e;
};
$e59d64f5fda153a1$export$1aabd8a0274ecfd6 = function(a) {
    return $e59d64f5fda153a1$var$y(a) === $e59d64f5fda153a1$var$l;
};
$e59d64f5fda153a1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e59d64f5fda153a1$var$d || a === $e59d64f5fda153a1$var$f || a === $e59d64f5fda153a1$var$v || a === $e59d64f5fda153a1$var$e || a === $e59d64f5fda153a1$var$l || a === $e59d64f5fda153a1$var$m || a === $e59d64f5fda153a1$var$w || "object" === typeof a && null !== a && (a.$$typeof === $e59d64f5fda153a1$var$p || a.$$typeof === $e59d64f5fda153a1$var$n || a.$$typeof === $e59d64f5fda153a1$var$g || a.$$typeof === $e59d64f5fda153a1$var$h || a.$$typeof === $e59d64f5fda153a1$var$k || a.$$typeof === $e59d64f5fda153a1$var$u || a.$$typeof === $e59d64f5fda153a1$var$q || a[0] === $e59d64f5fda153a1$var$r) ? !0 : !1;
};
$e59d64f5fda153a1$export$f5bbd400c2f4426f = $e59d64f5fda153a1$var$y;

});

parcelRequire.register("dTzuM", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a1dbf210d8994fb8$export$ae55be85d98224ed; }, function (v) { return $a1dbf210d8994fb8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a1dbf210d8994fb8$export$d39a5bbd09211389; }, function (v) { return $a1dbf210d8994fb8$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a1dbf210d8994fb8$export$466bfc07425424d5; }, function (v) { return $a1dbf210d8994fb8$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a1dbf210d8994fb8$export$cd75ccfd720a3cd4; }, function (v) { return $a1dbf210d8994fb8$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a1dbf210d8994fb8$export$fa8d919ba61d84db; }, function (v) { return $a1dbf210d8994fb8$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $a1dbf210d8994fb8$export$b3890eb0ae9dca99; }, function (v) { return $a1dbf210d8994fb8$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a1dbf210d8994fb8$export$502457920280e6be; }, function (v) { return $a1dbf210d8994fb8$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a1dbf210d8994fb8$export$c78a37762a8d58e1; }, function (v) { return $a1dbf210d8994fb8$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $a1dbf210d8994fb8$export$2577ef5d2565d52f; }, function (v) { return $a1dbf210d8994fb8$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a1dbf210d8994fb8$export$dc54d992c10e8a18; }, function (v) { return $a1dbf210d8994fb8$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a1dbf210d8994fb8$export$83d89fbfd8236492; }, function (v) { return $a1dbf210d8994fb8$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $a1dbf210d8994fb8$export$ae55be85d98224ed;
var $a1dbf210d8994fb8$export$d39a5bbd09211389;
var $a1dbf210d8994fb8$export$466bfc07425424d5;
var $a1dbf210d8994fb8$export$cd75ccfd720a3cd4;
var $a1dbf210d8994fb8$export$fa8d919ba61d84db;
var $a1dbf210d8994fb8$export$b3890eb0ae9dca99;
var $a1dbf210d8994fb8$export$502457920280e6be;
var $a1dbf210d8994fb8$export$c78a37762a8d58e1;
var $a1dbf210d8994fb8$export$2577ef5d2565d52f;
var $a1dbf210d8994fb8$export$dc54d992c10e8a18;
var $a1dbf210d8994fb8$export$83d89fbfd8236492;
"use strict";

var $4CEbD = parcelRequire("4CEbD");

var $9Rwgr = parcelRequire("9Rwgr");

var $3KFEz = parcelRequire("3KFEz");
function $a1dbf210d8994fb8$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$4CEbD) throw Error($a1dbf210d8994fb8$var$y(227));
var $a1dbf210d8994fb8$var$ba = new Set, $a1dbf210d8994fb8$var$ca = {};
function $a1dbf210d8994fb8$var$da(a, b) {
    $a1dbf210d8994fb8$var$ea(a, b);
    $a1dbf210d8994fb8$var$ea(a + "Capture", b);
}
function $a1dbf210d8994fb8$var$ea(a, b) {
    $a1dbf210d8994fb8$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$a1dbf210d8994fb8$var$ba.add(b[a]);
}
var $a1dbf210d8994fb8$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a1dbf210d8994fb8$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a1dbf210d8994fb8$var$ia = Object.prototype.hasOwnProperty, $a1dbf210d8994fb8$var$ja = {}, $a1dbf210d8994fb8$var$ka = {};
function $a1dbf210d8994fb8$var$la(a) {
    if ($a1dbf210d8994fb8$var$ia.call($a1dbf210d8994fb8$var$ka, a)) return !0;
    if ($a1dbf210d8994fb8$var$ia.call($a1dbf210d8994fb8$var$ja, a)) return !1;
    if ($a1dbf210d8994fb8$var$ha.test(a)) return $a1dbf210d8994fb8$var$ka[a] = !0;
    $a1dbf210d8994fb8$var$ja[a] = !0;
    return !1;
}
function $a1dbf210d8994fb8$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $5F2Q2._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a1dbf210d8994fb8$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a1dbf210d8994fb8$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a1dbf210d8994fb8$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a1dbf210d8994fb8$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a1dbf210d8994fb8$var$D[b] = new $a1dbf210d8994fb8$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a1dbf210d8994fb8$var$oa = /[\-:]([a-z])/g;
function $a1dbf210d8994fb8$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a1dbf210d8994fb8$var$oa, $a1dbf210d8994fb8$var$pa);
    $a1dbf210d8994fb8$var$D[b] = new $a1dbf210d8994fb8$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a1dbf210d8994fb8$var$oa, $a1dbf210d8994fb8$var$pa);
    $a1dbf210d8994fb8$var$D[b] = new $a1dbf210d8994fb8$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a1dbf210d8994fb8$var$oa, $a1dbf210d8994fb8$var$pa);
    $a1dbf210d8994fb8$var$D[b] = new $a1dbf210d8994fb8$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a1dbf210d8994fb8$var$D.xlinkHref = new $a1dbf210d8994fb8$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a1dbf210d8994fb8$var$D[a] = new $a1dbf210d8994fb8$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a1dbf210d8994fb8$var$qa(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$D.hasOwnProperty(b) ? $a1dbf210d8994fb8$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($a1dbf210d8994fb8$var$na(b, c, e, d) && (c = null), d || null === e ? $a1dbf210d8994fb8$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $a1dbf210d8994fb8$var$ra = $4CEbD.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a1dbf210d8994fb8$var$sa = 60103, $a1dbf210d8994fb8$var$ta = 60106, $a1dbf210d8994fb8$var$ua = 60107, $a1dbf210d8994fb8$var$wa = 60108, $a1dbf210d8994fb8$var$xa = 60114, $a1dbf210d8994fb8$var$ya = 60109, $a1dbf210d8994fb8$var$za = 60110, $a1dbf210d8994fb8$var$Aa = 60112, $a1dbf210d8994fb8$var$Ba = 60113, $a1dbf210d8994fb8$var$Ca = 60120, $a1dbf210d8994fb8$var$Da = 60115, $a1dbf210d8994fb8$var$Ea = 60116, $a1dbf210d8994fb8$var$Fa = 60121, $a1dbf210d8994fb8$var$Ga = 60128, $a1dbf210d8994fb8$var$Ha = 60129, $a1dbf210d8994fb8$var$Ia = 60130, $a1dbf210d8994fb8$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $a1dbf210d8994fb8$var$E = Symbol.for;
    $a1dbf210d8994fb8$var$sa = $a1dbf210d8994fb8$var$E("react.element");
    $a1dbf210d8994fb8$var$ta = $a1dbf210d8994fb8$var$E("react.portal");
    $a1dbf210d8994fb8$var$ua = $a1dbf210d8994fb8$var$E("react.fragment");
    $a1dbf210d8994fb8$var$wa = $a1dbf210d8994fb8$var$E("react.strict_mode");
    $a1dbf210d8994fb8$var$xa = $a1dbf210d8994fb8$var$E("react.profiler");
    $a1dbf210d8994fb8$var$ya = $a1dbf210d8994fb8$var$E("react.provider");
    $a1dbf210d8994fb8$var$za = $a1dbf210d8994fb8$var$E("react.context");
    $a1dbf210d8994fb8$var$Aa = $a1dbf210d8994fb8$var$E("react.forward_ref");
    $a1dbf210d8994fb8$var$Ba = $a1dbf210d8994fb8$var$E("react.suspense");
    $a1dbf210d8994fb8$var$Ca = $a1dbf210d8994fb8$var$E("react.suspense_list");
    $a1dbf210d8994fb8$var$Da = $a1dbf210d8994fb8$var$E("react.memo");
    $a1dbf210d8994fb8$var$Ea = $a1dbf210d8994fb8$var$E("react.lazy");
    $a1dbf210d8994fb8$var$Fa = $a1dbf210d8994fb8$var$E("react.block");
    $a1dbf210d8994fb8$var$E("react.scope");
    $a1dbf210d8994fb8$var$Ga = $a1dbf210d8994fb8$var$E("react.opaque.id");
    $a1dbf210d8994fb8$var$Ha = $a1dbf210d8994fb8$var$E("react.debug_trace_mode");
    $a1dbf210d8994fb8$var$Ia = $a1dbf210d8994fb8$var$E("react.offscreen");
    $a1dbf210d8994fb8$var$Ja = $a1dbf210d8994fb8$var$E("react.legacy_hidden");
}
var $a1dbf210d8994fb8$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $a1dbf210d8994fb8$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a1dbf210d8994fb8$var$Ka && a[$a1dbf210d8994fb8$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a1dbf210d8994fb8$var$Ma;
function $a1dbf210d8994fb8$var$Na(a) {
    if (void 0 === $a1dbf210d8994fb8$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a1dbf210d8994fb8$var$Ma = b && b[1] || "";
    }
    return "\n" + $a1dbf210d8994fb8$var$Ma + a;
}
var $a1dbf210d8994fb8$var$Oa = !1;
function $a1dbf210d8994fb8$var$Pa(a, b) {
    if (!a || $a1dbf210d8994fb8$var$Oa) return "";
    $a1dbf210d8994fb8$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a1dbf210d8994fb8$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a1dbf210d8994fb8$var$Na(a) : "";
}
function $a1dbf210d8994fb8$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $a1dbf210d8994fb8$var$Na(a.type);
        case 16:
            return $a1dbf210d8994fb8$var$Na("Lazy");
        case 13:
            return $a1dbf210d8994fb8$var$Na("Suspense");
        case 19:
            return $a1dbf210d8994fb8$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a1dbf210d8994fb8$var$Pa(a.type, !1), a;
        case 11:
            return a = $a1dbf210d8994fb8$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $a1dbf210d8994fb8$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $a1dbf210d8994fb8$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $a1dbf210d8994fb8$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a1dbf210d8994fb8$var$ua:
            return "Fragment";
        case $a1dbf210d8994fb8$var$ta:
            return "Portal";
        case $a1dbf210d8994fb8$var$xa:
            return "Profiler";
        case $a1dbf210d8994fb8$var$wa:
            return "StrictMode";
        case $a1dbf210d8994fb8$var$Ba:
            return "Suspense";
        case $a1dbf210d8994fb8$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a1dbf210d8994fb8$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $a1dbf210d8994fb8$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $a1dbf210d8994fb8$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $a1dbf210d8994fb8$var$Da:
            return $a1dbf210d8994fb8$var$Ra(a.type);
        case $a1dbf210d8994fb8$var$Fa:
            return $a1dbf210d8994fb8$var$Ra(a._render);
        case $a1dbf210d8994fb8$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $a1dbf210d8994fb8$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $a1dbf210d8994fb8$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $5F2Q2._)(a)){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $a1dbf210d8994fb8$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a1dbf210d8994fb8$var$Ua(a) {
    var b = $a1dbf210d8994fb8$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a1dbf210d8994fb8$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a1dbf210d8994fb8$var$Ua(a));
}
function $a1dbf210d8994fb8$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a1dbf210d8994fb8$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a1dbf210d8994fb8$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a1dbf210d8994fb8$var$Ya(a, b) {
    var c = b.checked;
    return $9Rwgr({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a1dbf210d8994fb8$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a1dbf210d8994fb8$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a1dbf210d8994fb8$var$$a(a, b) {
    b = b.checked;
    null != b && $a1dbf210d8994fb8$var$qa(a, "checked", b, !1);
}
function $a1dbf210d8994fb8$var$ab(a, b) {
    $a1dbf210d8994fb8$var$$a(a, b);
    var c = $a1dbf210d8994fb8$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a1dbf210d8994fb8$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a1dbf210d8994fb8$var$bb(a, b.type, $a1dbf210d8994fb8$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a1dbf210d8994fb8$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a1dbf210d8994fb8$var$bb(a, b, c) {
    if ("number" !== b || $a1dbf210d8994fb8$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $a1dbf210d8994fb8$var$db(a) {
    var b = "";
    $4CEbD.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $a1dbf210d8994fb8$var$eb(a, b) {
    a = $9Rwgr({
        children: void 0
    }, b);
    if (b = $a1dbf210d8994fb8$var$db(b.children)) a.children = b;
    return a;
}
function $a1dbf210d8994fb8$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a1dbf210d8994fb8$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a1dbf210d8994fb8$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a1dbf210d8994fb8$var$y(91));
    return $9Rwgr({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a1dbf210d8994fb8$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a1dbf210d8994fb8$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($a1dbf210d8994fb8$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a1dbf210d8994fb8$var$Sa(c)
    };
}
function $a1dbf210d8994fb8$var$ib(a, b) {
    var c = $a1dbf210d8994fb8$var$Sa(b.value), d = $a1dbf210d8994fb8$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a1dbf210d8994fb8$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $a1dbf210d8994fb8$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $a1dbf210d8994fb8$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a1dbf210d8994fb8$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a1dbf210d8994fb8$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a1dbf210d8994fb8$var$nb, $a1dbf210d8994fb8$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $a1dbf210d8994fb8$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $a1dbf210d8994fb8$var$nb = $a1dbf210d8994fb8$var$nb || document.createElement("div");
        $a1dbf210d8994fb8$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a1dbf210d8994fb8$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a1dbf210d8994fb8$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a1dbf210d8994fb8$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a1dbf210d8994fb8$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a1dbf210d8994fb8$var$qb).forEach(function(a) {
    $a1dbf210d8994fb8$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a1dbf210d8994fb8$var$qb[b] = $a1dbf210d8994fb8$var$qb[a];
    });
});
function $a1dbf210d8994fb8$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a1dbf210d8994fb8$var$qb.hasOwnProperty(a) && $a1dbf210d8994fb8$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $a1dbf210d8994fb8$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a1dbf210d8994fb8$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a1dbf210d8994fb8$var$ub = $9Rwgr({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a1dbf210d8994fb8$var$vb(a, b) {
    if (b) {
        if ($a1dbf210d8994fb8$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a1dbf210d8994fb8$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a1dbf210d8994fb8$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($a1dbf210d8994fb8$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a1dbf210d8994fb8$var$y(62));
    }
}
function $a1dbf210d8994fb8$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $a1dbf210d8994fb8$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a1dbf210d8994fb8$var$yb = null, $a1dbf210d8994fb8$var$zb = null, $a1dbf210d8994fb8$var$Ab = null;
function $a1dbf210d8994fb8$var$Bb(a) {
    if (a = $a1dbf210d8994fb8$var$Cb(a)) {
        if ("function" !== typeof $a1dbf210d8994fb8$var$yb) throw Error($a1dbf210d8994fb8$var$y(280));
        var b = a.stateNode;
        b && (b = $a1dbf210d8994fb8$var$Db(b), $a1dbf210d8994fb8$var$yb(a.stateNode, a.type, b));
    }
}
function $a1dbf210d8994fb8$var$Eb(a) {
    $a1dbf210d8994fb8$var$zb ? $a1dbf210d8994fb8$var$Ab ? $a1dbf210d8994fb8$var$Ab.push(a) : $a1dbf210d8994fb8$var$Ab = [
        a
    ] : $a1dbf210d8994fb8$var$zb = a;
}
function $a1dbf210d8994fb8$var$Fb() {
    if ($a1dbf210d8994fb8$var$zb) {
        var a = $a1dbf210d8994fb8$var$zb, b = $a1dbf210d8994fb8$var$Ab;
        $a1dbf210d8994fb8$var$Ab = $a1dbf210d8994fb8$var$zb = null;
        $a1dbf210d8994fb8$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a1dbf210d8994fb8$var$Bb(b[a]);
    }
}
function $a1dbf210d8994fb8$var$Gb(a, b) {
    return a(b);
}
function $a1dbf210d8994fb8$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $a1dbf210d8994fb8$var$Ib() {}
var $a1dbf210d8994fb8$var$Jb = $a1dbf210d8994fb8$var$Gb, $a1dbf210d8994fb8$var$Kb = !1, $a1dbf210d8994fb8$var$Lb = !1;
function $a1dbf210d8994fb8$var$Mb() {
    if (null !== $a1dbf210d8994fb8$var$zb || null !== $a1dbf210d8994fb8$var$Ab) $a1dbf210d8994fb8$var$Ib(), $a1dbf210d8994fb8$var$Fb();
}
function $a1dbf210d8994fb8$var$Nb(a, b, c) {
    if ($a1dbf210d8994fb8$var$Lb) return a(b, c);
    $a1dbf210d8994fb8$var$Lb = !0;
    try {
        return $a1dbf210d8994fb8$var$Jb(a, b, c);
    } finally{
        $a1dbf210d8994fb8$var$Lb = !1, $a1dbf210d8994fb8$var$Mb();
    }
}
function $a1dbf210d8994fb8$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a1dbf210d8994fb8$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a1dbf210d8994fb8$var$y(231, b, typeof c === "undefined" ? "undefined" : (0, $5F2Q2._)(c)));
    return c;
}
var $a1dbf210d8994fb8$var$Pb = !1;
if ($a1dbf210d8994fb8$var$fa) try {
    var $a1dbf210d8994fb8$var$Qb = {};
    Object.defineProperty($a1dbf210d8994fb8$var$Qb, "passive", {
        get: function get() {
            $a1dbf210d8994fb8$var$Pb = !0;
        }
    });
    window.addEventListener("test", $a1dbf210d8994fb8$var$Qb, $a1dbf210d8994fb8$var$Qb);
    window.removeEventListener("test", $a1dbf210d8994fb8$var$Qb, $a1dbf210d8994fb8$var$Qb);
} catch (a) {
    $a1dbf210d8994fb8$var$Pb = !1;
}
function $a1dbf210d8994fb8$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $a1dbf210d8994fb8$var$Sb = !1, $a1dbf210d8994fb8$var$Tb = null, $a1dbf210d8994fb8$var$Ub = !1, $a1dbf210d8994fb8$var$Vb = null, $a1dbf210d8994fb8$var$Wb = {
    onError: function onError(a) {
        $a1dbf210d8994fb8$var$Sb = !0;
        $a1dbf210d8994fb8$var$Tb = a;
    }
};
function $a1dbf210d8994fb8$var$Xb(a, b, c, d, e, f, g, h, k) {
    $a1dbf210d8994fb8$var$Sb = !1;
    $a1dbf210d8994fb8$var$Tb = null;
    $a1dbf210d8994fb8$var$Rb.apply($a1dbf210d8994fb8$var$Wb, arguments);
}
function $a1dbf210d8994fb8$var$Yb(a, b, c, d, e, f, g, h, k) {
    $a1dbf210d8994fb8$var$Xb.apply(this, arguments);
    if ($a1dbf210d8994fb8$var$Sb) {
        if ($a1dbf210d8994fb8$var$Sb) {
            var l = $a1dbf210d8994fb8$var$Tb;
            $a1dbf210d8994fb8$var$Sb = !1;
            $a1dbf210d8994fb8$var$Tb = null;
        } else throw Error($a1dbf210d8994fb8$var$y(198));
        $a1dbf210d8994fb8$var$Ub || ($a1dbf210d8994fb8$var$Ub = !0, $a1dbf210d8994fb8$var$Vb = l);
    }
}
function $a1dbf210d8994fb8$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a1dbf210d8994fb8$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a1dbf210d8994fb8$var$ac(a) {
    if ($a1dbf210d8994fb8$var$Zb(a) !== a) throw Error($a1dbf210d8994fb8$var$y(188));
}
function $a1dbf210d8994fb8$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $a1dbf210d8994fb8$var$Zb(a);
        if (null === b) throw Error($a1dbf210d8994fb8$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a1dbf210d8994fb8$var$ac(e), a;
                if (f === d) return $a1dbf210d8994fb8$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($a1dbf210d8994fb8$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a1dbf210d8994fb8$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($a1dbf210d8994fb8$var$y(190));
    }
    if (3 !== c.tag) throw Error($a1dbf210d8994fb8$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $a1dbf210d8994fb8$var$cc(a) {
    a = $a1dbf210d8994fb8$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $a1dbf210d8994fb8$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $a1dbf210d8994fb8$var$ec, $a1dbf210d8994fb8$var$fc, $a1dbf210d8994fb8$var$gc, $a1dbf210d8994fb8$var$hc, $a1dbf210d8994fb8$var$ic = !1, $a1dbf210d8994fb8$var$jc = [], $a1dbf210d8994fb8$var$kc = null, $a1dbf210d8994fb8$var$lc = null, $a1dbf210d8994fb8$var$mc = null, $a1dbf210d8994fb8$var$nc = new Map, $a1dbf210d8994fb8$var$oc = new Map, $a1dbf210d8994fb8$var$pc = [], $a1dbf210d8994fb8$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a1dbf210d8994fb8$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $a1dbf210d8994fb8$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a1dbf210d8994fb8$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a1dbf210d8994fb8$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a1dbf210d8994fb8$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a1dbf210d8994fb8$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a1dbf210d8994fb8$var$oc.delete(b.pointerId);
    }
}
function $a1dbf210d8994fb8$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $a1dbf210d8994fb8$var$rc(b, c, d, e, f), null !== b && (b = $a1dbf210d8994fb8$var$Cb(b), null !== b && $a1dbf210d8994fb8$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a1dbf210d8994fb8$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a1dbf210d8994fb8$var$kc = $a1dbf210d8994fb8$var$tc($a1dbf210d8994fb8$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $a1dbf210d8994fb8$var$lc = $a1dbf210d8994fb8$var$tc($a1dbf210d8994fb8$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $a1dbf210d8994fb8$var$mc = $a1dbf210d8994fb8$var$tc($a1dbf210d8994fb8$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a1dbf210d8994fb8$var$nc.set(f, $a1dbf210d8994fb8$var$tc($a1dbf210d8994fb8$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a1dbf210d8994fb8$var$oc.set(f, $a1dbf210d8994fb8$var$tc($a1dbf210d8994fb8$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a1dbf210d8994fb8$var$vc(a) {
    var b = $a1dbf210d8994fb8$var$wc(a.target);
    if (null !== b) {
        var c = $a1dbf210d8994fb8$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a1dbf210d8994fb8$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $a1dbf210d8994fb8$var$hc(a.lanePriority, function() {
                        $3KFEz.unstable_runWithPriority(a.priority, function() {
                            $a1dbf210d8994fb8$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a1dbf210d8994fb8$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a1dbf210d8994fb8$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $a1dbf210d8994fb8$var$Cb(c), null !== b && $a1dbf210d8994fb8$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a1dbf210d8994fb8$var$zc(a, b, c) {
    $a1dbf210d8994fb8$var$xc(a) && c.delete(b);
}
function $a1dbf210d8994fb8$var$Ac() {
    for($a1dbf210d8994fb8$var$ic = !1; 0 < $a1dbf210d8994fb8$var$jc.length;){
        var a = $a1dbf210d8994fb8$var$jc[0];
        if (null !== a.blockedOn) {
            a = $a1dbf210d8994fb8$var$Cb(a.blockedOn);
            null !== a && $a1dbf210d8994fb8$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $a1dbf210d8994fb8$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $a1dbf210d8994fb8$var$jc.shift();
    }
    null !== $a1dbf210d8994fb8$var$kc && $a1dbf210d8994fb8$var$xc($a1dbf210d8994fb8$var$kc) && ($a1dbf210d8994fb8$var$kc = null);
    null !== $a1dbf210d8994fb8$var$lc && $a1dbf210d8994fb8$var$xc($a1dbf210d8994fb8$var$lc) && ($a1dbf210d8994fb8$var$lc = null);
    null !== $a1dbf210d8994fb8$var$mc && $a1dbf210d8994fb8$var$xc($a1dbf210d8994fb8$var$mc) && ($a1dbf210d8994fb8$var$mc = null);
    $a1dbf210d8994fb8$var$nc.forEach($a1dbf210d8994fb8$var$zc);
    $a1dbf210d8994fb8$var$oc.forEach($a1dbf210d8994fb8$var$zc);
}
function $a1dbf210d8994fb8$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a1dbf210d8994fb8$var$ic || ($a1dbf210d8994fb8$var$ic = !0, $3KFEz.unstable_scheduleCallback($3KFEz.unstable_NormalPriority, $a1dbf210d8994fb8$var$Ac)));
}
function $a1dbf210d8994fb8$var$Cc(a) {
    var b = function b(_b) {
        return $a1dbf210d8994fb8$var$Bc(_b, a);
    };
    if (0 < $a1dbf210d8994fb8$var$jc.length) {
        $a1dbf210d8994fb8$var$Bc($a1dbf210d8994fb8$var$jc[0], a);
        for(var c = 1; c < $a1dbf210d8994fb8$var$jc.length; c++){
            var d = $a1dbf210d8994fb8$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a1dbf210d8994fb8$var$kc && $a1dbf210d8994fb8$var$Bc($a1dbf210d8994fb8$var$kc, a);
    null !== $a1dbf210d8994fb8$var$lc && $a1dbf210d8994fb8$var$Bc($a1dbf210d8994fb8$var$lc, a);
    null !== $a1dbf210d8994fb8$var$mc && $a1dbf210d8994fb8$var$Bc($a1dbf210d8994fb8$var$mc, a);
    $a1dbf210d8994fb8$var$nc.forEach(b);
    $a1dbf210d8994fb8$var$oc.forEach(b);
    for(c = 0; c < $a1dbf210d8994fb8$var$pc.length; c++)d = $a1dbf210d8994fb8$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a1dbf210d8994fb8$var$pc.length && (c = $a1dbf210d8994fb8$var$pc[0], null === c.blockedOn);)$a1dbf210d8994fb8$var$vc(c), null === c.blockedOn && $a1dbf210d8994fb8$var$pc.shift();
}
function $a1dbf210d8994fb8$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a1dbf210d8994fb8$var$Ec = {
    animationend: $a1dbf210d8994fb8$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $a1dbf210d8994fb8$var$Dc("Animation", "AnimationIteration"),
    animationstart: $a1dbf210d8994fb8$var$Dc("Animation", "AnimationStart"),
    transitionend: $a1dbf210d8994fb8$var$Dc("Transition", "TransitionEnd")
}, $a1dbf210d8994fb8$var$Fc = {}, $a1dbf210d8994fb8$var$Gc = {};
$a1dbf210d8994fb8$var$fa && ($a1dbf210d8994fb8$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $a1dbf210d8994fb8$var$Ec.animationend.animation, delete $a1dbf210d8994fb8$var$Ec.animationiteration.animation, delete $a1dbf210d8994fb8$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $a1dbf210d8994fb8$var$Ec.transitionend.transition);
function $a1dbf210d8994fb8$var$Hc(a) {
    if ($a1dbf210d8994fb8$var$Fc[a]) return $a1dbf210d8994fb8$var$Fc[a];
    if (!$a1dbf210d8994fb8$var$Ec[a]) return a;
    var b = $a1dbf210d8994fb8$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a1dbf210d8994fb8$var$Gc) return $a1dbf210d8994fb8$var$Fc[a] = b[c];
    return a;
}
var $a1dbf210d8994fb8$var$Ic = $a1dbf210d8994fb8$var$Hc("animationend"), $a1dbf210d8994fb8$var$Jc = $a1dbf210d8994fb8$var$Hc("animationiteration"), $a1dbf210d8994fb8$var$Kc = $a1dbf210d8994fb8$var$Hc("animationstart"), $a1dbf210d8994fb8$var$Lc = $a1dbf210d8994fb8$var$Hc("transitionend"), $a1dbf210d8994fb8$var$Mc = new Map, $a1dbf210d8994fb8$var$Nc = new Map, $a1dbf210d8994fb8$var$Oc = [
    "abort",
    "abort",
    $a1dbf210d8994fb8$var$Ic,
    "animationEnd",
    $a1dbf210d8994fb8$var$Jc,
    "animationIteration",
    $a1dbf210d8994fb8$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $a1dbf210d8994fb8$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $a1dbf210d8994fb8$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $a1dbf210d8994fb8$var$Nc.set(d, b);
        $a1dbf210d8994fb8$var$Mc.set(d, e);
        $a1dbf210d8994fb8$var$da(e, [
            d
        ]);
    }
}
var $a1dbf210d8994fb8$var$Qc = $3KFEz.unstable_now;
$a1dbf210d8994fb8$var$Qc();
var $a1dbf210d8994fb8$var$F = 8;
function $a1dbf210d8994fb8$var$Rc(a) {
    if (0 !== (1 & a)) return $a1dbf210d8994fb8$var$F = 15, 1;
    if (0 !== (2 & a)) return $a1dbf210d8994fb8$var$F = 14, 2;
    if (0 !== (4 & a)) return $a1dbf210d8994fb8$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 12, b;
    if (0 !== (a & 32)) return $a1dbf210d8994fb8$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 10, b;
    if (0 !== (a & 256)) return $a1dbf210d8994fb8$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 8, b;
    if (0 !== (a & 4096)) return $a1dbf210d8994fb8$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 5, b;
    if (a & 67108864) return $a1dbf210d8994fb8$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $a1dbf210d8994fb8$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $a1dbf210d8994fb8$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $a1dbf210d8994fb8$var$F = 1, 1073741824;
    $a1dbf210d8994fb8$var$F = 8;
    return a;
}
function $a1dbf210d8994fb8$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $a1dbf210d8994fb8$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($a1dbf210d8994fb8$var$y(358, a));
    }
}
function $a1dbf210d8994fb8$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $a1dbf210d8994fb8$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $a1dbf210d8994fb8$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $a1dbf210d8994fb8$var$Rc(k), e = $a1dbf210d8994fb8$var$F) : (h &= f, 0 !== h && (d = $a1dbf210d8994fb8$var$Rc(h), e = $a1dbf210d8994fb8$var$F));
    } else f = c & ~g, 0 !== f ? (d = $a1dbf210d8994fb8$var$Rc(f), e = $a1dbf210d8994fb8$var$F) : 0 !== h && (d = $a1dbf210d8994fb8$var$Rc(h), e = $a1dbf210d8994fb8$var$F);
    if (0 === d) return 0;
    d = 31 - $a1dbf210d8994fb8$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $a1dbf210d8994fb8$var$Rc(b);
        if (e <= $a1dbf210d8994fb8$var$F) return b;
        $a1dbf210d8994fb8$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a1dbf210d8994fb8$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a1dbf210d8994fb8$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a1dbf210d8994fb8$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $a1dbf210d8994fb8$var$Yc(24 & ~b), 0 === a ? $a1dbf210d8994fb8$var$Xc(10, b) : a;
        case 10:
            return a = $a1dbf210d8994fb8$var$Yc(192 & ~b), 0 === a ? $a1dbf210d8994fb8$var$Xc(8, b) : a;
        case 8:
            return a = $a1dbf210d8994fb8$var$Yc(3584 & ~b), 0 === a && (a = $a1dbf210d8994fb8$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $a1dbf210d8994fb8$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($a1dbf210d8994fb8$var$y(358, a));
}
function $a1dbf210d8994fb8$var$Yc(a) {
    return a & -a;
}
function $a1dbf210d8994fb8$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a1dbf210d8994fb8$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $a1dbf210d8994fb8$var$Vc(b);
    a[b] = c;
}
var $a1dbf210d8994fb8$var$Vc = Math.clz32 ? Math.clz32 : $a1dbf210d8994fb8$var$ad, $a1dbf210d8994fb8$var$bd = Math.log, $a1dbf210d8994fb8$var$cd = Math.LN2;
function $a1dbf210d8994fb8$var$ad(a) {
    return 0 === a ? 32 : 31 - ($a1dbf210d8994fb8$var$bd(a) / $a1dbf210d8994fb8$var$cd | 0) | 0;
}
var $a1dbf210d8994fb8$var$dd = $3KFEz.unstable_UserBlockingPriority, $a1dbf210d8994fb8$var$ed = $3KFEz.unstable_runWithPriority, $a1dbf210d8994fb8$var$fd = !0;
function $a1dbf210d8994fb8$var$gd(a, b, c, d) {
    $a1dbf210d8994fb8$var$Kb || $a1dbf210d8994fb8$var$Ib();
    var e = $a1dbf210d8994fb8$var$hd, f = $a1dbf210d8994fb8$var$Kb;
    $a1dbf210d8994fb8$var$Kb = !0;
    try {
        $a1dbf210d8994fb8$var$Hb(e, a, b, c, d);
    } finally{
        ($a1dbf210d8994fb8$var$Kb = f) || $a1dbf210d8994fb8$var$Mb();
    }
}
function $a1dbf210d8994fb8$var$id(a, b, c, d) {
    $a1dbf210d8994fb8$var$ed($a1dbf210d8994fb8$var$dd, $a1dbf210d8994fb8$var$hd.bind(null, a, b, c, d));
}
function $a1dbf210d8994fb8$var$hd(a, b, c, d) {
    if ($a1dbf210d8994fb8$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $a1dbf210d8994fb8$var$jc.length && -1 < $a1dbf210d8994fb8$var$qc.indexOf(a)) a = $a1dbf210d8994fb8$var$rc(null, a, b, c, d), $a1dbf210d8994fb8$var$jc.push(a);
        else {
            var f = $a1dbf210d8994fb8$var$yc(a, b, c, d);
            if (null === f) e && $a1dbf210d8994fb8$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $a1dbf210d8994fb8$var$qc.indexOf(a)) {
                        a = $a1dbf210d8994fb8$var$rc(f, a, b, c, d);
                        $a1dbf210d8994fb8$var$jc.push(a);
                        return;
                    }
                    if ($a1dbf210d8994fb8$var$uc(f, a, b, c, d)) return;
                    $a1dbf210d8994fb8$var$sc(a, d);
                }
                $a1dbf210d8994fb8$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $a1dbf210d8994fb8$var$yc(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$xb(d);
    e = $a1dbf210d8994fb8$var$wc(e);
    if (null !== e) {
        var f = $a1dbf210d8994fb8$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $a1dbf210d8994fb8$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $a1dbf210d8994fb8$var$jd(a, b, d, e, c);
    return null;
}
var $a1dbf210d8994fb8$var$kd = null, $a1dbf210d8994fb8$var$ld = null, $a1dbf210d8994fb8$var$md = null;
function $a1dbf210d8994fb8$var$nd() {
    if ($a1dbf210d8994fb8$var$md) return $a1dbf210d8994fb8$var$md;
    var a, b = $a1dbf210d8994fb8$var$ld, c = b.length, d, e = "value" in $a1dbf210d8994fb8$var$kd ? $a1dbf210d8994fb8$var$kd.value : $a1dbf210d8994fb8$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a1dbf210d8994fb8$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a1dbf210d8994fb8$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a1dbf210d8994fb8$var$pd() {
    return !0;
}
function $a1dbf210d8994fb8$var$qd() {
    return !1;
}
function $a1dbf210d8994fb8$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a1dbf210d8994fb8$var$pd : $a1dbf210d8994fb8$var$qd;
        this.isPropagationStopped = $a1dbf210d8994fb8$var$qd;
        return this;
    };
    $9Rwgr(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $5F2Q2._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $a1dbf210d8994fb8$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $5F2Q2._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $a1dbf210d8994fb8$var$pd);
        },
        persist: function persist() {},
        isPersistent: $a1dbf210d8994fb8$var$pd
    });
    return b;
}
var $a1dbf210d8994fb8$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a1dbf210d8994fb8$var$td = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$sd), $a1dbf210d8994fb8$var$ud = $9Rwgr({}, $a1dbf210d8994fb8$var$sd, {
    view: 0,
    detail: 0
}), $a1dbf210d8994fb8$var$vd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$ud), $a1dbf210d8994fb8$var$wd, $a1dbf210d8994fb8$var$xd, $a1dbf210d8994fb8$var$yd, $a1dbf210d8994fb8$var$Ad = $9Rwgr({}, $a1dbf210d8994fb8$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a1dbf210d8994fb8$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a1dbf210d8994fb8$var$yd && ($a1dbf210d8994fb8$var$yd && "mousemove" === a.type ? ($a1dbf210d8994fb8$var$wd = a.screenX - $a1dbf210d8994fb8$var$yd.screenX, $a1dbf210d8994fb8$var$xd = a.screenY - $a1dbf210d8994fb8$var$yd.screenY) : $a1dbf210d8994fb8$var$xd = $a1dbf210d8994fb8$var$wd = 0, $a1dbf210d8994fb8$var$yd = a);
        return $a1dbf210d8994fb8$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $a1dbf210d8994fb8$var$xd;
    }
}), $a1dbf210d8994fb8$var$Bd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Ad), $a1dbf210d8994fb8$var$Cd = $9Rwgr({}, $a1dbf210d8994fb8$var$Ad, {
    dataTransfer: 0
}), $a1dbf210d8994fb8$var$Dd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Cd), $a1dbf210d8994fb8$var$Ed = $9Rwgr({}, $a1dbf210d8994fb8$var$ud, {
    relatedTarget: 0
}), $a1dbf210d8994fb8$var$Fd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Ed), $a1dbf210d8994fb8$var$Gd = $9Rwgr({}, $a1dbf210d8994fb8$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a1dbf210d8994fb8$var$Hd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Gd), $a1dbf210d8994fb8$var$Id = $9Rwgr({}, $a1dbf210d8994fb8$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a1dbf210d8994fb8$var$Jd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Id), $a1dbf210d8994fb8$var$Kd = $9Rwgr({}, $a1dbf210d8994fb8$var$sd, {
    data: 0
}), $a1dbf210d8994fb8$var$Ld = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Kd), $a1dbf210d8994fb8$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a1dbf210d8994fb8$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a1dbf210d8994fb8$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a1dbf210d8994fb8$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a1dbf210d8994fb8$var$Od[a]) ? !!b[a] : !1;
}
function $a1dbf210d8994fb8$var$zd() {
    return $a1dbf210d8994fb8$var$Pd;
}
var $a1dbf210d8994fb8$var$Qd = $9Rwgr({}, $a1dbf210d8994fb8$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $a1dbf210d8994fb8$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a1dbf210d8994fb8$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a1dbf210d8994fb8$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a1dbf210d8994fb8$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $a1dbf210d8994fb8$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $a1dbf210d8994fb8$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a1dbf210d8994fb8$var$Rd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Qd), $a1dbf210d8994fb8$var$Sd = $9Rwgr({}, $a1dbf210d8994fb8$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a1dbf210d8994fb8$var$Td = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Sd), $a1dbf210d8994fb8$var$Ud = $9Rwgr({}, $a1dbf210d8994fb8$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a1dbf210d8994fb8$var$zd
}), $a1dbf210d8994fb8$var$Vd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Ud), $a1dbf210d8994fb8$var$Wd = $9Rwgr({}, $a1dbf210d8994fb8$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a1dbf210d8994fb8$var$Xd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Wd), $a1dbf210d8994fb8$var$Yd = $9Rwgr({}, $a1dbf210d8994fb8$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a1dbf210d8994fb8$var$Zd = $a1dbf210d8994fb8$var$rd($a1dbf210d8994fb8$var$Yd), $a1dbf210d8994fb8$var$$d = [
    9,
    13,
    27,
    32
], $a1dbf210d8994fb8$var$ae = $a1dbf210d8994fb8$var$fa && "CompositionEvent" in window, $a1dbf210d8994fb8$var$be = null;
$a1dbf210d8994fb8$var$fa && "documentMode" in document && ($a1dbf210d8994fb8$var$be = document.documentMode);
var $a1dbf210d8994fb8$var$ce = $a1dbf210d8994fb8$var$fa && "TextEvent" in window && !$a1dbf210d8994fb8$var$be, $a1dbf210d8994fb8$var$de = $a1dbf210d8994fb8$var$fa && (!$a1dbf210d8994fb8$var$ae || $a1dbf210d8994fb8$var$be && 8 < $a1dbf210d8994fb8$var$be && 11 >= $a1dbf210d8994fb8$var$be), $a1dbf210d8994fb8$var$ee = String.fromCharCode(32), $a1dbf210d8994fb8$var$fe = !1;
function $a1dbf210d8994fb8$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a1dbf210d8994fb8$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a1dbf210d8994fb8$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a1dbf210d8994fb8$var$ie = !1;
function $a1dbf210d8994fb8$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a1dbf210d8994fb8$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a1dbf210d8994fb8$var$fe = !0;
            return $a1dbf210d8994fb8$var$ee;
        case "textInput":
            return a = b.data, a === $a1dbf210d8994fb8$var$ee && $a1dbf210d8994fb8$var$fe ? null : a;
        default:
            return null;
    }
}
function $a1dbf210d8994fb8$var$ke(a, b) {
    if ($a1dbf210d8994fb8$var$ie) return "compositionend" === a || !$a1dbf210d8994fb8$var$ae && $a1dbf210d8994fb8$var$ge(a, b) ? (a = $a1dbf210d8994fb8$var$nd(), $a1dbf210d8994fb8$var$md = $a1dbf210d8994fb8$var$ld = $a1dbf210d8994fb8$var$kd = null, $a1dbf210d8994fb8$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a1dbf210d8994fb8$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a1dbf210d8994fb8$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a1dbf210d8994fb8$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a1dbf210d8994fb8$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a1dbf210d8994fb8$var$ne(a, b, c, d) {
    $a1dbf210d8994fb8$var$Eb(d);
    b = $a1dbf210d8994fb8$var$oe(b, "onChange");
    0 < b.length && (c = new $a1dbf210d8994fb8$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a1dbf210d8994fb8$var$pe = null, $a1dbf210d8994fb8$var$qe = null;
function $a1dbf210d8994fb8$var$re(a) {
    $a1dbf210d8994fb8$var$se(a, 0);
}
function $a1dbf210d8994fb8$var$te(a) {
    var b = $a1dbf210d8994fb8$var$ue(a);
    if ($a1dbf210d8994fb8$var$Wa(b)) return a;
}
function $a1dbf210d8994fb8$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a1dbf210d8994fb8$var$we = !1;
if ($a1dbf210d8994fb8$var$fa) {
    var $a1dbf210d8994fb8$var$xe;
    if ($a1dbf210d8994fb8$var$fa) {
        var $a1dbf210d8994fb8$var$ye = "oninput" in document;
        if (!$a1dbf210d8994fb8$var$ye) {
            var $a1dbf210d8994fb8$var$ze = document.createElement("div");
            $a1dbf210d8994fb8$var$ze.setAttribute("oninput", "return;");
            $a1dbf210d8994fb8$var$ye = "function" === typeof $a1dbf210d8994fb8$var$ze.oninput;
        }
        $a1dbf210d8994fb8$var$xe = $a1dbf210d8994fb8$var$ye;
    } else $a1dbf210d8994fb8$var$xe = !1;
    $a1dbf210d8994fb8$var$we = $a1dbf210d8994fb8$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a1dbf210d8994fb8$var$Ae() {
    $a1dbf210d8994fb8$var$pe && ($a1dbf210d8994fb8$var$pe.detachEvent("onpropertychange", $a1dbf210d8994fb8$var$Be), $a1dbf210d8994fb8$var$qe = $a1dbf210d8994fb8$var$pe = null);
}
function $a1dbf210d8994fb8$var$Be(a) {
    if ("value" === a.propertyName && $a1dbf210d8994fb8$var$te($a1dbf210d8994fb8$var$qe)) {
        var b = [];
        $a1dbf210d8994fb8$var$ne(b, $a1dbf210d8994fb8$var$qe, a, $a1dbf210d8994fb8$var$xb(a));
        a = $a1dbf210d8994fb8$var$re;
        if ($a1dbf210d8994fb8$var$Kb) a(b);
        else {
            $a1dbf210d8994fb8$var$Kb = !0;
            try {
                $a1dbf210d8994fb8$var$Gb(a, b);
            } finally{
                $a1dbf210d8994fb8$var$Kb = !1, $a1dbf210d8994fb8$var$Mb();
            }
        }
    }
}
function $a1dbf210d8994fb8$var$Ce(a, b, c) {
    "focusin" === a ? ($a1dbf210d8994fb8$var$Ae(), $a1dbf210d8994fb8$var$pe = b, $a1dbf210d8994fb8$var$qe = c, $a1dbf210d8994fb8$var$pe.attachEvent("onpropertychange", $a1dbf210d8994fb8$var$Be)) : "focusout" === a && $a1dbf210d8994fb8$var$Ae();
}
function $a1dbf210d8994fb8$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a1dbf210d8994fb8$var$te($a1dbf210d8994fb8$var$qe);
}
function $a1dbf210d8994fb8$var$Ee(a, b) {
    if ("click" === a) return $a1dbf210d8994fb8$var$te(b);
}
function $a1dbf210d8994fb8$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a1dbf210d8994fb8$var$te(b);
}
function $a1dbf210d8994fb8$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a1dbf210d8994fb8$var$He = "function" === typeof Object.is ? Object.is : $a1dbf210d8994fb8$var$Ge, $a1dbf210d8994fb8$var$Ie = Object.prototype.hasOwnProperty;
function $a1dbf210d8994fb8$var$Je(a, b) {
    if ($a1dbf210d8994fb8$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$a1dbf210d8994fb8$var$Ie.call(b, c[d]) || !$a1dbf210d8994fb8$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $a1dbf210d8994fb8$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a1dbf210d8994fb8$var$Le(a, b) {
    var c = $a1dbf210d8994fb8$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a1dbf210d8994fb8$var$Ke(c);
    }
}
function $a1dbf210d8994fb8$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a1dbf210d8994fb8$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a1dbf210d8994fb8$var$Ne() {
    for(var a = window, b = $a1dbf210d8994fb8$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a1dbf210d8994fb8$var$Xa(a.document);
    }
    return b;
}
function $a1dbf210d8994fb8$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $a1dbf210d8994fb8$var$Pe = $a1dbf210d8994fb8$var$fa && "documentMode" in document && 11 >= document.documentMode, $a1dbf210d8994fb8$var$Qe = null, $a1dbf210d8994fb8$var$Re = null, $a1dbf210d8994fb8$var$Se = null, $a1dbf210d8994fb8$var$Te = !1;
function $a1dbf210d8994fb8$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a1dbf210d8994fb8$var$Te || null == $a1dbf210d8994fb8$var$Qe || $a1dbf210d8994fb8$var$Qe !== $a1dbf210d8994fb8$var$Xa(d) || (d = $a1dbf210d8994fb8$var$Qe, "selectionStart" in d && $a1dbf210d8994fb8$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a1dbf210d8994fb8$var$Se && $a1dbf210d8994fb8$var$Je($a1dbf210d8994fb8$var$Se, d) || ($a1dbf210d8994fb8$var$Se = d, d = $a1dbf210d8994fb8$var$oe($a1dbf210d8994fb8$var$Re, "onSelect"), 0 < d.length && (b = new $a1dbf210d8994fb8$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a1dbf210d8994fb8$var$Qe)));
}
$a1dbf210d8994fb8$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$a1dbf210d8994fb8$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$a1dbf210d8994fb8$var$Pc($a1dbf210d8994fb8$var$Oc, 2);
for(var $a1dbf210d8994fb8$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $a1dbf210d8994fb8$var$We = 0; $a1dbf210d8994fb8$var$We < $a1dbf210d8994fb8$var$Ve.length; $a1dbf210d8994fb8$var$We++)$a1dbf210d8994fb8$var$Nc.set($a1dbf210d8994fb8$var$Ve[$a1dbf210d8994fb8$var$We], 0);
$a1dbf210d8994fb8$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a1dbf210d8994fb8$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a1dbf210d8994fb8$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a1dbf210d8994fb8$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a1dbf210d8994fb8$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a1dbf210d8994fb8$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a1dbf210d8994fb8$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a1dbf210d8994fb8$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a1dbf210d8994fb8$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a1dbf210d8994fb8$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a1dbf210d8994fb8$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a1dbf210d8994fb8$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($a1dbf210d8994fb8$var$Xe));
function $a1dbf210d8994fb8$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a1dbf210d8994fb8$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $a1dbf210d8994fb8$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a1dbf210d8994fb8$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a1dbf210d8994fb8$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($a1dbf210d8994fb8$var$Ub) throw a = $a1dbf210d8994fb8$var$Vb, $a1dbf210d8994fb8$var$Ub = !1, $a1dbf210d8994fb8$var$Vb = null, a;
}
function $a1dbf210d8994fb8$var$G(a, b) {
    var c = $a1dbf210d8994fb8$var$$e(b), d = a + "__bubble";
    c.has(d) || ($a1dbf210d8994fb8$var$af(b, a, 2, !1), c.add(d));
}
var $a1dbf210d8994fb8$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $a1dbf210d8994fb8$var$cf(a) {
    a[$a1dbf210d8994fb8$var$bf] || (a[$a1dbf210d8994fb8$var$bf] = !0, $a1dbf210d8994fb8$var$ba.forEach(function(b) {
        $a1dbf210d8994fb8$var$Ye.has(b) || $a1dbf210d8994fb8$var$df(b, !1, a, null);
        $a1dbf210d8994fb8$var$df(b, !0, a, null);
    }));
}
function $a1dbf210d8994fb8$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $a1dbf210d8994fb8$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $a1dbf210d8994fb8$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $a1dbf210d8994fb8$var$af(f, a, e, b), g.add(h));
}
function $a1dbf210d8994fb8$var$af(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $a1dbf210d8994fb8$var$gd;
            break;
        case 1:
            e = $a1dbf210d8994fb8$var$id;
            break;
        default:
            e = $a1dbf210d8994fb8$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a1dbf210d8994fb8$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a1dbf210d8994fb8$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a1dbf210d8994fb8$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a1dbf210d8994fb8$var$Nb(function() {
        var _$d = f, _$e = $a1dbf210d8994fb8$var$xb(c), g = [];
        a: {
            var h = $a1dbf210d8994fb8$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $a1dbf210d8994fb8$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $a1dbf210d8994fb8$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a1dbf210d8994fb8$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $a1dbf210d8994fb8$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $a1dbf210d8994fb8$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a1dbf210d8994fb8$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a1dbf210d8994fb8$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a1dbf210d8994fb8$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a1dbf210d8994fb8$var$Vd;
                        break;
                    case $a1dbf210d8994fb8$var$Ic:
                    case $a1dbf210d8994fb8$var$Jc:
                    case $a1dbf210d8994fb8$var$Kc:
                        k = $a1dbf210d8994fb8$var$Hd;
                        break;
                    case $a1dbf210d8994fb8$var$Lc:
                        k = $a1dbf210d8994fb8$var$Xd;
                        break;
                    case "scroll":
                        k = $a1dbf210d8994fb8$var$vd;
                        break;
                    case "wheel":
                        k = $a1dbf210d8994fb8$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a1dbf210d8994fb8$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a1dbf210d8994fb8$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = _$d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $a1dbf210d8994fb8$var$Ob(t, u), null != v && w.push($a1dbf210d8994fb8$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, _$e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($a1dbf210d8994fb8$var$wc(x) || x[$a1dbf210d8994fb8$var$ff])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = _$d, x = x ? $a1dbf210d8994fb8$var$wc(x) : null, null !== x && (z = $a1dbf210d8994fb8$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = _$d;
                    if (k !== x) {
                        w = $a1dbf210d8994fb8$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $a1dbf210d8994fb8$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $a1dbf210d8994fb8$var$ue(k);
                        q = null == x ? h : $a1dbf210d8994fb8$var$ue(x);
                        h = new w(v, t + "leave", k, c, _$e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $a1dbf210d8994fb8$var$wc(_$e) === _$d && (w = new w(u, t + "enter", x, c, _$e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $a1dbf210d8994fb8$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $a1dbf210d8994fb8$var$gf(v))q++;
                            for(; 0 < t - q;)w = $a1dbf210d8994fb8$var$gf(w), t--;
                            for(; 0 < q - t;)u = $a1dbf210d8994fb8$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $a1dbf210d8994fb8$var$gf(w);
                                u = $a1dbf210d8994fb8$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $a1dbf210d8994fb8$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $a1dbf210d8994fb8$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = _$d ? $a1dbf210d8994fb8$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $a1dbf210d8994fb8$var$ve;
                else if ($a1dbf210d8994fb8$var$me(h)) {
                    if ($a1dbf210d8994fb8$var$we) J = $a1dbf210d8994fb8$var$Fe;
                    else {
                        J = $a1dbf210d8994fb8$var$De;
                        var K = $a1dbf210d8994fb8$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $a1dbf210d8994fb8$var$Ee);
                if (J && (J = J(a, _$d))) {
                    $a1dbf210d8994fb8$var$ne(g, J, c, _$e);
                    break a;
                }
                K && K(a, h, _$d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $a1dbf210d8994fb8$var$bb(h, "number", h.value);
            }
            K = _$d ? $a1dbf210d8994fb8$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($a1dbf210d8994fb8$var$me(K) || "true" === K.contentEditable) $a1dbf210d8994fb8$var$Qe = K, $a1dbf210d8994fb8$var$Re = _$d, $a1dbf210d8994fb8$var$Se = null;
                    break;
                case "focusout":
                    $a1dbf210d8994fb8$var$Se = $a1dbf210d8994fb8$var$Re = $a1dbf210d8994fb8$var$Qe = null;
                    break;
                case "mousedown":
                    $a1dbf210d8994fb8$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a1dbf210d8994fb8$var$Te = !1;
                    $a1dbf210d8994fb8$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($a1dbf210d8994fb8$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a1dbf210d8994fb8$var$Ue(g, c, _$e);
            }
            var Q;
            if ($a1dbf210d8994fb8$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $a1dbf210d8994fb8$var$ie ? $a1dbf210d8994fb8$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($a1dbf210d8994fb8$var$de && "ko" !== c.locale && ($a1dbf210d8994fb8$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $a1dbf210d8994fb8$var$ie && (Q = $a1dbf210d8994fb8$var$nd()) : ($a1dbf210d8994fb8$var$kd = _$e, $a1dbf210d8994fb8$var$ld = "value" in $a1dbf210d8994fb8$var$kd ? $a1dbf210d8994fb8$var$kd.value : $a1dbf210d8994fb8$var$kd.textContent, $a1dbf210d8994fb8$var$ie = !0)), K = $a1dbf210d8994fb8$var$oe(_$d, L), 0 < K.length && (L = new $a1dbf210d8994fb8$var$Ld(L, a, null, c, _$e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $a1dbf210d8994fb8$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $a1dbf210d8994fb8$var$ce ? $a1dbf210d8994fb8$var$je(a, c) : $a1dbf210d8994fb8$var$ke(a, c)) _$d = $a1dbf210d8994fb8$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $a1dbf210d8994fb8$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = Q);
        }
        $a1dbf210d8994fb8$var$se(g, b);
    });
}
function $a1dbf210d8994fb8$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a1dbf210d8994fb8$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a1dbf210d8994fb8$var$Ob(a, c), null != f && d.unshift($a1dbf210d8994fb8$var$ef(a, f, e)), f = $a1dbf210d8994fb8$var$Ob(a, b), null != f && d.push($a1dbf210d8994fb8$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a1dbf210d8994fb8$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a1dbf210d8994fb8$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a1dbf210d8994fb8$var$Ob(c, f), null != k && g.unshift($a1dbf210d8994fb8$var$ef(c, k, h))) : e || (k = $a1dbf210d8994fb8$var$Ob(c, f), null != k && g.push($a1dbf210d8994fb8$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $a1dbf210d8994fb8$var$jf() {}
var $a1dbf210d8994fb8$var$kf = null, $a1dbf210d8994fb8$var$lf = null;
function $a1dbf210d8994fb8$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $a1dbf210d8994fb8$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a1dbf210d8994fb8$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $a1dbf210d8994fb8$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $a1dbf210d8994fb8$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $a1dbf210d8994fb8$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $a1dbf210d8994fb8$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a1dbf210d8994fb8$var$tf = 0;
function $a1dbf210d8994fb8$var$uf(a) {
    return {
        $$typeof: $a1dbf210d8994fb8$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $a1dbf210d8994fb8$var$vf = Math.random().toString(36).slice(2), $a1dbf210d8994fb8$var$wf = "__reactFiber$" + $a1dbf210d8994fb8$var$vf, $a1dbf210d8994fb8$var$xf = "__reactProps$" + $a1dbf210d8994fb8$var$vf, $a1dbf210d8994fb8$var$ff = "__reactContainer$" + $a1dbf210d8994fb8$var$vf, $a1dbf210d8994fb8$var$yf = "__reactEvents$" + $a1dbf210d8994fb8$var$vf;
function $a1dbf210d8994fb8$var$wc(a) {
    var b = a[$a1dbf210d8994fb8$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a1dbf210d8994fb8$var$ff] || c[$a1dbf210d8994fb8$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a1dbf210d8994fb8$var$sf(a); null !== a;){
                if (c = a[$a1dbf210d8994fb8$var$wf]) return c;
                a = $a1dbf210d8994fb8$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a1dbf210d8994fb8$var$Cb(a) {
    a = a[$a1dbf210d8994fb8$var$wf] || a[$a1dbf210d8994fb8$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a1dbf210d8994fb8$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a1dbf210d8994fb8$var$y(33));
}
function $a1dbf210d8994fb8$var$Db(a) {
    return a[$a1dbf210d8994fb8$var$xf] || null;
}
function $a1dbf210d8994fb8$var$$e(a) {
    var b = a[$a1dbf210d8994fb8$var$yf];
    void 0 === b && (b = a[$a1dbf210d8994fb8$var$yf] = new Set);
    return b;
}
var $a1dbf210d8994fb8$var$zf = [], $a1dbf210d8994fb8$var$Af = -1;
function $a1dbf210d8994fb8$var$Bf(a) {
    return {
        current: a
    };
}
function $a1dbf210d8994fb8$var$H(a) {
    0 > $a1dbf210d8994fb8$var$Af || (a.current = $a1dbf210d8994fb8$var$zf[$a1dbf210d8994fb8$var$Af], $a1dbf210d8994fb8$var$zf[$a1dbf210d8994fb8$var$Af] = null, $a1dbf210d8994fb8$var$Af--);
}
function $a1dbf210d8994fb8$var$I(a, b) {
    $a1dbf210d8994fb8$var$Af++;
    $a1dbf210d8994fb8$var$zf[$a1dbf210d8994fb8$var$Af] = a.current;
    a.current = b;
}
var $a1dbf210d8994fb8$var$Cf = {}, $a1dbf210d8994fb8$var$M = $a1dbf210d8994fb8$var$Bf($a1dbf210d8994fb8$var$Cf), $a1dbf210d8994fb8$var$N = $a1dbf210d8994fb8$var$Bf(!1), $a1dbf210d8994fb8$var$Df = $a1dbf210d8994fb8$var$Cf;
function $a1dbf210d8994fb8$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a1dbf210d8994fb8$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a1dbf210d8994fb8$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a1dbf210d8994fb8$var$Gf() {
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N);
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$M);
}
function $a1dbf210d8994fb8$var$Hf(a, b, c) {
    if ($a1dbf210d8994fb8$var$M.current !== $a1dbf210d8994fb8$var$Cf) throw Error($a1dbf210d8994fb8$var$y(168));
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$M, b);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$N, c);
}
function $a1dbf210d8994fb8$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($a1dbf210d8994fb8$var$y(108, $a1dbf210d8994fb8$var$Ra(b) || "Unknown", e));
    return $9Rwgr({}, c, d);
}
function $a1dbf210d8994fb8$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a1dbf210d8994fb8$var$Cf;
    $a1dbf210d8994fb8$var$Df = $a1dbf210d8994fb8$var$M.current;
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$M, a);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$N, $a1dbf210d8994fb8$var$N.current);
    return !0;
}
function $a1dbf210d8994fb8$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a1dbf210d8994fb8$var$y(169));
    c ? (a = $a1dbf210d8994fb8$var$If(a, b, $a1dbf210d8994fb8$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N), $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$M), $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$M, a)) : $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$N, c);
}
var $a1dbf210d8994fb8$var$Lf = null, $a1dbf210d8994fb8$var$Mf = null, $a1dbf210d8994fb8$var$Nf = $3KFEz.unstable_runWithPriority, $a1dbf210d8994fb8$var$Of = $3KFEz.unstable_scheduleCallback, $a1dbf210d8994fb8$var$Pf = $3KFEz.unstable_cancelCallback, $a1dbf210d8994fb8$var$Qf = $3KFEz.unstable_shouldYield, $a1dbf210d8994fb8$var$Rf = $3KFEz.unstable_requestPaint, $a1dbf210d8994fb8$var$Sf = $3KFEz.unstable_now, $a1dbf210d8994fb8$var$Tf = $3KFEz.unstable_getCurrentPriorityLevel, $a1dbf210d8994fb8$var$Uf = $3KFEz.unstable_ImmediatePriority, $a1dbf210d8994fb8$var$Vf = $3KFEz.unstable_UserBlockingPriority, $a1dbf210d8994fb8$var$Wf = $3KFEz.unstable_NormalPriority, $a1dbf210d8994fb8$var$Xf = $3KFEz.unstable_LowPriority, $a1dbf210d8994fb8$var$Yf = $3KFEz.unstable_IdlePriority, $a1dbf210d8994fb8$var$Zf = {}, $a1dbf210d8994fb8$var$$f = void 0 !== $a1dbf210d8994fb8$var$Rf ? $a1dbf210d8994fb8$var$Rf : function $f() {}, $a1dbf210d8994fb8$var$ag = null, $a1dbf210d8994fb8$var$bg = null, $a1dbf210d8994fb8$var$cg = !1, $a1dbf210d8994fb8$var$dg = $a1dbf210d8994fb8$var$Sf(), $a1dbf210d8994fb8$var$O = 1E4 > $a1dbf210d8994fb8$var$dg ? $a1dbf210d8994fb8$var$Sf : function O() {
    return $a1dbf210d8994fb8$var$Sf() - $a1dbf210d8994fb8$var$dg;
};
function $a1dbf210d8994fb8$var$eg() {
    switch($a1dbf210d8994fb8$var$Tf()){
        case $a1dbf210d8994fb8$var$Uf:
            return 99;
        case $a1dbf210d8994fb8$var$Vf:
            return 98;
        case $a1dbf210d8994fb8$var$Wf:
            return 97;
        case $a1dbf210d8994fb8$var$Xf:
            return 96;
        case $a1dbf210d8994fb8$var$Yf:
            return 95;
        default:
            throw Error($a1dbf210d8994fb8$var$y(332));
    }
}
function $a1dbf210d8994fb8$var$fg(a) {
    switch(a){
        case 99:
            return $a1dbf210d8994fb8$var$Uf;
        case 98:
            return $a1dbf210d8994fb8$var$Vf;
        case 97:
            return $a1dbf210d8994fb8$var$Wf;
        case 96:
            return $a1dbf210d8994fb8$var$Xf;
        case 95:
            return $a1dbf210d8994fb8$var$Yf;
        default:
            throw Error($a1dbf210d8994fb8$var$y(332));
    }
}
function $a1dbf210d8994fb8$var$gg(a, b) {
    a = $a1dbf210d8994fb8$var$fg(a);
    return $a1dbf210d8994fb8$var$Nf(a, b);
}
function $a1dbf210d8994fb8$var$hg(a, b, c) {
    a = $a1dbf210d8994fb8$var$fg(a);
    return $a1dbf210d8994fb8$var$Of(a, b, c);
}
function $a1dbf210d8994fb8$var$ig() {
    if (null !== $a1dbf210d8994fb8$var$bg) {
        var a = $a1dbf210d8994fb8$var$bg;
        $a1dbf210d8994fb8$var$bg = null;
        $a1dbf210d8994fb8$var$Pf(a);
    }
    $a1dbf210d8994fb8$var$jg();
}
function $a1dbf210d8994fb8$var$jg() {
    if (!$a1dbf210d8994fb8$var$cg && null !== $a1dbf210d8994fb8$var$ag) {
        $a1dbf210d8994fb8$var$cg = !0;
        var a = 0;
        try {
            var b = $a1dbf210d8994fb8$var$ag;
            $a1dbf210d8994fb8$var$gg(99, function() {
                for(; a < b.length; a++){
                    var _$c = b[a];
                    do _$c = _$c(!0);
                    while (null !== _$c);
                }
            });
            $a1dbf210d8994fb8$var$ag = null;
        } catch (c) {
            throw null !== $a1dbf210d8994fb8$var$ag && ($a1dbf210d8994fb8$var$ag = $a1dbf210d8994fb8$var$ag.slice(a + 1)), $a1dbf210d8994fb8$var$Of($a1dbf210d8994fb8$var$Uf, $a1dbf210d8994fb8$var$ig), c;
        } finally{
            $a1dbf210d8994fb8$var$cg = !1;
        }
    }
}
var $a1dbf210d8994fb8$var$kg = $a1dbf210d8994fb8$var$ra.ReactCurrentBatchConfig;
function $a1dbf210d8994fb8$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $9Rwgr({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a1dbf210d8994fb8$var$mg = $a1dbf210d8994fb8$var$Bf(null), $a1dbf210d8994fb8$var$ng = null, $a1dbf210d8994fb8$var$og = null, $a1dbf210d8994fb8$var$pg = null;
function $a1dbf210d8994fb8$var$qg() {
    $a1dbf210d8994fb8$var$pg = $a1dbf210d8994fb8$var$og = $a1dbf210d8994fb8$var$ng = null;
}
function $a1dbf210d8994fb8$var$rg(a) {
    var b = $a1dbf210d8994fb8$var$mg.current;
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$mg);
    a.type._context._currentValue = b;
}
function $a1dbf210d8994fb8$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $a1dbf210d8994fb8$var$tg(a, b) {
    $a1dbf210d8994fb8$var$ng = a;
    $a1dbf210d8994fb8$var$pg = $a1dbf210d8994fb8$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a1dbf210d8994fb8$var$ug = !0), a.firstContext = null);
}
function $a1dbf210d8994fb8$var$vg(a, b) {
    if ($a1dbf210d8994fb8$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $a1dbf210d8994fb8$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $a1dbf210d8994fb8$var$og) {
            if (null === $a1dbf210d8994fb8$var$ng) throw Error($a1dbf210d8994fb8$var$y(308));
            $a1dbf210d8994fb8$var$og = b;
            $a1dbf210d8994fb8$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $a1dbf210d8994fb8$var$og = $a1dbf210d8994fb8$var$og.next = b;
    }
    return a._currentValue;
}
var $a1dbf210d8994fb8$var$wg = !1;
function $a1dbf210d8994fb8$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $a1dbf210d8994fb8$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a1dbf210d8994fb8$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a1dbf210d8994fb8$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $a1dbf210d8994fb8$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a1dbf210d8994fb8$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $a1dbf210d8994fb8$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $9Rwgr({}, A, h);
                            break a;
                        case 2:
                            $a1dbf210d8994fb8$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $a1dbf210d8994fb8$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $a1dbf210d8994fb8$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a1dbf210d8994fb8$var$y(191, e));
            e.call(d);
        }
    }
}
var $a1dbf210d8994fb8$var$Fg = (new $4CEbD.Component).refs;
function $a1dbf210d8994fb8$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9Rwgr({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a1dbf210d8994fb8$var$Kg = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $a1dbf210d8994fb8$var$Zb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $a1dbf210d8994fb8$var$Hg(), e = $a1dbf210d8994fb8$var$Ig(a), f = $a1dbf210d8994fb8$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $a1dbf210d8994fb8$var$Ag(a, f);
        $a1dbf210d8994fb8$var$Jg(a, e, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $a1dbf210d8994fb8$var$Hg(), e = $a1dbf210d8994fb8$var$Ig(a), f = $a1dbf210d8994fb8$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $a1dbf210d8994fb8$var$Ag(a, f);
        $a1dbf210d8994fb8$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $a1dbf210d8994fb8$var$Hg(), d = $a1dbf210d8994fb8$var$Ig(a), e = $a1dbf210d8994fb8$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $a1dbf210d8994fb8$var$Ag(a, e);
        $a1dbf210d8994fb8$var$Jg(a, d, c);
    }
};
function $a1dbf210d8994fb8$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a1dbf210d8994fb8$var$Je(c, d) || !$a1dbf210d8994fb8$var$Je(e, f) : !0;
}
function $a1dbf210d8994fb8$var$Mg(a, b, c) {
    var d = !1, e = $a1dbf210d8994fb8$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a1dbf210d8994fb8$var$vg(f) : (e = $a1dbf210d8994fb8$var$Ff(b) ? $a1dbf210d8994fb8$var$Df : $a1dbf210d8994fb8$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a1dbf210d8994fb8$var$Ef(a, e) : $a1dbf210d8994fb8$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a1dbf210d8994fb8$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a1dbf210d8994fb8$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a1dbf210d8994fb8$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $a1dbf210d8994fb8$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a1dbf210d8994fb8$var$Fg;
    $a1dbf210d8994fb8$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a1dbf210d8994fb8$var$vg(f) : (f = $a1dbf210d8994fb8$var$Ff(b) ? $a1dbf210d8994fb8$var$Df : $a1dbf210d8994fb8$var$M.current, e.context = $a1dbf210d8994fb8$var$Ef(a, f));
    $a1dbf210d8994fb8$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a1dbf210d8994fb8$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a1dbf210d8994fb8$var$Kg.enqueueReplaceState(e, e.state, null), $a1dbf210d8994fb8$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $a1dbf210d8994fb8$var$Pg = Array.isArray;
function $a1dbf210d8994fb8$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a1dbf210d8994fb8$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a1dbf210d8994fb8$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function b(a) {
                var _$b = d.refs;
                _$b === $a1dbf210d8994fb8$var$Fg && (_$b = d.refs = {});
                null === a ? delete _$b[e] : _$b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($a1dbf210d8994fb8$var$y(284));
        if (!c._owner) throw Error($a1dbf210d8994fb8$var$y(290, a));
    }
    return a;
}
function $a1dbf210d8994fb8$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($a1dbf210d8994fb8$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $a1dbf210d8994fb8$var$Sg(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.lastEffect;
            null !== d ? (d.nextEffect = c, _b.lastEffect = c) : _b.firstEffect = _b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $a1dbf210d8994fb8$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a1dbf210d8994fb8$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $a1dbf210d8994fb8$var$Qg(a, b, c), d.return = a, d;
        d = $a1dbf210d8994fb8$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a1dbf210d8994fb8$var$Qg(a, b, c);
        d.return = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a1dbf210d8994fb8$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    };
    var n = function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a1dbf210d8994fb8$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var A = function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $a1dbf210d8994fb8$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a1dbf210d8994fb8$var$sa:
                    return c = $a1dbf210d8994fb8$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $a1dbf210d8994fb8$var$Qg(a, null, b), c.return = a, c;
                case $a1dbf210d8994fb8$var$ta:
                    return b = $a1dbf210d8994fb8$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($a1dbf210d8994fb8$var$Pg(b) || $a1dbf210d8994fb8$var$La(b)) return b = $a1dbf210d8994fb8$var$Xg(b, a.mode, c, null), b.return = a, b;
            $a1dbf210d8994fb8$var$Rg(a, b);
        }
        return null;
    };
    var p = function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a1dbf210d8994fb8$var$sa:
                    return c.key === e ? c.type === $a1dbf210d8994fb8$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a1dbf210d8994fb8$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($a1dbf210d8994fb8$var$Pg(c) || $a1dbf210d8994fb8$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $a1dbf210d8994fb8$var$Rg(a, c);
        }
        return null;
    };
    var C = function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a1dbf210d8994fb8$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $a1dbf210d8994fb8$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a1dbf210d8994fb8$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($a1dbf210d8994fb8$var$Pg(d) || $a1dbf210d8994fb8$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $a1dbf210d8994fb8$var$Rg(b, d);
        }
        return null;
    };
    var x = function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    };
    var w = function w(e, g, h, k) {
        var l = $a1dbf210d8994fb8$var$La(h);
        if ("function" !== typeof l) throw Error($a1dbf210d8994fb8$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($a1dbf210d8994fb8$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    };
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $a1dbf210d8994fb8$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $a1dbf210d8994fb8$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $a1dbf210d8994fb8$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $a1dbf210d8994fb8$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $a1dbf210d8994fb8$var$ua ? (d = $a1dbf210d8994fb8$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a1dbf210d8994fb8$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $a1dbf210d8994fb8$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a1dbf210d8994fb8$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $a1dbf210d8994fb8$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a1dbf210d8994fb8$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($a1dbf210d8994fb8$var$Pg(f)) return x(a, d, f, h);
        if ($a1dbf210d8994fb8$var$La(f)) return w(a, d, f, h);
        l && $a1dbf210d8994fb8$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($a1dbf210d8994fb8$var$y(152, $a1dbf210d8994fb8$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $a1dbf210d8994fb8$var$Yg = $a1dbf210d8994fb8$var$Sg(!0), $a1dbf210d8994fb8$var$Zg = $a1dbf210d8994fb8$var$Sg(!1), $a1dbf210d8994fb8$var$$g = {}, $a1dbf210d8994fb8$var$ah = $a1dbf210d8994fb8$var$Bf($a1dbf210d8994fb8$var$$g), $a1dbf210d8994fb8$var$bh = $a1dbf210d8994fb8$var$Bf($a1dbf210d8994fb8$var$$g), $a1dbf210d8994fb8$var$ch = $a1dbf210d8994fb8$var$Bf($a1dbf210d8994fb8$var$$g);
function $a1dbf210d8994fb8$var$dh(a) {
    if (a === $a1dbf210d8994fb8$var$$g) throw Error($a1dbf210d8994fb8$var$y(174));
    return a;
}
function $a1dbf210d8994fb8$var$eh(a, b) {
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$ch, b);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$bh, a);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$ah, $a1dbf210d8994fb8$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a1dbf210d8994fb8$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a1dbf210d8994fb8$var$mb(b, a);
    }
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$ah);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$ah, b);
}
function $a1dbf210d8994fb8$var$fh() {
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$ah);
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$bh);
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$ch);
}
function $a1dbf210d8994fb8$var$gh(a) {
    $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ch.current);
    var b = $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ah.current);
    var c = $a1dbf210d8994fb8$var$mb(b, a.type);
    b !== c && ($a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$bh, a), $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$ah, c));
}
function $a1dbf210d8994fb8$var$hh(a) {
    $a1dbf210d8994fb8$var$bh.current === a && ($a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$ah), $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$bh));
}
var $a1dbf210d8994fb8$var$P = $a1dbf210d8994fb8$var$Bf(0);
function $a1dbf210d8994fb8$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a1dbf210d8994fb8$var$jh = null, $a1dbf210d8994fb8$var$kh = null, $a1dbf210d8994fb8$var$lh = !1;
function $a1dbf210d8994fb8$var$mh(a, b) {
    var c = $a1dbf210d8994fb8$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $a1dbf210d8994fb8$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $a1dbf210d8994fb8$var$ph(a) {
    if ($a1dbf210d8994fb8$var$lh) {
        var b = $a1dbf210d8994fb8$var$kh;
        if (b) {
            var c = b;
            if (!$a1dbf210d8994fb8$var$oh(a, b)) {
                b = $a1dbf210d8994fb8$var$rf(c.nextSibling);
                if (!b || !$a1dbf210d8994fb8$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $a1dbf210d8994fb8$var$lh = !1;
                    $a1dbf210d8994fb8$var$jh = a;
                    return;
                }
                $a1dbf210d8994fb8$var$mh($a1dbf210d8994fb8$var$jh, c);
            }
            $a1dbf210d8994fb8$var$jh = a;
            $a1dbf210d8994fb8$var$kh = $a1dbf210d8994fb8$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $a1dbf210d8994fb8$var$lh = !1, $a1dbf210d8994fb8$var$jh = a;
    }
}
function $a1dbf210d8994fb8$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a1dbf210d8994fb8$var$jh = a;
}
function $a1dbf210d8994fb8$var$rh(a) {
    if (a !== $a1dbf210d8994fb8$var$jh) return !1;
    if (!$a1dbf210d8994fb8$var$lh) return $a1dbf210d8994fb8$var$qh(a), $a1dbf210d8994fb8$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$a1dbf210d8994fb8$var$nf(b, a.memoizedProps)) for(b = $a1dbf210d8994fb8$var$kh; b;)$a1dbf210d8994fb8$var$mh(a, b), b = $a1dbf210d8994fb8$var$rf(b.nextSibling);
    $a1dbf210d8994fb8$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a1dbf210d8994fb8$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a1dbf210d8994fb8$var$kh = $a1dbf210d8994fb8$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a1dbf210d8994fb8$var$kh = null;
        }
    } else $a1dbf210d8994fb8$var$kh = $a1dbf210d8994fb8$var$jh ? $a1dbf210d8994fb8$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a1dbf210d8994fb8$var$sh() {
    $a1dbf210d8994fb8$var$kh = $a1dbf210d8994fb8$var$jh = null;
    $a1dbf210d8994fb8$var$lh = !1;
}
var $a1dbf210d8994fb8$var$th = [];
function $a1dbf210d8994fb8$var$uh() {
    for(var a = 0; a < $a1dbf210d8994fb8$var$th.length; a++)$a1dbf210d8994fb8$var$th[a]._workInProgressVersionPrimary = null;
    $a1dbf210d8994fb8$var$th.length = 0;
}
var $a1dbf210d8994fb8$var$vh = $a1dbf210d8994fb8$var$ra.ReactCurrentDispatcher, $a1dbf210d8994fb8$var$wh = $a1dbf210d8994fb8$var$ra.ReactCurrentBatchConfig, $a1dbf210d8994fb8$var$xh = 0, $a1dbf210d8994fb8$var$R = null, $a1dbf210d8994fb8$var$S = null, $a1dbf210d8994fb8$var$T = null, $a1dbf210d8994fb8$var$yh = !1, $a1dbf210d8994fb8$var$zh = !1;
function $a1dbf210d8994fb8$var$Ah() {
    throw Error($a1dbf210d8994fb8$var$y(321));
}
function $a1dbf210d8994fb8$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a1dbf210d8994fb8$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a1dbf210d8994fb8$var$Ch(a, b, c, d, e, f) {
    $a1dbf210d8994fb8$var$xh = f;
    $a1dbf210d8994fb8$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a1dbf210d8994fb8$var$vh.current = null === a || null === a.memoizedState ? $a1dbf210d8994fb8$var$Dh : $a1dbf210d8994fb8$var$Eh;
    a = c(d, e);
    if ($a1dbf210d8994fb8$var$zh) {
        f = 0;
        do {
            $a1dbf210d8994fb8$var$zh = !1;
            if (!(25 > f)) throw Error($a1dbf210d8994fb8$var$y(301));
            f += 1;
            $a1dbf210d8994fb8$var$T = $a1dbf210d8994fb8$var$S = null;
            b.updateQueue = null;
            $a1dbf210d8994fb8$var$vh.current = $a1dbf210d8994fb8$var$Fh;
            a = c(d, e);
        }while ($a1dbf210d8994fb8$var$zh);
    }
    $a1dbf210d8994fb8$var$vh.current = $a1dbf210d8994fb8$var$Gh;
    b = null !== $a1dbf210d8994fb8$var$S && null !== $a1dbf210d8994fb8$var$S.next;
    $a1dbf210d8994fb8$var$xh = 0;
    $a1dbf210d8994fb8$var$T = $a1dbf210d8994fb8$var$S = $a1dbf210d8994fb8$var$R = null;
    $a1dbf210d8994fb8$var$yh = !1;
    if (b) throw Error($a1dbf210d8994fb8$var$y(300));
    return a;
}
function $a1dbf210d8994fb8$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a1dbf210d8994fb8$var$T ? $a1dbf210d8994fb8$var$R.memoizedState = $a1dbf210d8994fb8$var$T = a : $a1dbf210d8994fb8$var$T = $a1dbf210d8994fb8$var$T.next = a;
    return $a1dbf210d8994fb8$var$T;
}
function $a1dbf210d8994fb8$var$Ih() {
    if (null === $a1dbf210d8994fb8$var$S) {
        var a = $a1dbf210d8994fb8$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a1dbf210d8994fb8$var$S.next;
    var b = null === $a1dbf210d8994fb8$var$T ? $a1dbf210d8994fb8$var$R.memoizedState : $a1dbf210d8994fb8$var$T.next;
    if (null !== b) $a1dbf210d8994fb8$var$T = b, $a1dbf210d8994fb8$var$S = a;
    else {
        if (null === a) throw Error($a1dbf210d8994fb8$var$y(310));
        $a1dbf210d8994fb8$var$S = a;
        a = {
            memoizedState: $a1dbf210d8994fb8$var$S.memoizedState,
            baseState: $a1dbf210d8994fb8$var$S.baseState,
            baseQueue: $a1dbf210d8994fb8$var$S.baseQueue,
            queue: $a1dbf210d8994fb8$var$S.queue,
            next: null
        };
        null === $a1dbf210d8994fb8$var$T ? $a1dbf210d8994fb8$var$R.memoizedState = $a1dbf210d8994fb8$var$T = a : $a1dbf210d8994fb8$var$T = $a1dbf210d8994fb8$var$T.next = a;
    }
    return $a1dbf210d8994fb8$var$T;
}
function $a1dbf210d8994fb8$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a1dbf210d8994fb8$var$Kh(a) {
    var b = $a1dbf210d8994fb8$var$Ih(), c = b.queue;
    if (null === c) throw Error($a1dbf210d8994fb8$var$y(311));
    c.lastRenderedReducer = a;
    var d = $a1dbf210d8994fb8$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($a1dbf210d8994fb8$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $a1dbf210d8994fb8$var$R.lanes |= l;
                $a1dbf210d8994fb8$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $a1dbf210d8994fb8$var$He(d, b.memoizedState) || ($a1dbf210d8994fb8$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a1dbf210d8994fb8$var$Lh(a) {
    var b = $a1dbf210d8994fb8$var$Ih(), c = b.queue;
    if (null === c) throw Error($a1dbf210d8994fb8$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a1dbf210d8994fb8$var$He(f, b.memoizedState) || ($a1dbf210d8994fb8$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a1dbf210d8994fb8$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($a1dbf210d8994fb8$var$xh & a) === a) b._workInProgressVersionPrimary = d, $a1dbf210d8994fb8$var$th.push(b);
    if (a) return c(b._source);
    $a1dbf210d8994fb8$var$th.push(b);
    throw Error($a1dbf210d8994fb8$var$y(350));
}
function $a1dbf210d8994fb8$var$Nh(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$U;
    if (null === e) throw Error($a1dbf210d8994fb8$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $a1dbf210d8994fb8$var$vh.current, k = h.useState(function() {
        return $a1dbf210d8994fb8$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $a1dbf210d8994fb8$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $a1dbf210d8994fb8$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var _$a = f(b._source);
        if (!$a1dbf210d8994fb8$var$He(g, _$a)) {
            _$a = c(b._source);
            $a1dbf210d8994fb8$var$He(n, _$a) || (l(_$a), _$a = $a1dbf210d8994fb8$var$Ig(w), e.mutableReadLanes |= _$a & e.pendingLanes);
            _$a = e.mutableReadLanes;
            e.entangledLanes |= _$a;
            for(var _$d = e.entanglements, h = _$a; 0 < h;){
                var k = 31 - $a1dbf210d8994fb8$var$Vc(h), v = 1 << k;
                _$d[k] |= _$a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var _$a = p.getSnapshot, _$c = p.setSnapshot;
            try {
                _$c(_$a(b._source));
                var _$d = $a1dbf210d8994fb8$var$Ig(w);
                e.mutableReadLanes |= _$d & e.pendingLanes;
            } catch (q) {
                _$c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $a1dbf210d8994fb8$var$He(C, c) && $a1dbf210d8994fb8$var$He(x, b) && $a1dbf210d8994fb8$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $a1dbf210d8994fb8$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $a1dbf210d8994fb8$var$Oh.bind(null, $a1dbf210d8994fb8$var$R, a), k.queue = a, k.baseQueue = null, n = $a1dbf210d8994fb8$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $a1dbf210d8994fb8$var$Ph(a, b, c) {
    var d = $a1dbf210d8994fb8$var$Ih();
    return $a1dbf210d8994fb8$var$Nh(d, a, b, c);
}
function $a1dbf210d8994fb8$var$Qh(a) {
    var b = $a1dbf210d8994fb8$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $a1dbf210d8994fb8$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $a1dbf210d8994fb8$var$Oh.bind(null, $a1dbf210d8994fb8$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a1dbf210d8994fb8$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a1dbf210d8994fb8$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $a1dbf210d8994fb8$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a1dbf210d8994fb8$var$Sh(a) {
    var b = $a1dbf210d8994fb8$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $a1dbf210d8994fb8$var$Th() {
    return $a1dbf210d8994fb8$var$Ih().memoizedState;
}
function $a1dbf210d8994fb8$var$Uh(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$Hh();
    $a1dbf210d8994fb8$var$R.flags |= a;
    e.memoizedState = $a1dbf210d8994fb8$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a1dbf210d8994fb8$var$Vh(a, b, c, d) {
    var e = $a1dbf210d8994fb8$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a1dbf210d8994fb8$var$S) {
        var g = $a1dbf210d8994fb8$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $a1dbf210d8994fb8$var$Bh(d, g.deps)) {
            $a1dbf210d8994fb8$var$Rh(b, c, f, d);
            return;
        }
    }
    $a1dbf210d8994fb8$var$R.flags |= a;
    e.memoizedState = $a1dbf210d8994fb8$var$Rh(1 | b, c, f, d);
}
function $a1dbf210d8994fb8$var$Wh(a, b) {
    return $a1dbf210d8994fb8$var$Uh(516, 4, a, b);
}
function $a1dbf210d8994fb8$var$Xh(a, b) {
    return $a1dbf210d8994fb8$var$Vh(516, 4, a, b);
}
function $a1dbf210d8994fb8$var$Yh(a, b) {
    return $a1dbf210d8994fb8$var$Vh(4, 2, a, b);
}
function $a1dbf210d8994fb8$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a1dbf210d8994fb8$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a1dbf210d8994fb8$var$Vh(4, 2, $a1dbf210d8994fb8$var$Zh.bind(null, b, a), c);
}
function $a1dbf210d8994fb8$var$ai() {}
function $a1dbf210d8994fb8$var$bi(a, b) {
    var c = $a1dbf210d8994fb8$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a1dbf210d8994fb8$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a1dbf210d8994fb8$var$ci(a, b) {
    var c = $a1dbf210d8994fb8$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a1dbf210d8994fb8$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a1dbf210d8994fb8$var$di(a, b) {
    var c = $a1dbf210d8994fb8$var$eg();
    $a1dbf210d8994fb8$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $a1dbf210d8994fb8$var$gg(97 < c ? 97 : c, function() {
        var c = $a1dbf210d8994fb8$var$wh.transition;
        $a1dbf210d8994fb8$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $a1dbf210d8994fb8$var$wh.transition = c;
        }
    });
}
function $a1dbf210d8994fb8$var$Oh(a, b, c) {
    var d = $a1dbf210d8994fb8$var$Hg(), e = $a1dbf210d8994fb8$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $a1dbf210d8994fb8$var$R || null !== g && g === $a1dbf210d8994fb8$var$R) $a1dbf210d8994fb8$var$zh = $a1dbf210d8994fb8$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($a1dbf210d8994fb8$var$He(k, h)) return;
        } catch (l) {} finally{}
        $a1dbf210d8994fb8$var$Jg(a, e, d);
    }
}
var $a1dbf210d8994fb8$var$Gh = {
    readContext: $a1dbf210d8994fb8$var$vg,
    useCallback: $a1dbf210d8994fb8$var$Ah,
    useContext: $a1dbf210d8994fb8$var$Ah,
    useEffect: $a1dbf210d8994fb8$var$Ah,
    useImperativeHandle: $a1dbf210d8994fb8$var$Ah,
    useLayoutEffect: $a1dbf210d8994fb8$var$Ah,
    useMemo: $a1dbf210d8994fb8$var$Ah,
    useReducer: $a1dbf210d8994fb8$var$Ah,
    useRef: $a1dbf210d8994fb8$var$Ah,
    useState: $a1dbf210d8994fb8$var$Ah,
    useDebugValue: $a1dbf210d8994fb8$var$Ah,
    useDeferredValue: $a1dbf210d8994fb8$var$Ah,
    useTransition: $a1dbf210d8994fb8$var$Ah,
    useMutableSource: $a1dbf210d8994fb8$var$Ah,
    useOpaqueIdentifier: $a1dbf210d8994fb8$var$Ah,
    unstable_isNewReconciler: !1
}, $a1dbf210d8994fb8$var$Dh = {
    readContext: $a1dbf210d8994fb8$var$vg,
    useCallback: function useCallback(a, b) {
        $a1dbf210d8994fb8$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a1dbf210d8994fb8$var$vg,
    useEffect: $a1dbf210d8994fb8$var$Wh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a1dbf210d8994fb8$var$Uh(4, 2, $a1dbf210d8994fb8$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $a1dbf210d8994fb8$var$Uh(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $a1dbf210d8994fb8$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $a1dbf210d8994fb8$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $a1dbf210d8994fb8$var$Oh.bind(null, $a1dbf210d8994fb8$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $a1dbf210d8994fb8$var$Sh,
    useState: $a1dbf210d8994fb8$var$Qh,
    useDebugValue: $a1dbf210d8994fb8$var$ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $a1dbf210d8994fb8$var$Qh(a), c = b[0], d = b[1];
        $a1dbf210d8994fb8$var$Wh(function() {
            var b = $a1dbf210d8994fb8$var$wh.transition;
            $a1dbf210d8994fb8$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $a1dbf210d8994fb8$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = $a1dbf210d8994fb8$var$Qh(!1), b = a[0];
        a = $a1dbf210d8994fb8$var$di.bind(null, a[1]);
        $a1dbf210d8994fb8$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function useMutableSource(a, b, c) {
        var d = $a1dbf210d8994fb8$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $a1dbf210d8994fb8$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        if ($a1dbf210d8994fb8$var$lh) {
            var a = !1, b = $a1dbf210d8994fb8$var$uf(function() {
                a || (a = !0, c("r:" + ($a1dbf210d8994fb8$var$tf++).toString(36)));
                throw Error($a1dbf210d8994fb8$var$y(355));
            }), c = $a1dbf210d8994fb8$var$Qh(b)[1];
            0 === ($a1dbf210d8994fb8$var$R.mode & 2) && ($a1dbf210d8994fb8$var$R.flags |= 516, $a1dbf210d8994fb8$var$Rh(5, function() {
                c("r:" + ($a1dbf210d8994fb8$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($a1dbf210d8994fb8$var$tf++).toString(36);
        $a1dbf210d8994fb8$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $a1dbf210d8994fb8$var$Eh = {
    readContext: $a1dbf210d8994fb8$var$vg,
    useCallback: $a1dbf210d8994fb8$var$bi,
    useContext: $a1dbf210d8994fb8$var$vg,
    useEffect: $a1dbf210d8994fb8$var$Xh,
    useImperativeHandle: $a1dbf210d8994fb8$var$$h,
    useLayoutEffect: $a1dbf210d8994fb8$var$Yh,
    useMemo: $a1dbf210d8994fb8$var$ci,
    useReducer: $a1dbf210d8994fb8$var$Kh,
    useRef: $a1dbf210d8994fb8$var$Th,
    useState: function useState() {
        return $a1dbf210d8994fb8$var$Kh($a1dbf210d8994fb8$var$Jh);
    },
    useDebugValue: $a1dbf210d8994fb8$var$ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $a1dbf210d8994fb8$var$Kh($a1dbf210d8994fb8$var$Jh), c = b[0], d = b[1];
        $a1dbf210d8994fb8$var$Xh(function() {
            var b = $a1dbf210d8994fb8$var$wh.transition;
            $a1dbf210d8994fb8$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $a1dbf210d8994fb8$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = $a1dbf210d8994fb8$var$Kh($a1dbf210d8994fb8$var$Jh)[0];
        return [
            $a1dbf210d8994fb8$var$Th().current,
            a
        ];
    },
    useMutableSource: $a1dbf210d8994fb8$var$Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return $a1dbf210d8994fb8$var$Kh($a1dbf210d8994fb8$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $a1dbf210d8994fb8$var$Fh = {
    readContext: $a1dbf210d8994fb8$var$vg,
    useCallback: $a1dbf210d8994fb8$var$bi,
    useContext: $a1dbf210d8994fb8$var$vg,
    useEffect: $a1dbf210d8994fb8$var$Xh,
    useImperativeHandle: $a1dbf210d8994fb8$var$$h,
    useLayoutEffect: $a1dbf210d8994fb8$var$Yh,
    useMemo: $a1dbf210d8994fb8$var$ci,
    useReducer: $a1dbf210d8994fb8$var$Lh,
    useRef: $a1dbf210d8994fb8$var$Th,
    useState: function useState() {
        return $a1dbf210d8994fb8$var$Lh($a1dbf210d8994fb8$var$Jh);
    },
    useDebugValue: $a1dbf210d8994fb8$var$ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $a1dbf210d8994fb8$var$Lh($a1dbf210d8994fb8$var$Jh), c = b[0], d = b[1];
        $a1dbf210d8994fb8$var$Xh(function() {
            var b = $a1dbf210d8994fb8$var$wh.transition;
            $a1dbf210d8994fb8$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $a1dbf210d8994fb8$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = $a1dbf210d8994fb8$var$Lh($a1dbf210d8994fb8$var$Jh)[0];
        return [
            $a1dbf210d8994fb8$var$Th().current,
            a
        ];
    },
    useMutableSource: $a1dbf210d8994fb8$var$Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return $a1dbf210d8994fb8$var$Lh($a1dbf210d8994fb8$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $a1dbf210d8994fb8$var$ei = $a1dbf210d8994fb8$var$ra.ReactCurrentOwner, $a1dbf210d8994fb8$var$ug = !1;
function $a1dbf210d8994fb8$var$fi(a, b, c, d) {
    b.child = null === a ? $a1dbf210d8994fb8$var$Zg(b, null, c, d) : $a1dbf210d8994fb8$var$Yg(b, a.child, c, d);
}
function $a1dbf210d8994fb8$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a1dbf210d8994fb8$var$tg(b, e);
    d = $a1dbf210d8994fb8$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$a1dbf210d8994fb8$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $a1dbf210d8994fb8$var$hi(a, b, e);
    b.flags |= 1;
    $a1dbf210d8994fb8$var$fi(a, b, d, e);
    return b.child;
}
function $a1dbf210d8994fb8$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$a1dbf210d8994fb8$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $a1dbf210d8994fb8$var$ki(a, b, g, d, e, f);
        a = $a1dbf210d8994fb8$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $a1dbf210d8994fb8$var$Je, c(e, d) && a.ref === b.ref)) return $a1dbf210d8994fb8$var$hi(a, b, f);
    b.flags |= 1;
    a = $a1dbf210d8994fb8$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a1dbf210d8994fb8$var$ki(a, b, c, d, e, f) {
    if (null !== a && $a1dbf210d8994fb8$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($a1dbf210d8994fb8$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($a1dbf210d8994fb8$var$ug = !0);
        else return b.lanes = a.lanes, $a1dbf210d8994fb8$var$hi(a, b, f);
    }
    return $a1dbf210d8994fb8$var$li(a, b, c, d, f);
}
function $a1dbf210d8994fb8$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $a1dbf210d8994fb8$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $a1dbf210d8994fb8$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $a1dbf210d8994fb8$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a1dbf210d8994fb8$var$ni(b, d);
    $a1dbf210d8994fb8$var$fi(a, b, e, c);
    return b.child;
}
function $a1dbf210d8994fb8$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $a1dbf210d8994fb8$var$li(a, b, c, d, e) {
    var f = $a1dbf210d8994fb8$var$Ff(c) ? $a1dbf210d8994fb8$var$Df : $a1dbf210d8994fb8$var$M.current;
    f = $a1dbf210d8994fb8$var$Ef(b, f);
    $a1dbf210d8994fb8$var$tg(b, e);
    c = $a1dbf210d8994fb8$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$a1dbf210d8994fb8$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $a1dbf210d8994fb8$var$hi(a, b, e);
    b.flags |= 1;
    $a1dbf210d8994fb8$var$fi(a, b, c, e);
    return b.child;
}
function $a1dbf210d8994fb8$var$pi(a, b, c, d, e) {
    if ($a1dbf210d8994fb8$var$Ff(c)) {
        var f = !0;
        $a1dbf210d8994fb8$var$Jf(b);
    } else f = !1;
    $a1dbf210d8994fb8$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $a1dbf210d8994fb8$var$Mg(b, c, d), $a1dbf210d8994fb8$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a1dbf210d8994fb8$var$vg(l) : (l = $a1dbf210d8994fb8$var$Ff(c) ? $a1dbf210d8994fb8$var$Df : $a1dbf210d8994fb8$var$M.current, l = $a1dbf210d8994fb8$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a1dbf210d8994fb8$var$Ng(b, g, d, l);
        $a1dbf210d8994fb8$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $a1dbf210d8994fb8$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $a1dbf210d8994fb8$var$N.current || $a1dbf210d8994fb8$var$wg ? ("function" === typeof n && ($a1dbf210d8994fb8$var$Gg(b, c, n, d), k = b.memoizedState), (h = $a1dbf210d8994fb8$var$wg || $a1dbf210d8994fb8$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $a1dbf210d8994fb8$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a1dbf210d8994fb8$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a1dbf210d8994fb8$var$vg(k) : (k = $a1dbf210d8994fb8$var$Ff(c) ? $a1dbf210d8994fb8$var$Df : $a1dbf210d8994fb8$var$M.current, k = $a1dbf210d8994fb8$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $a1dbf210d8994fb8$var$Ng(b, g, d, k);
        $a1dbf210d8994fb8$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $a1dbf210d8994fb8$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $a1dbf210d8994fb8$var$N.current || $a1dbf210d8994fb8$var$wg ? ("function" === typeof C && ($a1dbf210d8994fb8$var$Gg(b, c, C, d), x = b.memoizedState), (l = $a1dbf210d8994fb8$var$wg || $a1dbf210d8994fb8$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $a1dbf210d8994fb8$var$qi(a, b, c, d, f, e);
}
function $a1dbf210d8994fb8$var$qi(a, b, c, d, e, f) {
    $a1dbf210d8994fb8$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $a1dbf210d8994fb8$var$Kf(b, c, !1), $a1dbf210d8994fb8$var$hi(a, b, f);
    d = b.stateNode;
    $a1dbf210d8994fb8$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a1dbf210d8994fb8$var$Yg(b, a.child, null, f), b.child = $a1dbf210d8994fb8$var$Yg(b, null, h, f)) : $a1dbf210d8994fb8$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a1dbf210d8994fb8$var$Kf(b, c, !0);
    return b.child;
}
function $a1dbf210d8994fb8$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $a1dbf210d8994fb8$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a1dbf210d8994fb8$var$Hf(a, b.context, !1);
    $a1dbf210d8994fb8$var$eh(a, b.containerInfo);
}
var $a1dbf210d8994fb8$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $a1dbf210d8994fb8$var$ti(a, b, c) {
    var d = b.pendingProps, e = $a1dbf210d8994fb8$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $a1dbf210d8994fb8$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $a1dbf210d8994fb8$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $a1dbf210d8994fb8$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $a1dbf210d8994fb8$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $a1dbf210d8994fb8$var$si, b.lanes = 33554432, a;
        c = $a1dbf210d8994fb8$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $a1dbf210d8994fb8$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $a1dbf210d8994fb8$var$si, d;
        c = $a1dbf210d8994fb8$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $a1dbf210d8994fb8$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $a1dbf210d8994fb8$var$si, d;
    c = $a1dbf210d8994fb8$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $a1dbf210d8994fb8$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $a1dbf210d8994fb8$var$vi(b, e, 0, null);
    c = $a1dbf210d8994fb8$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $a1dbf210d8994fb8$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $a1dbf210d8994fb8$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $a1dbf210d8994fb8$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $a1dbf210d8994fb8$var$Tg(g, h);
    null !== a ? d = $a1dbf210d8994fb8$var$Tg(a, d) : (d = $a1dbf210d8994fb8$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $a1dbf210d8994fb8$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $a1dbf210d8994fb8$var$sg(a.return, b);
}
function $a1dbf210d8994fb8$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $a1dbf210d8994fb8$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a1dbf210d8994fb8$var$fi(a, b, d.children, c);
    d = $a1dbf210d8994fb8$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a1dbf210d8994fb8$var$yi(a, c);
            else if (19 === a.tag) $a1dbf210d8994fb8$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a1dbf210d8994fb8$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a1dbf210d8994fb8$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a1dbf210d8994fb8$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a1dbf210d8994fb8$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $a1dbf210d8994fb8$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a1dbf210d8994fb8$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a1dbf210d8994fb8$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($a1dbf210d8994fb8$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $a1dbf210d8994fb8$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a1dbf210d8994fb8$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $a1dbf210d8994fb8$var$Bi, $a1dbf210d8994fb8$var$Ci, $a1dbf210d8994fb8$var$Di, $a1dbf210d8994fb8$var$Ei;
$a1dbf210d8994fb8$var$Bi = function Bi(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a1dbf210d8994fb8$var$Ci = function Ci() {};
$a1dbf210d8994fb8$var$Di = function Di(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $a1dbf210d8994fb8$var$Ya(a, e);
                d = $a1dbf210d8994fb8$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $a1dbf210d8994fb8$var$eb(a, e);
                d = $a1dbf210d8994fb8$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $9Rwgr({}, e, {
                    value: void 0
                });
                d = $9Rwgr({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a1dbf210d8994fb8$var$gb(a, e);
                d = $a1dbf210d8994fb8$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a1dbf210d8994fb8$var$jf);
        }
        $a1dbf210d8994fb8$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a1dbf210d8994fb8$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a1dbf210d8994fb8$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a1dbf210d8994fb8$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $a1dbf210d8994fb8$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a1dbf210d8994fb8$var$Ei = function Ei(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a1dbf210d8994fb8$var$Fi(a, b) {
    if (!$a1dbf210d8994fb8$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a1dbf210d8994fb8$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $a1dbf210d8994fb8$var$Ff(b.type) && $a1dbf210d8994fb8$var$Gf(), null;
        case 3:
            $a1dbf210d8994fb8$var$fh();
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N);
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$M);
            $a1dbf210d8994fb8$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a1dbf210d8994fb8$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $a1dbf210d8994fb8$var$Ci(b);
            return null;
        case 5:
            $a1dbf210d8994fb8$var$hh(b);
            var e = $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a1dbf210d8994fb8$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a1dbf210d8994fb8$var$y(166));
                    return null;
                }
                a = $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ah.current);
                if ($a1dbf210d8994fb8$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a1dbf210d8994fb8$var$wf] = b;
                    d[$a1dbf210d8994fb8$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $a1dbf210d8994fb8$var$G("cancel", d);
                            $a1dbf210d8994fb8$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a1dbf210d8994fb8$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $a1dbf210d8994fb8$var$Xe.length; a++)$a1dbf210d8994fb8$var$G($a1dbf210d8994fb8$var$Xe[a], d);
                            break;
                        case "source":
                            $a1dbf210d8994fb8$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a1dbf210d8994fb8$var$G("error", d);
                            $a1dbf210d8994fb8$var$G("load", d);
                            break;
                        case "details":
                            $a1dbf210d8994fb8$var$G("toggle", d);
                            break;
                        case "input":
                            $a1dbf210d8994fb8$var$Za(d, f);
                            $a1dbf210d8994fb8$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a1dbf210d8994fb8$var$G("invalid", d);
                            break;
                        case "textarea":
                            $a1dbf210d8994fb8$var$hb(d, f), $a1dbf210d8994fb8$var$G("invalid", d);
                    }
                    $a1dbf210d8994fb8$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $a1dbf210d8994fb8$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $a1dbf210d8994fb8$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $a1dbf210d8994fb8$var$Va(d);
                            $a1dbf210d8994fb8$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $a1dbf210d8994fb8$var$Va(d);
                            $a1dbf210d8994fb8$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a1dbf210d8994fb8$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $a1dbf210d8994fb8$var$kb.html && (a = $a1dbf210d8994fb8$var$lb(c));
                    a === $a1dbf210d8994fb8$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a1dbf210d8994fb8$var$wf] = b;
                    a[$a1dbf210d8994fb8$var$xf] = d;
                    $a1dbf210d8994fb8$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $a1dbf210d8994fb8$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $a1dbf210d8994fb8$var$G("cancel", a);
                            $a1dbf210d8994fb8$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a1dbf210d8994fb8$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a1dbf210d8994fb8$var$Xe.length; e++)$a1dbf210d8994fb8$var$G($a1dbf210d8994fb8$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $a1dbf210d8994fb8$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a1dbf210d8994fb8$var$G("error", a);
                            $a1dbf210d8994fb8$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $a1dbf210d8994fb8$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $a1dbf210d8994fb8$var$Za(a, d);
                            e = $a1dbf210d8994fb8$var$Ya(a, d);
                            $a1dbf210d8994fb8$var$G("invalid", a);
                            break;
                        case "option":
                            e = $a1dbf210d8994fb8$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $9Rwgr({}, d, {
                                value: void 0
                            });
                            $a1dbf210d8994fb8$var$G("invalid", a);
                            break;
                        case "textarea":
                            $a1dbf210d8994fb8$var$hb(a, d);
                            e = $a1dbf210d8994fb8$var$gb(a, d);
                            $a1dbf210d8994fb8$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $a1dbf210d8994fb8$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $a1dbf210d8994fb8$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a1dbf210d8994fb8$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a1dbf210d8994fb8$var$pb(a, k) : "number" === typeof k && $a1dbf210d8994fb8$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a1dbf210d8994fb8$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $a1dbf210d8994fb8$var$G("scroll", a) : null != k && $a1dbf210d8994fb8$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $a1dbf210d8994fb8$var$Va(a);
                            $a1dbf210d8994fb8$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $a1dbf210d8994fb8$var$Va(a);
                            $a1dbf210d8994fb8$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $a1dbf210d8994fb8$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $a1dbf210d8994fb8$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a1dbf210d8994fb8$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $a1dbf210d8994fb8$var$jf);
                    }
                    $a1dbf210d8994fb8$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $a1dbf210d8994fb8$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a1dbf210d8994fb8$var$y(166));
                c = $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ch.current);
                $a1dbf210d8994fb8$var$dh($a1dbf210d8994fb8$var$ah.current);
                $a1dbf210d8994fb8$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$a1dbf210d8994fb8$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a1dbf210d8994fb8$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $a1dbf210d8994fb8$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($a1dbf210d8994fb8$var$P.current & 1)) 0 === $a1dbf210d8994fb8$var$V && ($a1dbf210d8994fb8$var$V = 3);
                else {
                    if (0 === $a1dbf210d8994fb8$var$V || 3 === $a1dbf210d8994fb8$var$V) $a1dbf210d8994fb8$var$V = 4;
                    null === $a1dbf210d8994fb8$var$U || 0 === ($a1dbf210d8994fb8$var$Dg & 134217727) && 0 === ($a1dbf210d8994fb8$var$Hi & 134217727) || $a1dbf210d8994fb8$var$Ii($a1dbf210d8994fb8$var$U, $a1dbf210d8994fb8$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $a1dbf210d8994fb8$var$fh(), $a1dbf210d8994fb8$var$Ci(b), null === a && $a1dbf210d8994fb8$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $a1dbf210d8994fb8$var$rg(b), null;
        case 17:
            return $a1dbf210d8994fb8$var$Ff(b.type) && $a1dbf210d8994fb8$var$Gf(), null;
        case 19:
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $a1dbf210d8994fb8$var$Fi(d, !1);
                else {
                    if (0 !== $a1dbf210d8994fb8$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $a1dbf210d8994fb8$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $a1dbf210d8994fb8$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, $a1dbf210d8994fb8$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $a1dbf210d8994fb8$var$O() > $a1dbf210d8994fb8$var$Ji && (b.flags |= 64, f = !0, $a1dbf210d8994fb8$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $a1dbf210d8994fb8$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a1dbf210d8994fb8$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$a1dbf210d8994fb8$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $a1dbf210d8994fb8$var$O() - d.renderingStartTime > $a1dbf210d8994fb8$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $a1dbf210d8994fb8$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $a1dbf210d8994fb8$var$O(), c.sibling = null, b = $a1dbf210d8994fb8$var$P.current, $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $a1dbf210d8994fb8$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($a1dbf210d8994fb8$var$y(156, b.tag));
}
function $a1dbf210d8994fb8$var$Li(a) {
    switch(a.tag){
        case 1:
            $a1dbf210d8994fb8$var$Ff(a.type) && $a1dbf210d8994fb8$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $a1dbf210d8994fb8$var$fh();
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N);
            $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$M);
            $a1dbf210d8994fb8$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($a1dbf210d8994fb8$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $a1dbf210d8994fb8$var$hh(a), null;
        case 13:
            return $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P), null;
        case 4:
            return $a1dbf210d8994fb8$var$fh(), null;
        case 10:
            return $a1dbf210d8994fb8$var$rg(a), null;
        case 23:
        case 24:
            return $a1dbf210d8994fb8$var$Ki(), null;
        default:
            return null;
    }
}
function $a1dbf210d8994fb8$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $a1dbf210d8994fb8$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $a1dbf210d8994fb8$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a1dbf210d8994fb8$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $a1dbf210d8994fb8$var$Pi(a, b, c) {
    c = $a1dbf210d8994fb8$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a1dbf210d8994fb8$var$Qi || ($a1dbf210d8994fb8$var$Qi = !0, $a1dbf210d8994fb8$var$Ri = d);
        $a1dbf210d8994fb8$var$Ni(a, b);
    };
    return c;
}
function $a1dbf210d8994fb8$var$Si(a, b, c) {
    c = $a1dbf210d8994fb8$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $a1dbf210d8994fb8$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $a1dbf210d8994fb8$var$Ti ? $a1dbf210d8994fb8$var$Ti = new Set([
            this
        ]) : $a1dbf210d8994fb8$var$Ti.add(this), $a1dbf210d8994fb8$var$Ni(a, b));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
var $a1dbf210d8994fb8$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $a1dbf210d8994fb8$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $a1dbf210d8994fb8$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $a1dbf210d8994fb8$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $a1dbf210d8994fb8$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $a1dbf210d8994fb8$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($a1dbf210d8994fb8$var$y(163));
}
function $a1dbf210d8994fb8$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($a1dbf210d8994fb8$var$Zi(c, a), $a1dbf210d8994fb8$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $a1dbf210d8994fb8$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $a1dbf210d8994fb8$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $a1dbf210d8994fb8$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $a1dbf210d8994fb8$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $a1dbf210d8994fb8$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($a1dbf210d8994fb8$var$y(163));
}
function $a1dbf210d8994fb8$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $a1dbf210d8994fb8$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $a1dbf210d8994fb8$var$bj(a, b) {
    if ($a1dbf210d8994fb8$var$Mf && "function" === typeof $a1dbf210d8994fb8$var$Mf.onCommitFiberUnmount) try {
        $a1dbf210d8994fb8$var$Mf.onCommitFiberUnmount($a1dbf210d8994fb8$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $a1dbf210d8994fb8$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $a1dbf210d8994fb8$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $a1dbf210d8994fb8$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $a1dbf210d8994fb8$var$Wi(b, f);
            }
            break;
        case 5:
            $a1dbf210d8994fb8$var$Vi(b);
            break;
        case 4:
            $a1dbf210d8994fb8$var$cj(a, b);
    }
}
function $a1dbf210d8994fb8$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $a1dbf210d8994fb8$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a1dbf210d8994fb8$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($a1dbf210d8994fb8$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($a1dbf210d8994fb8$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($a1dbf210d8994fb8$var$y(161));
    }
    c.flags & 16 && ($a1dbf210d8994fb8$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $a1dbf210d8994fb8$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $a1dbf210d8994fb8$var$gj(a, c, b) : $a1dbf210d8994fb8$var$hj(a, c, b);
}
function $a1dbf210d8994fb8$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a1dbf210d8994fb8$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($a1dbf210d8994fb8$var$gj(a, b, c), a = a.sibling; null !== a;)$a1dbf210d8994fb8$var$gj(a, b, c), a = a.sibling;
}
function $a1dbf210d8994fb8$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a1dbf210d8994fb8$var$hj(a, b, c), a = a.sibling; null !== a;)$a1dbf210d8994fb8$var$hj(a, b, c), a = a.sibling;
}
function $a1dbf210d8994fb8$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($a1dbf210d8994fb8$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($a1dbf210d8994fb8$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($a1dbf210d8994fb8$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $a1dbf210d8994fb8$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$a1dbf210d8994fb8$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a1dbf210d8994fb8$var$$a(c, d);
                    $a1dbf210d8994fb8$var$wb(a, e);
                    b = $a1dbf210d8994fb8$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $a1dbf210d8994fb8$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $a1dbf210d8994fb8$var$ob(c, h) : "children" === g ? $a1dbf210d8994fb8$var$pb(c, h) : $a1dbf210d8994fb8$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $a1dbf210d8994fb8$var$ab(c, d);
                            break;
                        case "textarea":
                            $a1dbf210d8994fb8$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $a1dbf210d8994fb8$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $a1dbf210d8994fb8$var$fb(c, !!d.multiple, d.defaultValue, !0) : $a1dbf210d8994fb8$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($a1dbf210d8994fb8$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $a1dbf210d8994fb8$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($a1dbf210d8994fb8$var$jj = $a1dbf210d8994fb8$var$O(), $a1dbf210d8994fb8$var$aj(b.child, !0));
            $a1dbf210d8994fb8$var$kj(b);
            return;
        case 19:
            $a1dbf210d8994fb8$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $a1dbf210d8994fb8$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($a1dbf210d8994fb8$var$y(163));
}
function $a1dbf210d8994fb8$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a1dbf210d8994fb8$var$Ui);
        b.forEach(function(b) {
            var d = $a1dbf210d8994fb8$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a1dbf210d8994fb8$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $a1dbf210d8994fb8$var$nj = Math.ceil, $a1dbf210d8994fb8$var$oj = $a1dbf210d8994fb8$var$ra.ReactCurrentDispatcher, $a1dbf210d8994fb8$var$pj = $a1dbf210d8994fb8$var$ra.ReactCurrentOwner, $a1dbf210d8994fb8$var$X = 0, $a1dbf210d8994fb8$var$U = null, $a1dbf210d8994fb8$var$Y = null, $a1dbf210d8994fb8$var$W = 0, $a1dbf210d8994fb8$var$qj = 0, $a1dbf210d8994fb8$var$rj = $a1dbf210d8994fb8$var$Bf(0), $a1dbf210d8994fb8$var$V = 0, $a1dbf210d8994fb8$var$sj = null, $a1dbf210d8994fb8$var$tj = 0, $a1dbf210d8994fb8$var$Dg = 0, $a1dbf210d8994fb8$var$Hi = 0, $a1dbf210d8994fb8$var$uj = 0, $a1dbf210d8994fb8$var$vj = null, $a1dbf210d8994fb8$var$jj = 0, $a1dbf210d8994fb8$var$Ji = Infinity;
function $a1dbf210d8994fb8$var$wj() {
    $a1dbf210d8994fb8$var$Ji = $a1dbf210d8994fb8$var$O() + 500;
}
var $a1dbf210d8994fb8$var$Z = null, $a1dbf210d8994fb8$var$Qi = !1, $a1dbf210d8994fb8$var$Ri = null, $a1dbf210d8994fb8$var$Ti = null, $a1dbf210d8994fb8$var$xj = !1, $a1dbf210d8994fb8$var$yj = null, $a1dbf210d8994fb8$var$zj = 90, $a1dbf210d8994fb8$var$Aj = [], $a1dbf210d8994fb8$var$Bj = [], $a1dbf210d8994fb8$var$Cj = null, $a1dbf210d8994fb8$var$Dj = 0, $a1dbf210d8994fb8$var$Ej = null, $a1dbf210d8994fb8$var$Fj = -1, $a1dbf210d8994fb8$var$Gj = 0, $a1dbf210d8994fb8$var$Hj = 0, $a1dbf210d8994fb8$var$Ij = null, $a1dbf210d8994fb8$var$Jj = !1;
function $a1dbf210d8994fb8$var$Hg() {
    return 0 !== ($a1dbf210d8994fb8$var$X & 48) ? $a1dbf210d8994fb8$var$O() : -1 !== $a1dbf210d8994fb8$var$Fj ? $a1dbf210d8994fb8$var$Fj : $a1dbf210d8994fb8$var$Fj = $a1dbf210d8994fb8$var$O();
}
function $a1dbf210d8994fb8$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $a1dbf210d8994fb8$var$eg() ? 1 : 2;
    0 === $a1dbf210d8994fb8$var$Gj && ($a1dbf210d8994fb8$var$Gj = $a1dbf210d8994fb8$var$tj);
    if (0 !== $a1dbf210d8994fb8$var$kg.transition) {
        0 !== $a1dbf210d8994fb8$var$Hj && ($a1dbf210d8994fb8$var$Hj = null !== $a1dbf210d8994fb8$var$vj ? $a1dbf210d8994fb8$var$vj.pendingLanes : 0);
        a = $a1dbf210d8994fb8$var$Gj;
        var b = 4186112 & ~$a1dbf210d8994fb8$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $a1dbf210d8994fb8$var$eg();
    0 !== ($a1dbf210d8994fb8$var$X & 4) && 98 === a ? a = $a1dbf210d8994fb8$var$Xc(12, $a1dbf210d8994fb8$var$Gj) : (a = $a1dbf210d8994fb8$var$Sc(a), a = $a1dbf210d8994fb8$var$Xc(a, $a1dbf210d8994fb8$var$Gj));
    return a;
}
function $a1dbf210d8994fb8$var$Jg(a, b, c) {
    if (50 < $a1dbf210d8994fb8$var$Dj) throw $a1dbf210d8994fb8$var$Dj = 0, $a1dbf210d8994fb8$var$Ej = null, Error($a1dbf210d8994fb8$var$y(185));
    a = $a1dbf210d8994fb8$var$Kj(a, b);
    if (null === a) return null;
    $a1dbf210d8994fb8$var$$c(a, b, c);
    a === $a1dbf210d8994fb8$var$U && ($a1dbf210d8994fb8$var$Hi |= b, 4 === $a1dbf210d8994fb8$var$V && $a1dbf210d8994fb8$var$Ii(a, $a1dbf210d8994fb8$var$W));
    var d = $a1dbf210d8994fb8$var$eg();
    1 === b ? 0 !== ($a1dbf210d8994fb8$var$X & 8) && 0 === ($a1dbf210d8994fb8$var$X & 48) ? $a1dbf210d8994fb8$var$Lj(a) : ($a1dbf210d8994fb8$var$Mj(a, c), 0 === $a1dbf210d8994fb8$var$X && ($a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$ig())) : (0 === ($a1dbf210d8994fb8$var$X & 4) || 98 !== d && 99 !== d || (null === $a1dbf210d8994fb8$var$Cj ? $a1dbf210d8994fb8$var$Cj = new Set([
        a
    ]) : $a1dbf210d8994fb8$var$Cj.add(a)), $a1dbf210d8994fb8$var$Mj(a, c));
    $a1dbf210d8994fb8$var$vj = a;
}
function $a1dbf210d8994fb8$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $a1dbf210d8994fb8$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $a1dbf210d8994fb8$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $a1dbf210d8994fb8$var$Rc(k);
                var n = $a1dbf210d8994fb8$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $a1dbf210d8994fb8$var$Uc(a, a === $a1dbf210d8994fb8$var$U ? $a1dbf210d8994fb8$var$W : 0);
    b = $a1dbf210d8994fb8$var$F;
    if (0 === d) null !== c && (c !== $a1dbf210d8994fb8$var$Zf && $a1dbf210d8994fb8$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $a1dbf210d8994fb8$var$Zf && $a1dbf210d8994fb8$var$Pf(c);
        }
        15 === b ? (c = $a1dbf210d8994fb8$var$Lj.bind(null, a), null === $a1dbf210d8994fb8$var$ag ? ($a1dbf210d8994fb8$var$ag = [
            c
        ], $a1dbf210d8994fb8$var$bg = $a1dbf210d8994fb8$var$Of($a1dbf210d8994fb8$var$Uf, $a1dbf210d8994fb8$var$jg)) : $a1dbf210d8994fb8$var$ag.push(c), c = $a1dbf210d8994fb8$var$Zf) : 14 === b ? c = $a1dbf210d8994fb8$var$hg(99, $a1dbf210d8994fb8$var$Lj.bind(null, a)) : (c = $a1dbf210d8994fb8$var$Tc(b), c = $a1dbf210d8994fb8$var$hg(c, $a1dbf210d8994fb8$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a1dbf210d8994fb8$var$Nj(a) {
    $a1dbf210d8994fb8$var$Fj = -1;
    $a1dbf210d8994fb8$var$Hj = $a1dbf210d8994fb8$var$Gj = 0;
    if (0 !== ($a1dbf210d8994fb8$var$X & 48)) throw Error($a1dbf210d8994fb8$var$y(327));
    var b = a.callbackNode;
    if ($a1dbf210d8994fb8$var$Oj() && a.callbackNode !== b) return null;
    var c = $a1dbf210d8994fb8$var$Uc(a, a === $a1dbf210d8994fb8$var$U ? $a1dbf210d8994fb8$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 16;
    var f = $a1dbf210d8994fb8$var$Pj();
    if ($a1dbf210d8994fb8$var$U !== a || $a1dbf210d8994fb8$var$W !== d) $a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$Qj(a, d);
    for(;;)try {
        $a1dbf210d8994fb8$var$Rj();
        break;
    } catch (h) {
        $a1dbf210d8994fb8$var$Sj(a, h);
    }
    $a1dbf210d8994fb8$var$qg();
    $a1dbf210d8994fb8$var$oj.current = f;
    $a1dbf210d8994fb8$var$X = e;
    null !== $a1dbf210d8994fb8$var$Y ? d = 0 : ($a1dbf210d8994fb8$var$U = null, $a1dbf210d8994fb8$var$W = 0, d = $a1dbf210d8994fb8$var$V);
    if (0 !== ($a1dbf210d8994fb8$var$tj & $a1dbf210d8994fb8$var$Hi)) $a1dbf210d8994fb8$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($a1dbf210d8994fb8$var$X |= 64, a.hydrate && (a.hydrate = !1, $a1dbf210d8994fb8$var$qf(a.containerInfo)), c = $a1dbf210d8994fb8$var$Wc(a), 0 !== c && (d = $a1dbf210d8994fb8$var$Tj(a, c)));
        if (1 === d) throw b = $a1dbf210d8994fb8$var$sj, $a1dbf210d8994fb8$var$Qj(a, 0), $a1dbf210d8994fb8$var$Ii(a, c), $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($a1dbf210d8994fb8$var$y(345));
            case 2:
                $a1dbf210d8994fb8$var$Uj(a);
                break;
            case 3:
                $a1dbf210d8994fb8$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $a1dbf210d8994fb8$var$jj + 500 - $a1dbf210d8994fb8$var$O(), 10 < d)) {
                    if (0 !== $a1dbf210d8994fb8$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $a1dbf210d8994fb8$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $a1dbf210d8994fb8$var$of($a1dbf210d8994fb8$var$Uj.bind(null, a), d);
                    break;
                }
                $a1dbf210d8994fb8$var$Uj(a);
                break;
            case 4:
                $a1dbf210d8994fb8$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $a1dbf210d8994fb8$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $a1dbf210d8994fb8$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $a1dbf210d8994fb8$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $a1dbf210d8994fb8$var$of($a1dbf210d8994fb8$var$Uj.bind(null, a), c);
                    break;
                }
                $a1dbf210d8994fb8$var$Uj(a);
                break;
            case 5:
                $a1dbf210d8994fb8$var$Uj(a);
                break;
            default:
                throw Error($a1dbf210d8994fb8$var$y(329));
        }
    }
    $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O());
    return a.callbackNode === b ? $a1dbf210d8994fb8$var$Nj.bind(null, a) : null;
}
function $a1dbf210d8994fb8$var$Ii(a, b) {
    b &= ~$a1dbf210d8994fb8$var$uj;
    b &= ~$a1dbf210d8994fb8$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a1dbf210d8994fb8$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a1dbf210d8994fb8$var$Lj(a) {
    if (0 !== ($a1dbf210d8994fb8$var$X & 48)) throw Error($a1dbf210d8994fb8$var$y(327));
    $a1dbf210d8994fb8$var$Oj();
    if (a === $a1dbf210d8994fb8$var$U && 0 !== (a.expiredLanes & $a1dbf210d8994fb8$var$W)) {
        var b = $a1dbf210d8994fb8$var$W;
        var c = $a1dbf210d8994fb8$var$Tj(a, b);
        0 !== ($a1dbf210d8994fb8$var$tj & $a1dbf210d8994fb8$var$Hi) && (b = $a1dbf210d8994fb8$var$Uc(a, b), c = $a1dbf210d8994fb8$var$Tj(a, b));
    } else b = $a1dbf210d8994fb8$var$Uc(a, 0), c = $a1dbf210d8994fb8$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($a1dbf210d8994fb8$var$X |= 64, a.hydrate && (a.hydrate = !1, $a1dbf210d8994fb8$var$qf(a.containerInfo)), b = $a1dbf210d8994fb8$var$Wc(a), 0 !== b && (c = $a1dbf210d8994fb8$var$Tj(a, b)));
    if (1 === c) throw c = $a1dbf210d8994fb8$var$sj, $a1dbf210d8994fb8$var$Qj(a, 0), $a1dbf210d8994fb8$var$Ii(a, b), $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a1dbf210d8994fb8$var$Uj(a);
    $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O());
    return null;
}
function $a1dbf210d8994fb8$var$Vj() {
    if (null !== $a1dbf210d8994fb8$var$Cj) {
        var a = $a1dbf210d8994fb8$var$Cj;
        $a1dbf210d8994fb8$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O());
        });
    }
    $a1dbf210d8994fb8$var$ig();
}
function $a1dbf210d8994fb8$var$Wj(a, b) {
    var c = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 1;
    try {
        return a(b);
    } finally{
        $a1dbf210d8994fb8$var$X = c, 0 === $a1dbf210d8994fb8$var$X && ($a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$ig());
    }
}
function $a1dbf210d8994fb8$var$Xj(a, b) {
    var c = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X &= -2;
    $a1dbf210d8994fb8$var$X |= 8;
    try {
        return a(b);
    } finally{
        $a1dbf210d8994fb8$var$X = c, 0 === $a1dbf210d8994fb8$var$X && ($a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$ig());
    }
}
function $a1dbf210d8994fb8$var$ni(a, b) {
    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$rj, $a1dbf210d8994fb8$var$qj);
    $a1dbf210d8994fb8$var$qj |= b;
    $a1dbf210d8994fb8$var$tj |= b;
}
function $a1dbf210d8994fb8$var$Ki() {
    $a1dbf210d8994fb8$var$qj = $a1dbf210d8994fb8$var$rj.current;
    $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$rj);
}
function $a1dbf210d8994fb8$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a1dbf210d8994fb8$var$pf(c));
    if (null !== $a1dbf210d8994fb8$var$Y) for(c = $a1dbf210d8994fb8$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a1dbf210d8994fb8$var$Gf();
                break;
            case 3:
                $a1dbf210d8994fb8$var$fh();
                $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$N);
                $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$M);
                $a1dbf210d8994fb8$var$uh();
                break;
            case 5:
                $a1dbf210d8994fb8$var$hh(d);
                break;
            case 4:
                $a1dbf210d8994fb8$var$fh();
                break;
            case 13:
                $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P);
                break;
            case 19:
                $a1dbf210d8994fb8$var$H($a1dbf210d8994fb8$var$P);
                break;
            case 10:
                $a1dbf210d8994fb8$var$rg(d);
                break;
            case 23:
            case 24:
                $a1dbf210d8994fb8$var$Ki();
        }
        c = c.return;
    }
    $a1dbf210d8994fb8$var$U = a;
    $a1dbf210d8994fb8$var$Y = $a1dbf210d8994fb8$var$Tg(a.current, null);
    $a1dbf210d8994fb8$var$W = $a1dbf210d8994fb8$var$qj = $a1dbf210d8994fb8$var$tj = b;
    $a1dbf210d8994fb8$var$V = 0;
    $a1dbf210d8994fb8$var$sj = null;
    $a1dbf210d8994fb8$var$uj = $a1dbf210d8994fb8$var$Hi = $a1dbf210d8994fb8$var$Dg = 0;
}
function $a1dbf210d8994fb8$var$Sj(a, b) {
    do {
        var c = $a1dbf210d8994fb8$var$Y;
        try {
            $a1dbf210d8994fb8$var$qg();
            $a1dbf210d8994fb8$var$vh.current = $a1dbf210d8994fb8$var$Gh;
            if ($a1dbf210d8994fb8$var$yh) {
                for(var d = $a1dbf210d8994fb8$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a1dbf210d8994fb8$var$yh = !1;
            }
            $a1dbf210d8994fb8$var$xh = 0;
            $a1dbf210d8994fb8$var$T = $a1dbf210d8994fb8$var$S = $a1dbf210d8994fb8$var$R = null;
            $a1dbf210d8994fb8$var$zh = !1;
            $a1dbf210d8994fb8$var$pj.current = null;
            if (null === c || null === c.return) {
                $a1dbf210d8994fb8$var$V = 1;
                $a1dbf210d8994fb8$var$sj = b;
                $a1dbf210d8994fb8$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a1dbf210d8994fb8$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($a1dbf210d8994fb8$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $a1dbf210d8994fb8$var$zg(-1, 1);
                                        t.tag = 2;
                                        $a1dbf210d8994fb8$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $a1dbf210d8994fb8$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $a1dbf210d8994fb8$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($a1dbf210d8994fb8$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $a1dbf210d8994fb8$var$V && ($a1dbf210d8994fb8$var$V = 2);
                k = $a1dbf210d8994fb8$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $a1dbf210d8994fb8$var$Pi(p, f, b);
                            $a1dbf210d8994fb8$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $a1dbf210d8994fb8$var$Ti || !$a1dbf210d8994fb8$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $a1dbf210d8994fb8$var$Si(p, f, b);
                                $a1dbf210d8994fb8$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $a1dbf210d8994fb8$var$Zj(c);
        } catch (va) {
            b = va;
            $a1dbf210d8994fb8$var$Y === c && null !== c && ($a1dbf210d8994fb8$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a1dbf210d8994fb8$var$Pj() {
    var a = $a1dbf210d8994fb8$var$oj.current;
    $a1dbf210d8994fb8$var$oj.current = $a1dbf210d8994fb8$var$Gh;
    return null === a ? $a1dbf210d8994fb8$var$Gh : a;
}
function $a1dbf210d8994fb8$var$Tj(a, b) {
    var c = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 16;
    var d = $a1dbf210d8994fb8$var$Pj();
    $a1dbf210d8994fb8$var$U === a && $a1dbf210d8994fb8$var$W === b || $a1dbf210d8994fb8$var$Qj(a, b);
    for(;;)try {
        $a1dbf210d8994fb8$var$ak();
        break;
    } catch (e) {
        $a1dbf210d8994fb8$var$Sj(a, e);
    }
    $a1dbf210d8994fb8$var$qg();
    $a1dbf210d8994fb8$var$X = c;
    $a1dbf210d8994fb8$var$oj.current = d;
    if (null !== $a1dbf210d8994fb8$var$Y) throw Error($a1dbf210d8994fb8$var$y(261));
    $a1dbf210d8994fb8$var$U = null;
    $a1dbf210d8994fb8$var$W = 0;
    return $a1dbf210d8994fb8$var$V;
}
function $a1dbf210d8994fb8$var$ak() {
    for(; null !== $a1dbf210d8994fb8$var$Y;)$a1dbf210d8994fb8$var$bk($a1dbf210d8994fb8$var$Y);
}
function $a1dbf210d8994fb8$var$Rj() {
    for(; null !== $a1dbf210d8994fb8$var$Y && !$a1dbf210d8994fb8$var$Qf();)$a1dbf210d8994fb8$var$bk($a1dbf210d8994fb8$var$Y);
}
function $a1dbf210d8994fb8$var$bk(a) {
    var b = $a1dbf210d8994fb8$var$ck(a.alternate, a, $a1dbf210d8994fb8$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a1dbf210d8994fb8$var$Zj(a) : $a1dbf210d8994fb8$var$Y = b;
    $a1dbf210d8994fb8$var$pj.current = null;
}
function $a1dbf210d8994fb8$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $a1dbf210d8994fb8$var$Gi(c, b, $a1dbf210d8994fb8$var$qj);
            if (null !== c) {
                $a1dbf210d8994fb8$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($a1dbf210d8994fb8$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $a1dbf210d8994fb8$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $a1dbf210d8994fb8$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $a1dbf210d8994fb8$var$Y = b;
            return;
        }
        $a1dbf210d8994fb8$var$Y = b = a;
    }while (null !== b);
    0 === $a1dbf210d8994fb8$var$V && ($a1dbf210d8994fb8$var$V = 5);
}
function $a1dbf210d8994fb8$var$Uj(a) {
    var b = $a1dbf210d8994fb8$var$eg();
    $a1dbf210d8994fb8$var$gg(99, $a1dbf210d8994fb8$var$dk.bind(null, a, b));
    return null;
}
function $a1dbf210d8994fb8$var$dk(a, b) {
    do $a1dbf210d8994fb8$var$Oj();
    while (null !== $a1dbf210d8994fb8$var$yj);
    if (0 !== ($a1dbf210d8994fb8$var$X & 48)) throw Error($a1dbf210d8994fb8$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a1dbf210d8994fb8$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $a1dbf210d8994fb8$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $a1dbf210d8994fb8$var$Cj && 0 === (d & 24) && $a1dbf210d8994fb8$var$Cj.has(a) && $a1dbf210d8994fb8$var$Cj.delete(a);
    a === $a1dbf210d8994fb8$var$U && ($a1dbf210d8994fb8$var$Y = $a1dbf210d8994fb8$var$U = null, $a1dbf210d8994fb8$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $a1dbf210d8994fb8$var$X;
        $a1dbf210d8994fb8$var$X |= 32;
        $a1dbf210d8994fb8$var$pj.current = null;
        $a1dbf210d8994fb8$var$kf = $a1dbf210d8994fb8$var$fd;
        g = $a1dbf210d8994fb8$var$Ne();
        if ($a1dbf210d8994fb8$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $a1dbf210d8994fb8$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $a1dbf210d8994fb8$var$fd = !1;
        $a1dbf210d8994fb8$var$Ij = null;
        $a1dbf210d8994fb8$var$Jj = !1;
        $a1dbf210d8994fb8$var$Z = d;
        do try {
            $a1dbf210d8994fb8$var$ek();
        } catch (va) {
            if (null === $a1dbf210d8994fb8$var$Z) throw Error($a1dbf210d8994fb8$var$y(330));
            $a1dbf210d8994fb8$var$Wi($a1dbf210d8994fb8$var$Z, va);
            $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
        }
        while (null !== $a1dbf210d8994fb8$var$Z);
        $a1dbf210d8994fb8$var$Ij = null;
        $a1dbf210d8994fb8$var$Z = d;
        do try {
            for(g = a; null !== $a1dbf210d8994fb8$var$Z;){
                var t = $a1dbf210d8994fb8$var$Z.flags;
                t & 16 && $a1dbf210d8994fb8$var$pb($a1dbf210d8994fb8$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $a1dbf210d8994fb8$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $a1dbf210d8994fb8$var$fj($a1dbf210d8994fb8$var$Z);
                        $a1dbf210d8994fb8$var$Z.flags &= -3;
                        break;
                    case 6:
                        $a1dbf210d8994fb8$var$fj($a1dbf210d8994fb8$var$Z);
                        $a1dbf210d8994fb8$var$Z.flags &= -3;
                        $a1dbf210d8994fb8$var$ij($a1dbf210d8994fb8$var$Z.alternate, $a1dbf210d8994fb8$var$Z);
                        break;
                    case 1024:
                        $a1dbf210d8994fb8$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $a1dbf210d8994fb8$var$Z.flags &= -1025;
                        $a1dbf210d8994fb8$var$ij($a1dbf210d8994fb8$var$Z.alternate, $a1dbf210d8994fb8$var$Z);
                        break;
                    case 4:
                        $a1dbf210d8994fb8$var$ij($a1dbf210d8994fb8$var$Z.alternate, $a1dbf210d8994fb8$var$Z);
                        break;
                    case 8:
                        h = $a1dbf210d8994fb8$var$Z;
                        $a1dbf210d8994fb8$var$cj(g, h);
                        var J = h.alternate;
                        $a1dbf210d8994fb8$var$dj(h);
                        null !== J && $a1dbf210d8994fb8$var$dj(J);
                }
                $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $a1dbf210d8994fb8$var$Z) throw Error($a1dbf210d8994fb8$var$y(330));
            $a1dbf210d8994fb8$var$Wi($a1dbf210d8994fb8$var$Z, va);
            $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
        }
        while (null !== $a1dbf210d8994fb8$var$Z);
        v = $a1dbf210d8994fb8$var$lf;
        q = $a1dbf210d8994fb8$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $a1dbf210d8994fb8$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $a1dbf210d8994fb8$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $a1dbf210d8994fb8$var$Le(t, J), f = $a1dbf210d8994fb8$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $a1dbf210d8994fb8$var$fd = !!$a1dbf210d8994fb8$var$kf;
        $a1dbf210d8994fb8$var$lf = $a1dbf210d8994fb8$var$kf = null;
        a.current = c;
        $a1dbf210d8994fb8$var$Z = d;
        do try {
            for(t = a; null !== $a1dbf210d8994fb8$var$Z;){
                var K = $a1dbf210d8994fb8$var$Z.flags;
                K & 36 && $a1dbf210d8994fb8$var$Yi(t, $a1dbf210d8994fb8$var$Z.alternate, $a1dbf210d8994fb8$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $a1dbf210d8994fb8$var$Z.ref;
                    if (null !== Q) {
                        var L = $a1dbf210d8994fb8$var$Z.stateNode;
                        switch($a1dbf210d8994fb8$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $a1dbf210d8994fb8$var$Z) throw Error($a1dbf210d8994fb8$var$y(330));
            $a1dbf210d8994fb8$var$Wi($a1dbf210d8994fb8$var$Z, va);
            $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
        }
        while (null !== $a1dbf210d8994fb8$var$Z);
        $a1dbf210d8994fb8$var$Z = null;
        $a1dbf210d8994fb8$var$$f();
        $a1dbf210d8994fb8$var$X = e;
    } else a.current = c;
    if ($a1dbf210d8994fb8$var$xj) $a1dbf210d8994fb8$var$xj = !1, $a1dbf210d8994fb8$var$yj = a, $a1dbf210d8994fb8$var$zj = b;
    else for($a1dbf210d8994fb8$var$Z = d; null !== $a1dbf210d8994fb8$var$Z;)b = $a1dbf210d8994fb8$var$Z.nextEffect, $a1dbf210d8994fb8$var$Z.nextEffect = null, $a1dbf210d8994fb8$var$Z.flags & 8 && (K = $a1dbf210d8994fb8$var$Z, K.sibling = null, K.stateNode = null), $a1dbf210d8994fb8$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($a1dbf210d8994fb8$var$Ti = null);
    1 === d ? a === $a1dbf210d8994fb8$var$Ej ? $a1dbf210d8994fb8$var$Dj++ : ($a1dbf210d8994fb8$var$Dj = 0, $a1dbf210d8994fb8$var$Ej = a) : $a1dbf210d8994fb8$var$Dj = 0;
    c = c.stateNode;
    if ($a1dbf210d8994fb8$var$Mf && "function" === typeof $a1dbf210d8994fb8$var$Mf.onCommitFiberRoot) try {
        $a1dbf210d8994fb8$var$Mf.onCommitFiberRoot($a1dbf210d8994fb8$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $a1dbf210d8994fb8$var$Mj(a, $a1dbf210d8994fb8$var$O());
    if ($a1dbf210d8994fb8$var$Qi) throw $a1dbf210d8994fb8$var$Qi = !1, a = $a1dbf210d8994fb8$var$Ri, $a1dbf210d8994fb8$var$Ri = null, a;
    if (0 !== ($a1dbf210d8994fb8$var$X & 8)) return null;
    $a1dbf210d8994fb8$var$ig();
    return null;
}
function $a1dbf210d8994fb8$var$ek() {
    for(; null !== $a1dbf210d8994fb8$var$Z;){
        var a = $a1dbf210d8994fb8$var$Z.alternate;
        $a1dbf210d8994fb8$var$Jj || null === $a1dbf210d8994fb8$var$Ij || (0 !== ($a1dbf210d8994fb8$var$Z.flags & 8) ? $a1dbf210d8994fb8$var$dc($a1dbf210d8994fb8$var$Z, $a1dbf210d8994fb8$var$Ij) && ($a1dbf210d8994fb8$var$Jj = !0) : 13 === $a1dbf210d8994fb8$var$Z.tag && $a1dbf210d8994fb8$var$mj(a, $a1dbf210d8994fb8$var$Z) && $a1dbf210d8994fb8$var$dc($a1dbf210d8994fb8$var$Z, $a1dbf210d8994fb8$var$Ij) && ($a1dbf210d8994fb8$var$Jj = !0));
        var b = $a1dbf210d8994fb8$var$Z.flags;
        0 !== (b & 256) && $a1dbf210d8994fb8$var$Xi(a, $a1dbf210d8994fb8$var$Z);
        0 === (b & 512) || $a1dbf210d8994fb8$var$xj || ($a1dbf210d8994fb8$var$xj = !0, $a1dbf210d8994fb8$var$hg(97, function() {
            $a1dbf210d8994fb8$var$Oj();
            return null;
        }));
        $a1dbf210d8994fb8$var$Z = $a1dbf210d8994fb8$var$Z.nextEffect;
    }
}
function $a1dbf210d8994fb8$var$Oj() {
    if (90 !== $a1dbf210d8994fb8$var$zj) {
        var a = 97 < $a1dbf210d8994fb8$var$zj ? 97 : $a1dbf210d8994fb8$var$zj;
        $a1dbf210d8994fb8$var$zj = 90;
        return $a1dbf210d8994fb8$var$gg(a, $a1dbf210d8994fb8$var$fk);
    }
    return !1;
}
function $a1dbf210d8994fb8$var$$i(a, b) {
    $a1dbf210d8994fb8$var$Aj.push(b, a);
    $a1dbf210d8994fb8$var$xj || ($a1dbf210d8994fb8$var$xj = !0, $a1dbf210d8994fb8$var$hg(97, function() {
        $a1dbf210d8994fb8$var$Oj();
        return null;
    }));
}
function $a1dbf210d8994fb8$var$Zi(a, b) {
    $a1dbf210d8994fb8$var$Bj.push(b, a);
    $a1dbf210d8994fb8$var$xj || ($a1dbf210d8994fb8$var$xj = !0, $a1dbf210d8994fb8$var$hg(97, function() {
        $a1dbf210d8994fb8$var$Oj();
        return null;
    }));
}
function $a1dbf210d8994fb8$var$fk() {
    if (null === $a1dbf210d8994fb8$var$yj) return !1;
    var a = $a1dbf210d8994fb8$var$yj;
    $a1dbf210d8994fb8$var$yj = null;
    if (0 !== ($a1dbf210d8994fb8$var$X & 48)) throw Error($a1dbf210d8994fb8$var$y(331));
    var b = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 32;
    var c = $a1dbf210d8994fb8$var$Bj;
    $a1dbf210d8994fb8$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($a1dbf210d8994fb8$var$y(330));
            $a1dbf210d8994fb8$var$Wi(f, k);
        }
    }
    c = $a1dbf210d8994fb8$var$Aj;
    $a1dbf210d8994fb8$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($a1dbf210d8994fb8$var$y(330));
            $a1dbf210d8994fb8$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $a1dbf210d8994fb8$var$X = b;
    $a1dbf210d8994fb8$var$ig();
    return !0;
}
function $a1dbf210d8994fb8$var$gk(a, b, c) {
    b = $a1dbf210d8994fb8$var$Mi(c, b);
    b = $a1dbf210d8994fb8$var$Pi(a, b, 1);
    $a1dbf210d8994fb8$var$Ag(a, b);
    b = $a1dbf210d8994fb8$var$Hg();
    a = $a1dbf210d8994fb8$var$Kj(a, 1);
    null !== a && ($a1dbf210d8994fb8$var$$c(a, 1, b), $a1dbf210d8994fb8$var$Mj(a, b));
}
function $a1dbf210d8994fb8$var$Wi(a, b) {
    if (3 === a.tag) $a1dbf210d8994fb8$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $a1dbf210d8994fb8$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a1dbf210d8994fb8$var$Ti || !$a1dbf210d8994fb8$var$Ti.has(d))) {
                a = $a1dbf210d8994fb8$var$Mi(b, a);
                var e = $a1dbf210d8994fb8$var$Si(c, a, 1);
                $a1dbf210d8994fb8$var$Ag(c, e);
                e = $a1dbf210d8994fb8$var$Hg();
                c = $a1dbf210d8994fb8$var$Kj(c, 1);
                if (null !== c) $a1dbf210d8994fb8$var$$c(c, 1, e), $a1dbf210d8994fb8$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $a1dbf210d8994fb8$var$Ti || !$a1dbf210d8994fb8$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $a1dbf210d8994fb8$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a1dbf210d8994fb8$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $a1dbf210d8994fb8$var$U === a && ($a1dbf210d8994fb8$var$W & c) === c && (4 === $a1dbf210d8994fb8$var$V || 3 === $a1dbf210d8994fb8$var$V && ($a1dbf210d8994fb8$var$W & 62914560) === $a1dbf210d8994fb8$var$W && 500 > $a1dbf210d8994fb8$var$O() - $a1dbf210d8994fb8$var$jj ? $a1dbf210d8994fb8$var$Qj(a, 0) : $a1dbf210d8994fb8$var$uj |= c);
    $a1dbf210d8994fb8$var$Mj(a, b);
}
function $a1dbf210d8994fb8$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $a1dbf210d8994fb8$var$eg() ? 1 : 2 : (0 === $a1dbf210d8994fb8$var$Gj && ($a1dbf210d8994fb8$var$Gj = $a1dbf210d8994fb8$var$tj), b = $a1dbf210d8994fb8$var$Yc(62914560 & ~$a1dbf210d8994fb8$var$Gj), 0 === b && (b = 4194304)));
    c = $a1dbf210d8994fb8$var$Hg();
    a = $a1dbf210d8994fb8$var$Kj(a, b);
    null !== a && ($a1dbf210d8994fb8$var$$c(a, b, c), $a1dbf210d8994fb8$var$Mj(a, c));
}
var $a1dbf210d8994fb8$var$ck;
$a1dbf210d8994fb8$var$ck = function ck(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a1dbf210d8994fb8$var$N.current) $a1dbf210d8994fb8$var$ug = !0;
        else if (0 !== (c & d)) $a1dbf210d8994fb8$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $a1dbf210d8994fb8$var$ug = !1;
            switch(b.tag){
                case 3:
                    $a1dbf210d8994fb8$var$ri(b);
                    $a1dbf210d8994fb8$var$sh();
                    break;
                case 5:
                    $a1dbf210d8994fb8$var$gh(b);
                    break;
                case 1:
                    $a1dbf210d8994fb8$var$Ff(b.type) && $a1dbf210d8994fb8$var$Jf(b);
                    break;
                case 4:
                    $a1dbf210d8994fb8$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $a1dbf210d8994fb8$var$ti(a, b, c);
                        $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, $a1dbf210d8994fb8$var$P.current & 1);
                        b = $a1dbf210d8994fb8$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, $a1dbf210d8994fb8$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $a1dbf210d8994fb8$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$P, $a1dbf210d8994fb8$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $a1dbf210d8994fb8$var$mi(a, b, c);
            }
            return $a1dbf210d8994fb8$var$hi(a, b, c);
        }
    } else $a1dbf210d8994fb8$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $a1dbf210d8994fb8$var$Ef(b, $a1dbf210d8994fb8$var$M.current);
            $a1dbf210d8994fb8$var$tg(b, c);
            e = $a1dbf210d8994fb8$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($a1dbf210d8994fb8$var$Ff(d)) {
                    var f = !0;
                    $a1dbf210d8994fb8$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $a1dbf210d8994fb8$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $a1dbf210d8994fb8$var$Gg(b, d, g, a);
                e.updater = $a1dbf210d8994fb8$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $a1dbf210d8994fb8$var$Og(b, d, a, c);
                b = $a1dbf210d8994fb8$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $a1dbf210d8994fb8$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $a1dbf210d8994fb8$var$hk(e);
                a = $a1dbf210d8994fb8$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $a1dbf210d8994fb8$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $a1dbf210d8994fb8$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $a1dbf210d8994fb8$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $a1dbf210d8994fb8$var$ii(null, b, e, $a1dbf210d8994fb8$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($a1dbf210d8994fb8$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a1dbf210d8994fb8$var$lg(d, e), $a1dbf210d8994fb8$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a1dbf210d8994fb8$var$lg(d, e), $a1dbf210d8994fb8$var$pi(a, b, d, e, c);
        case 3:
            $a1dbf210d8994fb8$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($a1dbf210d8994fb8$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $a1dbf210d8994fb8$var$yg(a, b);
            $a1dbf210d8994fb8$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $a1dbf210d8994fb8$var$sh(), b = $a1dbf210d8994fb8$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $a1dbf210d8994fb8$var$kh = $a1dbf210d8994fb8$var$rf(b.stateNode.containerInfo.firstChild), $a1dbf210d8994fb8$var$jh = b, f = $a1dbf210d8994fb8$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $a1dbf210d8994fb8$var$th.push(f);
                    c = $a1dbf210d8994fb8$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $a1dbf210d8994fb8$var$fi(a, b, d, c), $a1dbf210d8994fb8$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $a1dbf210d8994fb8$var$gh(b), null === a && $a1dbf210d8994fb8$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a1dbf210d8994fb8$var$nf(d, e) ? g = null : null !== f && $a1dbf210d8994fb8$var$nf(d, f) && (b.flags |= 16), $a1dbf210d8994fb8$var$oi(a, b), $a1dbf210d8994fb8$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $a1dbf210d8994fb8$var$ph(b), null;
        case 13:
            return $a1dbf210d8994fb8$var$ti(a, b, c);
        case 4:
            return $a1dbf210d8994fb8$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a1dbf210d8994fb8$var$Yg(b, null, d, c) : $a1dbf210d8994fb8$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a1dbf210d8994fb8$var$lg(d, e), $a1dbf210d8994fb8$var$gi(a, b, d, e, c);
        case 7:
            return $a1dbf210d8994fb8$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a1dbf210d8994fb8$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a1dbf210d8994fb8$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $a1dbf210d8994fb8$var$I($a1dbf210d8994fb8$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $a1dbf210d8994fb8$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$a1dbf210d8994fb8$var$N.current) {
                            b = $a1dbf210d8994fb8$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $a1dbf210d8994fb8$var$zg(-1, c & -c), l.tag = 2, $a1dbf210d8994fb8$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $a1dbf210d8994fb8$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $a1dbf210d8994fb8$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $a1dbf210d8994fb8$var$tg(b, c), e = $a1dbf210d8994fb8$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $a1dbf210d8994fb8$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $a1dbf210d8994fb8$var$lg(e, b.pendingProps), f = $a1dbf210d8994fb8$var$lg(e.type, f), $a1dbf210d8994fb8$var$ii(a, b, e, f, d, c);
        case 15:
            return $a1dbf210d8994fb8$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a1dbf210d8994fb8$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $a1dbf210d8994fb8$var$Ff(d) ? (a = !0, $a1dbf210d8994fb8$var$Jf(b)) : a = !1, $a1dbf210d8994fb8$var$tg(b, c), $a1dbf210d8994fb8$var$Mg(b, d, e), $a1dbf210d8994fb8$var$Og(b, d, e, c), $a1dbf210d8994fb8$var$qi(null, b, d, !0, a, c);
        case 19:
            return $a1dbf210d8994fb8$var$Ai(a, b, c);
        case 23:
            return $a1dbf210d8994fb8$var$mi(a, b, c);
        case 24:
            return $a1dbf210d8994fb8$var$mi(a, b, c);
    }
    throw Error($a1dbf210d8994fb8$var$y(156, b.tag));
};
function $a1dbf210d8994fb8$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a1dbf210d8994fb8$var$nh(a, b, c, d) {
    return new $a1dbf210d8994fb8$var$ik(a, b, c, d);
}
function $a1dbf210d8994fb8$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a1dbf210d8994fb8$var$hk(a) {
    if ("function" === typeof a) return $a1dbf210d8994fb8$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a1dbf210d8994fb8$var$Aa) return 11;
        if (a === $a1dbf210d8994fb8$var$Da) return 14;
    }
    return 2;
}
function $a1dbf210d8994fb8$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $a1dbf210d8994fb8$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a1dbf210d8994fb8$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a1dbf210d8994fb8$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a1dbf210d8994fb8$var$ua:
            return $a1dbf210d8994fb8$var$Xg(c.children, e, f, b);
        case $a1dbf210d8994fb8$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $a1dbf210d8994fb8$var$wa:
            g = 8;
            e |= 1;
            break;
        case $a1dbf210d8994fb8$var$xa:
            return a = $a1dbf210d8994fb8$var$nh(12, c, b, e | 8), a.elementType = $a1dbf210d8994fb8$var$xa, a.type = $a1dbf210d8994fb8$var$xa, a.lanes = f, a;
        case $a1dbf210d8994fb8$var$Ba:
            return a = $a1dbf210d8994fb8$var$nh(13, c, b, e), a.type = $a1dbf210d8994fb8$var$Ba, a.elementType = $a1dbf210d8994fb8$var$Ba, a.lanes = f, a;
        case $a1dbf210d8994fb8$var$Ca:
            return a = $a1dbf210d8994fb8$var$nh(19, c, b, e), a.elementType = $a1dbf210d8994fb8$var$Ca, a.lanes = f, a;
        case $a1dbf210d8994fb8$var$Ia:
            return $a1dbf210d8994fb8$var$vi(c, e, f, b);
        case $a1dbf210d8994fb8$var$Ja:
            return a = $a1dbf210d8994fb8$var$nh(24, c, b, e), a.elementType = $a1dbf210d8994fb8$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a1dbf210d8994fb8$var$ya:
                    g = 10;
                    break a;
                case $a1dbf210d8994fb8$var$za:
                    g = 9;
                    break a;
                case $a1dbf210d8994fb8$var$Aa:
                    g = 11;
                    break a;
                case $a1dbf210d8994fb8$var$Da:
                    g = 14;
                    break a;
                case $a1dbf210d8994fb8$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $a1dbf210d8994fb8$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($a1dbf210d8994fb8$var$y(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $5F2Q2._)(a), ""));
    }
    b = $a1dbf210d8994fb8$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a1dbf210d8994fb8$var$Xg(a, b, c, d) {
    a = $a1dbf210d8994fb8$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a1dbf210d8994fb8$var$vi(a, b, c, d) {
    a = $a1dbf210d8994fb8$var$nh(23, a, d, b);
    a.elementType = $a1dbf210d8994fb8$var$Ia;
    a.lanes = c;
    return a;
}
function $a1dbf210d8994fb8$var$Ug(a, b, c) {
    a = $a1dbf210d8994fb8$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a1dbf210d8994fb8$var$Wg(a, b, c) {
    b = $a1dbf210d8994fb8$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a1dbf210d8994fb8$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $a1dbf210d8994fb8$var$Zc(0);
    this.expirationTimes = $a1dbf210d8994fb8$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a1dbf210d8994fb8$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $a1dbf210d8994fb8$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a1dbf210d8994fb8$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a1dbf210d8994fb8$var$lk(a, b, c, d) {
    var e = b.current, f = $a1dbf210d8994fb8$var$Hg(), g = $a1dbf210d8994fb8$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($a1dbf210d8994fb8$var$Zb(c) !== c || 1 !== c.tag) throw Error($a1dbf210d8994fb8$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($a1dbf210d8994fb8$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($a1dbf210d8994fb8$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($a1dbf210d8994fb8$var$Ff(k)) {
                c = $a1dbf210d8994fb8$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $a1dbf210d8994fb8$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a1dbf210d8994fb8$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $a1dbf210d8994fb8$var$Ag(e, b);
    $a1dbf210d8994fb8$var$Jg(e, g, f);
    return g;
}
function $a1dbf210d8994fb8$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a1dbf210d8994fb8$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a1dbf210d8994fb8$var$ok(a, b) {
    $a1dbf210d8994fb8$var$nk(a, b);
    (a = a.alternate) && $a1dbf210d8994fb8$var$nk(a, b);
}
function $a1dbf210d8994fb8$var$pk() {
    return null;
}
function $a1dbf210d8994fb8$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $a1dbf210d8994fb8$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $a1dbf210d8994fb8$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $a1dbf210d8994fb8$var$xg(b);
    a[$a1dbf210d8994fb8$var$ff] = c.current;
    $a1dbf210d8994fb8$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$a1dbf210d8994fb8$var$qk.prototype.render = function(a) {
    $a1dbf210d8994fb8$var$lk(a, this._internalRoot, null, null);
};
$a1dbf210d8994fb8$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $a1dbf210d8994fb8$var$lk(null, a, null, function() {
        b[$a1dbf210d8994fb8$var$ff] = null;
    });
};
function $a1dbf210d8994fb8$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a1dbf210d8994fb8$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $a1dbf210d8994fb8$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $a1dbf210d8994fb8$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $a1dbf210d8994fb8$var$mk(g);
                h.call(_$a);
            };
        }
        $a1dbf210d8994fb8$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $a1dbf210d8994fb8$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function e() {
                var _$a = $a1dbf210d8994fb8$var$mk(g);
                k.call(_$a);
            };
        }
        $a1dbf210d8994fb8$var$Xj(function() {
            $a1dbf210d8994fb8$var$lk(b, g, a, e);
        });
    }
    return $a1dbf210d8994fb8$var$mk(g);
}
$a1dbf210d8994fb8$var$ec = function ec(a) {
    if (13 === a.tag) {
        var b = $a1dbf210d8994fb8$var$Hg();
        $a1dbf210d8994fb8$var$Jg(a, 4, b);
        $a1dbf210d8994fb8$var$ok(a, 4);
    }
};
$a1dbf210d8994fb8$var$fc = function fc(a) {
    if (13 === a.tag) {
        var b = $a1dbf210d8994fb8$var$Hg();
        $a1dbf210d8994fb8$var$Jg(a, 67108864, b);
        $a1dbf210d8994fb8$var$ok(a, 67108864);
    }
};
$a1dbf210d8994fb8$var$gc = function gc(a) {
    if (13 === a.tag) {
        var b = $a1dbf210d8994fb8$var$Hg(), c = $a1dbf210d8994fb8$var$Ig(a);
        $a1dbf210d8994fb8$var$Jg(a, c, b);
        $a1dbf210d8994fb8$var$ok(a, c);
    }
};
$a1dbf210d8994fb8$var$hc = function hc(a, b) {
    return b();
};
$a1dbf210d8994fb8$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $a1dbf210d8994fb8$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a1dbf210d8994fb8$var$Db(d);
                        if (!e) throw Error($a1dbf210d8994fb8$var$y(90));
                        $a1dbf210d8994fb8$var$Wa(d);
                        $a1dbf210d8994fb8$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a1dbf210d8994fb8$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a1dbf210d8994fb8$var$fb(a, !!c.multiple, b, !1);
    }
};
$a1dbf210d8994fb8$var$Gb = $a1dbf210d8994fb8$var$Wj;
$a1dbf210d8994fb8$var$Hb = function Hb(a, b, c, d, e) {
    var f = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 4;
    try {
        return $a1dbf210d8994fb8$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $a1dbf210d8994fb8$var$X = f, 0 === $a1dbf210d8994fb8$var$X && ($a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$ig());
    }
};
$a1dbf210d8994fb8$var$Ib = function Ib() {
    0 === ($a1dbf210d8994fb8$var$X & 49) && ($a1dbf210d8994fb8$var$Vj(), $a1dbf210d8994fb8$var$Oj());
};
$a1dbf210d8994fb8$var$Jb = function Jb(a, b) {
    var c = $a1dbf210d8994fb8$var$X;
    $a1dbf210d8994fb8$var$X |= 2;
    try {
        return a(b);
    } finally{
        $a1dbf210d8994fb8$var$X = c, 0 === $a1dbf210d8994fb8$var$X && ($a1dbf210d8994fb8$var$wj(), $a1dbf210d8994fb8$var$ig());
    }
};
function $a1dbf210d8994fb8$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a1dbf210d8994fb8$var$rk(b)) throw Error($a1dbf210d8994fb8$var$y(200));
    return $a1dbf210d8994fb8$var$kk(a, b, null, c);
}
var $a1dbf210d8994fb8$var$vk = {
    Events: [
        $a1dbf210d8994fb8$var$Cb,
        $a1dbf210d8994fb8$var$ue,
        $a1dbf210d8994fb8$var$Db,
        $a1dbf210d8994fb8$var$Eb,
        $a1dbf210d8994fb8$var$Fb,
        $a1dbf210d8994fb8$var$Oj,
        {
            current: !1
        }
    ]
}, $a1dbf210d8994fb8$var$wk = {
    findFiberByHostInstance: $a1dbf210d8994fb8$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $a1dbf210d8994fb8$var$xk = {
    bundleType: $a1dbf210d8994fb8$var$wk.bundleType,
    version: $a1dbf210d8994fb8$var$wk.version,
    rendererPackageName: $a1dbf210d8994fb8$var$wk.rendererPackageName,
    rendererConfig: $a1dbf210d8994fb8$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a1dbf210d8994fb8$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $a1dbf210d8994fb8$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a1dbf210d8994fb8$var$wk.findFiberByHostInstance || $a1dbf210d8994fb8$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a1dbf210d8994fb8$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a1dbf210d8994fb8$var$yk.isDisabled && $a1dbf210d8994fb8$var$yk.supportsFiber) try {
        $a1dbf210d8994fb8$var$Lf = $a1dbf210d8994fb8$var$yk.inject($a1dbf210d8994fb8$var$xk), $a1dbf210d8994fb8$var$Mf = $a1dbf210d8994fb8$var$yk;
    } catch (a) {}
}
$a1dbf210d8994fb8$export$ae55be85d98224ed = $a1dbf210d8994fb8$var$vk;
$a1dbf210d8994fb8$export$d39a5bbd09211389 = $a1dbf210d8994fb8$var$uk;
$a1dbf210d8994fb8$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a1dbf210d8994fb8$var$y(188));
        throw Error($a1dbf210d8994fb8$var$y(268, Object.keys(a)));
    }
    a = $a1dbf210d8994fb8$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a1dbf210d8994fb8$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $a1dbf210d8994fb8$var$X;
    if (0 !== (c & 48)) return a(b);
    $a1dbf210d8994fb8$var$X |= 1;
    try {
        if (a) return $a1dbf210d8994fb8$var$gg(99, a.bind(null, b));
    } finally{
        $a1dbf210d8994fb8$var$X = c, $a1dbf210d8994fb8$var$ig();
    }
};
$a1dbf210d8994fb8$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a1dbf210d8994fb8$var$rk(b)) throw Error($a1dbf210d8994fb8$var$y(200));
    return $a1dbf210d8994fb8$var$tk(null, a, b, !0, c);
};
$a1dbf210d8994fb8$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a1dbf210d8994fb8$var$rk(b)) throw Error($a1dbf210d8994fb8$var$y(200));
    return $a1dbf210d8994fb8$var$tk(null, a, b, !1, c);
};
$a1dbf210d8994fb8$export$502457920280e6be = function(a) {
    if (!$a1dbf210d8994fb8$var$rk(a)) throw Error($a1dbf210d8994fb8$var$y(40));
    return a._reactRootContainer ? ($a1dbf210d8994fb8$var$Xj(function() {
        $a1dbf210d8994fb8$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a1dbf210d8994fb8$var$ff] = null;
        });
    }), !0) : !1;
};
$a1dbf210d8994fb8$export$c78a37762a8d58e1 = $a1dbf210d8994fb8$var$Wj;
$a1dbf210d8994fb8$export$2577ef5d2565d52f = function(a, b) {
    return $a1dbf210d8994fb8$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$a1dbf210d8994fb8$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a1dbf210d8994fb8$var$rk(c)) throw Error($a1dbf210d8994fb8$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a1dbf210d8994fb8$var$y(38));
    return $a1dbf210d8994fb8$var$tk(a, b, c, !1, d);
};
$a1dbf210d8994fb8$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("4CEbD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1Lc06"));

});

parcelRequire.register("3KFEz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kZmBV"));

});
parcelRequire.register("kZmBV", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f47b0b248e831907$export$c4744153514ff05d; }, function (v) { return $f47b0b248e831907$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f47b0b248e831907$export$b5836b71941fa3ed; }, function (v) { return $f47b0b248e831907$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f47b0b248e831907$export$d66a1c1c77bd778b; }, function (v) { return $f47b0b248e831907$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f47b0b248e831907$export$3e506c1ccc9cc1a7; }, function (v) { return $f47b0b248e831907$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f47b0b248e831907$export$e26fe2ed2fa76875; }, function (v) { return $f47b0b248e831907$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f47b0b248e831907$export$502329bbf4b505b1; }, function (v) { return $f47b0b248e831907$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f47b0b248e831907$export$6e3807111c4874c4; }, function (v) { return $f47b0b248e831907$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f47b0b248e831907$export$c27134553091fb3a; }, function (v) { return $f47b0b248e831907$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f47b0b248e831907$export$33ee1acdc04fd2a2; }, function (v) { return $f47b0b248e831907$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f47b0b248e831907$export$b00a404bbd5edef2; }, function (v) { return $f47b0b248e831907$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f47b0b248e831907$export$8352ce38b91d0c62; }, function (v) { return $f47b0b248e831907$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f47b0b248e831907$export$d3dfb8e4810cb555; }, function (v) { return $f47b0b248e831907$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f47b0b248e831907$export$839f9183b0465a69; }, function (v) { return $f47b0b248e831907$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f47b0b248e831907$export$72fdf0e06517287b; }, function (v) { return $f47b0b248e831907$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f47b0b248e831907$export$4b844e58a3e414b4; }, function (v) { return $f47b0b248e831907$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f47b0b248e831907$export$816d2913ae6b83b1; }, function (v) { return $f47b0b248e831907$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f47b0b248e831907$export$61bcfe829111a1d0; }, function (v) { return $f47b0b248e831907$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f47b0b248e831907$export$7ee8c9beb337bc3f; }, function (v) { return $f47b0b248e831907$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f47b0b248e831907$export$cf845f2c119da08a; }, function (v) { return $f47b0b248e831907$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f47b0b248e831907$export$c4744153514ff05d;
var $f47b0b248e831907$export$b5836b71941fa3ed;
var $f47b0b248e831907$export$d66a1c1c77bd778b;
var $f47b0b248e831907$export$3e506c1ccc9cc1a7;
var $f47b0b248e831907$export$e26fe2ed2fa76875;
var $f47b0b248e831907$export$502329bbf4b505b1;
var $f47b0b248e831907$export$6e3807111c4874c4;
var $f47b0b248e831907$export$c27134553091fb3a;
var $f47b0b248e831907$export$33ee1acdc04fd2a2;
var $f47b0b248e831907$export$b00a404bbd5edef2;
var $f47b0b248e831907$export$8352ce38b91d0c62;
var $f47b0b248e831907$export$d3dfb8e4810cb555;
var $f47b0b248e831907$export$839f9183b0465a69;
var $f47b0b248e831907$export$72fdf0e06517287b;
var $f47b0b248e831907$export$4b844e58a3e414b4;
var $f47b0b248e831907$export$816d2913ae6b83b1;
var $f47b0b248e831907$export$61bcfe829111a1d0;
var $f47b0b248e831907$export$7ee8c9beb337bc3f;
var $f47b0b248e831907$export$cf845f2c119da08a;
"use strict";
var $f47b0b248e831907$var$f, $f47b0b248e831907$var$g, $f47b0b248e831907$var$h, $f47b0b248e831907$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f47b0b248e831907$var$l = performance;
    $f47b0b248e831907$export$c4744153514ff05d = function() {
        return $f47b0b248e831907$var$l.now();
    };
} else {
    var $f47b0b248e831907$var$p = Date, $f47b0b248e831907$var$q = $f47b0b248e831907$var$p.now();
    $f47b0b248e831907$export$c4744153514ff05d = function() {
        return $f47b0b248e831907$var$p.now() - $f47b0b248e831907$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $f47b0b248e831907$var$t = null, $f47b0b248e831907$var$u = null, $f47b0b248e831907$var$w = function w1() {
        if (null !== $f47b0b248e831907$var$t) try {
            var a = $f47b0b248e831907$export$c4744153514ff05d();
            $f47b0b248e831907$var$t(!0, a);
            $f47b0b248e831907$var$t = null;
        } catch (b) {
            throw setTimeout($f47b0b248e831907$var$w, 0), b;
        }
    };
    $f47b0b248e831907$var$f = function(a) {
        null !== $f47b0b248e831907$var$t ? setTimeout($f47b0b248e831907$var$f, 0, a) : ($f47b0b248e831907$var$t = a, setTimeout($f47b0b248e831907$var$w, 0));
    };
    $f47b0b248e831907$var$g = function g(a, b) {
        $f47b0b248e831907$var$u = setTimeout(a, b);
    };
    $f47b0b248e831907$var$h = function h() {
        clearTimeout($f47b0b248e831907$var$u);
    };
    $f47b0b248e831907$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $f47b0b248e831907$var$k = $f47b0b248e831907$export$d66a1c1c77bd778b = function k() {};
} else {
    var $f47b0b248e831907$var$x = window.setTimeout, $f47b0b248e831907$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $f47b0b248e831907$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $f47b0b248e831907$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $f47b0b248e831907$var$A = !1, $f47b0b248e831907$var$B = null, $f47b0b248e831907$var$C = -1, $f47b0b248e831907$var$D = 5, $f47b0b248e831907$var$E = 0;
    $f47b0b248e831907$export$b5836b71941fa3ed = function() {
        return $f47b0b248e831907$export$c4744153514ff05d() >= $f47b0b248e831907$var$E;
    };
    $f47b0b248e831907$var$k = function k() {};
    $f47b0b248e831907$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f47b0b248e831907$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $f47b0b248e831907$var$F = new MessageChannel, $f47b0b248e831907$var$G = $f47b0b248e831907$var$F.port2;
    $f47b0b248e831907$var$F.port1.onmessage = function() {
        if (null !== $f47b0b248e831907$var$B) {
            var a = $f47b0b248e831907$export$c4744153514ff05d();
            $f47b0b248e831907$var$E = a + $f47b0b248e831907$var$D;
            try {
                $f47b0b248e831907$var$B(!0, a) ? $f47b0b248e831907$var$G.postMessage(null) : ($f47b0b248e831907$var$A = !1, $f47b0b248e831907$var$B = null);
            } catch (b) {
                throw $f47b0b248e831907$var$G.postMessage(null), b;
            }
        } else $f47b0b248e831907$var$A = !1;
    };
    $f47b0b248e831907$var$f = function f(a) {
        $f47b0b248e831907$var$B = a;
        $f47b0b248e831907$var$A || ($f47b0b248e831907$var$A = !0, $f47b0b248e831907$var$G.postMessage(null));
    };
    $f47b0b248e831907$var$g = function g(a, b) {
        $f47b0b248e831907$var$C = $f47b0b248e831907$var$x(function() {
            a($f47b0b248e831907$export$c4744153514ff05d());
        }, b);
    };
    $f47b0b248e831907$var$h = function h() {
        $f47b0b248e831907$var$y($f47b0b248e831907$var$C);
        $f47b0b248e831907$var$C = -1;
    };
}
function $f47b0b248e831907$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $f47b0b248e831907$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f47b0b248e831907$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $f47b0b248e831907$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $f47b0b248e831907$var$I(n, c)) void 0 !== r && 0 > $f47b0b248e831907$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $f47b0b248e831907$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $f47b0b248e831907$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $f47b0b248e831907$var$L = [], $f47b0b248e831907$var$M = [], $f47b0b248e831907$var$N = 1, $f47b0b248e831907$var$O = null, $f47b0b248e831907$var$P = 3, $f47b0b248e831907$var$Q = !1, $f47b0b248e831907$var$R = !1, $f47b0b248e831907$var$S = !1;
function $f47b0b248e831907$var$T(a) {
    for(var b = $f47b0b248e831907$var$J($f47b0b248e831907$var$M); null !== b;){
        if (null === b.callback) $f47b0b248e831907$var$K($f47b0b248e831907$var$M);
        else if (b.startTime <= a) $f47b0b248e831907$var$K($f47b0b248e831907$var$M), b.sortIndex = b.expirationTime, $f47b0b248e831907$var$H($f47b0b248e831907$var$L, b);
        else break;
        b = $f47b0b248e831907$var$J($f47b0b248e831907$var$M);
    }
}
function $f47b0b248e831907$var$U(a) {
    $f47b0b248e831907$var$S = !1;
    $f47b0b248e831907$var$T(a);
    if (!$f47b0b248e831907$var$R) {
        if (null !== $f47b0b248e831907$var$J($f47b0b248e831907$var$L)) $f47b0b248e831907$var$R = !0, $f47b0b248e831907$var$f($f47b0b248e831907$var$V);
        else {
            var b = $f47b0b248e831907$var$J($f47b0b248e831907$var$M);
            null !== b && $f47b0b248e831907$var$g($f47b0b248e831907$var$U, b.startTime - a);
        }
    }
}
function $f47b0b248e831907$var$V(a, b) {
    $f47b0b248e831907$var$R = !1;
    $f47b0b248e831907$var$S && ($f47b0b248e831907$var$S = !1, $f47b0b248e831907$var$h());
    $f47b0b248e831907$var$Q = !0;
    var c = $f47b0b248e831907$var$P;
    try {
        $f47b0b248e831907$var$T(b);
        for($f47b0b248e831907$var$O = $f47b0b248e831907$var$J($f47b0b248e831907$var$L); null !== $f47b0b248e831907$var$O && (!($f47b0b248e831907$var$O.expirationTime > b) || a && !$f47b0b248e831907$export$b5836b71941fa3ed());){
            var d = $f47b0b248e831907$var$O.callback;
            if ("function" === typeof d) {
                $f47b0b248e831907$var$O.callback = null;
                $f47b0b248e831907$var$P = $f47b0b248e831907$var$O.priorityLevel;
                var e = d($f47b0b248e831907$var$O.expirationTime <= b);
                b = $f47b0b248e831907$export$c4744153514ff05d();
                "function" === typeof e ? $f47b0b248e831907$var$O.callback = e : $f47b0b248e831907$var$O === $f47b0b248e831907$var$J($f47b0b248e831907$var$L) && $f47b0b248e831907$var$K($f47b0b248e831907$var$L);
                $f47b0b248e831907$var$T(b);
            } else $f47b0b248e831907$var$K($f47b0b248e831907$var$L);
            $f47b0b248e831907$var$O = $f47b0b248e831907$var$J($f47b0b248e831907$var$L);
        }
        if (null !== $f47b0b248e831907$var$O) var m = !0;
        else {
            var n = $f47b0b248e831907$var$J($f47b0b248e831907$var$M);
            null !== n && $f47b0b248e831907$var$g($f47b0b248e831907$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $f47b0b248e831907$var$O = null, $f47b0b248e831907$var$P = c, $f47b0b248e831907$var$Q = !1;
    }
}
var $f47b0b248e831907$var$W = $f47b0b248e831907$var$k;
$f47b0b248e831907$export$3e506c1ccc9cc1a7 = 5;
$f47b0b248e831907$export$e26fe2ed2fa76875 = 1;
$f47b0b248e831907$export$502329bbf4b505b1 = 4;
$f47b0b248e831907$export$6e3807111c4874c4 = 3;
$f47b0b248e831907$export$c27134553091fb3a = null;
$f47b0b248e831907$export$33ee1acdc04fd2a2 = 2;
$f47b0b248e831907$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f47b0b248e831907$export$8352ce38b91d0c62 = function() {
    $f47b0b248e831907$var$R || $f47b0b248e831907$var$Q || ($f47b0b248e831907$var$R = !0, $f47b0b248e831907$var$f($f47b0b248e831907$var$V));
};
$f47b0b248e831907$export$d3dfb8e4810cb555 = function() {
    return $f47b0b248e831907$var$P;
};
$f47b0b248e831907$export$839f9183b0465a69 = function() {
    return $f47b0b248e831907$var$J($f47b0b248e831907$var$L);
};
$f47b0b248e831907$export$72fdf0e06517287b = function(a) {
    switch($f47b0b248e831907$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f47b0b248e831907$var$P;
    }
    var c = $f47b0b248e831907$var$P;
    $f47b0b248e831907$var$P = b;
    try {
        return a();
    } finally{
        $f47b0b248e831907$var$P = c;
    }
};
$f47b0b248e831907$export$4b844e58a3e414b4 = function() {};
$f47b0b248e831907$export$816d2913ae6b83b1 = $f47b0b248e831907$var$W;
$f47b0b248e831907$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f47b0b248e831907$var$P;
    $f47b0b248e831907$var$P = a;
    try {
        return b();
    } finally{
        $f47b0b248e831907$var$P = c;
    }
};
$f47b0b248e831907$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f47b0b248e831907$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f47b0b248e831907$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f47b0b248e831907$var$H($f47b0b248e831907$var$M, a), null === $f47b0b248e831907$var$J($f47b0b248e831907$var$L) && a === $f47b0b248e831907$var$J($f47b0b248e831907$var$M) && ($f47b0b248e831907$var$S ? $f47b0b248e831907$var$h() : $f47b0b248e831907$var$S = !0, $f47b0b248e831907$var$g($f47b0b248e831907$var$U, c - d))) : (a.sortIndex = e, $f47b0b248e831907$var$H($f47b0b248e831907$var$L, a), $f47b0b248e831907$var$R || $f47b0b248e831907$var$Q || ($f47b0b248e831907$var$R = !0, $f47b0b248e831907$var$f($f47b0b248e831907$var$V)));
    return a;
};
$f47b0b248e831907$export$cf845f2c119da08a = function(a) {
    var b = $f47b0b248e831907$var$P;
    return function() {
        var c = $f47b0b248e831907$var$P;
        $f47b0b248e831907$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f47b0b248e831907$var$P = c;
        }
    };
};

});



parcelRequire.register("kH3hC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f10a5ec548a8895c$export$2b8d127b894957b9; }, function (v) { return $f10a5ec548a8895c$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f10a5ec548a8895c$export$cea3a54a6425200c; }, function (v) { return $f10a5ec548a8895c$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f10a5ec548a8895c$export$a7c73072b1a182ae; }, function (v) { return $f10a5ec548a8895c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f10a5ec548a8895c$export$9f27bc3417b4524d; }, function (v) { return $f10a5ec548a8895c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f10a5ec548a8895c$export$db77ccec0bb4ccac; }, function (v) { return $f10a5ec548a8895c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f10a5ec548a8895c$export$8392c0c9d3dcbd35; }, function (v) { return $f10a5ec548a8895c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f10a5ec548a8895c$export$ffb0004e005737fa; }, function (v) { return $f10a5ec548a8895c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f10a5ec548a8895c$export$b624eff549462981; }, function (v) { return $f10a5ec548a8895c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f10a5ec548a8895c$export$7897aa7841a5380c; }, function (v) { return $f10a5ec548a8895c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f10a5ec548a8895c$export$602eac185826482c; }, function (v) { return $f10a5ec548a8895c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f10a5ec548a8895c$export$e2c29f18771995cb; }, function (v) { return $f10a5ec548a8895c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f10a5ec548a8895c$export$5f8d39834fd61797; }, function (v) { return $f10a5ec548a8895c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f10a5ec548a8895c$export$74bf444e3cd11ea5; }, function (v) { return $f10a5ec548a8895c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f10a5ec548a8895c$export$92387174baf9b227; }, function (v) { return $f10a5ec548a8895c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f10a5ec548a8895c$export$ec112efeb987d9c6; }, function (v) { return $f10a5ec548a8895c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f10a5ec548a8895c$export$b706b080d889d2c9; }, function (v) { return $f10a5ec548a8895c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f10a5ec548a8895c$export$5be5a87408f70ddc; }, function (v) { return $f10a5ec548a8895c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f10a5ec548a8895c$export$45a5e7f76e0caa8d; }, function (v) { return $f10a5ec548a8895c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f10a5ec548a8895c$export$455c2e768291efa6; }, function (v) { return $f10a5ec548a8895c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f10a5ec548a8895c$export$9522e17588c12572; }, function (v) { return $f10a5ec548a8895c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f10a5ec548a8895c$export$2110ac352bb060b9; }, function (v) { return $f10a5ec548a8895c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f10a5ec548a8895c$export$56885ab8b9c456ab; }, function (v) { return $f10a5ec548a8895c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f10a5ec548a8895c$export$d927fcb6adf8f9de; }, function (v) { return $f10a5ec548a8895c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f10a5ec548a8895c$export$b82d16f27459e05a; }, function (v) { return $f10a5ec548a8895c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f10a5ec548a8895c$export$522c17b4f5e123e8; }, function (v) { return $f10a5ec548a8895c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f10a5ec548a8895c$export$1aabd8a0274ecfd6; }, function (v) { return $f10a5ec548a8895c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f10a5ec548a8895c$export$9b621391a187a31a; }, function (v) { return $f10a5ec548a8895c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f10a5ec548a8895c$export$f5bbd400c2f4426f; }, function (v) { return $f10a5ec548a8895c$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f10a5ec548a8895c$export$2b8d127b894957b9;
var $f10a5ec548a8895c$export$cea3a54a6425200c;
var $f10a5ec548a8895c$export$a7c73072b1a182ae;
var $f10a5ec548a8895c$export$9f27bc3417b4524d;
var $f10a5ec548a8895c$export$db77ccec0bb4ccac;
var $f10a5ec548a8895c$export$8392c0c9d3dcbd35;
var $f10a5ec548a8895c$export$ffb0004e005737fa;
var $f10a5ec548a8895c$export$b624eff549462981;
var $f10a5ec548a8895c$export$7897aa7841a5380c;
var $f10a5ec548a8895c$export$602eac185826482c;
var $f10a5ec548a8895c$export$e2c29f18771995cb;
var $f10a5ec548a8895c$export$5f8d39834fd61797;
var $f10a5ec548a8895c$export$74bf444e3cd11ea5;
var $f10a5ec548a8895c$export$92387174baf9b227;
var $f10a5ec548a8895c$export$ec112efeb987d9c6;
var $f10a5ec548a8895c$export$b706b080d889d2c9;
var $f10a5ec548a8895c$export$5be5a87408f70ddc;
var $f10a5ec548a8895c$export$45a5e7f76e0caa8d;
var $f10a5ec548a8895c$export$455c2e768291efa6;
var $f10a5ec548a8895c$export$9522e17588c12572;
var $f10a5ec548a8895c$export$2110ac352bb060b9;
var $f10a5ec548a8895c$export$56885ab8b9c456ab;
var $f10a5ec548a8895c$export$d927fcb6adf8f9de;
var $f10a5ec548a8895c$export$b82d16f27459e05a;
var $f10a5ec548a8895c$export$522c17b4f5e123e8;
var $f10a5ec548a8895c$export$1aabd8a0274ecfd6;
var $f10a5ec548a8895c$export$9b621391a187a31a;
var $f10a5ec548a8895c$export$f5bbd400c2f4426f;
"use strict";
var $f10a5ec548a8895c$var$b = "function" === typeof Symbol && Symbol.for, $f10a5ec548a8895c$var$c = $f10a5ec548a8895c$var$b ? Symbol.for("react.element") : 60103, $f10a5ec548a8895c$var$d = $f10a5ec548a8895c$var$b ? Symbol.for("react.portal") : 60106, $f10a5ec548a8895c$var$e = $f10a5ec548a8895c$var$b ? Symbol.for("react.fragment") : 60107, $f10a5ec548a8895c$var$f = $f10a5ec548a8895c$var$b ? Symbol.for("react.strict_mode") : 60108, $f10a5ec548a8895c$var$g = $f10a5ec548a8895c$var$b ? Symbol.for("react.profiler") : 60114, $f10a5ec548a8895c$var$h = $f10a5ec548a8895c$var$b ? Symbol.for("react.provider") : 60109, $f10a5ec548a8895c$var$k = $f10a5ec548a8895c$var$b ? Symbol.for("react.context") : 60110, $f10a5ec548a8895c$var$l = $f10a5ec548a8895c$var$b ? Symbol.for("react.async_mode") : 60111, $f10a5ec548a8895c$var$m = $f10a5ec548a8895c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f10a5ec548a8895c$var$n = $f10a5ec548a8895c$var$b ? Symbol.for("react.forward_ref") : 60112, $f10a5ec548a8895c$var$p = $f10a5ec548a8895c$var$b ? Symbol.for("react.suspense") : 60113, $f10a5ec548a8895c$var$q = $f10a5ec548a8895c$var$b ? Symbol.for("react.suspense_list") : 60120, $f10a5ec548a8895c$var$r = $f10a5ec548a8895c$var$b ? Symbol.for("react.memo") : 60115, $f10a5ec548a8895c$var$t = $f10a5ec548a8895c$var$b ? Symbol.for("react.lazy") : 60116, $f10a5ec548a8895c$var$v = $f10a5ec548a8895c$var$b ? Symbol.for("react.block") : 60121, $f10a5ec548a8895c$var$w = $f10a5ec548a8895c$var$b ? Symbol.for("react.fundamental") : 60117, $f10a5ec548a8895c$var$x = $f10a5ec548a8895c$var$b ? Symbol.for("react.responder") : 60118, $f10a5ec548a8895c$var$y = $f10a5ec548a8895c$var$b ? Symbol.for("react.scope") : 60119;
function $f10a5ec548a8895c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f10a5ec548a8895c$var$c:
                switch(a = a.type, a){
                    case $f10a5ec548a8895c$var$l:
                    case $f10a5ec548a8895c$var$m:
                    case $f10a5ec548a8895c$var$e:
                    case $f10a5ec548a8895c$var$g:
                    case $f10a5ec548a8895c$var$f:
                    case $f10a5ec548a8895c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f10a5ec548a8895c$var$k:
                            case $f10a5ec548a8895c$var$n:
                            case $f10a5ec548a8895c$var$t:
                            case $f10a5ec548a8895c$var$r:
                            case $f10a5ec548a8895c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f10a5ec548a8895c$var$d:
                return u;
        }
    }
}
function $f10a5ec548a8895c$var$A(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$m;
}
$f10a5ec548a8895c$export$2b8d127b894957b9 = $f10a5ec548a8895c$var$l;
$f10a5ec548a8895c$export$cea3a54a6425200c = $f10a5ec548a8895c$var$m;
$f10a5ec548a8895c$export$a7c73072b1a182ae = $f10a5ec548a8895c$var$k;
$f10a5ec548a8895c$export$9f27bc3417b4524d = $f10a5ec548a8895c$var$h;
$f10a5ec548a8895c$export$db77ccec0bb4ccac = $f10a5ec548a8895c$var$c;
$f10a5ec548a8895c$export$8392c0c9d3dcbd35 = $f10a5ec548a8895c$var$n;
$f10a5ec548a8895c$export$ffb0004e005737fa = $f10a5ec548a8895c$var$e;
$f10a5ec548a8895c$export$b624eff549462981 = $f10a5ec548a8895c$var$t;
$f10a5ec548a8895c$export$7897aa7841a5380c = $f10a5ec548a8895c$var$r;
$f10a5ec548a8895c$export$602eac185826482c = $f10a5ec548a8895c$var$d;
$f10a5ec548a8895c$export$e2c29f18771995cb = $f10a5ec548a8895c$var$g;
$f10a5ec548a8895c$export$5f8d39834fd61797 = $f10a5ec548a8895c$var$f;
$f10a5ec548a8895c$export$74bf444e3cd11ea5 = $f10a5ec548a8895c$var$p;
$f10a5ec548a8895c$export$92387174baf9b227 = function(a) {
    return $f10a5ec548a8895c$var$A(a) || $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$l;
};
$f10a5ec548a8895c$export$ec112efeb987d9c6 = $f10a5ec548a8895c$var$A;
$f10a5ec548a8895c$export$b706b080d889d2c9 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$k;
};
$f10a5ec548a8895c$export$5be5a87408f70ddc = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$h;
};
$f10a5ec548a8895c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f10a5ec548a8895c$var$c;
};
$f10a5ec548a8895c$export$455c2e768291efa6 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$n;
};
$f10a5ec548a8895c$export$9522e17588c12572 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$e;
};
$f10a5ec548a8895c$export$2110ac352bb060b9 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$t;
};
$f10a5ec548a8895c$export$56885ab8b9c456ab = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$r;
};
$f10a5ec548a8895c$export$d927fcb6adf8f9de = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$d;
};
$f10a5ec548a8895c$export$b82d16f27459e05a = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$g;
};
$f10a5ec548a8895c$export$522c17b4f5e123e8 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$f;
};
$f10a5ec548a8895c$export$1aabd8a0274ecfd6 = function(a) {
    return $f10a5ec548a8895c$var$z(a) === $f10a5ec548a8895c$var$p;
};
$f10a5ec548a8895c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f10a5ec548a8895c$var$e || a === $f10a5ec548a8895c$var$m || a === $f10a5ec548a8895c$var$g || a === $f10a5ec548a8895c$var$f || a === $f10a5ec548a8895c$var$p || a === $f10a5ec548a8895c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f10a5ec548a8895c$var$t || a.$$typeof === $f10a5ec548a8895c$var$r || a.$$typeof === $f10a5ec548a8895c$var$h || a.$$typeof === $f10a5ec548a8895c$var$k || a.$$typeof === $f10a5ec548a8895c$var$n || a.$$typeof === $f10a5ec548a8895c$var$w || a.$$typeof === $f10a5ec548a8895c$var$x || a.$$typeof === $f10a5ec548a8895c$var$y || a.$$typeof === $f10a5ec548a8895c$var$v);
};
$f10a5ec548a8895c$export$f5bbd400c2f4426f = $f10a5ec548a8895c$var$z;

});

parcelRequire.register("6mwXD", function(module, exports) {

var $hR1MC = parcelRequire("hR1MC");

var $bAAok = parcelRequire("bAAok");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hR1MC.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $bAAok;
module.exports = isBuffer;

});
parcelRequire.register("hR1MC", function(module, exports) {

var $iOzk5 = parcelRequire("iOzk5");
/** Detect free variable `self`. */ var $035ab8dad5af5ee3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $035ab8dad5af5ee3$var$root = $iOzk5 || $035ab8dad5af5ee3$var$freeSelf || Function("return this")();
module.exports = $035ab8dad5af5ee3$var$root;

});
parcelRequire.register("iOzk5", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $db284beafacdf6f9$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $db284beafacdf6f9$var$freeGlobal;

});


parcelRequire.register("bAAok", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $86ff4916b3ebebb1$var$stubFalse() {
    return false;
}
module.exports = $86ff4916b3ebebb1$var$stubFalse;

});


parcelRequire.register("fnsCs", function(module, exports) {

var $iOzk5 = parcelRequire("iOzk5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $iOzk5.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("5c1eQ", function(module, exports) {

var $hR1MC = parcelRequire("hR1MC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hR1MC.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRequire.register("4ig53", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $b0PmO = parcelRequire("b0PmO");

var $l9BwU = parcelRequire("l9BwU");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var $hFNrU = parcelRequire("hFNrU");

var $5alXP = parcelRequire("5alXP");

var $kvl0Q = parcelRequire("kvl0Q");

var $kXvZh = parcelRequire("kXvZh");
var META_SUPPORT_DATA = [
    "/properties"
];
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
var Ajv = /*#__PURE__*/ function(_core_1_default) {
    (0, $fsOl6._)(Ajv, _core_1_default);
    var _super = (0, $COJlH._)(Ajv);
    function Ajv() {
        (0, $h5oKP._)(this, Ajv);
        return _super.apply(this, arguments);
    }
    (0, $85qwq._)(Ajv, [
        {
            key: "_addVocabularies",
            value: function _addVocabularies() {
                var _this = this;
                (0, $b0PmO._)((0, $l9BwU._)(Ajv.prototype), "_addVocabularies", this).call(this);
                $5alXP.default.forEach(function(v) {
                    return _this.addVocabulary(v);
                });
                if (this.opts.discriminator) this.addKeyword($kvl0Q.default);
            }
        },
        {
            key: "_addDefaultMetaSchema",
            value: function _addDefaultMetaSchema() {
                (0, $b0PmO._)((0, $l9BwU._)(Ajv.prototype), "_addDefaultMetaSchema", this).call(this);
                if (!this.opts.meta) return;
                var metaSchema = this.opts.$data ? this.$dataMetaSchema($kXvZh, META_SUPPORT_DATA) : $kXvZh;
                this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
                this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
            }
        },
        {
            key: "defaultMeta",
            value: function defaultMeta() {
                return this.opts.defaultMeta = (0, $b0PmO._)((0, $l9BwU._)(Ajv.prototype), "defaultMeta", this).call(this) || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
            }
        }
    ]);
    return Ajv;
}($hFNrU.default);
module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $8n3O1 = parcelRequire("8n3O1");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function get() {
        return $8n3O1.KeywordCxt;
    }
});

var $3Ar5a = parcelRequire("3Ar5a");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function get() {
        return $3Ar5a._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.CodeGen;
    }
});

var $aNuxA = parcelRequire("aNuxA");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function get() {
        return $aNuxA.default;
    }
});

var $j2ZXR = parcelRequire("j2ZXR");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function get() {
        return $j2ZXR.default;
    }
});

});
parcelRequire.register("h5oKP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7061aff4cb7823a$export$2996f80ef42b8419; });
function $c7061aff4cb7823a$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("85qwq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e335d0e8622f1f7$export$d60067ff2358eee8; });
function $5e335d0e8622f1f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5e335d0e8622f1f7$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $5e335d0e8622f1f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e335d0e8622f1f7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("b0PmO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $80478a378edecd88$export$afb3516d9d608401; });

var $c4jrd = parcelRequire("c4jrd");
function $80478a378edecd88$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $80478a378edecd88$export$afb3516d9d608401 = Reflect.get;
    else $80478a378edecd88$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $c4jrd._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $80478a378edecd88$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRequire.register("c4jrd", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $8c94efbde6add34e$export$e4187255aefbc259; });

var $l9BwU = parcelRequire("l9BwU");
function $8c94efbde6add34e$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $l9BwU._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRequire.register("l9BwU", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $f6678cd8d1541b4c$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $f6678cd8d1541b4c$export$f09211a7d3c496a1; });
function $f6678cd8d1541b4c$export$f09211a7d3c496a1(o) {
    $f6678cd8d1541b4c$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f6678cd8d1541b4c$export$f09211a7d3c496a1(o);
}

});



parcelRequire.register("fsOl6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b42084e7dd907e98$export$7e4530ad35d3bb8; });

var $9QNuc = parcelRequire("9QNuc");
function $b42084e7dd907e98$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9QNuc._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("9QNuc", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $72bf5b4e22923350$export$c2c98ac76e997b63; });
function $72bf5b4e22923350$export$c2c98ac76e997b63(o, p) {
    $72bf5b4e22923350$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $72bf5b4e22923350$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("COJlH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $074ae6bb6d02de5e$export$8dd05c13f5255580; });

var $l9BwU = parcelRequire("l9BwU");

var $gfgCN = parcelRequire("gfgCN");

var $EtGm9 = parcelRequire("EtGm9");
function $074ae6bb6d02de5e$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $gfgCN._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $l9BwU._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $l9BwU._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $EtGm9._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("gfgCN", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $bd3af15c313d91fb$export$685354647fba1516; });
function $bd3af15c313d91fb$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("EtGm9", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $079ac2cd3ee17990$export$ef97c660ca164e52; });

var $fI3zL = parcelRequire("fI3zL");

var $5F2Q2 = parcelRequire("5F2Q2");
function $079ac2cd3ee17990$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $5F2Q2._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $fI3zL._assert_this_initialized)(self);
}

});
parcelRequire.register("fI3zL", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $b6fdbd2a39716eed$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $b6fdbd2a39716eed$export$f3b8ed2e4a5d10b8; });
function $b6fdbd2a39716eed$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRequire.register("hFNrU", function(module, exports) {

var $em5FP = parcelRequire("em5FP");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");

var $5F2Q2 = parcelRequire("5F2Q2");

var $nLPsB = parcelRequire("nLPsB");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $8n3O1 = parcelRequire("8n3O1");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function get() {
        return $8n3O1.KeywordCxt;
    }
});

var $3Ar5a = parcelRequire("3Ar5a");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function get() {
        return $3Ar5a._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function get() {
        return $3Ar5a.CodeGen;
    }
});

var $aNuxA = parcelRequire("aNuxA");

var $j2ZXR = parcelRequire("j2ZXR");

var $7w8WR = parcelRequire("7w8WR");

var $glLnH = parcelRequire("glLnH");

var $3Ar5a = parcelRequire("3Ar5a");

var $b6Wgf = parcelRequire("b6Wgf");

var $96OdM = parcelRequire("96OdM");

var $eKI5Q = parcelRequire("eKI5Q");

var $A4Hqa = parcelRequire("A4Hqa");

var $lyzle = parcelRequire("lyzle");
var $cddc9f96c167754d$var$defaultRegExp = function(str, flags) {
    return new RegExp(str, flags);
};
$cddc9f96c167754d$var$defaultRegExp.code = "new RegExp";
var $cddc9f96c167754d$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
var $cddc9f96c167754d$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
var $cddc9f96c167754d$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
var $cddc9f96c167754d$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
var $cddc9f96c167754d$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $cddc9f96c167754d$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var s = o.strict;
    var _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    var optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    var regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $cddc9f96c167754d$var$defaultRegExp;
    var uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $lyzle.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? (0, $cpUXF._)((0, $hF4Ve._)({}, o.code), {
            optimize: optimize,
            regExp: regExp
        }) : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $cddc9f96c167754d$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $cddc9f96c167754d$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
var $cddc9f96c167754d$var$Ajv = /*#__PURE__*/ function() {
    function Ajv() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $h5oKP._)(this, Ajv);
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = (0, $hF4Ve._)({}, opts, $cddc9f96c167754d$var$requiredOptions(opts));
        var _this_opts_code = this.opts.code, es5 = _this_opts_code.es5, lines = _this_opts_code.lines;
        this.scope = new $3Ar5a.ValueScope({
            scope: {},
            prefixes: $cddc9f96c167754d$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $cddc9f96c167754d$var$getLogger(opts.logger);
        var formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $7w8WR.getRules)();
        $cddc9f96c167754d$var$checkOptions.call(this, $cddc9f96c167754d$var$removedOptions, opts, "NOT SUPPORTED");
        $cddc9f96c167754d$var$checkOptions.call(this, $cddc9f96c167754d$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $cddc9f96c167754d$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $cddc9f96c167754d$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $cddc9f96c167754d$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $cddc9f96c167754d$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    (0, $85qwq._)(Ajv, [
        {
            key: "_addVocabularies",
            value: function _addVocabularies() {
                this.addKeyword("$async");
            }
        },
        {
            key: "_addDefaultMetaSchema",
            value: function _addDefaultMetaSchema() {
                var _this_opts = this.opts, $data = _this_opts.$data, meta = _this_opts.meta, schemaId = _this_opts.schemaId;
                var _dataRefSchema = $A4Hqa;
                if (schemaId === "id") {
                    _dataRefSchema = (0, $hF4Ve._)({}, $A4Hqa);
                    _dataRefSchema.id = _dataRefSchema.$id;
                    delete _dataRefSchema.$id;
                }
                if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
            }
        },
        {
            key: "defaultMeta",
            value: function defaultMeta() {
                var _this_opts = this.opts, meta = _this_opts.meta, schemaId = _this_opts.schemaId;
                return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
            }
        },
        {
            key: "validate",
            value: function validate(schemaKeyRef, data // to be validated
            ) {
                var v;
                if (typeof schemaKeyRef == "string") {
                    v = this.getSchema(schemaKeyRef);
                    if (!v) throw new Error('no schema with key or ref "'.concat(schemaKeyRef, '"'));
                } else v = this.compile(schemaKeyRef);
                var valid = v(data);
                if (!("$async" in v)) this.errors = v.errors;
                return valid;
            }
        },
        {
            key: "compile",
            value: function compile(schema, _meta) {
                var sch = this._addSchema(schema, _meta);
                return sch.validate || this._compileSchemaEnv(sch);
            }
        },
        {
            key: "compileAsync",
            value: function compileAsync(schema, meta) {
                var checkLoaded = function checkLoaded(param) {
                    var ref = param.missingSchema, missingRef = param.missingRef;
                    if (this.refs[ref]) throw new Error("AnySchema ".concat(ref, " is loaded but ").concat(missingRef, " cannot be resolved"));
                };
                if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
                var loadSchema = this.opts.loadSchema;
                return runCompileAsync.call(this, schema, meta);
                function runCompileAsync(_schema, _meta) {
                    return _runCompileAsync.apply(this, arguments);
                }
                function _runCompileAsync() {
                    _runCompileAsync = (0, $em5FP._)(function(_schema, _meta) {
                        var sch;
                        return (0, $nLPsB.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        loadMetaSchema.call(this, _schema.$schema)
                                    ];
                                case 1:
                                    _state.sent();
                                    sch = this._addSchema(_schema, _meta);
                                    return [
                                        2,
                                        sch.validate || _compileAsync.call(this, sch)
                                    ];
                            }
                        });
                    });
                    return _runCompileAsync.apply(this, arguments);
                }
                function loadMetaSchema($ref) {
                    return _loadMetaSchema.apply(this, arguments);
                }
                function _loadMetaSchema() {
                    _loadMetaSchema = (0, $em5FP._)(function($ref) {
                        return (0, $nLPsB.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!($ref && !this.getSchema($ref))) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        runCompileAsync.call(this, {
                                            $ref: $ref
                                        }, true)
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _loadMetaSchema.apply(this, arguments);
                }
                function _compileAsync(sch) {
                    return __compileAsync.apply(this, arguments);
                }
                function __compileAsync() {
                    __compileAsync = (0, $em5FP._)(function(sch) {
                        var e;
                        return (0, $nLPsB.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        1,
                                        ,
                                        3
                                    ]);
                                    return [
                                        2,
                                        this._compileSchemaEnv(sch)
                                    ];
                                case 1:
                                    e = _state.sent();
                                    if (!(e instanceof $j2ZXR.default)) throw e;
                                    checkLoaded.call(this, e);
                                    return [
                                        4,
                                        loadMissingSchema.call(this, e.missingSchema)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        _compileAsync.call(this, sch)
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return __compileAsync.apply(this, arguments);
                }
                function loadMissingSchema(ref) {
                    return _loadMissingSchema.apply(this, arguments);
                }
                function _loadMissingSchema() {
                    _loadMissingSchema = (0, $em5FP._)(function(ref) {
                        var _schema;
                        return (0, $nLPsB.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _loadSchema.call(this, ref)
                                    ];
                                case 1:
                                    _schema = _state.sent();
                                    if (!!this.refs[ref]) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadMetaSchema.call(this, _schema.$schema)
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _loadMissingSchema.apply(this, arguments);
                }
                function _loadSchema(ref) {
                    return __loadSchema.apply(this, arguments);
                }
                function __loadSchema() {
                    __loadSchema = (0, $em5FP._)(function(ref) {
                        var p;
                        return (0, $nLPsB.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    p = this._loading[ref];
                                    if (p) return [
                                        2,
                                        p
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        ,
                                        3,
                                        4
                                    ]);
                                    return [
                                        4,
                                        this._loading[ref] = loadSchema(ref)
                                    ];
                                case 2:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 3:
                                    delete this._loading[ref];
                                    return [
                                        7
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return __loadSchema.apply(this, arguments);
                }
            }
        },
        {
            // Adds schema to the instance
            key: "addSchema",
            value: function addSchema(schema, key, _meta) {
                var _validateSchema = arguments.length > 3 && arguments[3] !== void 0 // false to skip schema validation. Used internally, option validateSchema should be used instead.
                 ? arguments[3] : this.opts.validateSchema;
                if (Array.isArray(schema)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = schema[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var sch = _step.value;
                            this.addSchema(sch, undefined, _meta, _validateSchema);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return this;
                }
                var id;
                if (typeof schema === "object") {
                    var schemaId = this.opts.schemaId;
                    id = schema[schemaId];
                    if (id !== undefined && typeof id != "string") throw new Error("schema ".concat(schemaId, " must be string"));
                }
                key = (0, $b6Wgf.normalizeId)(key || id);
                this._checkUnique(key);
                this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
                return this;
            }
        },
        {
            // Add schema that will be used to validate other schemas
            // options in META_IGNORE_OPTIONS are alway set to false
            key: "addMetaSchema",
            value: function addMetaSchema(schema, key) {
                var _validateSchema = arguments.length > 2 && arguments[2] !== void 0 // false to skip schema validation, can be used to override validateSchema option for meta-schema
                 ? arguments[2] : this.opts.validateSchema;
                this.addSchema(schema, key, true, _validateSchema);
                return this;
            }
        },
        {
            //  Validate schema against its meta-schema
            key: "validateSchema",
            value: function validateSchema(schema, throwOrLogError) {
                if (typeof schema == "boolean") return true;
                var $schema;
                $schema = schema.$schema;
                if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
                $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
                if (!$schema) {
                    this.logger.warn("meta-schema not available");
                    this.errors = null;
                    return true;
                }
                var valid = this.validate($schema, schema);
                if (!valid && throwOrLogError) {
                    var message = "schema is invalid: " + this.errorsText();
                    if (this.opts.validateSchema === "log") this.logger.error(message);
                    else throw new Error(message);
                }
                return valid;
            }
        },
        {
            // Get compiled schema by `key` or `ref`.
            // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
            key: "getSchema",
            value: function getSchema(keyRef) {
                var sch;
                while(typeof (sch = $cddc9f96c167754d$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
                if (sch === undefined) {
                    var schemaId = this.opts.schemaId;
                    var root = new $glLnH.SchemaEnv({
                        schema: {},
                        schemaId: schemaId
                    });
                    sch = $glLnH.resolveSchema.call(this, root, keyRef);
                    if (!sch) return;
                    this.refs[keyRef] = sch;
                }
                return sch.validate || this._compileSchemaEnv(sch);
            }
        },
        {
            // Remove cached schema(s).
            // If no parameter is passed all schemas but meta-schemas are removed.
            // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
            // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
            key: "removeSchema",
            value: function removeSchema(schemaKeyRef) {
                if (schemaKeyRef instanceof RegExp) {
                    this._removeAllSchemas(this.schemas, schemaKeyRef);
                    this._removeAllSchemas(this.refs, schemaKeyRef);
                    return this;
                }
                switch(typeof schemaKeyRef === "undefined" ? "undefined" : (0, $5F2Q2._)(schemaKeyRef)){
                    case "undefined":
                        this._removeAllSchemas(this.schemas);
                        this._removeAllSchemas(this.refs);
                        this._cache.clear();
                        return this;
                    case "string":
                        {
                            var sch = $cddc9f96c167754d$var$getSchEnv.call(this, schemaKeyRef);
                            if (typeof sch == "object") this._cache.delete(sch.schema);
                            delete this.schemas[schemaKeyRef];
                            delete this.refs[schemaKeyRef];
                            return this;
                        }
                    case "object":
                        {
                            var cacheKey = schemaKeyRef;
                            this._cache.delete(cacheKey);
                            var id = schemaKeyRef[this.opts.schemaId];
                            if (id) {
                                id = (0, $b6Wgf.normalizeId)(id);
                                delete this.schemas[id];
                                delete this.refs[id];
                            }
                            return this;
                        }
                    default:
                        throw new Error("ajv.removeSchema: invalid parameter");
                }
            }
        },
        {
            // add "vocabulary" - a collection of keywords
            key: "addVocabulary",
            value: function addVocabulary(definitions) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var def = _step.value;
                        this.addKeyword(def);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            key: "addKeyword",
            value: function addKeyword(kwdOrDef, def // deprecated
            ) {
                var _this = this;
                var keyword;
                if (typeof kwdOrDef == "string") {
                    keyword = kwdOrDef;
                    if (typeof def == "object") {
                        this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                        def.keyword = keyword;
                    }
                } else if (typeof kwdOrDef == "object" && def === undefined) {
                    def = kwdOrDef;
                    keyword = def.keyword;
                    if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
                } else throw new Error("invalid addKeywords parameters");
                $cddc9f96c167754d$var$checkKeyword.call(this, keyword, def);
                if (!def) {
                    (0, $eKI5Q.eachItem)(keyword, function(kwd) {
                        return $cddc9f96c167754d$var$addRule.call(_this, kwd);
                    });
                    return this;
                }
                $cddc9f96c167754d$var$keywordMetaschema.call(this, def);
                var definition = (0, $cpUXF._)((0, $hF4Ve._)({}, def), {
                    type: (0, $96OdM.getJSONTypes)(def.type),
                    schemaType: (0, $96OdM.getJSONTypes)(def.schemaType)
                });
                (0, $eKI5Q.eachItem)(keyword, definition.type.length === 0 ? function(k) {
                    return $cddc9f96c167754d$var$addRule.call(_this, k, definition);
                } : function(k) {
                    return definition.type.forEach(function(t) {
                        return $cddc9f96c167754d$var$addRule.call(_this, k, definition, t);
                    });
                });
                return this;
            }
        },
        {
            key: "getKeyword",
            value: function getKeyword(keyword) {
                var rule = this.RULES.all[keyword];
                return typeof rule == "object" ? rule.definition : !!rule;
            }
        },
        {
            // Remove keyword
            key: "removeKeyword",
            value: function removeKeyword(keyword) {
                // TODO return type should be Ajv
                var RULES = this.RULES;
                delete RULES.keywords[keyword];
                delete RULES.all[keyword];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = RULES.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var group = _step.value;
                        var i = group.rules.findIndex(function(rule) {
                            return rule.keyword === keyword;
                        });
                        if (i >= 0) group.rules.splice(i, 1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            // Add format
            key: "addFormat",
            value: function addFormat(name, format) {
                if (typeof format == "string") format = new RegExp(format);
                this.formats[name] = format;
                return this;
            }
        },
        {
            key: "errorsText",
            value: function errorsText() {
                var errors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.errors, _ref // optional options with properties `separator` and `dataVar`
                 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_separator = _ref.separator, separator = _ref_separator === void 0 ? ", " : _ref_separator, _ref_dataVar = _ref.dataVar, dataVar = _ref_dataVar === void 0 ? "data" : _ref_dataVar;
                if (!errors || errors.length === 0) return "No errors";
                return errors.map(function(e) {
                    return "".concat(dataVar).concat(e.instancePath, " ").concat(e.message);
                }).reduce(function(text, msg) {
                    return text + separator + msg;
                });
            }
        },
        {
            key: "$dataMetaSchema",
            value: function $dataMetaSchema(metaSchema, keywordsJsonPointers) {
                var rules = this.RULES.all;
                metaSchema = JSON.parse(JSON.stringify(metaSchema));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keywordsJsonPointers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var jsonPointer = _step.value;
                        var segments = jsonPointer.split("/").slice(1); // first segment is an empty string
                        var keywords = metaSchema;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = segments[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var seg = _step1.value;
                                keywords = keywords[seg];
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        for(var key in rules){
                            var rule = rules[key];
                            if (typeof rule != "object") continue;
                            var $data = rule.definition.$data;
                            var schema = keywords[key];
                            if ($data && schema) keywords[key] = $cddc9f96c167754d$var$schemaOrData(schema);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return metaSchema;
            }
        },
        {
            key: "_removeAllSchemas",
            value: function _removeAllSchemas(schemas, regex) {
                for(var keyRef in schemas){
                    var sch = schemas[keyRef];
                    if (!regex || regex.test(keyRef)) {
                        if (typeof sch == "string") delete schemas[keyRef];
                        else if (sch && !sch.meta) {
                            this._cache.delete(sch.schema);
                            delete schemas[keyRef];
                        }
                    }
                }
            }
        },
        {
            key: "_addSchema",
            value: function _addSchema(schema, meta, baseId) {
                var validateSchema = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.opts.validateSchema, addSchema = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.opts.addUsedSchema;
                var id;
                var schemaId = this.opts.schemaId;
                if (typeof schema == "object") id = schema[schemaId];
                else {
                    if (this.opts.jtd) throw new Error("schema must be object");
                    else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
                }
                var sch = this._cache.get(schema);
                if (sch !== undefined) return sch;
                baseId = (0, $b6Wgf.normalizeId)(id || baseId);
                var localRefs = $b6Wgf.getSchemaRefs.call(this, schema, baseId);
                sch = new $glLnH.SchemaEnv({
                    schema: schema,
                    schemaId: schemaId,
                    meta: meta,
                    baseId: baseId,
                    localRefs: localRefs
                });
                this._cache.set(sch.schema, sch);
                if (addSchema && !baseId.startsWith("#")) {
                    // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
                    if (baseId) this._checkUnique(baseId);
                    this.refs[baseId] = sch;
                }
                if (validateSchema) this.validateSchema(schema, true);
                return sch;
            }
        },
        {
            key: "_checkUnique",
            value: function _checkUnique(id) {
                if (this.schemas[id] || this.refs[id]) throw new Error('schema with key or id "'.concat(id, '" already exists'));
            }
        },
        {
            key: "_compileSchemaEnv",
            value: function _compileSchemaEnv(sch) {
                if (sch.meta) this._compileMetaSchema(sch);
                else $glLnH.compileSchema.call(this, sch);
                /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
                return sch.validate;
            }
        },
        {
            key: "_compileMetaSchema",
            value: function _compileMetaSchema(sch) {
                var currentOpts = this.opts;
                this.opts = this._metaOpts;
                try {
                    $glLnH.compileSchema.call(this, sch);
                } finally{
                    this.opts = currentOpts;
                }
            }
        }
    ]);
    return Ajv;
}();
module.exports.default = $cddc9f96c167754d$var$Ajv;
$cddc9f96c167754d$var$Ajv.ValidationError = $aNuxA.default;
$cddc9f96c167754d$var$Ajv.MissingRefError = $j2ZXR.default;
function $cddc9f96c167754d$var$checkOptions(checkOpts, options, msg) {
    var log = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "error";
    for(var key in checkOpts){
        var opt = key;
        if (opt in options) this.logger[log]("".concat(msg, ": option ").concat(key, ". ").concat(checkOpts[opt]));
    }
}
function $cddc9f96c167754d$var$getSchEnv(keyRef) {
    keyRef = (0, $b6Wgf.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $cddc9f96c167754d$var$addInitialSchemas() {
    var optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(var key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $cddc9f96c167754d$var$addInitialFormats() {
    for(var name in this.opts.formats){
        var format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $cddc9f96c167754d$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(var keyword in defs){
        var def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $cddc9f96c167754d$var$getMetaSchemaOptions() {
    var metaOpts = (0, $hF4Ve._)({}, this.opts);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $cddc9f96c167754d$var$META_IGNORE_OPTIONS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var opt = _step.value;
            delete metaOpts[opt];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return metaOpts;
}
var $cddc9f96c167754d$var$noLogs = {
    log: function() {},
    warn: function() {},
    error: function() {}
};
function $cddc9f96c167754d$var$getLogger(logger) {
    if (logger === false) return $cddc9f96c167754d$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
var $cddc9f96c167754d$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $cddc9f96c167754d$var$checkKeyword(keyword, def) {
    var RULES = this.RULES;
    (0, $eKI5Q.eachItem)(keyword, function(kwd) {
        if (RULES.keywords[kwd]) throw new Error("Keyword ".concat(kwd, " is already defined"));
        if (!$cddc9f96c167754d$var$KEYWORD_NAME.test(kwd)) throw new Error("Keyword ".concat(kwd, " has invalid name"));
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $cddc9f96c167754d$var$addRule(keyword, definition, dataType) {
    var _this = this;
    var _a;
    var post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    var RULES = this.RULES;
    var ruleGroup = post ? RULES.post : RULES.rules.find(function(param) {
        var t = param.type;
        return t === dataType;
    });
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    var rule = {
        keyword: keyword,
        definition: (0, $cpUXF._)((0, $hF4Ve._)({}, definition), {
            type: (0, $96OdM.getJSONTypes)(definition.type),
            schemaType: (0, $96OdM.getJSONTypes)(definition.schemaType)
        })
    };
    if (definition.before) $cddc9f96c167754d$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach(function(kwd) {
        return _this.addKeyword(kwd);
    });
}
function $cddc9f96c167754d$var$addBeforeRule(ruleGroup, rule, before) {
    var i = ruleGroup.rules.findIndex(function(_rule) {
        return _rule.keyword === before;
    });
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn("rule ".concat(before, " is not defined"));
    }
}
function $cddc9f96c167754d$var$keywordMetaschema(def) {
    var metaSchema = def.metaSchema;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $cddc9f96c167754d$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
var $cddc9f96c167754d$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $cddc9f96c167754d$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $cddc9f96c167754d$var$$dataRef
        ]
    };
}

});
parcelRequire.register("em5FP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a7378571b3eb3843$export$7c398597f8905a1; });
function $a7378571b3eb3843$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a7378571b3eb3843$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a7378571b3eb3843$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a7378571b3eb3843$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("hF4Ve", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cdba156f56d9c0b3$export$581ff339ea0ba762; });

var $4IdPP = parcelRequire("4IdPP");
function $cdba156f56d9c0b3$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $4IdPP._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRequire.register("4IdPP", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $36e600d4bd8d4d58$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $36e600d4bd8d4d58$export$1e71eb4bef00f6b0; });
function $36e600d4bd8d4d58$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("cpUXF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $90a40128ed2aa990$export$4fa2f4023c9cbda5; });
function $90a40128ed2aa990$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $90a40128ed2aa990$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $90a40128ed2aa990$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRequire.register("nLPsB", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $04773ff0ebbb21bd$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $04773ff0ebbb21bd$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $04773ff0ebbb21bd$var$extendStatics = function extendStatics1(d, b) {
    $04773ff0ebbb21bd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $04773ff0ebbb21bd$var$extendStatics(d, b);
};
function $04773ff0ebbb21bd$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $04773ff0ebbb21bd$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $04773ff0ebbb21bd$export$18ce0697a983be9b = function __assign1() {
    $04773ff0ebbb21bd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04773ff0ebbb21bd$export$18ce0697a983be9b.apply(this, arguments);
};
function $04773ff0ebbb21bd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $04773ff0ebbb21bd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $04773ff0ebbb21bd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $04773ff0ebbb21bd$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $04773ff0ebbb21bd$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $04773ff0ebbb21bd$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $5F2Q2._)(x)) === "symbol" ? x : "".concat(x);
}
function $04773ff0ebbb21bd$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5F2Q2._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $04773ff0ebbb21bd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $04773ff0ebbb21bd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $04773ff0ebbb21bd$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $04773ff0ebbb21bd$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $04773ff0ebbb21bd$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $04773ff0ebbb21bd$export$45d3717a4c69092e(o, m, p);
}
function $04773ff0ebbb21bd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $04773ff0ebbb21bd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $04773ff0ebbb21bd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($04773ff0ebbb21bd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $04773ff0ebbb21bd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $04773ff0ebbb21bd$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $04773ff0ebbb21bd$export$10c90e4f7922046c(v) {
    return this instanceof $04773ff0ebbb21bd$export$10c90e4f7922046c ? (this.v = v, this) : new $04773ff0ebbb21bd$export$10c90e4f7922046c(v);
}
function $04773ff0ebbb21bd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $04773ff0ebbb21bd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $04773ff0ebbb21bd$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $04773ff0ebbb21bd$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $04773ff0ebbb21bd$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $04773ff0ebbb21bd$export$19a8beecd37a4c45 === "function" ? $04773ff0ebbb21bd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $04773ff0ebbb21bd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $04773ff0ebbb21bd$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $04773ff0ebbb21bd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $04773ff0ebbb21bd$export$45d3717a4c69092e(result, mod, k);
    }
    $04773ff0ebbb21bd$var$__setModuleDefault(result, mod);
    return result;
}
function $04773ff0ebbb21bd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $04773ff0ebbb21bd$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $04773ff0ebbb21bd$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $04773ff0ebbb21bd$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $04773ff0ebbb21bd$export$2e2bcd8739ae039 = {
    __extends: $04773ff0ebbb21bd$export$a8ba968b8961cb8a,
    __assign: $04773ff0ebbb21bd$export$18ce0697a983be9b,
    __rest: $04773ff0ebbb21bd$export$3c9a16f847548506,
    __decorate: $04773ff0ebbb21bd$export$29e00dfd3077644b,
    __param: $04773ff0ebbb21bd$export$d5ad3fd78186038f,
    __metadata: $04773ff0ebbb21bd$export$f1db080c865becb9,
    __awaiter: $04773ff0ebbb21bd$export$1050f835b63b671e,
    __generator: $04773ff0ebbb21bd$export$67ebef60e6f28a6,
    __createBinding: $04773ff0ebbb21bd$export$45d3717a4c69092e,
    __exportStar: $04773ff0ebbb21bd$export$f33643c0debef087,
    __values: $04773ff0ebbb21bd$export$19a8beecd37a4c45,
    __read: $04773ff0ebbb21bd$export$8d051b38c9118094,
    __spread: $04773ff0ebbb21bd$export$afc72e2116322959,
    __spreadArrays: $04773ff0ebbb21bd$export$6388937ca91ccae8,
    __spreadArray: $04773ff0ebbb21bd$export$1216008129fb82ed,
    __await: $04773ff0ebbb21bd$export$10c90e4f7922046c,
    __asyncGenerator: $04773ff0ebbb21bd$export$e427f37a30a4de9b,
    __asyncDelegator: $04773ff0ebbb21bd$export$bbd80228419bb833,
    __asyncValues: $04773ff0ebbb21bd$export$e3b29a3d6162315f,
    __makeTemplateObject: $04773ff0ebbb21bd$export$4fb47efe1390b86f,
    __importStar: $04773ff0ebbb21bd$export$c21735bcef00d192,
    __importDefault: $04773ff0ebbb21bd$export$da59b14a69baef04,
    __classPrivateFieldGet: $04773ff0ebbb21bd$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $04773ff0ebbb21bd$export$d40a35129aaff81f,
    __classPrivateFieldIn: $04773ff0ebbb21bd$export$81fdc39f203e4e04
};

});

parcelRequire.register("8n3O1", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");

var $bmZve = parcelRequire("bmZve");
"use strict";
function $61836c743e8f987f$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ", ",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject1() {
    var data = (0, $bmZve._)([
        '"use strict"; ',
        ""
    ]);
    $61836c743e8f987f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ", ",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject3() {
    var data = (0, $bmZve._)([
        ", ",
        "={}"
    ]);
    $61836c743e8f987f$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "{",
        '="", ',
        ", ",
        ", ",
        "=",
        "",
        "}={}"
    ]);
    $61836c743e8f987f$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        ".",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        ".",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        ".",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ".",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ".",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject10() {
    var data = (0, $bmZve._)([
        '""'
    ]);
    $61836c743e8f987f$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "undefined"
    ]);
    $61836c743e8f987f$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "undefined"
    ]);
    $61836c743e8f987f$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "{}"
    ]);
    $61836c743e8f987f$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "",
        ".evaluated"
    ]);
    $61836c743e8f987f$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject15() {
    var data = (0, $bmZve._)([
        "",
        ".dynamicProps"
    ]);
    $61836c743e8f987f$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject16() {
    var data = (0, $bmZve._)([
        "",
        ".props"
    ]);
    $61836c743e8f987f$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject17() {
    var data = (0, $bmZve._)([
        "undefined"
    ]);
    $61836c743e8f987f$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject18() {
    var data = (0, $bmZve._)([
        "",
        ".dynamicItems"
    ]);
    $61836c743e8f987f$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject19() {
    var data = (0, $bmZve._)([
        "",
        ".items"
    ]);
    $61836c743e8f987f$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject20() {
    var data = (0, $bmZve._)([
        "undefined"
    ]);
    $61836c743e8f987f$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject21() {
    var data = (0, $bmZve._)([
        "/*# sourceURL=",
        " */"
    ]);
    $61836c743e8f987f$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject22() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject23() {
    var data = (0, $bmZve._)([
        "",
        ".logger.log(",
        ")"
    ]);
    $61836c743e8f987f$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject24() {
    var data = (0, $bmZve._)([
        "",
        "/$comment"
    ]);
    $61836c743e8f987f$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject25() {
    var data = (0, $bmZve._)([
        "",
        ".opts.$comment(",
        ", ",
        ", ",
        ".schema)"
    ]);
    $61836c743e8f987f$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject26() {
    var data = (0, $bmZve._)([
        "",
        " === 0"
    ]);
    $61836c743e8f987f$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject27() {
    var data = (0, $bmZve._)([
        "new ",
        "(",
        ")"
    ]);
    $61836c743e8f987f$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject28() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $61836c743e8f987f$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject29() {
    var data = (0, $bmZve._)([
        "",
        " === 0"
    ]);
    $61836c743e8f987f$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject30() {
    var data = (0, $bmZve._)([
        "",
        ".props"
    ]);
    $61836c743e8f987f$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject31() {
    var data = (0, $bmZve._)([
        "",
        ".items"
    ]);
    $61836c743e8f987f$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject32() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject33() {
    var data = (0, $bmZve._)([
        "",
        " !== undefined && (",
        ")"
    ]);
    $61836c743e8f987f$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject34() {
    var data = (0, $bmZve._)([
        "",
        " === undefined"
    ]);
    $61836c743e8f987f$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject35() {
    var data = (0, $bmZve._)([
        "",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject36() {
    var data = (0, $bmZve._)([
        "!",
        "(",
        ")"
    ]);
    $61836c743e8f987f$var$_templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject37() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function $61836c743e8f987f$var$_templateObject38() {
    var data = (0, $bmZve._)([
        "",
        " && ",
        ""
    ]);
    $61836c743e8f987f$var$_templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $kkDks = parcelRequire("kkDks");

var $96OdM = parcelRequire("96OdM");

var $7qhzc = parcelRequire("7qhzc");

var $96OdM = parcelRequire("96OdM");

var $7mc8C = parcelRequire("7mc8C");

var $8sJhM = parcelRequire("8sJhM");

var $8ANrm = parcelRequire("8ANrm");

var $3Ar5a = parcelRequire("3Ar5a");

var $cuzEW = parcelRequire("cuzEW");

var $b6Wgf = parcelRequire("b6Wgf");

var $eKI5Q = parcelRequire("eKI5Q");

var $4Rc5N = parcelRequire("4Rc5N");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $61836c743e8f987f$var$validateFunctionCode(it) {
    if ($61836c743e8f987f$var$isSchemaObj(it)) {
        $61836c743e8f987f$var$checkKeywords(it);
        if ($61836c743e8f987f$var$schemaCxtHasRules(it)) {
            $61836c743e8f987f$var$topSchemaObjCode(it);
            return;
        }
    }
    $61836c743e8f987f$var$validateFunction(it, function() {
        return (0, $kkDks.topBoolOrEmptySchema)(it);
    });
}
module.exports.validateFunctionCode = $61836c743e8f987f$var$validateFunctionCode;
function $61836c743e8f987f$var$validateFunction(param, body) {
    var gen = param.gen, validateName = param.validateName, schema = param.schema, schemaEnv = param.schemaEnv, opts = param.opts;
    if (opts.code.es5) gen.func(validateName, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject(), $cuzEW.default.data, $cuzEW.default.valCxt), schemaEnv.$async, function() {
        gen.code((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject1(), $61836c743e8f987f$var$funcSourceUrl(schema, opts)));
        $61836c743e8f987f$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject2(), $cuzEW.default.data, $61836c743e8f987f$var$destructureValCxt(opts)), schemaEnv.$async, function() {
        return gen.code($61836c743e8f987f$var$funcSourceUrl(schema, opts)).code(body);
    });
}
function $61836c743e8f987f$var$destructureValCxt(opts) {
    return (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject4(), $cuzEW.default.instancePath, $cuzEW.default.parentData, $cuzEW.default.parentDataProperty, $cuzEW.default.rootData, $cuzEW.default.data, opts.dynamicRef ? (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject3(), $cuzEW.default.dynamicAnchors) : $3Ar5a.nil);
}
function $61836c743e8f987f$var$destructureValCxtES5(gen, opts) {
    gen.if($cuzEW.default.valCxt, function() {
        gen.var($cuzEW.default.instancePath, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject5(), $cuzEW.default.valCxt, $cuzEW.default.instancePath));
        gen.var($cuzEW.default.parentData, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject6(), $cuzEW.default.valCxt, $cuzEW.default.parentData));
        gen.var($cuzEW.default.parentDataProperty, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject7(), $cuzEW.default.valCxt, $cuzEW.default.parentDataProperty));
        gen.var($cuzEW.default.rootData, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject8(), $cuzEW.default.valCxt, $cuzEW.default.rootData));
        if (opts.dynamicRef) gen.var($cuzEW.default.dynamicAnchors, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject9(), $cuzEW.default.valCxt, $cuzEW.default.dynamicAnchors));
    }, function() {
        gen.var($cuzEW.default.instancePath, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject10()));
        gen.var($cuzEW.default.parentData, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject11()));
        gen.var($cuzEW.default.parentDataProperty, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject12()));
        gen.var($cuzEW.default.rootData, $cuzEW.default.data);
        if (opts.dynamicRef) gen.var($cuzEW.default.dynamicAnchors, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject13()));
    });
}
function $61836c743e8f987f$var$topSchemaObjCode(it) {
    var schema = it.schema, opts = it.opts, gen = it.gen;
    $61836c743e8f987f$var$validateFunction(it, function() {
        if (opts.$comment && schema.$comment) $61836c743e8f987f$var$commentKeyword(it);
        $61836c743e8f987f$var$checkNoDefault(it);
        gen.let($cuzEW.default.vErrors, null);
        gen.let($cuzEW.default.errors, 0);
        if (opts.unevaluated) $61836c743e8f987f$var$resetEvaluated(it);
        $61836c743e8f987f$var$typeAndKeywords(it);
        $61836c743e8f987f$var$returnResults(it);
    });
    return;
}
function $61836c743e8f987f$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    var gen = it.gen, validateName = it.validateName;
    it.evaluated = gen.const("evaluated", (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject14(), validateName));
    gen.if((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject15(), it.evaluated), function() {
        return gen.assign((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject16(), it.evaluated), (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject17()));
    });
    gen.if((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject18(), it.evaluated), function() {
        return gen.assign((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject19(), it.evaluated), (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject20()));
    });
}
function $61836c743e8f987f$var$funcSourceUrl(schema, opts) {
    var schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject21(), schId) : $3Ar5a.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $61836c743e8f987f$var$subschemaCode(it, valid) {
    if ($61836c743e8f987f$var$isSchemaObj(it)) {
        $61836c743e8f987f$var$checkKeywords(it);
        if ($61836c743e8f987f$var$schemaCxtHasRules(it)) {
            $61836c743e8f987f$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $kkDks.boolOrEmptySchema)(it, valid);
}
function $61836c743e8f987f$var$schemaCxtHasRules(param) {
    var schema = param.schema, self = param.self;
    if (typeof schema == "boolean") return !schema;
    for(var key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $61836c743e8f987f$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $61836c743e8f987f$var$subSchemaObjCode(it, valid) {
    var schema = it.schema, gen = it.gen, opts = it.opts;
    if (opts.$comment && schema.$comment) $61836c743e8f987f$var$commentKeyword(it);
    $61836c743e8f987f$var$updateContext(it);
    $61836c743e8f987f$var$checkAsyncSchema(it);
    var errsCount = gen.const("_errs", $cuzEW.default.errors);
    $61836c743e8f987f$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject22(), errsCount, $cuzEW.default.errors));
}
function $61836c743e8f987f$var$checkKeywords(it) {
    (0, $eKI5Q.checkUnknownRules)(it);
    $61836c743e8f987f$var$checkRefsAndKeywords(it);
}
function $61836c743e8f987f$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $61836c743e8f987f$var$schemaKeywords(it, [], false, errsCount);
    var types = (0, $96OdM.getSchemaTypes)(it.schema);
    var checkedTypes = (0, $96OdM.coerceAndCheckDataType)(it, types);
    $61836c743e8f987f$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $61836c743e8f987f$var$checkRefsAndKeywords(it) {
    var schema = it.schema, errSchemaPath = it.errSchemaPath, opts = it.opts, self = it.self;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $eKI5Q.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn('$ref: keywords ignored in schema at path "'.concat(errSchemaPath, '"'));
}
function $61836c743e8f987f$var$checkNoDefault(it) {
    var schema = it.schema, opts = it.opts;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $eKI5Q.checkStrictMode)(it, "default is ignored in the schema root");
}
function $61836c743e8f987f$var$updateContext(it) {
    var schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $b6Wgf.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $61836c743e8f987f$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $61836c743e8f987f$var$commentKeyword(param) {
    var gen = param.gen, schemaEnv = param.schemaEnv, schema = param.schema, errSchemaPath = param.errSchemaPath, opts = param.opts;
    var msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject23(), $cuzEW.default.self, msg));
    else if (typeof opts.$comment == "function") {
        var schemaPath = (0, $3Ar5a.str)($61836c743e8f987f$var$_templateObject24(), errSchemaPath);
        var rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject25(), $cuzEW.default.self, msg, schemaPath, rootName));
    }
}
function $61836c743e8f987f$var$returnResults(it) {
    var gen = it.gen, schemaEnv = it.schemaEnv, validateName = it.validateName, ValidationError = it.ValidationError, opts = it.opts;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject26(), $cuzEW.default.errors), function() {
        return gen.return($cuzEW.default.data);
    }, function() {
        return gen.throw((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject27(), ValidationError, $cuzEW.default.vErrors));
    });
    else {
        gen.assign((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject28(), validateName), $cuzEW.default.vErrors);
        if (opts.unevaluated) $61836c743e8f987f$var$assignEvaluated(it);
        gen.return((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject29(), $cuzEW.default.errors));
    }
}
function $61836c743e8f987f$var$assignEvaluated(param) {
    var gen = param.gen, evaluated = param.evaluated, props = param.props, items = param.items;
    if (props instanceof $3Ar5a.Name) gen.assign((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject30(), evaluated), props);
    if (items instanceof $3Ar5a.Name) gen.assign((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject31(), evaluated), items);
}
function $61836c743e8f987f$var$schemaKeywords(it, types, typeErrors, errsCount) {
    var groupKeywords = function groupKeywords(group) {
        if (!(0, $7qhzc.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $96OdM.checkDataType)(group.type, data, opts.strictNumbers));
            $61836c743e8f987f$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $96OdM.reportTypeError)(it);
            }
            gen.endIf();
        } else $61836c743e8f987f$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject32(), $cuzEW.default.errors, errsCount || 0));
    };
    var gen = it.gen, schema = it.schema, data = it.data, allErrors = it.allErrors, opts = it.opts, self = it.self;
    var RULES = self.RULES;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $eKI5Q.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(function() {
            return $61836c743e8f987f$var$keywordCode(it, "$ref", RULES.all.$ref.definition);
        }); // TODO typecast
        return;
    }
    if (!opts.jtd) $61836c743e8f987f$var$checkStrictTypes(it, types);
    gen.block(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = RULES.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var group = _step.value;
                groupKeywords(group);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        groupKeywords(RULES.post);
    });
}
function $61836c743e8f987f$var$iterateKeywords(it, group) {
    var gen = it.gen, schema = it.schema, useDefaults = it.opts.useDefaults;
    if (useDefaults) (0, $7mc8C.assignDefaults)(it, group.type);
    gen.block(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = group.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rule = _step.value;
                if ((0, $7qhzc.shouldUseRule)(schema, rule)) $61836c743e8f987f$var$keywordCode(it, rule.keyword, rule.definition, group.type);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $61836c743e8f987f$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $61836c743e8f987f$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $61836c743e8f987f$var$checkMultipleTypes(it, types);
    $61836c743e8f987f$var$checkKeywordTypes(it, it.dataTypes);
}
function $61836c743e8f987f$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach(function(t) {
        if (!$61836c743e8f987f$var$includesType(it.dataTypes, t)) $61836c743e8f987f$var$strictTypesError(it, 'type "'.concat(t, '" not allowed by context "').concat(it.dataTypes.join(","), '"'));
    });
    $61836c743e8f987f$var$narrowSchemaTypes(it, types);
}
function $61836c743e8f987f$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $61836c743e8f987f$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $61836c743e8f987f$var$checkKeywordTypes(it, ts) {
    var rules = it.self.RULES.all;
    for(var keyword in rules){
        var rule = rules[keyword];
        if (typeof rule == "object" && (0, $7qhzc.shouldUseRule)(it.schema, rule)) {
            var type = rule.definition.type;
            if (type.length && !type.some(function(t) {
                return $61836c743e8f987f$var$hasApplicableType(ts, t);
            })) $61836c743e8f987f$var$strictTypesError(it, 'missing type "'.concat(type.join(","), '" for keyword "').concat(keyword, '"'));
        }
    }
}
function $61836c743e8f987f$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $61836c743e8f987f$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $61836c743e8f987f$var$narrowSchemaTypes(it, withTypes) {
    var ts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = it.dataTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if ($61836c743e8f987f$var$includesType(withTypes, t)) ts.push(t);
            else if (withTypes.includes("integer") && t === "number") ts.push("integer");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    it.dataTypes = ts;
}
function $61836c743e8f987f$var$strictTypesError(it, msg) {
    var schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ' at "'.concat(schemaPath, '" (strictTypes)');
    (0, $eKI5Q.checkStrictMode)(it, msg, it.opts.strictTypes);
}
var $61836c743e8f987f$var$KeywordCxt = /*#__PURE__*/ function() {
    function KeywordCxt(it, def, keyword) {
        (0, $h5oKP._)(this, KeywordCxt);
        (0, $8sJhM.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $eKI5Q.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $61836c743e8f987f$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $8sJhM.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error("".concat(keyword, " value must be ").concat(JSON.stringify(def.schemaType)));
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $cuzEW.default.errors);
    }
    (0, $85qwq._)(KeywordCxt, [
        {
            key: "result",
            value: function result(condition, successAction, failAction) {
                this.failResult((0, $3Ar5a.not)(condition), successAction, failAction);
            }
        },
        {
            key: "failResult",
            value: function failResult(condition, successAction, failAction) {
                this.gen.if(condition);
                if (failAction) failAction();
                else this.error();
                if (successAction) {
                    this.gen.else();
                    successAction();
                    if (this.allErrors) this.gen.endIf();
                } else if (this.allErrors) this.gen.endIf();
                else this.gen.else();
            }
        },
        {
            key: "pass",
            value: function pass(condition, failAction) {
                this.failResult((0, $3Ar5a.not)(condition), undefined, failAction);
            }
        },
        {
            key: "fail",
            value: function fail(condition) {
                if (condition === undefined) {
                    this.error();
                    if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
                    return;
                }
                this.gen.if(condition);
                this.error();
                if (this.allErrors) this.gen.endIf();
                else this.gen.else();
            }
        },
        {
            key: "fail$data",
            value: function fail$data(condition) {
                if (!this.$data) return this.fail(condition);
                var schemaCode = this.schemaCode;
                this.fail((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject33(), schemaCode, (0, $3Ar5a.or)(this.invalid$data(), condition)));
            }
        },
        {
            key: "error",
            value: function error(append, errorParams, errorPaths) {
                if (errorParams) {
                    this.setParams(errorParams);
                    this._error(append, errorPaths);
                    this.setParams({});
                    return;
                }
                this._error(append, errorPaths);
            }
        },
        {
            key: "_error",
            value: function _error(append, errorPaths) {
                (append ? $4Rc5N.reportExtraError : $4Rc5N.reportError)(this, this.def.error, errorPaths);
            }
        },
        {
            key: "$dataError",
            value: function $dataError() {
                (0, $4Rc5N.reportError)(this, this.def.$dataError || $4Rc5N.keyword$DataError);
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
                (0, $4Rc5N.resetErrorsCount)(this.gen, this.errsCount);
            }
        },
        {
            key: "ok",
            value: function ok(cond) {
                if (!this.allErrors) this.gen.if(cond);
            }
        },
        {
            key: "setParams",
            value: function setParams(obj, assign) {
                if (assign) Object.assign(this.params, obj);
                else this.params = obj;
            }
        },
        {
            key: "block$data",
            value: function block$data(valid, codeBlock) {
                var $dataValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $3Ar5a.nil;
                var _this = this;
                this.gen.block(function() {
                    _this.check$data(valid, $dataValid);
                    codeBlock();
                });
            }
        },
        {
            key: "check$data",
            value: function check$data() {
                var valid = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $3Ar5a.nil, $dataValid = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3Ar5a.nil;
                if (!this.$data) return;
                var _this = this, gen = _this.gen, schemaCode = _this.schemaCode, schemaType = _this.schemaType, def = _this.def;
                gen.if((0, $3Ar5a.or)((0, $3Ar5a._)($61836c743e8f987f$var$_templateObject34(), schemaCode), $dataValid));
                if (valid !== $3Ar5a.nil) gen.assign(valid, true);
                if (schemaType.length || def.validateSchema) {
                    gen.elseIf(this.invalid$data());
                    this.$dataError();
                    if (valid !== $3Ar5a.nil) gen.assign(valid, false);
                }
                gen.else();
            }
        },
        {
            key: "invalid$data",
            value: function invalid$data() {
                var wrong$DataType = function wrong$DataType() {
                    if (schemaType.length) {
                        /* istanbul ignore if */ if (!(schemaCode instanceof $3Ar5a.Name)) throw new Error("ajv implementation error");
                        var st = Array.isArray(schemaType) ? schemaType : [
                            schemaType
                        ];
                        return (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject35(), (0, $96OdM.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $96OdM.DataType.Wrong));
                    }
                    return $3Ar5a.nil;
                };
                var invalid$DataSchema = function invalid$DataSchema() {
                    if (def.validateSchema) {
                        var validateSchemaRef = gen.scopeValue("validate$data", {
                            ref: def.validateSchema
                        }); // TODO value.code for standalone
                        return (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject36(), validateSchemaRef, schemaCode);
                    }
                    return $3Ar5a.nil;
                };
                var _this = this, gen = _this.gen, schemaCode = _this.schemaCode, schemaType = _this.schemaType, def = _this.def, it = _this.it;
                return (0, $3Ar5a.or)(wrong$DataType(), invalid$DataSchema());
            }
        },
        {
            key: "subschema",
            value: function subschema(appl, valid) {
                var subschema = (0, $8ANrm.getSubschema)(this.it, appl);
                (0, $8ANrm.extendSubschemaData)(subschema, this.it, appl);
                (0, $8ANrm.extendSubschemaMode)(subschema, appl);
                var nextContext = (0, $cpUXF._)((0, $hF4Ve._)({}, this.it, subschema), {
                    items: undefined,
                    props: undefined
                });
                $61836c743e8f987f$var$subschemaCode(nextContext, valid);
                return nextContext;
            }
        },
        {
            key: "mergeEvaluated",
            value: function mergeEvaluated(schemaCxt, toName) {
                var _this = this, it = _this.it, gen = _this.gen;
                if (!it.opts.unevaluated) return;
                if (it.props !== true && schemaCxt.props !== undefined) it.props = $eKI5Q.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
                if (it.items !== true && schemaCxt.items !== undefined) it.items = $eKI5Q.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
            }
        },
        {
            key: "mergeValidEvaluated",
            value: function mergeValidEvaluated(schemaCxt, valid) {
                var _this = this;
                var _this1 = this, it = _this1.it, gen = _this1.gen;
                if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
                    gen.if(valid, function() {
                        return _this.mergeEvaluated(schemaCxt, $3Ar5a.Name);
                    });
                    return true;
                }
            }
        }
    ]);
    return KeywordCxt;
}();
module.exports.KeywordCxt = $61836c743e8f987f$var$KeywordCxt;
function $61836c743e8f987f$var$keywordCode(it, keyword, def, ruleType) {
    var cxt = new $61836c743e8f987f$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $8sJhM.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $8sJhM.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $8sJhM.funcKeywordCode)(cxt, def);
}
var $61836c743e8f987f$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var $61836c743e8f987f$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $61836c743e8f987f$var$getData($data, param) {
    var dataLevel = param.dataLevel, dataNames = param.dataNames, dataPathArr = param.dataPathArr;
    var errorMsg = function errorMsg(pointerType, up) {
        return "Cannot access ".concat(pointerType, " ").concat(up, " levels up, current level is ").concat(dataLevel);
    };
    var jsonPointer;
    var data;
    if ($data === "") return $cuzEW.default.rootData;
    if ($data[0] === "/") {
        if (!$61836c743e8f987f$var$JSON_POINTER.test($data)) throw new Error("Invalid JSON-pointer: ".concat($data));
        jsonPointer = $data;
        data = $cuzEW.default.rootData;
    } else {
        var matches = $61836c743e8f987f$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error("Invalid JSON-pointer: ".concat($data));
        var up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    var expr = data;
    var segments = jsonPointer.split("/");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            if (segment) {
                data = (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject37(), data, (0, $3Ar5a.getProperty)((0, $eKI5Q.unescapeJsonPointer)(segment)));
                expr = (0, $3Ar5a._)($61836c743e8f987f$var$_templateObject38(), expr, data);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return expr;
}
module.exports.getData = $61836c743e8f987f$var$getData;

});
parcelRequire.register("bmZve", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $847174f7f5edb745$export$263b15b19e6ed8f; });
function $847174f7f5edb745$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRequire.register("kkDks", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $ecd42ecd4e35be01$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $ecd42ecd4e35be01$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $4Rc5N = parcelRequire("4Rc5N");

var $3Ar5a = parcelRequire("3Ar5a");

var $cuzEW = parcelRequire("cuzEW");
var $ecd42ecd4e35be01$var$boolError = {
    message: "boolean schema is false"
};
function $ecd42ecd4e35be01$var$topBoolOrEmptySchema(it) {
    var gen = it.gen, schema = it.schema, validateName = it.validateName;
    if (schema === false) $ecd42ecd4e35be01$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($cuzEW.default.data);
    else {
        gen.assign((0, $3Ar5a._)($ecd42ecd4e35be01$var$_templateObject(), validateName), null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $ecd42ecd4e35be01$var$topBoolOrEmptySchema;
function $ecd42ecd4e35be01$var$boolOrEmptySchema(it, valid) {
    var gen = it.gen, schema = it.schema;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $ecd42ecd4e35be01$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $ecd42ecd4e35be01$var$boolOrEmptySchema;
function $ecd42ecd4e35be01$var$falseSchemaError(it, overrideAllErrors) {
    var gen = it.gen, data = it.data;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    var cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $4Rc5N.reportError)(cxt, $ecd42ecd4e35be01$var$boolError, undefined, overrideAllErrors);
}

});
parcelRequire.register("4Rc5N", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");
"use strict";
function $38957dfcea6a709e$var$_templateObject() {
    var data = (0, $bmZve._)([
        'must pass "',
        '" keyword validation'
    ]);
    $38957dfcea6a709e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject1() {
    var data = (0, $bmZve._)([
        '"',
        '" keyword must be ',
        " ($data)"
    ]);
    $38957dfcea6a709e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject2() {
    var data = (0, $bmZve._)([
        '"',
        '" keyword is invalid ($data)'
    ]);
    $38957dfcea6a709e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "[",
        "]"
    ]);
    $38957dfcea6a709e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " !== null"
    ]);
    $38957dfcea6a709e$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $38957dfcea6a709e$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $38957dfcea6a709e$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        ".instancePath === undefined"
    ]);
    $38957dfcea6a709e$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ".instancePath"
    ]);
    $38957dfcea6a709e$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ".schemaPath"
    ]);
    $38957dfcea6a709e$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "",
        "/",
        ""
    ]);
    $38957dfcea6a709e$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        ".schema"
    ]);
    $38957dfcea6a709e$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "",
        ".data"
    ]);
    $38957dfcea6a709e$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "",
        " === null"
    ]);
    $38957dfcea6a709e$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "[",
        "]"
    ]);
    $38957dfcea6a709e$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject15() {
    var data = (0, $bmZve._)([
        "",
        ".push(",
        ")"
    ]);
    $38957dfcea6a709e$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject16() {
    var data = (0, $bmZve._)([
        "",
        "++"
    ]);
    $38957dfcea6a709e$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject17() {
    var data = (0, $bmZve._)([
        "new ",
        "(",
        ")"
    ]);
    $38957dfcea6a709e$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject18() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $38957dfcea6a709e$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject19() {
    var data = (0, $bmZve._)([
        "{}"
    ]);
    $38957dfcea6a709e$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject20() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $38957dfcea6a709e$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject21() {
    var data = (0, $bmZve._)([
        "",
        "/",
        ""
    ]);
    $38957dfcea6a709e$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject22() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $38957dfcea6a709e$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject23() {
    var data = (0, $bmZve._)([
        "{}"
    ]);
    $38957dfcea6a709e$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $38957dfcea6a709e$var$_templateObject24() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $38957dfcea6a709e$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $cuzEW = parcelRequire("cuzEW");
module.exports.keywordError = {
    message: function(param) {
        var keyword = param.keyword;
        return (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject(), keyword);
    }
};
module.exports.keyword$DataError = {
    message: function(param) {
        var keyword = param.keyword, schemaType = param.schemaType;
        return schemaType ? (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject1(), keyword, schemaType) : (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject2(), keyword);
    }
};
function $38957dfcea6a709e$var$reportError(cxt) {
    var error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module.exports.keywordError, errorPaths = arguments.length > 2 ? arguments[2] : void 0, overrideAllErrors = arguments.length > 3 ? arguments[3] : void 0;
    var it = cxt.it;
    var gen = it.gen, compositeRule = it.compositeRule, allErrors = it.allErrors;
    var errObj = $38957dfcea6a709e$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $38957dfcea6a709e$var$addError(gen, errObj);
    else $38957dfcea6a709e$var$returnErrors(it, (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject3(), errObj));
}
module.exports.reportError = $38957dfcea6a709e$var$reportError;
function $38957dfcea6a709e$var$reportExtraError(cxt) {
    var error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module.exports.keywordError, errorPaths = arguments.length > 2 ? arguments[2] : void 0;
    var it = cxt.it;
    var gen = it.gen, compositeRule = it.compositeRule, allErrors = it.allErrors;
    var errObj = $38957dfcea6a709e$var$errorObjectCode(cxt, error, errorPaths);
    $38957dfcea6a709e$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $38957dfcea6a709e$var$returnErrors(it, $cuzEW.default.vErrors);
}
module.exports.reportExtraError = $38957dfcea6a709e$var$reportExtraError;
function $38957dfcea6a709e$var$resetErrorsCount(gen, errsCount) {
    gen.assign($cuzEW.default.errors, errsCount);
    gen.if((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject4(), $cuzEW.default.vErrors), function() {
        return gen.if(errsCount, function() {
            return gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject5(), $cuzEW.default.vErrors), errsCount);
        }, function() {
            return gen.assign($cuzEW.default.vErrors, null);
        });
    });
}
module.exports.resetErrorsCount = $38957dfcea6a709e$var$resetErrorsCount;
function $38957dfcea6a709e$var$extendErrors(param) {
    var gen = param.gen, keyword = param.keyword, schemaValue = param.schemaValue, data = param.data, errsCount = param.errsCount, it = param.it;
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    var err = gen.name("err");
    gen.forRange("i", errsCount, $cuzEW.default.errors, function(i) {
        gen.const(err, (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject6(), $cuzEW.default.vErrors, i));
        gen.if((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject7(), err), function() {
            return gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject8(), err), (0, $3Ar5a.strConcat)($cuzEW.default.instancePath, it.errorPath));
        });
        gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject9(), err), (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject10(), it.errSchemaPath, keyword));
        if (it.opts.verbose) {
            gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject11(), err), schemaValue);
            gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject12(), err), data);
        }
    });
}
module.exports.extendErrors = $38957dfcea6a709e$var$extendErrors;
function $38957dfcea6a709e$var$addError(gen, errObj) {
    var err = gen.const("err", errObj);
    gen.if((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject13(), $cuzEW.default.vErrors), function() {
        return gen.assign($cuzEW.default.vErrors, (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject14(), err));
    }, (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject15(), $cuzEW.default.vErrors, err));
    gen.code((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject16(), $cuzEW.default.errors));
}
function $38957dfcea6a709e$var$returnErrors(it, errs) {
    var gen = it.gen, validateName = it.validateName, schemaEnv = it.schemaEnv;
    if (schemaEnv.$async) gen.throw((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject17(), it.ValidationError, errs));
    else {
        gen.assign((0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject18(), validateName), errs);
        gen.return(false);
    }
}
var $38957dfcea6a709e$var$E = {
    keyword: new $3Ar5a.Name("keyword"),
    schemaPath: new $3Ar5a.Name("schemaPath"),
    params: new $3Ar5a.Name("params"),
    propertyName: new $3Ar5a.Name("propertyName"),
    message: new $3Ar5a.Name("message"),
    schema: new $3Ar5a.Name("schema"),
    parentSchema: new $3Ar5a.Name("parentSchema")
};
function $38957dfcea6a709e$var$errorObjectCode(cxt, error, errorPaths) {
    var createErrors = cxt.it.createErrors;
    if (createErrors === false) return (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject19());
    return $38957dfcea6a709e$var$errorObject(cxt, error, errorPaths);
}
function $38957dfcea6a709e$var$errorObject(cxt, error) {
    var errorPaths = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _gen;
    var gen = cxt.gen, it = cxt.it;
    var keyValues = [
        $38957dfcea6a709e$var$errorInstancePath(it, errorPaths),
        $38957dfcea6a709e$var$errorSchemaPath(cxt, errorPaths)
    ];
    $38957dfcea6a709e$var$extraErrorProps(cxt, error, keyValues);
    return (_gen = gen).object.apply(_gen, (0, $h9dQc._)(keyValues));
}
function $38957dfcea6a709e$var$errorInstancePath(param, param1) {
    var errorPath = param.errorPath, instancePath = param1.instancePath;
    var instPath = instancePath ? (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject20(), errorPath, (0, $eKI5Q.getErrorPath)(instancePath, $eKI5Q.Type.Str)) : errorPath;
    return [
        $cuzEW.default.instancePath,
        (0, $3Ar5a.strConcat)($cuzEW.default.instancePath, instPath)
    ];
}
function $38957dfcea6a709e$var$errorSchemaPath(param, param1) {
    var keyword = param.keyword, errSchemaPath = param.it.errSchemaPath, schemaPath = param1.schemaPath, parentSchema = param1.parentSchema;
    var schPath = parentSchema ? errSchemaPath : (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject21(), errSchemaPath, keyword);
    if (schemaPath) schPath = (0, $3Ar5a.str)($38957dfcea6a709e$var$_templateObject22(), schPath, (0, $eKI5Q.getErrorPath)(schemaPath, $eKI5Q.Type.Str));
    return [
        $38957dfcea6a709e$var$E.schemaPath,
        schPath
    ];
}
function $38957dfcea6a709e$var$extraErrorProps(cxt, param, keyValues) {
    var params = param.params, message = param.message;
    var keyword = cxt.keyword, data = cxt.data, schemaValue = cxt.schemaValue, it = cxt.it;
    var opts = it.opts, propertyName = it.propertyName, topSchemaRef = it.topSchemaRef, schemaPath = it.schemaPath;
    keyValues.push([
        $38957dfcea6a709e$var$E.keyword,
        keyword
    ], [
        $38957dfcea6a709e$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject23())
    ]);
    if (opts.messages) keyValues.push([
        $38957dfcea6a709e$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $38957dfcea6a709e$var$E.schema,
        schemaValue
    ], [
        $38957dfcea6a709e$var$E.parentSchema,
        (0, $3Ar5a._)($38957dfcea6a709e$var$_templateObject24(), topSchemaRef, schemaPath)
    ], [
        $cuzEW.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $38957dfcea6a709e$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRequire.register("h9dQc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7be0373b872f7eb$export$1b5e630bc3aea29f; });

var $6LyaF = parcelRequire("6LyaF");

var $cnoDh = parcelRequire("cnoDh");

var $dCxy5 = parcelRequire("dCxy5");

var $4OOPV = parcelRequire("4OOPV");
function $c7be0373b872f7eb$export$1b5e630bc3aea29f(arr) {
    return (0, $6LyaF._array_without_holes)(arr) || (0, $cnoDh._iterable_to_array)(arr) || (0, $4OOPV._unsupported_iterable_to_array)(arr) || (0, $dCxy5._non_iterable_spread)();
}

});
parcelRequire.register("6LyaF", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $4ed1a37f83782a31$export$7e0947b5ad3404e2; });

var $bfKX2 = parcelRequire("bfKX2");
function $4ed1a37f83782a31$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $bfKX2._array_like_to_array)(arr);
}

});
parcelRequire.register("bfKX2", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $831583fb295916bd$export$79e617b1955a2616; });
function $831583fb295916bd$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("cnoDh", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $902abd8282f3c26e$export$1eb58a6e75231000; });
function $902abd8282f3c26e$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("dCxy5", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $9ea8d913eddd628f$export$e6f3c4780d19eb2b; });
function $9ea8d913eddd628f$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("4OOPV", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $382344016ce33782$export$a5be06335b3a083c; });

var $bfKX2 = parcelRequire("bfKX2");
function $382344016ce33782$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $bfKX2._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $bfKX2._array_like_to_array)(o, minLen);
}

});


parcelRequire.register("3Ar5a", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $b0PmO = parcelRequire("b0PmO");

var $l9BwU = parcelRequire("l9BwU");

var $fsOl6 = parcelRequire("fsOl6");

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");

var $2MVSR = parcelRequire("2MVSR");

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");

var $karXd = parcelRequire("karXd");

var $COJlH = parcelRequire("COJlH");
"use strict";
function $29c9bde2ffc5ac8c$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $29c9bde2ffc5ac8c$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $29c9bde2ffc5ac8c$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "Object.keys(",
        ")"
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $29c9bde2ffc5ac8c$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "!",
        ""
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $29c9bde2ffc5ac8c$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " ",
        " ",
        ""
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $29c9bde2ffc5ac8c$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "(",
        ")"
    ]);
    $29c9bde2ffc5ac8c$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $6go2u = parcelRequire("6go2u");

var $6MUvF = parcelRequire("6MUvF");

var $6go2u = parcelRequire("6go2u");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function get() {
        return $6go2u._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function get() {
        return $6go2u.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function get() {
        return $6go2u.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function get() {
        return $6go2u.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function get() {
        return $6go2u.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function get() {
        return $6go2u.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function get() {
        return $6go2u.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function get() {
        return $6go2u.Name;
    }
});

var $6MUvF = parcelRequire("6MUvF");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function get() {
        return $6MUvF.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function get() {
        return $6MUvF.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function get() {
        return $6MUvF.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function get() {
        return $6MUvF.varKinds;
    }
});
module.exports.operators = {
    GT: new $6go2u._Code(">"),
    GTE: new $6go2u._Code(">="),
    LT: new $6go2u._Code("<"),
    LTE: new $6go2u._Code("<="),
    EQ: new $6go2u._Code("==="),
    NEQ: new $6go2u._Code("!=="),
    NOT: new $6go2u._Code("!"),
    OR: new $6go2u._Code("||"),
    AND: new $6go2u._Code("&&"),
    ADD: new $6go2u._Code("+")
};
var $29c9bde2ffc5ac8c$var$Node = /*#__PURE__*/ function() {
    function Node() {
        (0, $h5oKP._)(this, Node);
    }
    (0, $85qwq._)(Node, [
        {
            key: "optimizeNodes",
            value: function optimizeNodes() {
                return this;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(_names, _constants) {
                return this;
            }
        }
    ]);
    return Node;
}();
var $29c9bde2ffc5ac8c$var$Def = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(Def, Node);
    var _super = (0, $COJlH._)(Def);
    function Def(varKind, name, rhs) {
        (0, $h5oKP._)(this, Def);
        var _this;
        _this = _super.call(this);
        _this.varKind = varKind;
        _this.name = name;
        _this.rhs = rhs;
        return _this;
    }
    (0, $85qwq._)(Def, [
        {
            key: "render",
            value: function render(param) {
                var es5 = param.es5, _n = param._n;
                var varKind = es5 ? $6MUvF.varKinds.var : this.varKind;
                var rhs = this.rhs === undefined ? "" : " = ".concat(this.rhs);
                return "".concat(varKind, " ").concat(this.name).concat(rhs, ";") + _n;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                if (!names[this.name.str]) return;
                if (this.rhs) this.rhs = $29c9bde2ffc5ac8c$var$optimizeExpr(this.rhs, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                return this.rhs instanceof $6go2u._CodeOrName ? this.rhs.names : {};
            }
        }
    ]);
    return Def;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$Assign = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(Assign, Node);
    var _super = (0, $COJlH._)(Assign);
    function Assign(lhs, rhs, sideEffects) {
        (0, $h5oKP._)(this, Assign);
        var _this;
        _this = _super.call(this);
        _this.lhs = lhs;
        _this.rhs = rhs;
        _this.sideEffects = sideEffects;
        return _this;
    }
    (0, $85qwq._)(Assign, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                return "".concat(this.lhs, " = ").concat(this.rhs, ";") + _n;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                if (this.lhs instanceof $6go2u.Name && !names[this.lhs.str] && !this.sideEffects) return;
                this.rhs = $29c9bde2ffc5ac8c$var$optimizeExpr(this.rhs, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                var names = this.lhs instanceof $6go2u.Name ? {} : (0, $hF4Ve._)({}, this.lhs.names);
                return $29c9bde2ffc5ac8c$var$addExprNames(names, this.rhs);
            }
        }
    ]);
    return Assign;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$AssignOp = /*#__PURE__*/ function(Assign) {
    (0, $fsOl6._)(AssignOp, Assign);
    var _super = (0, $COJlH._)(AssignOp);
    function AssignOp(lhs, op, rhs, sideEffects) {
        (0, $h5oKP._)(this, AssignOp);
        var _this;
        _this = _super.call(this, lhs, rhs, sideEffects);
        _this.op = op;
        return _this;
    }
    (0, $85qwq._)(AssignOp, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                return "".concat(this.lhs, " ").concat(this.op, "= ").concat(this.rhs, ";") + _n;
            }
        }
    ]);
    return AssignOp;
}($29c9bde2ffc5ac8c$var$Assign);
var $29c9bde2ffc5ac8c$var$Label = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(Label, Node);
    var _super = (0, $COJlH._)(Label);
    function Label(label) {
        (0, $h5oKP._)(this, Label);
        var _this;
        _this = _super.call(this);
        _this.label = label;
        _this.names = {};
        return _this;
    }
    (0, $85qwq._)(Label, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                return "".concat(this.label, ":") + _n;
            }
        }
    ]);
    return Label;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$Break = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(Break, Node);
    var _super = (0, $COJlH._)(Break);
    function Break(label) {
        (0, $h5oKP._)(this, Break);
        var _this;
        _this = _super.call(this);
        _this.label = label;
        _this.names = {};
        return _this;
    }
    (0, $85qwq._)(Break, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                var label = this.label ? " ".concat(this.label) : "";
                return "break".concat(label, ";") + _n;
            }
        }
    ]);
    return Break;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$Throw = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(Throw, Node);
    var _super = (0, $COJlH._)(Throw);
    function Throw(error) {
        (0, $h5oKP._)(this, Throw);
        var _this;
        _this = _super.call(this);
        _this.error = error;
        return _this;
    }
    (0, $85qwq._)(Throw, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                return "throw ".concat(this.error, ";") + _n;
            }
        },
        {
            key: "names",
            get: function get() {
                return this.error.names;
            }
        }
    ]);
    return Throw;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$AnyCode = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(AnyCode, Node);
    var _super = (0, $COJlH._)(AnyCode);
    function AnyCode(code) {
        (0, $h5oKP._)(this, AnyCode);
        var _this;
        _this = _super.call(this);
        _this.code = code;
        return _this;
    }
    (0, $85qwq._)(AnyCode, [
        {
            key: "render",
            value: function render(param) {
                var _n = param._n;
                return "".concat(this.code, ";") + _n;
            }
        },
        {
            key: "optimizeNodes",
            value: function optimizeNodes() {
                return "".concat(this.code) ? this : undefined;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                this.code = $29c9bde2ffc5ac8c$var$optimizeExpr(this.code, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                return this.code instanceof $6go2u._CodeOrName ? this.code.names : {};
            }
        }
    ]);
    return AnyCode;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$ParentNode = /*#__PURE__*/ function(Node) {
    (0, $fsOl6._)(ParentNode, Node);
    var _super = (0, $COJlH._)(ParentNode);
    function ParentNode() {
        var nodes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $h5oKP._)(this, ParentNode);
        var _this;
        _this = _super.call(this);
        _this.nodes = nodes;
        return _this;
    }
    (0, $85qwq._)(ParentNode, [
        {
            key: "render",
            value: function render(opts) {
                return this.nodes.reduce(function(code, n) {
                    return code + n.render(opts);
                }, "");
            }
        },
        {
            key: "optimizeNodes",
            value: function optimizeNodes() {
                var nodes = this.nodes;
                var i = nodes.length;
                while(i--){
                    var _nodes;
                    var n = nodes[i].optimizeNodes();
                    if (Array.isArray(n)) (_nodes = nodes).splice.apply(_nodes, [
                        i,
                        1
                    ].concat((0, $h9dQc._)(n)));
                    else if (n) nodes[i] = n;
                    else nodes.splice(i, 1);
                }
                return nodes.length > 0 ? this : undefined;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                var nodes = this.nodes;
                var i = nodes.length;
                while(i--){
                    // iterating backwards improves 1-pass optimization
                    var n = nodes[i];
                    if (n.optimizeNames(names, constants)) continue;
                    $29c9bde2ffc5ac8c$var$subtractNames(names, n.names);
                    nodes.splice(i, 1);
                }
                return nodes.length > 0 ? this : undefined;
            }
        },
        {
            key: "names",
            get: function get() {
                return this.nodes.reduce(function(names, n) {
                    return $29c9bde2ffc5ac8c$var$addNames(names, n.names);
                }, {});
            }
        }
    ]);
    return ParentNode;
}((0, $karXd._)($29c9bde2ffc5ac8c$var$Node));
var $29c9bde2ffc5ac8c$var$BlockNode = /*#__PURE__*/ function(ParentNode) {
    (0, $fsOl6._)(BlockNode, ParentNode);
    var _super = (0, $COJlH._)(BlockNode);
    function BlockNode() {
        (0, $h5oKP._)(this, BlockNode);
        return _super.apply(this, arguments);
    }
    (0, $85qwq._)(BlockNode, [
        {
            key: "render",
            value: function render(opts) {
                return "{" + opts._n + (0, $b0PmO._)((0, $l9BwU._)(BlockNode.prototype), "render", this).call(this, opts) + "}" + opts._n;
            }
        }
    ]);
    return BlockNode;
}($29c9bde2ffc5ac8c$var$ParentNode);
var $29c9bde2ffc5ac8c$var$Root = /*#__PURE__*/ function(ParentNode) {
    (0, $fsOl6._)(Root, ParentNode);
    var _super = (0, $COJlH._)(Root);
    function Root() {
        (0, $h5oKP._)(this, Root);
        return _super.apply(this, arguments);
    }
    return Root;
}($29c9bde2ffc5ac8c$var$ParentNode);
var $29c9bde2ffc5ac8c$var$Else = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(Else, BlockNode);
    var _super = (0, $COJlH._)(Else);
    function Else() {
        (0, $h5oKP._)(this, Else);
        return _super.apply(this, arguments);
    }
    return Else;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$Else.kind = "else";
var $29c9bde2ffc5ac8c$var$If = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(If, BlockNode);
    var _super = (0, $COJlH._)(If);
    function If(condition, nodes) {
        (0, $h5oKP._)(this, If);
        var _this;
        _this = _super.call(this, nodes);
        _this.condition = condition;
        return _this;
    }
    (0, $85qwq._)(If, [
        {
            key: "render",
            value: function render(opts) {
                var code = "if(".concat(this.condition, ")") + (0, $b0PmO._)((0, $l9BwU._)(If.prototype), "render", this).call(this, opts);
                if (this.else) code += "else " + this.else.render(opts);
                return code;
            }
        },
        {
            key: "optimizeNodes",
            value: function optimizeNodes() {
                (0, $b0PmO._)((0, $l9BwU._)(If.prototype), "optimizeNodes", this).call(this);
                var cond = this.condition;
                if (cond === true) return this.nodes; // else is ignored here
                var e = this.else;
                if (e) {
                    var ns = e.optimizeNodes();
                    e = this.else = Array.isArray(ns) ? new $29c9bde2ffc5ac8c$var$Else(ns) : ns;
                }
                if (e) {
                    if (cond === false) return e instanceof If ? e : e.nodes;
                    if (this.nodes.length) return this;
                    return new If($29c9bde2ffc5ac8c$var$not(cond), e instanceof If ? [
                        e
                    ] : e.nodes);
                }
                if (cond === false || !this.nodes.length) return undefined;
                return this;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                var _a;
                this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
                if (!((0, $b0PmO._)((0, $l9BwU._)(If.prototype), "optimizeNames", this).call(this, names, constants) || this.else)) return;
                this.condition = $29c9bde2ffc5ac8c$var$optimizeExpr(this.condition, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                var names = (0, $b0PmO._)((0, $l9BwU._)(If.prototype), "names", this);
                $29c9bde2ffc5ac8c$var$addExprNames(names, this.condition);
                if (this.else) $29c9bde2ffc5ac8c$var$addNames(names, this.else.names);
                return names;
            }
        }
    ]);
    return If;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$If.kind = "if";
var $29c9bde2ffc5ac8c$var$For = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(For, BlockNode);
    var _super = (0, $COJlH._)(For);
    function For() {
        (0, $h5oKP._)(this, For);
        return _super.apply(this, arguments);
    }
    return For;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$For.kind = "for";
var $29c9bde2ffc5ac8c$var$ForLoop = /*#__PURE__*/ function(For) {
    (0, $fsOl6._)(ForLoop, For);
    var _super = (0, $COJlH._)(ForLoop);
    function ForLoop(iteration) {
        (0, $h5oKP._)(this, ForLoop);
        var _this;
        _this = _super.call(this);
        _this.iteration = iteration;
        return _this;
    }
    (0, $85qwq._)(ForLoop, [
        {
            key: "render",
            value: function render(opts) {
                return "for(".concat(this.iteration, ")") + (0, $b0PmO._)((0, $l9BwU._)(ForLoop.prototype), "render", this).call(this, opts);
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                if (!(0, $b0PmO._)((0, $l9BwU._)(ForLoop.prototype), "optimizeNames", this).call(this, names, constants)) return;
                this.iteration = $29c9bde2ffc5ac8c$var$optimizeExpr(this.iteration, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                return $29c9bde2ffc5ac8c$var$addNames((0, $b0PmO._)((0, $l9BwU._)(ForLoop.prototype), "names", this), this.iteration.names);
            }
        }
    ]);
    return ForLoop;
}($29c9bde2ffc5ac8c$var$For);
var $29c9bde2ffc5ac8c$var$ForRange = /*#__PURE__*/ function(For) {
    (0, $fsOl6._)(ForRange, For);
    var _super = (0, $COJlH._)(ForRange);
    function ForRange(varKind, name, from, to) {
        (0, $h5oKP._)(this, ForRange);
        var _this;
        _this = _super.call(this);
        _this.varKind = varKind;
        _this.name = name;
        _this.from = from;
        _this.to = to;
        return _this;
    }
    (0, $85qwq._)(ForRange, [
        {
            key: "render",
            value: function render(opts) {
                var varKind = opts.es5 ? $6MUvF.varKinds.var : this.varKind;
                var _this = this, name = _this.name, from = _this.from, to = _this.to;
                return "for(".concat(varKind, " ").concat(name, "=").concat(from, "; ").concat(name, "<").concat(to, "; ").concat(name, "++)") + (0, $b0PmO._)((0, $l9BwU._)(ForRange.prototype), "render", this).call(this, opts);
            }
        },
        {
            key: "names",
            get: function get() {
                var names = $29c9bde2ffc5ac8c$var$addExprNames((0, $b0PmO._)((0, $l9BwU._)(ForRange.prototype), "names", this), this.from);
                return $29c9bde2ffc5ac8c$var$addExprNames(names, this.to);
            }
        }
    ]);
    return ForRange;
}($29c9bde2ffc5ac8c$var$For);
var $29c9bde2ffc5ac8c$var$ForIter = /*#__PURE__*/ function(For) {
    (0, $fsOl6._)(ForIter, For);
    var _super = (0, $COJlH._)(ForIter);
    function ForIter(loop, varKind, name, iterable) {
        (0, $h5oKP._)(this, ForIter);
        var _this;
        _this = _super.call(this);
        _this.loop = loop;
        _this.varKind = varKind;
        _this.name = name;
        _this.iterable = iterable;
        return _this;
    }
    (0, $85qwq._)(ForIter, [
        {
            key: "render",
            value: function render(opts) {
                return "for(".concat(this.varKind, " ").concat(this.name, " ").concat(this.loop, " ").concat(this.iterable, ")") + (0, $b0PmO._)((0, $l9BwU._)(ForIter.prototype), "render", this).call(this, opts);
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                if (!(0, $b0PmO._)((0, $l9BwU._)(ForIter.prototype), "optimizeNames", this).call(this, names, constants)) return;
                this.iterable = $29c9bde2ffc5ac8c$var$optimizeExpr(this.iterable, names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                return $29c9bde2ffc5ac8c$var$addNames((0, $b0PmO._)((0, $l9BwU._)(ForIter.prototype), "names", this), this.iterable.names);
            }
        }
    ]);
    return ForIter;
}($29c9bde2ffc5ac8c$var$For);
var $29c9bde2ffc5ac8c$var$Func = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(Func, BlockNode);
    var _super = (0, $COJlH._)(Func);
    function Func(name, args, async) {
        (0, $h5oKP._)(this, Func);
        var _this;
        _this = _super.call(this);
        _this.name = name;
        _this.args = args;
        _this.async = async;
        return _this;
    }
    (0, $85qwq._)(Func, [
        {
            key: "render",
            value: function render(opts) {
                var _async = this.async ? "async " : "";
                return "".concat(_async, "function ").concat(this.name, "(").concat(this.args, ")") + (0, $b0PmO._)((0, $l9BwU._)(Func.prototype), "render", this).call(this, opts);
            }
        }
    ]);
    return Func;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$Func.kind = "func";
var $29c9bde2ffc5ac8c$var$Return = /*#__PURE__*/ function(ParentNode) {
    (0, $fsOl6._)(Return, ParentNode);
    var _super = (0, $COJlH._)(Return);
    function Return() {
        (0, $h5oKP._)(this, Return);
        return _super.apply(this, arguments);
    }
    (0, $85qwq._)(Return, [
        {
            key: "render",
            value: function render(opts) {
                return "return " + (0, $b0PmO._)((0, $l9BwU._)(Return.prototype), "render", this).call(this, opts);
            }
        }
    ]);
    return Return;
}($29c9bde2ffc5ac8c$var$ParentNode);
$29c9bde2ffc5ac8c$var$Return.kind = "return";
var $29c9bde2ffc5ac8c$var$Try = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(Try, BlockNode);
    var _super = (0, $COJlH._)(Try);
    function Try() {
        (0, $h5oKP._)(this, Try);
        return _super.apply(this, arguments);
    }
    (0, $85qwq._)(Try, [
        {
            key: "render",
            value: function render(opts) {
                var code = "try" + (0, $b0PmO._)((0, $l9BwU._)(Try.prototype), "render", this).call(this, opts);
                if (this.catch) code += this.catch.render(opts);
                if (this.finally) code += this.finally.render(opts);
                return code;
            }
        },
        {
            key: "optimizeNodes",
            value: function optimizeNodes() {
                var _a, _b;
                (0, $b0PmO._)((0, $l9BwU._)(Try.prototype), "optimizeNodes", this).call(this);
                (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
                (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
                return this;
            }
        },
        {
            key: "optimizeNames",
            value: function optimizeNames(names, constants) {
                var _a, _b;
                (0, $b0PmO._)((0, $l9BwU._)(Try.prototype), "optimizeNames", this).call(this, names, constants);
                (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
                (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
                return this;
            }
        },
        {
            key: "names",
            get: function get() {
                var names = (0, $b0PmO._)((0, $l9BwU._)(Try.prototype), "names", this);
                if (this.catch) $29c9bde2ffc5ac8c$var$addNames(names, this.catch.names);
                if (this.finally) $29c9bde2ffc5ac8c$var$addNames(names, this.finally.names);
                return names;
            }
        }
    ]);
    return Try;
}($29c9bde2ffc5ac8c$var$BlockNode);
var $29c9bde2ffc5ac8c$var$Catch = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(Catch, BlockNode);
    var _super = (0, $COJlH._)(Catch);
    function Catch(error) {
        (0, $h5oKP._)(this, Catch);
        var _this;
        _this = _super.call(this);
        _this.error = error;
        return _this;
    }
    (0, $85qwq._)(Catch, [
        {
            key: "render",
            value: function render(opts) {
                return "catch(".concat(this.error, ")") + (0, $b0PmO._)((0, $l9BwU._)(Catch.prototype), "render", this).call(this, opts);
            }
        }
    ]);
    return Catch;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$Catch.kind = "catch";
var $29c9bde2ffc5ac8c$var$Finally = /*#__PURE__*/ function(BlockNode) {
    (0, $fsOl6._)(Finally, BlockNode);
    var _super = (0, $COJlH._)(Finally);
    function Finally() {
        (0, $h5oKP._)(this, Finally);
        return _super.apply(this, arguments);
    }
    (0, $85qwq._)(Finally, [
        {
            key: "render",
            value: function render(opts) {
                return "finally" + (0, $b0PmO._)((0, $l9BwU._)(Finally.prototype), "render", this).call(this, opts);
            }
        }
    ]);
    return Finally;
}($29c9bde2ffc5ac8c$var$BlockNode);
$29c9bde2ffc5ac8c$var$Finally.kind = "finally";
var $29c9bde2ffc5ac8c$var$CodeGen = /*#__PURE__*/ function() {
    function CodeGen(extScope) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $h5oKP._)(this, CodeGen);
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = (0, $cpUXF._)((0, $hF4Ve._)({}, opts), {
            _n: opts.lines ? "\n" : ""
        });
        this._extScope = extScope;
        this._scope = new $6MUvF.Scope({
            parent: extScope
        });
        this._nodes = [
            new $29c9bde2ffc5ac8c$var$Root()
        ];
    }
    (0, $85qwq._)(CodeGen, [
        {
            key: "toString",
            value: function toString() {
                return this._root.render(this.opts);
            }
        },
        {
            // returns unique name in the internal scope
            key: "name",
            value: function name(prefix) {
                return this._scope.name(prefix);
            }
        },
        {
            // reserves unique name in the external scope
            key: "scopeName",
            value: function scopeName(prefix) {
                return this._extScope.name(prefix);
            }
        },
        {
            // reserves unique name in the external scope and assigns value to it
            key: "scopeValue",
            value: function scopeValue(prefixOrName, value) {
                var name = this._extScope.value(prefixOrName, value);
                var vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
                vs.add(name);
                return name;
            }
        },
        {
            key: "getScopeValue",
            value: function getScopeValue(prefix, keyOrRef) {
                return this._extScope.getValue(prefix, keyOrRef);
            }
        },
        {
            // return code that assigns values in the external scope to the names that are used internally
            // (same names that were returned by gen.scopeName or gen.scopeValue)
            key: "scopeRefs",
            value: function scopeRefs(scopeName) {
                return this._extScope.scopeRefs(scopeName, this._values);
            }
        },
        {
            key: "scopeCode",
            value: function scopeCode() {
                return this._extScope.scopeCode(this._values);
            }
        },
        {
            key: "_def",
            value: function _def(varKind, nameOrPrefix, rhs, constant) {
                var name = this._scope.toName(nameOrPrefix);
                if (rhs !== undefined && constant) this._constants[name.str] = rhs;
                this._leafNode(new $29c9bde2ffc5ac8c$var$Def(varKind, name, rhs));
                return name;
            }
        },
        {
            // `const` declaration (`var` in es5 mode)
            key: "const",
            value: function _const(nameOrPrefix, rhs, _constant) {
                return this._def($6MUvF.varKinds.const, nameOrPrefix, rhs, _constant);
            }
        },
        {
            // `let` declaration with optional assignment (`var` in es5 mode)
            key: "let",
            value: function _let(nameOrPrefix, rhs, _constant) {
                return this._def($6MUvF.varKinds.let, nameOrPrefix, rhs, _constant);
            }
        },
        {
            // `var` declaration with optional assignment
            key: "var",
            value: function _var(nameOrPrefix, rhs, _constant) {
                return this._def($6MUvF.varKinds.var, nameOrPrefix, rhs, _constant);
            }
        },
        {
            // assignment code
            key: "assign",
            value: function assign(lhs, rhs, sideEffects) {
                return this._leafNode(new $29c9bde2ffc5ac8c$var$Assign(lhs, rhs, sideEffects));
            }
        },
        {
            // `+=` code
            key: "add",
            value: function add(lhs, rhs) {
                return this._leafNode(new $29c9bde2ffc5ac8c$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
            }
        },
        {
            // appends passed SafeExpr to code or executes Block
            key: "code",
            value: function code(c) {
                if (typeof c == "function") c();
                else if (c !== $6go2u.nil) this._leafNode(new $29c9bde2ffc5ac8c$var$AnyCode(c));
                return this;
            }
        },
        {
            // returns code for object literal for the passed argument list of key-value pairs
            key: "object",
            value: function object() {
                for(var _len = arguments.length, keyValues = new Array(_len), _key = 0; _key < _len; _key++){
                    keyValues[_key] = arguments[_key];
                }
                var code = [
                    "{"
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keyValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $2MVSR._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (code.length > 1) code.push(",");
                        code.push(key);
                        if (key !== value || this.opts.es5) {
                            code.push(":");
                            (0, $6go2u.addCodeArg)(code, value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                code.push("}");
                return new $6go2u._Code(code);
            }
        },
        {
            // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
            key: "if",
            value: function _if(condition, thenBody, elseBody) {
                this._blockNode(new $29c9bde2ffc5ac8c$var$If(condition));
                if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
                else if (thenBody) this.code(thenBody).endIf();
                else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
                return this;
            }
        },
        {
            // `else if` clause - invalid without `if` or after `else` clauses
            key: "elseIf",
            value: function elseIf(condition) {
                return this._elseNode(new $29c9bde2ffc5ac8c$var$If(condition));
            }
        },
        {
            // `else` clause - only valid after `if` or `else if` clauses
            key: "else",
            value: function _else() {
                return this._elseNode(new $29c9bde2ffc5ac8c$var$Else());
            }
        },
        {
            // end `if` statement (needed if gen.if was used only with condition)
            key: "endIf",
            value: function endIf() {
                return this._endBlockNode($29c9bde2ffc5ac8c$var$If, $29c9bde2ffc5ac8c$var$Else);
            }
        },
        {
            key: "_for",
            value: function _for(node, forBody) {
                this._blockNode(node);
                if (forBody) this.code(forBody).endFor();
                return this;
            }
        },
        {
            // a generic `for` clause (or statement if `forBody` is passed)
            key: "for",
            value: function _for(iteration, forBody) {
                return this._for(new $29c9bde2ffc5ac8c$var$ForLoop(iteration), forBody);
            }
        },
        {
            // `for` statement for a range of values
            key: "forRange",
            value: function forRange(nameOrPrefix, from, to, forBody) {
                var varKind = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.opts.es5 ? $6MUvF.varKinds.var : $6MUvF.varKinds.let;
                var name = this._scope.toName(nameOrPrefix);
                return this._for(new $29c9bde2ffc5ac8c$var$ForRange(varKind, name, from, to), function() {
                    return forBody(name);
                });
            }
        },
        {
            // `for-of` statement (in es5 mode replace with a normal for loop)
            key: "forOf",
            value: function forOf(nameOrPrefix, iterable, forBody) {
                var varKind = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $6MUvF.varKinds.const;
                var _this = this;
                var name = this._scope.toName(nameOrPrefix);
                if (this.opts.es5) {
                    var arr = iterable instanceof $6go2u.Name ? iterable : this.var("_arr", iterable);
                    return this.forRange("_i", 0, (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject(), arr), function(i) {
                        _this.var(name, (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject1(), arr, i));
                        forBody(name);
                    });
                }
                return this._for(new $29c9bde2ffc5ac8c$var$ForIter("of", varKind, name, iterable), function() {
                    return forBody(name);
                });
            }
        },
        {
            // `for-in` statement.
            // With option `ownProperties` replaced with a `for-of` loop for object keys
            key: "forIn",
            value: function forIn(nameOrPrefix, obj, forBody) {
                var varKind = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.opts.es5 ? $6MUvF.varKinds.var : $6MUvF.varKinds.const;
                if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject2(), obj), forBody);
                var name = this._scope.toName(nameOrPrefix);
                return this._for(new $29c9bde2ffc5ac8c$var$ForIter("in", varKind, name, obj), function() {
                    return forBody(name);
                });
            }
        },
        {
            // end `for` loop
            key: "endFor",
            value: function endFor() {
                return this._endBlockNode($29c9bde2ffc5ac8c$var$For);
            }
        },
        {
            // `label` statement
            key: "label",
            value: function label(label) {
                return this._leafNode(new $29c9bde2ffc5ac8c$var$Label(label));
            }
        },
        {
            // `break` statement
            key: "break",
            value: function _break(label) {
                return this._leafNode(new $29c9bde2ffc5ac8c$var$Break(label));
            }
        },
        {
            // `return` statement
            key: "return",
            value: function _return(value) {
                var node = new $29c9bde2ffc5ac8c$var$Return();
                this._blockNode(node);
                this.code(value);
                if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
                return this._endBlockNode($29c9bde2ffc5ac8c$var$Return);
            }
        },
        {
            // `try` statement
            key: "try",
            value: function _try(tryBody, catchCode, finallyCode) {
                if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
                var node = new $29c9bde2ffc5ac8c$var$Try();
                this._blockNode(node);
                this.code(tryBody);
                if (catchCode) {
                    var error = this.name("e");
                    this._currNode = node.catch = new $29c9bde2ffc5ac8c$var$Catch(error);
                    catchCode(error);
                }
                if (finallyCode) {
                    this._currNode = node.finally = new $29c9bde2ffc5ac8c$var$Finally();
                    this.code(finallyCode);
                }
                return this._endBlockNode($29c9bde2ffc5ac8c$var$Catch, $29c9bde2ffc5ac8c$var$Finally);
            }
        },
        {
            // `throw` statement
            key: "throw",
            value: function _throw(error) {
                return this._leafNode(new $29c9bde2ffc5ac8c$var$Throw(error));
            }
        },
        {
            // start self-balancing block
            key: "block",
            value: function block(body, nodeCount) {
                this._blockStarts.push(this._nodes.length);
                if (body) this.code(body).endBlock(nodeCount);
                return this;
            }
        },
        {
            // end the current self-balancing block
            key: "endBlock",
            value: function endBlock(nodeCount) {
                var len = this._blockStarts.pop();
                if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
                var toClose = this._nodes.length - len;
                if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error("CodeGen: wrong number of nodes: ".concat(toClose, " vs ").concat(nodeCount, " expected"));
                this._nodes.length = len;
                return this;
            }
        },
        {
            // `function` heading (or definition if funcBody is passed)
            key: "func",
            value: function func(name) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6go2u.nil, async = arguments.length > 2 ? arguments[2] : void 0, funcBody = arguments.length > 3 ? arguments[3] : void 0;
                this._blockNode(new $29c9bde2ffc5ac8c$var$Func(name, args, async));
                if (funcBody) this.code(funcBody).endFunc();
                return this;
            }
        },
        {
            // end function definition
            key: "endFunc",
            value: function endFunc() {
                return this._endBlockNode($29c9bde2ffc5ac8c$var$Func);
            }
        },
        {
            key: "optimize",
            value: function optimize() {
                var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                while(n-- > 0){
                    this._root.optimizeNodes();
                    this._root.optimizeNames(this._root.names, this._constants);
                }
            }
        },
        {
            key: "_leafNode",
            value: function _leafNode(node) {
                this._currNode.nodes.push(node);
                return this;
            }
        },
        {
            key: "_blockNode",
            value: function _blockNode(node) {
                this._currNode.nodes.push(node);
                this._nodes.push(node);
            }
        },
        {
            key: "_endBlockNode",
            value: function _endBlockNode(N1, N2) {
                var n = this._currNode;
                if (n instanceof N1 || N2 && n instanceof N2) {
                    this._nodes.pop();
                    return this;
                }
                throw new Error('CodeGen: not in block "'.concat(N2 ? "".concat(N1.kind, "/").concat(N2.kind) : N1.kind, '"'));
            }
        },
        {
            key: "_elseNode",
            value: function _elseNode(node) {
                var n = this._currNode;
                if (!(n instanceof $29c9bde2ffc5ac8c$var$If)) throw new Error('CodeGen: "else" without "if"');
                this._currNode = n.else = node;
                return this;
            }
        },
        {
            key: "_root",
            get: function get() {
                return this._nodes[0];
            }
        },
        {
            key: "_currNode",
            get: function get() {
                var ns = this._nodes;
                return ns[ns.length - 1];
            },
            set: function set(node) {
                var ns = this._nodes;
                ns[ns.length - 1] = node;
            }
        }
    ]);
    return CodeGen;
}();
module.exports.CodeGen = $29c9bde2ffc5ac8c$var$CodeGen;
function $29c9bde2ffc5ac8c$var$addNames(names, from) {
    for(var n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $29c9bde2ffc5ac8c$var$addExprNames(names, from) {
    return from instanceof $6go2u._CodeOrName ? $29c9bde2ffc5ac8c$var$addNames(names, from.names) : names;
}
function $29c9bde2ffc5ac8c$var$optimizeExpr(expr, names, constants) {
    var replaceName = function replaceName(n) {
        var c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    };
    var canOptimize = function canOptimize(e) {
        return e instanceof $6go2u._Code && e._items.some(function(c) {
            return c instanceof $6go2u.Name && names[c.str] === 1 && constants[c.str] !== undefined;
        });
    };
    if (expr instanceof $6go2u.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $6go2u._Code(expr._items.reduce(function(items, c) {
        var _items;
        if (c instanceof $6go2u.Name) c = replaceName(c);
        if (c instanceof $6go2u._Code) (_items = items).push.apply(_items, (0, $h9dQc._)(c._items));
        else items.push(c);
        return items;
    }, []));
}
function $29c9bde2ffc5ac8c$var$subtractNames(names, from) {
    for(var n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $29c9bde2ffc5ac8c$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject3(), $29c9bde2ffc5ac8c$var$par(x));
}
module.exports.not = $29c9bde2ffc5ac8c$var$not;
var $29c9bde2ffc5ac8c$var$andCode = $29c9bde2ffc5ac8c$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $29c9bde2ffc5ac8c$var$and() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.reduce($29c9bde2ffc5ac8c$var$andCode);
}
module.exports.and = $29c9bde2ffc5ac8c$var$and;
var $29c9bde2ffc5ac8c$var$orCode = $29c9bde2ffc5ac8c$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $29c9bde2ffc5ac8c$var$or() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.reduce($29c9bde2ffc5ac8c$var$orCode);
}
module.exports.or = $29c9bde2ffc5ac8c$var$or;
function $29c9bde2ffc5ac8c$var$mappend(op) {
    return function(x, y) {
        return x === $6go2u.nil ? y : y === $6go2u.nil ? x : (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject4(), $29c9bde2ffc5ac8c$var$par(x), op, $29c9bde2ffc5ac8c$var$par(y));
    };
}
function $29c9bde2ffc5ac8c$var$par(x) {
    return x instanceof $6go2u.Name ? x : (0, $6go2u._)($29c9bde2ffc5ac8c$var$_templateObject5(), x);
}

});
parcelRequire.register("2MVSR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $207cf70254f8c9c6$export$fdf2a89c76341bbf; });

var $jNBJX = parcelRequire("jNBJX");

var $59rYm = parcelRequire("59rYm");

var $dLLNg = parcelRequire("dLLNg");

var $4OOPV = parcelRequire("4OOPV");
function $207cf70254f8c9c6$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jNBJX._array_with_holes)(arr) || (0, $59rYm._iterable_to_array_limit)(arr, i) || (0, $4OOPV._unsupported_iterable_to_array)(arr, i) || (0, $dLLNg._non_iterable_rest)();
}

});
parcelRequire.register("jNBJX", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $e69fde57663a1e2a$export$e6256bf45c68d561; });
function $e69fde57663a1e2a$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("59rYm", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $3c037dc32f7ee08a$export$2fd15edff6687200; });
function $3c037dc32f7ee08a$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("dLLNg", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $a064bceec9029c30$export$60dbc22abd7da546; });
function $a064bceec9029c30$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("karXd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eaea6ce880aa6c4c$export$2466d533fda16e33; });

var $iP7ap = parcelRequire("iP7ap");

var $l9BwU = parcelRequire("l9BwU");

var $lueqm = parcelRequire("lueqm");

var $9QNuc = parcelRequire("9QNuc");
function $eaea6ce880aa6c4c$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $eaea6ce880aa6c4c$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $lueqm._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $iP7ap._construct)(Class, arguments, (0, $l9BwU._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $9QNuc._set_prototype_of)(Wrapper, Class);
    };
    return $eaea6ce880aa6c4c$export$2466d533fda16e33(Class);
}

});
parcelRequire.register("iP7ap", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $db428ca0d9cddcec$export$2d841144c5f8c4ab; });

var $gfgCN = parcelRequire("gfgCN");

var $9QNuc = parcelRequire("9QNuc");
function $db428ca0d9cddcec$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $gfgCN._is_native_reflect_construct)()) $db428ca0d9cddcec$export$2d841144c5f8c4ab = Reflect.construct;
    else $db428ca0d9cddcec$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $9QNuc._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $db428ca0d9cddcec$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRequire.register("lueqm", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $fa4796a7a9d79caa$export$514eda94019f4334; });
function $fa4796a7a9d79caa$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRequire.register("6go2u", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $4IdPP = parcelRequire("4IdPP");

var $fsOl6 = parcelRequire("fsOl6");

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");

var $COJlH = parcelRequire("COJlH");
"use strict";
function $48f6e264d438a883$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $48f6e264d438a883$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $48f6e264d438a883$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "[",
        "]"
    ]);
    $48f6e264d438a883$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
var $48f6e264d438a883$var$_CodeOrName = function _CodeOrName() {
    (0, $h5oKP._)(this, _CodeOrName);
};
module.exports._CodeOrName = $48f6e264d438a883$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var $48f6e264d438a883$var$Name = /*#__PURE__*/ function(_CodeOrName) {
    (0, $fsOl6._)(Name, _CodeOrName);
    var _super = (0, $COJlH._)(Name);
    function Name(s) {
        (0, $h5oKP._)(this, Name);
        var _this;
        _this = _super.call(this);
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        _this.str = s;
        return _this;
    }
    (0, $85qwq._)(Name, [
        {
            key: "toString",
            value: function toString() {
                return this.str;
            }
        },
        {
            key: "emptyStr",
            value: function emptyStr() {
                return false;
            }
        },
        {
            key: "names",
            get: function get() {
                return (0, $4IdPP._)({}, this.str, 1);
            }
        }
    ]);
    return Name;
}($48f6e264d438a883$var$_CodeOrName);
module.exports.Name = $48f6e264d438a883$var$Name;
var $48f6e264d438a883$var$_Code = /*#__PURE__*/ function(_CodeOrName) {
    (0, $fsOl6._)(_Code, _CodeOrName);
    var _super = (0, $COJlH._)(_Code);
    function _Code(code) {
        (0, $h5oKP._)(this, _Code);
        var _this;
        _this = _super.call(this);
        _this._items = typeof code === "string" ? [
            code
        ] : code;
        return _this;
    }
    (0, $85qwq._)(_Code, [
        {
            key: "toString",
            value: function toString() {
                return this.str;
            }
        },
        {
            key: "emptyStr",
            value: function emptyStr() {
                if (this._items.length > 1) return false;
                var item = this._items[0];
                return item === "" || item === '""';
            }
        },
        {
            key: "str",
            get: function get() {
                var _a;
                return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce(function(s, c) {
                    return "".concat(s).concat(c);
                }, "");
            }
        },
        {
            key: "names",
            get: function get() {
                var _a;
                return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce(function(names, c) {
                    if (c instanceof $48f6e264d438a883$var$Name) names[c.str] = (names[c.str] || 0) + 1;
                    return names;
                }, {});
            }
        }
    ]);
    return _Code;
}($48f6e264d438a883$var$_CodeOrName);
module.exports._Code = $48f6e264d438a883$var$_Code;
module.exports.nil = new $48f6e264d438a883$var$_Code("");
function $48f6e264d438a883$var$_(strs) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var code = [
        strs[0]
    ];
    var i = 0;
    while(i < args.length){
        $48f6e264d438a883$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $48f6e264d438a883$var$_Code(code);
}
module.exports._ = $48f6e264d438a883$var$_;
var $48f6e264d438a883$var$plus = new $48f6e264d438a883$var$_Code("+");
function $48f6e264d438a883$var$str(strs) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var expr = [
        $48f6e264d438a883$var$safeStringify(strs[0])
    ];
    var i = 0;
    while(i < args.length){
        expr.push($48f6e264d438a883$var$plus);
        $48f6e264d438a883$var$addCodeArg(expr, args[i]);
        expr.push($48f6e264d438a883$var$plus, $48f6e264d438a883$var$safeStringify(strs[++i]));
    }
    $48f6e264d438a883$var$optimize(expr);
    return new $48f6e264d438a883$var$_Code(expr);
}
module.exports.str = $48f6e264d438a883$var$str;
function $48f6e264d438a883$var$addCodeArg(code, arg) {
    var _code;
    if (arg instanceof $48f6e264d438a883$var$_Code) (_code = code).push.apply(_code, (0, $h9dQc._)(arg._items));
    else if (arg instanceof $48f6e264d438a883$var$Name) code.push(arg);
    else code.push($48f6e264d438a883$var$interpolate(arg));
}
module.exports.addCodeArg = $48f6e264d438a883$var$addCodeArg;
function $48f6e264d438a883$var$optimize(expr) {
    var i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $48f6e264d438a883$var$plus) {
            var res = $48f6e264d438a883$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $48f6e264d438a883$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $48f6e264d438a883$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return "".concat(a.slice(0, -1)).concat(b, '"');
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $48f6e264d438a883$var$Name)) return '"'.concat(a).concat(b.slice(1));
    return;
}
function $48f6e264d438a883$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $48f6e264d438a883$var$str($48f6e264d438a883$var$_templateObject(), c1, c2);
}
module.exports.strConcat = $48f6e264d438a883$var$strConcat;
// TODO do not allow arrays here
function $48f6e264d438a883$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $48f6e264d438a883$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $48f6e264d438a883$var$stringify(x) {
    return new $48f6e264d438a883$var$_Code($48f6e264d438a883$var$safeStringify(x));
}
module.exports.stringify = $48f6e264d438a883$var$stringify;
function $48f6e264d438a883$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $48f6e264d438a883$var$safeStringify;
function $48f6e264d438a883$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $48f6e264d438a883$var$_Code(".".concat(key)) : $48f6e264d438a883$var$_($48f6e264d438a883$var$_templateObject1(), key);
}
module.exports.getProperty = $48f6e264d438a883$var$getProperty;
//Does best effort to format the name properly
function $48f6e264d438a883$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $48f6e264d438a883$var$_Code("".concat(key));
    throw new Error("CodeGen: invalid export name: ".concat(key, ", use explicit $id name mapping"));
}
module.exports.getEsmExportName = $48f6e264d438a883$var$getEsmExportName;
function $48f6e264d438a883$var$regexpCode(rx) {
    return new $48f6e264d438a883$var$_Code(rx.toString());
}
module.exports.regexpCode = $48f6e264d438a883$var$regexpCode;

});

parcelRequire.register("6MUvF", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");

var $bmZve = parcelRequire("bmZve");

var $karXd = parcelRequire("karXd");

var $COJlH = parcelRequire("COJlH");
"use strict";
function $4f130f6ce33ff743$var$_templateObject() {
    var data = (0, $bmZve._)([
        ".",
        "[",
        "]"
    ]);
    $4f130f6ce33ff743$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4f130f6ce33ff743$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "\n"
    ], [
        "\\n"
    ]);
    $4f130f6ce33ff743$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4f130f6ce33ff743$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $4f130f6ce33ff743$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $4f130f6ce33ff743$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        "",
        " ",
        " = ",
        ";",
        ""
    ]);
    $4f130f6ce33ff743$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $4f130f6ce33ff743$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        "",
        "",
        ""
    ]);
    $4f130f6ce33ff743$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $6go2u = parcelRequire("6go2u");
var $4f130f6ce33ff743$var$ValueError = /*#__PURE__*/ function(Error1) {
    (0, $fsOl6._)(ValueError, Error1);
    var _super = (0, $COJlH._)(ValueError);
    function ValueError(name) {
        (0, $h5oKP._)(this, ValueError);
        var _this;
        _this = _super.call(this, 'CodeGen: "code" for '.concat(name, " not defined"));
        _this.value = name.value;
        return _this;
    }
    return ValueError;
}((0, $karXd._)(Error));
var $4f130f6ce33ff743$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($4f130f6ce33ff743$var$UsedValueState = module.exports.UsedValueState || (module.exports.UsedValueState = {}));
module.exports.varKinds = {
    const: new $6go2u.Name("const"),
    let: new $6go2u.Name("let"),
    var: new $6go2u.Name("var")
};
var $4f130f6ce33ff743$var$Scope = /*#__PURE__*/ function() {
    function Scope() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, prefixes = _ref.prefixes, parent = _ref.parent;
        (0, $h5oKP._)(this, Scope);
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    (0, $85qwq._)(Scope, [
        {
            key: "toName",
            value: function toName(nameOrPrefix) {
                return nameOrPrefix instanceof $6go2u.Name ? nameOrPrefix : this.name(nameOrPrefix);
            }
        },
        {
            key: "name",
            value: function name(prefix) {
                return new $6go2u.Name(this._newName(prefix));
            }
        },
        {
            key: "_newName",
            value: function _newName(prefix) {
                var ng = this._names[prefix] || this._nameGroup(prefix);
                return "".concat(prefix).concat(ng.index++);
            }
        },
        {
            key: "_nameGroup",
            value: function _nameGroup(prefix) {
                var _a, _b;
                if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error('CodeGen: prefix "'.concat(prefix, '" is not allowed in this scope'));
                return this._names[prefix] = {
                    prefix: prefix,
                    index: 0
                };
            }
        }
    ]);
    return Scope;
}();
module.exports.Scope = $4f130f6ce33ff743$var$Scope;
var $4f130f6ce33ff743$var$ValueScopeName = /*#__PURE__*/ function(_code_1_Name) {
    (0, $fsOl6._)(ValueScopeName, _code_1_Name);
    var _super = (0, $COJlH._)(ValueScopeName);
    function ValueScopeName(prefix, nameStr) {
        (0, $h5oKP._)(this, ValueScopeName);
        var _this;
        _this = _super.call(this, nameStr);
        _this.prefix = prefix;
        return _this;
    }
    (0, $85qwq._)(ValueScopeName, [
        {
            key: "setValue",
            value: function setValue(value, param) {
                var property = param.property, itemIndex = param.itemIndex;
                this.value = value;
                this.scopePath = (0, $6go2u._)($4f130f6ce33ff743$var$_templateObject(), new $6go2u.Name(property), itemIndex);
            }
        }
    ]);
    return ValueScopeName;
}($6go2u.Name);
module.exports.ValueScopeName = $4f130f6ce33ff743$var$ValueScopeName;
var $4f130f6ce33ff743$var$line = (0, $6go2u._)($4f130f6ce33ff743$var$_templateObject1());
var $4f130f6ce33ff743$var$ValueScope = /*#__PURE__*/ function(Scope) {
    (0, $fsOl6._)(ValueScope, Scope);
    var _super = (0, $COJlH._)(ValueScope);
    function ValueScope(opts) {
        (0, $h5oKP._)(this, ValueScope);
        var _this;
        _this = _super.call(this, opts);
        _this._values = {};
        _this._scope = opts.scope;
        _this.opts = (0, $cpUXF._)((0, $hF4Ve._)({}, opts), {
            _n: opts.lines ? $4f130f6ce33ff743$var$line : $6go2u.nil
        });
        return _this;
    }
    (0, $85qwq._)(ValueScope, [
        {
            key: "get",
            value: function get() {
                return this._scope;
            }
        },
        {
            key: "name",
            value: function name(prefix) {
                return new $4f130f6ce33ff743$var$ValueScopeName(prefix, this._newName(prefix));
            }
        },
        {
            key: "value",
            value: function value(nameOrPrefix, value) {
                var _a;
                if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
                var name = this.toName(nameOrPrefix);
                var prefix = name.prefix;
                var valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
                var vs = this._values[prefix];
                if (vs) {
                    var _name = vs.get(valueKey);
                    if (_name) return _name;
                } else vs = this._values[prefix] = new Map();
                vs.set(valueKey, name);
                var s = this._scope[prefix] || (this._scope[prefix] = []);
                var itemIndex = s.length;
                s[itemIndex] = value.ref;
                name.setValue(value, {
                    property: prefix,
                    itemIndex: itemIndex
                });
                return name;
            }
        },
        {
            key: "getValue",
            value: function getValue(prefix, keyOrRef) {
                var vs = this._values[prefix];
                if (!vs) return;
                return vs.get(keyOrRef);
            }
        },
        {
            key: "scopeRefs",
            value: function scopeRefs(scopeName) {
                var values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._values;
                return this._reduceValues(values, function(name) {
                    if (name.scopePath === undefined) throw new Error('CodeGen: name "'.concat(name, '" has no value'));
                    return (0, $6go2u._)($4f130f6ce33ff743$var$_templateObject2(), scopeName, name.scopePath);
                });
            }
        },
        {
            key: "scopeCode",
            value: function scopeCode() {
                var values = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._values, usedValues = arguments.length > 1 ? arguments[1] : void 0, getCode = arguments.length > 2 ? arguments[2] : void 0;
                return this._reduceValues(values, function(name) {
                    if (name.value === undefined) throw new Error('CodeGen: name "'.concat(name, '" has no value'));
                    return name.value.code;
                }, usedValues, getCode);
            }
        },
        {
            key: "_reduceValues",
            value: function _reduceValues(values, valueCode) {
                var _loop = function(prefix) {
                    var vs = values[prefix];
                    if (!vs) return "continue";
                    var nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
                    vs.forEach(function(name) {
                        if (nameSet.has(name)) return;
                        nameSet.set(name, $4f130f6ce33ff743$var$UsedValueState.Started);
                        var c = valueCode(name);
                        if (c) {
                            var def = _this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                            code = (0, $6go2u._)($4f130f6ce33ff743$var$_templateObject3(), code, def, name, c, _this.opts._n);
                        } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $6go2u._)($4f130f6ce33ff743$var$_templateObject4(), code, c, _this.opts._n);
                        else throw new $4f130f6ce33ff743$var$ValueError(name);
                        nameSet.set(name, $4f130f6ce33ff743$var$UsedValueState.Completed);
                    });
                };
                var usedValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, getCode = arguments.length > 3 ? arguments[3] : void 0;
                var _this = this;
                var code = $6go2u.nil;
                for(var prefix in values)_loop(prefix);
                return code;
            }
        }
    ]);
    return ValueScope;
}($4f130f6ce33ff743$var$Scope);
module.exports.ValueScope = $4f130f6ce33ff743$var$ValueScope;

});


parcelRequire.register("eKI5Q", function(module, exports) {

var $hF4Ve = parcelRequire("hF4Ve");

var $bmZve = parcelRequire("bmZve");
"use strict";
function $abd7909132a0cba0$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        "",
        "",
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " !== true && ",
        " !== undefined"
    ]);
    $abd7909132a0cba0$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " === true"
    ]);
    $abd7909132a0cba0$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " || {}"
    ]);
    $abd7909132a0cba0$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "Object.assign(",
        ", ",
        ")"
    ]);
    $abd7909132a0cba0$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        " !== true"
    ]);
    $abd7909132a0cba0$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        " || {}"
    ]);
    $abd7909132a0cba0$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        " !== true && ",
        " !== undefined"
    ]);
    $abd7909132a0cba0$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        " === true ? true : ",
        " > ",
        " ? ",
        " : ",
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "",
        " !== true"
    ]);
    $abd7909132a0cba0$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        " > ",
        " ? ",
        " : ",
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "{}"
    ]);
    $abd7909132a0cba0$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject14() {
    var data = (0, $bmZve._)([
        '"[" + ',
        ' + "]"'
    ]);
    $abd7909132a0cba0$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject15() {
    var data = (0, $bmZve._)([
        '"[\'" + ',
        ' + "\']"'
    ]);
    $abd7909132a0cba0$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject16() {
    var data = (0, $bmZve._)([
        '"/" + ',
        ""
    ]);
    $abd7909132a0cba0$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $abd7909132a0cba0$var$_templateObject17() {
    var data = (0, $bmZve._)([
        '"/" + ',
        '.replace(/~/g, "~0").replace(/\\//g, "~1")'
    ], [
        '"/" + ',
        '.replace(/~/g, "~0").replace(/\\\\//g, "~1")'
    ]);
    $abd7909132a0cba0$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $6go2u = parcelRequire("6go2u");
// TODO refactor to use Set
function $abd7909132a0cba0$var$toHash(arr) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            hash[item] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hash;
}
module.exports.toHash = $abd7909132a0cba0$var$toHash;
function $abd7909132a0cba0$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $abd7909132a0cba0$var$checkUnknownRules(it, schema);
    return !$abd7909132a0cba0$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $abd7909132a0cba0$var$alwaysValidSchema;
function $abd7909132a0cba0$var$checkUnknownRules(it) {
    var schema = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : it.schema;
    var opts = it.opts, self = it.self;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    var rules = self.RULES.keywords;
    for(var key in schema)if (!rules[key]) $abd7909132a0cba0$var$checkStrictMode(it, 'unknown keyword: "'.concat(key, '"'));
}
module.exports.checkUnknownRules = $abd7909132a0cba0$var$checkUnknownRules;
function $abd7909132a0cba0$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(var key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $abd7909132a0cba0$var$schemaHasRules;
function $abd7909132a0cba0$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(var key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $abd7909132a0cba0$var$schemaHasRulesButRef;
function $abd7909132a0cba0$var$schemaRefOrVal(param, schema, keyword, $data) {
    var topSchemaRef = param.topSchemaRef, schemaPath = param.schemaPath;
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject(), schema);
    }
    return (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject1(), topSchemaRef, schemaPath, (0, $3Ar5a.getProperty)(keyword));
}
module.exports.schemaRefOrVal = $abd7909132a0cba0$var$schemaRefOrVal;
function $abd7909132a0cba0$var$unescapeFragment(str) {
    return $abd7909132a0cba0$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $abd7909132a0cba0$var$unescapeFragment;
function $abd7909132a0cba0$var$escapeFragment(str) {
    return encodeURIComponent($abd7909132a0cba0$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $abd7909132a0cba0$var$escapeFragment;
function $abd7909132a0cba0$var$escapeJsonPointer(str) {
    if (typeof str == "number") return "".concat(str);
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $abd7909132a0cba0$var$escapeJsonPointer;
function $abd7909132a0cba0$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $abd7909132a0cba0$var$unescapeJsonPointer;
function $abd7909132a0cba0$var$eachItem(xs, f) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (Array.isArray(xs)) try {
        for(var _iterator = xs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var x = _step.value;
            f(x);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else f(xs);
}
module.exports.eachItem = $abd7909132a0cba0$var$eachItem;
function $abd7909132a0cba0$var$makeMergeEvaluated(param) {
    var mergeNames = param.mergeNames, mergeToName = param.mergeToName, mergeValues = param.mergeValues, resultToName = param.resultToName;
    return function(gen, from, to, toName) {
        var res = to === undefined ? from : to instanceof $3Ar5a.Name ? (from instanceof $3Ar5a.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $3Ar5a.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $3Ar5a.Name && !(res instanceof $3Ar5a.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $abd7909132a0cba0$var$makeMergeEvaluated({
        mergeNames: function(gen, from, to) {
            return gen.if((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject2(), to, from), function() {
                gen.if((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject3(), from), function() {
                    return gen.assign(to, true);
                }, function() {
                    return gen.assign(to, (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject4(), to)).code((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject5(), to, from));
                });
            });
        },
        mergeToName: function(gen, from, to) {
            return gen.if((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject6(), to), function() {
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject7(), to));
                    $abd7909132a0cba0$var$setEvaluated(gen, to, from);
                }
            });
        },
        mergeValues: function(from, to) {
            return from === true ? true : (0, $hF4Ve._)({}, from, to);
        },
        resultToName: $abd7909132a0cba0$var$evaluatedPropsToName
    }),
    items: $abd7909132a0cba0$var$makeMergeEvaluated({
        mergeNames: function(gen, from, to) {
            return gen.if((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject8(), to, from), function() {
                return gen.assign(to, (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject9(), from, to, from, to, from));
            });
        },
        mergeToName: function(gen, from, to) {
            return gen.if((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject10(), to), function() {
                return gen.assign(to, from === true ? true : (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject11(), to, from, to, from));
            });
        },
        mergeValues: function(from, to) {
            return from === true ? true : Math.max(from, to);
        },
        resultToName: function(gen, items) {
            return gen.var("items", items);
        }
    })
};
function $abd7909132a0cba0$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    var props = gen.var("props", (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject12()));
    if (ps !== undefined) $abd7909132a0cba0$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $abd7909132a0cba0$var$evaluatedPropsToName;
function $abd7909132a0cba0$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach(function(p) {
        return gen.assign((0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject13(), props, (0, $3Ar5a.getProperty)(p)), true);
    });
}
module.exports.setEvaluated = $abd7909132a0cba0$var$setEvaluated;
var $abd7909132a0cba0$var$snippets = {};
function $abd7909132a0cba0$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $abd7909132a0cba0$var$snippets[f.code] || ($abd7909132a0cba0$var$snippets[f.code] = new $6go2u._Code(f.code))
    });
}
module.exports.useFunc = $abd7909132a0cba0$var$useFunc;
var $abd7909132a0cba0$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($abd7909132a0cba0$var$Type = module.exports.Type || (module.exports.Type = {}));
function $abd7909132a0cba0$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $3Ar5a.Name) {
        var isNumber = dataPropType === $abd7909132a0cba0$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject14(), dataProp) : (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject15(), dataProp) : isNumber ? (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject16(), dataProp) : (0, $3Ar5a._)($abd7909132a0cba0$var$_templateObject17(), dataProp); // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $3Ar5a.getProperty)(dataProp).toString() : "/" + $abd7909132a0cba0$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $abd7909132a0cba0$var$getErrorPath;
function $abd7909132a0cba0$var$checkStrictMode(it, msg) {
    var mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : it.opts.strictSchema;
    if (!mode) return;
    msg = "strict mode: ".concat(msg);
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $abd7909132a0cba0$var$checkStrictMode;

});

parcelRequire.register("cuzEW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $9183f295630a8a7b$var$names = {
    // validation function arguments
    data: new $3Ar5a.Name("data"),
    // args passed from referencing schema
    valCxt: new $3Ar5a.Name("valCxt"),
    instancePath: new $3Ar5a.Name("instancePath"),
    parentData: new $3Ar5a.Name("parentData"),
    parentDataProperty: new $3Ar5a.Name("parentDataProperty"),
    rootData: new $3Ar5a.Name("rootData"),
    dynamicAnchors: new $3Ar5a.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $3Ar5a.Name("vErrors"),
    errors: new $3Ar5a.Name("errors"),
    this: new $3Ar5a.Name("this"),
    // "globals"
    self: new $3Ar5a.Name("self"),
    scope: new $3Ar5a.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $3Ar5a.Name("json"),
    jsonPos: new $3Ar5a.Name("jsonPos"),
    jsonLen: new $3Ar5a.Name("jsonLen"),
    jsonPart: new $3Ar5a.Name("jsonPart")
};
module.exports.default = $9183f295630a8a7b$var$names;

});



parcelRequire.register("96OdM", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $6a1ba18332a89962$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ' == "number" || ',
        ' == "boolean"'
    ]);
    $6a1ba18332a89962$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject1() {
    var data = (0, $bmZve._)([
        '"" + ',
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " === null"
    ]);
    $6a1ba18332a89962$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject3() {
    var data = (0, $bmZve._)([
        '""'
    ]);
    $6a1ba18332a89962$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        ' == "boolean" || ',
        " === null\n              || (",
        ' == "string" && ',
        " && ",
        " == +",
        ")"
    ]);
    $6a1ba18332a89962$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "+",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        ' === "boolean" || ',
        " === null\n              || (",
        ' === "string" && ',
        " && ",
        " == +",
        " && !(",
        " % 1))"
    ]);
    $6a1ba18332a89962$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "+",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ' === "false" || ',
        " === 0 || ",
        " === null"
    ]);
    $6a1ba18332a89962$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ' === "true" || ',
        " === 1"
    ]);
    $6a1ba18332a89962$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "",
        ' === "" || ',
        " === 0 || ",
        " === false"
    ]);
    $6a1ba18332a89962$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        ' === "string" || ',
        ' === "number"\n              || ',
        ' === "boolean" || ',
        " === null"
    ]);
    $6a1ba18332a89962$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "[",
        "]"
    ]);
    $6a1ba18332a89962$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "typeof ",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "undefined"
    ]);
    $6a1ba18332a89962$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject15() {
    var data = (0, $bmZve._)([
        "",
        " == 'object' && Array.isArray(",
        ") && ",
        ".length == 1"
    ]);
    $6a1ba18332a89962$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject16() {
    var data = (0, $bmZve._)([
        "",
        "[0]"
    ]);
    $6a1ba18332a89962$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject17() {
    var data = (0, $bmZve._)([
        "typeof ",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject18() {
    var data = (0, $bmZve._)([
        "",
        " !== undefined"
    ]);
    $6a1ba18332a89962$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject19() {
    var data = (0, $bmZve._)([
        "",
        " !== undefined"
    ]);
    $6a1ba18332a89962$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject20() {
    var data = (0, $bmZve._)([
        "",
        " !== undefined"
    ]);
    $6a1ba18332a89962$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject21() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $6a1ba18332a89962$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject22() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' == "number"'
    ]);
    $6a1ba18332a89962$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject23() {
    var data = (0, $bmZve._)([
        "isFinite(",
        ")"
    ]);
    $6a1ba18332a89962$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject24() {
    var data = (0, $bmZve._)([
        "",
        " ",
        " null"
    ]);
    $6a1ba18332a89962$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject25() {
    var data = (0, $bmZve._)([
        "Array.isArray(",
        ")"
    ]);
    $6a1ba18332a89962$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject26() {
    var data = (0, $bmZve._)([
        "",
        " && typeof ",
        ' == "object" && !Array.isArray(',
        ")"
    ]);
    $6a1ba18332a89962$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject27() {
    var data = (0, $bmZve._)([
        "!(",
        " % 1) && !isNaN(",
        ")"
    ]);
    $6a1ba18332a89962$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject28() {
    var data = (0, $bmZve._)([
        "typeof ",
        " ",
        " ",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject29() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' != "object"'
    ]);
    $6a1ba18332a89962$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject30() {
    var data = (0, $bmZve._)([
        "!",
        " || ",
        ""
    ]);
    $6a1ba18332a89962$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject31() {
    var data = (0, $bmZve._)([
        "{type: ",
        "}"
    ]);
    $6a1ba18332a89962$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a1ba18332a89962$var$_templateObject32() {
    var data = (0, $bmZve._)([
        "{type: ",
        "}"
    ]);
    $6a1ba18332a89962$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $7w8WR = parcelRequire("7w8WR");

var $7qhzc = parcelRequire("7qhzc");

var $4Rc5N = parcelRequire("4Rc5N");

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $6a1ba18332a89962$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($6a1ba18332a89962$var$DataType = module.exports.DataType || (module.exports.DataType = {}));
function $6a1ba18332a89962$var$getSchemaTypes(schema) {
    var types = $6a1ba18332a89962$var$getJSONTypes(schema.type);
    var hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $6a1ba18332a89962$var$getSchemaTypes;
function $6a1ba18332a89962$var$getJSONTypes(ts) {
    var types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($7w8WR.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $6a1ba18332a89962$var$getJSONTypes;
function $6a1ba18332a89962$var$coerceAndCheckDataType(it, types) {
    var gen = it.gen, data = it.data, opts = it.opts;
    var coerceTo = $6a1ba18332a89962$var$coerceToTypes(types, opts.coerceTypes);
    var checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $7qhzc.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        var wrongType = $6a1ba18332a89962$var$checkDataTypes(types, data, opts.strictNumbers, $6a1ba18332a89962$var$DataType.Wrong);
        gen.if(wrongType, function() {
            if (coerceTo.length) $6a1ba18332a89962$var$coerceData(it, types, coerceTo);
            else $6a1ba18332a89962$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $6a1ba18332a89962$var$coerceAndCheckDataType;
var $6a1ba18332a89962$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $6a1ba18332a89962$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter(function(t) {
        return $6a1ba18332a89962$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array";
    }) : [];
}
function $6a1ba18332a89962$var$coerceData(it, types, coerceTo) {
    var coerceSpecificType = function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject(), dataType, dataType)).assign(coerced, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject1(), data)).elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject2(), data)).assign(coerced, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject3()));
                return;
            case "number":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject4(), dataType, data, dataType, data, data, data)).assign(coerced, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject5(), data));
                return;
            case "integer":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject6(), dataType, data, dataType, data, data, data, data)).assign(coerced, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject7(), data));
                return;
            case "boolean":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject8(), data, data, data)).assign(coerced, false).elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject9(), data, data)).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject10(), data, data, data));
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject11(), dataType, dataType, dataType, data)).assign(coerced, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject12(), data));
        }
    };
    var gen = it.gen, data = it.data, opts = it.opts;
    var dataType = gen.let("dataType", (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject13(), data));
    var coerced = gen.let("coerced", (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject14()));
    if (opts.coerceTypes === "array") gen.if((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject15(), dataType, data, data), function() {
        return gen.assign(data, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject16(), data)).assign(dataType, (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject17(), data)).if($6a1ba18332a89962$var$checkDataTypes(types, data, opts.strictNumbers), function() {
            return gen.assign(coerced, data);
        });
    });
    gen.if((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject18(), coerced));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = coerceTo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if ($6a1ba18332a89962$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    gen.else();
    $6a1ba18332a89962$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject19(), coerced), function() {
        gen.assign(data, coerced);
        $6a1ba18332a89962$var$assignParentData(it, coerced);
    });
}
function $6a1ba18332a89962$var$assignParentData(param, expr) {
    var gen = param.gen, parentData = param.parentData, parentDataProperty = param.parentDataProperty;
    // TODO use gen.property
    gen.if((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject20(), parentData), function() {
        return gen.assign((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject21(), parentData, parentDataProperty), expr);
    });
}
function $6a1ba18332a89962$var$checkDataType(dataType, data, strictNums) {
    var correct = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $6a1ba18332a89962$var$DataType.Correct;
    var numCond = function numCond() {
        var _cond = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $3Ar5a.nil;
        return (0, $3Ar5a.and)((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject22(), data), _cond, strictNums ? (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject23(), data) : $3Ar5a.nil);
    };
    var EQ = correct === $6a1ba18332a89962$var$DataType.Correct ? $3Ar5a.operators.EQ : $3Ar5a.operators.NEQ;
    var cond;
    switch(dataType){
        case "null":
            return (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject24(), data, EQ);
        case "array":
            cond = (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject25(), data);
            break;
        case "object":
            cond = (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject26(), data, data, data);
            break;
        case "integer":
            cond = numCond((0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject27(), data, data));
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject28(), data, EQ, dataType);
    }
    return correct === $6a1ba18332a89962$var$DataType.Correct ? cond : (0, $3Ar5a.not)(cond);
}
module.exports.checkDataType = $6a1ba18332a89962$var$checkDataType;
function $6a1ba18332a89962$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $6a1ba18332a89962$var$checkDataType(dataTypes[0], data, strictNums, correct);
    var cond;
    var types = (0, $eKI5Q.toHash)(dataTypes);
    if (types.array && types.object) {
        var notObj = (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject29(), data);
        cond = types.null ? notObj : (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject30(), data, notObj);
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $3Ar5a.nil;
    if (types.number) delete types.integer;
    for(var t in types)cond = (0, $3Ar5a.and)(cond, $6a1ba18332a89962$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $6a1ba18332a89962$var$checkDataTypes;
var $6a1ba18332a89962$var$typeError = {
    message: function(param) {
        var schema = param.schema;
        return "must be ".concat(schema);
    },
    params: function(param) {
        var schema = param.schema, schemaValue = param.schemaValue;
        return typeof schema == "string" ? (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject31(), schema) : (0, $3Ar5a._)($6a1ba18332a89962$var$_templateObject32(), schemaValue);
    }
};
function $6a1ba18332a89962$var$reportTypeError(it) {
    var cxt = $6a1ba18332a89962$var$getTypeErrorContext(it);
    (0, $4Rc5N.reportError)(cxt, $6a1ba18332a89962$var$typeError);
}
module.exports.reportTypeError = $6a1ba18332a89962$var$reportTypeError;
function $6a1ba18332a89962$var$getTypeErrorContext(it) {
    var gen = it.gen, data = it.data, schema = it.schema;
    var schemaCode = (0, $eKI5Q.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRequire.register("7w8WR", function(module, exports) {

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
var $579276800b1c322a$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
var $579276800b1c322a$var$jsonTypes = new Set($579276800b1c322a$var$_jsonTypes);
function $579276800b1c322a$var$isJSONType(x) {
    return typeof x == "string" && $579276800b1c322a$var$jsonTypes.has(x);
}
module.exports.isJSONType = $579276800b1c322a$var$isJSONType;
function $579276800b1c322a$var$getRules() {
    var groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: (0, $cpUXF._)((0, $hF4Ve._)({}, groups), {
            integer: true,
            boolean: true,
            null: true
        }),
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $579276800b1c322a$var$getRules;

});

parcelRequire.register("7qhzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $56789683b2964e07$var$schemaHasRulesForType(param, type) {
    var schema = param.schema, self = param.self;
    var group = self.RULES.types[type];
    return group && group !== true && $56789683b2964e07$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $56789683b2964e07$var$schemaHasRulesForType;
function $56789683b2964e07$var$shouldUseGroup(schema, group) {
    return group.rules.some(function(rule) {
        return $56789683b2964e07$var$shouldUseRule(schema, rule);
    });
}
module.exports.shouldUseGroup = $56789683b2964e07$var$shouldUseGroup;
function $56789683b2964e07$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some(function(kwd) {
        return schema[kwd] !== undefined;
    }));
}
module.exports.shouldUseRule = $56789683b2964e07$var$shouldUseRule;

});


parcelRequire.register("7mc8C", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $55b400d387ad66cc$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $55b400d387ad66cc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $55b400d387ad66cc$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " === undefined"
    ]);
    $55b400d387ad66cc$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $55b400d387ad66cc$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " || ",
        " === null || ",
        ' === ""'
    ]);
    $55b400d387ad66cc$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $55b400d387ad66cc$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " = ",
        ""
    ]);
    $55b400d387ad66cc$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
function $55b400d387ad66cc$var$assignDefaults(it, ty) {
    var _it_schema = it.schema, properties = _it_schema.properties, items = _it_schema.items;
    if (ty === "object" && properties) for(var key in properties)$55b400d387ad66cc$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach(function(sch, i) {
        return $55b400d387ad66cc$var$assignDefault(it, i, sch.default);
    });
}
module.exports.assignDefaults = $55b400d387ad66cc$var$assignDefaults;
function $55b400d387ad66cc$var$assignDefault(it, prop, defaultValue) {
    var gen = it.gen, compositeRule = it.compositeRule, data = it.data, opts = it.opts;
    if (defaultValue === undefined) return;
    var childData = (0, $3Ar5a._)($55b400d387ad66cc$var$_templateObject(), data, (0, $3Ar5a.getProperty)(prop));
    if (compositeRule) {
        (0, $eKI5Q.checkStrictMode)(it, "default is ignored for: ".concat(childData));
        return;
    }
    var condition = (0, $3Ar5a._)($55b400d387ad66cc$var$_templateObject1(), childData);
    if (opts.useDefaults === "empty") condition = (0, $3Ar5a._)($55b400d387ad66cc$var$_templateObject2(), condition, childData, childData);
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $3Ar5a._)($55b400d387ad66cc$var$_templateObject3(), childData, (0, $3Ar5a.stringify)(defaultValue)));
}

});

parcelRequire.register("8sJhM", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $5F2Q2 = parcelRequire("5F2Q2");
"use strict";
function $6294111484f1d32f$var$_templateObject() {
    var data = (0, $bmZve._)([
        "await "
    ]);
    $6294111484f1d32f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " instanceof ",
        ""
    ]);
    $6294111484f1d32f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $6294111484f1d32f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $6294111484f1d32f$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "await "
    ]);
    $6294111484f1d32f$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $6294111484f1d32f$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $6294111484f1d32f$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "Array.isArray(",
        ")"
    ]);
    $6294111484f1d32f$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        " === null ? ",
        " : ",
        ".concat(",
        ")"
    ]);
    $6294111484f1d32f$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $6294111484f1d32f$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $6294111484f1d32f$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $cuzEW = parcelRequire("cuzEW");

var $d3q0m = parcelRequire("d3q0m");

var $4Rc5N = parcelRequire("4Rc5N");
function $6294111484f1d32f$var$macroKeywordCode(cxt, def) {
    var gen = cxt.gen, keyword = cxt.keyword, schema = cxt.schema, parentSchema = cxt.parentSchema, it = cxt.it;
    var macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    var schemaRef = $6294111484f1d32f$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    var valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $3Ar5a.nil,
        errSchemaPath: "".concat(it.errSchemaPath, "/").concat(keyword),
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, function() {
        return cxt.error(true);
    });
}
module.exports.macroKeywordCode = $6294111484f1d32f$var$macroKeywordCode;
function $6294111484f1d32f$var$funcKeywordCode(cxt, def) {
    var validateKeyword = function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $6294111484f1d32f$var$modifyData(cxt);
            reportErrs(function() {
                return cxt.error();
            });
        } else {
            var ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $6294111484f1d32f$var$modifyData(cxt);
            reportErrs(function() {
                return $6294111484f1d32f$var$addErrs(cxt, ruleErrs);
            });
        }
    };
    var validateAsync = function validateAsync() {
        var ruleErrs = gen.let("ruleErrs", null);
        gen.try(function() {
            return assignValid((0, $3Ar5a._)($6294111484f1d32f$var$_templateObject()));
        }, function(e) {
            return gen.assign(valid, false).if((0, $3Ar5a._)($6294111484f1d32f$var$_templateObject1(), e, it.ValidationError), function() {
                return gen.assign(ruleErrs, (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject2(), e));
            }, function() {
                return gen.throw(e);
            });
        });
        return ruleErrs;
    };
    var validateSync = function validateSync() {
        var validateErrs = (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject3(), validateRef);
        gen.assign(validateErrs, null);
        assignValid($3Ar5a.nil);
        return validateErrs;
    };
    var assignValid = function assignValid() {
        var _await = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : def.async ? (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject4()) : $3Ar5a.nil;
        var passCxt = it.opts.passContext ? $cuzEW.default.this : $cuzEW.default.self;
        var passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject5(), _await, (0, $d3q0m.callValidateCode)(cxt, validateRef, passCxt, passSchema)), def.modifying);
    };
    var reportErrs = function reportErrs(errors) {
        var _a;
        gen.if((0, $3Ar5a.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    };
    var _a;
    var gen = cxt.gen, keyword = cxt.keyword, schema = cxt.schema, parentSchema = cxt.parentSchema, $data = cxt.$data, it = cxt.it;
    $6294111484f1d32f$var$checkAsyncKeyword(it, def);
    var validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    var validateRef = $6294111484f1d32f$var$useKeyword(gen, keyword, validate);
    var valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
}
module.exports.funcKeywordCode = $6294111484f1d32f$var$funcKeywordCode;
function $6294111484f1d32f$var$modifyData(cxt) {
    var gen = cxt.gen, data = cxt.data, it = cxt.it;
    gen.if(it.parentData, function() {
        return gen.assign(data, (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject6(), it.parentData, it.parentDataProperty));
    });
}
function $6294111484f1d32f$var$addErrs(cxt, errs) {
    var gen = cxt.gen;
    gen.if((0, $3Ar5a._)($6294111484f1d32f$var$_templateObject7(), errs), function() {
        gen.assign($cuzEW.default.vErrors, (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject8(), $cuzEW.default.vErrors, errs, $cuzEW.default.vErrors, errs)).assign($cuzEW.default.errors, (0, $3Ar5a._)($6294111484f1d32f$var$_templateObject9(), $cuzEW.default.vErrors));
        (0, $4Rc5N.extendErrors)(cxt);
    }, function() {
        return cxt.error();
    });
}
function $6294111484f1d32f$var$checkAsyncKeyword(param, def) {
    var schemaEnv = param.schemaEnv;
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $6294111484f1d32f$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error('keyword "'.concat(keyword, '" failed to compile'));
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $3Ar5a.stringify)(result)
    });
}
function $6294111484f1d32f$var$validSchemaType(schema, schemaType) {
    var allowUndefined = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // TODO add tests
    return !schemaType.length || schemaType.some(function(st) {
        return st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : (typeof schema === "undefined" ? "undefined" : (0, $5F2Q2._)(schema)) == st || allowUndefined && typeof schema == "undefined";
    });
}
module.exports.validSchemaType = $6294111484f1d32f$var$validSchemaType;
function $6294111484f1d32f$var$validateKeywordUsage(param, def, keyword) {
    var schema = param.schema, opts = param.opts, self = param.self, errSchemaPath = param.errSchemaPath;
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    var deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some(function(kwd) {
        return !Object.prototype.hasOwnProperty.call(schema, kwd);
    })) throw new Error("parent schema must have dependencies of ".concat(keyword, ": ").concat(deps.join(",")));
    if (def.validateSchema) {
        var valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            var msg = 'keyword "'.concat(keyword, '" value is invalid at path "').concat(errSchemaPath, '": ') + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $6294111484f1d32f$var$validateKeywordUsage;

});
parcelRequire.register("d3q0m", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");
"use strict";
function $980fba335b4f9a62$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " = ",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "Object.prototype.hasOwnProperty"
    ]);
    $980fba335b4f9a62$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        ".call(",
        ", ",
        ")"
    ]);
    $980fba335b4f9a62$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        "",
        " !== undefined"
    ]);
    $980fba335b4f9a62$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        " && ",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        "",
        " === undefined"
    ]);
    $980fba335b4f9a62$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        ", ",
        ", ",
        "",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ", ",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ".call(",
        ", ",
        ")"
    ]);
    $980fba335b4f9a62$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ")"
    ]);
    $980fba335b4f9a62$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "new RegExp"
    ]);
    $980fba335b4f9a62$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ", ",
        ")"
    ]);
    $980fba335b4f9a62$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $980fba335b4f9a62$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $980fba335b4f9a62$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "",
        " || ",
        ""
    ]);
    $980fba335b4f9a62$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $cuzEW = parcelRequire("cuzEW");

var $eKI5Q = parcelRequire("eKI5Q");
function $980fba335b4f9a62$var$checkReportMissingProp(cxt, prop) {
    var gen = cxt.gen, data = cxt.data, it = cxt.it;
    gen.if($980fba335b4f9a62$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), function() {
        cxt.setParams({
            missingProperty: (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject(), prop)
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $980fba335b4f9a62$var$checkReportMissingProp;
function $980fba335b4f9a62$var$checkMissingProp(param, properties, missing) {
    var gen = param.gen, data = param.data, opts = param.it.opts;
    return (0, $3Ar5a.or).apply(this, (0, $h9dQc._)(properties.map(function(prop) {
        return (0, $3Ar5a.and)($980fba335b4f9a62$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject1(), missing, prop));
    })));
}
module.exports.checkMissingProp = $980fba335b4f9a62$var$checkMissingProp;
function $980fba335b4f9a62$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $980fba335b4f9a62$var$reportMissingProp;
function $980fba335b4f9a62$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject2())
    });
}
module.exports.hasPropFunc = $980fba335b4f9a62$var$hasPropFunc;
function $980fba335b4f9a62$var$isOwnProperty(gen, data, property) {
    return (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject3(), $980fba335b4f9a62$var$hasPropFunc(gen), data, property);
}
module.exports.isOwnProperty = $980fba335b4f9a62$var$isOwnProperty;
function $980fba335b4f9a62$var$propertyInData(gen, data, property, ownProperties) {
    var cond = (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject4(), data, (0, $3Ar5a.getProperty)(property));
    return ownProperties ? (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject5(), cond, $980fba335b4f9a62$var$isOwnProperty(gen, data, property)) : cond;
}
module.exports.propertyInData = $980fba335b4f9a62$var$propertyInData;
function $980fba335b4f9a62$var$noPropertyInData(gen, data, property, ownProperties) {
    var cond = (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject6(), data, (0, $3Ar5a.getProperty)(property));
    return ownProperties ? (0, $3Ar5a.or)(cond, (0, $3Ar5a.not)($980fba335b4f9a62$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $980fba335b4f9a62$var$noPropertyInData;
function $980fba335b4f9a62$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter(function(p) {
        return p !== "__proto__";
    }) : [];
}
module.exports.allSchemaProperties = $980fba335b4f9a62$var$allSchemaProperties;
function $980fba335b4f9a62$var$schemaProperties(it, schemaMap) {
    return $980fba335b4f9a62$var$allSchemaProperties(schemaMap).filter(function(p) {
        return !(0, $eKI5Q.alwaysValidSchema)(it, schemaMap[p]);
    });
}
module.exports.schemaProperties = $980fba335b4f9a62$var$schemaProperties;
function $980fba335b4f9a62$var$callValidateCode(param, func, context, passSchema) {
    var schemaCode = param.schemaCode, data = param.data, _param_it = param.it, gen = _param_it.gen, topSchemaRef = _param_it.topSchemaRef, schemaPath = _param_it.schemaPath, errorPath = _param_it.errorPath, it = param.it;
    var _gen;
    var dataAndSchema = passSchema ? (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject7(), schemaCode, data, topSchemaRef, schemaPath) : data;
    var valCxt = [
        [
            $cuzEW.default.instancePath,
            (0, $3Ar5a.strConcat)($cuzEW.default.instancePath, errorPath)
        ],
        [
            $cuzEW.default.parentData,
            it.parentData
        ],
        [
            $cuzEW.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $cuzEW.default.rootData,
            $cuzEW.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $cuzEW.default.dynamicAnchors,
        $cuzEW.default.dynamicAnchors
    ]);
    var args = (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject8(), dataAndSchema, (_gen = gen).object.apply(_gen, (0, $h9dQc._)(valCxt)));
    return context !== $3Ar5a.nil ? (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject9(), func, context, args) : (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject10(), func, args);
}
module.exports.callValidateCode = $980fba335b4f9a62$var$callValidateCode;
var $980fba335b4f9a62$var$newRegExp = (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject11());
function $980fba335b4f9a62$var$usePattern(param, pattern) {
    var gen = param.gen, opts = param.it.opts;
    var u = opts.unicodeRegExp ? "u" : "";
    var regExp = opts.code.regExp;
    var rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject12(), regExp.code === "new RegExp" ? $980fba335b4f9a62$var$newRegExp : (0, $eKI5Q.useFunc)(gen, regExp), pattern, u)
    });
}
module.exports.usePattern = $980fba335b4f9a62$var$usePattern;
function $980fba335b4f9a62$var$validateArray(cxt) {
    var validateItems = function validateItems(notValid) {
        var len = gen.const("len", (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject13(), data));
        gen.forRange("i", 0, len, function(i) {
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $eKI5Q.Type.Num
            }, valid);
            gen.if((0, $3Ar5a.not)(valid), notValid);
        });
    };
    var gen = cxt.gen, data = cxt.data, keyword = cxt.keyword, it = cxt.it;
    var valid = gen.name("valid");
    if (it.allErrors) {
        var validArr = gen.let("valid", true);
        validateItems(function() {
            return gen.assign(validArr, false);
        });
        return validArr;
    }
    gen.var(valid, true);
    validateItems(function() {
        return gen.break();
    });
    return valid;
}
module.exports.validateArray = $980fba335b4f9a62$var$validateArray;
function $980fba335b4f9a62$var$validateUnion(cxt) {
    var gen = cxt.gen, schema = cxt.schema, keyword = cxt.keyword, it = cxt.it;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    var alwaysValid = schema.some(function(sch) {
        return (0, $eKI5Q.alwaysValidSchema)(it, sch);
    });
    if (alwaysValid && !it.opts.unevaluated) return;
    var valid = gen.let("valid", false);
    var schValid = gen.name("_valid");
    gen.block(function() {
        return schema.forEach(function(_sch, i) {
            var schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $3Ar5a._)($980fba335b4f9a62$var$_templateObject14(), valid, schValid));
            var merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $3Ar5a.not)(valid));
        });
    });
    cxt.result(valid, function() {
        return cxt.reset();
    }, function() {
        return cxt.error(true);
    });
}
module.exports.validateUnion = $980fba335b4f9a62$var$validateUnion;

});


parcelRequire.register("8ANrm", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");
"use strict";
function $6418095b80037cd3$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $6418095b80037cd3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6418095b80037cd3$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        "",
        "",
        ""
    ]);
    $6418095b80037cd3$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6418095b80037cd3$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $6418095b80037cd3$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $6418095b80037cd3$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $6418095b80037cd3$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $6418095b80037cd3$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        ""
    ]);
    $6418095b80037cd3$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
function $6418095b80037cd3$var$getSubschema(it, param) {
    var keyword = param.keyword, schemaProp = param.schemaProp, schema = param.schema, schemaPath = param.schemaPath, errSchemaPath = param.errSchemaPath, topSchemaRef = param.topSchemaRef;
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        var sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $3Ar5a._)($6418095b80037cd3$var$_templateObject(), it.schemaPath, (0, $3Ar5a.getProperty)(keyword)),
            errSchemaPath: "".concat(it.errSchemaPath, "/").concat(keyword)
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $3Ar5a._)($6418095b80037cd3$var$_templateObject1(), it.schemaPath, (0, $3Ar5a.getProperty)(keyword), (0, $3Ar5a.getProperty)(schemaProp)),
            errSchemaPath: "".concat(it.errSchemaPath, "/").concat(keyword, "/").concat((0, $eKI5Q.escapeFragment)(schemaProp))
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $6418095b80037cd3$var$getSubschema;
function $6418095b80037cd3$var$extendSubschemaData(subschema, it, param) {
    var dataProp = param.dataProp, dpType = param.dataPropType, data = param.data, dataTypes = param.dataTypes, propertyName = param.propertyName;
    var dataContextProps = function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = (0, $h9dQc._)(it.dataNames).concat([
            _nextData
        ]);
    };
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    var gen = it.gen;
    if (dataProp !== undefined) {
        var errorPath = it.errorPath, dataPathArr = it.dataPathArr, opts = it.opts;
        var nextData = gen.let("data", (0, $3Ar5a._)($6418095b80037cd3$var$_templateObject2(), it.data, (0, $3Ar5a.getProperty)(dataProp)), true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $3Ar5a.str)($6418095b80037cd3$var$_templateObject3(), errorPath, (0, $eKI5Q.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax));
        subschema.parentDataProperty = (0, $3Ar5a._)($6418095b80037cd3$var$_templateObject4(), dataProp);
        subschema.dataPathArr = (0, $h9dQc._)(dataPathArr).concat([
            subschema.parentDataProperty
        ]);
    }
    if (data !== undefined) {
        var nextData1 = data instanceof $3Ar5a.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData1);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
}
module.exports.extendSubschemaData = $6418095b80037cd3$var$extendSubschemaData;
function $6418095b80037cd3$var$extendSubschemaMode(subschema, param) {
    var jtdDiscriminator = param.jtdDiscriminator, jtdMetadata = param.jtdMetadata, compositeRule = param.compositeRule, createErrors = param.createErrors, allErrors = param.allErrors;
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $6418095b80037cd3$var$extendSubschemaMode;

});

parcelRequire.register("b6Wgf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $eKI5Q = parcelRequire("eKI5Q");

var $3rDtx = parcelRequire("3rDtx");

var $bJlRI = parcelRequire("bJlRI");
// TODO refactor to use keyword definitions
var $816d72a97f4d3c1f$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $816d72a97f4d3c1f$var$inlineRef(schema) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$816d72a97f4d3c1f$var$hasRef(schema);
    if (!limit) return false;
    return $816d72a97f4d3c1f$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $816d72a97f4d3c1f$var$inlineRef;
var $816d72a97f4d3c1f$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $816d72a97f4d3c1f$var$hasRef(schema) {
    for(var key in schema){
        if ($816d72a97f4d3c1f$var$REF_KEYWORDS.has(key)) return true;
        var sch = schema[key];
        if (Array.isArray(sch) && sch.some($816d72a97f4d3c1f$var$hasRef)) return true;
        if (typeof sch == "object" && $816d72a97f4d3c1f$var$hasRef(sch)) return true;
    }
    return false;
}
function $816d72a97f4d3c1f$var$countKeys(schema) {
    var count = 0;
    for(var key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($816d72a97f4d3c1f$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $eKI5Q.eachItem)(schema[key], function(sch) {
            return count += $816d72a97f4d3c1f$var$countKeys(sch);
        });
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $816d72a97f4d3c1f$var$getFullPath(resolver) {
    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", normalize = arguments.length > 2 ? arguments[2] : void 0;
    if (normalize !== false) id = $816d72a97f4d3c1f$var$normalizeId(id);
    var p = resolver.parse(id);
    return $816d72a97f4d3c1f$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $816d72a97f4d3c1f$var$getFullPath;
function $816d72a97f4d3c1f$var$_getFullPath(resolver, p) {
    var serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $816d72a97f4d3c1f$var$_getFullPath;
var $816d72a97f4d3c1f$var$TRAILING_SLASH_HASH = /#\/?$/;
function $816d72a97f4d3c1f$var$normalizeId(id) {
    return id ? id.replace($816d72a97f4d3c1f$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $816d72a97f4d3c1f$var$normalizeId;
function $816d72a97f4d3c1f$var$resolveUrl(resolver, baseId, id) {
    id = $816d72a97f4d3c1f$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $816d72a97f4d3c1f$var$resolveUrl;
var $816d72a97f4d3c1f$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $816d72a97f4d3c1f$var$getSchemaRefs(schema, baseId) {
    var _this = this;
    var checkAmbiguosRef = function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$3rDtx(sch1, sch2)) throw ambiguos(ref);
    };
    var ambiguos = function ambiguos(ref) {
        return new Error('reference "'.concat(ref, '" resolves to more than one schema'));
    };
    if (typeof schema == "boolean") return {};
    var _this_opts = this.opts, schemaId = _this_opts.schemaId, uriResolver = _this_opts.uriResolver;
    var schId = $816d72a97f4d3c1f$var$normalizeId(schema[schemaId] || baseId);
    var baseIds = {
        "": schId
    };
    var pathPrefix = $816d72a97f4d3c1f$var$getFullPath(uriResolver, schId, false);
    var localRefs = {};
    var schemaRefs = new Set();
    $bJlRI(schema, {
        allKeys: true
    }, function(sch, jsonPtr, _, parentJsonPtr) {
        var addRef = function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            var _resolve = this.opts.uriResolver.resolve;
            ref = $816d72a97f4d3c1f$var$normalizeId(_$baseId ? _resolve(_$baseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            var schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $816d72a97f4d3c1f$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        };
        var addAnchor = function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$816d72a97f4d3c1f$var$ANCHOR.test(anchor)) throw new Error('invalid anchor "'.concat(anchor, '"'));
                addRef.call(this, "#".concat(anchor));
            }
        };
        if (parentJsonPtr === undefined) return;
        var fullPath = pathPrefix + jsonPtr;
        var _$baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") _$baseId = addRef.call(_this, sch[schemaId]);
        addAnchor.call(_this, sch.$anchor);
        addAnchor.call(_this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = _$baseId;
    });
    return localRefs;
}
module.exports.getSchemaRefs = $816d72a97f4d3c1f$var$getSchemaRefs;

});
parcelRequire.register("3rDtx", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRequire.register("bJlRI", function(module, exports) {
"use strict";
var $88a4dba9ec22e6bb$var$traverse = module.exports = function traverse(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $88a4dba9ec22e6bb$var$_traverse(opts, pre, post, schema, "", schema);
};
$88a4dba9ec22e6bb$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$88a4dba9ec22e6bb$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$88a4dba9ec22e6bb$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$88a4dba9ec22e6bb$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $88a4dba9ec22e6bb$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $88a4dba9ec22e6bb$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$88a4dba9ec22e6bb$var$_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $88a4dba9ec22e6bb$var$traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)$88a4dba9ec22e6bb$var$_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + $88a4dba9ec22e6bb$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $88a4dba9ec22e6bb$var$traverse.keywords || opts.allKeys && !(key in $88a4dba9ec22e6bb$var$traverse.skipKeywords)) $88a4dba9ec22e6bb$var$_traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $88a4dba9ec22e6bb$var$escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

});



parcelRequire.register("aNuxA", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $fsOl6 = parcelRequire("fsOl6");

var $karXd = parcelRequire("karXd");

var $COJlH = parcelRequire("COJlH");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7dc62bba4a2fc95a$var$ValidationError = /*#__PURE__*/ function(Error1) {
    (0, $fsOl6._)(ValidationError, Error1);
    var _super = (0, $COJlH._)(ValidationError);
    function ValidationError(errors) {
        (0, $h5oKP._)(this, ValidationError);
        var _this;
        _this = _super.call(this, "validation failed");
        _this.errors = errors;
        _this.ajv = _this.validation = true;
        return _this;
    }
    return ValidationError;
}((0, $karXd._)(Error));
module.exports.default = $7dc62bba4a2fc95a$var$ValidationError;

});

parcelRequire.register("j2ZXR", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $fsOl6 = parcelRequire("fsOl6");

var $karXd = parcelRequire("karXd");

var $COJlH = parcelRequire("COJlH");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b6Wgf = parcelRequire("b6Wgf");
var $ddde45105d625466$var$MissingRefError = /*#__PURE__*/ function(Error1) {
    (0, $fsOl6._)(MissingRefError, Error1);
    var _super = (0, $COJlH._)(MissingRefError);
    function MissingRefError(resolver, baseId, ref, msg) {
        (0, $h5oKP._)(this, MissingRefError);
        var _this;
        _this = _super.call(this, msg || "can't resolve reference ".concat(ref, " from id ").concat(baseId));
        _this.missingRef = (0, $b6Wgf.resolveUrl)(resolver, baseId, ref);
        _this.missingSchema = (0, $b6Wgf.normalizeId)((0, $b6Wgf.getFullPath)(resolver, _this.missingRef));
        return _this;
    }
    return MissingRefError;
}((0, $karXd._)(Error));
module.exports.default = $ddde45105d625466$var$MissingRefError;

});

parcelRequire.register("glLnH", function(module, exports) {

var $h5oKP = parcelRequire("h5oKP");

var $bmZve = parcelRequire("bmZve");
"use strict";
function $be735c72a535291d$var$_templateObject() {
    var data = (0, $bmZve._)([
        'require("ajv/dist/runtime/validation_error").default'
    ]);
    $be735c72a535291d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $be735c72a535291d$var$_templateObject1() {
    var data = (0, $bmZve._)([
        '""'
    ]);
    $be735c72a535291d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $aNuxA = parcelRequire("aNuxA");

var $cuzEW = parcelRequire("cuzEW");

var $b6Wgf = parcelRequire("b6Wgf");

var $eKI5Q = parcelRequire("eKI5Q");

var $8n3O1 = parcelRequire("8n3O1");
var $be735c72a535291d$var$SchemaEnv = function SchemaEnv(env) {
    (0, $h5oKP._)(this, SchemaEnv);
    var _a;
    this.refs = {};
    this.dynamicAnchors = {};
    var schema;
    if (typeof env.schema == "object") schema = env.schema;
    this.schema = env.schema;
    this.schemaId = env.schemaId;
    this.root = env.root || this;
    this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $b6Wgf.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
    this.schemaPath = env.schemaPath;
    this.localRefs = env.localRefs;
    this.meta = env.meta;
    this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
    this.refs = {};
};
module.exports.SchemaEnv = $be735c72a535291d$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $be735c72a535291d$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    var _sch = $be735c72a535291d$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    var rootId = (0, $b6Wgf.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    var _this_opts_code = this.opts.code, es5 = _this_opts_code.es5, lines = _this_opts_code.lines;
    var ownProperties = this.opts.ownProperties;
    var gen = new $3Ar5a.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    var _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $aNuxA.default,
        code: (0, $3Ar5a._)($be735c72a535291d$var$_templateObject())
    });
    var validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    var schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $cuzEW.default.data,
        parentData: $cuzEW.default.parentData,
        parentDataProperty: $cuzEW.default.parentDataProperty,
        dataNames: [
            $cuzEW.default.data
        ],
        dataPathArr: [
            $3Ar5a.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $3Ar5a.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $3Ar5a.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $3Ar5a._)($be735c72a535291d$var$_templateObject1()),
        opts: this.opts,
        self: this
    };
    var sourceCode;
    try {
        this._compilations.add(sch);
        (0, $8n3O1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        var validateCode = gen.toString();
        sourceCode = "".concat(gen.scopeRefs($cuzEW.default.scope), "return ").concat(validateCode);
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        var makeValidate = new Function("".concat($cuzEW.default.self), "".concat($cuzEW.default.scope), sourceCode);
        var validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            var props = schemaCxt.props, items = schemaCxt.items;
            validate.evaluated = {
                props: props instanceof $3Ar5a.Name ? undefined : props,
                items: items instanceof $3Ar5a.Name ? undefined : items,
                dynamicProps: props instanceof $3Ar5a.Name,
                dynamicItems: items instanceof $3Ar5a.Name
            };
            if (validate.source) validate.source.evaluated = (0, $3Ar5a.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $be735c72a535291d$var$compileSchema;
function $be735c72a535291d$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $b6Wgf.resolveUrl)(this.opts.uriResolver, baseId, ref);
    var schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    var _sch = $be735c72a535291d$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        var schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        var schemaId = this.opts.schemaId;
        if (schema) _sch = new $be735c72a535291d$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $be735c72a535291d$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $be735c72a535291d$var$resolveRef;
function $be735c72a535291d$var$inlineOrCompile(sch) {
    if ((0, $b6Wgf.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $be735c72a535291d$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $be735c72a535291d$var$getCompilingSchema(schEnv) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = this._compilations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sch = _step.value;
            if ($be735c72a535291d$var$sameSchemaEnv(sch, schEnv)) return sch;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
module.exports.getCompilingSchema = $be735c72a535291d$var$getCompilingSchema;
function $be735c72a535291d$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $be735c72a535291d$var$resolve(root, ref // reference to resolve
) {
    var sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $be735c72a535291d$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $be735c72a535291d$var$resolveSchema(root, ref // reference to resolve
) {
    var p = this.opts.uriResolver.parse(ref);
    var refPath = (0, $b6Wgf._getFullPath)(this.opts.uriResolver, p);
    var baseId = (0, $b6Wgf.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $be735c72a535291d$var$getJsonPointer.call(this, p, root);
    var id = (0, $b6Wgf.normalizeId)(refPath);
    var schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        var sch = $be735c72a535291d$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $be735c72a535291d$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $be735c72a535291d$var$compileSchema.call(this, schOrRef);
    if (id === (0, $b6Wgf.normalizeId)(ref)) {
        var schema = schOrRef.schema;
        var schemaId = this.opts.schemaId;
        var schId = schema[schemaId];
        if (schId) baseId = (0, $b6Wgf.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $be735c72a535291d$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $be735c72a535291d$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $be735c72a535291d$var$resolveSchema;
var $be735c72a535291d$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $be735c72a535291d$var$getJsonPointer(parsedRef, param) {
    var baseId = param.baseId, schema = param.schema, root = param.root;
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsedRef.fragment.slice(1).split("/")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (typeof schema === "boolean") return;
            var partSchema = schema[(0, $eKI5Q.unescapeFragment)(part)];
            if (partSchema === undefined) return;
            schema = partSchema;
            // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
            var schId = typeof schema === "object" && schema[this.opts.schemaId];
            if (!$be735c72a535291d$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $b6Wgf.resolveUrl)(this.opts.uriResolver, baseId, schId);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $eKI5Q.schemaHasRulesButRef)(schema, this.RULES)) {
        var $ref = (0, $b6Wgf.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $be735c72a535291d$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    var schemaId = this.opts.schemaId;
    env = env || new $be735c72a535291d$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRequire.register("A4Hqa", function(module, exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});

parcelRequire.register("lyzle", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8BSnL = parcelRequire("8BSnL");
$8BSnL.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $8BSnL;

});
parcelRequire.register("8BSnL", function(module, exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var merge = function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    };
    var subexp = function subexp(str) {
        return "(?:" + str + ")";
    };
    var typeOf = function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    };
    var toUpperCase = function toUpperCase(str) {
        return str.toUpperCase();
    };
    var toArray = function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    };
    var assign = function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    };
    var buildExps = function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    };
    var error$1 = /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    };
    var map = /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    };
    var mapDomain = /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    };
    var ucs2decode = /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    };
    var pctEncChar = function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    };
    var pctDecChars = function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    };
    var _normalizeComponentEncoding = function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    };
    var _stripLeadingZeros = function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    };
    var _normalizeIPv4 = function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    };
    var _normalizeIPv6 = function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    };
    var parse = function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    };
    var _recomposeAuthority = function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    };
    var removeDotSegments = function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    };
    var serialize = function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    };
    var resolveComponents = function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    };
    var resolve = function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    };
    var normalize = function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    };
    var equal = function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    };
    var escapeComponent = function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    };
    var unescapeComponent = function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    };
    var isSecure = function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    };
    var decodeUnreserved = function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    };
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        var sliceIterator = function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        };
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});



parcelRequire.register("5alXP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6ZoyH = parcelRequire("6ZoyH");

var $cdfyM = parcelRequire("cdfyM");

var $caB1Z = parcelRequire("caB1Z");

var $gPn0P = parcelRequire("gPn0P");

var $cGdwe = parcelRequire("cGdwe");
var $3c2eec7cef411b67$var$draft7Vocabularies = [
    $6ZoyH.default,
    $cdfyM.default,
    (0, $caB1Z.default)(),
    $gPn0P.default,
    $cGdwe.metadataVocabulary,
    $cGdwe.contentVocabulary
];
module.exports.default = $3c2eec7cef411b67$var$draft7Vocabularies;

});
parcelRequire.register("6ZoyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lxMX3 = parcelRequire("lxMX3");

var $3JiiT = parcelRequire("3JiiT");
var $516b7d7241a2cb2a$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $lxMX3.default,
    $3JiiT.default
];
module.exports.default = $516b7d7241a2cb2a$var$core;

});
parcelRequire.register("lxMX3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $faf2a6c59222c9e5$var$def = {
    keyword: "id",
    code: function() {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $faf2a6c59222c9e5$var$def;

});

parcelRequire.register("3JiiT", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $2b73c5c89154f713$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ".validate"
    ]);
    $2b73c5c89154f713$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        ".validate"
    ]);
    $2b73c5c89154f713$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "await ",
        ""
    ]);
    $2b73c5c89154f713$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "!(",
        " instanceof ",
        ")"
    ]);
    $2b73c5c89154f713$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        ".errors"
    ]);
    $2b73c5c89154f713$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        " === null ? ",
        " : ",
        ".concat(",
        ")"
    ]);
    $2b73c5c89154f713$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $2b73c5c89154f713$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        ".evaluated.props"
    ]);
    $2b73c5c89154f713$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $2b73c5c89154f713$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ".evaluated.items"
    ]);
    $2b73c5c89154f713$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $j2ZXR = parcelRequire("j2ZXR");

var $d3q0m = parcelRequire("d3q0m");

var $3Ar5a = parcelRequire("3Ar5a");

var $cuzEW = parcelRequire("cuzEW");

var $glLnH = parcelRequire("glLnH");

var $eKI5Q = parcelRequire("eKI5Q");
var $2b73c5c89154f713$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code: function(cxt) {
        var callRootRef = function callRootRef() {
            if (env === root) return $2b73c5c89154f713$var$callRef(cxt, validateName, env, env.$async);
            var rootName = gen.scopeValue("root", {
                ref: root
            });
            return $2b73c5c89154f713$var$callRef(cxt, (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject(), rootName), root, root.$async);
        };
        var callValidate = function callValidate(sch) {
            var v = $2b73c5c89154f713$var$getValidate(cxt, sch);
            $2b73c5c89154f713$var$callRef(cxt, v, sch, sch.$async);
        };
        var inlineRefSchema = function inlineRefSchema(sch) {
            var schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $3Ar5a.stringify)(sch)
            } : {
                ref: sch
            });
            var valid = gen.name("valid");
            var schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $3Ar5a.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        };
        var gen = cxt.gen, $ref = cxt.schema, it = cxt.it;
        var baseId = it.baseId, env = it.schemaEnv, validateName = it.validateName, opts = it.opts, self = it.self;
        var root = env.root;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        var schOrEnv = $glLnH.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $j2ZXR.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $glLnH.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
    }
};
function $2b73c5c89154f713$var$getValidate(cxt, sch) {
    var gen = cxt.gen;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject1(), gen.scopeValue("wrapper", {
        ref: sch
    }));
}
module.exports.getValidate = $2b73c5c89154f713$var$getValidate;
function $2b73c5c89154f713$var$callRef(cxt, v, sch, $async) {
    var callAsyncRef = function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        var valid = gen.let("valid");
        gen.try(function() {
            gen.code((0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject2(), (0, $d3q0m.callValidateCode)(cxt, v, passCxt)));
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, function(e) {
            gen.if((0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject3(), e, it.ValidationError), function() {
                return gen.throw(e);
            });
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    };
    var callSyncRef = function callSyncRef() {
        cxt.result((0, $d3q0m.callValidateCode)(cxt, v, passCxt), function() {
            return addEvaluatedFrom(v);
        }, function() {
            return addErrorsFrom(v);
        });
    };
    var addErrorsFrom = function addErrorsFrom(source) {
        var errs = (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject4(), source);
        gen.assign($cuzEW.default.vErrors, (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject5(), $cuzEW.default.vErrors, errs, $cuzEW.default.vErrors, errs)); // TODO tagged
        gen.assign($cuzEW.default.errors, (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject6(), $cuzEW.default.vErrors));
    };
    var addEvaluatedFrom = function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        var schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $eKI5Q.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                var props = gen.var("props", (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject7(), source));
                it.props = $eKI5Q.mergeEvaluated.props(gen, props, it.props, $3Ar5a.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $eKI5Q.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                var items = gen.var("items", (0, $3Ar5a._)($2b73c5c89154f713$var$_templateObject8(), source));
                it.items = $eKI5Q.mergeEvaluated.items(gen, items, it.items, $3Ar5a.Name);
            }
        }
    };
    var gen = cxt.gen, it = cxt.it;
    var allErrors = it.allErrors, env = it.schemaEnv, opts = it.opts;
    var passCxt = opts.passContext ? $cuzEW.default.this : $3Ar5a.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
}
module.exports.callRef = $2b73c5c89154f713$var$callRef;
module.exports.default = $2b73c5c89154f713$var$def;

});


parcelRequire.register("cdfyM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1vUFS = parcelRequire("1vUFS");

var $iI1oq = parcelRequire("iI1oq");

var $bECNG = parcelRequire("bECNG");

var $kky2U = parcelRequire("kky2U");

var $9SREr = parcelRequire("9SREr");

var $lKggN = parcelRequire("lKggN");

var $azaWa = parcelRequire("azaWa");

var $2y0cV = parcelRequire("2y0cV");

var $hpBAy = parcelRequire("hpBAy");

var $6jMuO = parcelRequire("6jMuO");
var $8e42c4d2b3805d3e$var$validation = [
    // number
    $1vUFS.default,
    $iI1oq.default,
    // string
    $bECNG.default,
    $kky2U.default,
    // object
    $9SREr.default,
    $lKggN.default,
    // array
    $azaWa.default,
    $2y0cV.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $hpBAy.default,
    $6jMuO.default
];
module.exports.default = $8e42c4d2b3805d3e$var$validation;

});
parcelRequire.register("1vUFS", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $11a4a612adc89b57$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must be ",
        " ",
        ""
    ]);
    $11a4a612adc89b57$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $11a4a612adc89b57$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{comparison: ",
        ", limit: ",
        "}"
    ]);
    $11a4a612adc89b57$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $11a4a612adc89b57$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " ",
        " ",
        " || isNaN(",
        ")"
    ]);
    $11a4a612adc89b57$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $11a4a612adc89b57$var$ops = $3Ar5a.operators;
var $11a4a612adc89b57$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $11a4a612adc89b57$var$ops.LTE,
        fail: $11a4a612adc89b57$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $11a4a612adc89b57$var$ops.GTE,
        fail: $11a4a612adc89b57$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $11a4a612adc89b57$var$ops.LT,
        fail: $11a4a612adc89b57$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $11a4a612adc89b57$var$ops.GT,
        fail: $11a4a612adc89b57$var$ops.LTE
    }
};
var $11a4a612adc89b57$var$error = {
    message: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        return (0, $3Ar5a.str)($11a4a612adc89b57$var$_templateObject(), $11a4a612adc89b57$var$KWDs[keyword].okStr, schemaCode);
    },
    params: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($11a4a612adc89b57$var$_templateObject1(), $11a4a612adc89b57$var$KWDs[keyword].okStr, schemaCode);
    }
};
var $11a4a612adc89b57$var$def = {
    keyword: Object.keys($11a4a612adc89b57$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $11a4a612adc89b57$var$error,
    code: function(cxt) {
        var keyword = cxt.keyword, data = cxt.data, schemaCode = cxt.schemaCode;
        cxt.fail$data((0, $3Ar5a._)($11a4a612adc89b57$var$_templateObject2(), data, $11a4a612adc89b57$var$KWDs[keyword].fail, schemaCode, data));
    }
};
module.exports.default = $11a4a612adc89b57$var$def;

});

parcelRequire.register("iI1oq", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $d9ed6aaffaac7562$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must be multiple of ",
        ""
    ]);
    $d9ed6aaffaac7562$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d9ed6aaffaac7562$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{multipleOf: ",
        "}"
    ]);
    $d9ed6aaffaac7562$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d9ed6aaffaac7562$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "Math.abs(Math.round(",
        ") - ",
        ") > 1e-",
        ""
    ]);
    $d9ed6aaffaac7562$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $d9ed6aaffaac7562$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " !== parseInt(",
        ")"
    ]);
    $d9ed6aaffaac7562$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $d9ed6aaffaac7562$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "(",
        " === 0 || (",
        " = ",
        "/",
        ", ",
        "))"
    ]);
    $d9ed6aaffaac7562$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $d9ed6aaffaac7562$var$error = {
    message: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a.str)($d9ed6aaffaac7562$var$_templateObject(), schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($d9ed6aaffaac7562$var$_templateObject1(), schemaCode);
    }
};
var $d9ed6aaffaac7562$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $d9ed6aaffaac7562$var$error,
    code: function(cxt) {
        var gen = cxt.gen, data = cxt.data, schemaCode = cxt.schemaCode, it = cxt.it;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        var prec = it.opts.multipleOfPrecision;
        var res = gen.let("res");
        var invalid = prec ? (0, $3Ar5a._)($d9ed6aaffaac7562$var$_templateObject2(), res, res, prec) : (0, $3Ar5a._)($d9ed6aaffaac7562$var$_templateObject3(), res, res);
        cxt.fail$data((0, $3Ar5a._)($d9ed6aaffaac7562$var$_templateObject4(), schemaCode, res, data, schemaCode, invalid));
    }
};
module.exports.default = $d9ed6aaffaac7562$var$def;

});

parcelRequire.register("bECNG", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $87c18717f55d7d4b$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have ",
        " than ",
        " characters"
    ]);
    $87c18717f55d7d4b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $87c18717f55d7d4b$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{limit: ",
        "}"
    ]);
    $87c18717f55d7d4b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $87c18717f55d7d4b$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $87c18717f55d7d4b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $87c18717f55d7d4b$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ")"
    ]);
    $87c18717f55d7d4b$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $87c18717f55d7d4b$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " ",
        " ",
        ""
    ]);
    $87c18717f55d7d4b$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $8dy0i = parcelRequire("8dy0i");
var $87c18717f55d7d4b$var$error = {
    message: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        var comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $3Ar5a.str)($87c18717f55d7d4b$var$_templateObject(), comp, schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($87c18717f55d7d4b$var$_templateObject1(), schemaCode);
    }
};
var $87c18717f55d7d4b$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $87c18717f55d7d4b$var$error,
    code: function(cxt) {
        var keyword = cxt.keyword, data = cxt.data, schemaCode = cxt.schemaCode, it = cxt.it;
        var op = keyword === "maxLength" ? $3Ar5a.operators.GT : $3Ar5a.operators.LT;
        var len = it.opts.unicode === false ? (0, $3Ar5a._)($87c18717f55d7d4b$var$_templateObject2(), data) : (0, $3Ar5a._)($87c18717f55d7d4b$var$_templateObject3(), (0, $eKI5Q.useFunc)(cxt.gen, $8dy0i.default), data);
        cxt.fail$data((0, $3Ar5a._)($87c18717f55d7d4b$var$_templateObject4(), len, op, schemaCode));
    }
};
module.exports.default = $87c18717f55d7d4b$var$def;

});
parcelRequire.register("8dy0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $5fb9ea11dff8aec3$var$ucs2length(str) {
    var len = str.length;
    var length = 0;
    var pos = 0;
    var value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $5fb9ea11dff8aec3$var$ucs2length;
$5fb9ea11dff8aec3$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRequire.register("kky2U", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $ecd015b88d04467e$var$_templateObject() {
    var data = (0, $bmZve._)([
        'must match pattern "',
        '"'
    ]);
    $ecd015b88d04467e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ecd015b88d04467e$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{pattern: ",
        "}"
    ]);
    $ecd015b88d04467e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $ecd015b88d04467e$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "(new RegExp(",
        ", ",
        "))"
    ]);
    $ecd015b88d04467e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $ecd015b88d04467e$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "!",
        ".test(",
        ")"
    ]);
    $ecd015b88d04467e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3q0m = parcelRequire("d3q0m");

var $3Ar5a = parcelRequire("3Ar5a");
var $ecd015b88d04467e$var$error = {
    message: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a.str)($ecd015b88d04467e$var$_templateObject(), schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($ecd015b88d04467e$var$_templateObject1(), schemaCode);
    }
};
var $ecd015b88d04467e$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $ecd015b88d04467e$var$error,
    code: function(cxt) {
        var data = cxt.data, $data = cxt.$data, schema = cxt.schema, schemaCode = cxt.schemaCode, it = cxt.it;
        // TODO regexp should be wrapped in try/catchs
        var u = it.opts.unicodeRegExp ? "u" : "";
        var regExp = $data ? (0, $3Ar5a._)($ecd015b88d04467e$var$_templateObject2(), schemaCode, u) : (0, $d3q0m.usePattern)(cxt, schema);
        cxt.fail$data((0, $3Ar5a._)($ecd015b88d04467e$var$_templateObject3(), regExp, data));
    }
};
module.exports.default = $ecd015b88d04467e$var$def;

});

parcelRequire.register("9SREr", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $7322c63a3ac48313$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have ",
        " than ",
        " properties"
    ]);
    $7322c63a3ac48313$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7322c63a3ac48313$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{limit: ",
        "}"
    ]);
    $7322c63a3ac48313$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7322c63a3ac48313$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "Object.keys(",
        ").length ",
        " ",
        ""
    ]);
    $7322c63a3ac48313$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $7322c63a3ac48313$var$error = {
    message: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        var comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $3Ar5a.str)($7322c63a3ac48313$var$_templateObject(), comp, schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($7322c63a3ac48313$var$_templateObject1(), schemaCode);
    }
};
var $7322c63a3ac48313$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $7322c63a3ac48313$var$error,
    code: function(cxt) {
        var keyword = cxt.keyword, data = cxt.data, schemaCode = cxt.schemaCode;
        var op = keyword === "maxProperties" ? $3Ar5a.operators.GT : $3Ar5a.operators.LT;
        cxt.fail$data((0, $3Ar5a._)($7322c63a3ac48313$var$_templateObject2(), data, op, schemaCode));
    }
};
module.exports.default = $7322c63a3ac48313$var$def;

});

parcelRequire.register("lKggN", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $fd4a83bcfe0840cb$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must have required property '",
        "'"
    ]);
    $fd4a83bcfe0840cb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $fd4a83bcfe0840cb$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{missingProperty: ",
        "}"
    ]);
    $fd4a83bcfe0840cb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3q0m = parcelRequire("d3q0m");

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $fd4a83bcfe0840cb$var$error = {
    message: function(param) {
        var missingProperty = param.params.missingProperty;
        return (0, $3Ar5a.str)($fd4a83bcfe0840cb$var$_templateObject(), missingProperty);
    },
    params: function(param) {
        var missingProperty = param.params.missingProperty;
        return (0, $3Ar5a._)($fd4a83bcfe0840cb$var$_templateObject1(), missingProperty);
    }
};
var $fd4a83bcfe0840cb$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $fd4a83bcfe0840cb$var$error,
    code: function(cxt) {
        var allErrorsMode = function allErrorsMode() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (useLoop || $data) cxt.block$data($3Ar5a.nil, loopAllRequired);
            else try {
                for(var _iterator = schema[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prop = _step.value;
                    (0, $d3q0m.checkReportMissingProp)(cxt, prop);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var exitOnErrorMode = function exitOnErrorMode() {
            var missing = gen.let("missing");
            if (useLoop || $data) {
                var valid = gen.let("valid", true);
                cxt.block$data(valid, function() {
                    return loopUntilMissing(missing, valid);
                });
                cxt.ok(valid);
            } else {
                gen.if((0, $d3q0m.checkMissingProp)(cxt, schema, missing));
                (0, $d3q0m.reportMissingProp)(cxt, missing);
                gen.else();
            }
        };
        var loopAllRequired = function loopAllRequired() {
            gen.forOf("prop", schemaCode, function(prop) {
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $d3q0m.noPropertyInData)(gen, data, prop, opts.ownProperties), function() {
                    return cxt.error();
                });
            });
        };
        var loopUntilMissing = function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, function() {
                gen.assign(valid, (0, $d3q0m.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $3Ar5a.not)(valid), function() {
                    cxt.error();
                    gen.break();
                });
            }, $3Ar5a.nil);
        };
        var gen = cxt.gen, schema = cxt.schema, schemaCode = cxt.schemaCode, data = cxt.data, $data = cxt.$data, it = cxt.it;
        var opts = it.opts;
        if (!$data && schema.length === 0) return;
        var useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            var props = cxt.parentSchema.properties;
            var definedProperties = cxt.it.definedProperties;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = schema[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var requiredKey = _step.value;
                    if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                        var schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                        var msg = 'required property "'.concat(requiredKey, '" is not defined at "').concat(schemaPath, '" (strictRequired)');
                        (0, $eKI5Q.checkStrictMode)(it, msg, it.opts.strictRequired);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
};
module.exports.default = $fd4a83bcfe0840cb$var$def;

});

parcelRequire.register("azaWa", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $7b15a82da3b28eeb$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have ",
        " than ",
        " items"
    ]);
    $7b15a82da3b28eeb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7b15a82da3b28eeb$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{limit: ",
        "}"
    ]);
    $7b15a82da3b28eeb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7b15a82da3b28eeb$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".length ",
        " ",
        ""
    ]);
    $7b15a82da3b28eeb$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $7b15a82da3b28eeb$var$error = {
    message: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        var comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $3Ar5a.str)($7b15a82da3b28eeb$var$_templateObject(), comp, schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($7b15a82da3b28eeb$var$_templateObject1(), schemaCode);
    }
};
var $7b15a82da3b28eeb$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $7b15a82da3b28eeb$var$error,
    code: function(cxt) {
        var keyword = cxt.keyword, data = cxt.data, schemaCode = cxt.schemaCode;
        var op = keyword === "maxItems" ? $3Ar5a.operators.GT : $3Ar5a.operators.LT;
        cxt.fail$data((0, $3Ar5a._)($7b15a82da3b28eeb$var$_templateObject2(), data, op, schemaCode));
    }
};
module.exports.default = $7b15a82da3b28eeb$var$def;

});

parcelRequire.register("2y0cV", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $1daeeaee82321e8c$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have duplicate items (items ## ",
        " and ",
        " are identical)"
    ]);
    $1daeeaee82321e8c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{i: ",
        ", j: ",
        "}"
    ]);
    $1daeeaee82321e8c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $1daeeaee82321e8c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " > 1"
    ]);
    $1daeeaee82321e8c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "{}"
    ]);
    $1daeeaee82321e8c$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject5() {
    var data = (0, $bmZve._)([
        ";",
        "--;"
    ]);
    $1daeeaee82321e8c$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $1daeeaee82321e8c$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "continue"
    ]);
    $1daeeaee82321e8c$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' == "string"'
    ]);
    $1daeeaee82321e8c$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        ' += "_"'
    ]);
    $1daeeaee82321e8c$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "typeof ",
        "[",
        '] == "number"'
    ]);
    $1daeeaee82321e8c$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $1daeeaee82321e8c$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "] = ",
        ""
    ]);
    $1daeeaee82321e8c$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject13() {
    var data = (0, $bmZve._)([
        ";",
        "--;"
    ]);
    $1daeeaee82321e8c$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "",
        " = ",
        "; ",
        "--;"
    ]);
    $1daeeaee82321e8c$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject15() {
    var data = (0, $bmZve._)([
        "",
        "(",
        "[",
        "], ",
        "[",
        "])"
    ]);
    $1daeeaee82321e8c$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $1daeeaee82321e8c$var$_templateObject16() {
    var data = (0, $bmZve._)([
        "",
        " === false"
    ]);
    $1daeeaee82321e8c$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $96OdM = parcelRequire("96OdM");

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $2NmjO = parcelRequire("2NmjO");
var $1daeeaee82321e8c$var$error = {
    message: function(param) {
        var _param_params = param.params, i = _param_params.i, j = _param_params.j;
        return (0, $3Ar5a.str)($1daeeaee82321e8c$var$_templateObject(), j, i);
    },
    params: function(param) {
        var _param_params = param.params, i = _param_params.i, j = _param_params.j;
        return (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject1(), i, j);
    }
};
var $1daeeaee82321e8c$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $1daeeaee82321e8c$var$error,
    code: function(cxt) {
        var validateUniqueItems = function validateUniqueItems() {
            var i = gen.let("i", (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject2(), data));
            var j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject3(), i), function() {
                return (canOptimize() ? loopN : loopN2)(i, j);
            });
        };
        var canOptimize = function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some(function(t) {
                return t === "object" || t === "array";
            });
        };
        var loopN = function loopN(i, j) {
            var item = gen.name("item");
            var wrongType = (0, $96OdM.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $96OdM.DataType.Wrong);
            var indices = gen.const("indices", (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject4()));
            gen.for((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject5(), i), function() {
                gen.let(item, (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject6(), data, i));
                gen.if(wrongType, (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject7()));
                if (itemTypes.length > 1) gen.if((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject8(), item), (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject9(), item));
                gen.if((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject10(), indices, item), function() {
                    gen.assign(j, (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject11(), indices, item));
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject12(), indices, item, i));
            });
        };
        var loopN2 = function loopN2(i, j) {
            var eql = (0, $eKI5Q.useFunc)(gen, $2NmjO.default);
            var outer = gen.name("outer");
            gen.label(outer).for((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject13(), i), function() {
                return gen.for((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject14(), j, i, j), function() {
                    return gen.if((0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject15(), eql, data, i, data, j), function() {
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    });
                });
            });
        };
        var gen = cxt.gen, data = cxt.data, $data = cxt.$data, schema = cxt.schema, parentSchema = cxt.parentSchema, schemaCode = cxt.schemaCode, it = cxt.it;
        if (!$data && !schema) return;
        var valid = gen.let("valid");
        var itemTypes = parentSchema.items ? (0, $96OdM.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $3Ar5a._)($1daeeaee82321e8c$var$_templateObject16(), schemaCode));
        cxt.ok(valid);
    }
};
module.exports.default = $1daeeaee82321e8c$var$def;

});
parcelRequire.register("2NmjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3rDtx = parcelRequire("3rDtx");
$3rDtx.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $3rDtx;

});


parcelRequire.register("hpBAy", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $cad1edc13801191f$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{allowedValue: ",
        "}"
    ]);
    $cad1edc13801191f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $cad1edc13801191f$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "!",
        "(",
        ", ",
        ")"
    ]);
    $cad1edc13801191f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $cad1edc13801191f$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " !== ",
        ""
    ]);
    $cad1edc13801191f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $2NmjO = parcelRequire("2NmjO");
var $cad1edc13801191f$var$error = {
    message: "must be equal to constant",
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($cad1edc13801191f$var$_templateObject(), schemaCode);
    }
};
var $cad1edc13801191f$var$def = {
    keyword: "const",
    $data: true,
    error: $cad1edc13801191f$var$error,
    code: function(cxt) {
        var gen = cxt.gen, data = cxt.data, $data = cxt.$data, schemaCode = cxt.schemaCode, schema = cxt.schema;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $3Ar5a._)($cad1edc13801191f$var$_templateObject1(), (0, $eKI5Q.useFunc)(gen, $2NmjO.default), data, schemaCode));
        else cxt.fail((0, $3Ar5a._)($cad1edc13801191f$var$_templateObject2(), schema, data));
    }
};
module.exports.default = $cad1edc13801191f$var$def;

});

parcelRequire.register("6jMuO", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");
"use strict";
function $499a22bc70917ff5$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{allowedValues: ",
        "}"
    ]);
    $499a22bc70917ff5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $499a22bc70917ff5$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ", ",
        ")"
    ]);
    $499a22bc70917ff5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $499a22bc70917ff5$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ", ",
        "[",
        "])"
    ]);
    $499a22bc70917ff5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $499a22bc70917ff5$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $499a22bc70917ff5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $2NmjO = parcelRequire("2NmjO");
var $499a22bc70917ff5$var$error = {
    message: "must be equal to one of the allowed values",
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($499a22bc70917ff5$var$_templateObject(), schemaCode);
    }
};
var $499a22bc70917ff5$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $499a22bc70917ff5$var$error,
    code: function(cxt) {
        var loopEnum = function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, function(v) {
                return gen.if((0, $3Ar5a._)($499a22bc70917ff5$var$_templateObject1(), getEql(), data, v), function() {
                    return gen.assign(valid, true).break();
                });
            });
        };
        var equalCode = function equalCode(vSchema, i) {
            var sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $3Ar5a._)($499a22bc70917ff5$var$_templateObject2(), getEql(), data, vSchema, i) : (0, $3Ar5a._)($499a22bc70917ff5$var$_templateObject3(), data, sch);
        };
        var gen = cxt.gen, data = cxt.data, $data = cxt.$data, schema = cxt.schema, schemaCode = cxt.schemaCode, it = cxt.it;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        var useLoop = schema.length >= it.opts.loopEnum;
        var eql;
        var getEql = function() {
            return eql !== null && eql !== void 0 ? eql : eql = (0, $eKI5Q.useFunc)(gen, $2NmjO.default);
        };
        var valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            var vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $3Ar5a.or).apply(this, (0, $h9dQc._)(schema.map(function(_x, i) {
                return equalCode(vSchema, i);
            })));
        }
        cxt.pass(valid);
    }
};
module.exports.default = $499a22bc70917ff5$var$def;

});


parcelRequire.register("caB1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49BQx = parcelRequire("49BQx");

var $3bvB9 = parcelRequire("3bvB9");

var $l2TfY = parcelRequire("l2TfY");

var $kPyHE = parcelRequire("kPyHE");

var $eGxPK = parcelRequire("eGxPK");

var $azYtx = parcelRequire("azYtx");

var $1O17z = parcelRequire("1O17z");

var $879Yu = parcelRequire("879Yu");

var $ePZnW = parcelRequire("ePZnW");

var $5Rk1s = parcelRequire("5Rk1s");

var $iMiG2 = parcelRequire("iMiG2");

var $cwkQX = parcelRequire("cwkQX");

var $emp47 = parcelRequire("emp47");

var $cmJTI = parcelRequire("cmJTI");

var $98MWM = parcelRequire("98MWM");

var $ixNLG = parcelRequire("ixNLG");
function $8dc324d407c81e5b$var$getApplicator() {
    var draft2020 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var applicator = [
        // any
        $iMiG2.default,
        $cwkQX.default,
        $emp47.default,
        $cmJTI.default,
        $98MWM.default,
        $ixNLG.default,
        // object
        $1O17z.default,
        $879Yu.default,
        $azYtx.default,
        $ePZnW.default,
        $5Rk1s.default
    ];
    // array
    if (draft2020) applicator.push($3bvB9.default, $kPyHE.default);
    else applicator.push($49BQx.default, $l2TfY.default);
    applicator.push($eGxPK.default);
    return applicator;
}
module.exports.default = $8dc324d407c81e5b$var$getApplicator;

});
parcelRequire.register("49BQx", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $30655c2bcd78e7a4$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have more than ",
        " items"
    ]);
    $30655c2bcd78e7a4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $30655c2bcd78e7a4$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{limit: ",
        "}"
    ]);
    $30655c2bcd78e7a4$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $30655c2bcd78e7a4$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $30655c2bcd78e7a4$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $30655c2bcd78e7a4$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "",
        " <= ",
        ""
    ]);
    $30655c2bcd78e7a4$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $30655c2bcd78e7a4$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " <= ",
        ""
    ]);
    $30655c2bcd78e7a4$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $30655c2bcd78e7a4$var$error = {
    message: function(param) {
        var len = param.params.len;
        return (0, $3Ar5a.str)($30655c2bcd78e7a4$var$_templateObject(), len);
    },
    params: function(param) {
        var len = param.params.len;
        return (0, $3Ar5a._)($30655c2bcd78e7a4$var$_templateObject1(), len);
    }
};
var $30655c2bcd78e7a4$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $30655c2bcd78e7a4$var$error,
    code: function(cxt) {
        var parentSchema = cxt.parentSchema, it = cxt.it;
        var items = parentSchema.items;
        if (!Array.isArray(items)) {
            (0, $eKI5Q.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $30655c2bcd78e7a4$var$validateAdditionalItems(cxt, items);
    }
};
function $30655c2bcd78e7a4$var$validateAdditionalItems(cxt, items) {
    var validateItems = function validateItems(valid) {
        gen.forRange("i", items.length, len, function(i) {
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $eKI5Q.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $3Ar5a.not)(valid), function() {
                return gen.break();
            });
        });
    };
    var gen = cxt.gen, schema = cxt.schema, data = cxt.data, keyword = cxt.keyword, it = cxt.it;
    it.items = true;
    var len = gen.const("len", (0, $3Ar5a._)($30655c2bcd78e7a4$var$_templateObject2(), data));
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $3Ar5a._)($30655c2bcd78e7a4$var$_templateObject3(), len, items.length));
    } else if (typeof schema == "object" && !(0, $eKI5Q.alwaysValidSchema)(it, schema)) {
        var valid = gen.var("valid", (0, $3Ar5a._)($30655c2bcd78e7a4$var$_templateObject4(), len, items.length)); // TODO var
        gen.if((0, $3Ar5a.not)(valid), function() {
            return validateItems(valid);
        });
        cxt.ok(valid);
    }
}
module.exports.validateAdditionalItems = $30655c2bcd78e7a4$var$validateAdditionalItems;
module.exports.default = $30655c2bcd78e7a4$var$def;

});

parcelRequire.register("3bvB9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2TfY = parcelRequire("l2TfY");
var $251ae8f1762afe7f$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: function(cxt) {
        return (0, $l2TfY.validateTuple)(cxt, "items");
    }
};
module.exports.default = $251ae8f1762afe7f$var$def;

});
parcelRequire.register("l2TfY", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $f524a5af7132dbeb$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $f524a5af7132dbeb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f524a5af7132dbeb$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " > ",
        ""
    ]);
    $f524a5af7132dbeb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $d3q0m = parcelRequire("d3q0m");
var $f524a5af7132dbeb$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code: function(cxt) {
        var schema = cxt.schema, it = cxt.it;
        if (Array.isArray(schema)) return $f524a5af7132dbeb$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $eKI5Q.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $d3q0m.validateArray)(cxt));
    }
};
function $f524a5af7132dbeb$var$validateTuple(cxt, extraItems) {
    var schArr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : cxt.schema;
    var checkStrictTuple = function checkStrictTuple(sch) {
        var opts = it.opts, errSchemaPath = it.errSchemaPath;
        var l = schArr.length;
        var fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            var msg = '"'.concat(keyword, '" is ').concat(l, "-tuple, but minItems or maxItems/").concat(extraItems, ' are not specified or different at path "').concat(errSchemaPath, '"');
            (0, $eKI5Q.checkStrictMode)(it, msg, opts.strictTuples);
        }
    };
    var gen = cxt.gen, parentSchema = cxt.parentSchema, data = cxt.data, keyword = cxt.keyword, it = cxt.it;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $eKI5Q.mergeEvaluated.items(gen, schArr.length, it.items);
    var valid = gen.name("valid");
    var len = gen.const("len", (0, $3Ar5a._)($f524a5af7132dbeb$var$_templateObject(), data));
    schArr.forEach(function(sch, i) {
        if ((0, $eKI5Q.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $3Ar5a._)($f524a5af7132dbeb$var$_templateObject1(), len, i), function() {
            return cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid);
        });
        cxt.ok(valid);
    });
}
module.exports.validateTuple = $f524a5af7132dbeb$var$validateTuple;
module.exports.default = $f524a5af7132dbeb$var$def;

});


parcelRequire.register("kPyHE", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $f2a37d5c5ac13b44$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must NOT have more than ",
        " items"
    ]);
    $f2a37d5c5ac13b44$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f2a37d5c5ac13b44$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{limit: ",
        "}"
    ]);
    $f2a37d5c5ac13b44$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $d3q0m = parcelRequire("d3q0m");

var $49BQx = parcelRequire("49BQx");
var $f2a37d5c5ac13b44$var$error = {
    message: function(param) {
        var len = param.params.len;
        return (0, $3Ar5a.str)($f2a37d5c5ac13b44$var$_templateObject(), len);
    },
    params: function(param) {
        var len = param.params.len;
        return (0, $3Ar5a._)($f2a37d5c5ac13b44$var$_templateObject1(), len);
    }
};
var $f2a37d5c5ac13b44$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $f2a37d5c5ac13b44$var$error,
    code: function(cxt) {
        var schema = cxt.schema, parentSchema = cxt.parentSchema, it = cxt.it;
        var prefixItems = parentSchema.prefixItems;
        it.items = true;
        if ((0, $eKI5Q.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $49BQx.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $d3q0m.validateArray)(cxt));
    }
};
module.exports.default = $f2a37d5c5ac13b44$var$def;

});

parcelRequire.register("eGxPK", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $ab0f3b95b931d110$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must contain at least ",
        " valid item(s)"
    ]);
    $ab0f3b95b931d110$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "must contain at least ",
        " and no more than ",
        " valid item(s)"
    ]);
    $ab0f3b95b931d110$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "{minContains: ",
        "}"
    ]);
    $ab0f3b95b931d110$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "{minContains: ",
        ", maxContains: ",
        "}"
    ]);
    $ab0f3b95b931d110$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        "++"
    ]);
    $ab0f3b95b931d110$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        " >= ",
        ""
    ]);
    $ab0f3b95b931d110$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        " > ",
        ""
    ]);
    $ab0f3b95b931d110$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        " >= ",
        ""
    ]);
    $ab0f3b95b931d110$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "",
        ".length"
    ]);
    $ab0f3b95b931d110$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        " >= ",
        ""
    ]);
    $ab0f3b95b931d110$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "",
        " && ",
        " <= ",
        ""
    ]);
    $ab0f3b95b931d110$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $ab0f3b95b931d110$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        ".length > 0"
    ]);
    $ab0f3b95b931d110$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $ab0f3b95b931d110$var$error = {
    message: function(param) {
        var _param_params = param.params, min = _param_params.min, max = _param_params.max;
        return max === undefined ? (0, $3Ar5a.str)($ab0f3b95b931d110$var$_templateObject(), min) : (0, $3Ar5a.str)($ab0f3b95b931d110$var$_templateObject1(), min, max);
    },
    params: function(param) {
        var _param_params = param.params, min = _param_params.min, max = _param_params.max;
        return max === undefined ? (0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject2(), min) : (0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject3(), min, max);
    }
};
var $ab0f3b95b931d110$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $ab0f3b95b931d110$var$error,
    code: function(cxt) {
        var validateItemsWithCount = function validateItemsWithCount() {
            var schValid = gen.name("_valid");
            var count = gen.let("count", 0);
            validateItems(schValid, function() {
                return gen.if(schValid, function() {
                    return checkLimits(count);
                });
            });
        };
        var validateItems = function validateItems(_valid, block) {
            gen.forRange("i", 0, len, function(i) {
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $eKI5Q.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        };
        var checkLimits = function checkLimits(count) {
            gen.code((0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject4(), count));
            if (max === undefined) gen.if((0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject5(), count, min), function() {
                return gen.assign(valid, true).break();
            });
            else {
                gen.if((0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject6(), count, max), function() {
                    return gen.assign(valid, false).break();
                });
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject7(), count, min), function() {
                    return gen.assign(valid, true);
                });
            }
        };
        var gen = cxt.gen, schema = cxt.schema, parentSchema = cxt.parentSchema, data = cxt.data, it = cxt.it;
        var min;
        var max;
        var minContains = parentSchema.minContains, maxContains = parentSchema.maxContains;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        var len = gen.const("len", (0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject8(), data));
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $eKI5Q.checkStrictMode)(it, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
            return;
        }
        if (max !== undefined && min > max) {
            (0, $eKI5Q.checkStrictMode)(it, '"minContains" > "maxContains" is always invalid');
            cxt.fail();
            return;
        }
        if ((0, $eKI5Q.alwaysValidSchema)(it, schema)) {
            var cond = (0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject9(), len, min);
            if (max !== undefined) cond = (0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject10(), cond, len, max);
            cxt.pass(cond);
            return;
        }
        it.items = true;
        var valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, function() {
            return gen.if(valid, function() {
                return gen.break();
            });
        });
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $3Ar5a._)($ab0f3b95b931d110$var$_templateObject11(), data), validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, function() {
            return cxt.reset();
        });
    }
};
module.exports.default = $ab0f3b95b931d110$var$def;

});

parcelRequire.register("azYtx", function(module, exports) {

var $2MVSR = parcelRequire("2MVSR");

var $bmZve = parcelRequire("bmZve");
"use strict";
function $7b3c157399a22315$var$_templateObject() {
    var data = (0, $bmZve._)([
        "must have ",
        " ",
        " when property ",
        " is present"
    ]);
    $7b3c157399a22315$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7b3c157399a22315$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{property: ",
        ",\n    missingProperty: ",
        ",\n    depsCount: ",
        ",\n    deps: ",
        "}"
    ]);
    $7b3c157399a22315$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7b3c157399a22315$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        " && (",
        ")"
    ]);
    $7b3c157399a22315$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $d3q0m = parcelRequire("d3q0m");
module.exports.error = {
    message: function(param) {
        var _param_params = param.params, property = _param_params.property, depsCount = _param_params.depsCount, deps = _param_params.deps;
        var property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $3Ar5a.str)($7b3c157399a22315$var$_templateObject(), property_ies, deps, property);
    },
    params: function(param) {
        var _param_params = param.params, property = _param_params.property, depsCount = _param_params.depsCount, deps = _param_params.deps, missingProperty = _param_params.missingProperty;
        return (0, $3Ar5a._)($7b3c157399a22315$var$_templateObject1(), property, missingProperty, depsCount, deps);
    }
};
var $7b3c157399a22315$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code: function(cxt) {
        var _splitDependencies = (0, $2MVSR._)($7b3c157399a22315$var$splitDependencies(cxt), 2), propDeps = _splitDependencies[0], schDeps = _splitDependencies[1];
        $7b3c157399a22315$var$validatePropertyDeps(cxt, propDeps);
        $7b3c157399a22315$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $7b3c157399a22315$var$splitDependencies(param) {
    var schema = param.schema;
    var propertyDeps = {};
    var schemaDeps = {};
    for(var key in schema){
        if (key === "__proto__") continue;
        var deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $7b3c157399a22315$var$validatePropertyDeps(cxt) {
    var _loop = function(prop) {
        var deps = propertyDeps[prop];
        if (deps.length === 0) return "continue";
        var hasProperty = (0, $d3q0m.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var depProp = _step.value;
                    (0, $d3q0m.checkReportMissingProp)(cxt, depProp);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        else {
            gen.if((0, $3Ar5a._)($7b3c157399a22315$var$_templateObject2(), hasProperty, (0, $d3q0m.checkMissingProp)(cxt, deps, missing)));
            (0, $d3q0m.reportMissingProp)(cxt, missing);
            gen.else();
        }
    };
    var propertyDeps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cxt.schema;
    var gen = cxt.gen, data = cxt.data, it = cxt.it;
    if (Object.keys(propertyDeps).length === 0) return;
    var missing = gen.let("missing");
    for(var prop in propertyDeps)_loop(prop);
}
module.exports.validatePropertyDeps = $7b3c157399a22315$var$validatePropertyDeps;
function $7b3c157399a22315$var$validateSchemaDeps(cxt) {
    var _loop = function(prop) {
        if ((0, $eKI5Q.alwaysValidSchema)(it, schemaDeps[prop])) return "continue";
        gen.if((0, $d3q0m.propertyInData)(gen, data, prop, it.opts.ownProperties), function() {
            var schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, function() {
            return gen.var(valid, true) // TODO var
            ;
        });
        cxt.ok(valid);
    };
    var schemaDeps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cxt.schema;
    var gen = cxt.gen, data = cxt.data, keyword = cxt.keyword, it = cxt.it;
    var valid = gen.name("valid");
    for(var prop in schemaDeps)_loop(prop);
}
module.exports.validateSchemaDeps = $7b3c157399a22315$var$validateSchemaDeps;
module.exports.default = $7b3c157399a22315$var$def;

});

parcelRequire.register("1O17z", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $150b5491c190a301$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{propertyName: ",
        "}"
    ]);
    $150b5491c190a301$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $150b5491c190a301$var$error = {
    message: "property name must be valid",
    params: function(param) {
        var params = param.params;
        return (0, $3Ar5a._)($150b5491c190a301$var$_templateObject(), params.propertyName);
    }
};
var $150b5491c190a301$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $150b5491c190a301$var$error,
    code: function(cxt) {
        var gen = cxt.gen, schema = cxt.schema, data = cxt.data, it = cxt.it;
        if ((0, $eKI5Q.alwaysValidSchema)(it, schema)) return;
        var valid = gen.name("valid");
        gen.forIn("key", data, function(key) {
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $3Ar5a.not)(valid), function() {
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $150b5491c190a301$var$def;

});

parcelRequire.register("879Yu", function(module, exports) {

var $bmZve = parcelRequire("bmZve");

var $h9dQc = parcelRequire("h9dQc");
"use strict";
function $5e86b6f07ea5fdab$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{additionalProperty: ",
        "}"
    ]);
    $5e86b6f07ea5fdab$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5e86b6f07ea5fdab$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $5e86b6f07ea5fdab$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $5e86b6f07ea5fdab$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ".test(",
        ")"
    ]);
    $5e86b6f07ea5fdab$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $5e86b6f07ea5fdab$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "delete ",
        "[",
        "]"
    ]);
    $5e86b6f07ea5fdab$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $5e86b6f07ea5fdab$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $5e86b6f07ea5fdab$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3q0m = parcelRequire("d3q0m");

var $3Ar5a = parcelRequire("3Ar5a");

var $cuzEW = parcelRequire("cuzEW");

var $eKI5Q = parcelRequire("eKI5Q");
var $5e86b6f07ea5fdab$var$error = {
    message: "must NOT have additional properties",
    params: function(param) {
        var params = param.params;
        return (0, $3Ar5a._)($5e86b6f07ea5fdab$var$_templateObject(), params.additionalProperty);
    }
};
var $5e86b6f07ea5fdab$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $5e86b6f07ea5fdab$var$error,
    code: function(cxt) {
        var checkAdditionalProperties = function checkAdditionalProperties() {
            gen.forIn("key", data, function(key) {
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), function() {
                    return additionalPropertyCode(key);
                });
            });
        };
        var isAdditional = function isAdditional(key) {
            var definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                var propsSchema = (0, $eKI5Q.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $d3q0m.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $3Ar5a.or).apply(this, (0, $h9dQc._)(props.map(function(p) {
                return (0, $3Ar5a._)($5e86b6f07ea5fdab$var$_templateObject1(), key, p);
            })));
            else definedProp = $3Ar5a.nil;
            if (patProps.length) definedProp = (0, $3Ar5a.or).apply(this, [
                definedProp
            ].concat((0, $h9dQc._)(patProps.map(function(p) {
                return (0, $3Ar5a._)($5e86b6f07ea5fdab$var$_templateObject2(), (0, $d3q0m.usePattern)(cxt, p), key);
            }))));
            return (0, $3Ar5a.not)(definedProp);
        };
        var deleteAdditional = function deleteAdditional(key) {
            gen.code((0, $3Ar5a._)($5e86b6f07ea5fdab$var$_templateObject3(), data, key));
        };
        var additionalPropertyCode = function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $eKI5Q.alwaysValidSchema)(it, schema)) {
                var valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $3Ar5a.not)(valid), function() {
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $3Ar5a.not)(valid), function() {
                        return gen.break();
                    });
                }
            }
        };
        var applyAdditionalSchema = function applyAdditionalSchema(key, valid, errors) {
            var subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $eKI5Q.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        };
        var gen = cxt.gen, schema = cxt.schema, parentSchema = cxt.parentSchema, data = cxt.data, errsCount = cxt.errsCount, it = cxt.it;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        var allErrors = it.allErrors, opts = it.opts;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $eKI5Q.alwaysValidSchema)(it, schema)) return;
        var props = (0, $d3q0m.allSchemaProperties)(parentSchema.properties);
        var patProps = (0, $d3q0m.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $3Ar5a._)($5e86b6f07ea5fdab$var$_templateObject4(), errsCount, $cuzEW.default.errors));
    }
};
module.exports.default = $5e86b6f07ea5fdab$var$def;

});

parcelRequire.register("ePZnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8n3O1 = parcelRequire("8n3O1");

var $d3q0m = parcelRequire("d3q0m");

var $eKI5Q = parcelRequire("eKI5Q");

var $879Yu = parcelRequire("879Yu");
var $acd571f1a9a15968$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code: function(cxt) {
        var hasDefault = function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        };
        var applyPropertySchema = function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        };
        var gen = cxt.gen, schema = cxt.schema, parentSchema = cxt.parentSchema, data = cxt.data, it = cxt.it;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $879Yu.default.code(new $8n3O1.KeywordCxt(it, $879Yu.default, "additionalProperties"));
        var allProps = (0, $d3q0m.allSchemaProperties)(schema);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var prop = _step.value;
                it.definedProperties.add(prop);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $eKI5Q.mergeEvaluated.props(gen, (0, $eKI5Q.toHash)(allProps), it.props);
        var properties = allProps.filter(function(p) {
            return !(0, $eKI5Q.alwaysValidSchema)(it, schema[p]);
        });
        if (properties.length === 0) return;
        var valid = gen.name("valid");
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = properties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var prop1 = _step1.value;
                if (hasDefault(prop1)) applyPropertySchema(prop1);
                else {
                    gen.if((0, $d3q0m.propertyInData)(gen, data, prop1, it.opts.ownProperties));
                    applyPropertySchema(prop1);
                    if (!it.allErrors) gen.else().var(valid, true);
                    gen.endIf();
                }
                cxt.it.definedProperties.add(prop1);
                cxt.ok(valid);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
};
module.exports.default = $acd571f1a9a15968$var$def;

});

parcelRequire.register("5Rk1s", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $44416f0a4db045c2$var$_templateObject() {
    var data = (0, $bmZve._)([
        "",
        ".test(",
        ")"
    ]);
    $44416f0a4db045c2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $44416f0a4db045c2$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $44416f0a4db045c2$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3q0m = parcelRequire("d3q0m");

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");

var $eKI5Q = parcelRequire("eKI5Q");
var $44416f0a4db045c2$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code: function(cxt) {
        var validatePatternProperties = function validatePatternProperties() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = patterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var pat = _step.value;
                    if (checkProperties) checkMatchingProperties(pat);
                    if (it.allErrors) validateProperties(pat);
                    else {
                        gen.var(valid, true); // TODO var
                        validateProperties(pat);
                        gen.if(valid);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var checkMatchingProperties = function checkMatchingProperties(pat) {
            for(var prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $eKI5Q.checkStrictMode)(it, "property ".concat(prop, " matches pattern ").concat(pat, " (use allowMatchingProperties)"));
        };
        var validateProperties = function validateProperties(pat) {
            gen.forIn("key", data, function(key) {
                gen.if((0, $3Ar5a._)($44416f0a4db045c2$var$_templateObject(), (0, $d3q0m.usePattern)(cxt, pat), key), function() {
                    var alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $eKI5Q.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $3Ar5a._)($44416f0a4db045c2$var$_templateObject1(), props, key), true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $3Ar5a.not)(valid), function() {
                        return gen.break();
                    });
                });
            });
        };
        var gen = cxt.gen, schema = cxt.schema, data = cxt.data, parentSchema = cxt.parentSchema, it = cxt.it;
        var opts = it.opts;
        var patterns = (0, $d3q0m.allSchemaProperties)(schema);
        var alwaysValidPatterns = patterns.filter(function(p) {
            return (0, $eKI5Q.alwaysValidSchema)(it, schema[p]);
        });
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        var checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        var valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $3Ar5a.Name)) it.props = (0, $eKI5Q.evaluatedPropsToName)(gen, it.props);
        var props = it.props;
        validatePatternProperties();
    }
};
module.exports.default = $44416f0a4db045c2$var$def;

});

parcelRequire.register("iMiG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eKI5Q = parcelRequire("eKI5Q");
var $dabb328c38637e08$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code: function(cxt) {
        var gen = cxt.gen, schema = cxt.schema, it = cxt.it;
        if ((0, $eKI5Q.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        var valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, function() {
            return cxt.reset();
        }, function() {
            return cxt.error();
        });
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $dabb328c38637e08$var$def;

});

parcelRequire.register("cwkQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3q0m = parcelRequire("d3q0m");
var $91d8a634b8e6d937$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $d3q0m.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $91d8a634b8e6d937$var$def;

});

parcelRequire.register("emp47", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $a74690364d0e0033$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{passingSchemas: ",
        "}"
    ]);
    $a74690364d0e0033$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a74690364d0e0033$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " && ",
        ""
    ]);
    $a74690364d0e0033$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $a74690364d0e0033$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "[",
        ", ",
        "]"
    ]);
    $a74690364d0e0033$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $a74690364d0e0033$var$error = {
    message: "must match exactly one schema in oneOf",
    params: function(param) {
        var params = param.params;
        return (0, $3Ar5a._)($a74690364d0e0033$var$_templateObject(), params.passing);
    }
};
var $a74690364d0e0033$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $a74690364d0e0033$var$error,
    code: function(cxt) {
        var validateOneOf = function validateOneOf() {
            schArr.forEach(function(sch, i) {
                var schCxt;
                if ((0, $eKI5Q.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $3Ar5a._)($a74690364d0e0033$var$_templateObject1(), schValid, valid)).assign(valid, false).assign(passing, (0, $3Ar5a._)($a74690364d0e0033$var$_templateObject2(), passing, i)).else();
                gen.if(schValid, function() {
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $3Ar5a.Name);
                });
            });
        };
        var gen = cxt.gen, schema = cxt.schema, parentSchema = cxt.parentSchema, it = cxt.it;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        var schArr = schema;
        var valid = gen.let("valid", false);
        var passing = gen.let("passing", null);
        var schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, function() {
            return cxt.reset();
        }, function() {
            return cxt.error(true);
        });
    }
};
module.exports.default = $a74690364d0e0033$var$def;

});

parcelRequire.register("cmJTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eKI5Q = parcelRequire("eKI5Q");
var $900b2469044397ca$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code: function(cxt) {
        var gen = cxt.gen, schema = cxt.schema, it = cxt.it;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        var valid = gen.name("valid");
        schema.forEach(function(sch, i) {
            if ((0, $eKI5Q.alwaysValidSchema)(it, sch)) return;
            var schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $900b2469044397ca$var$def;

});

parcelRequire.register("98MWM", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $6a7ad448f473bab1$var$_templateObject() {
    var data = (0, $bmZve._)([
        'must match "',
        '" schema'
    ]);
    $6a7ad448f473bab1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6a7ad448f473bab1$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{failingKeyword: ",
        "}"
    ]);
    $6a7ad448f473bab1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6a7ad448f473bab1$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        ""
    ]);
    $6a7ad448f473bab1$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $eKI5Q = parcelRequire("eKI5Q");
var $6a7ad448f473bab1$var$error = {
    message: function(param) {
        var params = param.params;
        return (0, $3Ar5a.str)($6a7ad448f473bab1$var$_templateObject(), params.ifClause);
    },
    params: function(param) {
        var params = param.params;
        return (0, $3Ar5a._)($6a7ad448f473bab1$var$_templateObject1(), params.ifClause);
    }
};
var $6a7ad448f473bab1$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $6a7ad448f473bab1$var$error,
    code: function(cxt) {
        var validateIf = function validateIf() {
            var schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        };
        var validateClause = function validateClause(keyword, ifClause) {
            return function() {
                var schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $3Ar5a._)($6a7ad448f473bab1$var$_templateObject2(), keyword));
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        };
        var gen = cxt.gen, parentSchema = cxt.parentSchema, it = cxt.it;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $eKI5Q.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        var hasThen = $6a7ad448f473bab1$var$hasSchema(it, "then");
        var hasElse = $6a7ad448f473bab1$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        var valid = gen.let("valid", true);
        var schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            var ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $3Ar5a.not)(schValid), validateClause("else"));
        cxt.pass(valid, function() {
            return cxt.error(true);
        });
    }
};
function $6a7ad448f473bab1$var$hasSchema(it, keyword) {
    var schema = it.schema[keyword];
    return schema !== undefined && !(0, $eKI5Q.alwaysValidSchema)(it, schema);
}
module.exports.default = $6a7ad448f473bab1$var$def;

});

parcelRequire.register("ixNLG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eKI5Q = parcelRequire("eKI5Q");
var $d801e9fcb2a4eb69$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code: function(param) {
        var keyword = param.keyword, parentSchema = param.parentSchema, it = param.it;
        if (parentSchema.if === undefined) (0, $eKI5Q.checkStrictMode)(it, '"'.concat(keyword, '" without "if" is ignored'));
    }
};
module.exports.default = $d801e9fcb2a4eb69$var$def;

});


parcelRequire.register("gPn0P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fyhOe = parcelRequire("fyhOe");
var $c40342889ccd2a7d$var$format = [
    $fyhOe.default
];
module.exports.default = $c40342889ccd2a7d$var$format;

});
parcelRequire.register("fyhOe", function(module, exports) {

var $2MVSR = parcelRequire("2MVSR");

var $bmZve = parcelRequire("bmZve");
"use strict";
function $b527d887755956de$var$_templateObject() {
    var data = (0, $bmZve._)([
        'must match format "',
        '"'
    ]);
    $b527d887755956de$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{format: ",
        "}"
    ]);
    $b527d887755956de$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $b527d887755956de$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' == "object" && !(',
        " instanceof RegExp)"
    ]);
    $b527d887755956de$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        '.type || "string"'
    ]);
    $b527d887755956de$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "",
        ".validate"
    ]);
    $b527d887755956de$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject6() {
    var data = (0, $bmZve._)([
        '"string"'
    ]);
    $b527d887755956de$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        " && !",
        ""
    ]);
    $b527d887755956de$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject8() {
    var data = (0, $bmZve._)([
        "(",
        ".async ? await ",
        "(",
        ") : ",
        "(",
        "))"
    ]);
    $b527d887755956de$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject9() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ")"
    ]);
    $b527d887755956de$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject10() {
    var data = (0, $bmZve._)([
        "(typeof ",
        ' == "function" ? ',
        " : ",
        ".test(",
        "))"
    ]);
    $b527d887755956de$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject11() {
    var data = (0, $bmZve._)([
        "",
        " && ",
        " !== true && ",
        " === ",
        " && !",
        ""
    ]);
    $b527d887755956de$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject12() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $b527d887755956de$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject13() {
    var data = (0, $bmZve._)([
        "",
        ".validate"
    ]);
    $b527d887755956de$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject14() {
    var data = (0, $bmZve._)([
        "await ",
        "(",
        ")"
    ]);
    $b527d887755956de$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject15() {
    var data = (0, $bmZve._)([
        "",
        "(",
        ")"
    ]);
    $b527d887755956de$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $b527d887755956de$var$_templateObject16() {
    var data = (0, $bmZve._)([
        "",
        ".test(",
        ")"
    ]);
    $b527d887755956de$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");
var $b527d887755956de$var$error = {
    message: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a.str)($b527d887755956de$var$_templateObject(), schemaCode);
    },
    params: function(param) {
        var schemaCode = param.schemaCode;
        return (0, $3Ar5a._)($b527d887755956de$var$_templateObject1(), schemaCode);
    }
};
var $b527d887755956de$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $b527d887755956de$var$error,
    code: function(cxt, ruleType) {
        var validate$DataFormat = function validate$DataFormat() {
            var fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            var fDef = gen.const("fDef", (0, $3Ar5a._)($b527d887755956de$var$_templateObject2(), fmts, schemaCode));
            var fType = gen.let("fType");
            var format = gen.let("format");
            // TODO simplify
            gen.if((0, $3Ar5a._)($b527d887755956de$var$_templateObject3(), fDef, fDef), function() {
                return gen.assign(fType, (0, $3Ar5a._)($b527d887755956de$var$_templateObject4(), fDef)).assign(format, (0, $3Ar5a._)($b527d887755956de$var$_templateObject5(), fDef));
            }, function() {
                return gen.assign(fType, (0, $3Ar5a._)($b527d887755956de$var$_templateObject6())).assign(format, fDef);
            });
            cxt.fail$data((0, $3Ar5a.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $3Ar5a.nil;
                return (0, $3Ar5a._)($b527d887755956de$var$_templateObject7(), schemaCode, format);
            }
            function invalidFmt() {
                var callFormat = schemaEnv.$async ? (0, $3Ar5a._)($b527d887755956de$var$_templateObject8(), fDef, format, data, format, data) : (0, $3Ar5a._)($b527d887755956de$var$_templateObject9(), format, data);
                var validData = (0, $3Ar5a._)($b527d887755956de$var$_templateObject10(), format, callFormat, format, data);
                return (0, $3Ar5a._)($b527d887755956de$var$_templateObject11(), format, format, fType, ruleType, validData);
            }
        };
        var validateFormat = function validateFormat() {
            var formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            var _getFormat = (0, $2MVSR._)(getFormat(formatDef), 3), fmtType = _getFormat[0], format = _getFormat[1], fmtRef = _getFormat[2];
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return 'unknown format "'.concat(schema, '" ignored in schema at path "').concat(errSchemaPath, '"');
                }
            }
            function getFormat(fmtDef) {
                var code = fmtDef instanceof RegExp ? (0, $3Ar5a.regexpCode)(fmtDef) : opts.code.formats ? (0, $3Ar5a._)($b527d887755956de$var$_templateObject12(), opts.code.formats, (0, $3Ar5a.getProperty)(schema)) : undefined;
                var fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $3Ar5a._)($b527d887755956de$var$_templateObject13(), fmt)
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $3Ar5a._)($b527d887755956de$var$_templateObject14(), fmtRef, data);
                }
                return typeof format == "function" ? (0, $3Ar5a._)($b527d887755956de$var$_templateObject15(), fmtRef, data) : (0, $3Ar5a._)($b527d887755956de$var$_templateObject16(), fmtRef, data);
            }
        };
        var gen = cxt.gen, data = cxt.data, $data = cxt.$data, schema = cxt.schema, schemaCode = cxt.schemaCode, it = cxt.it;
        var opts = it.opts, errSchemaPath = it.errSchemaPath, schemaEnv = it.schemaEnv, self = it.self;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
    }
};
module.exports.default = $b527d887755956de$var$def;

});


parcelRequire.register("cGdwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRequire.register("kvl0Q", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $eed700946cbe8352$var$_templateObject() {
    var data = (0, $bmZve._)([
        "{error: ",
        ", tag: ",
        ", tagValue: ",
        "}"
    ]);
    $eed700946cbe8352$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $eed700946cbe8352$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "",
        " === ",
        ""
    ]);
    $eed700946cbe8352$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $eed700946cbe8352$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $eed700946cbe8352$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $eed700946cbe8352$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' == "string"'
    ]);
    $eed700946cbe8352$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Ar5a = parcelRequire("3Ar5a");

var $5LgPt = parcelRequire("5LgPt");

var $glLnH = parcelRequire("glLnH");

var $eKI5Q = parcelRequire("eKI5Q");
var $eed700946cbe8352$var$error = {
    message: function(param) {
        var _param_params = param.params, discrError = _param_params.discrError, tagName = _param_params.tagName;
        return discrError === $5LgPt.DiscrError.Tag ? 'tag "'.concat(tagName, '" must be string') : 'value of tag "'.concat(tagName, '" must be in oneOf');
    },
    params: function(param) {
        var _param_params = param.params, discrError = _param_params.discrError, tag = _param_params.tag, tagName = _param_params.tagName;
        return (0, $3Ar5a._)($eed700946cbe8352$var$_templateObject(), discrError, tagName, tag);
    }
};
var $eed700946cbe8352$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $eed700946cbe8352$var$error,
    code: function(cxt) {
        var validateMapping = function validateMapping() {
            var mapping = getMapping();
            gen.if(false);
            for(var tagValue in mapping){
                gen.elseIf((0, $3Ar5a._)($eed700946cbe8352$var$_templateObject1(), tag, tagValue));
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $5LgPt.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        };
        var applyTagSchema = function applyTagSchema(schemaProp) {
            var _valid = gen.name("valid");
            var schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $3Ar5a.Name);
            return _valid;
        };
        var getMapping = function getMapping() {
            var _a;
            var oneOfMapping = {};
            var topRequired = hasRequired(parentSchema);
            var tagRequired = true;
            for(var i = 0; i < oneOf.length; i++){
                var sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $eKI5Q.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = $glLnH.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, sch === null || sch === void 0 ? void 0 : sch.$ref);
                    if (sch instanceof $glLnH.SchemaEnv) sch = sch.schema;
                }
                var propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error('discriminator: oneOf subschemas (or referenced schemas) must have "properties/'.concat(tagName, '"'));
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error('discriminator: "'.concat(tagName, '" must be required'));
            return oneOfMapping;
            function hasRequired(param) {
                var required = param.required;
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) try {
                    for(var _iterator = sch.enum[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tagValue = _step.value;
                        addMapping(tagValue, i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else throw new Error('discriminator: "properties/'.concat(tagName, '" must have "const" or "enum"'));
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error('discriminator: "'.concat(tagName, '" values must be unique strings'));
                oneOfMapping[tagValue] = i;
            }
        };
        var gen = cxt.gen, data = cxt.data, schema = cxt.schema, parentSchema = cxt.parentSchema, it = cxt.it;
        var oneOf = parentSchema.oneOf;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        var tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        var valid = gen.let("valid", false);
        var tag = gen.const("tag", (0, $3Ar5a._)($eed700946cbe8352$var$_templateObject2(), data, (0, $3Ar5a.getProperty)(tagName)));
        gen.if((0, $3Ar5a._)($eed700946cbe8352$var$_templateObject3(), tag), function() {
            return validateMapping();
        }, function() {
            return cxt.error(false, {
                discrError: $5LgPt.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $eed700946cbe8352$var$def;

});
parcelRequire.register("5LgPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $431e65727de54540$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($431e65727de54540$var$DiscrError = module.exports.DiscrError || (module.exports.DiscrError = {}));

});


parcelRequire.register("kXvZh", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

});


parcelRequire.register("6i0h5", function(module, exports) {

var $2MVSR = parcelRequire("2MVSR");

var $bmZve = parcelRequire("bmZve");
"use strict";
function _templateObject() {
    var data = (0, $bmZve._)([
        'require("ajv-formats/dist/formats").',
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $ha3G4 = parcelRequire("ha3G4");

var $317TM = parcelRequire("317TM");

var $3Ar5a = parcelRequire("3Ar5a");
var fullName = new $3Ar5a.Name("fullFormats");
var fastName = new $3Ar5a.Name("fastFormats");
var formatsPlugin = function(ajv) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        keywords: true
    };
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, $ha3G4.fullFormats, fullName);
        return ajv;
    }
    var _ref = (0, $2MVSR._)(opts.mode === "fast" ? [
        $ha3G4.fastFormats,
        fastName
    ] : [
        $ha3G4.fullFormats,
        fullName
    ], 2), formats = _ref[0], exportName = _ref[1];
    var list = opts.formats || $ha3G4.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) $317TM.default(ajv);
    return ajv;
};
formatsPlugin.get = function(name) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "full";
    var formats = mode === "fast" ? $ha3G4.fastFormats : $ha3G4.fullFormats;
    var f = formats[name];
    if (!f) throw new Error('Unknown format "'.concat(name, '"'));
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = $3Ar5a._(_templateObject(), exportName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var f = _step.value;
            ajv.addFormat(f, fs[f]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

});
parcelRequire.register("ha3G4", function(module, exports) {

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");

var $2MVSR = parcelRequire("2MVSR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNames = module.exports.fastFormats = module.exports.fullFormats = void 0;
function $c7e63925f8110efc$var$fmtDef(validate, compare) {
    return {
        validate: validate,
        compare: compare
    };
}
module.exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: $c7e63925f8110efc$var$fmtDef($c7e63925f8110efc$var$date, $c7e63925f8110efc$var$compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: $c7e63925f8110efc$var$fmtDef($c7e63925f8110efc$var$time, $c7e63925f8110efc$var$compareTime),
    "date-time": $c7e63925f8110efc$var$fmtDef($c7e63925f8110efc$var$date_time, $c7e63925f8110efc$var$compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: $c7e63925f8110efc$var$uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: RegExp("^(?:https?|ftp):\\/\\/(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u{00a1}-\\u{ffff}]+-)*[a-z0-9\\u{00a1}-\\u{ffff}]+)(?:\\.(?:[a-z0-9\\u{00a1}-\\u{ffff}]+-)*[a-z0-9\\u{00a1}-\\u{ffff}]+)*(?:\\.(?:[a-z\\u{00a1}-\\u{ffff}]{2,})))(?::\\d{2,5})?(?:\\/[^\\s]*)?$", "iu"),
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: $c7e63925f8110efc$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte: $c7e63925f8110efc$var$byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: $c7e63925f8110efc$var$validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: $c7e63925f8110efc$var$validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: $c7e63925f8110efc$var$validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: $c7e63925f8110efc$var$validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
module.exports.fastFormats = (0, $cpUXF._)((0, $hF4Ve._)({}, module.exports.fullFormats), {
    date: $c7e63925f8110efc$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, $c7e63925f8110efc$var$compareDate),
    time: $c7e63925f8110efc$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $c7e63925f8110efc$var$compareTime),
    "date-time": $c7e63925f8110efc$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $c7e63925f8110efc$var$compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
});
module.exports.formatNames = Object.keys(module.exports.fullFormats);
function $c7e63925f8110efc$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
var $c7e63925f8110efc$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var $c7e63925f8110efc$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c7e63925f8110efc$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    var matches = $c7e63925f8110efc$var$DATE.exec(str);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && $c7e63925f8110efc$var$isLeapYear(year) ? 29 : $c7e63925f8110efc$var$DAYS[month]);
}
function $c7e63925f8110efc$var$compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
var $c7e63925f8110efc$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function $c7e63925f8110efc$var$time(str, withTimeZone) {
    var matches = $c7e63925f8110efc$var$TIME.exec(str);
    if (!matches) return false;
    var hour = +matches[1];
    var minute = +matches[2];
    var second = +matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
}
function $c7e63925f8110efc$var$compareTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    var a1 = $c7e63925f8110efc$var$TIME.exec(t1);
    var a2 = $c7e63925f8110efc$var$TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
var $c7e63925f8110efc$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $c7e63925f8110efc$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    var dateTime = str.split($c7e63925f8110efc$var$DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && $c7e63925f8110efc$var$date(dateTime[0]) && $c7e63925f8110efc$var$time(dateTime[1], true);
}
function $c7e63925f8110efc$var$compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    var _dt1_split = (0, $2MVSR._)(dt1.split($c7e63925f8110efc$var$DATE_TIME_SEPARATOR), 2), d1 = _dt1_split[0], t1 = _dt1_split[1];
    var _dt2_split = (0, $2MVSR._)(dt2.split($c7e63925f8110efc$var$DATE_TIME_SEPARATOR), 2), d2 = _dt2_split[0], t2 = _dt2_split[1];
    var res = $c7e63925f8110efc$var$compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || $c7e63925f8110efc$var$compareTime(t1, t2);
}
var $c7e63925f8110efc$var$NOT_URI_FRAGMENT = /\/|:/;
var $c7e63925f8110efc$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $c7e63925f8110efc$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $c7e63925f8110efc$var$NOT_URI_FRAGMENT.test(str) && $c7e63925f8110efc$var$URI.test(str);
}
var $c7e63925f8110efc$var$BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function $c7e63925f8110efc$var$byte(str) {
    $c7e63925f8110efc$var$BYTE.lastIndex = 0;
    return $c7e63925f8110efc$var$BYTE.test(str);
}
var $c7e63925f8110efc$var$MIN_INT32 = -Math.pow(2, 31);
var $c7e63925f8110efc$var$MAX_INT32 = Math.pow(2, 31) - 1;
function $c7e63925f8110efc$var$validateInt32(value) {
    return Number.isInteger(value) && value <= $c7e63925f8110efc$var$MAX_INT32 && value >= $c7e63925f8110efc$var$MIN_INT32;
}
function $c7e63925f8110efc$var$validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function $c7e63925f8110efc$var$validateNumber() {
    return true;
}
var $c7e63925f8110efc$var$Z_ANCHOR = /[^\\]\\Z/;
function $c7e63925f8110efc$var$regex(str) {
    if ($c7e63925f8110efc$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("317TM", function(module, exports) {

var $bmZve = parcelRequire("bmZve");
"use strict";
function $232797a064042451$var$_templateObject() {
    var data = (0, $bmZve._)([
        "should be ",
        " ",
        ""
    ]);
    $232797a064042451$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject1() {
    var data = (0, $bmZve._)([
        "{comparison: ",
        ", limit: ",
        "}"
    ]);
    $232797a064042451$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject2() {
    var data = (0, $bmZve._)([
        "",
        "[",
        "]"
    ]);
    $232797a064042451$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject3() {
    var data = (0, $bmZve._)([
        "typeof ",
        ' != "object"'
    ]);
    $232797a064042451$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject4() {
    var data = (0, $bmZve._)([
        "",
        " instanceof RegExp"
    ]);
    $232797a064042451$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject5() {
    var data = (0, $bmZve._)([
        "typeof ",
        '.compare != "function"'
    ]);
    $232797a064042451$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject6() {
    var data = (0, $bmZve._)([
        "",
        "",
        ""
    ]);
    $232797a064042451$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $232797a064042451$var$_templateObject7() {
    var data = (0, $bmZve._)([
        "",
        ".compare(",
        ", ",
        ") ",
        " 0"
    ]);
    $232797a064042451$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatLimitDefinition = void 0;

var $4ig53 = parcelRequire("4ig53");

var $3Ar5a = parcelRequire("3Ar5a");
var $232797a064042451$var$ops = $3Ar5a.operators;
var $232797a064042451$var$KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: $232797a064042451$var$ops.LTE,
        fail: $232797a064042451$var$ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: $232797a064042451$var$ops.GTE,
        fail: $232797a064042451$var$ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: $232797a064042451$var$ops.LT,
        fail: $232797a064042451$var$ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: $232797a064042451$var$ops.GT,
        fail: $232797a064042451$var$ops.LTE
    }
};
var $232797a064042451$var$error = {
    message: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        return $3Ar5a.str($232797a064042451$var$_templateObject(), $232797a064042451$var$KWDs[keyword].okStr, schemaCode);
    },
    params: function(param) {
        var keyword = param.keyword, schemaCode = param.schemaCode;
        return $3Ar5a._($232797a064042451$var$_templateObject1(), $232797a064042451$var$KWDs[keyword].okStr, schemaCode);
    }
};
module.exports.formatLimitDefinition = {
    keyword: Object.keys($232797a064042451$var$KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error: $232797a064042451$var$error,
    code: function(cxt) {
        var validate$DataFormat = function validate$DataFormat() {
            var fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            var fmt = gen.const("fmt", $3Ar5a._($232797a064042451$var$_templateObject2(), fmts, fCxt.schemaCode));
            cxt.fail$data($3Ar5a.or($3Ar5a._($232797a064042451$var$_templateObject3(), fmt), $3Ar5a._($232797a064042451$var$_templateObject4(), fmt), $3Ar5a._($232797a064042451$var$_templateObject5(), fmt), compareCode(fmt)));
        };
        var validateFormat = function validateFormat() {
            var format = fCxt.schema;
            var fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error('"'.concat(keyword, '": format "').concat(format, '" does not define "compare" function'));
            var fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? $3Ar5a._($232797a064042451$var$_templateObject6(), opts.code.formats, $3Ar5a.getProperty(format)) : undefined
            });
            cxt.fail$data(compareCode(fmt));
        };
        var compareCode = function compareCode(fmt) {
            return $3Ar5a._($232797a064042451$var$_templateObject7(), fmt, data, schemaCode, $232797a064042451$var$KWDs[keyword].fail);
        };
        var gen = cxt.gen, data = cxt.data, schemaCode = cxt.schemaCode, keyword = cxt.keyword, it = cxt.it;
        var opts = it.opts, self = it.self;
        if (!opts.validateFormats) return;
        var fCxt = new $4ig53.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
    },
    dependencies: [
        "format"
    ]
};
var $232797a064042451$var$formatLimitPlugin = function(ajv) {
    ajv.addKeyword(module.exports.formatLimitDefinition);
    return ajv;
};
module.exports.default = $232797a064042451$var$formatLimitPlugin;

});


parcelRequire.register("asuNP", function(module, exports) {

var $5F2Q2 = parcelRequire("5F2Q2");
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined1) {
    "use strict";
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, $5F2Q2._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, $5F2Q2._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, $5F2Q2._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, $5F2Q2._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if ((typeof q === "undefined" ? "undefined" : (0, $5F2Q2._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, $5F2Q2._)(q[1]) == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if ((0, $5F2Q2._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            if ((0, $5F2Q2._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, $5F2Q2._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, $5F2Q2._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && (0, $5F2Q2._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, $5F2Q2._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, $5F2Q2._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if ((typeof define === "undefined" ? "undefined" : (0, $5F2Q2._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, $5F2Q2._)(window1)) !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, $5F2Q2._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : undefined);

});

parcelRequire.register("akmwF", function(module, exports) {

var $5F2Q2 = parcelRequire("5F2Q2");

var $eSBMZ = parcelRequire("eSBMZ");
!function(t, e) {
    module.exports = e();
}(undefined, function() {
    "use strict";
    var mt = function mt(x) {
        var t = 0;
        if (71 !== x[t++] || 73 !== x[t++] || 70 !== x[t++] || 56 !== x[t++] || 56 != (x[t++] + 1 & 253) || 97 !== x[t++]) throw "Invalid GIF 87a/89a header.";
        var S = x[t++] | x[t++] << 8, e = x[t++] | x[t++] << 8, n = x[t++], r = n >> 7, i = 1 << (7 & n) + 1;
        x[t++];
        x[t++];
        var o = null;
        r && (o = t, t += 3 * i);
        var a = !0, s = [], h = 0, c = null, l = 0, u = null;
        for(this.width = S, this.height = e; a && t < x.length;)switch(x[t++]){
            case 33:
                switch(x[t++]){
                    case 255:
                        if (11 !== x[t] || 78 == x[t + 1] && 69 == x[t + 2] && 84 == x[t + 3] && 83 == x[t + 4] && 67 == x[t + 5] && 65 == x[t + 6] && 80 == x[t + 7] && 69 == x[t + 8] && 50 == x[t + 9] && 46 == x[t + 10] && 48 == x[t + 11] && 3 == x[t + 12] && 1 == x[t + 13] && 0 == x[t + 16]) t += 14, u = x[t++] | x[t++] << 8, t++;
                        else for(t += 12;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    case 249:
                        if (4 !== x[t++] || 0 !== x[t + 4]) throw "Invalid graphics extension block.";
                        var f = x[t++];
                        h = x[t++] | x[t++] << 8, c = x[t++], 0 == (1 & f) && (c = null), l = f >> 2 & 7, t++;
                        break;
                    case 254:
                        for(;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    default:
                        throw "Unknown graphic control label: 0x" + x[t - 1].toString(16);
                }
                break;
            case 44:
                var d = x[t++] | x[t++] << 8, p = x[t++] | x[t++] << 8, g = x[t++] | x[t++] << 8, m = x[t++] | x[t++] << 8, w = x[t++], y = w >> 6 & 1, v = o, b = !1;
                if (w >> 7) {
                    b = !0;
                    v = t, t += 3 * (1 << (7 & w) + 1);
                }
                var k = t;
                for(t++;;){
                    var _;
                    if (0 === (_ = x[t++])) break;
                    t += _;
                }
                s.push({
                    x: d,
                    y: p,
                    width: g,
                    height: m,
                    has_local_palette: b,
                    palette_offset: v,
                    data_offset: k,
                    data_length: t - k,
                    transparent_index: c,
                    interlaced: !!y,
                    delay: h,
                    disposal: l
                });
                break;
            case 59:
                a = !1;
                break;
            default:
                throw "Unknown gif block: 0x" + x[t - 1].toString(16);
        }
        this.numFrames = function() {
            return s.length;
        }, this.loopCount = function() {
            return u;
        }, this.frameInfo = function(t) {
            if (t < 0 || t >= s.length) throw "Frame index out of range.";
            return s[t];
        }, this.decodeAndBlitFrameBGRA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = b, e[f++] = v, e[f++] = y, e[f++] = 255;
                }
                --c;
            }
        }, this.decodeAndBlitFrameRGBA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = y, e[f++] = v, e[f++] = b, e[f++] = 255;
                }
                --c;
            }
        };
    };
    var wt = function wt(t, e, n, r) {
        for(var i = t[e++], o = 1 << i, a = o + 1, s = a + 1, h = i + 1, c = (1 << h) - 1, l = 0, u = 0, f = 0, d = t[e++], p = new Int32Array(4096), g = null;;){
            for(; l < 16 && 0 !== d;)u |= t[e++] << l, l += 8, 1 === d ? d = t[e++] : --d;
            if (l < h) break;
            var m = u & c;
            if (u >>= h, l -= h, m !== o) {
                if (m === a) break;
                for(var w = m < s ? m : g, y = 0, v = w; o < v;)v = p[v] >> 8, ++y;
                var b = v;
                if (r < f + y + (w !== m ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                n[f++] = b;
                var x = f += y;
                for(w !== m && (n[f++] = b), v = w; y--;)v = p[v], n[--x] = 255 & v, v >>= 8;
                null !== g && s < 4096 && (p[s++] = g << 8 | b, c + 1 <= s && h < 12 && (++h, c = c << 1 | 1)), g = m;
            } else s = a + 1, c = (1 << (h = i + 1)) - 1, g = null;
        }
        return f !== r && console.log("Warning, gif stream shorter than expected."), n;
    };
    var yt = /*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ function yt(t) {
        var S, k, _, A, e, u = Math.floor, I = new Array(64), C = new Array(64), T = new Array(64), F = new Array(64), w = new Array(65535), y = new Array(65535), Q = new Array(64), v = new Array(64), P = [], E = 0, q = 7, O = new Array(64), B = new Array(64), R = new Array(64), n = new Array(256), j = new Array(2048), b = [
            0,
            1,
            5,
            6,
            14,
            15,
            27,
            28,
            2,
            4,
            7,
            13,
            16,
            26,
            29,
            42,
            3,
            8,
            12,
            17,
            25,
            30,
            41,
            43,
            9,
            11,
            18,
            24,
            31,
            40,
            44,
            53,
            10,
            19,
            23,
            32,
            39,
            45,
            52,
            54,
            20,
            22,
            33,
            38,
            46,
            51,
            55,
            60,
            21,
            34,
            37,
            47,
            50,
            56,
            59,
            61,
            35,
            36,
            48,
            49,
            57,
            58,
            62,
            63
        ], D = [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], M = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], U = [
            0,
            0,
            2,
            1,
            3,
            3,
            2,
            4,
            3,
            5,
            5,
            4,
            4,
            0,
            0,
            1,
            125
        ], N = [
            1,
            2,
            3,
            0,
            4,
            17,
            5,
            18,
            33,
            49,
            65,
            6,
            19,
            81,
            97,
            7,
            34,
            113,
            20,
            50,
            129,
            145,
            161,
            8,
            35,
            66,
            177,
            193,
            21,
            82,
            209,
            240,
            36,
            51,
            98,
            114,
            130,
            9,
            10,
            22,
            23,
            24,
            25,
            26,
            37,
            38,
            39,
            40,
            41,
            42,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ], z = [
            0,
            0,
            3,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0
        ], L = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], H = [
            0,
            0,
            2,
            1,
            2,
            4,
            4,
            3,
            4,
            7,
            5,
            4,
            4,
            0,
            1,
            2,
            119
        ], W = [
            0,
            1,
            2,
            3,
            17,
            4,
            5,
            33,
            49,
            6,
            18,
            65,
            81,
            7,
            97,
            113,
            19,
            34,
            50,
            129,
            8,
            20,
            66,
            145,
            161,
            177,
            193,
            9,
            35,
            51,
            82,
            240,
            21,
            98,
            114,
            209,
            10,
            22,
            36,
            52,
            225,
            37,
            241,
            23,
            24,
            25,
            26,
            38,
            39,
            40,
            41,
            42,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ];
        function r(t, e) {
            for(var n = 0, r = 0, i = new Array, o = 1; o <= 16; o++){
                for(var a = 1; a <= t[o]; a++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = o, r++, n++;
                n *= 2;
            }
            return i;
        }
        function G(t) {
            for(var e = t[0], n = t[1] - 1; 0 <= n;)e & 1 << n && (E |= 1 << q), n--, --q < 0 && (255 == E ? (V(255), V(0)) : V(E), q = 7, E = 0);
        }
        function V(t) {
            P.push(t);
        }
        function Y(t) {
            V(t >> 8 & 255), V(255 & t);
        }
        function X(t, e, n, r, i) {
            for(var o, a = i[0], s = i[240], h = function(t, e) {
                var _$n, _$r, _$i, o, a, s, h, c, l, u, f = 0;
                for(l = 0; l < 8; ++l){
                    _$n = t[f], _$r = t[f + 1], _$i = t[f + 2], o = t[f + 3], a = t[f + 4], s = t[f + 5], h = t[f + 6];
                    var d = _$n + (c = t[f + 7]), p = _$n - c, g = _$r + h, m = _$r - h, w = _$i + s, y = _$i - s, v = o + a, b = o - a, x = d + v, S = d - v, k = g + w, _ = g - w;
                    t[f] = x + k, t[f + 4] = x - k;
                    var A = .707106781 * (_ + S);
                    t[f + 2] = S + A, t[f + 6] = S - A;
                    var I = .382683433 * ((x = b + y) - (_ = m + p)), C = .5411961 * x + I, T = 1.306562965 * _ + I, F = .707106781 * (k = y + m), P = p + F, E = p - F;
                    t[f + 5] = E + C, t[f + 3] = E - C, t[f + 1] = P + T, t[f + 7] = P - T, f += 8;
                }
                for(l = f = 0; l < 8; ++l){
                    _$n = t[f], _$r = t[f + 8], _$i = t[f + 16], o = t[f + 24], a = t[f + 32], s = t[f + 40], h = t[f + 48];
                    var q = _$n + (c = t[f + 56]), O = _$n - c, B = _$r + h, R = _$r - h, j = _$i + s, D = _$i - s, M = o + a, U = o - a, N = q + M, z = q - M, L = B + j, H = B - j;
                    t[f] = N + L, t[f + 32] = N - L;
                    var W = .707106781 * (H + z);
                    t[f + 16] = z + W, t[f + 48] = z - W;
                    var _$G = .382683433 * ((N = U + D) - (H = R + O)), V = .5411961 * N + _$G, Y = 1.306562965 * H + _$G, X = .707106781 * (L = D + R), J = O + X, K = O - X;
                    t[f + 40] = K + V, t[f + 24] = K - V, t[f + 8] = J + Y, t[f + 56] = J - Y, f++;
                }
                for(l = 0; l < 64; ++l)u = t[l] * e[l], Q[l] = 0 < u ? u + .5 | 0 : u - .5 | 0;
                return Q;
            }(t, e), c = 0; c < 64; ++c)v[b[c]] = h[c];
            var l = v[0] - n;
            n = v[0], 0 == l ? G(r[0]) : (G(r[y[o = 32767 + l]]), G(w[o]));
            for(var u = 63; 0 < u && 0 == v[u]; u--);
            if (0 == u) return G(a), n;
            for(var f, d = 1; d <= u;){
                for(var p = d; 0 == v[d] && d <= u; ++d);
                var g = d - p;
                if (16 <= g) {
                    f = g >> 4;
                    for(var m = 1; m <= f; ++m)G(s);
                    g &= 15;
                }
                o = 32767 + v[d], G(i[(g << 4) + y[o]]), G(w[o]), d++;
            }
            return 63 != u && G(a), n;
        }
        function J(t) {
            if (t <= 0 && (t = 1), 100 < t && (t = 100), e != t) (function(t) {
                for(var e = [
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ], n = 0; n < 64; n++){
                    var r = u((e[n] * t + 50) / 100);
                    r < 1 ? r = 1 : 255 < r && (r = 255), I[b[n]] = r;
                }
                for(var i = [
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ], o = 0; o < 64; o++){
                    var a = u((i[o] * t + 50) / 100);
                    a < 1 ? a = 1 : 255 < a && (a = 255), C[b[o]] = a;
                }
                for(var s = [
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ], h = 0, c = 0; c < 8; c++)for(var l = 0; l < 8; l++)T[h] = 1 / (I[b[h]] * s[c] * s[l] * 8), F[h] = 1 / (C[b[h]] * s[c] * s[l] * 8), h++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), e = t;
        }
        this.encode = function(t, e) {
            var n, r;
            (new Date).getTime();
            e && J(e), P = new Array, E = 0, q = 7, Y(65496), Y(65504), Y(16), V(74), V(70), V(73), V(70), V(0), V(1), V(1), V(0), Y(1), Y(1), V(0), V(0), function() {
                Y(65499), Y(132), V(0);
                for(var _$t = 0; _$t < 64; _$t++)V(I[_$t]);
                V(1);
                for(var _$e = 0; _$e < 64; _$e++)V(C[_$e]);
            }(), n = t.width, r = t.height, Y(65472), Y(17), V(8), Y(r), Y(n), V(3), V(1), V(17), V(0), V(2), V(17), V(1), V(3), V(17), V(1), function() {
                Y(65476), Y(418), V(0);
                for(var _$t = 0; _$t < 16; _$t++)V(D[_$t + 1]);
                for(var _$e = 0; _$e <= 11; _$e++)V(M[_$e]);
                V(16);
                for(var n = 0; n < 16; n++)V(U[n + 1]);
                for(var r = 0; r <= 161; r++)V(N[r]);
                V(1);
                for(var i = 0; i < 16; i++)V(z[i + 1]);
                for(var o = 0; o <= 11; o++)V(L[o]);
                V(17);
                for(var a = 0; a < 16; a++)V(H[a + 1]);
                for(var s = 0; s <= 161; s++)V(W[s]);
            }(), Y(65498), Y(12), V(3), V(1), V(0), V(2), V(17), V(3), V(17), V(0), V(63), V(0);
            var i = 0, o = 0, a = 0;
            E = 0, q = 7, this.encode.displayName = "_encode_";
            for(var s, h, c, l, u, f, d, p, g, m = t.data, w = t.width, y = t.height, v = 4 * w, b = 0; b < y;){
                for(s = 0; s < v;){
                    for(f = u = v * b + s, d = -1, g = p = 0; g < 64; g++)f = u + (p = g >> 3) * v + (d = 4 * (7 & g)), y <= b + p && (f -= v * (b + 1 + p - y)), v <= s + d && (f -= s + d - v + 4), h = m[f++], c = m[f++], l = m[f++], O[g] = (j[h] + j[c + 256 >> 0] + j[l + 512 >> 0] >> 16) - 128, B[g] = (j[h + 768 >> 0] + j[c + 1024 >> 0] + j[l + 1280 >> 0] >> 16) - 128, R[g] = (j[h + 1280 >> 0] + j[c + 1536 >> 0] + j[l + 1792 >> 0] >> 16) - 128;
                    i = X(O, T, i, S, _), o = X(B, F, o, k, A), a = X(R, F, a, k, A), s += 32;
                }
                b += 8;
            }
            if (0 <= q) {
                var x = [];
                x[1] = q + 1, x[0] = (1 << q + 1) - 1, G(x);
            }
            return Y(65497), new Uint8Array(P);
        }, function() {
            (new Date).getTime();
            t || (t = 50), function() {
                for(var _$t = String.fromCharCode, e = 0; e < 256; e++)n[e] = _$t(e);
            }(), S = r(D, M), k = r(z, L), _ = r(U, N), A = r(H, W), function() {
                for(var _$t = 1, e = 2, n = 1; n <= 15; n++){
                    for(var _$r = _$t; _$r < e; _$r++)y[32767 + _$r] = n, w[32767 + _$r] = [], w[32767 + _$r][1] = n, w[32767 + _$r][0] = _$r;
                    for(var i = -(e - 1); i <= -_$t; i++)y[32767 + i] = n, w[32767 + i] = [], w[32767 + i][1] = n, w[32767 + i][0] = e - 1 + i;
                    _$t <<= 1, e <<= 1;
                }
            }(), function() {
                for(var _$t = 0; _$t < 256; _$t++)j[_$t] = 19595 * _$t, j[_$t + 256 >> 0] = 38470 * _$t, j[_$t + 512 >> 0] = 7471 * _$t + 32768, j[_$t + 768 >> 0] = -11059 * _$t, j[_$t + 1024 >> 0] = -21709 * _$t, j[_$t + 1280 >> 0] = 32768 * _$t + 8421375, j[_$t + 1536 >> 0] = -27439 * _$t, j[_$t + 1792 >> 0] = -5329 * _$t;
            }(), J(t), (new Date).getTime();
        }();
    };
    var xt = function xt(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
            "BM",
            "BA",
            "CI",
            "CP",
            "IC",
            "PT"
        ].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
    };
    var t, y, e, I, i, o, a, h, C, T, d, p, F, n, r, s, c, P, E, q, g, m, w, l, v, b, x, S, u, k, _, f, A, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y, X, J, K, Q, Z, vt = "function" == typeof Symbol && "symbol" == (0, $5F2Q2._)(Symbol.iterator) ? function vt(t) {
        return typeof t === "undefined" ? "undefined" : (0, $5F2Q2._)(t);
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $5F2Q2._)(t);
    }, $ = function(pt) {
        var wt = function wt(o) {
            var a = {};
            this.subscribe = function(t, e, n) {
                if ("function" != typeof e) return !1;
                a.hasOwnProperty(t) || (a[t] = {});
                var r = Math.random().toString(35);
                return a[t][r] = [
                    e,
                    !!n
                ], r;
            }, this.unsubscribe = function(t) {
                for(var e in a)if (a[e][t]) return delete a[e][t], !0;
                return !1;
            }, this.publish = function(t) {
                if (a.hasOwnProperty(t)) {
                    var e = Array.prototype.slice.call(arguments, 1), n = [];
                    for(var r in a[t]){
                        var i = a[t][r];
                        try {
                            i[0].apply(o, e);
                        } catch (t) {
                            pt.console && console.error("jsPDF PubSub Error", t.message, t);
                        }
                        i[1] && n.push(r);
                    }
                    n.length && n.forEach(this.unsubscribe);
                }
            };
        };
        var gt = "1.3", mt = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        function yt(t, e, n, r) {
            var i = {};
            "object" === (void 0 === t ? "undefined" : vt(t)) && (t = (i = t).orientation, e = i.unit || e, n = i.format || n, r = i.compress || i.compressPdf || r), e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
            ("" + n).toLowerCase();
            var K, w, y, o, u, v, a, s, h, c, l, f = !!r && "function" == typeof Uint8Array, Q = i.textColor || "0 g", d = i.drawColor || "0 G", Z = i.fontSize || 16, $ = i.charSpace || 0, tt = i.R2L || !1, et = i.lineHeight || 1.15, p = i.lineWidth || .200025, g = "00000000000000000000000000000000", m = 2, b = !1, x = [], nt = {}, S = {}, k = 0, _ = [], A = [], I = [], C = [], T = [], F = 0, P = 0, E = 0, q = {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
            }, O = {}, rt = new wt(O), B = i.hotfixes || [], R = function R(t) {
                var _$e, _$n = t.ch1, _$r = t.ch2, i = t.ch3, o = t.ch4, a = (t.precision, "draw" === t.pdfColorType ? [
                    "G",
                    "RG",
                    "K"
                ] : [
                    "g",
                    "rg",
                    "k"
                ]);
                if ("string" == typeof _$n && "#" !== _$n.charAt(0)) {
                    var s = new RGBColor(_$n);
                    s.ok && (_$n = s.toHex());
                }
                if ("string" == typeof _$n && /^#[0-9A-Fa-f]{3}$/.test(_$n) && (_$n = "#" + _$n[1] + _$n[1] + _$n[2] + _$n[2] + _$n[3] + _$n[3]), "string" == typeof _$n && /^#[0-9A-Fa-f]{6}$/.test(_$n)) {
                    var h = parseInt(_$n.substr(1), 16);
                    _$n = h >> 16 & 255, _$r = h >> 8 & 255, i = 255 & h;
                }
                if (void 0 === _$r || void 0 === o && _$n === _$r && _$r === i) {
                    if ("string" == typeof _$n) _$e = _$n + " " + a[0];
                    else switch(t.precision){
                        case 2:
                            _$e = N(_$n / 255) + " " + a[0];
                            break;
                        case 3:
                        default:
                            _$e = z(_$n / 255) + " " + a[0];
                    }
                } else if (void 0 === o || "object" === (void 0 === o ? "undefined" : vt(o))) {
                    if ("string" == typeof _$n) _$e = [
                        _$n,
                        _$r,
                        i,
                        a[1]
                    ].join(" ");
                    else switch(t.precision){
                        case 2:
                            _$e = [
                                N(_$n / 255),
                                N(_$r / 255),
                                N(i / 255),
                                a[1]
                            ].join(" ");
                            break;
                        default:
                        case 3:
                            _$e = [
                                z(_$n / 255),
                                z(_$r / 255),
                                z(i / 255),
                                a[1]
                            ].join(" ");
                    }
                    o && 0 === o.a && (_$e = [
                        "255",
                        "255",
                        "255",
                        a[1]
                    ].join(" "));
                } else if ("string" == typeof _$n) _$e = [
                    _$n,
                    _$r,
                    i,
                    o,
                    a[2]
                ].join(" ");
                else switch(t.precision){
                    case 2:
                        _$e = [
                            N(_$n),
                            N(_$r),
                            N(i),
                            N(o),
                            a[2]
                        ].join(" ");
                        break;
                    case 3:
                    default:
                        _$e = [
                            z(_$n),
                            z(_$r),
                            z(i),
                            z(o),
                            a[2]
                        ].join(" ");
                }
                return _$e;
            }, j = function j(t) {
                var _$e = function e(t) {
                    return ("0" + parseInt(t)).slice(-2);
                }, _$n = t.getTimezoneOffset(), _$r = _$n < 0 ? "+" : "-", i = Math.floor(Math.abs(_$n / 60)), o = Math.abs(_$n % 60), a = [
                    _$r,
                    _$e(i),
                    "'",
                    _$e(o),
                    "'"
                ].join("");
                return [
                    "D:",
                    t.getFullYear(),
                    _$e(t.getMonth() + 1),
                    _$e(t.getDate()),
                    _$e(t.getHours()),
                    _$e(t.getMinutes()),
                    _$e(t.getSeconds()),
                    a
                ].join("");
            }, D = function D(t) {
                var _$e;
                return void 0 === (void 0 === t ? "undefined" : vt(t)) && (t = new Date), _$e = "object" === (void 0 === t ? "undefined" : vt(t)) && "[object Date]" === Object.prototype.toString.call(t) ? j(t) : /^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t) ? t : j(new Date), c = _$e;
            }, M = function M(t) {
                var _$e = c;
                return "jsDate" === t && (_$e = function(t) {
                    var _$e = parseInt(t.substr(2, 4), 10), _$n = parseInt(t.substr(6, 2), 10) - 1, _$r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), o = parseInt(t.substr(12, 2), 10), a = parseInt(t.substr(14, 2), 10);
                    parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10);
                    return new Date(_$e, _$n, _$r, i, o, a, 0);
                }(c)), _$e;
            }, U = function U(t) {
                return t = t || "12345678901234567890123456789012".split("").map(function() {
                    return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), g = t;
            }, N = function N(t) {
                return t.toFixed(2);
            }, z = function z(t) {
                return t.toFixed(3);
            }, it = function it(t) {
                t = "string" == typeof t ? t : t.toString(), b ? _[o].push(t) : (E += t.length + 1, C.push(t));
            }, L = function L() {
                return x[++m] = E, it(m + " 0 obj"), m;
            }, H = function H(t) {
                it("stream"), it(t), it("endstream");
            }, W = function W() {
                for(var _$t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), it("/Font <<"), nt)nt.hasOwnProperty(_$t) && it("/" + _$t + " " + nt[_$t].objectNumber + " 0 R");
                it(">>"), it("/XObject <<"), rt.publish("putXobjectDict"), it(">>");
            }, G = function G() {
                !function() {
                    for(var _$t in nt)nt.hasOwnProperty(_$t) && (_$e = nt[_$t], rt.publish("putFont", {
                        font: _$e,
                        out: it,
                        newObject: L
                    }), !0 !== _$e.isAlreadyPutted && (_$e.objectNumber = L(), it("<<"), it("/Type /Font"), it("/BaseFont /" + _$e.postScriptName), it("/Subtype /Type1"), "string" == typeof _$e.encoding && it("/Encoding /" + _$e.encoding), it("/FirstChar 32"), it("/LastChar 255"), it(">>"), it("endobj")));
                    var _$e;
                }(), rt.publish("putResources"), x[2] = E, it("2 0 obj"), it("<<"), W(), it(">>"), it("endobj"), rt.publish("postPutResources");
            }, V = function V(t, e, n) {
                S.hasOwnProperty(e) || (S[e] = {}), S[e][n] = t;
            }, Y = function Y(t, e, n, r) {
                var i = "F" + (Object.keys(nt).length + 1).toString(10), o = nt[i] = {
                    id: i,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: n,
                    encoding: r,
                    metadata: {}
                };
                return V(i, e, n), rt.publish("addFont", o), i;
            }, ot = function ot(t, e) {
                return (function(t, e) {
                    var _$n, _$r, i, o, a, s, h, c, l;
                    if (i = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && nt[K].metadata && nt[K].metadata[i] && nt[K].metadata[i].encoding && (o = nt[K].metadata[i].encoding, !a && nt[K].encoding && (a = nt[K].encoding), !a && o.codePages && (a = o.codePages[0]), "string" == typeof a && (a = o[a]), a)) {
                        for(h = !1, s = [], _$n = 0, _$r = t.length; _$n < _$r; _$n++)(c = a[t.charCodeAt(_$n)]) ? s.push(String.fromCharCode(c)) : s.push(t[_$n]), s[_$n].charCodeAt(0) >> 8 && (h = !0);
                        t = s.join("");
                    }
                    for(_$n = t.length; void 0 === h && 0 !== _$n;)t.charCodeAt(_$n - 1) >> 8 && (h = !0), _$n--;
                    if (!h) return t;
                    for(s = e.noBOM ? [] : [
                        254,
                        255
                    ], _$n = 0, _$r = t.length; _$n < _$r; _$n++){
                        if ((l = (c = t.charCodeAt(_$n)) >> 8) >> 8) throw new Error("Character at position " + _$n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                        s.push(l), s.push(c - (l << 8));
                    }
                    return String.fromCharCode.apply(void 0, s);
                })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            }, X = function X() {
                (function(t, e) {
                    var _$n = "string" == typeof e && e.toLowerCase();
                    if ("string" == typeof t) {
                        var _$r = t.toLowerCase();
                        mt.hasOwnProperty(_$r) && (t = mt[_$r][0] / w, e = mt[_$r][1] / w);
                    }
                    if (Array.isArray(t) && (e = t[1], t = t[0]), _$n) {
                        switch(_$n.substr(0, 1)){
                            case "l":
                                t < e && (_$n = "s");
                                break;
                            case "p":
                                e < t && (_$n = "s");
                        }
                        "s" === _$n && (y = t, t = e, e = y);
                    }
                    b = !0, _[++k] = [], I[k] = {
                        width: Number(t) || u,
                        height: Number(e) || v
                    }, A[k] = {}, J(k);
                }).apply(this, arguments), it(N(p * w) + " w"), it(d), 0 !== F && it(F + " J"), 0 !== P && it(P + " j"), rt.publish("addPage", {
                    pageNumber: k
                });
            }, J = function J(t) {
                0 < t && t <= k && (u = I[o = t].width, v = I[t].height);
            }, at = function at(t, e, n) {
                var _$r, i = void 0;
                return n = n || {}, t = void 0 !== t ? t : nt[K].fontName, e = void 0 !== e ? e : nt[K].fontStyle, _$r = t.toLowerCase(), void 0 !== S[_$r] && void 0 !== S[_$r][e] ? i = S[_$r][e] : void 0 !== S[t] && void 0 !== S[t][e] ? i = S[t][e] : !1 === n.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = S.times[e]) && (i = S.times.normal), i;
            }, st = function st() {
                b = !1, m = 2, E = 0, C = [], x = [], T = [], rt.publish("buildDocument"), it("%PDF-" + gt), it("%\xba\xdf\xac\xe0"), function() {
                    var _$t, _$e, _$n, _$r, i, o, a, s, h, c = [];
                    for(a = pt.adler32cs || yt.API.adler32cs, f && void 0 === a && (f = !1), _$t = 1; _$t <= k; _$t++){
                        if (c.push(L()), s = (u = I[_$t].width) * w, h = (v = I[_$t].height) * w, it("<</Type /Page"), it("/Parent 1 0 R"), it("/Resources 2 0 R"), it("/MediaBox [0 0 " + N(s) + " " + N(h) + "]"), rt.publish("putPage", {
                            pageNumber: _$t,
                            page: _[_$t]
                        }), it("/Contents " + (m + 1) + " 0 R"), it(">>"), it("endobj"), _$e = _[_$t].join("\n"), L(), f) {
                            for(_$n = [], _$r = _$e.length; _$r--;)_$n[_$r] = _$e.charCodeAt(_$r);
                            o = a.from(_$e), (i = new Deflater(6)).append(new Uint8Array(_$n)), _$e = i.flush(), (_$n = new Uint8Array(_$e.length + 6)).set(new Uint8Array([
                                120,
                                156
                            ])), _$n.set(_$e, 2), _$n.set(new Uint8Array([
                                255 & o,
                                o >> 8 & 255,
                                o >> 16 & 255,
                                o >> 24 & 255
                            ]), _$e.length + 2), _$e = String.fromCharCode.apply(null, _$n), it("<</Length " + _$e.length + " /Filter [/FlateDecode]>>");
                        } else it("<</Length " + _$e.length + ">>");
                        H(_$e), it("endobj");
                    }
                    x[1] = E, it("1 0 obj"), it("<</Type /Pages");
                    var l = "/Kids [";
                    for(_$r = 0; _$r < k; _$r++)l += c[_$r] + " 0 R ";
                    it(l + "]"), it("/Count " + k), it(">>"), it("endobj"), rt.publish("postPutPages");
                }(), function() {
                    rt.publish("putAdditionalObjects");
                    for(var _$t = 0; _$t < T.length; _$t++){
                        var _$e = T[_$t];
                        x[_$e.objId] = E, it(_$e.objId + " 0 obj"), it(_$e.content), it("endobj");
                    }
                    m += T.length, rt.publish("postPutAdditionalObjects");
                }(), G(), L(), it("<<"), function() {
                    for(var _$t in it("/Producer (jsPDF " + yt.version + ")"), q)q.hasOwnProperty(_$t) && q[_$t] && it("/" + _$t.substr(0, 1).toUpperCase() + _$t.substr(1) + " (" + ot(q[_$t]) + ")");
                    it("/CreationDate (" + c + ")");
                }(), it(">>"), it("endobj"), L(), it("<<"), function() {
                    switch(it("/Type /Catalog"), it("/Pages 1 0 R"), s || (s = "fullwidth"), s){
                        case "fullwidth":
                            it("/OpenAction [3 0 R /FitH null]");
                            break;
                        case "fullheight":
                            it("/OpenAction [3 0 R /FitV null]");
                            break;
                        case "fullpage":
                            it("/OpenAction [3 0 R /Fit]");
                            break;
                        case "original":
                            it("/OpenAction [3 0 R /XYZ null null 1]");
                            break;
                        default:
                            var _$t = "" + s;
                            "%" === _$t.substr(_$t.length - 1) && (s = parseInt(s) / 100), "number" == typeof s && it("/OpenAction [3 0 R /XYZ null null " + N(s) + "]");
                    }
                    switch(h || (h = "continuous"), h){
                        case "continuous":
                            it("/PageLayout /OneColumn");
                            break;
                        case "single":
                            it("/PageLayout /SinglePage");
                            break;
                        case "two":
                        case "twoleft":
                            it("/PageLayout /TwoColumnLeft");
                            break;
                        case "tworight":
                            it("/PageLayout /TwoColumnRight");
                    }
                    a && it("/PageMode /" + a), rt.publish("putCatalog");
                }(), it(">>"), it("endobj");
                var _$t, _$e = E, _$n = "0000000000";
                for(it("xref"), it("0 " + (m + 1)), it(_$n + " 65535 f "), _$t = 1; _$t <= m; _$t++){
                    var _$r = x[_$t];
                    it("function" == typeof _$r ? (_$n + x[_$t]()).slice(-10) + " 00000 n " : (_$n + x[_$t]).slice(-10) + " 00000 n ");
                }
                return it("trailer"), it("<<"), it("/Size " + (m + 1)), it("/Root " + m + " 0 R"), it("/Info " + (m - 1) + " 0 R"), it("/ID [ <" + g + "> <" + g + "> ]"), it(">>"), it("startxref"), it("" + _$e), it("%%EOF"), b = !0, C.join("\n");
            }, ht = function ht(t) {
                var _$e = "S";
                return "F" === t ? _$e = "f" : "FD" === t || "DF" === t ? _$e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (_$e = t), _$e;
            }, ct = function ct() {
                for(var _$t = st(), _$e = _$t.length, _$n = new ArrayBuffer(_$e), _$r = new Uint8Array(_$n); _$e--;)_$r[_$e] = _$t.charCodeAt(_$e);
                return _$n;
            }, lt = function lt() {
                return new Blob([
                    ct()
                ], {
                    type: "application/pdf"
                });
            }, ut = ((l = function l(t, e) {
                var _$n = "dataur" === ("" + t).substr(0, 6) ? "data:application/pdf;base64," + btoa(st()) : 0;
                switch(t){
                    case void 0:
                        return st();
                    case "save":
                        if ("object" === ("undefined" == typeof navigator ? "undefined" : vt(navigator)) && navigator.getUserMedia && (void 0 === pt.URL || void 0 === pt.URL.createObjectURL)) return O.output("dataurlnewwindow");
                        bt(lt(), e), "function" == typeof bt.unload && pt.setTimeout && setTimeout(bt.unload, 911);
                        break;
                    case "arraybuffer":
                        return ct();
                    case "blob":
                        return lt();
                    case "bloburi":
                    case "bloburl":
                        return pt.URL && pt.URL.createObjectURL(lt()) || void 0;
                    case "datauristring":
                    case "dataurlstring":
                        return _$n;
                    case "dataurlnewwindow":
                        var _$r = pt.open(_$n);
                        if (_$r || "undefined" == typeof safari) return _$r;
                    case "datauri":
                    case "dataurl":
                        return pt.document.location.href = _$n;
                    default:
                        throw new Error('Output type "' + t + '" is not supported.');
                }
            }).foo = function ut() {
                try {
                    return l.apply(this, arguments);
                } catch (t) {
                    var _$e = t.stack || "";
                    ~_$e.indexOf(" at ") && (_$e = _$e.split(" at ")[1]);
                    var _$n = "Error in function " + _$e.split("\n")[0].split("<")[0] + ": " + t.message;
                    if (!pt.console) throw new Error(_$n);
                    pt.console.error(_$n, t), pt.alert && alert(_$n);
                }
            }, (l.foo.bar = l).foo), ft = function ft(t) {
                return !0 === Array.isArray(B) && -1 < B.indexOf(t);
            };
            switch(e){
                case "pt":
                    w = 1;
                    break;
                case "mm":
                    w = 72 / 25.4;
                    break;
                case "cm":
                    w = 72 / 2.54;
                    break;
                case "in":
                    w = 72;
                    break;
                case "px":
                    w = 1 == ft("px_scaling") ? .75 : 96 / 72;
                    break;
                case "pc":
                case "em":
                    w = 12;
                    break;
                case "ex":
                    w = 6;
                    break;
                default:
                    throw "Invalid unit: " + e;
            }
            for(var dt in D(), U(), O.internal = {
                pdfEscape: ot,
                getStyle: ht,
                getFont: function getFont() {
                    return nt[at.apply(O, arguments)];
                },
                getFontSize: function getFontSize() {
                    return Z;
                },
                getCharSpace: function getCharSpace() {
                    return $;
                },
                getTextColor: function getTextColor() {
                    var _$t = Q.split(" ");
                    if (2 === _$t.length && "g" === _$t[1]) {
                        var _$e = parseFloat(_$t[0]);
                        _$t = [
                            _$e,
                            _$e,
                            _$e,
                            "r"
                        ];
                    }
                    for(var _$n = "#", _$r = 0; _$r < 3; _$r++)_$n += ("0" + Math.floor(255 * parseFloat(_$t[_$r])).toString(16)).slice(-2);
                    return _$n;
                },
                getLineHeight: function getLineHeight() {
                    return Z * et;
                },
                write: function write(t) {
                    it(1 === arguments.length ? t : Array.prototype.join.call(arguments, " "));
                },
                getCoordinateString: function getCoordinateString(t) {
                    return N(t * w);
                },
                getVerticalCoordinateString: function getVerticalCoordinateString(t) {
                    return N((v - t) * w);
                },
                collections: {},
                newObject: L,
                newAdditionalObject: function newAdditionalObject() {
                    var _$t = 2 * _.length + 1, _$e = {
                        objId: _$t += T.length,
                        content: ""
                    };
                    return T.push(_$e), _$e;
                },
                newObjectDeferred: function newObjectDeferred() {
                    return x[++m] = function() {
                        return E;
                    }, m;
                },
                newObjectDeferredBegin: function newObjectDeferredBegin(t) {
                    x[t] = E;
                },
                putStream: H,
                events: rt,
                scaleFactor: w,
                pageSize: {
                    getWidth: function getWidth() {
                        return u;
                    },
                    getHeight: function getHeight() {
                        return v;
                    }
                },
                output: function output(t, e) {
                    return ut(t, e);
                },
                getNumberOfPages: function getNumberOfPages() {
                    return _.length - 1;
                },
                pages: _,
                out: it,
                f2: N,
                getPageInfo: function getPageInfo(t) {
                    return {
                        objId: 2 * (t - 1) + 3,
                        pageNumber: t,
                        pageContext: A[t]
                    };
                },
                getCurrentPageInfo: function getCurrentPageInfo() {
                    return {
                        objId: 2 * (o - 1) + 3,
                        pageNumber: o,
                        pageContext: A[o]
                    };
                },
                getPDFVersion: function getPDFVersion() {
                    return gt;
                },
                hasHotfix: ft
            }, O.addPage = function() {
                return X.apply(this, arguments), this;
            }, O.setPage = function() {
                return J.apply(this, arguments), this;
            }, O.insertPage = function(t) {
                return this.addPage(), this.movePage(o, t), this;
            }, O.movePage = function(t, e) {
                if (e < t) {
                    for(var _$n = _[t], _$r = I[t], i = A[t], o = t; e < o; o--)_[o] = _[o - 1], I[o] = I[o - 1], A[o] = A[o - 1];
                    _[e] = _$n, I[e] = _$r, A[e] = i, this.setPage(e);
                } else if (t < e) {
                    for(_$n = _[t], _$r = I[t], i = A[t], o = t; o < e; o++)_[o] = _[o + 1], I[o] = I[o + 1], A[o] = A[o + 1];
                    _[e] = _$n, I[e] = _$r, A[e] = i, this.setPage(e);
                }
                return this;
            }, O.deletePage = function() {
                return (function(t) {
                    0 < t && t <= k && (_.splice(t, 1), I.splice(t, 1), --k < o && (o = k), this.setPage(o));
                }).apply(this, arguments), this;
            }, O.setCreationDate = function(t) {
                return D(t), this;
            }, O.getCreationDate = function(t) {
                return M(t);
            }, O.setFileId = function(t) {
                return U(t), this;
            }, O.getFileId = function() {
                return g;
            }, O.setDisplayMode = function(t, e, n) {
                if (s = t, h = e, -1 == [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen"
                ].indexOf(a = n)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + n + '" is not recognized.');
                return this;
            }, O.text = function(t, e, n, i) {
                var _$r, o, a = "", s = et, h = this;
                function c(t) {
                    for(var _$e, _$n = t.concat(), _$r = [], _$i = _$n.length; _$i--;)"string" == typeof (_$e = _$n.shift()) ? _$r.push(_$e) : "[object Array]" === Object.prototype.toString.call(t) && 1 === _$e.length ? _$r.push(_$e[0]) : _$r.push([
                        _$e[0],
                        _$e[1],
                        _$e[2]
                    ]);
                    return _$r;
                }
                function l(t, e) {
                    var _$n;
                    if ("string" == typeof t) _$n = e(t)[0];
                    else if ("[object Array]" === Object.prototype.toString.call(t)) {
                        for(var _$r, _$i, o = t.concat(), a = [], s = o.length; s--;)"string" == typeof (_$r = o.shift()) ? a.push(e(_$r)[0]) : "[object Array]" === Object.prototype.toString.call(_$r) && "string" === _$r[0] && (_$i = e(_$r[0], _$r[1], _$r[2]), a.push([
                            _$i[0],
                            _$i[1],
                            _$i[2]
                        ]));
                        _$n = a;
                    }
                    return _$n;
                }
                "number" == typeof t && (o = n, n = e, e = t, t = o);
                var u = i, f = arguments[4], d = arguments[5];
                "object" === (void 0 === u ? "undefined" : vt(u)) && null !== u || ("string" == typeof f && (d = f, f = null), "string" == typeof u && (d = u, u = null), "number" == typeof u && (f = u, u = null), i = {
                    flags: u,
                    angle: f,
                    align: d
                });
                var p = !1, g = !0;
                if ("string" == typeof t) p = !0;
                else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var m, w = t.concat(), y = [], v = w.length; v--;)("string" != typeof (m = w.shift()) || "[object Array]" === Object.prototype.toString.call(m) && "string" != typeof m[0]) && (g = !1);
                    p = g;
                }
                if (!1 === p) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
                var b = nt[K].encoding;
                "WinAnsiEncoding" !== b && "StandardEncoding" !== b || (t = l(t, function(t, e, n) {
                    var _$r;
                    return [
                        (_$r = t, _$r = _$r.split("	").join(Array(i.TabLen || 9).join(" ")), ot(_$r, u)),
                        e,
                        n
                    ];
                })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
                    t
                ]), 0 < (j = i.maxWidth || 0) && ("string" == typeof t ? t = h.splitTextToSize(t, j) : "[object Array]" === Object.prototype.toString.call(t) && (t = h.splitTextToSize(t.join(" "), j)));
                var x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("preProcessText", x), t = x.text;
                f = (i = x.options).angle;
                var S = h.internal.scaleFactor, k = (h.internal.pageSize.getHeight(), []);
                if (f) {
                    f *= Math.PI / 180;
                    var _ = Math.cos(f), A = Math.sin(f), I = function I(t) {
                        return t.toFixed(2);
                    };
                    k = [
                        I(_),
                        I(A),
                        I(-1 * A),
                        I(_)
                    ];
                }
                void 0 !== (R = i.charSpace) && (a += R + " Tc\n");
                i.lang;
                var C = -1, T = i.renderingMode || i.stroke, F = h.internal.getCurrentPageInfo().pageContext;
                switch(T){
                    case 0:
                    case !1:
                    case "fill":
                        C = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        C = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        C = 2;
                        break;
                    case 3:
                    case "invisible":
                        C = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        C = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        C = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        C = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        C = 7;
                }
                var P = F.usedRenderingMode || -1;
                -1 !== C ? a += C + " Tr\n" : -1 !== P && (a += "0 Tr\n"), -1 !== C && (F.usedRenderingMode = C);
                d = i.align || "left";
                var E = Z * s, q = h.internal.pageSize.getHeight(), O = h.internal.pageSize.getWidth(), B = (S = h.internal.scaleFactor, nt[K]), R = i.charSpace || $, j = i.maxWidth || 0, D = (u = {}, []);
                if ("[object Array]" === Object.prototype.toString.call(t)) {
                    var M, U;
                    y = c(t);
                    "left" !== d && (U = y.map(function(t) {
                        return h.getStringUnitWidth(t, {
                            font: B,
                            charSpace: R,
                            fontSize: Z
                        }) * Z / S;
                    }));
                    var N, z = Math.max.apply(Math, U), L = 0;
                    if ("right" === d) {
                        e -= U[0], t = [];
                        var H = 0;
                        for(v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("center" === d) {
                        e -= U[0] / 2, t = [];
                        for(H = 0, v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) / 2 * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("left" === d) {
                        t = [];
                        for(H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, t.push(y[H]);
                    } else {
                        if ("justify" !== d) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                        t = [];
                        for(j = 0 !== j ? j : O, H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, H < v - 1 && D.push(((j - U[H]) / (y[H].split(" ").length - 1) * S).toFixed(2)), t.push([
                            y[H],
                            N,
                            M
                        ]);
                    }
                }
                !0 === ("boolean" == typeof i.R2L ? i.R2L : tt) && (t = l(t, function(t, e, n) {
                    return [
                        t.split("").reverse().join(""),
                        e,
                        n
                    ];
                }));
                x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("postProcessText", x), t = x.text, _$r = x.mutex.isHex;
                y = c(t);
                t = [];
                var W, G, V, Y = 0, X = (v = y.length, "");
                for(H = 0; H < v; H++)X = "", "[object Array]" !== Object.prototype.toString.call(y[H]) ? (W = parseFloat(e * S).toFixed(2), G = parseFloat((q - n) * S).toFixed(2), V = (_$r ? "<" : "(") + y[H] + (_$r ? ">" : ")")) : "[object Array]" === Object.prototype.toString.call(y[H]) && (W = parseFloat(y[H][1]).toFixed(2), G = parseFloat(y[H][2]).toFixed(2), V = (_$r ? "<" : "(") + y[H][0] + (_$r ? ">" : ")"), Y = 1), void 0 !== D && void 0 !== D[H] && (X = D[H] + " Tw\n"), 0 !== k.length && 0 === H ? t.push(X + k.join(" ") + " " + W + " " + G + " Tm\n" + V) : 1 === Y || 0 === Y && 0 === H ? t.push(X + W + " " + G + " Td\n" + V) : t.push(X + V);
                t = 0 === Y ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
                var J = "BT\n/" + K + " " + Z + " Tf\n" + (Z * s).toFixed(2) + " TL\n" + Q + "\n";
                return J += a, J += t, it(J += "ET"), h;
            }, O.lstext = function(t, e, n, r) {
                console.warn("jsPDF.lstext is deprecated");
                for(var i = 0, o = t.length; i < o; i++, e += r)this.text(t[i], e, n);
                return this;
            }, O.line = function(t, e, n, r) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ]
                ], t, e);
            }, O.clip = function() {
                it("W"), it("S");
            }, O.clip_fixed = function(t) {
                it("evenodd" === t ? "W*" : "W"), it("n");
            }, O.lines = function(t, e, n, r, i, o) {
                var a, s, h, c, l, u, f, d, p, g, m;
                for("number" == typeof t && (y = n, n = e, e = t, t = y), r = r || [
                    1,
                    1
                ], it(z(e * w) + " " + z((v - n) * w) + " m "), a = r[0], s = r[1], c = t.length, g = e, m = n, h = 0; h < c; h++)2 === (l = t[h]).length ? (g = l[0] * a + g, m = l[1] * s + m, it(z(g * w) + " " + z((v - m) * w) + " l")) : (u = l[0] * a + g, f = l[1] * s + m, d = l[2] * a + g, p = l[3] * s + m, g = l[4] * a + g, m = l[5] * s + m, it(z(u * w) + " " + z((v - f) * w) + " " + z(d * w) + " " + z((v - p) * w) + " " + z(g * w) + " " + z((v - m) * w) + " c"));
                return o && it(" h"), null !== i && it(ht(i)), this;
            }, O.rect = function(t, e, n, r, i) {
                ht(i);
                return it([
                    N(t * w),
                    N((v - e) * w),
                    N(n * w),
                    N(-r * w),
                    "re"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.triangle = function(t, e, n, r, i, o, a) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ],
                    [
                        i - n,
                        o - r
                    ],
                    [
                        t - i,
                        e - o
                    ]
                ], t, e, [
                    1,
                    1
                ], a, !0), this;
            }, O.roundedRect = function(t, e, n, r, i, o, a) {
                var s = 4 / 3 * (Math.SQRT2 - 1);
                return this.lines([
                    [
                        n - 2 * i,
                        0
                    ],
                    [
                        i * s,
                        0,
                        i,
                        o - o * s,
                        i,
                        o
                    ],
                    [
                        0,
                        r - 2 * o
                    ],
                    [
                        0,
                        o * s,
                        -i * s,
                        o,
                        -i,
                        o
                    ],
                    [
                        2 * i - n,
                        0
                    ],
                    [
                        -i * s,
                        0,
                        -i,
                        -o * s,
                        -i,
                        -o
                    ],
                    [
                        0,
                        2 * o - r
                    ],
                    [
                        0,
                        -o * s,
                        i * s,
                        -o,
                        i,
                        -o
                    ]
                ], t + i, e, [
                    1,
                    1
                ], a), this;
            }, O.ellipse = function(t, e, n, r, i) {
                var o = 4 / 3 * (Math.SQRT2 - 1) * n, a = 4 / 3 * (Math.SQRT2 - 1) * r;
                return it([
                    N((t + n) * w),
                    N((v - e) * w),
                    "m",
                    N((t + n) * w),
                    N((v - (e - a)) * w),
                    N((t + o) * w),
                    N((v - (e - r)) * w),
                    N(t * w),
                    N((v - (e - r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t - o) * w),
                    N((v - (e - r)) * w),
                    N((t - n) * w),
                    N((v - (e - a)) * w),
                    N((t - n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), it([
                    N((t - n) * w),
                    N((v - (e + a)) * w),
                    N((t - o) * w),
                    N((v - (e + r)) * w),
                    N(t * w),
                    N((v - (e + r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t + o) * w),
                    N((v - (e + r)) * w),
                    N((t + n) * w),
                    N((v - (e + a)) * w),
                    N((t + n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.circle = function(t, e, n, r) {
                return this.ellipse(t, e, n, n, r);
            }, O.setProperties = function(t) {
                for(var _$e in q)q.hasOwnProperty(_$e) && t[_$e] && (q[_$e] = t[_$e]);
                return this;
            }, O.setFontSize = function(t) {
                return Z = t, this;
            }, O.setFont = function(t, e) {
                return K = at(t, e), this;
            }, O.setFontStyle = O.setFontType = function(t) {
                return K = at(void 0, t), this;
            }, O.getFontList = function() {
                var _$t, _$e, _$n, _$r = {};
                for(_$t in S)if (S.hasOwnProperty(_$t)) for(_$e in _$r[_$t] = _$n = [], S[_$t])S[_$t].hasOwnProperty(_$e) && _$n.push(_$e);
                return _$r;
            }, O.addFont = function(t, e, n, r) {
                Y(t, e, n, r = r || "Identity-H");
            }, O.setLineWidth = function(t) {
                return it((t * w).toFixed(2) + " w"), this;
            }, O.setDrawColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "draw",
                    precision: 2
                })), this;
            }, O.setFillColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "fill",
                    precision: 2
                })), this;
            }, O.setTextColor = function(t, e, n, r) {
                return Q = R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "text",
                    precision: 3
                }), this;
            }, O.setCharSpace = function(t) {
                return $ = t, this;
            }, O.setR2L = function(t) {
                return tt = t, this;
            }, O.CapJoinStyles = {
                0: 0,
                butt: 0,
                but: 0,
                miter: 0,
                1: 1,
                round: 1,
                rounded: 1,
                circle: 1,
                2: 2,
                projecting: 2,
                project: 2,
                square: 2,
                bevel: 2
            }, O.setLineCap = function(t) {
                var _$e = this.CapJoinStyles[t];
                if (void 0 === _$e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((F = _$e) + " J"), this;
            }, O.setLineJoin = function(t) {
                var _$e = this.CapJoinStyles[t];
                if (void 0 === _$e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((P = _$e) + " j"), this;
            }, O.output = ut, O.save = function(t) {
                O.output("save", t);
            }, yt.API)yt.API.hasOwnProperty(dt) && ("events" === dt && yt.API.events.length ? function(t, e) {
                var _$n, _$r, i;
                for(i = e.length - 1; -1 !== i; i--)_$n = e[i][0], _$r = e[i][1], t.subscribe.apply(t, [
                    _$n
                ].concat("function" == typeof _$r ? [
                    _$r
                ] : _$r));
            }(rt, yt.API.events) : O[dt] = yt.API[dt]);
            return function() {
                for(var _$t = "helvetica", _$e = "times", _$n = "courier", _$r = "normal", i = "bold", o = "italic", a = "bolditalic", s = [
                    [
                        "Helvetica",
                        _$t,
                        _$r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Bold",
                        _$t,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Oblique",
                        _$t,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-BoldOblique",
                        _$t,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier",
                        _$n,
                        _$r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Bold",
                        _$n,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Oblique",
                        _$n,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-BoldOblique",
                        _$n,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Roman",
                        _$e,
                        _$r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Bold",
                        _$e,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Italic",
                        _$e,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-BoldItalic",
                        _$e,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "ZapfDingbats",
                        "zapfdingbats",
                        _$r,
                        null
                    ],
                    [
                        "Symbol",
                        "symbol",
                        _$r,
                        null
                    ]
                ], h = 0, c = s.length; h < c; h++){
                    var l = Y(s[h][0], s[h][1], s[h][2], s[h][3]), u = s[h][0].split("-");
                    V(l, u[0], u[1] || "");
                }
                rt.publish("addFonts", {
                    fonts: nt,
                    dictionary: S
                });
            }(), K = "F1", X(n, t), rt.publish("initialized"), O;
        }
        return yt.API = {
            events: []
        }, yt.version = "0.0.0", "function" == typeof define && define.amd ? define("jsPDF", function() {
            return yt;
        }) : (0, module.exports) ? (module.exports = yt, module.exports.jsPDF = yt) : pt.jsPDF = yt, yt;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    /** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */ /**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ !function(n, t) {
        var l, a, e = 1, r = function r(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
        }, s = function s(t) {
            return t * (e / 1);
        }, h = function h(t) {
            var e = new I, _$n = N.internal.getHeight(t) || 0, r = N.internal.getWidth(t) || 0;
            return e.BBox = [
                0,
                0,
                r.toFixed(2),
                _$n.toFixed(2)
            ], e;
        }, i = function i(t, e, n) {
            t = t || 0;
            var r = 1;
            if (r <<= e - 1, 1 == (n = n || 1)) t = t | r;
            else t = t & ~r;
            return t;
        }, o = function o(t, e, n) {
            n = n || 1.3, t = t || 0;
            return 1 == e.readOnly && (t = i(t, 1)), 1 == e.required && (t = i(t, 2)), 1 == e.noExport && (t = i(t, 3)), 1 == e.multiline && (t = i(t, 13)), e.password && (t = i(t, 14)), e.noToggleToOff && (t = i(t, 15)), e.radio && (t = i(t, 16)), e.pushbutton && (t = i(t, 17)), e.combo && (t = i(t, 18)), e.edit && (t = i(t, 19)), e.sort && (t = i(t, 20)), e.fileSelect && 1.4 <= n && (t = i(t, 21)), e.multiSelect && 1.4 <= n && (t = i(t, 22)), e.doNotSpellCheck && 1.4 <= n && (t = i(t, 23)), 1 == e.doNotScroll && 1.4 <= n && (t = i(t, 24)), e.richText && 1.4 <= n && (t = i(t, 25)), t;
        }, u = function u(t) {
            var e = t[0], _$n = t[1], r = t[2], i = t[3], o = {};
            return Array.isArray(e) ? (e[0] = s(e[0]), e[1] = s(e[1]), e[2] = s(e[2]), e[3] = s(e[3])) : (e = s(e), _$n = s(_$n), r = s(r), i = s(i)), o.lowerLeft_X = e || 0, o.lowerLeft_Y = s(a) - _$n - i || 0, o.upperRight_X = e + r || 0, o.upperRight_Y = s(a) - _$n || 0, [
                o.lowerLeft_X.toFixed(2),
                o.lowerLeft_Y.toFixed(2),
                o.upperRight_X.toFixed(2),
                o.upperRight_Y.toFixed(2)
            ];
        }, f = function f(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
                var e = [], _$n = t.V || t.DV, r = c(t, _$n);
                e.push("/Tx BMC"), e.push("q"), e.push("/F1 " + r.fontSize.toFixed(2) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push("BT"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                var i = new h(t);
                return i.stream = e.join("\n"), i;
            }
        }, c = function c(t, e, i, n) {
            n = n || 12, i = i || "helvetica";
            var r = {
                text: "",
                fontSize: ""
            }, o = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "), a = n, s = N.internal.getHeight(t) || 0;
            s = s < 0 ? -s : s;
            var h = N.internal.getWidth(t) || 0;
            h = h < 0 ? -h : h;
            var c = function c(t, e, n) {
                if (t + 1 < o.length) {
                    var r = e + " " + o[t + 1];
                    return A(r, n + "px", i).width <= h - 4;
                }
                return !1;
            };
            a++;
            t: for(;;){
                e = "";
                var l = A("3", --a + "px", i).height, u = t.multiline ? s - a : (s - l) / 2, f = -2, d = u += 2, p = 0, g = 0, m = 0;
                if (a <= 0) {
                    a = 12, e = "(...) Tj\n", e += "% Width of Text: " + A(e, "1px").width + ", FieldWidth:" + h + "\n";
                    break;
                }
                m = A(o[0] + " ", a + "px", i).width;
                var w = "", y = 0;
                for(var v in o){
                    w = " " == (w += o[v] + " ").substr(w.length - 1) ? w.substr(0, w.length - 1) : w;
                    var b = parseInt(v);
                    m = A(w + " ", a + "px", i).width;
                    var x = c(b, w, a), S = v >= o.length - 1;
                    if (!x || S) {
                        if (x || S) {
                            if (S) g = b;
                            else if (t.multiline && s < (l + 2) * (y + 2) + 2) continue t;
                        } else {
                            if (!t.multiline) continue t;
                            if (s < (l + 2) * (y + 2) + 2) continue t;
                            g = b;
                        }
                        for(var k = "", _ = p; _ <= g; _++)k += o[_] + " ";
                        switch(k = " " == k.substr(k.length - 1) ? k.substr(0, k.length - 1) : k, m = A(k, a + "px", i).width, t.Q){
                            case 2:
                                f = h - m - 2;
                                break;
                            case 1:
                                f = (h - m) / 2;
                                break;
                            case 0:
                            default:
                                f = 2;
                        }
                        e += f.toFixed(2) + " " + d.toFixed(2) + " Td\n", e += "(" + k + ") Tj\n", e += -f.toFixed(2) + " 0 Td\n", d = -(a + 2), m = 0, p = g + 1, y++, w = "";
                    } else w += " ";
                }
                break;
            }
            return r.text = e, r.fontSize = a, r;
        }, A = function A(t, e, n) {
            n = n || "helvetica";
            var r = l.internal.getFont(n), i = l.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(e),
                charSpace: 0
            }) * parseFloat(e);
            return {
                height: l.getStringUnitWidth("3", {
                    font: r,
                    fontSize: parseFloat(e),
                    charSpace: 0
                }) * parseFloat(e) * 1.5,
                width: i
            };
        }, d = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
        }, p = function p() {
            for(var _$t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){
                var e = l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[_$t];
                e.hasAnnotation && m.call(l, e);
            }
        }, g = function g(t) {
            l.internal.acroformPlugin.printedOut && (l.internal.acroformPlugin.printedOut = !1, l.internal.acroformPlugin.acroFormDictionaryRoot = null), l.internal.acroformPlugin.acroFormDictionaryRoot || x.call(l), l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
        }, m = function m(t) {
            var e = {
                type: "reference",
                object: t
            };
            l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e);
        }, w = function w() {
            void 0 !== l.internal.acroformPlugin.acroFormDictionaryRoot ? l.internal.write("/AcroForm " + l.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R") : console.log("Root missing...");
        }, y = function y() {
            l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID, l.internal.acroformPlugin.printedOut = !0;
        }, v = function v(t) {
            var e = !t;
            t || (l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId), l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));
            t = t || l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;
            for(var _$n in t){
                var r = t[_$n], i = r.Rect;
                r.Rect && (r.Rect = u.call(this, r.Rect)), l.internal.newObjectDeferredBegin(r.objId);
                var o = r.objId + " 0 obj\n<<\n";
                if ("object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getContent && (o += r.getContent()), r.Rect = i, r.hasAppearanceStream && !r.appearanceStreamContent) {
                    var a = f.call(this, r);
                    o += "/AP << /N " + a + " >>\n", l.internal.acroformPlugin.xForms.push(a);
                }
                if (r.appearanceStreamContent) {
                    for(var s in o += "/AP << ", r.appearanceStreamContent){
                        var h = r.appearanceStreamContent[s];
                        if (o += "/" + s + " ", o += "<< ", 1 <= Object.keys(h).length || Array.isArray(h)) for(var _$n in h){
                            var c;
                            "function" == typeof (c = h[_$n]) && (c = c.call(this, r)), o += "/" + _$n + " " + c + " ", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        }
                        else "function" == typeof (c = h) && (c = c.call(this, r)), o += "/" + _$n + " " + c + " \n", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        o += " >>\n";
                    }
                    o += ">>\n";
                }
                o += ">>\nendobj\n", l.internal.out(o);
            }
            e && b.call(this, l.internal.acroformPlugin.xForms);
        }, b = function b(t) {
            for(var e in t){
                var _$n = e, r = t[e];
                l.internal.newObjectDeferredBegin(r && r.objId);
                var i = "";
                "object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getString && (i = r.getString()), l.internal.out(i), delete t[_$n];
            }
        }, x = function x() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
                if (l = this, T.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(d)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                e = l.internal.scaleFactor, a = l.internal.pageSize.getHeight(), l.internal.acroformPlugin.acroFormDictionaryRoot = new C, l.internal.acroformPlugin.acroFormDictionaryRoot._eventID = l.internal.events.subscribe("postPutResources", y), l.internal.events.subscribe("buildDocument", p), l.internal.events.subscribe("putCatalog", w), l.internal.events.subscribe("postPutPages", v), l.internal.acroformPlugin.isInitialized = !0;
            }
        }, S = function S(t) {
            if (Array.isArray(t)) {
                var e = " [";
                for(var _$n in t)e += t[_$n].toString(), e += _$n < t.length - 1 ? " " : "";
                return e += "]";
            }
        }, k = function k(t) {
            return 0 !== (t = t || "").indexOf("(") && (t = "(" + t), ")" != t.substring(t.length - 1) && (t += ")"), t;
        }, _ = function _() {
            var _$t;
            Object.defineProperty(this, "objId", {
                get: function get() {
                    return _$t || (_$t = l.internal.newObjectDeferred()), _$t || console.log("Couldn't create Object ID"), _$t;
                },
                configurable: !1
            });
        };
        _.prototype.toString = function() {
            return this.objId + " 0 R";
        }, _.prototype.getString = function() {
            var _$t = this.objId + " 0 obj\n<<";
            return _$t += this.getContent() + ">>\n", this.stream && (_$t += "stream\n", _$t += this.stream, _$t += "\nendstream\n"), _$t += "endobj\n";
        }, _.prototype.getContent = function() {
            var _$t = "";
            return _$t += function(t) {
                var e = "", _$n = Object.keys(t).filter(function(t) {
                    return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
                });
                for(var r in _$n){
                    var i = _$n[r], o = t[i];
                    o && (Array.isArray(o) ? e += "/" + i + " " + S(o) + "\n" : e += o instanceof _ ? "/" + i + " " + o.objId + " 0 R\n" : "/" + i + " " + o + "\n");
                }
                return e;
            }(this);
        };
        var I = function I() {
            var e;
            _.call(this), this.Type = "/XObject", this.Subtype = "/Form", this.FormType = 1, this.BBox, this.Matrix, this.Resources = "2 0 R", this.PieceInfo, Object.defineProperty(this, "Length", {
                enumerable: !0,
                get: function get() {
                    return void 0 !== e ? e.length : 0;
                }
            }), Object.defineProperty(this, "stream", {
                enumerable: !1,
                set: function set(t) {
                    e = t.trim();
                },
                get: function get() {
                    return e || null;
                }
            });
        };
        r(I, _);
        var C = function C() {
            _.call(this);
            var _$t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !1,
                configurable: !0,
                get: function get() {
                    return 0 < _$t.length ? _$t : void 0;
                }
            }), Object.defineProperty(this, "Fields", {
                enumerable: !0,
                configurable: !0,
                get: function get() {
                    return _$t;
                }
            }), this.DA;
        };
        r(C, _);
        var T = function t() {
            var e;
            _.call(this), Object.defineProperty(this, "Rect", {
                enumerable: !0,
                configurable: !1,
                get: function get() {
                    if (e) return e;
                },
                set: function set(t) {
                    e = t;
                }
            });
            var _$n, r, i, o, a = "";
            Object.defineProperty(this, "FT", {
                enumerable: !0,
                set: function set(t) {
                    a = t;
                },
                get: function get() {
                    return a;
                }
            }), Object.defineProperty(this, "T", {
                enumerable: !0,
                configurable: !1,
                set: function set(t) {
                    _$n = t;
                },
                get: function get() {
                    if (!_$n || _$n.length < 1) {
                        if (this instanceof j) return;
                        return "(FieldObject" + t.FieldNum++ + ")";
                    }
                    return "(" == _$n.substring(0, 1) && _$n.substring(_$n.length - 1) ? _$n : "(" + _$n + ")";
                }
            }), Object.defineProperty(this, "DA", {
                enumerable: !0,
                get: function get() {
                    if (r) return "(" + r + ")";
                },
                set: function set(t) {
                    r = t;
                }
            }), Object.defineProperty(this, "DV", {
                enumerable: !0,
                configurable: !0,
                get: function get() {
                    if (i) return i;
                },
                set: function set(t) {
                    i = t;
                }
            }), Object.defineProperty(this, "V", {
                enumerable: !0,
                configurable: !0,
                get: function get() {
                    if (o) return o;
                },
                set: function set(t) {
                    o = t;
                }
            }), Object.defineProperty(this, "Type", {
                enumerable: !0,
                get: function get() {
                    return this.hasAnnotation ? "/Annot" : null;
                }
            }), Object.defineProperty(this, "Subtype", {
                enumerable: !0,
                get: function get() {
                    return this.hasAnnotation ? "/Widget" : null;
                }
            }), this.BG, Object.defineProperty(this, "hasAnnotation", {
                enumerable: !1,
                get: function get() {
                    return !!(this.Rect || this.BC || this.BG);
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            }), Object.defineProperty(this, "page", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        };
        r(T, _);
        var F = function F() {
            T.call(this), this.FT = "/Ch", this.Opt = [], this.V = "()", this.TI = 0;
            var e = !1;
            Object.defineProperty(this, "combo", {
                enumerable: !1,
                get: function get() {
                    return e;
                },
                set: function set(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "edit", {
                enumerable: !0,
                set: function set(t) {
                    1 == t ? (this._edit = !0, this.combo = !0) : this._edit = !1;
                },
                get: function get() {
                    return !!this._edit && this._edit;
                },
                configurable: !1
            }), this.hasAppearanceStream = !0;
        };
        r(F, T);
        var P = function P() {
            F.call(this), this.combo = !1;
        };
        r(P, F);
        var E = function E() {
            P.call(this), this.combo = !0;
        };
        r(E, P);
        var q = function q() {
            E.call(this), this.edit = !0;
        };
        r(q, E);
        var O = function O() {
            T.call(this), this.FT = "/Btn";
        };
        r(O, T);
        var B = function B() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "pushbutton", {
                enumerable: !1,
                get: function get() {
                    return e;
                },
                set: function set(t) {
                    e = t;
                }
            });
        };
        r(B, O);
        var R = function R() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "radio", {
                enumerable: !1,
                get: function get() {
                    return e;
                },
                set: function set(t) {
                    e = t;
                }
            });
            var _$n, _$t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !0,
                get: function get() {
                    if (0 < _$t.length) return _$t;
                }
            }), Object.defineProperty(this, "__Kids", {
                get: function get() {
                    return _$t;
                }
            }), Object.defineProperty(this, "noToggleToOff", {
                enumerable: !1,
                get: function get() {
                    return _$n;
                },
                set: function set(t) {
                    _$n = t;
                }
            });
        };
        r(R, O);
        var j = function j(t, e) {
            T.call(this), this.Parent = t, this._AppearanceType = N.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(e), this.F = i(this.F, 3, 1), this.MK = this._AppearanceType.createMK(), this.AS = "/Off", this._Name = e;
        };
        r(j, T), R.prototype.setAppearance = function(t) {
            if ("createAppearanceStream" in t && "createMK" in t) for(var e in this.__Kids){
                var _$n = this.__Kids[e];
                _$n.appearanceStreamContent = t.createAppearanceStream(_$n._Name), _$n.MK = t.createMK();
            }
            else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
        }, R.prototype.createOption = function(t) {
            this.__Kids.length;
            var e = new j(this, t);
            return this.__Kids.push(e), n.addField(e), e;
        };
        var D = function D() {
            O.call(this), this.appearanceStreamContent = N.CheckBox.createAppearanceStream(), this.MK = N.CheckBox.createMK(), this.AS = "/On", this.V = "/On";
        };
        r(D, O);
        var M = function M() {
            var e, _$n;
            T.call(this), this.DA = N.createDefaultAppearanceStream(), this.F = 4, Object.defineProperty(this, "V", {
                get: function get() {
                    return e ? k(e) : e;
                },
                enumerable: !0,
                set: function set(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "DV", {
                get: function get() {
                    return _$n ? k(_$n) : _$n;
                },
                enumerable: !0,
                set: function set(t) {
                    _$n = t;
                }
            });
            var r = !1;
            Object.defineProperty(this, "multiline", {
                enumerable: !1,
                get: function get() {
                    return r;
                },
                set: function set(t) {
                    r = t;
                }
            });
            var i = !1;
            Object.defineProperty(this, "fileSelect", {
                enumerable: !1,
                get: function get() {
                    return i;
                },
                set: function set(t) {
                    i = t;
                }
            });
            var o = !1;
            Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !1,
                get: function get() {
                    return o;
                },
                set: function set(t) {
                    o = t;
                }
            });
            var a = !1;
            Object.defineProperty(this, "doNotScroll", {
                enumerable: !1,
                get: function get() {
                    return a;
                },
                set: function set(t) {
                    a = t;
                }
            });
            var s = !1;
            Object.defineProperty(this, "MaxLen", {
                enumerable: !0,
                get: function get() {
                    return s;
                },
                set: function set(t) {
                    s = t;
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                get: function get() {
                    return this.V || this.DV;
                }
            });
        };
        r(M, T);
        var U = function U() {
            M.call(this);
            var e = !0;
            Object.defineProperty(this, "password", {
                enumerable: !1,
                get: function get() {
                    return e;
                },
                set: function set(t) {
                    e = t;
                }
            });
        };
        r(U, M);
        var N = {
            CheckBox: {
                createAppearanceStream: function createAppearanceStream() {
                    return {
                        N: {
                            On: N.CheckBox.YesNormal
                        },
                        D: {
                            On: N.CheckBox.YesPushDown,
                            Off: N.CheckBox.OffPushDown
                        }
                    };
                },
                createMK: function createMK() {
                    return "<< /CA (3)>>";
                },
                YesPushDown: function YesPushDown(t) {
                    var e = h(t), _$n = [], r = l.internal.getFont("zapfdingbats", "normal").id;
                    t.Q = 1;
                    var i = c(t, "3", "ZapfDingbats", 50);
                    return _$n.push("0.749023 g"), _$n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), _$n.push("f"), _$n.push("BMC"), _$n.push("q"), _$n.push("0 0 1 rg"), _$n.push("/" + r + " " + i.fontSize.toFixed(2) + " Tf 0 g"), _$n.push("BT"), _$n.push(i.text), _$n.push("ET"), _$n.push("Q"), _$n.push("EMC"), e.stream = _$n.join("\n"), e;
                },
                YesNormal: function YesNormal(t) {
                    var e = h(t), _$n = l.internal.getFont("zapfdingbats", "normal").id, r = [];
                    t.Q = 1;
                    var i = N.internal.getHeight(t), o = N.internal.getWidth(t), a = c(t, "3", "ZapfDingbats", .9 * i);
                    return r.push("1 g"), r.push("0 0 " + o.toFixed(2) + " " + i.toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("0 0 1 rg"), r.push("0 0 " + (o - 1).toFixed(2) + " " + (i - 1).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push("0 g"), r.push("BT"), r.push("/" + _$n + " " + a.fontSize.toFixed(2) + " Tf 0 g"), r.push(a.text), r.push("ET"), r.push("Q"), e.stream = r.join("\n"), e;
                },
                OffPushDown: function OffPushDown(t) {
                    var e = h(t), _$n = [];
                    return _$n.push("0.749023 g"), _$n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), _$n.push("f"), e.stream = _$n.join("\n"), e;
                }
            },
            RadioButton: {
                Circle: {
                    createAppearanceStream: function createAppearanceStream(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Circle.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Circle.YesNormal, e.D[t] = N.RadioButton.Circle.YesPushDown, e;
                    },
                    createMK: function createMK() {
                        return "<< /CA (l)>>";
                    },
                    YesNormal: function YesNormal(t) {
                        var e = h(t), _$n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4;
                        r *= .9;
                        var i = N.internal.Bezier_C;
                        return _$n.push("q"), _$n.push("1 0 0 1 " + N.internal.getWidth(t) / 2 + " " + N.internal.getHeight(t) / 2 + " cm"), _$n.push(r + " 0 m"), _$n.push(r + " " + r * i + " " + r * i + " " + r + " 0 " + r + " c"), _$n.push("-" + r * i + " " + r + " -" + r + " " + r * i + " -" + r + " 0 c"), _$n.push("-" + r + " -" + r * i + " -" + r * i + " -" + r + " 0 -" + r + " c"), _$n.push(r * i + " -" + r + " " + r + " -" + r * i + " " + r + " 0 c"), _$n.push("f"), _$n.push("Q"), e.stream = _$n.join("\n"), e;
                    },
                    YesPushDown: function YesPushDown(t) {
                        var e = h(t), _$n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C, a = r * N.internal.Bezier_C;
                        return _$n.push("0.749023 g"), _$n.push("q"), _$n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), _$n.push(i + " 0 m"), _$n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), _$n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), _$n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), _$n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), _$n.push("f"), _$n.push("Q"), _$n.push("0 g"), _$n.push("q"), _$n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), _$n.push(r + " 0 m"), _$n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), _$n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), _$n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), _$n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), _$n.push("f"), _$n.push("Q"), e.stream = _$n.join("\n"), e;
                    },
                    OffPushDown: function OffPushDown(t) {
                        var e = h(t), _$n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C;
                        return _$n.push("0.749023 g"), _$n.push("q"), _$n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), _$n.push(i + " 0 m"), _$n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), _$n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), _$n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), _$n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), _$n.push("f"), _$n.push("Q"), e.stream = _$n.join("\n"), e;
                    }
                },
                Cross: {
                    createAppearanceStream: function createAppearanceStream(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Cross.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Cross.YesNormal, e.D[t] = N.RadioButton.Cross.YesPushDown, e;
                    },
                    createMK: function createMK() {
                        return "<< /CA (8)>>";
                    },
                    YesNormal: function YesNormal(t) {
                        var e = h(t), _$n = [], r = N.internal.calculateCross(t);
                        return _$n.push("q"), _$n.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), _$n.push("W"), _$n.push("n"), _$n.push(r.x1.x.toFixed(2) + " " + r.x1.y.toFixed(2) + " m"), _$n.push(r.x2.x.toFixed(2) + " " + r.x2.y.toFixed(2) + " l"), _$n.push(r.x4.x.toFixed(2) + " " + r.x4.y.toFixed(2) + " m"), _$n.push(r.x3.x.toFixed(2) + " " + r.x3.y.toFixed(2) + " l"), _$n.push("s"), _$n.push("Q"), e.stream = _$n.join("\n"), e;
                    },
                    YesPushDown: function YesPushDown(t) {
                        var e = h(t), _$n = N.internal.calculateCross(t), r = [];
                        return r.push("0.749023 g"), r.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push(_$n.x1.x.toFixed(2) + " " + _$n.x1.y.toFixed(2) + " m"), r.push(_$n.x2.x.toFixed(2) + " " + _$n.x2.y.toFixed(2) + " l"), r.push(_$n.x4.x.toFixed(2) + " " + _$n.x4.y.toFixed(2) + " m"), r.push(_$n.x3.x.toFixed(2) + " " + _$n.x3.y.toFixed(2) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                    },
                    OffPushDown: function OffPushDown(t) {
                        var e = h(t), _$n = [];
                        return _$n.push("0.749023 g"), _$n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), _$n.push("f"), e.stream = _$n.join("\n"), e;
                    }
                }
            },
            createDefaultAppearanceStream: function createDefaultAppearanceStream(t) {
                return "/F1 0 Tf 0 g";
            }
        };
        N.internal = {
            Bezier_C: .551915024494,
            calculateCross: function calculateCross(t) {
                var e, _$n, r = N.internal.getWidth(t), i = N.internal.getHeight(t), o = (_$n = i) < (e = r) ? _$n : e;
                return {
                    x1: {
                        x: (r - o) / 2,
                        y: (i - o) / 2 + o
                    },
                    x2: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2
                    },
                    x3: {
                        x: (r - o) / 2,
                        y: (i - o) / 2
                    },
                    x4: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2 + o
                    }
                };
            }
        }, N.internal.getWidth = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[2])), e;
        }, N.internal.getHeight = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[3])), e;
        }, n.addField = function(t) {
            return x.call(this), t instanceof M ? this.addTextField.call(this, t) : t instanceof F ? this.addChoiceField.call(this, t) : t instanceof O ? this.addButton.call(this, t) : t instanceof j ? g.call(this, t) : t && g.call(this, t), t.page = l.internal.getCurrentPageInfo().pageNumber, this;
        }, n.addButton = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Btn", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addTextField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Tx", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addChoiceField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Ch", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, "object" == (void 0 === t ? "undefined" : vt(t)) && (t.ChoiceField = F, t.ListBox = P, t.ComboBox = E, t.EditBox = q, t.Button = O, t.PushButton = B, t.RadioButton = R, t.CheckBox = D, t.TextField = M, t.PasswordField = U, t.AcroForm = {
            Appearance: N
        }), n.AcroFormChoiceField = F, n.AcroFormListBox = P, n.AcroFormComboBox = E, n.AcroFormEditBox = q, n.AcroFormButton = O, n.AcroFormPushButton = B, n.AcroFormRadioButton = R, n.AcroFormCheckBox = D, n.AcroFormTextField = M, n.AcroFormPasswordField = U, n.AcroForm = {
            ChoiceField: F,
            ListBox: P,
            ComboBox: E,
            EditBox: q,
            Button: O,
            PushButton: B,
            RadioButton: R,
            CheckBox: D,
            TextField: M,
            PasswordField: U
        };
    }($.API, "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global), $.API.addHTML = function(t, p, g, s, m) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof p && (s = p, m = g), "function" == typeof s && (m = s, s = null), "function" != typeof m && (m = function m() {});
        var e = this.internal, w = e.scaleFactor, y = e.pageSize.getWidth(), v = e.pageSize.getHeight();
        if ((s = s || {}).onrendered = (function(h) {
            p = parseInt(p) || 0, g = parseInt(g) || 0;
            var _$t = s.dim || {}, c = Object.assign({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                useFor: "content"
            }, s.margin), e = _$t.h || Math.min(v, h.height / w), l = _$t.w || Math.min(y, h.width / w) - p, u = s.format || "JPEG", f = s.imageCompression || "SLOW";
            if (h.height > v - c.top - c.bottom && s.pagesplit) {
                var d = function d(t, e, n, r, i) {
                    var o = document.createElement("canvas");
                    o.height = i, o.width = r;
                    var a = o.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.webkitImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, a.fillStyle = s.backgroundColor || "#ffffff", a.fillRect(0, 0, r, i), a.drawImage(t, e, n, r, i, 0, 0, r, i), o;
                }, n = (function() {
                    for(var _$t, e, n = 0, r = 0, i = {}, o = !1;;){
                        var a;
                        if (r = 0, i.top = 0 !== n ? c.top : g, i.left = 0 !== n ? c.left : p, o = (y - c.left - c.right) * w < h.width, "content" === c.useFor ? 0 === n ? (_$t = Math.min((y - c.left) * w, h.width), e = Math.min((v - c.top) * w, h.height - n)) : (_$t = Math.min(y * w, h.width), e = Math.min(v * w, h.height - n), i.top = 0) : (_$t = Math.min((y - c.left - c.right) * w, h.width), e = Math.min((v - c.bottom - c.top) * w, h.height - n)), o) for(;;){
                            "content" === c.useFor && (0 === r ? _$t = Math.min((y - c.left) * w, h.width) : (_$t = Math.min(y * w, h.width - r), i.left = 0));
                            var _$s = [
                                a = d(h, r, n, _$t, e),
                                i.left,
                                i.top,
                                a.width / w,
                                a.height / w,
                                u,
                                null,
                                f
                            ];
                            if (this.addImage.apply(this, _$s), (r += _$t) >= h.width) break;
                            this.addPage();
                        }
                        else _$s = [
                            a = d(h, 0, n, _$t, e),
                            i.left,
                            i.top,
                            a.width / w,
                            a.height / w,
                            u,
                            null,
                            f
                        ], this.addImage.apply(this, _$s);
                        if ((n += e) >= h.height) break;
                        this.addPage();
                    }
                    m(l, n, null, _$s);
                }).bind(this);
                if ("CANVAS" === h.nodeName) {
                    var r = new Image;
                    r.onload = n, r.src = h.toDataURL("image/png"), h = r;
                } else n();
            } else {
                var i = Math.random().toString(35), o = [
                    h,
                    p,
                    g,
                    l,
                    e,
                    u,
                    i,
                    f
                ];
                this.addImage.apply(this, o), m(l, e, i, o);
            }
        }).bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" != typeof rasterizeHTML) {
            var n = "drawDocument";
            return "string" == typeof t && (n = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || y * w, rasterizeHTML[n](t, void 0, s).then(function(t) {
                s.onrendered(t.image);
            }, function(t) {
                m(null, t);
            });
        }
        return null;
    }, /** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */ function(b) {
        var x = "addImage_", h = {
            PNG: [
                [
                    137,
                    80,
                    78,
                    71
                ]
            ],
            TIFF: [
                [
                    77,
                    77,
                    0,
                    42
                ],
                [
                    73,
                    73,
                    42,
                    0
                ]
            ],
            JPEG: [
                [
                    255,
                    216,
                    255,
                    224,
                    void 0,
                    void 0,
                    74,
                    70,
                    73,
                    70,
                    0
                ],
                [
                    255,
                    216,
                    255,
                    225,
                    void 0,
                    void 0,
                    69,
                    120,
                    105,
                    102,
                    0,
                    0
                ]
            ],
            JPEG2000: [
                [
                    0,
                    0,
                    0,
                    12,
                    106,
                    80,
                    32,
                    32
                ]
            ],
            GIF87a: [
                [
                    71,
                    73,
                    70,
                    56,
                    55,
                    97
                ]
            ],
            GIF89a: [
                [
                    71,
                    73,
                    70,
                    56,
                    57,
                    97
                ]
            ],
            BMP: [
                [
                    66,
                    77
                ],
                [
                    66,
                    65
                ],
                [
                    67,
                    73
                ],
                [
                    67,
                    80
                ],
                [
                    73,
                    67
                ],
                [
                    80,
                    84
                ]
            ]
        };
        b.getImageFileTypeByImageData = function(t, e) {
            var n, r;
            e = e || "UNKNOWN";
            var i, o, a, s = "UNKNOWN";
            for(a in h)for(i = h[a], n = 0; n < i.length; n += 1){
                for(o = !0, r = 0; r < i[n].length; r += 1)if (void 0 !== i[n][r] && i[n][r] !== t.charCodeAt(r)) {
                    o = !1;
                    break;
                }
                if (!0 === o) {
                    s = a;
                    break;
                }
            }
            return "UNKOWN" === s && "UNKNOWN" !== e && (console.warn('FileType of Image not recognized. Processing image as "' + e + '".'), s = e), s;
        };
        var n = function t(e) {
            var n = this.internal.newObject(), r = this.internal.write, i = this.internal.putStream;
            if (e.n = n, r("<</Type /XObject"), r("/Subtype /Image"), r("/Width " + e.w), r("/Height " + e.h), e.cs === this.color_spaces.INDEXED ? r("/ColorSpace [/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? n + 2 : n + 1) + " 0 R]") : (r("/ColorSpace /" + e.cs), e.cs === this.color_spaces.DEVICE_CMYK && r("/Decode [1 0 1 0 1 0 1 0]")), r("/BitsPerComponent " + e.bpc), "f" in e && r("/Filter /" + e.f), "dp" in e && r("/DecodeParms <<" + e.dp + ">>"), "trns" in e && e.trns.constructor == Array) {
                for(var o = "", a = 0, s = e.trns.length; a < s; a++)o += e.trns[a] + " " + e.trns[a] + " ";
                r("/Mask [" + o + "]");
            }
            if ("smask" in e && r("/SMask " + (n + 1) + " 0 R"), r("/Length " + e.data.length + ">>"), i(e.data), r("endobj"), "smask" in e) {
                var h = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w, c = {
                    w: e.w,
                    h: e.h,
                    cs: "DeviceGray",
                    bpc: e.bpc,
                    dp: h,
                    data: e.smask
                };
                "f" in e && (c.f = e.f), t.call(this, c);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), r("<< /Length " + e.pal.length + ">>"), i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))), r("endobj"));
        }, S = function S() {
            var t = this.internal.collections[x + "images"];
            for(var e in t)n.call(this, t[e]);
        }, k = function k() {
            var t, e = this.internal.collections[x + "images"], n = this.internal.write;
            for(var r in e)n("/I" + (t = e[r]).i, t.n, "0", "R");
        }, _ = function _(t) {
            return "function" == typeof b["process" + t.toUpperCase()];
        }, A = function A(t) {
            return "object" === (void 0 === t ? "undefined" : vt(t)) && 1 === t.nodeType;
        }, I = function I(t, e) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/")) return n;
                !e && /\.png(?:[?#].*)?$/i.test(n) && (e = "png");
            }
            if ("CANVAS" === t.nodeName) var r = t;
            else {
                (r = document.createElement("canvas")).width = t.clientWidth || t.width, r.height = t.clientHeight || t.height;
                var i = r.getContext("2d");
                if (!i) throw "addImage requires canvas to be supported by browser.";
                i.drawImage(t, 0, 0, r.width, r.height);
            }
            return r.toDataURL("png" == ("" + e).toLowerCase() ? "image/png" : "image/jpeg");
        }, C = function C(t, e) {
            var n;
            if (e) {
                for(var r in e)if (t === e[r].alias) {
                    n = e[r];
                    break;
                }
            }
            return n;
        };
        b.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN"
        }, b.decode = {
            DCT_DECODE: "DCTDecode",
            FLATE_DECODE: "FlateDecode",
            LZW_DECODE: "LZWDecode",
            JPX_DECODE: "JPXDecode",
            JBIG2_DECODE: "JBIG2Decode",
            ASCII85_DECODE: "ASCII85Decode",
            ASCII_HEX_DECODE: "ASCIIHexDecode",
            RUN_LENGTH_DECODE: "RunLengthDecode",
            CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, b.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW"
        }, b.sHashCode = function(t) {
            return t = t || "", Array.prototype.reduce && t.split("").reduce(function(t, e) {
                return (t = (t << 5) - t + e.charCodeAt(0)) & t;
            }, 0);
        }, b.isString = function(t) {
            return "string" == typeof t;
        }, b.validateStringAsBase64 = function(t) {
            var e = !0;
            return (t = t || "").length % 4 != 0 && (e = !1), !1 === /[A-Za-z0-9\/]+/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2)) && (e = !1), e;
        }, b.extractInfoFromBase64DataURI = function(t) {
            return /^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t);
        }, b.supportsArrayBuffer = function() {
            return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, b.isArrayBuffer = function(t) {
            return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, b.isArrayBufferView = function(t) {
            return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, b.binaryStringToUint8Array = function(t) {
            for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
            return n;
        }, b.arrayBufferToBinaryString = function(t) {
            if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
            if ("function" == typeof TextDecoder) {
                var e = new TextDecoder("ascii");
                if ("ascii" === e.encoding) return e.decode(t);
            }
            for(var n = this.isArrayBuffer(t) ? t : new Uint8Array(t), r = 20480, i = "", o = Math.ceil(n.byteLength / r), a = 0; a < o; a++)i += String.fromCharCode.apply(null, n.slice(a * r, a * r + r));
            return i;
        }, b.arrayBufferToBase64 = function(t) {
            for(var e, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = new Uint8Array(t), o = i.byteLength, a = o % 3, s = o - a, h = 0; h < s; h += 3)n += r[(16515072 & (e = i[h] << 16 | i[h + 1] << 8 | i[h + 2])) >> 18] + r[(258048 & e) >> 12] + r[(4032 & e) >> 6] + r[63 & e];
            return 1 == a ? n += r[(252 & (e = i[s])) >> 2] + r[(3 & e) << 4] + "==" : 2 == a && (n += r[(64512 & (e = i[s] << 8 | i[s + 1])) >> 10] + r[(1008 & e) >> 4] + r[(15 & e) << 2] + "="), n;
        }, b.createImageInfo = function(t, e, n, r, i, o, a, s, h, c, l, u, f) {
            var d = {
                alias: s,
                w: e,
                h: n,
                cs: r,
                bpc: i,
                i: a,
                data: t
            };
            return o && (d.f = o), h && (d.dp = h), c && (d.trns = c), l && (d.pal = l), u && (d.smask = u), f && (d.p = f), d;
        }, b.addImage = function(t, e, n, r, i, o, a, s, h) {
            var c = "";
            if ("string" != typeof e) {
                var l = o;
                o = i, i = r, r = n, n = e, e = l;
            }
            if ("object" === (void 0 === t ? "undefined" : vt(t)) && !A(t) && "imageData" in t) {
                var u = t;
                t = u.imageData, e = u.format || e, n = u.x || n || 0, r = u.y || r || 0, i = u.w || i, o = u.h || o, a = u.alias || a, s = u.compression || s, h = u.rotation || u.angle || h;
            }
            if (isNaN(n) || isNaN(r)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
            var f, d, p, g, m, w, y, v = (function() {
                var _$t = this.internal.collections[x + "images"];
                return _$t || (this.internal.collections[x + "images"] = _$t = {}, this.internal.events.subscribe("putResources", S), this.internal.events.subscribe("putXobjectDict", k)), _$t;
            }).call(this);
            if (!(f = C(t, v)) && (A(t) && (t = I(t, e)), (null == (y = a) || 0 === y.length) && (a = "string" == typeof (w = t) && b.sHashCode(w)), !(f = C(a, v)))) {
                if (this.isString(t) && ("" !== (c = this.convertStringToImageData(t)) ? t = c : void 0 !== (c = this.loadImageFile(t)) && (t = c)), e = this.getImageFileTypeByImageData(t, e), !_(e)) throw new Error("addImage does not support files of type '" + e + "', please ensure that a plugin for '" + e + "' support is added.");
                if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (d = t, t = this.binaryStringToUint8Array(t))), !(f = this["process" + e.toUpperCase()](t, (m = 0, (g = v) && (m = Object.keys ? Object.keys(g).length : function(t) {
                    var _$e = 0;
                    for(var _$n in t)t.hasOwnProperty(_$n) && _$e++;
                    return _$e;
                }(g)), m), a, ((p = s) && "string" == typeof p && (p = p.toUpperCase()), p in b.image_compression ? p : b.image_compression.NONE), d))) throw new Error("An unkwown error occurred whilst processing the image");
            }
            return (function(t, e, n, r, i, o, a, s) {
                var _$h = (function(t, e, n) {
                    return t || e || (e = t = -96), t < 0 && (t = -1 * n.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.w / n.h), 0 === e && (e = t * n.h / n.w), [
                        t,
                        e
                    ];
                }).call(this, n, r, i), c = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
                if (n = _$h[0], r = _$h[1], a[o] = i, s) {
                    s *= Math.PI / 180;
                    var u = Math.cos(s), f = Math.sin(s), d = function d(t) {
                        return t.toFixed(4);
                    }, p = [
                        d(u),
                        d(f),
                        d(-1 * f),
                        d(u),
                        0,
                        0,
                        "cm"
                    ];
                }
                this.internal.write("q"), s ? (this.internal.write([
                    1,
                    "0",
                    "0",
                    1,
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    "0",
                    "0",
                    "cm"
                ].join(" "))) : this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write("/I" + i.i + " Do"), this.internal.write("Q");
            }).call(this, n, r, i, o, f, f.i, v, h), this;
        }, b.convertStringToImageData = function(t) {
            var e, n = "";
            this.isString(t) && (null !== (e = this.extractInfoFromBase64DataURI(t)) ? b.validateStringAsBase64(e[3]) && (n = atob(e[3])) : b.validateStringAsBase64(t) && (n = atob(t)));
            return n;
        };
        var c = function c(t, e) {
            return t.subarray(e, e + 5);
        };
        b.processJPEG = function(t, e, n, r, i, o) {
            var a, s = this.decode.DCT_DECODE;
            if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
            if (this.isString(t) && (a = function(t) {
                var _$e;
                if ((t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3), !t.charCodeAt(6) === "J".charCodeAt(0)) || !t.charCodeAt(7) === "F".charCodeAt(0) || !t.charCodeAt(8) === "I".charCodeAt(0) || !t.charCodeAt(9) === "F".charCodeAt(0) || (t.charCodeAt(10), false)) throw new Error("getJpegSize requires a binary string jpeg file");
                for(var _$n = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, _$i = t.length; r < _$i;){
                    if (r += _$n, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
                    if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return _$e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [
                        256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8),
                        _$e,
                        t.charCodeAt(r + 9)
                    ];
                    r += 2, _$n = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
                }
            }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (a = function(t) {
                if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
                for(var _$e, _$n = t.length, r = (t[4] << 8) + t[5], _$i = 4; _$i < _$n;){
                    if (r = ((_$e = c(t, _$i += r))[2] << 8) + _$e[3], (192 === _$e[1] || 194 === _$e[1]) && 255 === _$e[0] && 7 < r) return {
                        width: ((_$e = c(t, _$i + 5))[2] << 8) + _$e[3],
                        height: (_$e[0] << 8) + _$e[1],
                        numcomponents: _$e[4]
                    };
                    _$i += 2;
                }
                throw new Error("getJpegSizeFromBytes could not find the size of the image");
            }(t), t = i || this.arrayBufferToBinaryString(t)), void 0 === o) switch(a.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                default:
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            return this.createImageInfo(t, a.width, a.height, o, 8, s, e, n);
        }, b.processJPG = function() {
            return this.processJPEG.apply(this, arguments);
        }, b.loadImageFile = function(t, e, n) {
            e = e || !0, n = n || function() {};
            Object.prototype.toString.call("undefined" != typeof $eSBMZ ? $eSBMZ : 0);
            if (void 0 !== ("undefined" == typeof window ? "undefined" : vt(window)) && "object" === ("undefined" == typeof location ? "undefined" : vt(location)) && "http" === location.protocol.substr(0, 4)) return function(t, e, n) {
                var r = new XMLHttpRequest, i = [], o = 0, a = function a(t) {
                    var _$e = t.length, _$n = String.fromCharCode;
                    for(o = 0; o < _$e; o += 1)i.push(_$n(255 & t.charCodeAt(o)));
                    return i.join("");
                };
                if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                    return a(this.responseText);
                }), r.send(null), 200 === r.status) return e ? a(r.responseText) : void 0;
                console.warn('Unable to load file "' + t + '"');
            }(t, e);
        }, b.getImageProperties = function(t) {
            var e, n, r = "";
            if (A(t) && (t = I(t)), this.isString(t) && ("" !== (r = this.convertStringToImageData(t)) ? t = r : void 0 !== (r = this.loadImageFile(t)) && (t = r)), n = this.getImageFileTypeByImageData(t), !_(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
            if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (t = this.binaryStringToUint8Array(t))), !(e = this["process" + n.toUpperCase()](t))) throw new Error("An unkwown error occurred whilst processing the image");
            return {
                fileType: n,
                width: e.w,
                height: e.h,
                colorSpace: e.cs,
                compressionMode: e.f,
                bitsPerComponent: e.bpc
            };
        };
    }($.API), /**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ t = $.API, y = {
        annotations: [],
        f2: function f2(t) {
            return t.toFixed(2);
        },
        notEmpty: function notEmpty(t) {
            if (void 0 !== t && "" != t) return !0;
        }
    }, $.API.annotationPlugin = y, $.API.events.push([
        "addPage",
        function(t) {
            this.annotationPlugin.annotations[t.pageNumber] = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var e = this.annotationPlugin.annotations[t.pageNumber], n = !1, r = 0; r < e.length && !n; r++)switch((h = e[r]).type){
                case "link":
                    if (y.notEmpty(h.options.url) || y.notEmpty(h.options.pageNumber)) {
                        n = !0;
                        break;
                    }
                case "reference":
                case "text":
                case "freetext":
                    n = !0;
            }
            if (0 != n) {
                this.internal.write("/Annots [");
                var i = this.annotationPlugin.f2, o = this.internal.scaleFactor, a = this.internal.pageSize.getHeight(), s = this.internal.getPageInfo(t.pageNumber);
                for(r = 0; r < e.length; r++){
                    var h;
                    switch((h = e[r]).type){
                        case "reference":
                            this.internal.write(" " + h.object.objId + " 0 R ");
                            break;
                        case "text":
                            var c = this.internal.newAdditionalObject(), l = this.internal.newAdditionalObject(), u = h.title || "Note";
                            m = "<</Type /Annot /Subtype /Text " + (d = "/Rect [" + i(h.bounds.x * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w) * o) + " " + i((a - h.bounds.y) * o) + "] ") + "/Contents (" + h.contents + ")", m += " /Popup " + l.objId + " 0 R", m += " /P " + s.objId + " 0 R", m += " /T (" + u + ") >>", c.content = m;
                            var f = c.objId + " 0 R";
                            m = "<</Type /Annot /Subtype /Popup " + (d = "/Rect [" + i((h.bounds.x + 30) * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w + 30) * o) + " " + i((a - h.bounds.y) * o) + "] ") + " /Parent " + f, h.open && (m += " /Open true"), m += " >>", l.content = m, this.internal.write(c.objId, "0 R", l.objId, "0 R");
                            break;
                        case "freetext":
                            var d = "/Rect [" + i(h.bounds.x * o) + " " + i((a - h.bounds.y) * o) + " " + i(h.bounds.x + h.bounds.w * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + "] ", p = h.color || "#000000";
                            m = "<</Type /Annot /Subtype /FreeText " + d + "/Contents (" + h.contents + ")", m += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + p + ")", m += " /Border [0 0 0]", m += " >>", this.internal.write(m);
                            break;
                        case "link":
                            if (h.options.name) {
                                var g = this.annotations._nameMap[h.options.name];
                                h.options.pageNumber = g.page, h.options.top = g.y;
                            } else h.options.top || (h.options.top = 0);
                            d = "/Rect [" + i(h.x * o) + " " + i((a - h.y) * o) + " " + i((h.x + h.w) * o) + " " + i((a - (h.y + h.h)) * o) + "] ";
                            var m = "";
                            if (h.options.url) m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /A <</S /URI /URI (" + h.options.url + ") >>";
                            else if (h.options.pageNumber) switch(m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /Dest [" + (t = this.internal.getPageInfo(h.options.pageNumber)).objId + " 0 R", h.options.magFactor = h.options.magFactor || "XYZ", h.options.magFactor){
                                case "Fit":
                                    m += " /Fit]";
                                    break;
                                case "FitH":
                                    m += " /FitH " + h.options.top + "]";
                                    break;
                                case "FitV":
                                    h.options.left = h.options.left || 0, m += " /FitV " + h.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var w = i((a - h.options.top) * o);
                                    h.options.left = h.options.left || 0, void 0 === h.options.zoom && (h.options.zoom = 0), m += " /XYZ " + h.options.left + " " + w + " " + h.options.zoom + "]";
                            }
                            "" != m && (m += " >>", this.internal.write(m));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), o = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n), n += .2 * o, this.link(e, n - o, i, o, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    }, t.getLineHeight = function() {
        return this.internal.getLineHeight();
    }, function(t) {
        var g = function g(t) {
            return void 0 !== t && void 0 !== u[t.charCodeAt(0)];
        };
        var l = function l(t) {
            return void 0 !== t && 0 <= n.indexOf(t.charCodeAt(0));
        };
        var m = function m(t) {
            return void 0 !== t && 0 <= e.indexOf(t.charCodeAt(0));
        };
        var w = function w(t) {
            return g(t) && 2 <= u[t.charCodeAt(0)].length;
        };
        var y = function y(t, e, n, r) {
            var i;
            return g(t) ? (r = r || {}, u = Object.assign(u, r), !w(t) || !g(e) && !g(n) || !g(n) && l(e) || l(t) && !g(e) || l(t) && m(e) || l(t) && l(e) ? (u = Object.assign(u, d), o) : g(i = t) && 4 == u[i.charCodeAt(0)].length && g(e) && !l(e) && g(n) && w(n) ? (u = Object.assign(u, d), c) : l(t) || !g(n) ? (u = Object.assign(u, d), s) : (u = Object.assign(u, d), h)) : -1;
        };
        var a = Object.keys({
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            ur: "Urdu"
        }), u = {
            1569: [
                65152
            ],
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1572: [
                65157,
                65158
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1574: [
                65161,
                65162,
                65163,
                65164
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ],
            1576: [
                65167,
                65168,
                65169,
                65170
            ],
            1577: [
                65171,
                65172
            ],
            1578: [
                65173,
                65174,
                65175,
                65176
            ],
            1579: [
                65177,
                65178,
                65179,
                65180
            ],
            1580: [
                65181,
                65182,
                65183,
                65184
            ],
            1581: [
                65185,
                65186,
                65187,
                65188
            ],
            1582: [
                65189,
                65190,
                65191,
                65192
            ],
            1583: [
                65193,
                65194,
                65193
            ],
            1584: [
                65195,
                65196,
                65195
            ],
            1585: [
                65197,
                65198,
                65197
            ],
            1586: [
                65199,
                65200,
                65199
            ],
            1587: [
                65201,
                65202,
                65203,
                65204
            ],
            1588: [
                65205,
                65206,
                65207,
                65208
            ],
            1589: [
                65209,
                65210,
                65211,
                65212
            ],
            1590: [
                65213,
                65214,
                65215,
                65216
            ],
            1591: [
                65217,
                65218,
                65219,
                65220
            ],
            1592: [
                65221,
                65222,
                65223,
                65224
            ],
            1593: [
                65225,
                65226,
                65227,
                65228
            ],
            1594: [
                65229,
                65230,
                65231,
                65232
            ],
            1601: [
                65233,
                65234,
                65235,
                65236
            ],
            1602: [
                65237,
                65238,
                65239,
                65240
            ],
            1603: [
                65241,
                65242,
                65243,
                65244
            ],
            1604: [
                65245,
                65246,
                65247,
                65248
            ],
            1605: [
                65249,
                65250,
                65251,
                65252
            ],
            1606: [
                65253,
                65254,
                65255,
                65256
            ],
            1607: [
                65257,
                65258,
                65259,
                65260
            ],
            1608: [
                65261,
                65262,
                65261
            ],
            1609: [
                65263,
                65264,
                64488,
                64489
            ],
            1610: [
                65265,
                65266,
                65267,
                65268
            ],
            1649: [
                64336,
                64337
            ],
            1655: [
                64477
            ],
            1657: [
                64358,
                64359,
                64360,
                64361
            ],
            1658: [
                64350,
                64351,
                64352,
                64353
            ],
            1659: [
                64338,
                64339,
                64340,
                64341
            ],
            1662: [
                64342,
                64343,
                64344,
                64345
            ],
            1663: [
                64354,
                64355,
                64356,
                64357
            ],
            1664: [
                64346,
                64347,
                64348,
                64349
            ],
            1667: [
                64374,
                64375,
                64376,
                64377
            ],
            1668: [
                64370,
                64371,
                64372,
                64373
            ],
            1670: [
                64378,
                64379,
                64380,
                64381
            ],
            1671: [
                64382,
                64383,
                64384,
                64385
            ],
            1672: [
                64392,
                64393
            ],
            1676: [
                64388,
                64389
            ],
            1677: [
                64386,
                64387
            ],
            1678: [
                64390,
                64391
            ],
            1681: [
                64396,
                64397
            ],
            1688: [
                64394,
                64395,
                64394
            ],
            1700: [
                64362,
                64363,
                64364,
                64365
            ],
            1702: [
                64366,
                64367,
                64368,
                64369
            ],
            1705: [
                64398,
                64399,
                64400,
                64401
            ],
            1709: [
                64467,
                64468,
                64469,
                64470
            ],
            1711: [
                64402,
                64403,
                64404,
                64405
            ],
            1713: [
                64410,
                64411,
                64412,
                64413
            ],
            1715: [
                64406,
                64407,
                64408,
                64409
            ],
            1722: [
                64414,
                64415
            ],
            1723: [
                64416,
                64417,
                64418,
                64419
            ],
            1726: [
                64426,
                64427,
                64428,
                64429
            ],
            1728: [
                64420,
                64421
            ],
            1729: [
                64422,
                64423,
                64424,
                64425
            ],
            1733: [
                64480,
                64481
            ],
            1734: [
                64473,
                64474
            ],
            1735: [
                64471,
                64472
            ],
            1736: [
                64475,
                64476
            ],
            1737: [
                64482,
                64483
            ],
            1739: [
                64478,
                64479
            ],
            1740: [
                64508,
                64509,
                64510,
                64511
            ],
            1744: [
                64484,
                64485,
                64486,
                64487
            ],
            1746: [
                64430,
                64431
            ],
            1747: [
                64432,
                64433
            ]
        }, f = {
            1570: [
                65269,
                65270,
                65269,
                65270
            ],
            1571: [
                65271,
                65272,
                65271,
                65272
            ],
            1573: [
                65273,
                65274,
                65273,
                65274
            ],
            1575: [
                65275,
                65276,
                65275,
                65276
            ]
        }, d = {
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ]
        }, p = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }, e = [
            1570,
            1571,
            1573,
            1575
        ], n = [
            1569,
            1570,
            1571,
            1572,
            1573,
            1575,
            1577,
            1583,
            1584,
            1585,
            1586,
            1608,
            1688
        ], o = 0, s = 1, h = 2, c = 3;
        var v = t.processArabic = function v(t, e) {
            t = t || "", e = e || !1;
            var n, r, i, o = "", a = 0, s = 0, h = "", c = "", l = "";
            for(a = 0; a < t.length; a += 1)h = t[a], c = t[a - 1], l = t[a + 1], g(h) ? void 0 !== c && 1604 === c.charCodeAt(0) && m(h) ? (s = y(h, t[a - 2], t[a + 1], f), n = String.fromCharCode(f[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : void 0 !== c && 1617 === c.charCodeAt(0) && void 0 !== (r = h) && void 0 !== p[r.charCodeAt(0)] ? (s = y(h, t[a - 2], t[a + 1], d), n = String.fromCharCode(p[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : (s = y(h, c, l, d), o += String.fromCharCode(u[h.charCodeAt(0)][s])) : o += e ? ({
                "(": ")",
                ")": "("
            })[i = h] || i : h;
            return e ? o.split("").reverse().join("") : o;
        };
        t.events.push([
            "preProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang), i = [];
                if (0 <= a.indexOf(r)) {
                    if ("[object Array]" === Object.prototype.toString.call(e)) {
                        var o = 0;
                        for(i = [], o = 0; o < e.length; o += 1)"[object Array]" === Object.prototype.toString.call(e[o]) ? i.push([
                            v(e[o][0], !0),
                            e[o][1],
                            e[o][2]
                        ]) : i.push([
                            v(e[o], !0)
                        ]);
                        t.text = i;
                    } else t.text = v(e, !0);
                    void 0 === n.charSpace && (t.options.charSpace = 0), !0 === n.R2L && (t.options.R2L = !1);
                }
            }
        ]);
    }($.API), $.API.autoPrint = function(t) {
        var e;
        switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function() {
                    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                }), this.internal.events.subscribe("putCatalog", function() {
                    this.internal.out("/OpenAction " + e + " 0 R");
                });
        }
        return this;
    }, /**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (e = $.API).events.push([
        "initialized",
        function() {
            this.canvas.pdf = this;
        }
    ]), e.canvas = {
        getContext: function getContext(t) {
            return (this.pdf.context2d._canvas = this).pdf.context2d;
        },
        childNodes: []
    }, Object.defineProperty(e.canvas, "width", {
        get: function get() {
            return this._width;
        },
        set: function set(t) {
            this._width = t, this.getContext("2d").pageWrapX = t + 1;
        }
    }), Object.defineProperty(e.canvas, "height", {
        get: function get() {
            return this._height;
        },
        set: function set(t) {
            this._height = t, this.getContext("2d").pageWrapY = t + 1;
        }
    }), /** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ I = $.API, C = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
    }, T = 1, d = function d(t, e, n, r, i) {
        C = {
            x: t,
            y: e,
            w: n,
            h: r,
            ln: i
        };
    }, p = function p() {
        return C;
    }, F = {
        left: 0,
        top: 0,
        bottom: 0
    }, I.setHeaderFunction = function(t) {
        h = t;
    }, I.getTextDimensions = function(e) {
        i = this.internal.getFont().fontName, o = this.table_font_size || this.internal.getFontSize(), a = this.internal.getFont().fontStyle;
        var t, n, r = 19.049976 / 25.4;
        (n = document.createElement("font")).id = "jsPDFCell";
        try {
            n.style.fontStyle = a;
        } catch (t) {
            n.style.fontWeight = a;
        }
        n.style.fontSize = o + "pt", n.style.fontFamily = i;
        try {
            n.textContent = e;
        } catch (t) {
            n.innerText = e;
        }
        return document.body.appendChild(n), t = {
            w: (n.offsetWidth + 1) * r,
            h: (n.offsetHeight + 1) * r
        }, document.body.removeChild(n), t;
    }, I.cellAddPage = function() {
        var t = this.margins || F;
        this.addPage(), d(t.left, t.top, void 0, void 0), T += 1;
    }, I.cellInitialize = function() {
        C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1;
    }, I.cell = function(t, e, n, r, i, o, a) {
        var s = p(), h = !1;
        if (void 0 !== s.ln) {
            if (s.ln === o) t = s.x + s.w, e = s.y;
            else {
                var c = this.margins || F;
                s.y + s.h + r + 13 >= this.internal.pageSize.getHeight() - c.bottom && (this.cellAddPage(), h = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(o, !0)), e = p().y + p().h, h && (e = 23);
            }
        }
        if (void 0 !== i[0]) {
            if (this.printingHeaderRow ? this.rect(t, e, n, r, "FD") : this.rect(t, e, n, r), "right" === a) {
                i instanceof Array || (i = [
                    i
                ]);
                for(var l = 0; l < i.length; l++){
                    var u = i[l], f = this.getStringUnitWidth(u) * this.internal.getFontSize();
                    this.text(u, t + n - f - 3, e + this.internal.getLineHeight() * (l + 1));
                }
            } else this.text(i, t + 3, e + this.internal.getLineHeight());
        }
        return d(t, e, n, r, o), this;
    }, I.arrayMax = function(t, e) {
        var n, r, i, o = t[0];
        for(n = 0, r = t.length; n < r; n += 1)i = t[n], e ? -1 === e(o, i) && (o = i) : o < i && (o = i);
        return o;
    }, I.table = function(t, e, n, r, i) {
        if (!n) throw "No data for PDF table";
        var o, a, s, h, c, l, u, f, d, p, g = [], m = [], w = {}, y = {}, v = [], b = [], x = !1, S = !0, k = 12, _ = F;
        if (_.width = this.internal.pageSize.getWidth(), i && (!0 === i.autoSize && (x = !0), !1 === i.printHeaders && (S = !1), i.fontSize && (k = i.fontSize), i.css && void 0 !== i.css["font-size"] && (k = 16 * i.css["font-size"]), i.margins && (_ = i.margins)), this.lnMod = 0, C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1, this.printHeaders = S, this.margins = _, this.setFontSize(k), this.table_font_size = k, null == r) g = Object.keys(n[0]);
        else if (r[0] && "string" != typeof r[0]) for(a = 0, s = r.length; a < s; a += 1)o = r[a], g.push(o.name), m.push(o.prompt), y[o.name] = o.width * (19.049976 / 25.4);
        else g = r;
        if (x) for(p = function p(t) {
            return t[o];
        }, a = 0, s = g.length; a < s; a += 1){
            for(w[o = g[a]] = n.map(p), v.push(this.getTextDimensions(m[a] || o).w), u = 0, h = (l = w[o]).length; u < h; u += 1)c = l[u], v.push(this.getTextDimensions(c).w);
            y[o] = I.arrayMax(v), v = [];
        }
        if (S) {
            var A = this.calculateLineHeight(g, y, m.length ? m : g);
            for(a = 0, s = g.length; a < s; a += 1)o = g[a], b.push([
                t,
                e,
                y[o],
                A,
                String(m.length ? m[a] : o)
            ]);
            this.setTableHeaderRow(b), this.printHeaderRow(1, !1);
        }
        for(a = 0, s = n.length; a < s; a += 1)for(f = n[a], A = this.calculateLineHeight(g, y, f), u = 0, d = g.length; u < d; u += 1)o = g[u], this.cell(t, e, y[o], A, f[o], a + 2, o.align);
        return this.lastCellPos = C, this.table_x = t, this.table_y = e, this;
    }, I.calculateLineHeight = function(t, e, n) {
        for(var r, i = 0, o = 0; o < t.length; o++){
            n[r = t[o]] = this.splitTextToSize(String(n[r]), e[r] - 3);
            var a = this.internal.getLineHeight() * n[r].length + 3;
            i < a && (i = a);
        }
        return i;
    }, I.setTableHeaderRow = function(t) {
        this.tableHeaderRow = t;
    }, I.printHeaderRow = function(t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var n, r, i, o;
        if (this.printingHeaderRow = !0, void 0 !== h) {
            var a = h(this, T);
            d(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var s = [];
        for(i = 0, o = this.tableHeaderRow.length; i < o; i += 1)this.setFillColor(200, 200, 200), n = this.tableHeaderRow[i], e && (this.margins.top = 13, n[1] = this.margins && this.margins.top || 0, s.push(n)), r = [].concat(n), this.cell.apply(this, r.concat(t));
        0 < s.length && this.setTableHeaderRow(s), this.setFontStyle("normal"), this.printingHeaderRow = !1;
    }, /**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ function(t) {
        var e = function e() {
            this._isStrokeTransparent = !1, this._strokeOpacity = 1, this.strokeStyle = "#000000", this.fillStyle = "#000000", this._isFillTransparent = !1, this._fillOpacity = 1, this.font = "12pt times", this.textBaseline = "alphabetic", this.textAlign = "start", this.lineWidth = 1, this.lineJoin = "miter", this.lineCap = "butt", this._transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ], this.globalCompositeOperation = "normal", this.globalAlpha = 1, this._clip_path = [], this.ignoreClearRect = !1, this.copy = function(t) {
                this._isStrokeTransparent = t._isStrokeTransparent, this._strokeOpacity = t._strokeOpacity, this.strokeStyle = t.strokeStyle, this._isFillTransparent = t._isFillTransparent, this._fillOpacity = t._fillOpacity, this.fillStyle = t.fillStyle, this.font = t.font, this.lineWidth = t.lineWidth, this.lineJoin = t.lineJoin, this.lineCap = t.lineCap, this.textBaseline = t.textBaseline, this.textAlign = t.textAlign, this._fontSize = t._fontSize, this._transform = t._transform.slice(0), this.globalCompositeOperation = t.globalCompositeOperation, this.globalAlpha = t.globalAlpha, this._clip_path = t._clip_path.slice(0), this.ignoreClearRect = t.ignoreClearRect;
            };
        };
        t.events.push([
            "initialized",
            function() {
                ((this.context2d.pdf = this).context2d.internal.pdf = this).context2d.ctx = new e, this.context2d.ctxStack = [], this.context2d.path = [];
            }
        ]), t.context2d = {
            pageWrapXEnabled: !1,
            pageWrapYEnabled: !1,
            pageWrapX: 9999999,
            pageWrapY: 9999999,
            ctx: new e,
            f2: function f2(t) {
                return t.toFixed(2);
            },
            fillRect: function fillRect(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "f");
                }
            },
            strokeRect: function strokeRect(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "s");
                }
            },
            clearRect: function clearRect(t, e, n, r) {
                if (!this.ctx.ignoreClearRect) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.save(), this.setFillStyle("#ffffff"), this.pdf.rect(i.x, i.y, i.w, i.h, "f"), this.restore();
                }
            },
            save: function save() {
                this.ctx._fontSize = this.pdf.internal.getFontSize();
                var _$t = new e;
                _$t.copy(this.ctx), this.ctxStack.push(this.ctx), this.ctx = _$t;
            },
            restore: function restore() {
                this.ctx = this.ctxStack.pop(), this.setFillStyle(this.ctx.fillStyle), this.setStrokeStyle(this.ctx.strokeStyle), this.setFont(this.ctx.font), this.pdf.setFontSize(this.ctx._fontSize), this.setLineCap(this.ctx.lineCap), this.setLineWidth(this.ctx.lineWidth), this.setLineJoin(this.ctx.lineJoin);
            },
            rect: function rect(t, e, n, r) {
                this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.closePath();
            },
            beginPath: function beginPath() {
                this.path = [];
            },
            closePath: function closePath() {
                this.path.push({
                    type: "close"
                });
            },
            _getRGBA: function _getRGBA(t) {
                var e, n, r, i, o = new RGBColor(t);
                if (!t) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    style: t
                };
                if (this.internal.rxTransparent.test(t)) i = r = n = e = 0;
                else {
                    var a = this.internal.rxRgb.exec(t);
                    null != a ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1) : null != (a = this.internal.rxRgba.exec(t)) ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4])) : (i = 1, "#" != t.charAt(0) && (t = o.ok ? o.toHex() : "#000000"), 4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16));
                }
                return {
                    r: e,
                    g: n,
                    b: r,
                    a: i,
                    style: t
                };
            },
            setFillStyle: function setFillStyle(t) {
                var e = this._getRGBA(t);
                this.ctx.fillStyle = t, this.ctx._isFillTransparent = 0 === e.a, this.ctx._fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            },
            setStrokeStyle: function setStrokeStyle(t) {
                var e = this._getRGBA(t);
                this.ctx.strokeStyle = e.style, this.ctx._isStrokeTransparent = 0 === e.a, this.ctx._strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            },
            fillText: function fillText(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (h < .01) this.pdf.text(t, e, this._getBaseline(n), null, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), null, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            strokeText: function strokeText(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (1 === h) this.pdf.text(t, e, this._getBaseline(n), {
                        stroke: !0
                    }, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), {
                            stroke: !0
                        }, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            setFont: function setFont(t) {
                if (this.ctx.font = t, null != (c = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))) {
                    var e = c[1], n = (c[2], c[3]), r = c[4], i = c[5], o = c[6];
                    r = "px" === i ? Math.floor(parseFloat(r)) : "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(r)), this.pdf.setFontSize(r), "bold" === n || "700" === n ? this.pdf.setFontStyle("bold") : "italic" === e ? this.pdf.setFontStyle("italic") : this.pdf.setFontStyle("normal"), l = "bold" === n || "700" === n ? "italic" === e ? "bolditalic" : "bold" : "italic" === e ? "italic" : "normal";
                    for(var a = o.toLowerCase().split(/\s*,\s*/), s = "Times", h = 0; h < a.length; h++){
                        if (void 0 !== this.pdf.internal.getFont(a[h], l, {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h];
                            break;
                        }
                        if ("bolditalic" === l && void 0 !== this.pdf.internal.getFont(a[h], "bold", {
                            noFallback: !0,
                            disableWarning: !0
                        })) s = a[h], l = "bold";
                        else if (void 0 !== this.pdf.internal.getFont(a[h], "normal", {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h], l = "normal";
                            break;
                        }
                    }
                    this.pdf.setFont(s, l);
                } else {
                    var c = /\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);
                    if (null != c) {
                        var l, u = c[1], f = (c[2], c[3]);
                        (l = c[4]) || (l = "normal"), u = "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(u)), this.pdf.setFontSize(u), this.pdf.setFont(f, l);
                    }
                }
            },
            setTextBaseline: function setTextBaseline(t) {
                this.ctx.textBaseline = t;
            },
            getTextBaseline: function getTextBaseline() {
                return this.ctx.textBaseline;
            },
            setTextAlign: function setTextAlign(t) {
                this.ctx.textAlign = t;
            },
            getTextAlign: function getTextAlign() {
                return this.ctx.textAlign;
            },
            setLineWidth: function setLineWidth(t) {
                this.ctx.lineWidth = t, this.pdf.setLineWidth(t);
            },
            setLineCap: function setLineCap(t) {
                this.ctx.lineCap = t, this.pdf.setLineCap(t);
            },
            setLineJoin: function setLineJoin(t) {
                this.ctx.lineJoin = t, this.pdf.setLineJoin(t);
            },
            moveTo: function moveTo(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "mt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            _wrapX: function _wrapX(t) {
                return this.pageWrapXEnabled ? t % this.pageWrapX : t;
            },
            _wrapY: function _wrapY(t) {
                return this.pageWrapYEnabled ? (this._gotoPage(this._page(t)), (t - this.lastBreak) % this.pageWrapY) : t;
            },
            transform: function transform(t, e, n, r, i, o) {
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ]);
            },
            setTransform: function setTransform(t, e, n, r, i, o) {
                this.ctx._transform = [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ];
            },
            _getTransform: function _getTransform() {
                return this.ctx._transform;
            },
            lastBreak: 0,
            pageBreaks: [],
            _page: function _page(t) {
                if (this.pageWrapYEnabled) {
                    for(var e = this.lastBreak = 0, n = 0, r = 0; r < this.pageBreaks.length; r++)if (t >= this.pageBreaks[r]) {
                        e++, 0 === this.lastBreak && n++;
                        var i = this.pageBreaks[r] - this.lastBreak;
                        this.lastBreak = this.pageBreaks[r], n += Math.floor(i / this.pageWrapY);
                    }
                    if (0 === this.lastBreak) n += Math.floor(t / this.pageWrapY) + 1;
                    return n + e;
                }
                return this.pdf.internal.getCurrentPageInfo().pageNumber;
            },
            _gotoPage: function _gotoPage(t) {},
            lineTo: function lineTo(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "lt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            bezierCurveTo: function bezierCurveTo(t, e, n, r, i, o) {
                var a;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), i = this._wrapX(i), o = this._wrapY(o), i = (a = this._matrix_map_point(this.ctx._transform, [
                    i,
                    o
                ]))[0], o = a[1];
                var s = {
                    type: "bct",
                    x1: t = (a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = a[1],
                    x2: n = (a = this._matrix_map_point(this.ctx._transform, [
                        n,
                        r
                    ]))[0],
                    y2: r = a[1],
                    x: i,
                    y: o
                };
                this.path.push(s);
            },
            quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
                var i;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), n = (i = this._matrix_map_point(this.ctx._transform, [
                    n,
                    r
                ]))[0], r = i[1];
                var o = {
                    type: "qct",
                    x1: t = (i = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = i[1],
                    x: n,
                    y: r
                };
                this.path.push(o);
            },
            arc: function arc(t, e, n, r, i, o) {
                if (t = this._wrapX(t), e = this._wrapY(e), !this._matrix_is_identity(this.ctx._transform)) {
                    var a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]);
                    t = a[0], e = a[1];
                    var s = this._matrix_map_point(this.ctx._transform, [
                        0,
                        0
                    ]), h = this._matrix_map_point(this.ctx._transform, [
                        0,
                        n
                    ]);
                    n = Math.sqrt(Math.pow(h[0] - s[0], 2) + Math.pow(h[1] - s[1], 2));
                }
                var c = {
                    type: "arc",
                    x: t,
                    y: e,
                    radius: n,
                    startAngle: r,
                    endAngle: i,
                    anticlockwise: o
                };
                this.path.push(c);
            },
            drawImage: function drawImage(t, e, n, r, i, o, a, s, h) {
                void 0 !== o && (e = o, n = a, r = s, i = h), e = this._wrapX(e), n = this._wrapY(n);
                var c, l = this._matrix_map_rect(this.ctx._transform, {
                    x: e,
                    y: n,
                    w: r,
                    h: i
                }), u = (this._matrix_map_rect(this.ctx._transform, {
                    x: o,
                    y: a,
                    w: s,
                    h: h
                }), /data:image\/(\w+).*/i.exec(t));
                c = null != u ? u[1] : "png", this.pdf.addImage(t, c, l.x, l.y, l.w, l.h);
            },
            _matrix_multiply: function _matrix_multiply(t, e) {
                var n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], h = n * t[0] + r * t[2], c = i * t[0] + o * t[2], l = a * t[0] + s * t[2] + t[4];
                return r = n * t[1] + r * t[3], o = i * t[1] + o * t[3], s = a * t[1] + s * t[3] + t[5], [
                    n = h,
                    r,
                    i = c,
                    o,
                    a = l,
                    s
                ];
            },
            _matrix_rotation: function _matrix_rotation(t) {
                return Math.atan2(t[2], t[0]);
            },
            _matrix_decompose: function _matrix_decompose(t) {
                var e = t[0], n = t[1], r = t[2], i = t[3], o = Math.sqrt(e * e + n * n), a = (e /= o) * r + (n /= o) * i;
                r -= e * a, i -= n * a;
                var s = Math.sqrt(r * r + i * i);
                return a /= s, e * (i /= s) < n * (r /= s) && (e = -e, n = -n, a = -a, o = -o), {
                    scale: [
                        o,
                        0,
                        0,
                        s,
                        0,
                        0
                    ],
                    translate: [
                        1,
                        0,
                        0,
                        1,
                        t[4],
                        t[5]
                    ],
                    rotate: [
                        e,
                        n,
                        -n,
                        e,
                        0,
                        0
                    ],
                    skew: [
                        1,
                        0,
                        a,
                        1,
                        0,
                        0
                    ]
                };
            },
            _matrix_map_point: function _matrix_map_point(t, e) {
                var n = t[0], r = t[1], i = t[2], o = t[3], a = t[4], s = t[5], h = e[0], c = e[1];
                return [
                    h * n + c * i + a,
                    h * r + c * o + s
                ];
            },
            _matrix_map_point_obj: function _matrix_map_point_obj(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]);
                return {
                    x: n[0],
                    y: n[1]
                };
            },
            _matrix_map_rect: function _matrix_map_rect(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]), r = this._matrix_map_point(t, [
                    e.x + e.w,
                    e.y + e.h
                ]);
                return {
                    x: n[0],
                    y: n[1],
                    w: r[0] - n[0],
                    h: r[1] - n[1]
                };
            },
            _matrix_is_identity: function _matrix_is_identity(t) {
                return 1 == t[0] && 0 == t[1] && 0 == t[2] && 1 == t[3] && 0 == t[4] && 0 == t[5];
            },
            rotate: function rotate(t) {
                var e = [
                    Math.cos(t),
                    Math.sin(t),
                    -Math.sin(t),
                    Math.cos(t),
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, e);
            },
            scale: function scale(t, e) {
                var n = [
                    t,
                    0,
                    0,
                    e,
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            translate: function translate(t, e) {
                var n = [
                    1,
                    0,
                    0,
                    1,
                    t,
                    e
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            stroke: function stroke() {
                if (0 < this.ctx._clip_path.length) {
                    var _$t;
                    (_$t = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var e = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._stroke(!0), this.ctx._clip_path = this.path, this.path = e, this._stroke(!1), _$t.push("Q");
                } else this._stroke(!1);
            },
            _stroke: function _stroke(t) {
                if (t || !this._isStrokeTransparent()) {
                    for(var e = [], n = this.path, r = 0; r < n.length; r++){
                        var i = n[r];
                        switch(i.type){
                            case "mt":
                                e.push({
                                    start: i,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var o = [
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o), e[e.length - 1].abs.push(i);
                                break;
                            case "bct":
                                o = [
                                    i.x1 - n[r - 1].x,
                                    i.y1 - n[r - 1].y,
                                    i.x2 - n[r - 1].x,
                                    i.y2 - n[r - 1].y,
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "qct":
                                var a = n[r - 1].x + 2 / 3 * (i.x1 - n[r - 1].x), s = n[r - 1].y + 2 / 3 * (i.y1 - n[r - 1].y), h = i.x + 2 / 3 * (i.x1 - i.x), c = i.y + 2 / 3 * (i.y1 - i.y), l = i.x, u = i.y;
                                o = [
                                    a - n[r - 1].x,
                                    s - n[r - 1].y,
                                    h - n[r - 1].x,
                                    c - n[r - 1].y,
                                    l - n[r - 1].x,
                                    u - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "arc":
                                0 == e.length && e.push({
                                    start: {
                                        x: 0,
                                        y: 0
                                    },
                                    deltas: [],
                                    abs: []
                                }), e[e.length - 1].arc = !0, Array.isArray(e[e.length - 1].abs) && e[e.length - 1].abs.push(i);
                        }
                    }
                    for(r = 0; r < e.length; r++){
                        var f;
                        if (f = r == e.length - 1 ? "s" : null, e[r].arc) for(var d = e[r].abs, p = 0; p < d.length; p++){
                            var g = d[p], m = 360 * g.startAngle / (2 * Math.PI), w = 360 * g.endAngle / (2 * Math.PI), y = g.x, v = g.y;
                            this.internal.arc2(this, y, v, g.radius, m, w, g.anticlockwise, f, t);
                        }
                        else {
                            y = e[r].start.x, v = e[r].start.y;
                            t ? (this.pdf.lines(e[r].deltas, y, v, null, null), this.pdf.clip_fixed()) : this.pdf.lines(e[r].deltas, y, v, null, f);
                        }
                    }
                }
            },
            _isFillTransparent: function _isFillTransparent() {
                return this.ctx._isFillTransparent || 0 == this.globalAlpha;
            },
            _isStrokeTransparent: function _isStrokeTransparent() {
                return this.ctx._isStrokeTransparent || 0 == this.globalAlpha;
            },
            fill: function fill(t) {
                if (0 < this.ctx._clip_path.length) {
                    var e;
                    (e = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var n = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(t, !0), this.ctx._clip_path = this.path, this.path = n, this._fill(t, !1), e.push("Q");
                } else this._fill(t, !1);
            },
            _fill: function _fill(t, e) {
                if (!this._isFillTransparent()) {
                    var n, r = "function" == typeof this.pdf.internal.newObject2;
                    n = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage();
                    var i = [], o = window.outIntercept;
                    if (r) switch(this.ctx.globalCompositeOperation){
                        case "normal":
                        case "source-over":
                            break;
                        case "destination-in":
                        case "destination-out":
                            var a = this.pdf.internal.newStreamObject(), s = this.pdf.internal.newObject2();
                            s.push("<</Type /ExtGState"), s.push("/SMask <</S /Alpha /G " + a.objId + " 0 R>>"), s.push(">>");
                            var h = "MASK" + s.objId;
                            this.pdf.internal.addGraphicsState(h, s.objId);
                            var c = "/" + h + " gs";
                            n.splice(0, 0, "q"), n.splice(1, 0, c), n.push("Q"), window.outIntercept = a;
                            break;
                        default:
                            var l = "/" + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];
                            l && this.pdf.internal.out(l + " gs");
                    }
                    var u = this.ctx.globalAlpha;
                    if (this.ctx._fillOpacity < 1 && (u = this.ctx._fillOpacity), r) {
                        var f = this.pdf.internal.newObject2();
                        f.push("<</Type /ExtGState"), f.push("/CA " + u), f.push("/ca " + u), f.push(">>");
                        h = "GS_O_" + f.objId;
                        this.pdf.internal.addGraphicsState(h, f.objId), this.pdf.internal.out("/" + h + " gs");
                    }
                    for(var d = this.path, p = 0; p < d.length; p++){
                        var g = d[p];
                        switch(g.type){
                            case "mt":
                                i.push({
                                    start: g,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var m = [
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m), i[i.length - 1].abs.push(g);
                                break;
                            case "bct":
                                m = [
                                    g.x1 - d[p - 1].x,
                                    g.y1 - d[p - 1].y,
                                    g.x2 - d[p - 1].x,
                                    g.y2 - d[p - 1].y,
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "qct":
                                var w = d[p - 1].x + 2 / 3 * (g.x1 - d[p - 1].x), y = d[p - 1].y + 2 / 3 * (g.y1 - d[p - 1].y), v = g.x + 2 / 3 * (g.x1 - g.x), b = g.y + 2 / 3 * (g.y1 - g.y), x = g.x, S = g.y;
                                m = [
                                    w - d[p - 1].x,
                                    y - d[p - 1].y,
                                    v - d[p - 1].x,
                                    b - d[p - 1].y,
                                    x - d[p - 1].x,
                                    S - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "arc":
                                0 === i.length && i.push({
                                    deltas: [],
                                    abs: []
                                }), i[i.length - 1].arc = !0, Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(g);
                                break;
                            case "close":
                                i.push({
                                    close: !0
                                });
                        }
                    }
                    for(p = 0; p < i.length; p++){
                        var k;
                        if (p == i.length - 1 ? (k = "f", "evenodd" === t && (k += "*")) : k = null, i[p].close) this.pdf.internal.out("h"), k && this.pdf.internal.out(k);
                        else if (i[p].arc) {
                            i[p].start && this.internal.move2(this, i[p].start.x, i[p].start.y);
                            for(var _ = i[p].abs, A = 0; A < _.length; A++){
                                var I = _[A];
                                if (void 0 !== I.startAngle) {
                                    var C = 360 * I.startAngle / (2 * Math.PI), T = 360 * I.endAngle / (2 * Math.PI), F = I.x, P = I.y;
                                    if (0 === A && this.internal.move2(this, F, P), this.internal.arc2(this, F, P, I.radius, C, T, I.anticlockwise, null, e), A === _.length - 1 && i[p].start) {
                                        F = i[p].start.x, P = i[p].start.y;
                                        this.internal.line2(E, F, P);
                                    }
                                } else this.internal.line2(E, I.x, I.y);
                            }
                        } else {
                            F = i[p].start.x, P = i[p].start.y;
                            e ? (this.pdf.lines(i[p].deltas, F, P, null, null), this.pdf.clip_fixed()) : this.pdf.lines(i[p].deltas, F, P, null, k);
                        }
                    }
                    window.outIntercept = o;
                }
            },
            pushMask: function pushMask() {
                if ("function" == typeof this.pdf.internal.newObject2) {
                    var _$t = this.pdf.internal.newStreamObject(), e = this.pdf.internal.newObject2();
                    e.push("<</Type /ExtGState"), e.push("/SMask <</S /Alpha /G " + _$t.objId + " 0 R>>"), e.push(">>");
                    var n = "MASK" + e.objId;
                    this.pdf.internal.addGraphicsState(n, e.objId);
                    var r = "/" + n + " gs";
                    this.pdf.internal.out(r);
                } else console.log("jsPDF v2 not enabled");
            },
            clip: function clip() {
                if (0 < this.ctx._clip_path.length) for(var _$t = 0; _$t < this.path.length; _$t++)this.ctx._clip_path.push(this.path[_$t]);
                else this.ctx._clip_path = this.path;
                this.path = [];
            },
            measureText: function measureText(n) {
                var r = this.pdf;
                return {
                    getWidth: function getWidth() {
                        var _$t = r.internal.getFontSize(), e = r.getStringUnitWidth(n) * _$t / r.internal.scaleFactor;
                        return e *= 1.3333;
                    },
                    get width () {
                        return this.getWidth(n);
                    }
                };
            },
            _getBaseline: function _getBaseline(t) {
                var e = parseInt(this.pdf.internal.getFontSize()), n = .25 * e;
                switch(this.ctx.textBaseline){
                    case "bottom":
                        return t - n;
                    case "top":
                        return t + e;
                    case "hanging":
                        return t + e - n;
                    case "middle":
                        return t + e / 2 - n;
                    case "ideographic":
                        return t;
                    case "alphabetic":
                    default:
                        return t;
                }
            }
        };
        var E = t.context2d;
        Object.defineProperty(E, "fillStyle", {
            set: function set(t) {
                this.setFillStyle(t);
            },
            get: function get() {
                return this.ctx.fillStyle;
            }
        }), Object.defineProperty(E, "strokeStyle", {
            set: function set(t) {
                this.setStrokeStyle(t);
            },
            get: function get() {
                return this.ctx.strokeStyle;
            }
        }), Object.defineProperty(E, "lineWidth", {
            set: function set(t) {
                this.setLineWidth(t);
            },
            get: function get() {
                return this.ctx.lineWidth;
            }
        }), Object.defineProperty(E, "lineCap", {
            set: function set(t) {
                this.setLineCap(t);
            },
            get: function get() {
                return this.ctx.lineCap;
            }
        }), Object.defineProperty(E, "lineJoin", {
            set: function set(t) {
                this.setLineJoin(t);
            },
            get: function get() {
                return this.ctx.lineJoin;
            }
        }), Object.defineProperty(E, "miterLimit", {
            set: function set(t) {
                this.ctx.miterLimit = t;
            },
            get: function get() {
                return this.ctx.miterLimit;
            }
        }), Object.defineProperty(E, "textBaseline", {
            set: function set(t) {
                this.setTextBaseline(t);
            },
            get: function get() {
                return this.getTextBaseline();
            }
        }), Object.defineProperty(E, "textAlign", {
            set: function set(t) {
                this.setTextAlign(t);
            },
            get: function get() {
                return this.getTextAlign();
            }
        }), Object.defineProperty(E, "font", {
            set: function set(t) {
                this.setFont(t);
            },
            get: function get() {
                return this.ctx.font;
            }
        }), Object.defineProperty(E, "globalCompositeOperation", {
            set: function set(t) {
                this.ctx.globalCompositeOperation = t;
            },
            get: function get() {
                return this.ctx.globalCompositeOperation;
            }
        }), Object.defineProperty(E, "globalAlpha", {
            set: function set(t) {
                this.ctx.globalAlpha = t;
            },
            get: function get() {
                return this.ctx.globalAlpha;
            }
        }), Object.defineProperty(E, "canvas", {
            get: function get() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        }), Object.defineProperty(E, "ignoreClearRect", {
            set: function set(t) {
                this.ctx.ignoreClearRect = t;
            },
            get: function get() {
                return this.ctx.ignoreClearRect;
            }
        }), E.internal = {}, E.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, E.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/, E.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/, E.internal.arc = function(t, e, n, r, i, o, a, s) {
            for(var h = this.pdf.internal.scaleFactor, c = this.pdf.internal.pageSize.getHeight(), l = this.pdf.internal.f2, u = i * (Math.PI / 180), f = o * (Math.PI / 180), d = this.createArc(r, u, f, a), p = 0; p < d.length; p++){
                var g = d[p];
                0 === p ? this.pdf.internal.out([
                    l((g.x1 + e) * h),
                    l((c - (g.y1 + n)) * h),
                    "m",
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")) : this.pdf.internal.out([
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")), t._lastPoint = {
                    x: e,
                    y: n
                };
            }
            null !== s && this.pdf.internal.out(this.pdf.internal.getStyle(s));
        }, E.internal.arc2 = function(t, e, n, r, i, o, a, s, h) {
            var c = e, l = n;
            h ? (this.arc(t, c, l, r, i, o, a, null), this.pdf.clip_fixed()) : this.arc(t, c, l, r, i, o, a, s);
        }, E.internal.move2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2;
            this.pdf.internal.out([
                o(e * r),
                o((i - n) * r),
                "m"
            ].join(" ")), t._lastPoint = {
                x: e,
                y: n
            };
        }, E.internal.line2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2, a = {
                x: e,
                y: n
            };
            this.pdf.internal.out([
                o(a.x * r),
                o((i - a.y) * r),
                "l"
            ].join(" ")), t._lastPoint = a;
        }, E.internal.createArc = function(t, e, n, r) {
            var i = 2 * Math.PI, o = Math.PI / 2, a = e;
            for((a < i || i < a) && (a %= i), a < 0 && (a = i + a); n < e;)e -= i;
            var s = Math.abs(n - e);
            s < i && r && (s = i - s);
            for(var h = [], c = r ? -1 : 1, l = a; 1e-5 < s;){
                var u = l + c * Math.min(s, o);
                h.push(this.createSmallArc(t, l, u)), s -= Math.abs(u - l), l = u;
            }
            return h;
        }, E.internal.getCurrentPage = function() {
            return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber];
        }, E.internal.createSmallArc = function(t, e, n) {
            var r = (n - e) / 2, i = t * Math.cos(r), o = t * Math.sin(r), a = i, s = -o, h = a * a + s * s, c = h + a * i + s * o, l = 4 / 3 * (Math.sqrt(2 * h * c) - c) / (a * o - s * i), u = a - l * s, f = s + l * a, d = u, p = -f, g = r + e, m = Math.cos(g), w = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: u * m - f * w,
                y2: u * w + f * m,
                x3: d * m - p * w,
                y3: d * w + p * m,
                x4: t * Math.cos(n),
                y4: t * Math.sin(n)
            };
        };
    }($.API, "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */ function(t) {
        var T, F, i, a, s, h, c, l, P, v, f, u, d, n, E, q, p, g, m, O;
        T = function() {
            var e = function e() {};
            return function(t) {
                return e.prototype = t, new e;
            };
        }(), v = function v(t) {
            var e, n, r, i, o, a, s;
            for(n = 0, r = t.length, e = void 0, a = i = !1; !i && n !== r;)(e = t[n] = t[n].trimLeft()) && (i = !0), n++;
            for(n = r - 1; r && !a && -1 !== n;)(e = t[n] = t[n].trimRight()) && (a = !0), n--;
            for(o = /\s+$/g, s = !0, n = 0; n !== r;)"\u2028" != t[n] && (e = t[n].replace(/\s+/g, " "), s && (e = e.trimLeft()), e && (s = o.test(e)), t[n] = e), n++;
            return t;
        }, u = function u(t) {
            var e, n, r;
            for(e = void 0, n = (r = t.split(",")).shift(); !e && n;)e = i[n.trim().toLowerCase()], n = r.shift();
            return e;
        }, d = function d(t) {
            var e;
            return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = n[t]) ? e : void 0 !== (e = ({
                "xx-small": 9,
                "x-small": 11,
                small: 13,
                medium: 16,
                large: 19,
                "x-large": 23,
                "xx-large": 28,
                auto: 0
            })[t]) ? n[t] = e / 16 : (e = parseFloat(t)) ? n[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? n[t] = parseFloat(e[1]) / 16 : n[t] = 1);
        }, P = function P(t) {
            var e, n, r, i, o;
            return o = t, i = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(o, null) : o.currentStyle ? o.currentStyle : o.style, n = void 0, (e = {})["font-family"] = u((r = function r(t) {
                return t = t.replace(/-\D/g, function(t) {
                    return t.charAt(1).toUpperCase();
                }), i[t];
            })("font-family")) || "times", e["font-style"] = a[r("font-style")] || "normal", e["text-align"] = s[r("text-align")] || "left", "bold" === (n = h[r("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = n : e["font-style"] = n + e["font-style"]), e["font-size"] = d(r("font-size")) || 1, e["line-height"] = d(r("line-height")) || 1, e.display = "inline" === r("display") ? "inline" : "block", n = "block" === e.display, e["margin-top"] = n && d(r("margin-top")) || 0, e["margin-bottom"] = n && d(r("margin-bottom")) || 0, e["padding-top"] = n && d(r("padding-top")) || 0, e["padding-bottom"] = n && d(r("padding-bottom")) || 0, e["margin-left"] = n && d(r("margin-left")) || 0, e["margin-right"] = n && d(r("margin-right")) || 0, e["padding-left"] = n && d(r("padding-left")) || 0, e["padding-right"] = n && d(r("padding-right")) || 0, e["page-break-before"] = r("page-break-before") || "auto", e.float = c[r("cssFloat")] || "none", e.clear = l[r("clear")] || "none", e.color = r("color"), e;
        }, E = function E(t, e, n) {
            var r, i, o, a, s;
            if (o = !1, a = i = void 0, r = n["#" + t.id]) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            if (r = n[t.nodeName], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            for(s = "string" == typeof t.className ? t.className.split(" ") : [], i = 0; i < s.length; i++)if (r = n["." + s[i]], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            return o;
        }, O = function O(t, e) {
            var n, r, i, o, a, s, h, c, l;
            for(n = [], r = [], i = 0, l = t.rows[0].cells.length, h = t.clientWidth; i < l;)c = t.rows[0].cells[i], r[i] = {
                name: c.textContent.toLowerCase().replace(/\s+/g, ""),
                prompt: c.textContent.replace(/\r?\n/g, ""),
                width: c.clientWidth / h * e.pdf.internal.pageSize.getWidth()
            }, i++;
            for(i = 1; i < t.rows.length;){
                for(s = t.rows[i], a = {}, o = 0; o < s.cells.length;)a[r[o].name] = s.cells[o].textContent.replace(/\r?\n/g, ""), o++;
                n.push(a), i++;
            }
            return {
                rows: n,
                headers: r
            };
        };
        var B = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
        }, R = 1;
        F = function(t, i, e) {
            var n, r, o, a, s, h, c, l;
            for(r = t.childNodes, n = void 0, (s = "block" === (o = P(t)).display) && (i.setBlockBoundary(), i.setBlockStyle(o)), a = 0, h = r.length; a < h;){
                if ("object" === (void 0 === (n = r[a]) ? "undefined" : vt(n))) {
                    if (i.executeWatchFunctions(n), 1 === n.nodeType && "HEADER" === n.nodeName) {
                        var u = n, f = i.pdf.margins_doc.top;
                        i.pdf.internal.events.subscribe("addPage", function(t) {
                            i.y = f, F(u, i, e), i.pdf.margins_doc.top = i.y + 10, i.y += 10;
                        }, !1);
                    }
                    if (8 === n.nodeType && "#comment" === n.nodeName) ~n.textContent.indexOf("ADD_PAGE") && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top);
                    else if (1 !== n.nodeType || B[n.nodeName]) {
                        if (3 === n.nodeType) {
                            var d = n.nodeValue;
                            if (n.nodeValue && "LI" === n.parentNode.nodeName) {
                                if ("OL" === n.parentNode.parentNode.nodeName) d = R++ + ". " + d;
                                else {
                                    var p = o["font-size"], g = (3 - .75 * p) * i.pdf.internal.scaleFactor, m = .75 * p * i.pdf.internal.scaleFactor, w = 1.74 * p / i.pdf.internal.scaleFactor;
                                    l = function l(t, e) {
                                        this.pdf.circle(t + g, e + m, w, "FD");
                                    };
                                }
                            }
                            16 & n.ownerDocument.body.compareDocumentPosition(n) && i.addText(d, o);
                        } else "string" == typeof n && i.addText(n, o);
                    } else {
                        var y;
                        if ("IMG" === n.nodeName) {
                            var v = n.getAttribute("src");
                            y = q[i.pdf.sHashCode(v) || v];
                        }
                        if (y) {
                            i.pdf.internal.pageSize.getHeight() - i.pdf.margins_doc.bottom < i.y + n.height && i.y > i.pdf.margins_doc.top && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top, i.executeWatchFunctions(n));
                            var b = P(n), x = i.x, S = 12 / i.pdf.internal.scaleFactor, k = (b["margin-left"] + b["padding-left"]) * S, _ = (b["margin-right"] + b["padding-right"]) * S, A = (b["margin-top"] + b["padding-top"]) * S, I = (b["margin-bottom"] + b["padding-bottom"]) * S;
                            void 0 !== b.float && "right" === b.float ? x += i.settings.width - n.width - _ : x += k, i.pdf.addImage(y, x, i.y + A, n.width, n.height), y = void 0, "right" === b.float || "left" === b.float ? (i.watchFunctions.push((function(t, e, n, r) {
                                return i.y >= e ? (i.x += t, i.settings.width += n, !0) : !!(r && 1 === r.nodeType && !B[r.nodeName] && i.x + r.width > i.pdf.margins_doc.left + i.pdf.margins_doc.width) && (i.x += t, i.y = e, i.settings.width += n, !0);
                            }).bind(this, "left" === b.float ? -n.width - k - _ : 0, i.y + n.height + A + I, n.width)), i.watchFunctions.push((function(t, e, n) {
                                return !(i.y < t && e === i.pdf.internal.getNumberOfPages()) || 1 === n.nodeType && "both" === P(n).clear && (i.y = t, !0);
                            }).bind(this, i.y + n.height, i.pdf.internal.getNumberOfPages())), i.settings.width -= n.width + k + _, "left" === b.float && (i.x += n.width + k + _)) : i.y += n.height + A + I;
                        } else if ("TABLE" === n.nodeName) c = O(n, i), i.y += 10, i.pdf.table(i.x, i.y, c.rows, c.headers, {
                            autoSize: !1,
                            printHeaders: e.printHeaders,
                            margins: i.pdf.margins_doc,
                            css: P(n)
                        }), i.y = i.pdf.lastCellPos.y + i.pdf.lastCellPos.h + 20;
                        else if ("OL" === n.nodeName || "UL" === n.nodeName) R = 1, E(n, i, e) || F(n, i, e), i.y += 10;
                        else if ("LI" === n.nodeName) {
                            var C = i.x;
                            i.x += 20 / i.pdf.internal.scaleFactor, i.y += 3, E(n, i, e) || F(n, i, e), i.x = C;
                        } else "BR" === n.nodeName ? (i.y += o["font-size"] * i.pdf.internal.scaleFactor, i.addText("\u2028", T(o))) : E(n, i, e) || F(n, i, e);
                    }
                }
                a++;
            }
            if (e.outY = i.y, s) return i.setBlockBoundary(l);
        }, q = {}, p = function p(t, o, e, n) {
            var h = function h() {
                o.pdf.internal.events.publish("imagesLoaded"), n(a);
            };
            var c = function c(e, n, r) {
                if (e) {
                    var i = new Image;
                    a = ++s, i.crossOrigin = "", i.onerror = i.onload = function() {
                        if (i.complete && (0 === i.src.indexOf("data:image/") && (i.width = n || i.width || 0, i.height = r || i.height || 0), i.width + i.height)) {
                            var _$t = o.pdf.sHashCode(e) || e;
                            q[_$t] = q[_$t] || i;
                        }
                        --s || h();
                    }, i.src = e;
                }
            };
            var a, r = t.getElementsByTagName("img"), i = r.length, s = 0;
            for(; i--;)c(r[i].getAttribute("src"), r[i].width, r[i].height);
            return s || h();
        }, g = function g(t, o, a) {
            var s = t.getElementsByTagName("footer");
            if (0 < s.length) {
                s = s[0];
                var e = o.pdf.internal.write, n = o.y;
                o.pdf.internal.write = function() {}, F(s, o, a);
                var h = Math.ceil(o.y - n) + 5;
                o.y = n, o.pdf.internal.write = e, o.pdf.margins_doc.bottom += h;
                for(var r = function r(t) {
                    var e = void 0 !== t ? t.pageNumber : 1, n = o.y;
                    o.y = o.pdf.internal.pageSize.getHeight() - o.pdf.margins_doc.bottom, o.pdf.margins_doc.bottom -= h;
                    for(var r = s.getElementsByTagName("span"), i = 0; i < r.length; ++i)-1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (r[i].innerHTML = e), -1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (r[i].innerHTML = "###jsPDFVarTotalPages###");
                    F(s, o, a), o.pdf.margins_doc.bottom += h, o.y = n;
                }, i = s.getElementsByTagName("span"), c = 0; c < i.length; ++c)-1 < (" " + i[c].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && o.pdf.internal.events.subscribe("htmlRenderingFinished", o.pdf.putTotalPages.bind(o.pdf, "###jsPDFVarTotalPages###"), !0);
                o.pdf.internal.events.subscribe("addPage", r, !1), r(), B.FOOTER = 1;
            }
        }, m = function m(t, e, n, r, i, o) {
            if (!e) return !1;
            var a, s, h, c;
            "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (a = e.replace(/<\/?script[^>]*?>/gi, ""), c = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (h = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", h.innerHTML = '<iframe style="height:1px;width:1px" name="' + c + '" />', document.body.appendChild(h), (s = window.frames[c]).document.open(), s.document.writeln(a), s.document.close(), e = s.document.body);
            var l, u = new f(t, n, r, i);
            return p.call(this, e, u, i.elementHandlers, function(t) {
                g(e, u, i.elementHandlers), F(e, u, i.elementHandlers), u.pdf.internal.events.publish("htmlRenderingFinished"), l = u.dispose(), "function" == typeof o ? o(l) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
            }), l || {
                x: u.x,
                y: u.y
            };
        }, (f = function f(t, e, n, r) {
            return this.pdf = t, this.x = e, this.y = n, this.settings = r, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function() {
            return this.paragraph = {
                text: [],
                style: []
            }, this.pdf.internal.write("q");
        }, f.prototype.dispose = function() {
            return this.pdf.internal.write("Q"), {
                x: this.x,
                y: this.y,
                ready: !0
            };
        }, f.prototype.executeWatchFunctions = function(t) {
            var e = !1, n = [];
            if (0 < this.watchFunctions.length) {
                for(var r = 0; r < this.watchFunctions.length; ++r)!0 === this.watchFunctions[r](t) ? e = !0 : n.push(this.watchFunctions[r]);
                this.watchFunctions = n;
            }
            return e;
        }, f.prototype.splitFragmentsIntoLines = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f, d, p, g;
            for(u = this.pdf.internal.scaleFactor, o = {}, s = h = c = g = a = i = l = r = void 0, d = [
                f = []
            ], n = 0, p = this.settings.width; t.length;)if (a = t.shift(), g = e.shift(), a) {
                if ((i = o[(r = g["font-family"]) + (l = g["font-style"])]) || (i = this.pdf.internal.getFont(r, l).metadata.Unicode, o[r + l] = i), c = {
                    widths: i.widths,
                    kerning: i.kerning,
                    fontSize: 12 * g["font-size"],
                    textIndent: n
                }, h = this.pdf.getStringUnitWidth(a, c) * c.fontSize / u, "\u2028" == a) f = [], d.push(f);
                else if (p < n + h) {
                    for(s = this.pdf.splitTextToSize(a, p, c), f.push([
                        s.shift(),
                        g
                    ]); s.length;)f = [
                        [
                            s.shift(),
                            g
                        ]
                    ], d.push(f);
                    n = this.pdf.getStringUnitWidth(f[0][0], c) * c.fontSize / u;
                } else f.push([
                    a,
                    g
                ]), n += h;
            }
            if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for(var m = 0; m < d.length; ++m){
                var w = this.pdf.getStringUnitWidth(d[m][0][0], c) * c.fontSize / u;
                0 < m && (d[m][0][1] = T(d[m][0][1]));
                var y = p - w;
                if ("right" === g["text-align"]) d[m][0][1]["margin-left"] = y;
                else if ("center" === g["text-align"]) d[m][0][1]["margin-left"] = y / 2;
                else if ("justify" === g["text-align"]) {
                    var v = d[m][0][0].split(" ").length - 1;
                    d[m][0][1]["word-spacing"] = y / v, m === d.length - 1 && (d[m][0][1]["word-spacing"] = 0);
                }
            }
            return d;
        }, f.prototype.RenderTextFragment = function(t, e) {
            var n, r;
            r = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), r = Math.max(r, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * r).toFixed(2), "Td")), n = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
            var i = this.getPdfColor(e.color);
            i !== this.lastTextColor && (this.pdf.internal.write(i), this.lastTextColor = i), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + n.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, f.prototype.getPdfColor = function(t) {
            var e, n, r, i = new RGBColor(t), o = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
            if (null != o ? (e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3])) : ("#" != t.charAt(0) && (t = i.ok ? i.toHex() : "#000000"), e = t.substring(1, 3), e = parseInt(e, 16), n = t.substring(3, 5), n = parseInt(n, 16), r = t.substring(5, 7), r = parseInt(r, 16)), "string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
                var a = parseInt(e.substr(1), 16);
                e = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a;
            }
            var s = this.f3;
            return 0 === e && 0 === n && 0 === r || void 0 === n ? s(e / 255) + " g" : [
                s(e / 255),
                s(n / 255),
                s(r / 255),
                "rg"
            ].join(" ");
        }, f.prototype.f3 = function(t) {
            return t.toFixed(3);
        }, f.prototype.renderParagraph = function(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d;
            if (r = v(this.paragraph.text), f = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
                text: [],
                style: [],
                blockstyle: {},
                priorblockstyle: e
            }, r.join("").trim()) {
                s = this.splitFragmentsIntoLines(r, f), h = a = void 0, n = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, u = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * n, l = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * n, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, u = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * n), c = this.pdf.internal.write, o = i = void 0, this.y += u, c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                for(var p = 0; s.length;){
                    for(i = h = 0, o = (a = s.shift()).length; i !== o;)a[i][0].trim() && (h = Math.max(h, a[i][1]["line-height"], a[i][1]["font-size"]), d = 7 * a[i][1]["font-size"]), i++;
                    var g = 0, m = 0;
                    for(void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (m = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - p, p = m), c(g + Math.max(e["margin-left"] || 0, 0) * n, (-12 * h).toFixed(2), "Td"), i = 0, o = a.length; i !== o;)a[i][0] && this.RenderTextFragment(a[i][0], a[i][1]), i++;
                    if (this.y += h * n, this.executeWatchFunctions(a[0][1]) && 0 < s.length) {
                        var w = [], y = [];
                        s.forEach(function(t) {
                            for(var e = 0, n = t.length; e !== n;)t[e][0] && (w.push(t[e][0] + " "), y.push(t[e][1])), ++e;
                        }), s = this.splitFragmentsIntoLines(v(w), y), c("ET", "Q"), c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                    }
                }
                return t && "function" == typeof t && t.call(this, this.x - 9, this.y - d / 2), c("ET", "Q"), this.y += l;
            }
        }, f.prototype.setBlockBoundary = function(t) {
            return this.renderParagraph(t);
        }, f.prototype.setBlockStyle = function(t) {
            return this.paragraph.blockstyle = t;
        }, f.prototype.addText = function(t, e) {
            return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, i = {
            helvetica: "helvetica",
            "sans-serif": "helvetica",
            "times new roman": "times",
            serif: "times",
            times: "times",
            monospace: "courier",
            courier: "courier"
        }, h = {
            100: "normal",
            200: "normal",
            300: "normal",
            400: "normal",
            500: "bold",
            600: "bold",
            700: "bold",
            800: "bold",
            900: "bold",
            normal: "normal",
            bold: "bold",
            bolder: "bold",
            lighter: "normal"
        }, a = {
            normal: "normal",
            italic: "italic",
            oblique: "italic"
        }, s = {
            left: "left",
            right: "right",
            center: "center",
            justify: "justify"
        }, c = {
            none: "none",
            right: "right",
            left: "left"
        }, l = {
            none: "none",
            both: "both"
        }, n = {
            normal: 1
        }, t.fromHTML = function(t, e, n, r, i, o) {
            return this.margins_doc = o || {
                top: 0,
                bottom: 0
            }, r || (r = {}), r.elementHandlers || (r.elementHandlers = {}), m(this, t, isNaN(e) ? 4 : e, isNaN(n) ? 4 : n, r, i);
        };
    }($.API), $.API.addJS = function(t) {
        return s = t, this.internal.events.subscribe("postPutResources", function(t) {
            n = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (n + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + s + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
            void 0 !== n && void 0 !== r && this.internal.out("/Names <</JavaScript " + n + " 0 R>>");
        }), this;
    }, /**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (c = $.API).events.push([
        "postPutResources",
        function() {
            var t = this, e = /^(\d+) 0 obj$/;
            if (0 < this.outline.root.children.length) for(var n = t.outline.render().split(/\r\n/), r = 0; r < n.length; r++){
                var i = n[r], o = e.exec(i);
                if (null != o) {
                    var a = o[1];
                    t.internal.newObjectDeferredBegin(a);
                }
                t.internal.write(i);
            }
            if (this.outline.createNamedDestinations) {
                var s = this.internal.pages.length, h = [];
                for(r = 0; r < s; r++){
                    var c = t.internal.newObject();
                    h.push(c);
                    var l = t.internal.getPageInfo(r + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var u = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), r = 0; r < h.length; r++)t.internal.write("(page_" + (r + 1) + ")" + h[r] + " 0 R");
                t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + u + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), c.events.push([
        "putCatalog",
        function() {
            0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
        }
    ]), c.events.push([
        "initialized",
        function() {
            var o = this;
            o.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, o.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, o.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = o, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, o.outline.genIds_r = function(t) {
                t.id = o.internal.newObjectDeferred();
                for(var e = 0; e < t.children.length; e++)this.genIds_r(t.children[e]);
            }, o.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, o.outline.renderItems = function(t) {
                for(var e = 0; e < t.children.length; e++){
                    var n = t.children[e];
                    this.objStart(n), this.line("/Title " + this.makeString(n.title)), this.line("/Parent " + this.makeRef(t)), 0 < e && this.line("/Prev " + this.makeRef(t.children[e - 1])), e < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[e + 1])), 0 < n.children.length && (this.line("/First " + this.makeRef(n.children[0])), this.line("/Last " + this.makeRef(n.children[n.children.length - 1])));
                    var r = this.count = this.count_r({
                        count: 0
                    }, n);
                    if (0 < r && this.line("/Count " + r), n.options && n.options.pageNumber) {
                        var i = o.internal.getPageInfo(n.options.pageNumber);
                        this.line("/Dest [" + i.objId + " 0 R /XYZ 0 " + this.ctx.pdf.internal.pageSize.getHeight() * this.ctx.pdf.internal.scaleFactor + " 0]");
                    }
                    this.objEnd();
                }
                for(e = 0; e < t.children.length; e++)n = t.children[e], this.renderItems(n);
            }, o.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, o.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, o.outline.makeString = function(t) {
                return "(" + o.internal.pdfEscape(t) + ")";
            }, o.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, o.outline.objEnd = function(t) {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, o.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]), /**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */ P = $.API, E = function E() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
    }, q = function q(t, e, n, r) {
        var i = 5, o = b;
        switch(r){
            case P.image_compression.FAST:
                i = 3, o = v;
                break;
            case P.image_compression.MEDIUM:
                i = 6, o = x;
                break;
            case P.image_compression.SLOW:
                i = 9, o = S;
        }
        t = w(t, e, n, o);
        var a = new Uint8Array(g(i)), s = m(t), h = new Deflater(i), c = h.append(t), l = h.flush(), u = a.length + c.length + l.length, f = new Uint8Array(u + 4);
        return f.set(a), f.set(c, a.length), f.set(l, a.length + c.length), f[u++] = s >>> 24 & 255, f[u++] = s >>> 16 & 255, f[u++] = s >>> 8 & 255, f[u++] = 255 & s, P.arrayBufferToBinaryString(f);
    }, g = function g(t, e) {
        var n = Math.LOG2E * Math.log(32768) - 8 << 4 | 8, r = n << 8;
        return r |= Math.min(3, (e - 1 & 255) >> 1) << 6, r |= 0, [
            n,
            255 & (r += 31 - r % 31)
        ];
    }, m = function m(t, e) {
        for(var n, r = 1, i = 0, o = t.length, a = 0; 0 < o;){
            for(o -= n = e < o ? e : o; i += r += t[a++], --n;);
            r %= 65521, i %= 65521;
        }
        return (i << 16 | r) >>> 0;
    }, w = function w(t, e, n, r) {
        for(var i, o, a, s = t.length / e, h = new Uint8Array(t.length + s), c = k(), l = 0; l < s; l++){
            if (a = l * e, i = t.subarray(a, a + e), r) h.set(r(i, n, o), a + l);
            else {
                for(var u = 0, f = c.length, d = []; u < f; u++)d[u] = c[u](i, n, o);
                var p = _(d.concat());
                h.set(d[p], a + l);
            }
            o = i;
        }
        return h;
    }, l = function l(t, e, n) {
        var r = Array.apply([], t);
        return r.unshift(0), r;
    }, v = function v(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 1; o < a; o++)r = t[o - e] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, b = function b(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 2; o < a; o++)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, x = function x(t, e, n) {
        var r, i, o = [], a = 0, s = t.length;
        for(o[0] = 3; a < s; a++)r = t[a - e] || 0, i = n && n[a] || 0, o[a + 1] = t[a] + 256 - (r + i >>> 1) & 255;
        return o;
    }, S = function S(t, e, n) {
        var r, i, o, a, s = [], h = 0, c = t.length;
        for(s[0] = 4; h < c; h++)r = t[h - e] || 0, i = n && n[h] || 0, o = n && n[h - e] || 0, a = u(r, i, o), s[h + 1] = t[h] - a + 256 & 255;
        return s;
    }, u = function u(t, e, n) {
        var r = t + e - n, i = Math.abs(r - t), o = Math.abs(r - e), a = Math.abs(r - n);
        return i <= o && i <= a ? t : o <= a ? e : n;
    }, k = function k() {
        return [
            l,
            v,
            b,
            x,
            S
        ];
    }, _ = function _(t) {
        for(var e, n, r, i = 0, o = t.length; i < o;)((e = f(t[i].slice(1))) < n || !n) && (n = e, r = i), i++;
        return r;
    }, f = function f(t) {
        for(var e = 0, n = t.length, r = 0; e < n;)r += Math.abs(t[e++]);
        return r;
    }, P.processPNG = function(t, e, n, r, i) {
        var o, a, s, h, c, l, u = this.color_spaces.DEVICE_RGB, f = this.decode.FLATE_DECODE, d = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
            if ("function" != typeof PNG || "function" != typeof kt) throw new Error("PNG support requires png.js and zlib.js");
            if (t = (o = new PNG(t)).imgData, d = o.bits, u = o.colorSpace, h = o.colors, -1 !== [
                4,
                6
            ].indexOf(o.colorType)) {
                if (8 === o.bits) for(var p, g = (I = 32 == o.pixelBitlength ? new Uint32Array(o.decodePixels().buffer) : 16 == o.pixelBitlength ? new Uint16Array(o.decodePixels().buffer) : new Uint8Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * o.colors), w = new Uint8Array(g), y = o.pixelBitlength - o.bits, v = 0, b = 0; v < g; v++){
                    for(x = I[v], p = 0; p < y;)m[b++] = x >>> p & 255, p += o.bits;
                    w[v] = x >>> p & 255;
                }
                if (16 === o.bits) {
                    g = (I = new Uint32Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * (32 / o.pixelBitlength) * o.colors), w = new Uint8Array(g * (32 / o.pixelBitlength));
                    for(var x, S = 1 < o.colors, k = b = v = 0; v < g;)x = I[v++], m[b++] = x >>> 0 & 255, S && (m[b++] = x >>> 16 & 255, x = I[v++], m[b++] = x >>> 0 & 255), w[k++] = x >>> 16 & 255;
                    d = 8;
                }
                r !== P.image_compression.NONE && E() ? (t = q(m, o.width * o.colors, o.colors, r), l = q(w, o.width, 1, r)) : (t = m, l = w, f = null);
            }
            if (3 === o.colorType && (u = this.color_spaces.INDEXED, c = o.palette, o.transparency.indexed)) {
                var _ = o.transparency.indexed, A = 0;
                for(v = 0, g = _.length; v < g; ++v)A += _[v];
                if ((A /= 255) == g - 1 && -1 !== _.indexOf(0)) s = [
                    _.indexOf(0)
                ];
                else if (A !== g) {
                    var I = o.decodePixels();
                    for(w = new Uint8Array(I.length), v = 0, g = I.length; v < g; v++)w[v] = _[I[v]];
                    l = q(w, o.width, 1);
                }
            }
            var C = function(t) {
                var _$e;
                switch(t){
                    case P.image_compression.FAST:
                        _$e = 11;
                        break;
                    case P.image_compression.MEDIUM:
                        _$e = 13;
                        break;
                    case P.image_compression.SLOW:
                        _$e = 14;
                        break;
                    default:
                        _$e = 12;
                }
                return _$e;
            }(r);
            return a = f === this.decode.FLATE_DECODE ? "/Predictor " + C + " /Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width : "/Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (l && this.isArrayBuffer(l) || this.isArrayBufferView(l)) && (l = this.arrayBufferToBinaryString(l)), this.createImageInfo(t, o.width, o.height, u, d, f, e, n, a, s, c, l, C);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
    }, /**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (A = $.API).processGIF89A = function(t, e, n, r, i) {
        var o = new mt(t), a = o.width, s = o.height, h = [];
        o.decodeAndBlitFrameRGBA(0, h);
        var c = {
            data: h,
            width: a,
            height: s
        }, l = new yt(100).encode(c, 100);
        return A.processJPEG.call(this, l, e, n, r);
    }, A.processGIF87A = A.processGIF89A, /**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (O = $.API).processBMP = function(t, e, n, r, i) {
        var o = new xt(t, !1), a = o.width, s = o.height, h = {
            data: o.getData(),
            width: a,
            height: s
        }, c = new yt(100).encode(h, 100);
        return O.processJPEG.call(this, c, e, n, r);
    }, $.API.setLanguage = function(t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
            af: "Afrikaans",
            sq: "Albanian",
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            an: "Aragonese",
            hy: "Armenian",
            as: "Assamese",
            ast: "Asturian",
            az: "Azerbaijani",
            eu: "Basque",
            be: "Belarusian",
            bn: "Bengali",
            bs: "Bosnian",
            br: "Breton",
            bg: "Bulgarian",
            my: "Burmese",
            ca: "Catalan",
            ch: "Chamorro",
            ce: "Chechen",
            zh: "Chinese",
            "zh-HK": "Chinese (Hong Kong)",
            "zh-CN": "Chinese (PRC)",
            "zh-SG": "Chinese (Singapore)",
            "zh-TW": "Chinese (Taiwan)",
            cv: "Chuvash",
            co: "Corsican",
            cr: "Cree",
            hr: "Croatian",
            cs: "Czech",
            da: "Danish",
            nl: "Dutch (Standard)",
            "nl-BE": "Dutch (Belgian)",
            en: "English",
            "en-AU": "English (Australia)",
            "en-BZ": "English (Belize)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-JM": "English (Jamaica)",
            "en-NZ": "English (New Zealand)",
            "en-PH": "English (Philippines)",
            "en-ZA": "English (South Africa)",
            "en-TT": "English (Trinidad & Tobago)",
            "en-GB": "English (United Kingdom)",
            "en-US": "English (United States)",
            "en-ZW": "English (Zimbabwe)",
            eo: "Esperanto",
            et: "Estonian",
            fo: "Faeroese",
            fj: "Fijian",
            fi: "Finnish",
            fr: "French (Standard)",
            "fr-BE": "French (Belgium)",
            "fr-CA": "French (Canada)",
            "fr-FR": "French (France)",
            "fr-LU": "French (Luxembourg)",
            "fr-MC": "French (Monaco)",
            "fr-CH": "French (Switzerland)",
            fy: "Frisian",
            fur: "Friulian",
            gd: "Gaelic (Scots)",
            "gd-IE": "Gaelic (Irish)",
            gl: "Galacian",
            ka: "Georgian",
            de: "German (Standard)",
            "de-AT": "German (Austria)",
            "de-DE": "German (Germany)",
            "de-LI": "German (Liechtenstein)",
            "de-LU": "German (Luxembourg)",
            "de-CH": "German (Switzerland)",
            el: "Greek",
            gu: "Gujurati",
            ht: "Haitian",
            he: "Hebrew",
            hi: "Hindi",
            hu: "Hungarian",
            is: "Icelandic",
            id: "Indonesian",
            iu: "Inuktitut",
            ga: "Irish",
            it: "Italian (Standard)",
            "it-CH": "Italian (Switzerland)",
            ja: "Japanese",
            kn: "Kannada",
            ks: "Kashmiri",
            kk: "Kazakh",
            km: "Khmer",
            ky: "Kirghiz",
            tlh: "Klingon",
            ko: "Korean",
            "ko-KP": "Korean (North Korea)",
            "ko-KR": "Korean (South Korea)",
            la: "Latin",
            lv: "Latvian",
            lt: "Lithuanian",
            lb: "Luxembourgish",
            mk: "FYRO Macedonian",
            ms: "Malay",
            ml: "Malayalam",
            mt: "Maltese",
            mi: "Maori",
            mr: "Marathi",
            mo: "Moldavian",
            nv: "Navajo",
            ng: "Ndonga",
            ne: "Nepali",
            no: "Norwegian",
            nb: "Norwegian (Bokmal)",
            nn: "Norwegian (Nynorsk)",
            oc: "Occitan",
            or: "Oriya",
            om: "Oromo",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            pl: "Polish",
            pt: "Portuguese",
            "pt-BR": "Portuguese (Brazil)",
            pa: "Punjabi",
            "pa-IN": "Punjabi (India)",
            "pa-PK": "Punjabi (Pakistan)",
            qu: "Quechua",
            rm: "Rhaeto-Romanic",
            ro: "Romanian",
            "ro-MO": "Romanian (Moldavia)",
            ru: "Russian",
            "ru-MO": "Russian (Moldavia)",
            sz: "Sami (Lappish)",
            sg: "Sango",
            sa: "Sanskrit",
            sc: "Sardinian",
            sd: "Sindhi",
            si: "Singhalese",
            sr: "Serbian",
            sk: "Slovak",
            sl: "Slovenian",
            so: "Somani",
            sb: "Sorbian",
            es: "Spanish",
            "es-AR": "Spanish (Argentina)",
            "es-BO": "Spanish (Bolivia)",
            "es-CL": "Spanish (Chile)",
            "es-CO": "Spanish (Colombia)",
            "es-CR": "Spanish (Costa Rica)",
            "es-DO": "Spanish (Dominican Republic)",
            "es-EC": "Spanish (Ecuador)",
            "es-SV": "Spanish (El Salvador)",
            "es-GT": "Spanish (Guatemala)",
            "es-HN": "Spanish (Honduras)",
            "es-MX": "Spanish (Mexico)",
            "es-NI": "Spanish (Nicaragua)",
            "es-PA": "Spanish (Panama)",
            "es-PY": "Spanish (Paraguay)",
            "es-PE": "Spanish (Peru)",
            "es-PR": "Spanish (Puerto Rico)",
            "es-ES": "Spanish (Spain)",
            "es-UY": "Spanish (Uruguay)",
            "es-VE": "Spanish (Venezuela)",
            sx: "Sutu",
            sw: "Swahili",
            sv: "Swedish",
            "sv-FI": "Swedish (Finland)",
            "sv-SV": "Swedish (Sweden)",
            ta: "Tamil",
            tt: "Tatar",
            te: "Teluga",
            th: "Thai",
            tig: "Tigre",
            ts: "Tsonga",
            tn: "Tswana",
            tr: "Turkish",
            tk: "Turkmen",
            uk: "Ukrainian",
            hsb: "Upper Sorbian",
            ur: "Urdu",
            ve: "Venda",
            vi: "Vietnamese",
            vo: "Volapuk",
            wa: "Walloon",
            cy: "Welsh",
            xh: "Xhosa",
            ji: "Yiddish",
            zu: "Zulu"
        })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
    }, /** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */ B = $.API, R = B.getCharWidthsArray = function R(t, e) {
        var n, r, i, o = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), h = e.widths ? e.widths : o.metadata.Unicode.widths, c = h.fof ? h.fof : 1, l = e.kerning ? e.kerning : o.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, f = 0, d = h[0] || c, p = [];
        for(n = 0, r = t.length; n < r; n++)i = t.charCodeAt(n), "function" == typeof o.metadata.widthOfString ? p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i)) + s * (1e3 / a) || 0) / 1e3) : p.push((h[i] || d) / c + (l[i] && l[i][f] || 0) / u), f = i;
        return p;
    }, j = B.getArraySum = function j(t) {
        for(var e = t.length, n = 0; e;)n += t[--e];
        return n;
    }, D = B.getStringUnitWidth = function D(t, e) {
        var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : j(R.apply(this, arguments));
    }, M = function M(t, e, n, r) {
        for(var i = [], o = 0, a = t.length, s = 0; o !== a && s + e[o] < n;)s += e[o], o++;
        i.push(t.slice(0, o));
        var h = o;
        for(s = 0; o !== a;)s + e[o] > r && (i.push(t.slice(h, o)), s = 0, h = o), s += e[o], o++;
        return h !== o && i.push(t.slice(h, o)), i;
    }, U = function U(t, e, n) {
        n || (n = {});
        var r, i, o, a, s, h, c = [], l = [
            c
        ], u = n.textIndent || 0, f = 0, d = 0, p = t.split(" "), g = R.apply(this, [
            " ",
            n
        ])[0];
        if (h = -1 === n.lineIndent ? p[0].length + 2 : n.lineIndent || 0) {
            var m = Array(h).join(" "), w = [];
            p.map(function(t) {
                1 < (t = t.split(/\s*\n/)).length ? w = w.concat(t.map(function(t, e) {
                    return (e && t.length ? "\n" : "") + t;
                })) : w.push(t[0]);
            }), p = w, h = D.apply(this, [
                m,
                n
            ]);
        }
        for(o = 0, a = p.length; o < a; o++){
            var y = 0;
            if (r = p[o], h && "\n" == r[0] && (r = r.substr(1), y = 1), i = R.apply(this, [
                r,
                n
            ]), e < u + f + (d = j(i)) || y) {
                if (e < d) {
                    for(s = M.apply(this, [
                        r,
                        i,
                        e - (u + f),
                        e
                    ]), c.push(s.shift()), c = [
                        s.pop()
                    ]; s.length;)l.push([
                        s.shift()
                    ]);
                    d = j(i.slice(r.length - (c[0] ? c[0].length : 0)));
                } else c = [
                    r
                ];
                l.push(c), u = d + h, f = g;
            } else c.push(r), u += f + d, f = g;
        }
        if (h) var v = function v(t, e) {
            return (e ? m : "") + t.join(" ");
        };
        else v = function v(t) {
            return t.join(" ");
        };
        return l.map(v);
    }, B.splitTextToSize = function(t, e, n) {
        var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(t) {
            var _$e = {
                0: 1
            }, _$n = {};
            if (t.widths && t.kerning) return {
                widths: t.widths,
                kerning: t.kerning
            };
            var r = this.internal.getFont(t.fontName, t.fontStyle), i = "Unicode";
            return r.metadata[i] ? {
                widths: r.metadata[i].widths || _$e,
                kerning: r.metadata[i].kerning || _$n
            } : {
                font: r.metadata,
                fontSize: this.internal.getFontSize(),
                charSpace: this.internal.getCharSpace()
            };
        }).call(this, n);
        r = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / i;
        o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, o.lineIndent = n.lineIndent;
        var s, h, c = [];
        for(s = 0, h = r.length; s < h; s++)c = c.concat(U.apply(this, [
            r[s],
            a,
            o
        ]));
        return c;
    }, /** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */ N = $.API, L = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: (z = function z(t) {
            for(var e = "klmnopqrstuvwxyz", n = {}, r = 0; r < e.length; r++)n[e[r]] = "0123456789abcdef"[r];
            var i, o, a, s, h, c = {}, l = 1, u = c, f = [], d = "", p = "", g = t.length - 1;
            for(r = 1; r != g;)h = t[r], r += 1, "'" == h ? o ? (s = o.join(""), o = i) : o = [] : o ? o.push(h) : "{" == h ? (f.push([
                u,
                s
            ]), u = {}, s = i) : "}" == h ? ((a = f.pop())[0][a[1]] = u, s = i, u = a[0]) : "-" == h ? l = -1 : s === i ? n.hasOwnProperty(h) ? (d += n[h], s = parseInt(d, 16) * l, l = 1, d = "") : d += h : n.hasOwnProperty(h) ? (p += n[h], u[s] = parseInt(p, 16) * l, l = 1, s = i, p = "") : p += h;
            return c;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, H = {
        Unicode: {
            Courier: L,
            "Courier-Bold": L,
            "Courier-BoldOblique": L,
            "Courier-Oblique": L,
            Helvetica: L,
            "Helvetica-Bold": L,
            "Helvetica-BoldOblique": L,
            "Helvetica-Oblique": L,
            "Times-Roman": L,
            "Times-Bold": L,
            "Times-BoldItalic": L,
            "Times-Italic": L
        }
    }, W = {
        Unicode: {
            "Courier-Oblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    }, N.events.push([
        "addFont",
        function(t) {
            var e, n, r, i = "Unicode";
            (e = W[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).widths = e.widths, n.kerning = e.kerning), (r = H[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).encoding = r).codePages && r.codePages.length && (t.encoding = r.codePages[0]);
        }
    ]), G = $, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")(), G.API.events.push([
        "addFont",
        function(t) {
            G.API.existsFileInVFS(t.postScriptName) ? (t.metadata = G.API.TTFFont.open(t.postScriptName, t.fontName, G.API.getFileFromVFS(t.postScriptName), t.encoding), t.metadata.Unicode = t.metadata.Unicode || {
                encoding: {},
                kerning: {},
                widths: []
            }) : 14 < t.id.slice(1) && console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('" + t.postScriptName + "').");
        }
    ]), /** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */ (V = $.API).addSvg = function(t, e, n, r, i) {
        var o = function o(t) {
            for(var _$e = parseFloat(t[1]), _$n = parseFloat(t[2]), _$r = [], _$i = 3, o = t.length; _$i < o;)"c" === t[_$i] ? (_$r.push([
                parseFloat(t[_$i + 1]),
                parseFloat(t[_$i + 2]),
                parseFloat(t[_$i + 3]),
                parseFloat(t[_$i + 4]),
                parseFloat(t[_$i + 5]),
                parseFloat(t[_$i + 6])
            ]), _$i += 7) : "l" === t[_$i] ? (_$r.push([
                parseFloat(t[_$i + 1]),
                parseFloat(t[_$i + 2])
            ]), _$i += 3) : _$i += 1;
            return [
                _$e,
                _$n,
                _$r
            ];
        };
        if (void 0 === e || void 0 === n) throw new Error("addSVG needs values for 'x' and 'y'");
        var a, s, h, c, l, u, f, d, p = (c = document, d = c.createElement("iframe"), l = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (f = (u = c).createElement("style")).type = "text/css", f.styleSheet ? f.styleSheet.cssText = l : f.appendChild(u.createTextNode(l)), u.getElementsByTagName("head")[0].appendChild(f), d.name = "childframe", d.setAttribute("width", 0), d.setAttribute("height", 0), d.setAttribute("frameborder", "0"), d.setAttribute("scrolling", "no"), d.setAttribute("seamless", "seamless"), d.setAttribute("class", "jsPDF_sillysvg_iframe"), c.body.appendChild(d), d), g = (a = t, (h = ((s = p).contentWindow || s.contentDocument).document).write(a), h.close(), h.getElementsByTagName("svg")[0]), m = [
            1,
            1
        ], w = parseFloat(g.getAttribute("width")), y = parseFloat(g.getAttribute("height"));
        w && y && (r && i ? m = [
            r / w,
            i / y
        ] : r ? m = [
            r / w,
            r / w
        ] : i && (m = [
            i / y,
            i / y
        ]));
        var v, b, x, S, k = g.childNodes;
        for(v = 0, b = k.length; v < b; v++)(x = k[v]).tagName && "PATH" === x.tagName.toUpperCase() && ((S = o(x.getAttribute("d").split(" ")))[0] = S[0] * m[0] + e, S[1] = S[1] * m[1] + n, this.lines.call(this, S[2], S[0], S[1], m));
        return this;
    }, V.addSVG = V.addSvg, V.addSvgAsImage = function(t, e, n, r, i, o, a, s) {
        if (isNaN(e) || isNaN(n)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(r) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = r, h.height = i;
        var c = h.getContext("2d");
        return c.fillStyle = "#fff", c.fillRect(0, 0, h.width, h.height), canvg(h, t, {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0
        }), this.addImage(h.toDataURL("image/jpeg", 1), e, n, r, i, a, s), this;
    }, $.API.putTotalPages = function(t) {
        for(var e = new RegExp(t, "g"), n = 1; n <= this.internal.getNumberOfPages(); n++)for(var r = 0; r < this.internal.pages[n].length; r++)this.internal.pages[n][r] = this.internal.pages[n][r].replace(e, this.internal.getNumberOfPages());
        return this;
    }, $.API.viewerPreferences = function(t, e) {
        var f = function f(t, e) {
            var n, r = !1;
            for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
            return r;
        };
        var n;
        t = t || {}, e = e || !1;
        var r, i, o = {
            HideToolbar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideMenubar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideWindowUI: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            FitWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            CenterWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            DisplayDocTitle: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
                defaultValue: "UseNone",
                value: "UseNone",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "UseOC"
                ],
                pdfVersion: 1.3
            },
            Direction: {
                defaultValue: "L2R",
                value: "L2R",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "L2R",
                    "R2L"
                ],
                pdfVersion: 1.3
            },
            ViewArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            ViewClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintScaling: {
                defaultValue: "AppDefault",
                value: "AppDefault",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "AppDefault",
                    "None"
                ],
                pdfVersion: 1.6
            },
            Duplex: {
                defaultValue: "",
                value: "none",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "Simplex",
                    "DuplexFlipShortEdge",
                    "DuplexFlipLongEdge",
                    "none"
                ],
                pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.7
            },
            PrintPageRange: {
                defaultValue: "",
                value: "",
                type: "array",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            },
            NumCopies: {
                defaultValue: 1,
                value: 1,
                type: "integer",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            }
        }, a = Object.keys(o), s = [], h = 0, c = 0, l = 0, u = !0;
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
            var d = a.length;
            for(l = 0; l < d; l += 1)n[a[l]].value = n[a[l]].defaultValue, n[a[l]].explicitSet = !1;
        }
        if ("object" === (void 0 === t ? "undefined" : vt(t))) {
            for(r in t)if (i = t[r], f(a, r) && void 0 !== i) {
                if ("boolean" === n[r].type && "boolean" == typeof i) n[r].value = i;
                else if ("name" === n[r].type && f(n[r].valueSet, i)) n[r].value = i;
                else if ("integer" === n[r].type && Number.isInteger(i)) n[r].value = i;
                else if ("array" === n[r].type) {
                    for(h = 0; h < i.length; h += 1)if (u = !0, 1 === i[h].length && "number" == typeof i[h][0]) s.push(String(i[h]));
                    else if (1 < i[h].length) {
                        for(c = 0; c < i[h].length; c += 1)"number" != typeof i[h][c] && (u = !1);
                        !0 === u && s.push(String(i[h].join("-")));
                    }
                    n[r].value = String(s);
                } else n[r].value = n[r].defaultValue;
                n[r].explicitSet = !0;
            }
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            var _$t, _$e = [];
            for(_$t in n)!0 === n[_$t].explicitSet && ("name" === n[_$t].type ? _$e.push("/" + _$t + " /" + n[_$t].value) : _$e.push("/" + _$t + " " + n[_$t].value));
            0 !== _$e.length && this.internal.write("/ViewerPreferences\n<<\n" + _$e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    }, /** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */ Y = $.API, K = J = X = "", Y.addMetadata = function(t, e) {
        return J = e || "http://jspdf.default.namespaceuri/", X = t, this.internal.events.subscribe("postPutResources", function() {
            if (X) {
                var _$t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + J + '"><jspdf:metadata>', _$e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(_$t)), r = unescape(encodeURIComponent(X)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), a = n.length + r.length + i.length + _$e.length + o.length;
                K = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(_$e + n + r + i + o), this.internal.write("endstream"), this.internal.write("endobj");
            } else K = "";
        }), this.internal.events.subscribe("putCatalog", function() {
            K && this.internal.write("/Metadata " + K + " 0 R");
        }), this;
    }, function(l, t) {
        var e = l.API, m = [
            0
        ];
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "Identity-H" === t.encoding) {
                        for(var r = t.metadata.Unicode.widths, i = t.metadata.subset.encode(m), o = "", a = 0; a < i.length; a++)o += String.fromCharCode(i[a]);
                        var s = n();
                        e("<<"), e("/Length " + o.length), e("/Length1 " + o.length), e(">>"), e("stream"), e(o), e("endstream"), e("endobj");
                        var h = n();
                        e("<<"), e("/Type /FontDescriptor"), e("/FontName /" + t.fontName), e("/FontFile2 " + s + " 0 R"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/Flags " + t.metadata.flags), e("/StemV " + t.metadata.stemV), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e(">>"), e("endobj");
                        var c = n();
                        e("<<"), e("/Type /Font"), e("/BaseFont /" + t.fontName), e("/FontDescriptor " + h + " 0 R"), e("/W " + l.API.PDFObject.convert(r)), e("/CIDToGIDMap /Identity"), e("/DW 1000"), e("/Subtype /CIDFontType2"), e("/CIDSystemInfo"), e("<<"), e("/Supplement 0"), e("/Registry (Adobe)"), e("/Ordering (" + t.encoding + ")"), e(">>"), e(">>"), e("endobj"), t.objectNumber = n(), e("<<"), e("/Type /Font"), e("/Subtype /Type0"), e("/BaseFont /" + t.fontName), e("/Encoding /" + t.encoding), e("/DescendantFonts [" + c + " 0 R]"), e(">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "WinAnsiEncoding" === t.encoding) {
                        t.metadata.Unicode.widths;
                        for(var r = t.metadata.rawData, i = "", o = 0; o < r.length; o++)i += String.fromCharCode(r[o]);
                        var a = n();
                        e("<<"), e("/Length " + i.length), e("/Length1 " + i.length), e(">>"), e("stream"), e(i), e("endstream"), e("endobj");
                        var s = n();
                        for(e("<<"), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e("/StemV " + t.metadata.stemV), e("/Type /FontDescriptor"), e("/FontFile2 " + a + " 0 R"), e("/Flags 96"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/FontName /" + t.fontName), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e(">>"), e("endobj"), t.objectNumber = n(), o = 0; o < t.metadata.hmtx.widths.length; o++)t.metadata.hmtx.widths[o] = parseInt(t.metadata.hmtx.widths[o] * (1e3 / t.metadata.head.unitsPerEm));
                        e("<</Subtype/TrueType/Type/Font/BaseFont/" + t.fontName + "/FontDescriptor " + s + " 0 R/Encoding/" + t.encoding + " /FirstChar 29 /LastChar 255 /Widths " + l.API.PDFObject.convert(t.metadata.hmtx.widths) + ">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        var c = function c(t) {
            var e, n, r = t.text || "", i = t.x, o = t.y, a = t.options || {}, s = t.mutex || {}, h = s.pdfEscape, c = s.activeFontKey, _$l = s.fonts, u = (s.activeFontSize, ""), f = 0, d = "", p = _$l[n = c].encoding;
            if ("Identity-H" !== _$l[n].encoding) return {
                text: r,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
            for(d = r, n = c, "[object Array]" === Object.prototype.toString.call(r) && (d = r[0]), f = 0; f < d.length; f += 1)_$l[n].metadata.hasOwnProperty("cmap") && (e = _$l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]), e ? u += d[f] : d[f].charCodeAt(0) < 256 && _$l[n].metadata.hasOwnProperty("Unicode") ? u += d[f] : u += "";
            var g = "";
            return parseInt(n.slice(1)) < 14 || "WinAnsiEncoding" === p ? g = function(t) {
                for(var e = "", n = 0; n < t.length; n++)e += "" + t.charCodeAt(n).toString(16);
                return e;
            }(h(u, n)) : "Identity-H" === p && (g = function(t, e) {
                for(var n, r = e.metadata.Unicode.widths, i = [
                    "",
                    "0",
                    "00",
                    "000",
                    "0000"
                ], o = [
                    ""
                ], a = 0, s = t.length; a < s; ++a){
                    if (n = e.metadata.characterToGlyph(t.charCodeAt(a)), m.push(n), -1 == r.indexOf(n) && (r.push(n), r.push([
                        parseInt(e.metadata.widthOfGlyph(n), 10)
                    ])), "0" == n) return o.join("");
                    n = n.toString(16), o.push(i[4 - n.length], n);
                }
                return o.join("");
            }(u, _$l[n])), s.isHex = !0, {
                text: g,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
        };
        e.events.push([
            "postProcessText",
            function(t) {
                var e = t.text || "", n = t.x, r = t.y, i = t.options, o = t.mutex, a = (i.lang, []), s = {
                    text: e,
                    x: n,
                    y: r,
                    options: i,
                    mutex: o
                };
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var h = 0;
                    for(h = 0; h < e.length; h += 1)"[object Array]" === Object.prototype.toString.call(e[h]) && 3 === e[h].length ? a.push([
                        c(Object.assign({}, s, {
                            text: e[h][0]
                        })).text,
                        e[h][1],
                        e[h][2]
                    ]) : a.push(c(Object.assign({}, s, {
                        text: e[h]
                    })).text);
                    t.text = a;
                } else t.text = c(Object.assign({}, s, {
                    text: e
                })).text;
            }
        ]);
    }($, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")()), Q = $.API, Z = {}, Q.existsFileInVFS = function(t) {
        return Z.hasOwnProperty(t);
    }, Q.addFileToVFS = function(t, e) {
        return Z[t] = e, this;
    }, Q.getFileFromVFS = function(t) {
        return Z.hasOwnProperty(t) ? Z[t] : null;
    }, function(t) {
        if (t.URL = t.URL || t.webkitURL, t.Blob && t.URL) try {
            return new Blob;
        } catch (t) {}
        var s = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || function(t) {
            var s = function s(t) {
                return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1];
            }, e = function e() {
                this.data = [];
            }, h = function h(t, e, n) {
                this.data = t, this.size = t.length, this.type = e, this.encoding = n;
            }, n = e.prototype, r = h.prototype, c = t.FileReaderSync, l = function l(t) {
                this.code = this[this.name = t];
            }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), o = i.length, a = t.URL || t.webkitURL || t, u = a.createObjectURL, f = a.revokeObjectURL, d = a, p = t.btoa, g = t.atob, m = t.ArrayBuffer, w = t.Uint8Array, y = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
            for(h.fake = r.fake = !0; o--;)l.prototype[i[o]] = o + 1;
            return a.createObjectURL || (d = t.URL = function d(t) {
                var e, n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                return n.href = t, "origin" in n || ("data:" === n.protocol.toLowerCase() ? n.origin = null : (e = t.match(y), n.origin = e && e[1])), n;
            }), d.createObjectURL = function(t) {
                var e, n = t.type;
                return null === n && (n = "application/octet-stream"), t instanceof h ? (e = "data:" + n, "base64" === t.encoding ? e + ";base64," + t.data : "URI" === t.encoding ? e + "," + decodeURIComponent(t.data) : p ? e + ";base64," + p(t.data) : e + "," + encodeURIComponent(t.data)) : u ? u.call(a, t) : void 0;
            }, d.revokeObjectURL = function(t) {
                "data:" !== t.substring(0, 5) && f && f.call(a, t);
            }, n.append = function(t) {
                var e = this.data;
                if (w && (t instanceof m || t instanceof w)) {
                    for(var n = "", r = new w(t), i = 0, o = r.length; i < o; i++)n += String.fromCharCode(r[i]);
                    e.push(n);
                } else if ("Blob" === s(t) || "File" === s(t)) {
                    if (!c) throw new l("NOT_READABLE_ERR");
                    var a = new c;
                    e.push(a.readAsBinaryString(t));
                } else t instanceof h ? "base64" === t.encoding && g ? e.push(g(t.data)) : "URI" === t.encoding ? e.push(decodeURIComponent(t.data)) : "raw" === t.encoding && e.push(t.data) : ("string" != typeof t && (t += ""), e.push(unescape(encodeURIComponent(t))));
            }, n.getBlob = function(t) {
                return arguments.length || (t = null), new h(this.data.join(""), t, "raw");
            }, n.toString = function() {
                return "[object BlobBuilder]";
            }, r.slice = function(t, e, n) {
                var r = arguments.length;
                return r < 3 && (n = null), new h(this.data.slice(t, 1 < r ? e : this.data.length), n, this.encoding);
            }, r.toString = function() {
                return "[object Blob]";
            }, r.close = function() {
                this.size = 0, delete this.data;
            }, e;
        }(t);
        t.Blob = function(t, e) {
            var n = e && e.type || "", r = new s;
            if (t) for(var i = 0, o = t.length; i < o; i++)Uint8Array && t[i] instanceof Uint8Array ? r.append(t[i].buffer) : r.append(t[i]);
            var a = r.getBlob(n);
            return !a.slice && a.webkitSlice && (a.slice = a.webkitSlice), a;
        };
        var e = Object.getPrototypeOf || function(t) {
            return t.__proto__;
        };
        t.Blob.prototype = e(new t.Blob);
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content || window);
    var tt, et, nt, rt, it, ot, at, st, ht, ct, lt, ut, ft, dt, pt, gt, bt = bt || function(s) {
        if (!(void 0 === s || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var t = s.document, h = function h() {
                return s.URL || s.webkitURL || s;
            }, c = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), l = "download" in c, u = /constructor/i.test(s.HTMLElement) || s.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), d = function d(t) {
                (s.setImmediate || s.setTimeout)(function() {
                    throw t;
                }, 0);
            }, p = function p(t) {
                setTimeout(function() {
                    "string" == typeof t ? h().revokeObjectURL(t) : t.remove();
                }, 4e4);
            }, g = function g(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
                    String.fromCharCode(65279),
                    t
                ], {
                    type: t.type
                }) : t;
            }, r = function r(t, n, e) {
                e || (t = g(t));
                var r, i = this, o = "application/octet-stream" === t.type, a = function a() {
                    !function(t, e, n) {
                        for(var r = (e = [].concat(e)).length; r--;){
                            var i = t["on" + e[r]];
                            if ("function" == typeof i) try {
                                i.call(t, n || t);
                            } catch (t) {
                                d(t);
                            }
                        }
                    }(i, "writestart progress write writeend".split(" "));
                };
                if (i.readyState = i.INIT, l) return r = h().createObjectURL(t), void setTimeout(function() {
                    var _$t, _$e;
                    c.href = r, c.download = n, _$t = c, _$e = new MouseEvent("click"), _$t.dispatchEvent(_$e), a(), p(r), i.readyState = i.DONE;
                });
                !function() {
                    if ((f || o && u) && s.FileReader) {
                        var _$e = new FileReader;
                        return _$e.onloadend = function() {
                            var _$t = f ? _$e.result : _$e.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            s.open(_$t, "_blank") || (s.location.href = _$t), _$t = void 0, i.readyState = i.DONE, a();
                        }, _$e.readAsDataURL(t), i.readyState = i.INIT;
                    }
                    r || (r = h().createObjectURL(t)), o ? s.location.href = r : s.open(r, "_blank") || (s.location.href = r);
                    i.readyState = i.DONE, a(), p(r);
                }();
            }, e = r.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(t, e, n) {
                return e = e || t.name || "download", n || (t = g(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (e.abort = function() {}, e.readyState = e.INIT = 0, e.WRITING = 1, e.DONE = 2, e.error = e.onwritestart = e.onprogress = e.onwrite = e.onabort = e.onerror = e.onwriteend = null, function(t, e, n) {
                return new r(t, e || t.name || "download", n);
            });
        }
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content);
    (0, module.exports) ? module.exports.saveAs = bt : "undefined" != typeof define && null !== define && null !== define.amd && define("FileSaver.js", function() {
        return bt;
    }), $.API.adler32cs = (ot = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, at = null, st = function() {
        if (!ot) return function() {
            return !1;
        };
        try {
            var t = {};
            "function" == typeof t.Buffer && (at = t.Buffer);
        } catch (t) {}
        return function(t) {
            return t instanceof ArrayBuffer || null !== at && t instanceof at;
        };
    }(), ht = null !== at ? function ht(t) {
        return new at(t, "utf8").toString("binary");
    } : function(t) {
        return unescape(encodeURIComponent(t));
    }, ct = 65521, lt = function lt(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + (255 & e.charCodeAt(i))) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, ut = function ut(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + e[i]) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, dt = (ft = {}).Adler32 = (((it = (rt = function it(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
    }).prototype = {}).constructor = rt).from = ((tt = function tt(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = lt(1, t.toString());
    }).prototype = it, tt), rt.fromUtf8 = ((et = function et(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        this.checksum = lt(1, e);
    }).prototype = it, et), ot && (rt.fromBuffer = ((nt = function nt(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(1, e);
    }).prototype = it, nt)), it.update = function dt(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = lt(this.checksum, t);
    }, it.updateUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return this.checksum = lt(this.checksum, e);
    }, ot && (it.updateBuffer = function(t) {
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(this.checksum, e);
    }), it.clone = function() {
        return new dt(this.checksum);
    }, rt), ft.from = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return lt(1, t.toString());
    }, ft.fromUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return lt(1, e);
    }, ot && (ft.fromBuffer = function(t) {
        if (!st(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return ut(1, e);
    }), ft);
    try {
        module.exports.GifWriter = function(w, t, e, n) {
            var b = function b(t) {
                var _$e = t.length;
                if (_$e < 2 || 256 < _$e || _$e & _$e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
                return _$e;
            };
            var y = 0, r = void 0 === (n = void 0 === n ? {} : n).loop ? null : n.loop, v = void 0 === n.palette ? null : n.palette;
            if (t <= 0 || e <= 0 || 65535 < t || 65535 < e) throw "Width/Height invalid.";
            w[y++] = 71, w[y++] = 73, w[y++] = 70, w[y++] = 56, w[y++] = 57, w[y++] = 97;
            var i = 0, o = 0;
            if (null !== v) {
                for(var a = b(v); a >>= 1;)++i;
                if (a = 1 << i, --i, void 0 !== n.background) {
                    if (a <= (o = n.background)) throw "Background index out of range.";
                    if (0 === o) throw "Background index explicitly passed as 0.";
                }
            }
            if (w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = (null !== v ? 128 : 0) | i, w[y++] = o, w[y++] = 0, null !== v) for(var s = 0, h = v.length; s < h; ++s){
                var c = v[s];
                w[y++] = c >> 16 & 255, w[y++] = c >> 8 & 255, w[y++] = 255 & c;
            }
            if (null !== r) {
                if (r < 0 || 65535 < r) throw "Loop count invalid.";
                w[y++] = 33, w[y++] = 255, w[y++] = 11, w[y++] = 78, w[y++] = 69, w[y++] = 84, w[y++] = 83, w[y++] = 67, w[y++] = 65, w[y++] = 80, w[y++] = 69, w[y++] = 50, w[y++] = 46, w[y++] = 48, w[y++] = 3, w[y++] = 1, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = 0;
            }
            var x = !1;
            this.addFrame = function(t, e, n, r, i, o) {
                if (!0 === x && (--y, x = !1), o = void 0 === o ? {} : o, t < 0 || e < 0 || 65535 < t || 65535 < e) throw "x/y invalid.";
                if (n <= 0 || r <= 0 || 65535 < n || 65535 < r) throw "Width/Height invalid.";
                if (i.length < n * r) throw "Not enough pixels for the frame size.";
                var a = !0, s = o.palette;
                if (null == s && (a = !1, s = v), null == s) throw "Must supply either a local or global palette.";
                for(var h = b(s), c = 0; h >>= 1;)++c;
                h = 1 << c;
                var l = void 0 === o.delay ? 0 : o.delay, u = void 0 === o.disposal ? 0 : o.disposal;
                if (u < 0 || 3 < u) throw "Disposal out of range.";
                var f = !1, d = 0;
                if (void 0 !== o.transparent && null !== o.transparent && (f = !0, (d = o.transparent) < 0 || h <= d)) throw "Transparent color index.";
                if ((0 !== u || f || 0 !== l) && (w[y++] = 33, w[y++] = 249, w[y++] = 4, w[y++] = u << 2 | (!0 === f ? 1 : 0), w[y++] = 255 & l, w[y++] = l >> 8 & 255, w[y++] = d, w[y++] = 0), w[y++] = 44, w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = 255 & n, w[y++] = n >> 8 & 255, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = !0 === a ? 128 | c - 1 : 0, !0 === a) for(var p = 0, g = s.length; p < g; ++p){
                    var m = s[p];
                    w[y++] = m >> 16 & 255, w[y++] = m >> 8 & 255, w[y++] = 255 & m;
                }
                y = function(e, n, t, r) {
                    var f = function f(t) {
                        for(; t <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === _$i + 256 && (e[_$i] = 255, _$i = n++);
                    };
                    var d = function d(t) {
                        u |= t << l, l += c, f(8);
                    };
                    e[n++] = t;
                    var _$i = n++, _$o = 1 << t, a = _$o - 1, s = _$o + 1, h = s + 1, c = t + 1, l = 0, u = 0;
                    var p = r[0] & a, g = {};
                    d(_$o);
                    for(var m = 1, _$w = r.length; m < _$w; ++m){
                        var y = r[m] & a, v = p << 8 | y, b = g[v];
                        if (void 0 === b) {
                            for(u |= p << l, l += c; 8 <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === _$i + 256 && (e[_$i] = 255, _$i = n++);
                            4096 === h ? (d(_$o), h = s + 1, c = t + 1, g = {}) : (1 << c <= h && ++c, g[v] = h++), p = y;
                        } else p = b;
                    }
                    return d(p), d(s), f(1), _$i + 1 === n ? e[_$i] = 0 : (e[_$i] = n - _$i - 1, e[n++] = 0), n;
                }(w, y, c < 2 ? 2 : c, i);
            }, this.end = function() {
                return !1 === x && (w[y++] = 59, x = !0), y;
            };
        }, module.exports.GifReader = mt;
    } catch (t) {}
    try {
        module.exports = yt;
    } catch (t) {}
    xt.prototype.parseHeader = function() {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for(var e = 0; e < t; e++){
                var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: r,
                    blue: n,
                    quad: o
                };
            }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
    }, xt.prototype.parseBGR = function() {
        this.pos = this.offset;
        try {
            var _$t = "bit" + this.bitPP, e = this.width * this.height * 4;
            this.data = new Uint8Array(e), this[_$t]();
        } catch (t) {
            console.log("bit decode error:" + t);
        }
    }, xt.prototype.bit1 = function() {
        var t = Math.ceil(this.width / 8), e = t % 4, n = 0 <= this.height ? this.height - 1 : -this.height;
        for(n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++)for(var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                var h = this.palette[o >> 7 - s & 1];
                this.data[a + 4 * s] = h.blue, this.data[a + 4 * s + 1] = h.green, this.data[a + 4 * s + 2] = h.red, this.data[a + 4 * s + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit4 = function() {
        for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 2 * i * 4, s = o >> 4, h = 15 & o, c = this.palette[s];
                if (this.data[a] = c.blue, this.data[a + 1] = c.green, this.data[a + 2] = c.red, this.data[a + 3] = 255, 2 * i + 1 >= this.width) break;
                c = this.palette[h], this.data[a + 4] = c.blue, this.data[a + 4 + 1] = c.green, this.data[a + 4 + 2] = c.red, this.data[a + 4 + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit8 = function() {
        for(var t = this.width % 4, e = this.height - 1; 0 <= e; e--){
            for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                var i = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * r;
                if (i < this.palette.length) {
                    var a = this.palette[i];
                    this.data[o] = a.red, this.data[o + 1] = a.green, this.data[o + 2] = a.blue, this.data[o + 3] = 255;
                } else this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
            }
            0 != t && (this.pos += 4 - t);
        }
    }, xt.prototype.bit15 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var a = (o & e) / e * 255 | 0, s = (o >> 5 & e) / e * 255 | 0, h = (o >> 10 & e) / e * 255 | 0, c = o >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
                this.data[l] = h, this.data[l + 1] = s, this.data[l + 2] = a, this.data[l + 3] = c;
            }
            this.pos += t;
        }
    }, xt.prototype.bit16 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; 0 <= r; r--){
            for(var i = this.bottom_up ? r : this.height - 1 - r, o = 0; o < this.width; o++){
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (a & e) / e * 255 | 0, h = (a >> 5 & n) / n * 255 | 0, c = (a >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * o;
                this.data[l] = c, this.data[l + 1] = h, this.data[l + 2] = s, this.data[l + 3] = 255;
            }
            this.pos += t;
        }
    }, xt.prototype.bit24 = function() {
        for(var t = this.height - 1; 0 <= t; t--){
            for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
                this.data[a] = o, this.data[a + 1] = i, this.data[a + 2] = r, this.data[a + 3] = 255;
            }
            this.pos += this.width % 4;
        }
    }, xt.prototype.bit32 = function() {
        for(var t = this.height - 1; 0 <= t; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
            this.data[s] = o, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = a;
        }
    }, xt.prototype.getData = function() {
        return this.data;
    };
    try {
        module.exports = function(t) {
            var e = new xt(t);
            return {
                data: e.getData(),
                width: e.width,
                height: e.height
            };
        };
    } catch (t) {}
    /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ !function(t) {
        var ut = function ut() {
            var d = this;
            function h(t, e) {
                for(var n = 0; n |= 1 & t, t >>>= 1, n <<= 1, 0 < --e;);
                return n >>> 1;
            }
            d.build_tree = function(t) {
                var e, n, r, i = d.dyn_tree, o = d.stat_desc.static_tree, a = d.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = g, e = 0; e < a; e++)0 !== i[2 * e] ? (t.heap[++t.heap_len] = s = e, t.depth[e] = 0) : i[2 * e + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (r = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[r] = 0, t.opt_len--, o && (t.static_len -= o[2 * r + 1]);
                for(d.max_code = s, e = Math.floor(t.heap_len / 2); 1 <= e; e--)t.pqdownheap(i, e);
                for(r = a; e = t.heap[1], t.heap[1] = t.heap[t.heap_len--], t.pqdownheap(i, 1), n = t.heap[1], t.heap[--t.heap_max] = e, t.heap[--t.heap_max] = n, i[2 * r] = i[2 * e] + i[2 * n], t.depth[r] = Math.max(t.depth[e], t.depth[n]) + 1, i[2 * e + 1] = i[2 * n + 1] = r, t.heap[1] = r++, t.pqdownheap(i, 1), 2 <= t.heap_len;);
                t.heap[--t.heap_max] = t.heap[1], function(t) {
                    var e, n, r, i, o, a, s = d.dyn_tree, h = d.stat_desc.static_tree, c = d.stat_desc.extra_bits, l = d.stat_desc.extra_base, u = d.stat_desc.max_length, f = 0;
                    for(i = 0; i <= p; i++)t.bl_count[i] = 0;
                    for(s[2 * t.heap[t.heap_max] + 1] = 0, e = t.heap_max + 1; e < g; e++)u < (i = s[2 * s[2 * (n = t.heap[e]) + 1] + 1] + 1) && (i = u, f++), s[2 * n + 1] = i, n > d.max_code || (t.bl_count[i]++, o = 0, l <= n && (o = c[n - l]), a = s[2 * n], t.opt_len += a * (i + o), h && (t.static_len += a * (h[2 * n + 1] + o)));
                    if (0 !== f) {
                        do {
                            for(i = u - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[u]--, f -= 2;
                        }while (0 < f);
                        for(i = u; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(r = t.heap[--e]) > d.max_code || (s[2 * r + 1] != i && (t.opt_len += (i - s[2 * r + 1]) * s[2 * r], s[2 * r + 1] = i), n--);
                    }
                }(t), function(t, e, n) {
                    var r, i, o, a = [], s = 0;
                    for(r = 1; r <= p; r++)a[r] = s = s + n[r - 1] << 1;
                    for(i = 0; i <= e; i++)0 !== (o = t[2 * i + 1]) && (t[2 * i] = h(a[o]++, o));
                }(i, d.max_code, t.bl_count);
            };
        };
        var ft = function ft(t, e, n, r, i) {
            var o = this;
            o.static_tree = t, o.extra_bits = e, o.extra_base = n, o.elems = r, o.max_length = i;
        };
        var n = function n(t, e, n, r, i) {
            var o = this;
            o.good_length = t, o.max_lazy = e, o.nice_length = n, o.max_chain = r, o.func = i;
        };
        var mt = function mt(t, e, n, r) {
            var i = t[2 * e], o = t[2 * n];
            return i < o || i == o && r[e] <= r[n];
        };
        var r = function r() {
            var h, c, l, u, f, d, p, g, i, m, w, y, v, a, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, s, j, D, M, U, N, z, o, L, H, W, G = this, V = new ut, Y = new ut, X = new ut;
            function J() {
                var _$t;
                for(_$t = 0; _$t < 286; _$t++)s[2 * _$t] = 0;
                for(_$t = 0; _$t < 30; _$t++)j[2 * _$t] = 0;
                for(_$t = 0; _$t < 19; _$t++)D[2 * _$t] = 0;
                s[512] = 1, G.opt_len = G.static_len = 0, N = o = 0;
            }
            function K(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = o, o = t[2 * (n + 1) + 1], ++a < s && r == o || (a < h ? D[2 * r] += a : 0 !== r ? (r != i && D[2 * r]++, D[32]++) : a <= 10 ? D[34]++ : D[36]++, i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4));
            }
            function Q(t) {
                G.pending_buf[G.pending++] = t;
            }
            function Z(t) {
                Q(255 & t), Q(t >>> 8 & 255);
            }
            function $(t, e) {
                var n, r = e;
                16 - r < W ? (Z(H |= (n = t) << W & 65535), H = n >>> 16 - W, W += r - 16) : (H |= t << W & 65535, W += r);
            }
            function tt(t, e) {
                var n = 2 * t;
                $(65535 & e[n], 65535 & e[n + 1]);
            }
            function et(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), n = 0; n <= e; n++)if (r = o, o = t[2 * (n + 1) + 1], !(++a < s && r == o)) {
                    if (a < h) for(; tt(r, D), 0 != --a;);
                    else 0 !== r ? (r != i && (tt(r, D), a--), tt(16, D), $(a - 3, 2)) : a <= 10 ? (tt(17, D), $(a - 3, 3)) : (tt(18, D), $(a - 11, 7));
                    i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4);
                }
            }
            function nt() {
                16 == W ? (Z(H), W = H = 0) : 8 <= W && (Q(255 & H), H >>>= 8, W -= 8);
            }
            function rt(t, e) {
                var n, r, i;
                if (G.pending_buf[z + 2 * N] = t >>> 8 & 255, G.pending_buf[z + 2 * N + 1] = 255 & t, G.pending_buf[M + N] = 255 & e, N++, 0 === t ? s[2 * e]++ : (o++, t--, s[2 * (ut._length_code[e] + 256 + 1)]++, j[2 * ut.d_code(t)]++), 0 == (8191 & N) && 2 < q) {
                    for(n = 8 * N, r = I - S, i = 0; i < 30; i++)n += j[2 * i] * (5 + ut.extra_dbits[i]);
                    if (n >>>= 3, o < Math.floor(N / 2) && n < Math.floor(r / 2)) return !0;
                }
                return N == U - 1;
            }
            function it(t, e) {
                var n, r, i, o, a = 0;
                if (0 !== N) for(; n = G.pending_buf[z + 2 * a] << 8 & 65280 | 255 & G.pending_buf[z + 2 * a + 1], r = 255 & G.pending_buf[M + a], a++, 0 === n ? tt(r, t) : (tt((i = ut._length_code[r]) + 256 + 1, t), 0 !== (o = ut.extra_lbits[i]) && $(r -= ut.base_length[i], o), tt(i = ut.d_code(--n), e), 0 !== (o = ut.extra_dbits[i]) && $(n -= ut.base_dist[i], o)), a < N;);
                tt(256, t), L = t[513];
            }
            function ot() {
                8 < W ? Z(H) : 0 < W && Q(255 & H), W = H = 0;
            }
            function at(t, e, n) {
                var r, i, o;
                $(0 + (n ? 1 : 0), 3), r = t, i = e, o = !0, ot(), L = 8, o && (Z(i), Z(~i)), G.pending_buf.set(g.subarray(r, r + i), G.pending), G.pending += i;
            }
            function e(t, e, n) {
                var r, i, o = 0;
                0 < q ? (V.build_tree(G), Y.build_tree(G), o = function() {
                    var _$t;
                    for(K(s, V.max_code), K(j, Y.max_code), X.build_tree(G), _$t = 18; 3 <= _$t && 0 === D[2 * ut.bl_order[_$t] + 1]; _$t--);
                    return G.opt_len += 3 * (_$t + 1) + 5 + 5 + 4, _$t;
                }(), r = G.opt_len + 3 + 7 >>> 3, (i = G.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 != t ? at(t, e, n) : i == r ? ($(2 + (n ? 1 : 0), 3), it(ft.static_ltree, ft.static_dtree)) : ($(4 + (n ? 1 : 0), 3), function(t, e, n) {
                    var r;
                    for($(t - 257, 5), $(e - 1, 5), $(n - 4, 4), r = 0; r < n; r++)$(D[2 * ut.bl_order[r] + 1], 3);
                    et(s, t - 1), et(j, e - 1);
                }(V.max_code + 1, Y.max_code + 1, o + 1), it(s, j)), J(), n && ot();
            }
            function st(t) {
                e(0 <= S ? S : -1, I - S, t), S = I, h.flush_pending();
            }
            function ht() {
                var _$t, e, n, r;
                do {
                    if (0 === (r = i - T - I) && 0 === I && 0 === T) r = f;
                    else if (-1 == r) r--;
                    else if (f + f - gt <= I) {
                        for(g.set(g.subarray(f, f + f), 0), C -= f, I -= f, S -= f, n = _$t = v; e = 65535 & w[--n], w[n] = f <= e ? e - f : 0, 0 != --_$t;);
                        for(n = _$t = f; e = 65535 & m[--n], m[n] = f <= e ? e - f : 0, 0 != --_$t;);
                        r += f;
                    }
                    if (0 === h.avail_in) return;
                    _$t = h.read_buf(g, I + T, r), 3 <= (T += _$t) && (y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b);
                }while (T < gt && 0 !== h.avail_in);
            }
            function ct(t) {
                var e, n, r = P, i = I, o = F, a = f - gt < I ? I - (f - gt) : 0, s = R, h = p, c = I + 258, l = g[i + o - 1], u = g[i + o];
                B <= F && (r >>= 2), T < s && (s = T);
                do if (g[(e = t) + o] == u && g[e + o - 1] == l && g[e] == g[i] && g[++e] == g[i + 1]) {
                    i += 2, e++;
                    do ;
                    while (g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && i < c);
                    if (n = 258 - (c - i), i = c - 258, o < n) {
                        if (C = t, s <= (o = n)) break;
                        l = g[i + o - 1], u = g[i + o];
                    }
                }
                while ((t = 65535 & m[t & h]) > a && 0 != --r);
                return o <= T ? o : T;
            }
            function lt(t) {
                return t.total_in = t.total_out = 0, t.msg = null, G.pending = 0, G.pending_out = 0, c = 113, u = 0, V.dyn_tree = s, V.stat_desc = ft.static_l_desc, Y.dyn_tree = j, Y.stat_desc = ft.static_d_desc, X.dyn_tree = D, X.stat_desc = ft.static_bl_desc, W = H = 0, L = 8, J(), function() {
                    var _$t;
                    for(i = 2 * f, _$t = w[v - 1] = 0; _$t < v - 1; _$t++)w[_$t] = 0;
                    E = dt[q].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain, k = F = 2, y = A = T = S = I = 0;
                }(), 0;
            }
            G.depth = [], G.bl_count = [], G.heap = [], s = [], j = [], D = [], G.pqdownheap = function(t, e) {
                for(var n = G.heap, r = n[e], i = e << 1; i <= G.heap_len && (i < G.heap_len && mt(t, n[i + 1], n[i], G.depth) && i++, !mt(t, r, n[i], G.depth));)n[e] = n[i], e = i, i <<= 1;
                n[e] = r;
            }, G.deflateInit = function(t, e, n, r, i, o) {
                return r || (r = 8), i || (i = 8), o || (o = 0), t.msg = null, -1 == e && (e = 6), i < 1 || 9 < i || 8 != r || n < 9 || 15 < n || e < 0 || 9 < e || o < 0 || 2 < o ? -2 : (t.dstate = G, p = (f = 1 << (d = n)) - 1, b = (v = 1 << (a = i + 7)) - 1, x = Math.floor((a + 3 - 1) / 3), g = new Uint8Array(2 * f), m = [], w = [], U = 1 << i + 6, G.pending_buf = new Uint8Array(4 * U), l = 4 * U, z = Math.floor(U / 2), M = 3 * U, q = e, O = o, lt(t));
            }, G.deflateEnd = function() {
                return 42 != c && 113 != c && 666 != c ? -2 : (G.pending_buf = null, g = m = w = null, G.dstate = null, 113 == c ? -3 : 0);
            }, G.deflateParams = function(t, e, n) {
                var r = 0;
                return -1 == e && (e = 6), e < 0 || 9 < e || n < 0 || 2 < n ? -2 : (dt[q].func != dt[e].func && 0 !== t.total_in && (r = t.deflate(1)), q != e && (E = dt[q = e].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain), O = n, r);
            }, G.deflateSetDictionary = function(t, e, n) {
                var r, i = n, o = 0;
                if (!e || 42 != c) return -2;
                if (i < 3) return 0;
                for(f - gt < i && (o = n - (i = f - gt)), g.set(e.subarray(o, o + i), 0), S = I = i, y = ((y = 255 & g[0]) << x ^ 255 & g[1]) & b, r = 0; r <= i - 3; r++)y = (y << x ^ 255 & g[r + 2]) & b, m[r & p] = w[y], w[y] = r;
                return 0;
            }, G.deflate = function(t, e) {
                var n, r, i, o, a, s;
                if (4 < e || e < 0) return -2;
                if (!t.next_out || !t.next_in && 0 !== t.avail_in || 666 == c && 4 != e) return t.msg = pt[4], -2;
                if (0 === t.avail_out) return t.msg = pt[7], -5;
                if (h = t, o = u, u = e, 42 == c && (r = 8 + (d - 8 << 4) << 8, 3 < (i = (q - 1 & 255) >> 1) && (i = 3), r |= i << 6, 0 !== I && (r |= 32), c = 113, Q((s = r += 31 - r % 31) >> 8 & 255), Q(255 & s)), 0 !== G.pending) {
                    if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                } else if (0 === h.avail_in && e <= o && 4 != e) return h.msg = pt[7], -5;
                if (666 == c && 0 !== h.avail_in) return t.msg = pt[7], -5;
                if (0 !== h.avail_in || 0 !== T || 0 != e && 666 != c) {
                    switch(a = -1, dt[q].func){
                        case 0:
                            a = function(t) {
                                var _$e, n = 65535;
                                for(l - 5 < n && (n = l - 5);;){
                                    if (T <= 1) {
                                        if (ht(), 0 === T && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (I += T, _$e = S + n, ((T = 0) === I || _$e <= I) && (T = I - _$e, I = _$e, st(!1), 0 === h.avail_out)) return 0;
                                    if (f - gt <= I - S && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 1:
                            a = function(t) {
                                for(var _$e, n = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 !== n && (I - n & 65535) <= f - gt && 2 != O && (k = ct(n)), 3 <= k) {
                                        if (_$e = rt(I - C, k - 3), T -= k, k <= E && 3 <= T) {
                                            for(k--; y = (y << x ^ 255 & g[++I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I, 0 != --k;);
                                            I++;
                                        } else I += k, k = 0, y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b;
                                    } else _$e = rt(0, 255 & g[I]), T--, I++;
                                    if (_$e && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 2:
                            a = function(t) {
                                for(var _$e, n, r = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), F = k, _ = C, k = 2, 0 !== r && F < E && (I - r & 65535) <= f - gt && (2 != O && (k = ct(r)), k <= 5 && (1 == O || 3 == k && 4096 < I - C) && (k = 2)), 3 <= F && k <= F) {
                                        for(n = I + T - 3, _$e = rt(I - 1 - _, F - 3), T -= F - 1, F -= 2; ++I <= n && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 != --F;);
                                        if (A = 0, k = 2, I++, _$e && (st(!1), 0 === h.avail_out)) return 0;
                                    } else if (0 !== A) {
                                        if ((_$e = rt(0, 255 & g[I - 1])) && st(!1), I++, T--, 0 === h.avail_out) return 0;
                                    } else A = 1, I++, T--;
                                }
                                return 0 !== A && (_$e = rt(0, 255 & g[I - 1]), A = 0), st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                    }
                    if (2 != a && 3 != a || (c = 666), 0 == a || 2 == a) return 0 === h.avail_out && (u = -1), 0;
                    if (1 == a) {
                        if (1 == e) $(2, 3), tt(256, ft.static_ltree), nt(), 1 + L + 10 - W < 9 && ($(2, 3), tt(256, ft.static_ltree), nt()), L = 7;
                        else if (at(0, 0, !1), 3 == e) for(n = 0; n < v; n++)w[n] = 0;
                        if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                    }
                }
                return 4 != e ? 0 : 1;
            };
        };
        var i = function i() {
            var _$t = this;
            _$t.next_in_index = 0, _$t.next_out_index = 0, _$t.avail_in = 0, _$t.total_in = 0, _$t.avail_out = 0, _$t.total_out = 0;
        };
        var p = 15, g = 573, e = [
            0,
            1,
            2,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            0,
            0,
            16,
            17,
            18,
            18,
            19,
            19,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29
        ];
        ut._length_code = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28
        ], ut.base_length = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            10,
            12,
            14,
            16,
            20,
            24,
            28,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            0
        ], ut.base_dist = [
            0,
            1,
            2,
            3,
            4,
            6,
            8,
            12,
            16,
            24,
            32,
            48,
            64,
            96,
            128,
            192,
            256,
            384,
            512,
            768,
            1024,
            1536,
            2048,
            3072,
            4096,
            6144,
            8192,
            12288,
            16384,
            24576
        ], ut.d_code = function(t) {
            return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, ut.extra_lbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
        ], ut.extra_dbits = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
        ], ut.extra_blbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            3,
            7
        ], ut.bl_order = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], ft.static_ltree = [
            12,
            8,
            140,
            8,
            76,
            8,
            204,
            8,
            44,
            8,
            172,
            8,
            108,
            8,
            236,
            8,
            28,
            8,
            156,
            8,
            92,
            8,
            220,
            8,
            60,
            8,
            188,
            8,
            124,
            8,
            252,
            8,
            2,
            8,
            130,
            8,
            66,
            8,
            194,
            8,
            34,
            8,
            162,
            8,
            98,
            8,
            226,
            8,
            18,
            8,
            146,
            8,
            82,
            8,
            210,
            8,
            50,
            8,
            178,
            8,
            114,
            8,
            242,
            8,
            10,
            8,
            138,
            8,
            74,
            8,
            202,
            8,
            42,
            8,
            170,
            8,
            106,
            8,
            234,
            8,
            26,
            8,
            154,
            8,
            90,
            8,
            218,
            8,
            58,
            8,
            186,
            8,
            122,
            8,
            250,
            8,
            6,
            8,
            134,
            8,
            70,
            8,
            198,
            8,
            38,
            8,
            166,
            8,
            102,
            8,
            230,
            8,
            22,
            8,
            150,
            8,
            86,
            8,
            214,
            8,
            54,
            8,
            182,
            8,
            118,
            8,
            246,
            8,
            14,
            8,
            142,
            8,
            78,
            8,
            206,
            8,
            46,
            8,
            174,
            8,
            110,
            8,
            238,
            8,
            30,
            8,
            158,
            8,
            94,
            8,
            222,
            8,
            62,
            8,
            190,
            8,
            126,
            8,
            254,
            8,
            1,
            8,
            129,
            8,
            65,
            8,
            193,
            8,
            33,
            8,
            161,
            8,
            97,
            8,
            225,
            8,
            17,
            8,
            145,
            8,
            81,
            8,
            209,
            8,
            49,
            8,
            177,
            8,
            113,
            8,
            241,
            8,
            9,
            8,
            137,
            8,
            73,
            8,
            201,
            8,
            41,
            8,
            169,
            8,
            105,
            8,
            233,
            8,
            25,
            8,
            153,
            8,
            89,
            8,
            217,
            8,
            57,
            8,
            185,
            8,
            121,
            8,
            249,
            8,
            5,
            8,
            133,
            8,
            69,
            8,
            197,
            8,
            37,
            8,
            165,
            8,
            101,
            8,
            229,
            8,
            21,
            8,
            149,
            8,
            85,
            8,
            213,
            8,
            53,
            8,
            181,
            8,
            117,
            8,
            245,
            8,
            13,
            8,
            141,
            8,
            77,
            8,
            205,
            8,
            45,
            8,
            173,
            8,
            109,
            8,
            237,
            8,
            29,
            8,
            157,
            8,
            93,
            8,
            221,
            8,
            61,
            8,
            189,
            8,
            125,
            8,
            253,
            8,
            19,
            9,
            275,
            9,
            147,
            9,
            403,
            9,
            83,
            9,
            339,
            9,
            211,
            9,
            467,
            9,
            51,
            9,
            307,
            9,
            179,
            9,
            435,
            9,
            115,
            9,
            371,
            9,
            243,
            9,
            499,
            9,
            11,
            9,
            267,
            9,
            139,
            9,
            395,
            9,
            75,
            9,
            331,
            9,
            203,
            9,
            459,
            9,
            43,
            9,
            299,
            9,
            171,
            9,
            427,
            9,
            107,
            9,
            363,
            9,
            235,
            9,
            491,
            9,
            27,
            9,
            283,
            9,
            155,
            9,
            411,
            9,
            91,
            9,
            347,
            9,
            219,
            9,
            475,
            9,
            59,
            9,
            315,
            9,
            187,
            9,
            443,
            9,
            123,
            9,
            379,
            9,
            251,
            9,
            507,
            9,
            7,
            9,
            263,
            9,
            135,
            9,
            391,
            9,
            71,
            9,
            327,
            9,
            199,
            9,
            455,
            9,
            39,
            9,
            295,
            9,
            167,
            9,
            423,
            9,
            103,
            9,
            359,
            9,
            231,
            9,
            487,
            9,
            23,
            9,
            279,
            9,
            151,
            9,
            407,
            9,
            87,
            9,
            343,
            9,
            215,
            9,
            471,
            9,
            55,
            9,
            311,
            9,
            183,
            9,
            439,
            9,
            119,
            9,
            375,
            9,
            247,
            9,
            503,
            9,
            15,
            9,
            271,
            9,
            143,
            9,
            399,
            9,
            79,
            9,
            335,
            9,
            207,
            9,
            463,
            9,
            47,
            9,
            303,
            9,
            175,
            9,
            431,
            9,
            111,
            9,
            367,
            9,
            239,
            9,
            495,
            9,
            31,
            9,
            287,
            9,
            159,
            9,
            415,
            9,
            95,
            9,
            351,
            9,
            223,
            9,
            479,
            9,
            63,
            9,
            319,
            9,
            191,
            9,
            447,
            9,
            127,
            9,
            383,
            9,
            255,
            9,
            511,
            9,
            0,
            7,
            64,
            7,
            32,
            7,
            96,
            7,
            16,
            7,
            80,
            7,
            48,
            7,
            112,
            7,
            8,
            7,
            72,
            7,
            40,
            7,
            104,
            7,
            24,
            7,
            88,
            7,
            56,
            7,
            120,
            7,
            4,
            7,
            68,
            7,
            36,
            7,
            100,
            7,
            20,
            7,
            84,
            7,
            52,
            7,
            116,
            7,
            3,
            8,
            131,
            8,
            67,
            8,
            195,
            8,
            35,
            8,
            163,
            8,
            99,
            8,
            227,
            8
        ], ft.static_dtree = [
            0,
            5,
            16,
            5,
            8,
            5,
            24,
            5,
            4,
            5,
            20,
            5,
            12,
            5,
            28,
            5,
            2,
            5,
            18,
            5,
            10,
            5,
            26,
            5,
            6,
            5,
            22,
            5,
            14,
            5,
            30,
            5,
            1,
            5,
            17,
            5,
            9,
            5,
            25,
            5,
            5,
            5,
            21,
            5,
            13,
            5,
            29,
            5,
            3,
            5,
            19,
            5,
            11,
            5,
            27,
            5,
            7,
            5,
            23,
            5
        ], ft.static_l_desc = new ft(ft.static_ltree, ut.extra_lbits, 257, 286, p), ft.static_d_desc = new ft(ft.static_dtree, ut.extra_dbits, 0, 30, p), ft.static_bl_desc = new ft(null, ut.extra_blbits, 0, 19, 7);
        var dt = [
            new n(0, 0, 0, 0, 0),
            new n(4, 4, 8, 4, 1),
            new n(4, 5, 16, 8, 1),
            new n(4, 6, 32, 32, 1),
            new n(4, 4, 16, 16, 2),
            new n(8, 16, 32, 32, 2),
            new n(8, 16, 128, 128, 2),
            new n(8, 32, 128, 256, 2),
            new n(32, 128, 258, 1024, 2),
            new n(32, 258, 258, 4096, 2)
        ], pt = [
            "need dictionary",
            "stream end",
            "",
            "",
            "stream error",
            "data error",
            "",
            "buffer error",
            "",
            ""
        ], gt = 262;
        i.prototype = {
            deflateInit: function deflateInit(t, e) {
                return this.dstate = new r, e || (e = p), this.dstate.deflateInit(this, t, e);
            },
            deflate: function deflate(t) {
                return this.dstate ? this.dstate.deflate(this, t) : -2;
            },
            deflateEnd: function deflateEnd() {
                if (!this.dstate) return -2;
                var _$t = this.dstate.deflateEnd();
                return this.dstate = null, _$t;
            },
            deflateParams: function deflateParams(t, e) {
                return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
            },
            deflateSetDictionary: function deflateSetDictionary(t, e) {
                return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
            },
            read_buf: function read_buf(t, e, n) {
                var r = this, i = r.avail_in;
                return n < i && (i = n), 0 === i ? 0 : (r.avail_in -= i, t.set(r.next_in.subarray(r.next_in_index, r.next_in_index + i), e), r.next_in_index += i, r.total_in += i, i);
            },
            flush_pending: function flush_pending() {
                var _$t = this, e = _$t.dstate.pending;
                e > _$t.avail_out && (e = _$t.avail_out), 0 !== e && (_$t.next_out.set(_$t.dstate.pending_buf.subarray(_$t.dstate.pending_out, _$t.dstate.pending_out + e), _$t.next_out_index), _$t.next_out_index += e, _$t.dstate.pending_out += e, _$t.total_out += e, _$t.avail_out -= e, _$t.dstate.pending -= e, 0 === _$t.dstate.pending && (_$t.dstate.pending_out = 0));
            }
        };
        var o = t.zip || t;
        o.Deflater = o._jzlib_Deflater = function(t) {
            var s = new i, h = new Uint8Array(512), e = t ? t.level : -1;
            void 0 === e && (e = -1), s.deflateInit(e), s.next_out = h, this.append = function(t, e) {
                var n, r = [], i = 0, o = 0, a = 0;
                if (t.length) {
                    s.next_in_index = 0, s.next_in = t, s.avail_in = t.length;
                    do {
                        if (s.next_out_index = 0, s.avail_out = 512, 0 != s.deflate(0)) throw new Error("deflating: " + s.msg);
                        s.next_out_index && (512 == s.next_out_index ? r.push(new Uint8Array(h)) : r.push(new Uint8Array(h.subarray(0, s.next_out_index)))), a += s.next_out_index, e && 0 < s.next_in_index && s.next_in_index != i && (e(s.next_in_index), i = s.next_in_index);
                    }while (0 < s.avail_in || 0 === s.avail_out);
                    return n = new Uint8Array(a), r.forEach(function(t) {
                        n.set(t, o), o += t.length;
                    }), n;
                }
            }, this.flush = function() {
                var _$t, e, n = [], r = 0, i = 0;
                do {
                    if (s.next_out_index = 0, s.avail_out = 512, 1 != (_$t = s.deflate(4)) && 0 != _$t) throw new Error("deflating: " + s.msg);
                    0 < 512 - s.avail_out && n.push(new Uint8Array(h.subarray(0, s.next_out_index))), i += s.next_out_index;
                }while (0 < s.avail_in || 0 === s.avail_out);
                return s.deflateEnd(), e = new Uint8Array(i), n.forEach(function(t) {
                    e.set(t, r), r += t.length;
                }), e;
            };
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */ function(t) {
        function f(t) {
            var e;
            this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
            var l = {
                aliceblue: "f0f8ff",
                antiquewhite: "faebd7",
                aqua: "00ffff",
                aquamarine: "7fffd4",
                azure: "f0ffff",
                beige: "f5f5dc",
                bisque: "ffe4c4",
                black: "000000",
                blanchedalmond: "ffebcd",
                blue: "0000ff",
                blueviolet: "8a2be2",
                brown: "a52a2a",
                burlywood: "deb887",
                cadetblue: "5f9ea0",
                chartreuse: "7fff00",
                chocolate: "d2691e",
                coral: "ff7f50",
                cornflowerblue: "6495ed",
                cornsilk: "fff8dc",
                crimson: "dc143c",
                cyan: "00ffff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgoldenrod: "b8860b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkkhaki: "bdb76b",
                darkmagenta: "8b008b",
                darkolivegreen: "556b2f",
                darkorange: "ff8c00",
                darkorchid: "9932cc",
                darkred: "8b0000",
                darksalmon: "e9967a",
                darkseagreen: "8fbc8f",
                darkslateblue: "483d8b",
                darkslategray: "2f4f4f",
                darkturquoise: "00ced1",
                darkviolet: "9400d3",
                deeppink: "ff1493",
                deepskyblue: "00bfff",
                dimgray: "696969",
                dodgerblue: "1e90ff",
                feldspar: "d19275",
                firebrick: "b22222",
                floralwhite: "fffaf0",
                forestgreen: "228b22",
                fuchsia: "ff00ff",
                gainsboro: "dcdcdc",
                ghostwhite: "f8f8ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                honeydew: "f0fff0",
                hotpink: "ff69b4",
                indianred: "cd5c5c",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lavender: "e6e6fa",
                lavenderblush: "fff0f5",
                lawngreen: "7cfc00",
                lemonchiffon: "fffacd",
                lightblue: "add8e6",
                lightcoral: "f08080",
                lightcyan: "e0ffff",
                lightgoldenrodyellow: "fafad2",
                lightgrey: "d3d3d3",
                lightgreen: "90ee90",
                lightpink: "ffb6c1",
                lightsalmon: "ffa07a",
                lightseagreen: "20b2aa",
                lightskyblue: "87cefa",
                lightslateblue: "8470ff",
                lightslategray: "778899",
                lightsteelblue: "b0c4de",
                lightyellow: "ffffe0",
                lime: "00ff00",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "ff00ff",
                maroon: "800000",
                mediumaquamarine: "66cdaa",
                mediumblue: "0000cd",
                mediumorchid: "ba55d3",
                mediumpurple: "9370d8",
                mediumseagreen: "3cb371",
                mediumslateblue: "7b68ee",
                mediumspringgreen: "00fa9a",
                mediumturquoise: "48d1cc",
                mediumvioletred: "c71585",
                midnightblue: "191970",
                mintcream: "f5fffa",
                mistyrose: "ffe4e1",
                moccasin: "ffe4b5",
                navajowhite: "ffdead",
                navy: "000080",
                oldlace: "fdf5e6",
                olive: "808000",
                olivedrab: "6b8e23",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                palegoldenrod: "eee8aa",
                palegreen: "98fb98",
                paleturquoise: "afeeee",
                palevioletred: "d87093",
                papayawhip: "ffefd5",
                peachpuff: "ffdab9",
                peru: "cd853f",
                pink: "ffc0cb",
                plum: "dda0dd",
                powderblue: "b0e0e6",
                purple: "800080",
                red: "ff0000",
                rosybrown: "bc8f8f",
                royalblue: "4169e1",
                saddlebrown: "8b4513",
                salmon: "fa8072",
                sandybrown: "f4a460",
                seagreen: "2e8b57",
                seashell: "fff5ee",
                sienna: "a0522d",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                snow: "fffafa",
                springgreen: "00ff7f",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                thistle: "d8bfd8",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                violetred: "d02090",
                wheat: "f5deb3",
                white: "ffffff",
                whitesmoke: "f5f5f5",
                yellow: "ffff00",
                yellowgreen: "9acd32"
            };
            for(var n in l)t == n && (t = l[n]);
            for(var u = [
                {
                    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                    example: [
                        "rgb(123, 234, 45)",
                        "rgb(255,234,245)"
                    ],
                    process: function process(t) {
                        return [
                            parseInt(t[1]),
                            parseInt(t[2]),
                            parseInt(t[3])
                        ];
                    }
                },
                {
                    re: /^(\w{2})(\w{2})(\w{2})$/,
                    example: [
                        "#00ff00",
                        "336699"
                    ],
                    process: function process(t) {
                        return [
                            parseInt(t[1], 16),
                            parseInt(t[2], 16),
                            parseInt(t[3], 16)
                        ];
                    }
                },
                {
                    re: /^(\w{1})(\w{1})(\w{1})$/,
                    example: [
                        "#fb0",
                        "f0f"
                    ],
                    process: function process(t) {
                        return [
                            parseInt(t[1] + t[1], 16),
                            parseInt(t[2] + t[2], 16),
                            parseInt(t[3] + t[3], 16)
                        ];
                    }
                }
            ], r = 0; r < u.length; r++){
                var i = u[r].re, o = u[r].process, a = i.exec(t);
                a && (e = o(a), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
            }
            this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function() {
                return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
            }, this.toHex = function() {
                var _$t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
                return 1 == _$t.length && (_$t = "0" + _$t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + _$t + e + n;
            }, this.getHelpXML = function() {
                for(var _$t = new Array, e = 0; e < u.length; e++)for(var n = u[e].example, r = 0; r < n.length; r++)_$t[_$t.length] = n[r];
                for(var i in l)_$t[_$t.length] = i;
                var o = document.createElement("ul");
                o.setAttribute("id", "rgbcolor-examples");
                for(e = 0; e < _$t.length; e++)try {
                    var a = document.createElement("li"), s = new f(_$t[e]), h = document.createElement("div");
                    h.style.cssText = "margin: 3px; border: 1px solid black; background:" + s.toHex() + "; color:" + s.toHex(), h.appendChild(document.createTextNode("test"));
                    var c = document.createTextNode(" " + _$t[e] + " -> " + s.toRGB() + " -> " + s.toHex());
                    a.appendChild(h), a.appendChild(c), o.appendChild(a);
                } catch (t) {}
                return o;
            };
        }
        "undefined" != typeof define && define.amd ? define("RGBColor", function() {
            return f;
        }) : (0, module.exports) && (module.exports = f), t.RGBColor = f;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), function(t) {
        var e;
        module.exports = t();
    }(function() {
        return (function o(a, s, h) {
            function c(n, t) {
                if (!s[n]) {
                    if (!a[n]) {
                        var e = undefined;
                        if (!t && e) return e(n, !0);
                        if (l) return l(n, !0);
                        var r = new Error("Cannot find module '" + n + "'");
                        throw r.code = "MODULE_NOT_FOUND", r;
                    }
                    var i = s[n] = {
                        exports: {}
                    };
                    a[n][0].call(i.exports, function(t) {
                        var e = a[n][1][t];
                        return c(e || t);
                    }, i, i.exports, o, a, s, h);
                }
                return s[n].exports;
            }
            for(var l = undefined, t = 0; t < h.length; t++)c(h[t]);
            return c;
        })({
            1: [
                function(t, q, O) {
                    (function(E) {
                        !function(t) {
                            var I = function I(t) {
                                throw RangeError(u[t]);
                            };
                            var d = function d(t, e) {
                                for(var n = t.length; n--;)t[n] = e(t[n]);
                                return t;
                            };
                            var p = function p(t, e) {
                                return d(t.split(l), e).join(".");
                            };
                            var C = function C(t) {
                                for(var e, n, r = [], i = 0, o = t.length; i < o;)55296 <= (e = t.charCodeAt(i++)) && e <= 56319 && i < o ? 56320 == (64512 & (n = t.charCodeAt(i++))) ? r.push(((1023 & e) << 10) + (1023 & n) + 65536) : (r.push(e), i--) : r.push(e);
                                return r;
                            };
                            var T = function T(t) {
                                return d(t, function(t) {
                                    var e = "";
                                    return 65535 < t && (e += A((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += A(t);
                                }).join("");
                            };
                            var F = function F(t, e) {
                                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                            };
                            var P = function P(t, e, n) {
                                var r = 0;
                                for(t = n ? _(t / s) : t >> 1, t += _(t / e); f * b >> 1 < t; r += y)t = _(t / f);
                                return _(r + (f + 1) * t / (t + a));
                            };
                            var g = function g(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f = [], d = t.length, p = 0, g = S, m = x;
                                for((n = t.lastIndexOf(k)) < 0 && (n = 0), r = 0; r < n; ++r)128 <= t.charCodeAt(r) && I("not-basic"), f.push(t.charCodeAt(r));
                                for(i = 0 < n ? n + 1 : 0; i < d;){
                                    for(o = p, a = 1, s = y; d <= i && I("invalid-input"), u = t.charCodeAt(i++), (y <= (h = u - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : y) || h > _((w - p) / a)) && I("overflow"), p += h * a, !(h < (c = s <= m ? v : m + b <= s ? b : s - m)); s += y)a > _(w / (l = y - c)) && I("overflow"), a *= l;
                                    m = P(p - o, e = f.length + 1, 0 == o), _(p / e) > w - g && I("overflow"), g += _(p / e), p %= e, f.splice(p++, 0, g);
                                }
                                return T(f);
                            };
                            var m = function m(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g, m = [];
                                for(f = (t = C(t)).length, e = S, o = x, a = n = 0; a < f; ++a)(u = t[a]) < 128 && m.push(A(u));
                                for(r = i = m.length, i && m.push(k); r < f;){
                                    for(s = w, a = 0; a < f; ++a)e <= (u = t[a]) && u < s && (s = u);
                                    for(s - e > _((w - n) / (d = r + 1)) && I("overflow"), n += (s - e) * d, e = s, a = 0; a < f; ++a)if ((u = t[a]) < e && ++n > w && I("overflow"), u == e) {
                                        for(h = n, c = y; !(h < (l = c <= o ? v : o + b <= c ? b : c - o)); c += y)g = h - l, p = y - l, m.push(A(F(l + g % p, 0))), h = _(g / p);
                                        m.push(A(F(h, 0))), o = P(n, d, r == i), n = 0, ++r;
                                    }
                                    ++n, ++e;
                                }
                                return m.join("");
                            };
                            var e = "object" == typeof O && O, n = "object" == typeof q && q && q.exports == e && q, r = "object" == typeof E && E;
                            r.global !== r && r.window !== r || (t = r);
                            var i, o, w = 2147483647, y = 36, v = 1, b = 26, a = 38, s = 700, x = 72, S = 128, k = "-", h = /^xn--/, c = /[^ -~]/, l = /\x2E|\u3002|\uFF0E|\uFF61/g, u = {
                                overflow: "Overflow: input needs wider integers to process",
                                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                                "invalid-input": "Invalid input"
                            }, f = y - v, _ = Math.floor, A = String.fromCharCode;
                            if (i = {
                                version: "1.2.4",
                                ucs2: {
                                    decode: C,
                                    encode: T
                                },
                                decode: g,
                                encode: m,
                                toASCII: function toASCII(t) {
                                    return p(t, function(t) {
                                        return c.test(t) ? "xn--" + m(t) : t;
                                    });
                                },
                                toUnicode: function toUnicode(t) {
                                    return p(t, function(t) {
                                        return h.test(t) ? g(t.slice(4).toLowerCase()) : t;
                                    });
                                }
                            }, e && !e.nodeType) {
                                if (n) n.exports = i;
                                else for(o in i)i.hasOwnProperty(o) && (e[o] = i[o]);
                            } else t.punycode = i;
                        }(this);
                    }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ],
            2: [
                function(t, e, n) {
                    var i = t("./log");
                    function u(t, e) {
                        for(var n = 3 === t.nodeType ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), r = t.firstChild; r;)!0 !== e && 1 === r.nodeType && "SCRIPT" === r.nodeName || n.appendChild(u(r, e)), r = r.nextSibling;
                        return 1 === t.nodeType && (n._scrollTop = t.scrollTop, n._scrollLeft = t.scrollLeft, "CANVAS" === t.nodeName ? function(e, t) {
                            try {
                                t && (t.width = e.width, t.height = e.height, t.getContext("2d").putImageData(e.getContext("2d").getImageData(0, 0, e.width, e.height), 0, 0));
                            } catch (t) {
                                i("Unable to copy canvas content from", e, t);
                            }
                        }(t, n) : "TEXTAREA" !== t.nodeName && "SELECT" !== t.nodeName || (n.value = t.value)), n;
                    }
                    e.exports = function(o, t, e, n, a, s, h) {
                        var c = u(o.documentElement, a.javascriptEnabled), l = t.createElement("iframe");
                        return l.className = "html2canvas-container", l.style.visibility = "hidden", l.style.position = "fixed", l.style.left = "-10000px", l.style.top = "0px", l.style.border = "0", l.width = e, l.height = n, l.scrolling = "no", t.body.appendChild(l), new Promise(function(e) {
                            var _$t, _$n, r, i = l.contentWindow.document;
                            l.contentWindow.onload = l.onload = function() {
                                var _$t = setInterval(function() {
                                    0 < i.body.childNodes.length && (!function t(e) {
                                        if (1 === e.nodeType) {
                                            e.scrollTop = e._scrollTop, e.scrollLeft = e._scrollLeft;
                                            for(var _$n = e.firstChild; _$n;)t(_$n), _$n = _$n.nextSibling;
                                        }
                                    }(i.documentElement), clearInterval(_$t), "view" === a.type && (l.contentWindow.scrollTo(s, h), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || l.contentWindow.scrollY === h && l.contentWindow.scrollX === s || (i.documentElement.style.top = -h + "px", i.documentElement.style.left = -s + "px", i.documentElement.style.position = "absolute")), e(l));
                                }, 50);
                            }, i.open(), i.write("<!DOCTYPE html><html></html>"), _$n = s, r = h, !(_$t = o).defaultView || _$n === _$t.defaultView.pageXOffset && r === _$t.defaultView.pageYOffset || _$t.defaultView.scrollTo(_$n, r), i.replaceChild(i.adoptNode(c), i.documentElement), i.close();
                        });
                    };
                },
                {
                    "./log": 13
                }
            ],
            3: [
                function(t, e, n) {
                    var r = function r(t) {
                        this.r = 0, this.g = 0, this.b = 0, this.a = null;
                        this.fromArray(t) || this.namedColor(t) || this.rgb(t) || this.rgba(t) || this.hex6(t) || this.hex3(t);
                    };
                    r.prototype.darken = function(t) {
                        var _$e = 1 - t;
                        return new r([
                            Math.round(this.r * _$e),
                            Math.round(this.g * _$e),
                            Math.round(this.b * _$e),
                            this.a
                        ]);
                    }, r.prototype.isTransparent = function() {
                        return 0 === this.a;
                    }, r.prototype.isBlack = function() {
                        return 0 === this.r && 0 === this.g && 0 === this.b;
                    }, r.prototype.fromArray = function(t) {
                        return Array.isArray(t) && (this.r = Math.min(t[0], 255), this.g = Math.min(t[1], 255), this.b = Math.min(t[2], 255), 3 < t.length && (this.a = t[3])), Array.isArray(t);
                    };
                    var i = /^#([a-f0-9]{3})$/i;
                    r.prototype.hex3 = function(t) {
                        var _$e;
                        return null !== (_$e = t.match(i)) && (this.r = parseInt(_$e[1][0] + _$e[1][0], 16), this.g = parseInt(_$e[1][1] + _$e[1][1], 16), this.b = parseInt(_$e[1][2] + _$e[1][2], 16)), null !== _$e;
                    };
                    var o = /^#([a-f0-9]{6})$/i;
                    r.prototype.hex6 = function(t) {
                        var _$e = null;
                        return null !== (_$e = t.match(o)) && (this.r = parseInt(_$e[1].substring(0, 2), 16), this.g = parseInt(_$e[1].substring(2, 4), 16), this.b = parseInt(_$e[1].substring(4, 6), 16)), null !== _$e;
                    };
                    var a = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    r.prototype.rgb = function(t) {
                        var _$e;
                        return null !== (_$e = t.match(a)) && (this.r = Number(_$e[1]), this.g = Number(_$e[2]), this.b = Number(_$e[3])), null !== _$e;
                    };
                    var s = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
                    r.prototype.rgba = function(t) {
                        var _$e;
                        return null !== (_$e = t.match(s)) && (this.r = Number(_$e[1]), this.g = Number(_$e[2]), this.b = Number(_$e[3]), this.a = Number(_$e[4])), null !== _$e;
                    }, r.prototype.toString = function() {
                        return null !== this.a && 1 !== this.a ? "rgba(" + [
                            this.r,
                            this.g,
                            this.b,
                            this.a
                        ].join(",") + ")" : "rgb(" + [
                            this.r,
                            this.g,
                            this.b
                        ].join(",") + ")";
                    }, r.prototype.namedColor = function(t) {
                        t = t.toLowerCase();
                        var _$e = h[t];
                        if (_$e) this.r = _$e[0], this.g = _$e[1], this.b = _$e[2];
                        else if ("transparent" === t) return this.r = this.g = this.b = this.a = 0, !0;
                        return !!_$e;
                    }, r.prototype.isColor = !0;
                    var h = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    e.exports = r;
                },
                {}
            ],
            4: [
                function(t, e, n) {
                    var o = function o(t, e) {
                        var n, r, i = S++;
                        if ((e = e || {}).logging && (w.options.logging = !0, w.options.start = Date.now()), e.async = void 0 === e.async || e.async, e.allowTaint = void 0 !== e.allowTaint && e.allowTaint, e.removeContainer = void 0 === e.removeContainer || e.removeContainer, e.javascriptEnabled = void 0 !== e.javascriptEnabled && e.javascriptEnabled, e.imageTimeout = void 0 === e.imageTimeout ? 1e4 : e.imageTimeout, e.renderer = "function" == typeof e.renderer ? e.renderer : d, e.strict = !!e.strict, "string" == typeof t) {
                            if ("string" != typeof e.proxy) return Promise.reject("Proxy must be used when rendering url");
                            var o = null != e.width ? e.width : window.innerWidth, a = null != e.height ? e.height : window.innerHeight;
                            return v((n = t, r = document.createElement("a"), r.href = n, r.href = r.href, r), e.proxy, document, o, a, e).then(function(t) {
                                return k(t.contentWindow.document.documentElement, t, e, o, a);
                            });
                        }
                        var s, h, c, l, u, f = (void 0 === t ? [
                            document.documentElement
                        ] : t.length ? t : [
                            t
                        ])[0];
                        return f.setAttribute(x + i, i), (s = f.ownerDocument, h = e, c = f.ownerDocument.defaultView.innerWidth, l = f.ownerDocument.defaultView.innerHeight, u = i, y(s, s, c, l, h, s.defaultView.pageXOffset, s.defaultView.pageYOffset).then(function(t) {
                            w("Document cloned");
                            var _$e = x + u, n = "[" + _$e + "='" + u + "']";
                            s.querySelector(n).removeAttribute(_$e);
                            var r = t.contentWindow, i = r.document.querySelector(n), o = "function" == typeof h.onclone ? Promise.resolve(h.onclone(r.document)) : Promise.resolve(!0);
                            return o.then(function() {
                                return k(i, t, h, c, l);
                            });
                        })).then(function(t) {
                            return "function" == typeof e.onrendered && (w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"), e.onrendered(t)), t;
                        });
                    };
                    var k = function k(n, r, i, t, e) {
                        var o, a, s = r.contentWindow, h = new p(s.document), c = new g(i, h), l = b(n), u = "view" === i.type ? t : (o = s.document, Math.max(Math.max(o.body.scrollWidth, o.documentElement.scrollWidth), Math.max(o.body.offsetWidth, o.documentElement.offsetWidth), Math.max(o.body.clientWidth, o.documentElement.clientWidth))), f = "view" === i.type ? e : (a = s.document, Math.max(Math.max(a.body.scrollHeight, a.documentElement.scrollHeight), Math.max(a.body.offsetHeight, a.documentElement.offsetHeight), Math.max(a.body.clientHeight, a.documentElement.clientHeight))), d = new i.renderer(u, f, c, i, document);
                        return new m(n, d, h, c, i).ready.then(function() {
                            var _$t, _$e;
                            return w("Finished rendering"), _$t = "view" === i.type ? _(d.canvas, {
                                width: d.canvas.width,
                                height: d.canvas.height,
                                top: 0,
                                left: 0,
                                x: 0,
                                y: 0
                            }) : n === s.document.body || n === s.document.documentElement || null != i.canvas ? d.canvas : _(d.canvas, {
                                width: null != i.width ? i.width : l.width,
                                height: null != i.height ? i.height : l.height,
                                top: l.top,
                                left: l.left,
                                x: 0,
                                y: 0
                            }), _$e = r, i.removeContainer && (_$e.parentNode.removeChild(_$e), w("Cleaned up container")), _$t;
                        });
                    };
                    var _ = function _(t, e) {
                        var n = document.createElement("canvas"), r = Math.min(t.width - 1, Math.max(0, e.left)), i = Math.min(t.width, Math.max(1, e.left + e.width)), o = Math.min(t.height - 1, Math.max(0, e.top)), a = Math.min(t.height, Math.max(1, e.top + e.height));
                        n.width = e.width, n.height = e.height;
                        var s = i - r, h = a - o;
                        return w("Cropping canvas at:", "left:", e.left, "top:", e.top, "width:", s, "height:", h), w("Resulting crop with width", e.width, "and height", e.height, "with x", r, "and y", o), n.getContext("2d").drawImage(t, r, o, s, h, e.x, e.y, s, h), n;
                    };
                    var p = t("./support"), d = t("./renderers/canvas"), g = t("./imageloader"), m = t("./nodeparser"), r = t("./nodecontainer"), w = t("./log"), i = t("./utils"), y = t("./clone"), v = t("./proxy").loadUrlDocument, b = i.getBounds, x = "data-html2canvas-node", S = 0;
                    o.CanvasRenderer = d, o.NodeContainer = r, o.log = w, o.utils = i;
                    var a = "undefined" == typeof document || "function" != typeof Object.create || "function" != typeof document.createElement("canvas").getContext ? function a() {
                        return Promise.reject("No canvas support");
                    } : o;
                    e.exports = a;
                },
                {
                    "./clone": 2,
                    "./imageloader": 11,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./nodeparser": 15,
                    "./proxy": 16,
                    "./renderers/canvas": 20,
                    "./support": 22,
                    "./utils": 26
                }
            ],
            5: [
                function(t, e, n) {
                    var r = t("./log"), i = t("./utils").smallImage;
                    e.exports = function t(e) {
                        if (this.src = e, r("DummyImageContainer for", e), !this.promise || !this.image) {
                            r("Initiating DummyImageContainer"), t.prototype.image = new Image;
                            var n = this.image;
                            t.prototype.promise = new Promise(function(t, e) {
                                n.onload = t, n.onerror = e, n.src = i(), !0 === n.complete && t(n);
                            });
                        }
                    };
                },
                {
                    "./log": 13,
                    "./utils": 26
                }
            ],
            6: [
                function(t, e, n) {
                    var h = t("./utils").smallImage;
                    e.exports = function(t, e) {
                        var n, r, i = document.createElement("div"), o = document.createElement("img"), a = document.createElement("span"), s = "Hidden Text";
                        i.style.visibility = "hidden", i.style.fontFamily = t, i.style.fontSize = e, i.style.margin = 0, i.style.padding = 0, document.body.appendChild(i), o.src = h(), o.width = 1, o.height = 1, o.style.margin = 0, o.style.padding = 0, o.style.verticalAlign = "baseline", a.style.fontFamily = t, a.style.fontSize = e, a.style.margin = 0, a.style.padding = 0, a.appendChild(document.createTextNode(s)), i.appendChild(a), i.appendChild(o), n = o.offsetTop - a.offsetTop + 1, i.removeChild(a), i.appendChild(document.createTextNode(s)), i.style.lineHeight = "normal", o.style.verticalAlign = "super", r = o.offsetTop - i.offsetTop + 1, document.body.removeChild(i), this.baseline = n, this.lineWidth = 1, this.middle = r;
                    };
                },
                {
                    "./utils": 26
                }
            ],
            7: [
                function(t, e, n) {
                    var i = function i() {
                        this.data = {};
                    };
                    var r = t("./font");
                    i.prototype.getMetrics = function(t, e) {
                        return void 0 === this.data[t + "-" + e] && (this.data[t + "-" + e] = new r(t, e)), this.data[t + "-" + e];
                    }, e.exports = i;
                },
                {
                    "./font": 6
                }
            ],
            8: [
                function(o, t, e) {
                    var n = function n(e, t, n) {
                        this.image = null, this.src = e;
                        var r = this, i = a(e);
                        this.promise = (t ? new Promise(function(t) {
                            "about:blank" === e.contentWindow.document.URL || null == e.contentWindow.document.documentElement ? e.contentWindow.onload = e.onload = function() {
                                t(e);
                            } : t(e);
                        }) : this.proxyLoad(n.proxy, i, n)).then(function(t) {
                            return o("./core")(t.contentWindow.document.documentElement, {
                                type: "view",
                                width: t.width,
                                height: t.height,
                                proxy: n.proxy,
                                javascriptEnabled: n.javascriptEnabled,
                                removeContainer: n.removeContainer,
                                allowTaint: n.allowTaint,
                                imageTimeout: n.imageTimeout / 2
                            });
                        }).then(function(t) {
                            return r.image = t;
                        });
                    };
                    var a = o("./utils").getBounds, i = o("./proxy").loadUrlDocument;
                    n.prototype.proxyLoad = function(t, e, n) {
                        var r = this.src;
                        return i(r.src, t, r.ownerDocument, e.width, e.height, n);
                    }, t.exports = n;
                },
                {
                    "./core": 4,
                    "./proxy": 16,
                    "./utils": 26
                }
            ],
            9: [
                function(t, e, n) {
                    var r = function r(t) {
                        this.src = t.value, this.colorStops = [], this.type = null, this.x0 = .5, this.y0 = .5, this.x1 = .5, this.y1 = .5, this.promise = Promise.resolve(!0);
                    };
                    r.TYPES = {
                        LINEAR: 1,
                        RADIAL: 2
                    }, r.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i, e.exports = r;
                },
                {}
            ],
            10: [
                function(t, e, n) {
                    e.exports = function(n, r) {
                        this.src = n, this.image = new Image;
                        var i = this;
                        this.tainted = null, this.promise = new Promise(function(t, e) {
                            i.image.onload = t, i.image.onerror = e, r && (i.image.crossOrigin = "anonymous"), i.image.src = n, !0 === i.image.complete && t(i.image);
                        });
                    };
                },
                {}
            ],
            11: [
                function(t, e, n) {
                    var d = function d(t, e) {
                        this.link = null, this.options = t, this.support = e, this.origin = this.getOrigin(window.location.href);
                    };
                    var o = t("./log"), r = t("./imagecontainer"), i = t("./dummyimagecontainer"), a = t("./proxyimagecontainer"), s = t("./framecontainer"), h = t("./svgcontainer"), c = t("./svgnodecontainer"), l = t("./lineargradientcontainer"), u = t("./webkitgradientcontainer"), f = t("./utils").bind;
                    d.prototype.findImages = function(t) {
                        var _$e = [];
                        return t.reduce(function(t, e) {
                            switch(e.node.nodeName){
                                case "IMG":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node.src
                                            ],
                                            method: "url"
                                        }
                                    ]);
                                case "svg":
                                case "IFRAME":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node
                                            ],
                                            method: e.node.nodeName
                                        }
                                    ]);
                            }
                            return t;
                        }, []).forEach(this.addImage(_$e, this.loadImage), this), _$e;
                    }, d.prototype.findBackgroundImage = function(t, e) {
                        return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t, this.loadImage), this), t;
                    }, d.prototype.addImage = function(n, r) {
                        return function(e) {
                            e.args.forEach(function(t) {
                                this.imageExists(n, t) || (n.splice(0, 0, r.call(this, e)), o("Added image #" + n.length, "string" == typeof t ? t.substring(0, 100) : t));
                            }, this);
                        };
                    }, d.prototype.hasImageBackground = function(t) {
                        return "none" !== t.method;
                    }, d.prototype.loadImage = function(t) {
                        if ("url" === t.method) {
                            var _$e = t.args[0];
                            return !this.isSVG(_$e) || this.support.svg || this.options.allowTaint ? _$e.match(/data:image\/.*;base64,/i) ? new r(_$e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi, ""), !1) : this.isSameOrigin(_$e) || !0 === this.options.allowTaint || this.isSVG(_$e) ? new r(_$e, !1) : this.support.cors && !this.options.allowTaint && this.options.useCORS ? new r(_$e, !0) : this.options.proxy ? new a(_$e, this.options.proxy) : new i(_$e) : new h(_$e);
                        }
                        return "linear-gradient" === t.method ? new l(t) : "gradient" === t.method ? new u(t) : "svg" === t.method ? new c(t.args[0], this.support.svg) : "IFRAME" === t.method ? new s(t.args[0], this.isSameOrigin(t.args[0].src), this.options) : new i(t);
                    }, d.prototype.isSVG = function(t) {
                        return "svg" === t.substring(t.length - 3).toLowerCase() || h.prototype.isInline(t);
                    }, d.prototype.imageExists = function(t, e) {
                        return t.some(function(t) {
                            return t.src === e;
                        });
                    }, d.prototype.isSameOrigin = function(t) {
                        return this.getOrigin(t) === this.origin;
                    }, d.prototype.getOrigin = function(t) {
                        var _$e = this.link || (this.link = document.createElement("a"));
                        return _$e.href = t, _$e.href = _$e.href, _$e.protocol + _$e.hostname + _$e.port;
                    }, d.prototype.getPromise = function(e) {
                        return this.timeout(e, this.options.imageTimeout).catch(function() {
                            return new i(e.src).promise.then(function(t) {
                                e.image = t;
                            });
                        });
                    }, d.prototype.get = function(e) {
                        var n = null;
                        return this.images.some(function(t) {
                            return (n = t).src === e;
                        }) ? n : null;
                    }, d.prototype.fetch = function(t) {
                        return this.images = t.reduce(f(this.findBackgroundImage, this), this.findImages(t)), this.images.forEach(function(e, n) {
                            e.promise.then(function() {
                                o("Succesfully loaded image #" + (n + 1), e);
                            }, function(t) {
                                o("Failed loading image #" + (n + 1), e, t);
                            });
                        }), this.ready = Promise.all(this.images.map(this.getPromise, this)), o("Finished searching images"), this;
                    }, d.prototype.timeout = function(n, r) {
                        var i, _$t = Promise.race([
                            n.promise,
                            new Promise(function(t, e) {
                                i = setTimeout(function() {
                                    o("Timed out loading image", n), e(n);
                                }, r);
                            })
                        ]).then(function(t) {
                            return clearTimeout(i), t;
                        });
                        return _$t.catch(function() {
                            clearTimeout(i);
                        }), _$t;
                    }, e.exports = d;
                },
                {
                    "./dummyimagecontainer": 5,
                    "./framecontainer": 8,
                    "./imagecontainer": 10,
                    "./lineargradientcontainer": 12,
                    "./log": 13,
                    "./proxyimagecontainer": 17,
                    "./svgcontainer": 23,
                    "./svgnodecontainer": 24,
                    "./utils": 26,
                    "./webkitgradientcontainer": 27
                }
            ],
            12: [
                function(t, e, n) {
                    var i = t("./gradientcontainer"), o = t("./color");
                    function r(t) {
                        i.apply(this, arguments), this.type = i.TYPES.LINEAR;
                        var _$e = r.REGEXP_DIRECTION.test(t.args[0]) || !i.REGEXP_COLORSTOP.test(t.args[0]);
                        _$e ? t.args[0].split(/\s+/).reverse().forEach(function(t, e) {
                            switch(t){
                                case "left":
                                    this.x0 = 0, this.x1 = 1;
                                    break;
                                case "top":
                                    this.y0 = 0, this.y1 = 1;
                                    break;
                                case "right":
                                    this.x0 = 1, this.x1 = 0;
                                    break;
                                case "bottom":
                                    this.y0 = 1, this.y1 = 0;
                                    break;
                                case "to":
                                    var n = this.y0, _$r = this.x0;
                                    this.y0 = this.y1, this.x0 = this.x1, this.x1 = _$r, this.y1 = n;
                                    break;
                                case "center":
                                    break;
                                default:
                                    var i = .01 * parseFloat(t, 10);
                                    if (isNaN(i)) break;
                                    0 === e ? (this.y0 = i, this.y1 = 1 - this.y0) : (this.x0 = i, this.x1 = 1 - this.x0);
                            }
                        }, this) : (this.y0 = 0, this.y1 = 1), this.colorStops = t.args.slice(_$e ? 1 : 0).map(function(t) {
                            var _$e = t.match(i.REGEXP_COLORSTOP), n = +_$e[2], _$r = 0 === n ? "%" : _$e[3];
                            return {
                                color: new o(_$e[1]),
                                stop: "%" === _$r ? n / 100 : null
                            };
                        }), null === this.colorStops[0].stop && (this.colorStops[0].stop = 0), null === this.colorStops[this.colorStops.length - 1].stop && (this.colorStops[this.colorStops.length - 1].stop = 1), this.colorStops.forEach(function(n, r) {
                            null === n.stop && this.colorStops.slice(r).some(function(t, e) {
                                return null !== t.stop && (n.stop = (t.stop - this.colorStops[r - 1].stop) / (e + 1) + this.colorStops[r - 1].stop, !0);
                            }, this);
                        }, this);
                    }
                    r.prototype = Object.create(i.prototype), r.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i, e.exports = r;
                },
                {
                    "./color": 3,
                    "./gradientcontainer": 9
                }
            ],
            13: [
                function(t, e, n) {
                    var r = function r1() {
                        r.options.logging && window.console && window.console.log && Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                            Date.now() - r.options.start + "ms",
                            "html2canvas:"
                        ].concat([].slice.call(arguments, 0)));
                    };
                    r.options = {
                        logging: !1
                    }, e.exports = r;
                },
                {}
            ],
            14: [
                function(t, e, n) {
                    var h = function h(t, e) {
                        this.node = t, this.parent = e, this.stack = null, this.bounds = null, this.borders = null, this.clip = [], this.backgroundClip = [], this.offsetBounds = null, this.visible = null, this.computedStyles = null, this.colors = {}, this.styles = {}, this.backgroundImages = null, this.transformData = null, this.transformMatrix = null, this.isPseudoElement = !1, this.opacity = null;
                    };
                    var c = function c(t) {
                        return -1 !== t.toString().indexOf("%");
                    };
                    var l = function l(t) {
                        return t.replace("px", "");
                    };
                    var u = function u(t) {
                        return parseFloat(t);
                    };
                    var o = t("./color"), r = t("./utils"), i = r.getBounds, a = r.parseBackgrounds, s = r.offsetBounds;
                    h.prototype.cloneTo = function(t) {
                        t.visible = this.visible, t.borders = this.borders, t.bounds = this.bounds, t.clip = this.clip, t.backgroundClip = this.backgroundClip, t.computedStyles = this.computedStyles, t.styles = this.styles, t.backgroundImages = this.backgroundImages, t.opacity = this.opacity;
                    }, h.prototype.getOpacity = function() {
                        return null === this.opacity ? this.opacity = this.cssFloat("opacity") : this.opacity;
                    }, h.prototype.assignStack = function(t) {
                        (this.stack = t).children.push(this);
                    }, h.prototype.isElementVisible = function() {
                        return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : "none" !== this.css("display") && "hidden" !== this.css("visibility") && !this.node.hasAttribute("data-html2canvas-ignore") && ("INPUT" !== this.node.nodeName || "hidden" !== this.node.getAttribute("type"));
                    }, h.prototype.css = function(t) {
                        return this.computedStyles || (this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null)), this.styles[t] || (this.styles[t] = this.computedStyles[t]);
                    }, h.prototype.prefixedCss = function(e) {
                        var n = this.css(e);
                        return void 0 === n && [
                            "webkit",
                            "moz",
                            "ms",
                            "o"
                        ].some(function(t) {
                            return void 0 !== (n = this.css(t + e.substr(0, 1).toUpperCase() + e.substr(1)));
                        }, this), void 0 === n ? null : n;
                    }, h.prototype.computedStyle = function(t) {
                        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, t);
                    }, h.prototype.cssInt = function(t) {
                        var _$e = parseInt(this.css(t), 10);
                        return isNaN(_$e) ? 0 : _$e;
                    }, h.prototype.color = function(t) {
                        return this.colors[t] || (this.colors[t] = new o(this.css(t)));
                    }, h.prototype.cssFloat = function(t) {
                        var _$e = parseFloat(this.css(t));
                        return isNaN(_$e) ? 0 : _$e;
                    }, h.prototype.fontWeight = function() {
                        var _$t = this.css("fontWeight");
                        switch(parseInt(_$t, 10)){
                            case 401:
                                _$t = "bold";
                                break;
                            case 400:
                                _$t = "normal";
                        }
                        return _$t;
                    }, h.prototype.parseClip = function() {
                        var _$t = this.css("clip").match(this.CLIP);
                        return _$t ? {
                            top: parseInt(_$t[1], 10),
                            right: parseInt(_$t[2], 10),
                            bottom: parseInt(_$t[3], 10),
                            left: parseInt(_$t[4], 10)
                        } : null;
                    }, h.prototype.parseBackgroundImages = function() {
                        return this.backgroundImages || (this.backgroundImages = a(this.css("backgroundImage")));
                    }, h.prototype.cssList = function(t, e) {
                        var n = (this.css(t) || "").split(",");
                        return 1 === (n = (n = n[e || 0] || n[0] || "auto").trim().split(" ")).length && (n = [
                            n[0],
                            c(n[0]) ? "auto" : n[0]
                        ]), n;
                    }, h.prototype.parseBackgroundSize = function(t, e, n) {
                        var r, i, o = this.cssList("backgroundSize", n);
                        if (c(o[0])) r = t.width * parseFloat(o[0]) / 100;
                        else {
                            if (/contain|cover/.test(o[0])) {
                                var a = t.width / t.height, s = e.width / e.height;
                                return a < s ^ "contain" === o[0] ? {
                                    width: t.height * s,
                                    height: t.height
                                } : {
                                    width: t.width,
                                    height: t.width / s
                                };
                            }
                            r = parseInt(o[0], 10);
                        }
                        return i = "auto" === o[0] && "auto" === o[1] ? e.height : "auto" === o[1] ? r / e.width * e.height : c(o[1]) ? t.height * parseFloat(o[1]) / 100 : parseInt(o[1], 10), "auto" === o[0] && (r = i / e.height * e.width), {
                            width: r,
                            height: i
                        };
                    }, h.prototype.parseBackgroundPosition = function(t, e, n, r) {
                        var i, o, a = this.cssList("backgroundPosition", n);
                        return i = c(a[0]) ? (t.width - (r || e).width) * (parseFloat(a[0]) / 100) : parseInt(a[0], 10), o = "auto" === a[1] ? i / e.width * e.height : c(a[1]) ? (t.height - (r || e).height) * parseFloat(a[1]) / 100 : parseInt(a[1], 10), "auto" === a[0] && (i = o / e.height * e.width), {
                            left: i,
                            top: o
                        };
                    }, h.prototype.parseBackgroundRepeat = function(t) {
                        return this.cssList("backgroundRepeat", t)[0];
                    }, h.prototype.parseTextShadows = function() {
                        var _$t = this.css("textShadow"), _$e = [];
                        if (_$t && "none" !== _$t) for(var n = _$t.match(this.TEXT_SHADOW_PROPERTY), r = 0; n && r < n.length; r++){
                            var i = n[r].match(this.TEXT_SHADOW_VALUES);
                            _$e.push({
                                color: new o(i[0]),
                                offsetX: i[1] ? parseFloat(i[1].replace("px", "")) : 0,
                                offsetY: i[2] ? parseFloat(i[2].replace("px", "")) : 0,
                                blur: i[3] ? i[3].replace("px", "") : 0
                            });
                        }
                        return _$e;
                    }, h.prototype.parseTransform = function() {
                        if (!this.transformData) {
                            if (this.hasTransform()) {
                                var _$t = this.parseBounds(), _$e = this.prefixedCss("transformOrigin").split(" ").map(l).map(u);
                                _$e[0] += _$t.left, _$e[1] += _$t.top, this.transformData = {
                                    origin: _$e,
                                    matrix: this.parseTransformMatrix()
                                };
                            } else this.transformData = {
                                origin: [
                                    0,
                                    0
                                ],
                                matrix: [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ]
                            };
                        }
                        return this.transformData;
                    }, h.prototype.parseTransformMatrix = function() {
                        if (!this.transformMatrix) {
                            var _$t = this.prefixedCss("transform"), _$e = _$t ? function(t) {
                                if (t && "matrix" === t[1]) return t[2].split(",").map(function(t) {
                                    return parseFloat(t.trim());
                                });
                                if (t && "matrix3d" === t[1]) {
                                    var _$e = t[2].split(",").map(function(t) {
                                        return parseFloat(t.trim());
                                    });
                                    return [
                                        _$e[0],
                                        _$e[1],
                                        _$e[4],
                                        _$e[5],
                                        _$e[12],
                                        _$e[13]
                                    ];
                                }
                            }(_$t.match(this.MATRIX_PROPERTY)) : null;
                            this.transformMatrix = _$e || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                        }
                        return this.transformMatrix;
                    }, h.prototype.parseBounds = function() {
                        return this.bounds || (this.bounds = this.hasTransform() ? s(this.node) : i(this.node));
                    }, h.prototype.hasTransform = function() {
                        return "1,0,0,1,0,0" !== this.parseTransformMatrix().join(",") || this.parent && this.parent.hasTransform();
                    }, h.prototype.getValue = function() {
                        var _$t, _$e, n = this.node.value || "";
                        return "SELECT" === this.node.tagName ? (_$t = this.node, n = (_$e = _$t.options[_$t.selectedIndex || 0]) && _$e.text || "") : "password" === this.node.type && (n = Array(n.length + 1).join("•")), 0 === n.length ? this.node.placeholder || "" : n;
                    }, h.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/, h.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g, h.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g, h.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/, e.exports = h;
                },
                {
                    "./color": 3,
                    "./utils": 26
                }
            ],
            15: [
                function(t, e, n) {
                    var i = function i(t, e, n, r, i) {
                        s("Starting NodeParser"), this.renderer = e, this.options = i, this.range = null, this.support = n, this.renderQueue = [], this.stack = new p(!0, 1, t.ownerDocument, null);
                        var o = new c(t, null);
                        if (i.background && e.rectangle(0, 0, e.width, e.height, new u(i.background)), t === t.ownerDocument.documentElement) {
                            var a = new c(o.color("backgroundColor").isTransparent() ? t.ownerDocument.body : t.ownerDocument.documentElement, null);
                            e.rectangle(0, 0, e.width, e.height, a.color("backgroundColor"));
                        }
                        o.visibile = o.isElementVisible(), this.createPseudoHideStyles(t.ownerDocument), this.disableAnimations(t.ownerDocument), this.nodes = L([
                            o
                        ].concat(this.getChildren(o)).filter(function(t) {
                            return t.visible = t.isElementVisible();
                        }).map(this.getPseudoElements, this)), this.fontMetrics = new l, s("Fetched nodes, total:", this.nodes.length), s("Calculate overflow clips"), this.calculateOverflowClips(), s("Start fetching images"), this.images = r.fetch(this.nodes.filter(j)), this.ready = this.images.ready.then(g(function() {
                            return s("Images loaded, starting parsing"), s("Creating stacking contexts"), this.createStackingContexts(), s("Sorting stacking contexts"), this.sortStackingContexts(this.stack), this.parse(this.stack), s("Render queue created with " + this.renderQueue.length + " items"), new Promise(g(function(t) {
                                i.async ? "function" == typeof i.async ? i.async.call(this, this.renderQueue, t) : 0 < this.renderQueue.length ? (this.renderIndex = 0, this.asyncRenderer(this.renderQueue, t)) : t() : (this.renderQueue.forEach(this.paint, this), t());
                            }, this));
                        }, this));
                    };
                    var o = function o(t) {
                        return t.parent && t.parent.clip.length;
                    };
                    var y = function y() {};
                    var b = function b(a, s, h, c) {
                        return a.map(function(t, e) {
                            if (0 < t.width) {
                                var n = s.left, r = s.top, i = s.width, o = s.height - a[2].width;
                                switch(e){
                                    case 0:
                                        o = a[0].width, t.args = _({
                                            c1: [
                                                n,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r
                                            ],
                                            c3: [
                                                n + i - a[1].width,
                                                r + o
                                            ],
                                            c4: [
                                                n + a[3].width,
                                                r + o
                                            ]
                                        }, c[0], c[1], h.topLeftOuter, h.topLeftInner, h.topRightOuter, h.topRightInner);
                                        break;
                                    case 1:
                                        n = s.left + s.width - a[1].width, i = a[1].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r + o + a[2].width
                                            ],
                                            c3: [
                                                n,
                                                r + o
                                            ],
                                            c4: [
                                                n,
                                                r + a[0].width
                                            ]
                                        }, c[1], c[2], h.topRightOuter, h.topRightInner, h.bottomRightOuter, h.bottomRightInner);
                                        break;
                                    case 2:
                                        r = r + s.height - a[2].width, o = a[2].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r + o
                                            ],
                                            c2: [
                                                n,
                                                r + o
                                            ],
                                            c3: [
                                                n + a[3].width,
                                                r
                                            ],
                                            c4: [
                                                n + i - a[3].width,
                                                r
                                            ]
                                        }, c[2], c[3], h.bottomRightOuter, h.bottomRightInner, h.bottomLeftOuter, h.bottomLeftInner);
                                        break;
                                    case 3:
                                        i = a[3].width, t.args = _({
                                            c1: [
                                                n,
                                                r + o + a[2].width
                                            ],
                                            c2: [
                                                n,
                                                r
                                            ],
                                            c3: [
                                                n + i,
                                                r + a[0].width
                                            ],
                                            c4: [
                                                n + i,
                                                r + o
                                            ]
                                        }, c[3], c[0], h.bottomLeftOuter, h.bottomLeftInner, h.topLeftOuter, h.topLeftInner);
                                }
                            }
                            return t;
                        });
                    };
                    var x = function x(t, e, n, r) {
                        var i = (Math.sqrt(2) - 1) / 3 * 4, o = n * i, a = r * i, s = t + n, h = e + r;
                        return {
                            topLeft: k({
                                x: t,
                                y: h
                            }, {
                                x: t,
                                y: h - a
                            }, {
                                x: s - o,
                                y: e
                            }, {
                                x: s,
                                y: e
                            }),
                            topRight: k({
                                x: t,
                                y: e
                            }, {
                                x: t + o,
                                y: e
                            }, {
                                x: s,
                                y: h - a
                            }, {
                                x: s,
                                y: h
                            }),
                            bottomRight: k({
                                x: s,
                                y: e
                            }, {
                                x: s,
                                y: e + a
                            }, {
                                x: t + o,
                                y: h
                            }, {
                                x: t,
                                y: h
                            }),
                            bottomLeft: k({
                                x: s,
                                y: h
                            }, {
                                x: s - o,
                                y: h
                            }, {
                                x: t,
                                y: e + a
                            }, {
                                x: t,
                                y: e
                            })
                        };
                    };
                    var S = function S(t, e, n) {
                        var r = t.left, i = t.top, o = t.width, a = t.height, s = e[0][0] < o / 2 ? e[0][0] : o / 2, h = e[0][1] < a / 2 ? e[0][1] : a / 2, c = e[1][0] < o / 2 ? e[1][0] : o / 2, l = e[1][1] < a / 2 ? e[1][1] : a / 2, u = e[2][0] < o / 2 ? e[2][0] : o / 2, f = e[2][1] < a / 2 ? e[2][1] : a / 2, d = e[3][0] < o / 2 ? e[3][0] : o / 2, p = e[3][1] < a / 2 ? e[3][1] : a / 2, g = o - c, m = a - f, w = o - u, y = a - p;
                        return {
                            topLeftOuter: x(r, i, s, h).topLeft.subdivide(.5),
                            topLeftInner: x(r + n[3].width, i + n[0].width, Math.max(0, s - n[3].width), Math.max(0, h - n[0].width)).topLeft.subdivide(.5),
                            topRightOuter: x(r + g, i, c, l).topRight.subdivide(.5),
                            topRightInner: x(r + Math.min(g, o + n[3].width), i + n[0].width, g > o + n[3].width ? 0 : c - n[3].width, l - n[0].width).topRight.subdivide(.5),
                            bottomRightOuter: x(r + w, i + m, u, f).bottomRight.subdivide(.5),
                            bottomRightInner: x(r + Math.min(w, o - n[3].width), i + Math.min(m, a + n[0].width), Math.max(0, u - n[1].width), f - n[2].width).bottomRight.subdivide(.5),
                            bottomLeftOuter: x(r, i + y, d, p).bottomLeft.subdivide(.5),
                            bottomLeftInner: x(r + n[3].width, i + y, Math.max(0, d - n[3].width), p - n[2].width).bottomLeft.subdivide(.5)
                        };
                    };
                    var _ = function _(t, e, n, r, i, o, a) {
                        var s = [];
                        return 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            r[1].start.x,
                            r[1].start.y
                        ]), r[1].curveTo(s)) : s.push([
                            "line",
                            t.c1[0],
                            t.c1[1]
                        ]), 0 < n[0] || 0 < n[1] ? (s.push([
                            "line",
                            o[0].start.x,
                            o[0].start.y
                        ]), o[0].curveTo(s), s.push([
                            "line",
                            a[0].end.x,
                            a[0].end.y
                        ]), a[0].curveToReversed(s)) : (s.push([
                            "line",
                            t.c2[0],
                            t.c2[1]
                        ]), s.push([
                            "line",
                            t.c3[0],
                            t.c3[1]
                        ])), 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            i[1].end.x,
                            i[1].end.y
                        ]), i[1].curveToReversed(s)) : s.push([
                            "line",
                            t.c4[0],
                            t.c4[1]
                        ]), s;
                    };
                    var A = function A(t, e, n, r, i, o, a) {
                        0 < e[0] || 0 < e[1] ? (t.push([
                            "line",
                            r[0].start.x,
                            r[0].start.y
                        ]), r[0].curveTo(t), r[1].curveTo(t)) : t.push([
                            "line",
                            o,
                            a
                        ]), (0 < n[0] || 0 < n[1]) && t.push([
                            "line",
                            i[0].start.x,
                            i[0].start.y
                        ]);
                    };
                    var I = function I(t) {
                        return t.cssInt("zIndex") < 0;
                    };
                    var C = function C(t) {
                        return 0 < t.cssInt("zIndex");
                    };
                    var T = function T(t) {
                        return 0 === t.cssInt("zIndex");
                    };
                    var F = function F(t) {
                        return -1 !== [
                            "inline",
                            "inline-block",
                            "inline-table"
                        ].indexOf(t.css("display"));
                    };
                    var P = function P(t) {
                        return t instanceof p;
                    };
                    var E = function E(t) {
                        return 0 < t.node.data.trim().length;
                    };
                    var q = function q(t) {
                        return t.nodeType === Node.TEXT_NODE || t.nodeType === Node.ELEMENT_NODE;
                    };
                    var O = function O(t) {
                        return "static" !== t.css("position");
                    };
                    var B = function B(t) {
                        return "none" !== t.css("float");
                    };
                    var R = function R(t) {
                        var _$e = this;
                        return function() {
                            return !t.apply(_$e, arguments);
                        };
                    };
                    var j = function j(t) {
                        return t.node.nodeType === Node.ELEMENT_NODE;
                    };
                    var D = function D(t) {
                        return !0 === t.isPseudoElement;
                    };
                    var M = function M(t) {
                        return t.node.nodeType === Node.TEXT_NODE;
                    };
                    var U = function U(t) {
                        return parseInt(t, 10);
                    };
                    var N = function N(t) {
                        return t.width;
                    };
                    var z = function z(t) {
                        return t.node.nodeType !== Node.ELEMENT_NODE || -1 === [
                            "SCRIPT",
                            "HEAD",
                            "TITLE",
                            "OBJECT",
                            "BR",
                            "OPTION"
                        ].indexOf(t.node.nodeName);
                    };
                    var L = function L(t) {
                        return [].concat.apply([], t);
                    };
                    var s = t("./log"), h = t("punycode"), c = t("./nodecontainer"), f = t("./textcontainer"), d = t("./pseudoelementcontainer"), l = t("./fontmetrics"), u = t("./color"), p = t("./stackingcontext"), r = t("./utils"), g = r.bind, a = r.getBounds, m = r.parseBackgrounds, w = r.offsetBounds;
                    i.prototype.calculateOverflowClips = function() {
                        this.nodes.forEach(function(t) {
                            if (j(t)) {
                                D(t) && t.appendToDOM(), t.borders = this.parseBorders(t);
                                var _$e = "hidden" === t.css("overflow") ? [
                                    t.borders.clip
                                ] : [], n = t.parseClip();
                                n && -1 !== [
                                    "absolute",
                                    "fixed"
                                ].indexOf(t.css("position")) && _$e.push([
                                    [
                                        "rect",
                                        t.bounds.left + n.left,
                                        t.bounds.top + n.top,
                                        n.right - n.left,
                                        n.bottom - n.top
                                    ]
                                ]), t.clip = o(t) ? t.parent.clip.concat(_$e) : _$e, t.backgroundClip = "hidden" !== t.css("overflow") ? t.clip.concat([
                                    t.borders.clip
                                ]) : t.clip, D(t) && t.cleanDOM();
                            } else M(t) && (t.clip = o(t) ? t.parent.clip : []);
                            D(t) || (t.bounds = null);
                        }, this);
                    }, i.prototype.asyncRenderer = function(t, e, n) {
                        n = n || Date.now(), this.paint(t[this.renderIndex++]), t.length === this.renderIndex ? e() : n + 20 > Date.now() ? this.asyncRenderer(t, e, n) : setTimeout(g(function() {
                            this.asyncRenderer(t, e);
                        }, this), 0);
                    }, i.prototype.createPseudoHideStyles = function(t) {
                        this.createStyles(t, "." + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }.' + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
                    }, i.prototype.disableAnimations = function(t) {
                        this.createStyles(t, "* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}");
                    }, i.prototype.createStyles = function(t, e) {
                        var n = t.createElement("style");
                        n.innerHTML = e, t.body.appendChild(n);
                    }, i.prototype.getPseudoElements = function(t) {
                        var _$e = [
                            [
                                t
                            ]
                        ];
                        if (t.node.nodeType === Node.ELEMENT_NODE) {
                            var n = this.getPseudoElement(t, ":before"), r = this.getPseudoElement(t, ":after");
                            n && _$e.push(n), r && _$e.push(r);
                        }
                        return L(_$e);
                    }, i.prototype.getPseudoElement = function(t, e) {
                        var n = t.computedStyle(e);
                        if (!n || !n.content || "none" === n.content || "-moz-alt-content" === n.content || "none" === n.display) return null;
                        for(var r, i, o = (r = n.content, (i = r.substr(0, 1)) === r.substr(r.length - 1) && i.match(/'|"/) ? r.substr(1, r.length - 2) : r), a = "url" === o.substr(0, 3), s = document.createElement(a ? "img" : "html2canvaspseudoelement"), h = new d(s, t, e), c = n.length - 1; 0 <= c; c--){
                            var l = n.item(c).replace(/(\-[a-z])/g, function(t) {
                                return t.toUpperCase().replace("-", "");
                            });
                            s.style[l] = n[l];
                        }
                        if (s.className = d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER, a) return s.src = m(o)[0].args[0], [
                            h
                        ];
                        var u = document.createTextNode(o);
                        return s.appendChild(u), [
                            h,
                            new f(u, h)
                        ];
                    }, i.prototype.getChildren = function(n) {
                        return L([].filter.call(n.node.childNodes, q).map(function(t) {
                            var _$e = [
                                t.nodeType === Node.TEXT_NODE ? new f(t, n) : new c(t, n)
                            ].filter(z);
                            return t.nodeType === Node.ELEMENT_NODE && _$e.length && "TEXTAREA" !== t.tagName ? _$e[0].isElementVisible() ? _$e.concat(this.getChildren(_$e[0])) : [] : _$e;
                        }, this));
                    }, i.prototype.newStackingContext = function(t, e) {
                        var n = new p(e, t.getOpacity(), t.node, t.parent);
                        t.cloneTo(n), (e ? n.getParentStack(this) : n.parent.stack).contexts.push(n), t.stack = n;
                    }, i.prototype.createStackingContexts = function() {
                        this.nodes.forEach(function(t) {
                            var _$e, n;
                            j(t) && (this.isRootElement(t) || t.getOpacity() < 1 || (n = (_$e = t).css("position"), "auto" !== (-1 !== [
                                "absolute",
                                "relative",
                                "fixed"
                            ].indexOf(n) ? _$e.css("zIndex") : "auto")) || this.isBodyWithTransparentRoot(t) || t.hasTransform()) ? this.newStackingContext(t, !0) : j(t) && (O(t) && T(t) || -1 !== [
                                "inline-block",
                                "inline-table"
                            ].indexOf(t.css("display")) || B(t)) ? this.newStackingContext(t, !1) : t.assignStack(t.parent.stack);
                        }, this);
                    }, i.prototype.isBodyWithTransparentRoot = function(t) {
                        return "BODY" === t.node.nodeName && t.parent.color("backgroundColor").isTransparent();
                    }, i.prototype.isRootElement = function(t) {
                        return null === t.parent;
                    }, i.prototype.sortStackingContexts = function(t) {
                        var n;
                        t.contexts.sort((n = t.contexts.slice(0), function(t, e) {
                            return t.cssInt("zIndex") + n.indexOf(t) / n.length - (e.cssInt("zIndex") + n.indexOf(e) / n.length);
                        })), t.contexts.forEach(this.sortStackingContexts, this);
                    }, i.prototype.parseTextBounds = function(a) {
                        return function(t, e, n) {
                            if ("none" !== a.parent.css("textDecoration").substr(0, 4) || 0 !== t.trim().length) {
                                if (this.support.rangeBounds && !a.parent.hasTransform()) {
                                    var r = n.slice(0, e).join("").length;
                                    return this.getRangeBounds(a.node, r, t.length);
                                }
                                if (a.node && "string" == typeof a.node.data) {
                                    var i = a.node.splitText(t.length), o = this.getWrapperBounds(a.node, a.parent.hasTransform());
                                    return a.node = i, o;
                                }
                            } else this.support.rangeBounds && !a.parent.hasTransform() || (a.node = a.node.splitText(t.length));
                            return {};
                        };
                    }, i.prototype.getWrapperBounds = function(t, e) {
                        var n = t.ownerDocument.createElement("html2canvaswrapper"), r = t.parentNode, i = t.cloneNode(!0);
                        n.appendChild(t.cloneNode(!0)), r.replaceChild(n, t);
                        var o = e ? w(n) : a(n);
                        return r.replaceChild(i, n), o;
                    }, i.prototype.getRangeBounds = function(t, e, n) {
                        var r = this.range || (this.range = t.ownerDocument.createRange());
                        return r.setStart(t, e), r.setEnd(t, e + n), r.getBoundingClientRect();
                    }, i.prototype.parse = function(t) {
                        var _$e = t.contexts.filter(I), n = t.children.filter(j), r = n.filter(R(B)), i = r.filter(R(O)).filter(R(F)), o = n.filter(R(O)).filter(B), a = r.filter(R(O)).filter(F), s = t.contexts.concat(r.filter(O)).filter(T), h = t.children.filter(M).filter(E), c = t.contexts.filter(C);
                        _$e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t) {
                            this.renderQueue.push(t), P(t) && (this.parse(t), this.renderQueue.push(new y));
                        }, this);
                    }, i.prototype.paint = function(t) {
                        try {
                            t instanceof y ? this.renderer.ctx.restore() : M(t) ? (D(t.parent) && t.parent.appendToDOM(), this.paintText(t), D(t.parent) && t.parent.cleanDOM()) : this.paintNode(t);
                        } catch (t) {
                            if (s(t), this.options.strict) throw t;
                        }
                    }, i.prototype.paintNode = function(t) {
                        P(t) && (this.renderer.setOpacity(t.opacity), this.renderer.ctx.save(), t.hasTransform() && this.renderer.setTransform(t.parseTransform())), "INPUT" === t.node.nodeName && "checkbox" === t.node.type ? this.paintCheckbox(t) : "INPUT" === t.node.nodeName && "radio" === t.node.type ? this.paintRadio(t) : this.paintElement(t);
                    }, i.prototype.paintElement = function(n) {
                        var r = n.parseBounds();
                        this.renderer.clip(n.backgroundClip, function() {
                            this.renderer.renderBackground(n, r, n.borders.borders.map(N));
                        }, this), this.renderer.clip(n.clip, function() {
                            this.renderer.renderBorders(n.borders.borders);
                        }, this), this.renderer.clip(n.backgroundClip, function() {
                            switch(n.node.nodeName){
                                case "svg":
                                case "IFRAME":
                                    var _$t = this.images.get(n.node);
                                    _$t ? this.renderer.renderImage(n, r, n.borders, _$t) : s("Error loading <" + n.node.nodeName + ">", n.node);
                                    break;
                                case "IMG":
                                    var _$e = this.images.get(n.node.src);
                                    _$e ? this.renderer.renderImage(n, r, n.borders, _$e) : s("Error loading <img>", n.node.src);
                                    break;
                                case "CANVAS":
                                    this.renderer.renderImage(n, r, n.borders, {
                                        image: n.node
                                    });
                                    break;
                                case "SELECT":
                                case "INPUT":
                                case "TEXTAREA":
                                    this.paintFormValue(n);
                            }
                        }, this);
                    }, i.prototype.paintCheckbox = function(t) {
                        var _$e = t.parseBounds(), n = Math.min(_$e.width, _$e.height), r = {
                            width: n - 1,
                            height: n - 1,
                            top: _$e.top,
                            left: _$e.left
                        }, i = [
                            3,
                            3
                        ], o = [
                            i,
                            i,
                            i,
                            i
                        ], a = [
                            1,
                            1,
                            1,
                            1
                        ].map(function(t) {
                            return {
                                color: new u("#A5A5A5"),
                                width: t
                            };
                        }), s = S(r, o, a);
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.rectangle(r.left + 1, r.top + 1, r.width - 2, r.height - 2, new u("#DEDEDE")), this.renderer.renderBorders(b(a, r, s, o)), t.node.checked && (this.renderer.font(new u("#424242"), "normal", "normal", "bold", n - 3 + "px", "arial"), this.renderer.text("✔", r.left + n / 6, r.top + n - 1));
                        }, this);
                    }, i.prototype.paintRadio = function(t) {
                        var _$e = t.parseBounds(), n = Math.min(_$e.width, _$e.height) - 2;
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.circleStroke(_$e.left + 1, _$e.top + 1, n, new u("#DEDEDE"), 1, new u("#A5A5A5")), t.node.checked && this.renderer.circle(Math.ceil(_$e.left + n / 4) + 1, Math.ceil(_$e.top + n / 4) + 1, Math.floor(n / 2), new u("#424242"));
                        }, this);
                    }, i.prototype.paintFormValue = function(e) {
                        var _$t = e.getValue();
                        if (0 < _$t.length) {
                            var n = e.node.ownerDocument, r = n.createElement("html2canvaswrapper");
                            [
                                "lineHeight",
                                "textAlign",
                                "fontFamily",
                                "fontWeight",
                                "fontSize",
                                "color",
                                "paddingLeft",
                                "paddingTop",
                                "paddingRight",
                                "paddingBottom",
                                "width",
                                "height",
                                "borderLeftStyle",
                                "borderTopStyle",
                                "borderLeftWidth",
                                "borderTopWidth",
                                "boxSizing",
                                "whiteSpace",
                                "wordWrap"
                            ].forEach(function(t) {
                                try {
                                    r.style[t] = e.css(t);
                                } catch (t) {
                                    s("html2canvas: Parse: Exception caught in renderFormValue: " + t.message);
                                }
                            });
                            var i = e.parseBounds();
                            r.style.position = "fixed", r.style.left = i.left + "px", r.style.top = i.top + "px", r.textContent = _$t, n.body.appendChild(r), this.paintText(new f(r.firstChild, e)), n.body.removeChild(r);
                        }
                    }, i.prototype.paintText = function(n) {
                        n.applyTextTransform();
                        var _$t, _$e = h.ucs2.decode(n.node.data), r = this.options.letterRendering && !/^(normal|none|0px)$/.test(n.parent.css("letterSpacing")) || (_$t = n.node.data, /[^\u0000-\u00ff]/.test(_$t)) ? _$e.map(function(t) {
                            return h.ucs2.encode([
                                t
                            ]);
                        }) : function(t) {
                            var _$e, _$n = [], r = 0, i = !1;
                            for(; t.length;)o = t[r], -1 !== [
                                32,
                                13,
                                10,
                                9,
                                45
                            ].indexOf(o) === i ? ((_$e = t.splice(0, r)).length && _$n.push(h.ucs2.encode(_$e)), i = !i, r = 0) : r++, r >= t.length && (_$e = t.splice(0, r)).length && _$n.push(h.ucs2.encode(_$e));
                            var o;
                            return _$n;
                        }(_$e), i = n.parent.fontWeight(), o = n.parent.css("fontSize"), a = n.parent.css("fontFamily"), s = n.parent.parseTextShadows();
                        this.renderer.font(n.parent.color("color"), n.parent.css("fontStyle"), n.parent.css("fontVariant"), i, o, a), s.length ? this.renderer.fontShadow(s[0].color, s[0].offsetX, s[0].offsetY, s[0].blur) : this.renderer.clearShadow(), this.renderer.clip(n.parent.clip, function() {
                            r.map(this.parseTextBounds(n), this).forEach(function(t, e) {
                                t && !1 === /^\s*$/.test(r[e]) && (this.renderer.text(r[e], t.left, t.bottom), this.renderTextDecoration(n.parent, t, this.fontMetrics.getMetrics(a, o)));
                            }, this);
                        }, this);
                    }, i.prototype.renderTextDecoration = function(t, e, n) {
                        switch(t.css("textDecoration").split(" ")[0]){
                            case "underline":
                                this.renderer.rectangle(e.left, Math.round(e.top + n.baseline + n.lineWidth), e.width, 1, t.color("color"));
                                break;
                            case "overline":
                                this.renderer.rectangle(e.left, Math.round(e.top), e.width, 1, t.color("color"));
                                break;
                            case "line-through":
                                this.renderer.rectangle(e.left, Math.ceil(e.top + n.middle + n.lineWidth), e.width, 1, t.color("color"));
                        }
                    };
                    var v = {
                        inset: [
                            [
                                "darken",
                                .6
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .6
                            ]
                        ]
                    };
                    function k(s, h, c, l) {
                        var u = function u(t, e, n) {
                            return {
                                x: t.x + (e.x - t.x) * n,
                                y: t.y + (e.y - t.y) * n
                            };
                        };
                        return {
                            start: s,
                            startControl: h,
                            endControl: c,
                            end: l,
                            subdivide: function subdivide(t) {
                                var _$e = u(s, h, t), n = u(h, c, t), r = u(c, l, t), i = u(_$e, n, t), o = u(n, r, t), a = u(i, o, t);
                                return [
                                    k(s, _$e, i, a),
                                    k(a, o, r, l)
                                ];
                            },
                            curveTo: function curveTo(t) {
                                t.push([
                                    "bezierCurve",
                                    h.x,
                                    h.y,
                                    c.x,
                                    c.y,
                                    l.x,
                                    l.y
                                ]);
                            },
                            curveToReversed: function curveToReversed(t) {
                                t.push([
                                    "bezierCurve",
                                    c.x,
                                    c.y,
                                    h.x,
                                    h.y,
                                    s.x,
                                    s.y
                                ]);
                            }
                        };
                    }
                    i.prototype.parseBorders = function(o) {
                        var r, _$t = o.parseBounds(), _$e = (r = o, [
                            "TopLeft",
                            "TopRight",
                            "BottomRight",
                            "BottomLeft"
                        ].map(function(t) {
                            var _$e = r.css("border" + t + "Radius"), n = _$e.split(" ");
                            return n.length <= 1 && (n[1] = n[0]), n.map(U);
                        })), n = [
                            "Top",
                            "Right",
                            "Bottom",
                            "Left"
                        ].map(function(t, e) {
                            var n = o.css("border" + t + "Style"), r = o.color("border" + t + "Color");
                            "inset" === n && r.isBlack() && (r = new u([
                                255,
                                255,
                                255,
                                r.a
                            ]));
                            var i = v[n] ? v[n][e] : null;
                            return {
                                width: o.cssInt("border" + t + "Width"),
                                color: i ? r[i[0]](i[1]) : r,
                                args: null
                            };
                        }), i = S(_$t, _$e, n);
                        return {
                            clip: this.parseBackgroundClip(o, i, n, _$e, _$t),
                            borders: b(n, _$t, i, _$e)
                        };
                    }, i.prototype.parseBackgroundClip = function(t, e, n, r, i) {
                        var o = [];
                        switch(t.css("backgroundClip")){
                            case "content-box":
                            case "padding-box":
                                A(o, r[0], r[1], e.topLeftInner, e.topRightInner, i.left + n[3].width, i.top + n[0].width), A(o, r[1], r[2], e.topRightInner, e.bottomRightInner, i.left + i.width - n[1].width, i.top + n[0].width), A(o, r[2], r[3], e.bottomRightInner, e.bottomLeftInner, i.left + i.width - n[1].width, i.top + i.height - n[2].width), A(o, r[3], r[0], e.bottomLeftInner, e.topLeftInner, i.left + n[3].width, i.top + i.height - n[2].width);
                                break;
                            default:
                                A(o, r[0], r[1], e.topLeftOuter, e.topRightOuter, i.left, i.top), A(o, r[1], r[2], e.topRightOuter, e.bottomRightOuter, i.left + i.width, i.top), A(o, r[2], r[3], e.bottomRightOuter, e.bottomLeftOuter, i.left + i.width, i.top + i.height), A(o, r[3], r[0], e.bottomLeftOuter, e.topLeftOuter, i.left, i.top + i.height);
                        }
                        return o;
                    }, e.exports = i;
                },
                {
                    "./color": 3,
                    "./fontmetrics": 7,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./pseudoelementcontainer": 18,
                    "./stackingcontext": 21,
                    "./textcontainer": 25,
                    "./utils": 26,
                    punycode: 1
                }
            ],
            16: [
                function(t, e, n) {
                    var l = function l(t, e, n) {
                        var r = "withCredentials" in new XMLHttpRequest;
                        if (!e) return Promise.reject("No proxy configured");
                        var i = f(r), o = d(e, t, i);
                        return r ? a(o) : u(n, o, i).then(function(t) {
                            return c(t.content);
                        });
                    };
                    var u = function u(i, o, a) {
                        return new Promise(function(e, n) {
                            var _$t = i.createElement("script"), r = function r() {
                                delete window.html2canvas.proxy[a], i.body.removeChild(_$t);
                            };
                            window.html2canvas.proxy[a] = function(t) {
                                r(), e(t);
                            }, _$t.src = o, _$t.onerror = function(t) {
                                r(), n(t);
                            }, i.body.appendChild(_$t);
                        });
                    };
                    var f = function f(t) {
                        return t ? "" : "html2canvas_" + Date.now() + "_" + ++i + "_" + Math.round(1e5 * Math.random());
                    };
                    var d = function d(t, e, n) {
                        return t + "?url=" + encodeURIComponent(e) + (n.length ? "&callback=html2canvas.proxy." + n : "");
                    };
                    var a = t("./xhr"), r = t("./utils"), s = t("./log"), h = t("./clone"), c = r.decode64;
                    var i = 0;
                    n.Proxy = l, n.ProxyURL = function(t, e, n) {
                        var r = "crossOrigin" in new Image, i = f(r), o = d(e, t, i);
                        return r ? Promise.resolve(o) : u(n, o, i).then(function(t) {
                            return "data:" + t.type + ";base64," + t.content;
                        });
                    }, n.loadUrlDocument = function(t, e, n, r, i, o) {
                        var a;
                        return new l(t, e, window.document).then((a = t, function(e) {
                            var _$n, _$t = new DOMParser;
                            try {
                                _$n = _$t.parseFromString(e, "text/html");
                            } catch (t) {
                                s("DOMParser not supported, falling back to createHTMLDocument"), _$n = document.implementation.createHTMLDocument("");
                                try {
                                    _$n.open(), _$n.write(e), _$n.close();
                                } catch (t) {
                                    s("createHTMLDocument write not supported, falling back to document.body.innerHTML"), _$n.body.innerHTML = e;
                                }
                            }
                            var r = _$n.querySelector("base");
                            if (!r || !r.href.host) {
                                var i = _$n.createElement("base");
                                i.href = a, _$n.head.insertBefore(i, _$n.head.firstChild);
                            }
                            return _$n;
                        })).then(function(t) {
                            return h(t, n, r, i, o, 0, 0);
                        });
                    };
                },
                {
                    "./clone": 2,
                    "./log": 13,
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            17: [
                function(t, e, n) {
                    var o = t("./proxy").ProxyURL;
                    e.exports = function(n, r) {
                        var _$t = document.createElement("a");
                        _$t.href = n, n = _$t.href, this.src = n, this.image = new Image;
                        var i = this;
                        this.promise = new Promise(function(t, e) {
                            i.image.crossOrigin = "Anonymous", i.image.onload = t, i.image.onerror = e, new o(n, r, document).then(function(t) {
                                i.image.src = t;
                            }).catch(e);
                        });
                    };
                },
                {
                    "./proxy": 16
                }
            ],
            18: [
                function(t, e, n) {
                    var i = function i(t, e, n) {
                        r.call(this, t, e), this.isPseudoElement = !0, this.before = ":before" === n;
                    };
                    var r = t("./nodecontainer");
                    i.prototype.cloneTo = function(t) {
                        i.prototype.cloneTo.call(this, t), t.isPseudoElement = !0, t.before = this.before;
                    }, (i.prototype = Object.create(r.prototype)).appendToDOM = function() {
                        this.before ? this.parent.node.insertBefore(this.node, this.parent.node.firstChild) : this.parent.node.appendChild(this.node), this.parent.node.className += " " + this.getHideClass();
                    }, i.prototype.cleanDOM = function() {
                        this.node.parentNode.removeChild(this.node), this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
                    }, i.prototype.getHideClass = function() {
                        return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
                    }, i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before", i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after", e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            19: [
                function(t, e, n) {
                    var r = function r(t, e, n, r, i) {
                        this.width = t, this.height = e, this.images = n, this.options = r, this.document = i;
                    };
                    var h = t("./log");
                    r.prototype.renderImage = function(t, e, n, r) {
                        var i = t.cssInt("paddingLeft"), o = t.cssInt("paddingTop"), a = t.cssInt("paddingRight"), s = t.cssInt("paddingBottom"), h = n.borders, c = e.width - (h[1].width + h[3].width + i + a), l = e.height - (h[0].width + h[2].width + o + s);
                        this.drawImage(r, 0, 0, r.image.width || c, r.image.height || l, e.left + i + h[3].width, e.top + o + h[0].width, c, l);
                    }, r.prototype.renderBackground = function(t, e, n) {
                        0 < e.height && 0 < e.width && (this.renderBackgroundColor(t, e), this.renderBackgroundImage(t, e, n));
                    }, r.prototype.renderBackgroundColor = function(t, e) {
                        var n = t.color("backgroundColor");
                        n.isTransparent() || this.rectangle(e.left, e.top, e.width, e.height, n);
                    }, r.prototype.renderBorders = function(t) {
                        t.forEach(this.renderBorder, this);
                    }, r.prototype.renderBorder = function(t) {
                        t.color.isTransparent() || null === t.args || this.drawShape(t.args, t.color);
                    }, r.prototype.renderBackgroundImage = function(o, a, s) {
                        o.parseBackgroundImages().reverse().forEach(function(t, e, n) {
                            switch(t.method){
                                case "url":
                                    var r = this.images.get(t.args[0]);
                                    r ? this.renderBackgroundRepeating(o, a, r, n.length - (e + 1), s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "linear-gradient":
                                case "gradient":
                                    var i = this.images.get(t.value);
                                    i ? this.renderBackgroundGradient(i, a, s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "none":
                                    break;
                                default:
                                    h("Unknown background-image type", t.args[0]);
                            }
                        }, this);
                    }, r.prototype.renderBackgroundRepeating = function(t, e, n, r, i) {
                        var o = t.parseBackgroundSize(e, n.image, r), a = t.parseBackgroundPosition(e, n.image, r, o);
                        switch(t.parseBackgroundRepeat(r)){
                            case "repeat-x":
                            case "repeat no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + i[3], e.top + a.top + i[0], 99999, o.height, i);
                                break;
                            case "repeat-y":
                            case "no-repeat repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + i[0], o.width, 99999, i);
                                break;
                            case "no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + a.top + i[0], o.width, o.height, i);
                                break;
                            default:
                                this.renderBackgroundRepeat(n, a, o, {
                                    top: e.top,
                                    left: e.left
                                }, i[3], i[0]);
                        }
                    }, e.exports = r;
                },
                {
                    "./log": 13
                }
            ],
            20: [
                function(t, e, n) {
                    var a = function a(t, e) {
                        r.apply(this, arguments), this.canvas = this.options.canvas || this.document.createElement("canvas"), this.options.canvas || (this.canvas.width = t, this.canvas.height = e), this.ctx = this.canvas.getContext("2d"), this.taintCtx = this.document.createElement("canvas").getContext("2d"), this.ctx.textBaseline = "bottom", this.variables = {}, o("Initialized CanvasRenderer with size", t, "x", e);
                    };
                    var s = function s(t) {
                        return 0 < t.length;
                    };
                    var r = t("../renderer"), i = t("../lineargradientcontainer"), o = t("../log");
                    (a.prototype = Object.create(r.prototype)).setFillStyle = function(t) {
                        return this.ctx.fillStyle = "object" == typeof t && t.isColor ? t.toString() : t, this.ctx;
                    }, a.prototype.rectangle = function(t, e, n, r, i) {
                        this.setFillStyle(i).fillRect(t, e, n, r);
                    }, a.prototype.circle = function(t, e, n, r) {
                        this.setFillStyle(r), this.ctx.beginPath(), this.ctx.arc(t + n / 2, e + n / 2, n / 2, 0, 2 * Math.PI, !0), this.ctx.closePath(), this.ctx.fill();
                    }, a.prototype.circleStroke = function(t, e, n, r, i, o) {
                        this.circle(t, e, n, r), this.ctx.strokeStyle = o.toString(), this.ctx.stroke();
                    }, a.prototype.drawShape = function(t, e) {
                        this.shape(t), this.setFillStyle(e).fill();
                    }, a.prototype.taints = function(e) {
                        if (null === e.tainted) {
                            this.taintCtx.drawImage(e.image, 0, 0);
                            try {
                                this.taintCtx.getImageData(0, 0, 1, 1), e.tainted = !1;
                            } catch (t) {
                                this.taintCtx = document.createElement("canvas").getContext("2d"), e.tainted = !0;
                            }
                        }
                        return e.tainted;
                    }, a.prototype.drawImage = function(t, e, n, r, i, o, a, s, h) {
                        this.taints(t) && !this.options.allowTaint || this.ctx.drawImage(t.image, e, n, r, i, o, a, s, h);
                    }, a.prototype.clip = function(t, e, n) {
                        this.ctx.save(), t.filter(s).forEach(function(t) {
                            this.shape(t).clip();
                        }, this), e.call(n), this.ctx.restore();
                    }, a.prototype.shape = function(t) {
                        return this.ctx.beginPath(), t.forEach(function(t, e) {
                            "rect" === t[0] ? this.ctx.rect.apply(this.ctx, t.slice(1)) : this.ctx[0 === e ? "moveTo" : t[0] + "To"].apply(this.ctx, t.slice(1));
                        }, this), this.ctx.closePath(), this.ctx;
                    }, a.prototype.font = function(t, e, n, r, i, o) {
                        this.setFillStyle(t).font = [
                            e,
                            n,
                            r,
                            i,
                            o
                        ].join(" ").split(",")[0];
                    }, a.prototype.fontShadow = function(t, e, n, r) {
                        this.setVariable("shadowColor", t.toString()).setVariable("shadowOffsetY", e).setVariable("shadowOffsetX", n).setVariable("shadowBlur", r);
                    }, a.prototype.clearShadow = function() {
                        this.setVariable("shadowColor", "rgba(0,0,0,0)");
                    }, a.prototype.setOpacity = function(t) {
                        this.ctx.globalAlpha = t;
                    }, a.prototype.setTransform = function(t) {
                        this.ctx.translate(t.origin[0], t.origin[1]), this.ctx.transform.apply(this.ctx, t.matrix), this.ctx.translate(-t.origin[0], -t.origin[1]);
                    }, a.prototype.setVariable = function(t, e) {
                        return this.variables[t] !== e && (this.variables[t] = this.ctx[t] = e), this;
                    }, a.prototype.text = function(t, e, n) {
                        this.ctx.fillText(t, e, n);
                    }, a.prototype.backgroundRepeatShape = function(t, e, n, r, i, o, a, s, h) {
                        var c = [
                            [
                                "line",
                                Math.round(i),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(s + o)
                            ],
                            [
                                "line",
                                Math.round(i),
                                Math.round(s + o)
                            ]
                        ];
                        this.clip([
                            c
                        ], function() {
                            this.renderBackgroundRepeat(t, e, n, r, h[3], h[0]);
                        }, this);
                    }, a.prototype.renderBackgroundRepeat = function(t, e, n, r, i, o) {
                        var a = Math.round(r.left + e.left + i), s = Math.round(r.top + e.top + o);
                        this.setFillStyle(this.ctx.createPattern(this.resizeImage(t, n), "repeat")), this.ctx.translate(a, s), this.ctx.fill(), this.ctx.translate(-a, -s);
                    }, a.prototype.renderBackgroundGradient = function(t, e) {
                        if (t instanceof i) {
                            var n = this.ctx.createLinearGradient(e.left + e.width * t.x0, e.top + e.height * t.y0, e.left + e.width * t.x1, e.top + e.height * t.y1);
                            t.colorStops.forEach(function(t) {
                                n.addColorStop(t.stop, t.color.toString());
                            }), this.rectangle(e.left, e.top, e.width, e.height, n);
                        }
                    }, a.prototype.resizeImage = function(t, e) {
                        var n = t.image;
                        if (n.width === e.width && n.height === e.height) return n;
                        var r = document.createElement("canvas");
                        return r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(n, 0, 0, n.width, n.height, 0, 0, e.width, e.height), r;
                    }, e.exports = a;
                },
                {
                    "../lineargradientcontainer": 12,
                    "../log": 13,
                    "../renderer": 19
                }
            ],
            21: [
                function(t, e, n) {
                    var r = function r(t, e, n, r) {
                        i.call(this, n, r), this.ownStacking = t, this.contexts = [], this.children = [], this.opacity = (this.parent ? this.parent.stack.opacity : 1) * e;
                    };
                    var i = t("./nodecontainer");
                    (r.prototype = Object.create(i.prototype)).getParentStack = function(t) {
                        var _$e = this.parent ? this.parent.stack : null;
                        return _$e ? _$e.ownStacking ? _$e : _$e.getParentStack(t) : t.stack;
                    }, e.exports = r;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            22: [
                function(t, e, n) {
                    var r = function r(t) {
                        this.rangeBounds = this.testRangeBounds(t), this.cors = this.testCORS(), this.svg = this.testSVG();
                    };
                    r.prototype.testRangeBounds = function(t) {
                        var _$e, n, r = !1;
                        return t.createRange && (_$e = t.createRange()).getBoundingClientRect && ((n = t.createElement("boundtest")).style.height = "123px", n.style.display = "block", t.body.appendChild(n), _$e.selectNode(n), 123 === _$e.getBoundingClientRect().height && (r = !0), t.body.removeChild(n)), r;
                    }, r.prototype.testCORS = function() {
                        return void 0 !== (new Image).crossOrigin;
                    }, r.prototype.testSVG = function() {
                        var t = new Image, _$e = document.createElement("canvas"), n = _$e.getContext("2d");
                        t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                        try {
                            n.drawImage(t, 0, 0), _$e.toDataURL();
                        } catch (t) {
                            return !1;
                        }
                        return !0;
                    }, e.exports = r;
                },
                {}
            ],
            23: [
                function(t, e, n) {
                    var o = function o(t) {
                        this.src = t, this.image = null;
                        var n = this;
                        this.promise = this.hasFabric().then(function() {
                            return n.isInline(t) ? Promise.resolve(n.inlineFormatting(t)) : r(t);
                        }).then(function(e) {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.loadSVGFromString(e, n.createCanvas.call(n, t));
                            });
                        });
                    };
                    var r = t("./xhr"), i = t("./utils").decode64;
                    o.prototype.hasFabric = function() {
                        return window.html2canvas.svg && window.html2canvas.svg.fabric ? Promise.resolve() : Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"));
                    }, o.prototype.inlineFormatting = function(t) {
                        return /^data:image\/svg\+xml;base64,/.test(t) ? this.decode64(this.removeContentType(t)) : this.removeContentType(t);
                    }, o.prototype.removeContentType = function(t) {
                        return t.replace(/^data:image\/svg\+xml(;base64)?,/, "");
                    }, o.prototype.isInline = function(t) {
                        return /^data:image\/svg\+xml/i.test(t);
                    }, o.prototype.createCanvas = function(r) {
                        var i = this;
                        return function(t, e) {
                            var n = new window.html2canvas.svg.fabric.StaticCanvas("c");
                            i.image = n.lowerCanvasEl, n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t, e)).renderAll(), r(n.lowerCanvasEl);
                        };
                    }, o.prototype.decode64 = function(t) {
                        return "function" == typeof window.atob ? window.atob(t) : i(t);
                    }, e.exports = o;
                },
                {
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            24: [
                function(t, e, n) {
                    var i = function i(n, t) {
                        this.src = n, this.image = null;
                        var r = this;
                        this.promise = t ? new Promise(function(t, e) {
                            r.image = new Image, r.image.onload = t, r.image.onerror = e, r.image.src = "data:image/svg+xml," + (new XMLSerializer).serializeToString(n), !0 === r.image.complete && t(r.image);
                        }) : this.hasFabric().then(function() {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.parseSVGDocument(n, r.createCanvas.call(r, t));
                            });
                        });
                    };
                    var r = t("./svgcontainer");
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./svgcontainer": 23
                }
            ],
            25: [
                function(t, e, n) {
                    var i = function i(t, e) {
                        r.call(this, t, e);
                    };
                    var o = function o(t, e, n) {
                        if (0 < t.length) return e + n.toUpperCase();
                    };
                    var r = t("./nodecontainer");
                    (i.prototype = Object.create(r.prototype)).applyTextTransform = function() {
                        this.node.data = this.transform(this.parent.css("textTransform"));
                    }, i.prototype.transform = function(t) {
                        var _$e = this.node.data;
                        switch(t){
                            case "lowercase":
                                return _$e.toLowerCase();
                            case "capitalize":
                                return _$e.replace(/(^|\s|:|-|\(|\))([a-z])/g, o);
                            case "uppercase":
                                return _$e.toUpperCase();
                            default:
                                return _$e;
                        }
                    }, e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            26: [
                function(t, e, n) {
                    n.smallImage = function() {
                        return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                    }, n.bind = function(t, e) {
                        return function() {
                            return t.apply(e, arguments);
                        };
                    }, /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ n.decode64 = function(t) {
                        var e, _$n, r, i, o, a, s, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = t.length, l = "";
                        for(e = 0; e < c; e += 4)o = h.indexOf(t[e]) << 2 | (_$n = h.indexOf(t[e + 1])) >> 4, a = (15 & _$n) << 4 | (r = h.indexOf(t[e + 2])) >> 2, s = (3 & r) << 6 | (i = h.indexOf(t[e + 3])), l += 64 === r ? String.fromCharCode(o) : 64 === i || -1 === i ? String.fromCharCode(o, a) : String.fromCharCode(o, a, s);
                        return l;
                    }, n.getBounds = function(t) {
                        if (t.getBoundingClientRect) {
                            var e = t.getBoundingClientRect(), _$n = null == t.offsetWidth ? e.width : t.offsetWidth;
                            return {
                                top: e.top,
                                bottom: e.bottom || e.top + e.height,
                                right: e.left + _$n,
                                left: e.left,
                                width: _$n,
                                height: null == t.offsetHeight ? e.height : t.offsetHeight
                            };
                        }
                        return {};
                    }, n.offsetBounds = function(t) {
                        var e = t.offsetParent ? n.offsetBounds(t.offsetParent) : {
                            top: 0,
                            left: 0
                        };
                        return {
                            top: t.offsetTop + e.top,
                            bottom: t.offsetTop + t.offsetHeight + e.top,
                            right: t.offsetLeft + e.left + t.offsetWidth,
                            left: t.offsetLeft + e.left,
                            width: t.offsetWidth,
                            height: t.offsetHeight
                        };
                    }, n.parseBackgrounds = function(t) {
                        var e, _$n, r, i, o, a, s, h = [], c = 0, l = 0, u = function u() {
                            e && ('"' === _$n.substr(0, 1) && (_$n = _$n.substr(1, _$n.length - 2)), _$n && s.push(_$n), "-" === e.substr(0, 1) && 0 < (i = e.indexOf("-", 1) + 1) && (r = e.substr(0, i), e = e.substr(i)), h.push({
                                prefix: r,
                                method: e.toLowerCase(),
                                value: o,
                                args: s,
                                image: null
                            })), s = [], e = r = _$n = o = "";
                        };
                        return s = [], e = r = _$n = o = "", t.split("").forEach(function(t) {
                            if (!(0 === c && -1 < " \r\n	".indexOf(t))) {
                                switch(t){
                                    case '"':
                                        a ? a === t && (a = null) : a = t;
                                        break;
                                    case "(":
                                        if (a) break;
                                        if (0 === c) return c = 1, void (o += t);
                                        l++;
                                        break;
                                    case ")":
                                        if (a) break;
                                        if (1 === c) {
                                            if (0 === l) return c = 0, o += t, void u();
                                            l--;
                                        }
                                        break;
                                    case ",":
                                        if (a) break;
                                        if (0 === c) return void u();
                                        if (1 === c && 0 === l && !e.match(/^url$/i)) return s.push(_$n), _$n = "", void (o += t);
                                }
                                o += t, 0 === c ? e += t : _$n += t;
                            }
                        }), u(), h;
                    };
                },
                {}
            ],
            27: [
                function(t, e, n) {
                    var i = function i(t) {
                        r.apply(this, arguments), this.type = "linear" === t.args[0] ? r.TYPES.LINEAR : r.TYPES.RADIAL;
                    };
                    var r = t("./gradientcontainer");
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./gradientcontainer": 9
                }
            ],
            28: [
                function(t, e, n) {
                    e.exports = function(r) {
                        return new Promise(function(t, e) {
                            var n = new XMLHttpRequest;
                            n.open("GET", r), n.onload = function() {
                                200 === n.status ? t(n.responseText) : e(new Error(n.statusText));
                            }, n.onerror = function() {
                                e(new Error("Network Error"));
                            }, n.send();
                        });
                    };
                },
                {}
            ]
        }, {}, [
            4
        ])(4);
    }), function(t) {
        var n = "+".charCodeAt(0), r = "/".charCodeAt(0), i = "0".charCodeAt(0), o = "a".charCodeAt(0), a = "A".charCodeAt(0), s = "-".charCodeAt(0), h = "_".charCodeAt(0), l = function l(t) {
            var e = t.charCodeAt(0);
            return e === n || e === s ? 62 : e === r || e === h ? 63 : e < i ? -1 : e < i + 10 ? e - i + 26 + 26 : e < a + 26 ? e - a : e < o + 26 ? e - o + 26 : void 0;
        };
        t.API.TTFFont = function() {
            var i = function i(t, e, n) {
                var r;
                if (this.rawData = t, r = this.contents = new X(t), this.contents.pos = 4, "ttcf" === r.readString(4)) {
                    if (!e) throw new Error("Must specify a font name for TTC files.");
                    throw new Error("Font " + e + " not found in TTC file.");
                }
                r.pos = 0, this.parse(), this.subset = new T(this), this.registerTTF();
            };
            return i.open = function(t, e, n, r) {
                return new i(function(t) {
                    var c = function c(t) {
                        a[h++] = t;
                    };
                    var _$e, _$n, _$r, i, o, a;
                    if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var s = t.length;
                    o = "=" === t.charAt(s - 2) ? 2 : "=" === t.charAt(s - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - o), _$r = 0 < o ? t.length - 4 : t.length;
                    var h = 0;
                    for(_$n = _$e = 0; _$e < _$r; _$e += 4, _$n += 3)c((16711680 & (i = l(t.charAt(_$e)) << 18 | l(t.charAt(_$e + 1)) << 12 | l(t.charAt(_$e + 2)) << 6 | l(t.charAt(_$e + 3)))) >> 16), c((65280 & i) >> 8), c(255 & i);
                    return 2 === o ? c(255 & (i = l(t.charAt(_$e)) << 2 | l(t.charAt(_$e + 1)) >> 4)) : 1 === o && (c((i = l(t.charAt(_$e)) << 10 | l(t.charAt(_$e + 1)) << 4 | l(t.charAt(_$e + 2)) >> 2) >> 8 & 255), c(255 & i)), a;
                }(n), e, r);
            }, i.prototype.parse = function() {
                return this.directory = new e(this.contents), this.head = new d(this), this.name = new b(this), this.cmap = new m(this), this.hhea = new g(this), this.maxp = new x(this), this.hmtx = new S(this), this.post = new y(this), this.os2 = new w(this), this.loca = new C(this), this.glyf = new _(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                    this.head.xMin,
                    this.head.yMin,
                    this.head.xMax,
                    this.head.yMax
                ];
            }, i.prototype.registerTTF = function() {
                var i, _$t, e, n, r;
                if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                    var _$t, e, n, r;
                    for(r = [], _$t = 0, e = (n = this.bbox).length; _$t < e; _$t++)i = n[_$t], r.push(Math.round(i * this.scaleFactor));
                    return r;
                }).call(this), this.stemV = 0, this.post.exists ? (e = 255 & (n = this.post.italic_angle), !0 & (_$t = n >> 16) && (_$t = -(1 + (65535 ^ _$t))), this.italicAngle = +(_$t + "." + e)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
            }, i.prototype.characterToGlyph = function(t) {
                var e;
                return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
            }, i.prototype.widthOfGlyph = function(t) {
                var e;
                return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
            }, i.prototype.widthOfString = function(t, e, n) {
                var r, i, o, a, s;
                for(i = a = o = 0, s = (t = "" + t).length; 0 <= s ? a < s : s < a; i = 0 <= s ? ++a : --a)r = t.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                return o * (e / 1e3);
            }, i.prototype.lineHeight = function(t, e) {
                var n;
                return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
            }, i;
        }();
        var c, X = function() {
            var _$t = function _$t(t) {
                this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            };
            return _$t.prototype.readByte = function() {
                return this.data[this.pos++];
            }, _$t.prototype.writeByte = function(t) {
                return this.data[this.pos++] = t;
            }, _$t.prototype.readUInt32 = function() {
                return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, _$t.prototype.writeUInt32 = function(t) {
                return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, _$t.prototype.readInt32 = function() {
                var _$t;
                return 2147483648 <= (_$t = this.readUInt32()) ? _$t - 4294967296 : _$t;
            }, _$t.prototype.writeInt32 = function(t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, _$t.prototype.readUInt16 = function() {
                return this.readByte() << 8 | this.readByte();
            }, _$t.prototype.writeUInt16 = function(t) {
                return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, _$t.prototype.readInt16 = function() {
                var _$t;
                return 32768 <= (_$t = this.readUInt16()) ? _$t - 65536 : _$t;
            }, _$t.prototype.writeInt16 = function(t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }, _$t.prototype.readString = function(t) {
                var e, n, r;
                for(n = [], e = r = 0; 0 <= t ? r < t : t < r; e = 0 <= t ? ++r : --r)n[e] = String.fromCharCode(this.readByte());
                return n.join("");
            }, _$t.prototype.writeString = function(t) {
                var e, n, r, i;
                for(i = [], e = n = 0, r = t.length; 0 <= r ? n < r : r < n; e = 0 <= r ? ++n : --n)i.push(this.writeByte(t.charCodeAt(e)));
                return i;
            }, _$t.prototype.readShort = function() {
                return this.readInt16();
            }, _$t.prototype.writeShort = function(t) {
                return this.writeInt16(t);
            }, _$t.prototype.readLongLong = function() {
                var _$t, e, n, r, i, o, a, s;
                return _$t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), o = this.readByte(), a = this.readByte(), s = this.readByte(), 128 & _$t ? -1 * (72057594037927940 * (255 ^ _$t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ a) + (255 ^ s) + 1) : 72057594037927940 * _$t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * o + 256 * a + s;
            }, _$t.prototype.readInt = function() {
                return this.readInt32();
            }, _$t.prototype.writeInt = function(t) {
                return this.writeInt32(t);
            }, _$t.prototype.read = function(t) {
                var e, n;
                for(e = [], n = 0; 0 <= t ? n < t : t < n; 0 <= t ? ++n : --n)e.push(this.readByte());
                return e;
            }, _$t.prototype.write = function(t) {
                var e, n, r, i;
                for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                return i;
            }, _$t;
        }(), e = function() {
            var _$t = function _$t(t) {
                var e, n, r;
                for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : r < n; 0 <= r ? ++n : --n)e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt()
                }, this.tables[e.tag] = e;
            };
            var p;
            return _$t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d;
                for(d in u = Object.keys(t).length, a = Math.log(2), c = 16 * Math.floor(Math.log(u) / a), i = Math.floor(c / a), h = 16 * u - c, (n = new X).writeInt(this.scalarType), n.writeShort(u), n.writeShort(c), n.writeShort(i), n.writeShort(h), r = 16 * u, s = n.pos + r, o = null, f = [], t)for(l = t[d], n.writeString(d), n.writeInt(p(l)), n.writeInt(s), n.writeInt(l.length), f = f.concat(l), "head" === d && (o = s), s += l.length; s % 4;)f.push(0), s++;
                return n.write(f), e = 2981146554 - p(n.data), n.pos = o + 8, n.writeUInt32(e), n.data;
            }, p = function p(t) {
                var e, n, r, i;
                for(t = k.call(t); t.length % 4;)t.push(0);
                for(n = new X(t), r = e = 0, i = t.length; r < i; r += 4)e += n.readUInt32();
                return 4294967295 & e;
            }, _$t;
        }(), u = {}.hasOwnProperty, f = function f(t, e) {
            var r = function r() {
                this.constructor = t;
            };
            for(var n in e)u.call(e, n) && (t[n] = e[n]);
            return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
        };
        c = function() {
            var _$t = function _$t(t) {
                var e;
                this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
            };
            return _$t.prototype.parse = function() {}, _$t.prototype.encode = function() {}, _$t.prototype.raw = function() {
                return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
            }, _$t;
        }();
        var d = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "head", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e;
        }(), p = function() {
            var _$t = function _$t(n, t) {
                var e, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v;
                switch(this.platformID = n.readUInt16(), this.encodingID = n.readShort(), this.offset = t + n.readInt(), l = n.pos, n.pos = this.offset, this.format = n.readUInt16(), this.length = n.readUInt16(), this.language = n.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                    case 0:
                        for(s = m = 0; m < 256; s = ++m)this.codeMap[s] = n.readByte();
                        break;
                    case 4:
                        for(f = n.readUInt16(), u = f / 2, n.pos += 6, i = function() {
                            var _$t, e;
                            for(e = [], s = _$t = 0; 0 <= u ? _$t < u : u < _$t; s = 0 <= u ? ++_$t : --_$t)e.push(n.readUInt16());
                            return e;
                        }(), n.pos += 2, p = function() {
                            var _$t, e;
                            for(e = [], s = _$t = 0; 0 <= u ? _$t < u : u < _$t; s = 0 <= u ? ++_$t : --_$t)e.push(n.readUInt16());
                            return e;
                        }(), h = function() {
                            var _$t, e;
                            for(e = [], s = _$t = 0; 0 <= u ? _$t < u : u < _$t; s = 0 <= u ? ++_$t : --_$t)e.push(n.readUInt16());
                            return e;
                        }(), c = function() {
                            var _$t, e;
                            for(e = [], s = _$t = 0; 0 <= u ? _$t < u : u < _$t; s = 0 <= u ? ++_$t : --_$t)e.push(n.readUInt16());
                            return e;
                        }(), r = (this.length - n.pos + this.offset) / 2, a = function() {
                            var _$t, e;
                            for(e = [], s = _$t = 0; 0 <= r ? _$t < r : r < _$t; s = 0 <= r ? ++_$t : --_$t)e.push(n.readUInt16());
                            return e;
                        }(), s = w = 0, v = i.length; w < v; s = ++w)for(g = i[s], e = y = d = p[s]; d <= g ? y <= g : g <= y; e = d <= g ? ++y : --y)0 === c[s] ? o = e + h[s] : 0 !== (o = a[c[s] / 2 + (e - d) - (u - s)] || 0) && (o += h[s]), this.codeMap[e] = 65535 & o;
                }
                n.pos = l;
            };
            return _$t.encode = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y;
                switch(F = new X, o = Object.keys(t).sort(function(t, e) {
                    return t - e;
                }), e){
                    case "macroman":
                        for(p = 0, g = function() {
                            var _$t, _$e;
                            for(_$e = [], d = _$t = 0; _$t < 256; d = ++_$t)_$e.push(0);
                            return _$e;
                        }(), w = {
                            0: 0
                        }, i = {}, P = 0, B = o.length; P < B; P++)null == w[W = t[r = o[P]]] && (w[W] = ++p), i[r] = {
                            old: t[r],
                            new: w[t[r]]
                        }, g[r] = w[t[r]];
                        return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                            charMap: i,
                            subtable: F.data,
                            maxGlyphID: p + 1
                        };
                    case "unicode":
                        for(C = [], l = [], w = {}, n = {}, m = h = null, E = y = 0, R = o.length; E < R; E++)null == w[b = t[r = o[E]]] && (w[b] = ++y), n[r] = {
                            old: b,
                            new: w[b]
                        }, a = w[b] - r, null != m && a === h || (m && l.push(m), C.push(r), h = a), m = r;
                        for(m && l.push(m), l.push(65535), C.push(65535), A = 2 * (_ = C.length), k = 2 * Math.pow(Math.log(_) / Math.LN2, 2), u = Math.log(k / 2) / Math.LN2, S = 2 * _ - k, s = [], x = [], f = [], d = q = 0, j = C.length; q < j; d = ++q){
                            if (I = C[d], c = l[d], 65535 === I) {
                                s.push(0), x.push(0);
                                break;
                            }
                            if (32768 <= I - (T = n[I].new)) for(s.push(0), x.push(2 * (f.length + _ - d)), r = O = I; I <= c ? O <= c : c <= O; r = I <= c ? ++O : --O)f.push(n[r].new);
                            else s.push(T - I), x.push(0);
                        }
                        for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * _ + 2 * f.length), F.writeUInt16(0), F.writeUInt16(A), F.writeUInt16(k), F.writeUInt16(u), F.writeUInt16(S), L = 0, D = l.length; L < D; L++)r = l[L], F.writeUInt16(r);
                        for(F.writeUInt16(0), H = 0, M = C.length; H < M; H++)r = C[H], F.writeUInt16(r);
                        for(G = 0, U = s.length; G < U; G++)a = s[G], F.writeUInt16(a);
                        for(V = 0, N = x.length; V < N; V++)v = x[V], F.writeUInt16(v);
                        for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                        return {
                            charMap: n,
                            subtable: F.data,
                            maxGlyphID: y + 1
                        };
                }
            }, _$t;
        }(), m = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
                var _$e, n, r;
                for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : n < r; 0 <= n ? ++r : --r)_$e = new p(t, this.offset), this.tables.push(_$e), _$e.isUnicode && null == this.unicode && (this.unicode = _$e);
                return !0;
            }, e.encode = function(t, e) {
                var n, r;
                return null == e && (e = "macroman"), n = p.encode(t, e), (r = new X).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
            }, e;
        }(), g = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
        }(), w = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
                if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
                    var _$t, _$e;
                    for(_$e = [], _$t = 0; _$t < 10; ++_$t)_$e.push(n.readByte());
                    return _$e;
                }(), this.charRange = function() {
                    var _$t, _$e;
                    for(_$e = [], _$t = 0; _$t < 4; ++_$t)_$e.push(n.readInt());
                    return _$e;
                }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), 0 < this.version && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
                    var _$t, _$e;
                    for(_$e = [], _$t = 0; _$t < 2; ++_$t)_$e.push(n.readInt());
                    return _$e;
                }(), 1 < this.version)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
            }, e;
        }(), y = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "post", e.prototype.parse = function(r) {
                var _$t, _$e, n, i;
                switch(r.pos = this.offset, this.format = r.readInt(), this.italicAngle = r.readInt(), this.underlinePosition = r.readShort(), this.underlineThickness = r.readShort(), this.isFixedPitch = r.readInt(), this.minMemType42 = r.readInt(), this.maxMemType42 = r.readInt(), this.minMemType1 = r.readInt(), this.maxMemType1 = r.readInt(), this.format){
                    case 65536:
                        break;
                    case 131072:
                        for(_$e = r.readUInt16(), this.glyphNameIndex = [], n = 0; 0 <= _$e ? n < _$e : _$e < n; 0 <= _$e ? ++n : --n)this.glyphNameIndex.push(r.readUInt16());
                        for(this.names = [], i = []; r.pos < this.offset + this.length;)_$t = r.readByte(), i.push(this.names.push(r.readString(_$t)));
                        return i;
                    case 151552:
                        return _$e = r.readUInt16(), this.offsets = r.read(_$e);
                    case 196608:
                        break;
                    case 262144:
                        return this.map = (function() {
                            var _$t, _$e, n;
                            for(n = [], _$t = 0, _$e = this.file.maxp.numGlyphs; 0 <= _$e ? _$t < _$e : _$e < _$t; 0 <= _$e ? ++_$t : --_$t)n.push(r.readUInt32());
                            return n;
                        }).call(this);
                }
            }, e;
        }(), v = function v(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
        }, b = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "name", e.prototype.parse = function(t) {
                var _$e, n, r, i, o, a, s, h, c, l, u, f;
                for(t.pos = this.offset, t.readShort(), _$e = t.readShort(), a = t.readShort(), n = [], i = c = 0; 0 <= _$e ? c < _$e : _$e < c; i = 0 <= _$e ? ++c : --c)n.push({
                    platformID: t.readShort(),
                    encodingID: t.readShort(),
                    languageID: t.readShort(),
                    nameID: t.readShort(),
                    length: t.readShort(),
                    offset: this.offset + a + t.readShort()
                });
                for(s = {}, i = l = 0, u = n.length; l < u; i = ++l)r = n[i], t.pos = r.offset, h = t.readString(r.length), o = new v(h, r), null == s[f = r.nameID] && (s[f] = []), s[r.nameID].push(o);
                return this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5], this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, ""), this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
            }, e;
        }(), x = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
        }(), S = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
                var _$t, r, i, _$e, o, a, s;
                for(n.pos = this.offset, this.metrics = [], _$e = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? _$e < a : a < _$e; 0 <= a ? ++_$e : --_$e)this.metrics.push({
                    advance: n.readUInt16(),
                    lsb: n.readInt16()
                });
                for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                    var _$t, _$e;
                    for(_$e = [], _$t = 0; 0 <= r ? _$t < r : r < _$t; 0 <= r ? ++_$t : --_$t)_$e.push(n.readInt16());
                    return _$e;
                }(), this.widths = (function() {
                    var _$t, _$e, _$n, r;
                    for(r = [], _$t = 0, _$e = (_$n = this.metrics).length; _$t < _$e; _$t++)i = _$n[_$t], r.push(i.advance);
                    return r;
                }).call(this), _$t = this.widths[this.widths.length - 1], s = [], o = 0; 0 <= r ? o < r : r < o; 0 <= r ? ++o : --o)s.push(this.widths.push(_$t));
                return s;
            }, e.prototype.forGlyph = function(t) {
                return t in this.metrics ? this.metrics[t] : {
                    advance: this.metrics[this.metrics.length - 1].advance,
                    lsb: this.leftSideBearings[t - this.metrics.length]
                };
            }, e;
        }(), k = [].slice, _ = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "glyf", e.prototype.parse = function(t) {
                return this.cache = {};
            }, e.prototype.glyphFor = function(t) {
                var _$e, n, r, i, o, a, s, h, c, l;
                return t in this.cache ? this.cache[t] : (i = this.file.loca, _$e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (_$e.pos = this.offset + n, o = (a = new X(_$e.read(r))).readShort(), h = a.readShort(), l = a.readShort(), s = a.readShort(), c = a.readShort(), this.cache[t] = -1 === o ? new I(a, h, l, s, c) : new A(a, o, h, l, s, c), this.cache[t]));
            }, e.prototype.encode = function(t, e, n) {
                var r, i, o, a, s;
                for(o = [], i = [], a = 0, s = e.length; a < s; a++)r = t[e[a]], i.push(o.length), r && (o = o.concat(r.encode(n)));
                return i.push(o.length), {
                    table: o,
                    offsets: i
                };
            }, e;
        }(), A = function() {
            var _$t = function _$t(t, e, n, r, i, o) {
                this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = o, this.compound = !1;
            };
            return _$t.prototype.encode = function() {
                return this.raw.data;
            }, _$t;
        }(), I = function() {
            var _$t = function _$t(t, e, n, r, i) {
                var o, a;
                for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; a = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readShort()), 32 & a;)o.pos += 1 & a ? 4 : 2, 128 & a ? o.pos += 8 : 64 & a ? o.pos += 4 : 8 & a && (o.pos += 2);
            };
            return _$t.prototype.encode = function(t) {
                var e, n, r, i, o;
                for(n = new X(k.call(this.raw.data)), e = r = 0, i = (o = this.glyphIDs).length; r < i; e = ++r)o[e], n.pos = this.glyphOffsets[e];
                return n.data;
            }, _$t;
        }(), C = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "loca", e.prototype.parse = function(r) {
                var _$t;
                return r.pos = this.offset, _$t = this.file.head.indexToLocFormat, this.offsets = 0 === _$t ? (function() {
                    var _$t, _$e, n;
                    for(n = [], _$t = 0, _$e = this.length; _$t < _$e; _$t += 2)n.push(2 * r.readUInt16());
                    return n;
                }).call(this) : (function() {
                    var _$t, _$e, n;
                    for(n = [], _$t = 0, _$e = this.length; _$t < _$e; _$t += 4)n.push(r.readUInt32());
                    return n;
                }).call(this);
            }, e.prototype.indexOf = function(t) {
                return this.offsets[t];
            }, e.prototype.lengthOf = function(t) {
                return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function(t, e) {
                for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, o = 0; o < n.length; ++o)if (n[o] = r, i < e.length && e[i] == o) {
                    ++i, n[o] = r;
                    var a = this.offsets[o], s = this.offsets[o + 1] - a;
                    0 < s && (r += s);
                }
                for(var h = new Array(4 * n.length), c = 0; c < n.length; ++c)h[4 * c + 3] = 255 & n[c], h[4 * c + 2] = (65280 & n[c]) >> 8, h[4 * c + 1] = (16711680 & n[c]) >> 16, h[4 * c] = (4278190080 & n[c]) >> 24;
                return h;
            }, e;
        }(), T = function() {
            var _$t = function _$t(t) {
                this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            };
            return _$t.prototype.generateCmap = function() {
                var _$t, e, n, r, i;
                for(e in r = this.font.cmap.tables[0].codeMap, _$t = {}, i = this.subset)n = i[e], _$t[e] = r[n];
                return _$t;
            }, _$t.prototype.glyphsFor = function(t) {
                var e, n, r, i, o, a, s;
                for(r = {}, o = 0, a = t.length; o < a; o++)r[i = t[o]] = this.font.glyf.glyphFor(i);
                for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                if (0 < e.length) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                return r;
            }, _$t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g;
                for(n in e = m.encode(this.generateCmap(), "unicode"), i = this.glyphsFor(t), u = {
                    0: 0
                }, g = e.charMap)u[(a = g[n]).old] = a.new;
                for(f in l = e.maxGlyphID, i)f in u || (u[f] = l++);
                return h = function(t) {
                    var e, n;
                    for(e in n = {}, t)n[t[e]] = e;
                    return n;
                }(u), c = Object.keys(h).sort(function(t, e) {
                    return t - e;
                }), d = function() {
                    var _$t, e, n;
                    for(n = [], _$t = 0, e = c.length; _$t < e; _$t++)o = c[_$t], n.push(h[o]);
                    return n;
                }(), r = this.font.glyf.encode(i, d, u), s = this.font.loca.encode(r.offsets, d), p = {
                    cmap: this.font.cmap.raw(),
                    glyf: r.table,
                    loca: s,
                    hmtx: this.font.hmtx.raw(),
                    hhea: this.font.hhea.raw(),
                    maxp: this.font.maxp.raw(),
                    post: this.font.post.raw(),
                    name: this.font.name.raw(),
                    head: this.font.head.raw()
                }, this.font.os2.exists && (p["OS/2"] = this.font.os2.raw()), this.font.directory.encode(p);
            }, _$t;
        }();
        t.API.PDFObject = function() {
            var a = function a() {};
            var o;
            return o = function o(t, e) {
                return (Array(e + 1).join("0") + t).slice(-e);
            }, a.convert = function(r) {
                var i, _$t, e, n;
                if (Array.isArray(r)) return "[" + (function() {
                    var _$t, e, n;
                    for(n = [], _$t = 0, e = r.length; _$t < e; _$t++)i = r[_$t], n.push(a.convert(i));
                    return n;
                })().join(" ") + "]";
                if ("string" == typeof r) return "/" + r;
                if (null != r ? r.isString : void 0) return "(" + r + ")";
                if (r instanceof Date) return "(D:" + o(r.getUTCFullYear(), 4) + o(r.getUTCMonth(), 2) + o(r.getUTCDate(), 2) + o(r.getUTCHours(), 2) + o(r.getUTCMinutes(), 2) + o(r.getUTCSeconds(), 2) + "Z)";
                if ("[object Object]" === ({}).toString.call(r)) {
                    for(_$t in e = [
                        "<<"
                    ], r)n = r[_$t], e.push("/" + _$t + " " + a.convert(n));
                    return e.push(">>"), e.join("\n");
                }
                return "" + r;
            }, a;
        }();
    }($), /*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */ pt = "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")(), gt = function() {
        var i = function i(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d, p;
            for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;){
                switch(e = this.readUInt32(), c = (function() {
                    var _$t, e;
                    for(e = [], _$t = 0; _$t < 4; ++_$t)e.push(String.fromCharCode(this.data[this.pos++]));
                    return e;
                }).call(this).join("")){
                    case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: []
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        a && this.animation.frames.push(a), this.pos += 4, a = {
                            width: this.readUInt32(),
                            height: this.readUInt32(),
                            xOffset: this.readUInt32(),
                            yOffset: this.readUInt32()
                        }, o = this.readUInt16(), i = this.readUInt16() || 100, a.delay = 1e3 * o / i, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                        break;
                    case "IDAT":
                    case "fdAT":
                        for("fdAT" === c && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : e < f; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch(this.transparency = {}, this.colorType){
                            case 3:
                                if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                                if (0 < (l = r - this.transparency.indexed.length)) for(d = 0; 0 <= l ? d < l : l < d; 0 <= l ? ++d : --d)this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        s = (u = this.read(e)).indexOf(0), h = String.fromCharCode.apply(String, u.slice(0, s)), this.text[h] = String.fromCharCode.apply(String, u.slice(s + 1));
                        break;
                    case "IEND":
                        return a && this.animation.frames.push(a), this.colors = (function() {
                            switch(this.colorType){
                                case 0:
                                case 3:
                                case 4:
                                    return 1;
                                case 2:
                                case 6:
                                    return 3;
                            }
                        }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                            switch(this.colors){
                                case 1:
                                    return "DeviceGray";
                                case 3:
                                    return "DeviceRGB";
                            }
                        }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                    default:
                        this.pos += e;
                }
                if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
            }
        };
        var c, n, r;
        i.load = function(t, e, n) {
            var r;
            return "function" == typeof e && (n = e), (r = new XMLHttpRequest).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function() {
                var _$t;
                return _$t = new i(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && _$t.render(e), "function" == typeof n ? n(_$t) : void 0;
            }, r.send(null);
        }, i.prototype.read = function(t) {
            var e, n;
            for(n = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
            return n;
        }, i.prototype.readUInt32 = function() {
            return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.readUInt16 = function() {
            return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.decodePixels = function(E) {
            var t = function t(t, e, n, r) {
                var i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A = Math.ceil((R.width - t) / n), I = Math.ceil((R.height - e) / r), C = R.width == A && R.height == I;
                for(w = q * A, g = C ? O : new Uint8Array(w * I), c = E.length, o = m = 0; m < I && B < c;){
                    switch(E[B++]){
                        case 0:
                            for(s = b = 0; b < w; s = b += 1)g[o++] = E[B++];
                            break;
                        case 1:
                            for(s = x = 0; x < w; s = x += 1)i = E[B++], h = s < q ? 0 : g[o - q], g[o++] = (i + h) % 256;
                            break;
                        case 2:
                            for(s = S = 0; S < w; s = S += 1)i = E[B++], a = (s - s % q) / q, y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (y + i) % 256;
                            break;
                        case 3:
                            for(s = k = 0; k < w; s = k += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (i + Math.floor((h + y) / 2)) % 256;
                            break;
                        case 4:
                            for(s = _ = 0; _ < w; s = _ += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], 0 === m ? y = v = 0 : (y = g[(m - 1) * w + a * q + s % q], v = a && g[(m - 1) * w + (a - 1) * q + s % q]), l = h + y - v, u = Math.abs(l - h), d = Math.abs(l - y), p = Math.abs(l - v), f = u <= d && u <= p ? h : d <= p ? y : v, g[o++] = (i + f) % 256;
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + E[B - 1]);
                    }
                    if (!C) {
                        var T = ((e + m * r) * R.width + t) * q, F = m * w;
                        for(s = 0; s < A; s += 1){
                            for(var P = 0; P < q; P += 1)O[T++] = g[F++];
                            T += (n - 1) * q;
                        }
                    }
                    m++;
                }
            };
            var q = this.pixelBitlength / 8, O = new Uint8Array(this.width * this.height * q), B = 0, R = this;
            if (null == E && (E = this.imgData), 0 === E.length) return new Uint8Array(0);
            return E = (E = new kt(E)).getBytes(), 1 == R.interlaceMethod ? (t(0, 0, 8, 8), t(4, 0, 8, 8), t(0, 4, 4, 8), t(2, 0, 4, 4), t(0, 2, 2, 4), t(1, 0, 2, 2), t(0, 1, 1, 2)) : t(0, 0, 1, 1), O;
        }, i.prototype.decodePalette = function() {
            var t, e, n, r, i, o, a, s, h;
            for(n = this.palette, o = this.transparency.indexed || [], i = new Uint8Array((o.length || 0) + n.length), r = 0, n.length, e = a = t = 0, s = n.length; a < s; e = a += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (h = o[t++]) ? h : 255;
            return i;
        }, i.prototype.copyToImageData = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f;
            if (r = this.colors, l = null, n = this.hasAlphaChannel, this.palette.length && (l = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), c = (i = t.data || t).length, a = l || e, o = s = 0, 1 === r) for(; o < c;)h = l ? 4 * e[o / 4] : s, u = a[h++], i[o++] = u, i[o++] = u, i[o++] = u, i[o++] = n ? a[h++] : 255, s = h;
            else for(; o < c;)h = l ? 4 * e[o / 4] : s, i[o++] = a[h++], i[o++] = a[h++], i[o++] = a[h++], i[o++] = n ? a[h++] : 255, s = h;
        }, i.prototype.decode = function() {
            var t;
            return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
            n = pt.document.createElement("canvas"), r = n.getContext("2d");
        } catch (t) {
            return -1;
        }
        return c = function c(t) {
            var e;
            return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        }, i.prototype.decodeFrames = function(t) {
            var e, n, r, i, o, a, s, h;
            if (this.animation) {
                for(h = [], n = o = 0, a = (s = this.animation.frames).length; o < a; n = ++o)e = s[n], r = t.createImageData(e.width, e.height), i = this.decodePixels(new Uint8Array(e.data)), this.copyToImageData(r, i), e.imageData = r, h.push(e.image = c(r));
                return h;
            }
        }, i.prototype.renderFrame = function(t, e) {
            var n, r, i;
            return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
        }, i.prototype.animate = function(n) {
            var r, i, o, a, s, t, h = this;
            return i = 0, t = this.animation, a = t.numFrames, o = t.frames, s = t.numPlays, (r = function() {
                var t, e;
                if (t = i++ % a, e = o[t], h.renderFrame(n, t), 1 < a && i / a < s) return h.animation._timeout = setTimeout(r, e.delay);
            })();
        }, i.prototype.stopAnimation = function() {
            var t;
            return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, i.prototype.render = function(t) {
            var e, n;
            return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
        }, i;
    }(), pt.PNG = gt;
    /*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */ var St = function() {
        var t = function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
        };
        return t.prototype = {
            ensureBuffer: function ensureBuffer(t) {
                var e = this.buffer, n = e ? e.byteLength : 0;
                if (t < n) return e;
                for(var r = 512; r < t;)r <<= 1;
                for(var i = new Uint8Array(r), o = 0; o < n; ++o)i[o] = e[o];
                return this.buffer = i;
            },
            getByte: function getByte() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return this.buffer[this.pos++];
            },
            getBytes: function getBytes(t) {
                var e = this.pos;
                if (t) {
                    this.ensureBuffer(e + t);
                    for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                    var r = this.bufferLength;
                    r < n && (n = r);
                } else {
                    for(; !this.eof;)this.readBlock();
                    n = this.bufferLength;
                }
                return this.pos = n, this.buffer.subarray(e, n);
            },
            lookChar: function lookChar() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function getChar() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function makeSubStream(t, e, n) {
                for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
                return new Stream(this.buffer, t, e, n);
            },
            skip: function skip(t) {
                t || (t = 1), this.pos += t;
            },
            reset: function reset() {
                this.pos = 0;
            }
        }, t;
    }(), kt = function() {
        var B = function B(t) {
            throw new Error(t);
        };
        var t = function t(t) {
            var e = 0, n = t[e++], r = t[e++];
            -1 != n && -1 != r || B("Invalid header in flate stream"), 8 != (15 & n) && B("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && B("Bad FCHECK in flate stream"), 32 & r && B("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, St.call(this);
        };
        if ("undefined" != typeof Uint32Array) {
            var F = new Uint32Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]), P = new Uint32Array([
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                65547,
                65549,
                65551,
                65553,
                131091,
                131095,
                131099,
                131103,
                196643,
                196651,
                196659,
                196667,
                262211,
                262227,
                262243,
                262259,
                327811,
                327843,
                327875,
                327907,
                258,
                258,
                258
            ]), E = new Uint32Array([
                1,
                2,
                3,
                4,
                65541,
                65543,
                131081,
                131085,
                196625,
                196633,
                262177,
                262193,
                327745,
                327777,
                393345,
                393409,
                459009,
                459137,
                524801,
                525057,
                590849,
                591361,
                657409,
                658433,
                724993,
                727041,
                794625,
                798721,
                868353,
                876545
            ]), q = [
                new Uint32Array([
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590016,
                    459016,
                    524384,
                    524320,
                    589984,
                    524288,
                    524416,
                    524352,
                    590048,
                    459012,
                    524376,
                    524312,
                    589968,
                    459028,
                    524408,
                    524344,
                    590032,
                    459020,
                    524392,
                    524328,
                    59e4,
                    524296,
                    524424,
                    524360,
                    590064,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590024,
                    459018,
                    524388,
                    524324,
                    589992,
                    524292,
                    524420,
                    524356,
                    590056,
                    459014,
                    524380,
                    524316,
                    589976,
                    459030,
                    524412,
                    524348,
                    590040,
                    459022,
                    524396,
                    524332,
                    590008,
                    524300,
                    524428,
                    524364,
                    590072,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590020,
                    459017,
                    524386,
                    524322,
                    589988,
                    524290,
                    524418,
                    524354,
                    590052,
                    459013,
                    524378,
                    524314,
                    589972,
                    459029,
                    524410,
                    524346,
                    590036,
                    459021,
                    524394,
                    524330,
                    590004,
                    524298,
                    524426,
                    524362,
                    590068,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590028,
                    459019,
                    524390,
                    524326,
                    589996,
                    524294,
                    524422,
                    524358,
                    590060,
                    459015,
                    524382,
                    524318,
                    589980,
                    459031,
                    524414,
                    524350,
                    590044,
                    459023,
                    524398,
                    524334,
                    590012,
                    524302,
                    524430,
                    524366,
                    590076,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590018,
                    459016,
                    524385,
                    524321,
                    589986,
                    524289,
                    524417,
                    524353,
                    590050,
                    459012,
                    524377,
                    524313,
                    589970,
                    459028,
                    524409,
                    524345,
                    590034,
                    459020,
                    524393,
                    524329,
                    590002,
                    524297,
                    524425,
                    524361,
                    590066,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590026,
                    459018,
                    524389,
                    524325,
                    589994,
                    524293,
                    524421,
                    524357,
                    590058,
                    459014,
                    524381,
                    524317,
                    589978,
                    459030,
                    524413,
                    524349,
                    590042,
                    459022,
                    524397,
                    524333,
                    590010,
                    524301,
                    524429,
                    524365,
                    590074,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590022,
                    459017,
                    524387,
                    524323,
                    589990,
                    524291,
                    524419,
                    524355,
                    590054,
                    459013,
                    524379,
                    524315,
                    589974,
                    459029,
                    524411,
                    524347,
                    590038,
                    459021,
                    524395,
                    524331,
                    590006,
                    524299,
                    524427,
                    524363,
                    590070,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590030,
                    459019,
                    524391,
                    524327,
                    589998,
                    524295,
                    524423,
                    524359,
                    590062,
                    459015,
                    524383,
                    524319,
                    589982,
                    459031,
                    524415,
                    524351,
                    590046,
                    459023,
                    524399,
                    524335,
                    590014,
                    524303,
                    524431,
                    524367,
                    590078,
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590017,
                    459016,
                    524384,
                    524320,
                    589985,
                    524288,
                    524416,
                    524352,
                    590049,
                    459012,
                    524376,
                    524312,
                    589969,
                    459028,
                    524408,
                    524344,
                    590033,
                    459020,
                    524392,
                    524328,
                    590001,
                    524296,
                    524424,
                    524360,
                    590065,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590025,
                    459018,
                    524388,
                    524324,
                    589993,
                    524292,
                    524420,
                    524356,
                    590057,
                    459014,
                    524380,
                    524316,
                    589977,
                    459030,
                    524412,
                    524348,
                    590041,
                    459022,
                    524396,
                    524332,
                    590009,
                    524300,
                    524428,
                    524364,
                    590073,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590021,
                    459017,
                    524386,
                    524322,
                    589989,
                    524290,
                    524418,
                    524354,
                    590053,
                    459013,
                    524378,
                    524314,
                    589973,
                    459029,
                    524410,
                    524346,
                    590037,
                    459021,
                    524394,
                    524330,
                    590005,
                    524298,
                    524426,
                    524362,
                    590069,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590029,
                    459019,
                    524390,
                    524326,
                    589997,
                    524294,
                    524422,
                    524358,
                    590061,
                    459015,
                    524382,
                    524318,
                    589981,
                    459031,
                    524414,
                    524350,
                    590045,
                    459023,
                    524398,
                    524334,
                    590013,
                    524302,
                    524430,
                    524366,
                    590077,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590019,
                    459016,
                    524385,
                    524321,
                    589987,
                    524289,
                    524417,
                    524353,
                    590051,
                    459012,
                    524377,
                    524313,
                    589971,
                    459028,
                    524409,
                    524345,
                    590035,
                    459020,
                    524393,
                    524329,
                    590003,
                    524297,
                    524425,
                    524361,
                    590067,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590027,
                    459018,
                    524389,
                    524325,
                    589995,
                    524293,
                    524421,
                    524357,
                    590059,
                    459014,
                    524381,
                    524317,
                    589979,
                    459030,
                    524413,
                    524349,
                    590043,
                    459022,
                    524397,
                    524333,
                    590011,
                    524301,
                    524429,
                    524365,
                    590075,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590023,
                    459017,
                    524387,
                    524323,
                    589991,
                    524291,
                    524419,
                    524355,
                    590055,
                    459013,
                    524379,
                    524315,
                    589975,
                    459029,
                    524411,
                    524347,
                    590039,
                    459021,
                    524395,
                    524331,
                    590007,
                    524299,
                    524427,
                    524363,
                    590071,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590031,
                    459019,
                    524391,
                    524327,
                    589999,
                    524295,
                    524423,
                    524359,
                    590063,
                    459015,
                    524383,
                    524319,
                    589983,
                    459031,
                    524415,
                    524351,
                    590047,
                    459023,
                    524399,
                    524335,
                    590015,
                    524303,
                    524431,
                    524367,
                    590079
                ]),
                9
            ], O = [
                new Uint32Array([
                    327680,
                    327696,
                    327688,
                    327704,
                    327684,
                    327700,
                    327692,
                    327708,
                    327682,
                    327698,
                    327690,
                    327706,
                    327686,
                    327702,
                    327694,
                    0,
                    327681,
                    327697,
                    327689,
                    327705,
                    327685,
                    327701,
                    327693,
                    327709,
                    327683,
                    327699,
                    327691,
                    327707,
                    327687,
                    327703,
                    327695,
                    0
                ]),
                5
            ];
            return (t.prototype = Object.create(St.prototype)).getBits = function(t) {
                for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && B("Bad encoding in flate stream"), r |= e << n, n += 8;
                return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
            }, t.prototype.getCode = function(t) {
                for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, a = this.bytesPos; r < n;){
                    var s;
                    void 0 === (s = o[a++]) && B("Bad encoding in flate stream"), i |= s << r, r += 8;
                }
                var h = e[i & (1 << n) - 1], c = h >> 16, l = 65535 & h;
                return (0 == r || r < c || 0 == c) && B("Bad encoding in flate stream"), this.codeBuf = i >> c, this.codeSize = r - c, this.bytesPos = a, l;
            }, t.prototype.generateHuffmanTable = function(t) {
                for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
                for(var i = 1 << n, o = new Uint32Array(i), a = 1, s = 0, h = 2; a <= n; ++a, s <<= 1, h <<= 1)for(var c = 0; c < e; ++c)if (t[c] == a) {
                    var l = 0, u = s;
                    for(r = 0; r < a; ++r)l = l << 1 | 1 & u, u >>= 1;
                    for(r = l; r < i; r += h)o[r] = a << 16 | c;
                    ++s;
                }
                return [
                    o,
                    n
                ];
            }, t.prototype.readBlock = function() {
                var t = function t(t, e, n, r, i) {
                    for(var o = t.getBits(n) + r; 0 < o--;)e[h++] = i;
                };
                var e = this.getBits(3);
                if (1 & e && (this.eof = !0), 0 != (e >>= 1)) {
                    var n, r;
                    if (1 == e) n = q, r = O;
                    else if (2 == e) {
                        for(var i = this.getBits(5) + 257, o = this.getBits(5) + 1, a = this.getBits(4) + 4, s = Array(F.length), h = 0; h < a;)s[F[h++]] = this.getBits(3);
                        for(var c = this.generateHuffmanTable(s), l = 0, u = (h = 0, i + o), f = new Array(u); h < u;){
                            var d = this.getCode(c);
                            16 == d ? t(this, f, 2, 3, l) : 17 == d ? t(this, f, 3, 3, l = 0) : 18 == d ? t(this, f, 7, 11, l = 0) : f[h++] = l = d;
                        }
                        n = this.generateHuffmanTable(f.slice(0, i)), r = this.generateHuffmanTable(f.slice(i, u));
                    } else B("Unknown block type in flate stream");
                    for(var p = (I = this.buffer) ? I.length : 0, g = this.bufferLength;;){
                        var m = this.getCode(n);
                        if (m < 256) p <= g + 1 && (p = (I = this.ensureBuffer(g + 1)).length), I[g++] = m;
                        else {
                            if (256 == m) return void (this.bufferLength = g);
                            var w = (m = P[m -= 257]) >> 16;
                            0 < w && (w = this.getBits(w));
                            l = (65535 & m) + w;
                            m = this.getCode(r), 0 < (w = (m = E[m]) >> 16) && (w = this.getBits(w));
                            var y = (65535 & m) + w;
                            p <= g + l && (p = (I = this.ensureBuffer(g + l)).length);
                            for(var v = 0; v < l; ++v, ++g)I[g] = I[g - y];
                        }
                    }
                } else {
                    var b, x = this.bytes, S = this.bytesPos;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var k = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), k |= b << 8, void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var _ = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), (_ |= b << 8) != (65535 & ~k) && B("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                    var A = this.bufferLength, I = this.ensureBuffer(A + k), C = A + k;
                    this.bufferLength = C;
                    for(var T = A; T < C; ++T){
                        if (void 0 === (b = x[S++])) {
                            this.eof = !0;
                            break;
                        }
                        I[T] = b;
                    }
                    this.bytesPos = S;
                }
            }, t;
        }
    }();
    return function(t) {
        if ("object" != typeof t.console) {
            t.console = {};
            for(var e, n, r = t.console, i = function i() {}, o = [
                "memory"
            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)r[e] || (r[e] = {});
            for(; n = a.pop();)r[n] || (r[n] = i);
        }
        var s, h, c, l, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function(t) {
            var e, n, r, i, o, a = 0, s = 0, h = "", c = [];
            if (!t) return t;
            for(; e = (o = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[s++] = u.charAt(e) + u.charAt(n) + u.charAt(r) + u.charAt(i), a < t.length;);
            h = c.join("");
            var l = t.length % 3;
            return (l ? h.slice(0, l - 3) : h) + "===".slice(l || 3);
        }), void 0 === t.atob && (t.atob = function(t) {
            var e, n, r, i, o, a, s = 0, h = 0, c = [];
            if (!t) return t;
            for(t += ""; e = (a = u.indexOf(t.charAt(s++)) << 18 | u.indexOf(t.charAt(s++)) << 12 | (i = u.indexOf(t.charAt(s++))) << 6 | (o = u.indexOf(t.charAt(s++)))) >> 16 & 255, n = a >> 8 & 255, r = 255 & a, c[h++] = 64 == i ? String.fromCharCode(e) : 64 == o ? String.fromCharCode(e, n) : String.fromCharCode(e, n, r), s < t.length;);
            return c.join("");
        }), Array.prototype.map || (Array.prototype.map = function(t) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var e = Object(this), n = e.length >>> 0, r = new Array(n), i = 1 < arguments.length ? arguments[1] : void 0, o = 0; o < n; o++)o in e && (r[o] = t.call(i, e[o], o, e));
            return r;
        }), Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function(t, e) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var n = Object(this), r = n.length >>> 0, i = 0; i < r; i++)i in n && t.call(e, n[i], i, n);
        }), Object.keys || (Object.keys = (s = Object.prototype.hasOwnProperty, h = !({
            toString: null
        }).propertyIsEnumerable("toString"), l = (c = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ]).length, function(t) {
            if ("object" != typeof t && ("function" != typeof t || null === t)) throw new TypeError;
            var e, n, r = [];
            for(e in t)s.call(t, e) && r.push(e);
            if (h) for(n = 0; n < l; n++)s.call(t, c[n]) && r.push(c[n]);
            return r;
        })), "function" != typeof Object.assign && (Object.assign = function(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            t = Object(t);
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                if (null != n) for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
        }), String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function() {
            return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function() {
            return this.replace(/\s+$/g, "");
        });
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), $;
});

});
parcelRequire.register("eSBMZ", function(module, exports) {
// shim for using process in browser
var $ad536bfce0513606$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ad536bfce0513606$var$cachedSetTimeout;
var $ad536bfce0513606$var$cachedClearTimeout;
function $ad536bfce0513606$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ad536bfce0513606$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ad536bfce0513606$var$cachedSetTimeout = setTimeout;
        else $ad536bfce0513606$var$cachedSetTimeout = $ad536bfce0513606$var$defaultSetTimout;
    } catch (e) {
        $ad536bfce0513606$var$cachedSetTimeout = $ad536bfce0513606$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ad536bfce0513606$var$cachedClearTimeout = clearTimeout;
        else $ad536bfce0513606$var$cachedClearTimeout = $ad536bfce0513606$var$defaultClearTimeout;
    } catch (e) {
        $ad536bfce0513606$var$cachedClearTimeout = $ad536bfce0513606$var$defaultClearTimeout;
    }
})();
function $ad536bfce0513606$var$runTimeout(fun) {
    if ($ad536bfce0513606$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ad536bfce0513606$var$cachedSetTimeout === $ad536bfce0513606$var$defaultSetTimout || !$ad536bfce0513606$var$cachedSetTimeout) && setTimeout) {
        $ad536bfce0513606$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad536bfce0513606$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ad536bfce0513606$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ad536bfce0513606$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ad536bfce0513606$var$runClearTimeout(marker) {
    if ($ad536bfce0513606$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ad536bfce0513606$var$cachedClearTimeout === $ad536bfce0513606$var$defaultClearTimeout || !$ad536bfce0513606$var$cachedClearTimeout) && clearTimeout) {
        $ad536bfce0513606$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad536bfce0513606$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ad536bfce0513606$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ad536bfce0513606$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ad536bfce0513606$var$queue = [];
var $ad536bfce0513606$var$draining = false;
var $ad536bfce0513606$var$currentQueue;
var $ad536bfce0513606$var$queueIndex = -1;
function $ad536bfce0513606$var$cleanUpNextTick() {
    if (!$ad536bfce0513606$var$draining || !$ad536bfce0513606$var$currentQueue) return;
    $ad536bfce0513606$var$draining = false;
    if ($ad536bfce0513606$var$currentQueue.length) $ad536bfce0513606$var$queue = $ad536bfce0513606$var$currentQueue.concat($ad536bfce0513606$var$queue);
    else $ad536bfce0513606$var$queueIndex = -1;
    if ($ad536bfce0513606$var$queue.length) $ad536bfce0513606$var$drainQueue();
}
function $ad536bfce0513606$var$drainQueue() {
    if ($ad536bfce0513606$var$draining) return;
    var timeout = $ad536bfce0513606$var$runTimeout($ad536bfce0513606$var$cleanUpNextTick);
    $ad536bfce0513606$var$draining = true;
    var len = $ad536bfce0513606$var$queue.length;
    while(len){
        $ad536bfce0513606$var$currentQueue = $ad536bfce0513606$var$queue;
        $ad536bfce0513606$var$queue = [];
        while(++$ad536bfce0513606$var$queueIndex < len)if ($ad536bfce0513606$var$currentQueue) $ad536bfce0513606$var$currentQueue[$ad536bfce0513606$var$queueIndex].run();
        $ad536bfce0513606$var$queueIndex = -1;
        len = $ad536bfce0513606$var$queue.length;
    }
    $ad536bfce0513606$var$currentQueue = null;
    $ad536bfce0513606$var$draining = false;
    $ad536bfce0513606$var$runClearTimeout(timeout);
}
$ad536bfce0513606$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ad536bfce0513606$var$queue.push(new $ad536bfce0513606$var$Item(fun, args));
    if ($ad536bfce0513606$var$queue.length === 1 && !$ad536bfce0513606$var$draining) $ad536bfce0513606$var$runTimeout($ad536bfce0513606$var$drainQueue);
};
// v8 likes predictible objects
function $ad536bfce0513606$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ad536bfce0513606$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ad536bfce0513606$var$process.title = "browser";
$ad536bfce0513606$var$process.browser = true;
$ad536bfce0513606$var$process.env = {};
$ad536bfce0513606$var$process.argv = [];
$ad536bfce0513606$var$process.version = ""; // empty string to avoid regexp issues
$ad536bfce0513606$var$process.versions = {};
function $ad536bfce0513606$var$noop() {}
$ad536bfce0513606$var$process.on = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.addListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.once = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.off = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.removeListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.removeAllListeners = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.emit = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.prependListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.prependOnceListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.listeners = function(name) {
    return [];
};
$ad536bfce0513606$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ad536bfce0513606$var$process.cwd = function() {
    return "/";
};
$ad536bfce0513606$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ad536bfce0513606$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("bTsa4", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var __extends = function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __awaiter = function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var __spreadArray = function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    };
    var hue2rgb = function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    };
    var isSupportedImage = function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    };
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    var __assign = function __assign1() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var Bounds = /** @class */ function() {
        var Bounds = function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        };
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        var Trie = function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        };
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        var Break = function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        };
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        var Tokenizer = function Tokenizer() {
            this._value = [];
        };
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        var Parser = function Parser(tokens) {
            this._tokens = tokens;
        };
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function parse(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        var CSSParsedDeclaration = function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        };
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        var CSSParsedPseudoDeclaration = function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        };
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        var CSSParsedCounterDeclaration = function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        };
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        var ElementContainer = function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        };
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        var Trie = function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        };
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function testRangeBounds(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function testSVG(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        var TextBounds = function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        };
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        var TextContainer = function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        };
        return TextContainer;
    }();
    var transform = function transform(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        var ImageElementContainer = function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        };
        __extends(ImageElementContainer, _super);
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        var CanvasElementContainer = function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        };
        __extends(CanvasElementContainer, _super);
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        var SVGElementContainer = function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        };
        __extends(SVGElementContainer, _super);
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        var LIElementContainer = function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        };
        __extends(LIElementContainer, _super);
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        var OLElementContainer = function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        };
        __extends(OLElementContainer, _super);
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("•") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        var InputElementContainer = function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        };
        __extends(InputElementContainer, _super);
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        var SelectElementContainer = function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        };
        __extends(SelectElementContainer, _super);
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        var TextareaElementContainer = function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        };
        __extends(TextareaElementContainer, _super);
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        var IFrameElementContainer = function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        };
        __extends(IFrameElementContainer, _super);
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function parseNodeTree1(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        var CounterState = function CounterState() {
            this.counters = {};
        };
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "Ք",
            "Փ",
            "Ւ",
            "Ց",
            "Ր",
            "Տ",
            "Վ",
            "Ս",
            "Ռ",
            "Ջ",
            "Պ",
            "Չ",
            "Ո",
            "Շ",
            "Ն",
            "Յ",
            "Մ",
            "Ճ",
            "Ղ",
            "Ձ",
            "Հ",
            "Կ",
            "Ծ",
            "Խ",
            "Լ",
            "Ի",
            "Ժ",
            "Թ",
            "Ը",
            "Է",
            "Զ",
            "Ե",
            "Դ",
            "Գ",
            "Բ",
            "Ա"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "י׳",
            "ט׳",
            "ח׳",
            "ז׳",
            "ו׳",
            "ה׳",
            "ד׳",
            "ג׳",
            "ב׳",
            "א׳",
            "ת",
            "ש",
            "ר",
            "ק",
            "צ",
            "פ",
            "ע",
            "ס",
            "נ",
            "מ",
            "ל",
            "כ",
            "יט",
            "יח",
            "יז",
            "טז",
            "טו",
            "י",
            "ט",
            "ח",
            "ז",
            "ו",
            "ה",
            "ד",
            "ג",
            "ב",
            "א"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "ჵ",
            "ჰ",
            "ჯ",
            "ჴ",
            "ხ",
            "ჭ",
            "წ",
            "ძ",
            "ც",
            "ჩ",
            "შ",
            "ყ",
            "ღ",
            "ქ",
            "ფ",
            "ჳ",
            "ტ",
            "ს",
            "რ",
            "ჟ",
            "პ",
            "ო",
            "ჲ",
            "ნ",
            "მ",
            "ლ",
            "კ",
            "ი",
            "თ",
            "ჱ",
            "ზ",
            "ვ",
            "ე",
            "დ",
            "გ",
            "ბ",
            "ა"
        ]
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
    var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
    var JAPANESE_NEGATIVE = "マイナス";
    var KOREAN_NEGATIVE = "마이너스";
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "、" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "•" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "◦" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "◾" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "〇一二三四五六七八九", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "子丑寅卯辰巳午未申酉戌亥", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "甲乙丙丁戊己庚辛壬癸", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹貳參肆伍陸柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹贰叁肆伍陆柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "〇一二三四五六七八九", "十百千万", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "零壱弐参四伍六七八九", "拾百千万", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "영일이삼사오육칠팔구", "십백천만", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", "十百千萬", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "零壹貳參四五六七八九", "拾百千", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        var DocumentCloner = function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        };
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var _$window = node.ownerDocument.defaultView;
            if (_$window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = _$window.getComputedStyle(node);
                var styleBefore = _$window.getComputedStyle(node, ":before");
                var styleAfter = _$window.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var _$document = clone.ownerDocument;
            if (!_$document || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = _$document.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = _$document.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(_$document.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(_$document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(_$document.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var _$document = body.ownerDocument;
        if (_$document) {
            var style = _$document.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        var CacheStorage = function CacheStorage() {};
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        var Cache = function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        };
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        var Vector = function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        };
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        var BezierCurve = function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        };
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        var BoundCurves = function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        };
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        var TransformEffect = function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        };
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        var ClipEffect = function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        };
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        var OpacityEffect = function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        };
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        var StackingContext = function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        };
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        var ElementPaint = function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        };
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree1(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        var FontMetrics = function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        };
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        var Renderer = function Renderer(context, options) {
            this.context = context;
            this.options = options;
        };
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        var CanvasRenderer = function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        };
        __extends(CanvasRenderer, _super);
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        var ForeignObjectRenderer = function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        };
        __extends(ForeignObjectRenderer, _super);
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        var Logger = function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});





var $4CEbD = parcelRequire("4CEbD");
var $6263f5d92dfcd1a2$exports = {};
function $6263f5d92dfcd1a2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$6263f5d92dfcd1a2$exports = $6263f5d92dfcd1a2$var$_classCallCheck, $6263f5d92dfcd1a2$exports.__esModule = true, $6263f5d92dfcd1a2$exports["default"] = $6263f5d92dfcd1a2$exports;


var $edff451f2f94804f$exports = {};
var $3b4a02ea78d60cb5$exports = {};
var $6e9eff2adc3225c0$exports = {};
function $6e9eff2adc3225c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6e9eff2adc3225c0$exports = $6e9eff2adc3225c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6e9eff2adc3225c0$exports.__esModule = true, $6e9eff2adc3225c0$exports["default"] = $6e9eff2adc3225c0$exports, $6e9eff2adc3225c0$var$_typeof(obj);
}
$6e9eff2adc3225c0$exports = $6e9eff2adc3225c0$var$_typeof, $6e9eff2adc3225c0$exports.__esModule = true, $6e9eff2adc3225c0$exports["default"] = $6e9eff2adc3225c0$exports;


var $3b4a02ea78d60cb5$var$_typeof = $6e9eff2adc3225c0$exports.default;
var $4f638d2731a305df$exports = {};

var $4f638d2731a305df$var$_typeof = $6e9eff2adc3225c0$exports.default;
function $4f638d2731a305df$var$_toPrimitive(input, hint) {
    if ($4f638d2731a305df$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4f638d2731a305df$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$4f638d2731a305df$exports = $4f638d2731a305df$var$_toPrimitive, $4f638d2731a305df$exports.__esModule = true, $4f638d2731a305df$exports["default"] = $4f638d2731a305df$exports;


function $3b4a02ea78d60cb5$var$_toPropertyKey(arg) {
    var key = $4f638d2731a305df$exports(arg, "string");
    return $3b4a02ea78d60cb5$var$_typeof(key) === "symbol" ? key : String(key);
}
$3b4a02ea78d60cb5$exports = $3b4a02ea78d60cb5$var$_toPropertyKey, $3b4a02ea78d60cb5$exports.__esModule = true, $3b4a02ea78d60cb5$exports["default"] = $3b4a02ea78d60cb5$exports;


function $edff451f2f94804f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3b4a02ea78d60cb5$exports(descriptor.key), descriptor);
    }
}
function $edff451f2f94804f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $edff451f2f94804f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $edff451f2f94804f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$edff451f2f94804f$exports = $edff451f2f94804f$var$_createClass, $edff451f2f94804f$exports.__esModule = true, $edff451f2f94804f$exports["default"] = $edff451f2f94804f$exports;


var $d1049584750a9d41$exports = {};

function $d1049584750a9d41$var$_defineProperty(obj, key, value) {
    key = $3b4a02ea78d60cb5$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$d1049584750a9d41$exports = $d1049584750a9d41$var$_defineProperty, $d1049584750a9d41$exports.__esModule = true, $d1049584750a9d41$exports["default"] = $d1049584750a9d41$exports;



var $4CEbD = parcelRequire("4CEbD");
var $981b4935b5361a32$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $981b4935b5361a32$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $981b4935b5361a32$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $981b4935b5361a32$var$htmlEntities[m];
};
var $981b4935b5361a32$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($981b4935b5361a32$var$matchHtmlEntity, $981b4935b5361a32$var$unescapeHtmlEntity);
};


function $b4ff156111e82d24$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b4ff156111e82d24$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b4ff156111e82d24$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d1049584750a9d41$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b4ff156111e82d24$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b4ff156111e82d24$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $981b4935b5361a32$export$e8bacd2802a88316)
};
var $b4ff156111e82d24$var$i18nInstance;
var $b4ff156111e82d24$export$5603ab5ced17ce64 = (0, $4CEbD.createContext)();
function $b4ff156111e82d24$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $b4ff156111e82d24$var$defaultOptions = $b4ff156111e82d24$var$_objectSpread($b4ff156111e82d24$var$_objectSpread({}, $b4ff156111e82d24$var$defaultOptions), options);
}
function $b4ff156111e82d24$export$212bb2fc580a90a8() {
    return $b4ff156111e82d24$var$defaultOptions;
}
var $b4ff156111e82d24$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6263f5d92dfcd1a2$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($edff451f2f94804f$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $b4ff156111e82d24$export$a039134f2fc7e0(instance) {
    $b4ff156111e82d24$var$i18nInstance = instance;
}
function $b4ff156111e82d24$export$64af334f494c2f47() {
    return $b4ff156111e82d24$var$i18nInstance;
}
var $b4ff156111e82d24$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $b4ff156111e82d24$export$2e2366488d12e20d(instance.options.react);
        $b4ff156111e82d24$export$a039134f2fc7e0(instance);
    }
};
function $b4ff156111e82d24$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $b4ff156111e82d24$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($b4ff156111e82d24$var$_objectSpread($b4ff156111e82d24$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $b4ff156111e82d24$export$704200e5d0b9e8f() {
    var i18n = $b4ff156111e82d24$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $ab097cf8c16e418a$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $4CEbD.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $4CEbD.createElement)((0, $b4ff156111e82d24$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $5F2Q2 = parcelRequire("5F2Q2");

var $4CEbD = parcelRequire("4CEbD");
var $301b25c3bc3e558a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $301b25c3bc3e558a$var$ReactIs, $301b25c3bc3e558a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$301b25c3bc3e558a$exports = (parcelRequire("iacei"))();


var $ee6ed275075e2808$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $ee6ed275075e2808$var$hasElementType = typeof Element !== "undefined";
var $ee6ed275075e2808$var$hasMap = typeof Map === "function";
var $ee6ed275075e2808$var$hasSet = typeof Set === "function";
var $ee6ed275075e2808$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $ee6ed275075e2808$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$ee6ed275075e2808$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($ee6ed275075e2808$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$ee6ed275075e2808$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($ee6ed275075e2808$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($ee6ed275075e2808$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($ee6ed275075e2808$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$ee6ed275075e2808$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$ee6ed275075e2808$exports = function isEqual(a, b) {
    try {
        return $ee6ed275075e2808$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $6dd9c7be11585a35$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $6dd9c7be11585a35$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$6dd9c7be11585a35$exports = $6dd9c7be11585a35$var$invariant;


var $8d4bb89e3659dc98$exports = {};
//
$8d4bb89e3659dc98$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $5e43d30989714aad$var$a() {
    return $5e43d30989714aad$var$a = Object.assign || function(t) {
        for(var _$e = 1; _$e < arguments.length; _$e++){
            var _$r = arguments[_$e];
            for(var n in _$r)Object.prototype.hasOwnProperty.call(_$r, n) && (t[n] = _$r[n]);
        }
        return t;
    }, $5e43d30989714aad$var$a.apply(this, arguments);
}
function $5e43d30989714aad$var$s(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, $5e43d30989714aad$var$c(t, e);
}
function $5e43d30989714aad$var$c(t, e) {
    return $5e43d30989714aad$var$c = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $5e43d30989714aad$var$c(t, e);
}
function $5e43d30989714aad$var$u(t, e) {
    if (null == t) return {};
    var _$r, n, i = {}, o = Object.keys(t);
    for(n = 0; n < o.length; n++)e.indexOf(_$r = o[n]) >= 0 || (i[_$r] = t[_$r]);
    return i;
}
var $5e43d30989714aad$var$l = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title",
    FRAGMENT: "Symbol(react.fragment)"
}, $5e43d30989714aad$var$p = {
    rel: [
        "amphtml",
        "canonical",
        "alternate"
    ]
}, $5e43d30989714aad$var$f = {
    type: [
        "application/ld+json"
    ]
}, $5e43d30989714aad$var$d = {
    charset: "",
    name: [
        "robots",
        "description"
    ],
    property: [
        "og:type",
        "og:title",
        "og:url",
        "og:image",
        "og:image:alt",
        "og:description",
        "twitter:url",
        "twitter:title",
        "twitter:description",
        "twitter:image",
        "twitter:image:alt",
        "twitter:card",
        "twitter:site"
    ]
}, $5e43d30989714aad$var$h = Object.keys($5e43d30989714aad$var$l).map(function(t) {
    return $5e43d30989714aad$var$l[t];
}), $5e43d30989714aad$var$m = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
}, $5e43d30989714aad$var$y = Object.keys($5e43d30989714aad$var$m).reduce(function(t, e) {
    return t[$5e43d30989714aad$var$m[e]] = e, t;
}, {}), $5e43d30989714aad$var$T = function T(t, e) {
    for(var _$r = t.length - 1; _$r >= 0; _$r -= 1){
        var n = t[_$r];
        if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
    }
    return null;
}, $5e43d30989714aad$var$g = function g(t) {
    var _$e = $5e43d30989714aad$var$T(t, $5e43d30989714aad$var$l.TITLE), _$r = $5e43d30989714aad$var$T(t, "titleTemplate");
    if (Array.isArray(_$e) && (_$e = _$e.join("")), _$r && _$e) return _$r.replace(/%s/g, function() {
        return _$e;
    });
    var n = $5e43d30989714aad$var$T(t, "defaultTitle");
    return _$e || n || void 0;
}, $5e43d30989714aad$var$b = function b(t) {
    return $5e43d30989714aad$var$T(t, "onChangeClientState") || function() {};
}, $5e43d30989714aad$var$v = function v(t, e) {
    return e.filter(function(e) {
        return void 0 !== e[t];
    }).map(function(e) {
        return e[t];
    }).reduce(function(t, e) {
        return $5e43d30989714aad$var$a({}, t, e);
    }, {});
}, $5e43d30989714aad$var$A = function A(t, e) {
    return e.filter(function(t) {
        return void 0 !== t[$5e43d30989714aad$var$l.BASE];
    }).map(function(t) {
        return t[$5e43d30989714aad$var$l.BASE];
    }).reverse().reduce(function(e, r) {
        if (!e.length) for(var n = Object.keys(r), i = 0; i < n.length; i += 1){
            var o = n[i].toLowerCase();
            if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
        }
        return e;
    }, []);
}, $5e43d30989714aad$var$C = function C(t, e, r) {
    var n = {};
    return r.filter(function(e) {
        return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + (0, $5F2Q2._)(e[t]) + '"'), !1);
    }).map(function(e) {
        return e[t];
    }).reverse().reduce(function(t, r) {
        var i = {};
        r.filter(function(t) {
            for(var _$r, o = Object.keys(t), _$a = 0; _$a < o.length; _$a += 1){
                var s = o[_$a], c = s.toLowerCase();
                -1 === e.indexOf(c) || "rel" === _$r && "canonical" === t[_$r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (_$r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (_$r = s);
            }
            if (!_$r || !t[_$r]) return !1;
            var u = t[_$r].toLowerCase();
            return n[_$r] || (n[_$r] = {}), i[_$r] || (i[_$r] = {}), !n[_$r][u] && (i[_$r][u] = !0, !0);
        }).reverse().forEach(function(e) {
            return t.push(e);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s += 1){
            var c = o[s], u = $5e43d30989714aad$var$a({}, n[c], i[c]);
            n[c] = u;
        }
        return t;
    }, []).reverse();
}, $5e43d30989714aad$var$O = function O(t, e) {
    if (Array.isArray(t) && t.length) {
        for(var _$r = 0; _$r < t.length; _$r += 1)if (t[_$r][e]) return !0;
    }
    return !1;
}, $5e43d30989714aad$var$S = function S(t) {
    return Array.isArray(t) ? t.join("") : t;
}, $5e43d30989714aad$var$E = function E(t, e) {
    return Array.isArray(t) ? t.reduce(function(t, r) {
        return function(t, e) {
            for(var _$r = Object.keys(t), n = 0; n < _$r.length; n += 1)if (e[_$r[n]] && e[_$r[n]].includes(t[_$r[n]])) return !0;
            return !1;
        }(r, e) ? t.priority.push(r) : t.default.push(r), t;
    }, {
        priority: [],
        default: []
    }) : {
        default: t
    };
}, $5e43d30989714aad$var$I = function I(t, e) {
    var _$r;
    return $5e43d30989714aad$var$a({}, t, ((_$r = {})[e] = void 0, _$r));
}, $5e43d30989714aad$var$P = [
    $5e43d30989714aad$var$l.NOSCRIPT,
    $5e43d30989714aad$var$l.SCRIPT,
    $5e43d30989714aad$var$l.STYLE
], $5e43d30989714aad$var$w = function w(t, e) {
    return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, $5e43d30989714aad$var$x = function x(t) {
    return Object.keys(t).reduce(function(e, r) {
        var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
        return e ? e + " " + n : n;
    }, "");
}, $5e43d30989714aad$var$L = function L(t, e) {
    return void 0 === e && (e = {}), Object.keys(t).reduce(function(e, r) {
        return e[$5e43d30989714aad$var$m[r] || r] = t[r], e;
    }, e);
}, $5e43d30989714aad$var$j = function j(e, r) {
    return r.map(function(r, n) {
        var i, o = ((i = {
            key: n
        })["data-rh"] = !0, i);
        return Object.keys(r).forEach(function(t) {
            var _$e = $5e43d30989714aad$var$m[t] || t;
            "innerHTML" === _$e || "cssText" === _$e ? o.dangerouslySetInnerHTML = {
                __html: r.innerHTML || r.cssText
            } : o[_$e] = r[t];
        }), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(e, o);
    });
}, $5e43d30989714aad$var$M = function M(e, r, n) {
    switch(e){
        case $5e43d30989714aad$var$l.TITLE:
            return {
                toComponent: function toComponent() {
                    var _$e, n, i, o;
                    return n = r.titleAttributes, (i = {
                        key: _$e = r.title
                    })["data-rh"] = !0, o = $5e43d30989714aad$var$L(n, i), [
                        (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($5e43d30989714aad$var$l.TITLE, o, _$e)
                    ];
                },
                toString: function toString() {
                    return function(t, e, r, n) {
                        var i = $5e43d30989714aad$var$x(r), o = $5e43d30989714aad$var$S(e);
                        return i ? "<" + t + ' data-rh="true" ' + i + ">" + $5e43d30989714aad$var$w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + $5e43d30989714aad$var$w(o, n) + "</" + t + ">";
                    }(e, r.title, r.titleAttributes, n);
                }
            };
        case "bodyAttributes":
        case "htmlAttributes":
            return {
                toComponent: function toComponent() {
                    return $5e43d30989714aad$var$L(r);
                },
                toString: function toString() {
                    return $5e43d30989714aad$var$x(r);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $5e43d30989714aad$var$j(e, r);
                },
                toString: function toString() {
                    return function(t, e, r) {
                        return e.reduce(function(e, n) {
                            var i = Object.keys(n).filter(function(t) {
                                return !("innerHTML" === t || "cssText" === t);
                            }).reduce(function(t, e) {
                                var i = void 0 === n[e] ? e : e + '="' + $5e43d30989714aad$var$w(n[e], r) + '"';
                                return t ? t + " " + i : i;
                            }, ""), o = n.innerHTML || n.cssText || "", a = -1 === $5e43d30989714aad$var$P.indexOf(t);
                            return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
                        }, "");
                    }(e, r, n);
                }
            };
    }
}, $5e43d30989714aad$var$k = function k(t) {
    var _$e = t.baseTag, _$r = t.bodyAttributes, n = t.encode, i = t.htmlAttributes, o = t.noscriptTags, a = t.styleTags, s = t.title, c = void 0 === s ? "" : s, u = t.titleAttributes, h = t.linkTags, m = t.metaTags, y = t.scriptTags, T = {
        toComponent: function toComponent() {},
        toString: function toString() {
            return "";
        }
    };
    if (t.prioritizeSeoTags) {
        var g = function(t) {
            var _$e = t.linkTags, _$r = t.scriptTags, n = t.encode, i = $5e43d30989714aad$var$E(t.metaTags, $5e43d30989714aad$var$d), o = $5e43d30989714aad$var$E(_$e, $5e43d30989714aad$var$p), a = $5e43d30989714aad$var$E(_$r, $5e43d30989714aad$var$f);
            return {
                priorityMethods: {
                    toComponent: function toComponent() {
                        return [].concat($5e43d30989714aad$var$j($5e43d30989714aad$var$l.META, i.priority), $5e43d30989714aad$var$j($5e43d30989714aad$var$l.LINK, o.priority), $5e43d30989714aad$var$j($5e43d30989714aad$var$l.SCRIPT, a.priority));
                    },
                    toString: function toString() {
                        return $5e43d30989714aad$var$M($5e43d30989714aad$var$l.META, i.priority, n) + " " + $5e43d30989714aad$var$M($5e43d30989714aad$var$l.LINK, o.priority, n) + " " + $5e43d30989714aad$var$M($5e43d30989714aad$var$l.SCRIPT, a.priority, n);
                    }
                },
                metaTags: i.default,
                linkTags: o.default,
                scriptTags: a.default
            };
        }(t);
        T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
    }
    return {
        priority: T,
        base: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.BASE, _$e, n),
        bodyAttributes: $5e43d30989714aad$var$M("bodyAttributes", _$r, n),
        htmlAttributes: $5e43d30989714aad$var$M("htmlAttributes", i, n),
        link: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.LINK, h, n),
        meta: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.META, m, n),
        noscript: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.NOSCRIPT, o, n),
        script: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.SCRIPT, y, n),
        style: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.STYLE, a, n),
        title: $5e43d30989714aad$var$M($5e43d30989714aad$var$l.TITLE, {
            title: c,
            titleAttributes: u
        }, n)
    };
}, $5e43d30989714aad$var$H = [], $5e43d30989714aad$export$a9cf6990c9c7feb9 = function N(t, e) {
    var _$r = this;
    void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
        setHelmet: function setHelmet(t) {
            _$r.context.helmet = t;
        },
        helmetInstances: {
            get: function get() {
                return _$r.canUseDOM ? $5e43d30989714aad$var$H : _$r.instances;
            },
            add: function add(t) {
                (_$r.canUseDOM ? $5e43d30989714aad$var$H : _$r.instances).push(t);
            },
            remove: function remove(t) {
                var _$e = (_$r.canUseDOM ? $5e43d30989714aad$var$H : _$r.instances).indexOf(t);
                (_$r.canUseDOM ? $5e43d30989714aad$var$H : _$r.instances).splice(_$e, 1);
            }
        }
    }, this.context = t, this.canUseDOM = e, e || (t.helmet = $5e43d30989714aad$var$k({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: !0,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
    }));
}, $5e43d30989714aad$var$R = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createContext({}), $5e43d30989714aad$var$D = (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).shape({
    setHelmet: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    helmetInstances: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).shape({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
        add: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func
    })
}), $5e43d30989714aad$var$U = "undefined" != typeof document, $5e43d30989714aad$export$4719288a8f5f7e71 = /*#__PURE__*/ function(e) {
    function r(t) {
        var n;
        return (n = e.call(this, t) || this).helmetData = new $5e43d30989714aad$export$a9cf6990c9c7feb9(n.props.context, r.canUseDOM), n;
    }
    return $5e43d30989714aad$var$s(r, e), r.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($5e43d30989714aad$var$R.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }, r;
}((0, $4CEbD.Component));
$5e43d30989714aad$export$4719288a8f5f7e71.canUseDOM = $5e43d30989714aad$var$U, $5e43d30989714aad$export$4719288a8f5f7e71.propTypes = {
    context: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).shape({
        helmet: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).shape()
    }),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node.isRequired
}, $5e43d30989714aad$export$4719288a8f5f7e71.defaultProps = {
    context: {}
}, $5e43d30989714aad$export$4719288a8f5f7e71.displayName = "HelmetProvider";
var $5e43d30989714aad$var$Y = function Y(t, e) {
    var _$r, n = document.head || document.querySelector($5e43d30989714aad$var$l.HEAD), i = n.querySelectorAll(t + "[data-rh]"), o = [].slice.call(i), a = [];
    return e && e.length && e.forEach(function(e) {
        var n = document.createElement(t);
        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
        n.setAttribute("data-rh", "true"), o.some(function(t, e) {
            return _$r = e, n.isEqualNode(t);
        }) ? o.splice(_$r, 1) : a.push(n);
    }), o.forEach(function(t) {
        return t.parentNode.removeChild(t);
    }), a.forEach(function(t) {
        return n.appendChild(t);
    }), {
        oldTags: o,
        newTags: a
    };
}, $5e43d30989714aad$var$B = function B(t, e) {
    var _$r = document.getElementsByTagName(t)[0];
    if (_$r) {
        for(var n = _$r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1){
            var c = a[s], u = e[c] || "";
            _$r.getAttribute(c) !== u && _$r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
            var l = o.indexOf(c);
            -1 !== l && o.splice(l, 1);
        }
        for(var p = o.length - 1; p >= 0; p -= 1)_$r.removeAttribute(o[p]);
        i.length === o.length ? _$r.removeAttribute("data-rh") : _$r.getAttribute("data-rh") !== a.join(",") && _$r.setAttribute("data-rh", a.join(","));
    }
}, $5e43d30989714aad$var$K = function K(t, e) {
    var _$r = t.baseTag, n = t.htmlAttributes, i = t.linkTags, o = t.metaTags, a = t.noscriptTags, s = t.onChangeClientState, c = t.scriptTags, u = t.styleTags, p = t.title, f = t.titleAttributes;
    $5e43d30989714aad$var$B($5e43d30989714aad$var$l.BODY, t.bodyAttributes), $5e43d30989714aad$var$B($5e43d30989714aad$var$l.HTML, n), function(t, e) {
        void 0 !== t && document.title !== t && (document.title = $5e43d30989714aad$var$S(t)), $5e43d30989714aad$var$B($5e43d30989714aad$var$l.TITLE, e);
    }(p, f);
    var d = {
        baseTag: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.BASE, _$r),
        linkTags: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.LINK, i),
        metaTags: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.META, o),
        noscriptTags: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.NOSCRIPT, a),
        scriptTags: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.SCRIPT, c),
        styleTags: $5e43d30989714aad$var$Y($5e43d30989714aad$var$l.STYLE, u)
    }, h = {}, m = {};
    Object.keys(d).forEach(function(t) {
        var _$e = d[t], _$r = _$e.newTags, n = _$e.oldTags;
        _$r.length && (h[t] = _$r), n.length && (m[t] = d[t].oldTags);
    }), e && e(), s(t, h, m);
}, $5e43d30989714aad$var$_ = null, $5e43d30989714aad$var$z = /*#__PURE__*/ function(t) {
    var _$e = function _$e() {
        for(var _$e, _$r = arguments.length, n = new Array(_$r), i = 0; i < _$r; i++)n[i] = arguments[i];
        return (_$e = t.call.apply(t, [
            this
        ].concat(n)) || this).rendered = !1, _$e;
    };
    $5e43d30989714aad$var$s(_$e, t);
    var _$r = _$e.prototype;
    return _$r.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8d4bb89e3659dc98$exports)))(t, this.props);
    }, _$r.componentDidUpdate = function() {
        this.emitChange();
    }, _$r.componentWillUnmount = function() {
        this.props.context.helmetInstances.remove(this), this.emitChange();
    }, _$r.emitChange = function() {
        var _$t, _$e, _$r = this.props.context, n = _$r.setHelmet, i = null, o = (_$t = _$r.helmetInstances.get().map(function(t) {
            var _$e = $5e43d30989714aad$var$a({}, t.props);
            return delete _$e.context, _$e;
        }), {
            baseTag: $5e43d30989714aad$var$A([
                "href"
            ], _$t),
            bodyAttributes: $5e43d30989714aad$var$v("bodyAttributes", _$t),
            defer: $5e43d30989714aad$var$T(_$t, "defer"),
            encode: $5e43d30989714aad$var$T(_$t, "encodeSpecialCharacters"),
            htmlAttributes: $5e43d30989714aad$var$v("htmlAttributes", _$t),
            linkTags: $5e43d30989714aad$var$C($5e43d30989714aad$var$l.LINK, [
                "rel",
                "href"
            ], _$t),
            metaTags: $5e43d30989714aad$var$C($5e43d30989714aad$var$l.META, [
                "name",
                "charset",
                "http-equiv",
                "property",
                "itemprop"
            ], _$t),
            noscriptTags: $5e43d30989714aad$var$C($5e43d30989714aad$var$l.NOSCRIPT, [
                "innerHTML"
            ], _$t),
            onChangeClientState: $5e43d30989714aad$var$b(_$t),
            scriptTags: $5e43d30989714aad$var$C($5e43d30989714aad$var$l.SCRIPT, [
                "src",
                "innerHTML"
            ], _$t),
            styleTags: $5e43d30989714aad$var$C($5e43d30989714aad$var$l.STYLE, [
                "cssText"
            ], _$t),
            title: $5e43d30989714aad$var$g(_$t),
            titleAttributes: $5e43d30989714aad$var$v("titleAttributes", _$t),
            prioritizeSeoTags: $5e43d30989714aad$var$O(_$t, "prioritizeSeoTags")
        });
        $5e43d30989714aad$export$4719288a8f5f7e71.canUseDOM ? (_$e = o, $5e43d30989714aad$var$_ && cancelAnimationFrame($5e43d30989714aad$var$_), _$e.defer ? $5e43d30989714aad$var$_ = requestAnimationFrame(function() {
            $5e43d30989714aad$var$K(_$e, function() {
                $5e43d30989714aad$var$_ = null;
            });
        }) : ($5e43d30989714aad$var$K(_$e), $5e43d30989714aad$var$_ = null)) : $5e43d30989714aad$var$k && (i = $5e43d30989714aad$var$k(o)), n(i);
    }, _$r.init = function() {
        this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
    }, _$r.render = function() {
        return this.init(), null;
    }, _$e;
}((0, $4CEbD.Component));
$5e43d30989714aad$var$z.propTypes = {
    context: $5e43d30989714aad$var$D.isRequired
}, $5e43d30989714aad$var$z.displayName = "HelmetDispatcher";
var $5e43d30989714aad$var$F = [
    "children"
], $5e43d30989714aad$var$G = [
    "children"
], $5e43d30989714aad$export$dcef8f9bb9a41431 = /*#__PURE__*/ function(e) {
    var _$r = function _$r() {
        return e.apply(this, arguments) || this;
    };
    $5e43d30989714aad$var$s(_$r, e);
    var o = _$r.prototype;
    return o.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ee6ed275075e2808$exports)))($5e43d30989714aad$var$I(this.props, "helmetData"), $5e43d30989714aad$var$I(t, "helmetData"));
    }, o.mapNestedChildrenToProps = function(t, e) {
        if (!e) return null;
        switch(t.type){
            case $5e43d30989714aad$var$l.SCRIPT:
            case $5e43d30989714aad$var$l.NOSCRIPT:
                return {
                    innerHTML: e
                };
            case $5e43d30989714aad$var$l.STYLE:
                return {
                    cssText: e
                };
            default:
                throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        }
    }, o.flattenArrayTypeChildren = function(t) {
        var _$e, _$r = t.child, n = t.arrayTypeChildren;
        return $5e43d30989714aad$var$a({}, n, ((_$e = {})[_$r.type] = [].concat(n[_$r.type] || [], [
            $5e43d30989714aad$var$a({}, t.newChildProps, this.mapNestedChildrenToProps(_$r, t.nestedChildren))
        ]), _$e));
    }, o.mapObjectTypeChildren = function(t) {
        var _$e, _$r, n = t.child, i = t.newProps, o = t.newChildProps, _$s = t.nestedChildren;
        switch(n.type){
            case $5e43d30989714aad$var$l.TITLE:
                return $5e43d30989714aad$var$a({}, i, ((_$e = {})[n.type] = _$s, _$e.titleAttributes = $5e43d30989714aad$var$a({}, o), _$e));
            case $5e43d30989714aad$var$l.BODY:
                return $5e43d30989714aad$var$a({}, i, {
                    bodyAttributes: $5e43d30989714aad$var$a({}, o)
                });
            case $5e43d30989714aad$var$l.HTML:
                return $5e43d30989714aad$var$a({}, i, {
                    htmlAttributes: $5e43d30989714aad$var$a({}, o)
                });
            default:
                return $5e43d30989714aad$var$a({}, i, ((_$r = {})[n.type] = $5e43d30989714aad$var$a({}, o), _$r));
        }
    }, o.mapArrayTypeChildrenToProps = function(t, e) {
        var _$r = $5e43d30989714aad$var$a({}, e);
        return Object.keys(t).forEach(function(e) {
            var n;
            _$r = $5e43d30989714aad$var$a({}, _$r, ((n = {})[e] = t[e], n));
        }), _$r;
    }, o.warnOnInvalidChildren = function(t, e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))($5e43d30989714aad$var$h.some(function(e) {
            return t.type === e;
        }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + $5e43d30989714aad$var$h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(!e || "string" == typeof e || Array.isArray(e) && !e.some(function(t) {
            return "string" != typeof t;
        }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
    }, o.mapChildrenToProps = function(e, r) {
        var n = this, i = {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Children.forEach(e, function(t) {
            if (t && t.props) {
                var _$e = t.props, o = _$e.children, a = $5e43d30989714aad$var$u(_$e, $5e43d30989714aad$var$F), _$s = Object.keys(a).reduce(function(t, e) {
                    return t[$5e43d30989714aad$var$y[e] || e] = a[e], t;
                }, {}), c = t.type;
                switch("symbol" == (typeof c === "undefined" ? "undefined" : (0, $5F2Q2._)(c)) ? c = c.toString() : n.warnOnInvalidChildren(t, o), c){
                    case $5e43d30989714aad$var$l.FRAGMENT:
                        r = n.mapChildrenToProps(o, r);
                        break;
                    case $5e43d30989714aad$var$l.LINK:
                    case $5e43d30989714aad$var$l.META:
                    case $5e43d30989714aad$var$l.NOSCRIPT:
                    case $5e43d30989714aad$var$l.SCRIPT:
                    case $5e43d30989714aad$var$l.STYLE:
                        i = n.flattenArrayTypeChildren({
                            child: t,
                            arrayTypeChildren: i,
                            newChildProps: _$s,
                            nestedChildren: o
                        });
                        break;
                    default:
                        r = n.mapObjectTypeChildren({
                            child: t,
                            newProps: r,
                            newChildProps: _$s,
                            nestedChildren: o
                        });
                }
            }
        }), this.mapArrayTypeChildrenToProps(i, r);
    }, o.render = function() {
        var _$e = this.props, _$r = _$e.children, n = $5e43d30989714aad$var$u(_$e, $5e43d30989714aad$var$G), i = $5e43d30989714aad$var$a({}, n), o = n.helmetData;
        return _$r && (i = this.mapChildrenToProps(_$r, i)), !o || o instanceof $5e43d30989714aad$export$a9cf6990c9c7feb9 || (o = new $5e43d30989714aad$export$a9cf6990c9c7feb9(o.context, o.instances)), o ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($5e43d30989714aad$var$z, $5e43d30989714aad$var$a({}, i, {
            context: o.value,
            helmetData: void 0
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($5e43d30989714aad$var$R.Consumer, null, function(e) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($5e43d30989714aad$var$z, $5e43d30989714aad$var$a({}, i, {
                context: e
            }));
        });
    }, _$r;
}((0, $4CEbD.Component));
$5e43d30989714aad$export$dcef8f9bb9a41431.propTypes = {
    base: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node
    ]),
    defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    defer: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object),
    meta: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object),
    noscript: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object),
    onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    script: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    prioritizeSeoTags: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    helmetData: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object
}, $5e43d30989714aad$export$dcef8f9bb9a41431.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
}, $5e43d30989714aad$export$dcef8f9bb9a41431.displayName = "Helmet";


var $a49107eacf056432$export$711117ad6ad27992 = "persist:";
var $a49107eacf056432$export$2aaee4793dd13a52 = "persist/FLUSH";
var $a49107eacf056432$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $a49107eacf056432$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $a49107eacf056432$export$913fe0e161ed92a2 = "persist/PERSIST";
var $a49107eacf056432$export$5514fc3b4067675f = "persist/PURGE";
var $a49107eacf056432$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $a49107eacf056432$export$363ebe89e6e7aeef = -1;



var $5F2Q2 = parcelRequire("5F2Q2");
function $14aff9548edddfb7$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $5F2Q2._)(Symbol.iterator) === "symbol") $14aff9548edddfb7$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    else $14aff9548edddfb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    return $14aff9548edddfb7$var$_typeof(obj);
}
function $14aff9548edddfb7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $14aff9548edddfb7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $14aff9548edddfb7$var$ownKeys(source, true).forEach(function(key) {
            $14aff9548edddfb7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $14aff9548edddfb7$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $14aff9548edddfb7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14aff9548edddfb7$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $14aff9548edddfb7$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $14aff9548edddfb7$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $6b7e18cbba31ec1e$export$2e2bcd8739ae039(config) {
    var processNextKey = function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    };
    var writeStagedState = function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    };
    var passWhitelistBlacklist = function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    };
    var onWriteFail = function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    };
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $a49107eacf056432$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $6b7e18cbba31ec1e$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $6b7e18cbba31ec1e$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $65f07d98b71bd272$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $a49107eacf056432$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $65f07d98b71bd272$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $65f07d98b71bd272$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $bee25176393f1b3b$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $a49107eacf056432$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $bee25176393f1b3b$var$warnIfRemoveError);
}
function $bee25176393f1b3b$var$warnIfRemoveError(err) {}


function $47b4cda08f368afe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47b4cda08f368afe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $47b4cda08f368afe$var$ownKeys(source, true).forEach(function(key) {
            $47b4cda08f368afe$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $47b4cda08f368afe$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47b4cda08f368afe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47b4cda08f368afe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $47b4cda08f368afe$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $47b4cda08f368afe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $47b4cda08f368afe$var$DEFAULT_TIMEOUT = 5000;
function $47b4cda08f368afe$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $a49107eacf056432$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $14aff9548edddfb7$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $65f07d98b71bd272$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $47b4cda08f368afe$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $47b4cda08f368afe$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $a49107eacf056432$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $6b7e18cbba31ec1e$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $47b4cda08f368afe$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $47b4cda08f368afe$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $a49107eacf056432$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $bee25176393f1b3b$export$2e2bcd8739ae039)(config));
            return $47b4cda08f368afe$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $a49107eacf056432$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $47b4cda08f368afe$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $a49107eacf056432$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $a49107eacf056432$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $47b4cda08f368afe$var$_objectSpread({}, restState, {
                _persist: $47b4cda08f368afe$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $47b4cda08f368afe$var$_objectSpread({}, reconciledRest, {
                    _persist: $47b4cda08f368afe$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($47b4cda08f368afe$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}



var $5F2Q2 = parcelRequire("5F2Q2");
function $aef438142fbed70c$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $aef438142fbed70c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aef438142fbed70c$export$2e2bcd8739ae039(obj);
}



function $21ee2ecc22c8b917$export$2e2bcd8739ae039(input, hint) {
    if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $9d0269e895187a7a$export$2e2bcd8739ae039(arg) {
    var key = (0, $21ee2ecc22c8b917$export$2e2bcd8739ae039)(arg, "string");
    return (0, $aef438142fbed70c$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $be350f5be03d52fe$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $9d0269e895187a7a$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $f48306fa8da079ea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f48306fa8da079ea$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f48306fa8da079ea$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $be350f5be03d52fe$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f48306fa8da079ea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $89b24bf7e3a8e9f2$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $89b24bf7e3a8e9f2$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $89b24bf7e3a8e9f2$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $89b24bf7e3a8e9f2$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $89b24bf7e3a8e9f2$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $89b24bf7e3a8e9f2$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $89b24bf7e3a8e9f2$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $89b24bf7e3a8e9f2$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $89b24bf7e3a8e9f2$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $5F2Q2._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($89b24bf7e3a8e9f2$var$isDate(val)) return "date";
    if ($89b24bf7e3a8e9f2$var$isError(val)) return "error";
    var constructorName = $89b24bf7e3a8e9f2$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $89b24bf7e3a8e9f2$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $89b24bf7e3a8e9f2$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $89b24bf7e3a8e9f2$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $89b24bf7e3a8e9f2$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $5F2Q2._)(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $89b24bf7e3a8e9f2$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var ensureCanMutateNextListeners = /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    };
    var getState = /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(3));
        return currentState;
    };
    var subscribe = /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    };
    var dispatch = /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$89b24bf7e3a8e9f2$var$isPlainObject(action)) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    };
    var replaceReducer = /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $89b24bf7e3a8e9f2$export$4219e499db7ca678.REPLACE
        });
    };
    var observable = /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$89b24bf7e3a8e9f2$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    ;
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(1));
        return enhancer($89b24bf7e3a8e9f2$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $89b24bf7e3a8e9f2$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$89b24bf7e3a8e9f2$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $89b24bf7e3a8e9f2$export$8928921ea2d3b126 = $89b24bf7e3a8e9f2$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $89b24bf7e3a8e9f2$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $89b24bf7e3a8e9f2$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $89b24bf7e3a8e9f2$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$89b24bf7e3a8e9f2$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $89b24bf7e3a8e9f2$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $89b24bf7e3a8e9f2$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $89b24bf7e3a8e9f2$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $89b24bf7e3a8e9f2$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $89b24bf7e3a8e9f2$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $89b24bf7e3a8e9f2$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $89b24bf7e3a8e9f2$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $89b24bf7e3a8e9f2$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $89b24bf7e3a8e9f2$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $89b24bf7e3a8e9f2$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $89b24bf7e3a8e9f2$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $89b24bf7e3a8e9f2$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($89b24bf7e3a8e9f2$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $f48306fa8da079ea$export$2e2bcd8739ae039)((0, $f48306fa8da079ea$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}




var $5F2Q2 = parcelRequire("5F2Q2");
function $56beb6bbb1443246$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $5F2Q2._)(Symbol.iterator) === "symbol") $56beb6bbb1443246$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    else $56beb6bbb1443246$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    return $56beb6bbb1443246$var$_typeof(obj);
}
function $56beb6bbb1443246$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $56beb6bbb1443246$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $56beb6bbb1443246$var$ownKeys(source, true).forEach(function(key) {
            $56beb6bbb1443246$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $56beb6bbb1443246$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $56beb6bbb1443246$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $56beb6bbb1443246$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $56beb6bbb1443246$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $56beb6bbb1443246$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($56beb6bbb1443246$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $56beb6bbb1443246$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $56beb6bbb1443246$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $56beb6bbb1443246$var$_typeof(o) === "object";
}


function $3a5a6a748adfab8d$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $56beb6bbb1443246$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $47b4cda08f368afe$export$2e2bcd8739ae039)(config, (0, $89b24bf7e3a8e9f2$export$66e4520cdb265d18)(reducers));
}




function $382d3e111b0c0f6e$var$_toConsumableArray(arr) {
    return $382d3e111b0c0f6e$var$_arrayWithoutHoles(arr) || $382d3e111b0c0f6e$var$_iterableToArray(arr) || $382d3e111b0c0f6e$var$_nonIterableSpread();
}
function $382d3e111b0c0f6e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $382d3e111b0c0f6e$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $382d3e111b0c0f6e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $382d3e111b0c0f6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $382d3e111b0c0f6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $382d3e111b0c0f6e$var$ownKeys(source, true).forEach(function(key) {
            $382d3e111b0c0f6e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $382d3e111b0c0f6e$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $382d3e111b0c0f6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $382d3e111b0c0f6e$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $382d3e111b0c0f6e$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $382d3e111b0c0f6e$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $a49107eacf056432$export$51e82cdd7353a0e1:
            return $382d3e111b0c0f6e$var$_objectSpread({}, state, {
                registry: [].concat($382d3e111b0c0f6e$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $a49107eacf056432$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $382d3e111b0c0f6e$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $382d3e111b0c0f6e$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $382d3e111b0c0f6e$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $89b24bf7e3a8e9f2$export$f51a9068ac82ea43)($382d3e111b0c0f6e$var$persistorReducer, $382d3e111b0c0f6e$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $a49107eacf056432$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $a49107eacf056432$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $382d3e111b0c0f6e$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $a49107eacf056432$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $a49107eacf056432$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $a49107eacf056432$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $a49107eacf056432$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $193016d66b9c46e7$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $a49107eacf056432$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a44c60cc4b29c8d5$export$2e2bcd8739ae039(inbound, outbound) {
    var whitelistBlacklistCheck = function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    };
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $ba25758a6f39d355$exports = {};
$parcel$export($ba25758a6f39d355$exports, "applyMiddleware", function () { return $89b24bf7e3a8e9f2$export$9ff26e0402cc7b7; }, function (v) { return $89b24bf7e3a8e9f2$export$9ff26e0402cc7b7 = v; });
$parcel$export($ba25758a6f39d355$exports, "combineReducers", function () { return $89b24bf7e3a8e9f2$export$66e4520cdb265d18; }, function (v) { return $89b24bf7e3a8e9f2$export$66e4520cdb265d18 = v; });
$parcel$export($ba25758a6f39d355$exports, "compose", function () { return $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7; }, function (v) { return $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7 = v; });
$parcel$export($ba25758a6f39d355$exports, "createStore", function () { return $89b24bf7e3a8e9f2$export$f51a9068ac82ea43; }, function (v) { return $89b24bf7e3a8e9f2$export$f51a9068ac82ea43 = v; });

$parcel$export($ba25758a6f39d355$exports, "configureStore", function () { return $ba25758a6f39d355$export$7d8a5b498da695ac; });
$parcel$export($ba25758a6f39d355$exports, "createSlice", function () { return $ba25758a6f39d355$export$4d8d9bd83c24ae8b; });

var $5F2Q2 = parcelRequire("5F2Q2");

var $5F2Q2 = parcelRequire("5F2Q2");
function $3726ef9d8ef2a133$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var _$i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $3726ef9d8ef2a133$export$541ac630993a4c84(n) {
    return !!n && !!n[$3726ef9d8ef2a133$var$Q];
}
function $3726ef9d8ef2a133$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $3726ef9d8ef2a133$var$Z;
    }(n) || Array.isArray(n) || !!n[$3726ef9d8ef2a133$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$3726ef9d8ef2a133$export$6ee2082928bcb0ee]) || $3726ef9d8ef2a133$var$s(n) || $3726ef9d8ef2a133$var$v(n));
}
function $3726ef9d8ef2a133$export$22e8af3f75a010e3(t) {
    return $3726ef9d8ef2a133$export$541ac630993a4c84(t) || $3726ef9d8ef2a133$var$n(23, t), t[$3726ef9d8ef2a133$var$Q].t;
}
function $3726ef9d8ef2a133$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $3726ef9d8ef2a133$var$o(n) ? (t ? Object.keys : $3726ef9d8ef2a133$var$nn)(n).forEach(function(e) {
        t && "symbol" == (typeof e === "undefined" ? "undefined" : (0, $5F2Q2._)(e)) || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $3726ef9d8ef2a133$var$o(n) {
    var r = n[$3726ef9d8ef2a133$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $3726ef9d8ef2a133$var$s(n) ? 2 : $3726ef9d8ef2a133$var$v(n) ? 3 : 0;
}
function $3726ef9d8ef2a133$var$u(n, r) {
    return 2 === $3726ef9d8ef2a133$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $3726ef9d8ef2a133$var$a(n, r) {
    return 2 === $3726ef9d8ef2a133$var$o(n) ? n.get(r) : n[r];
}
function $3726ef9d8ef2a133$var$f(n, r, t) {
    var e = $3726ef9d8ef2a133$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $3726ef9d8ef2a133$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $3726ef9d8ef2a133$var$s(n) {
    return $3726ef9d8ef2a133$var$X && n instanceof Map;
}
function $3726ef9d8ef2a133$var$v(n) {
    return $3726ef9d8ef2a133$var$q && n instanceof Set;
}
function $3726ef9d8ef2a133$var$p(n) {
    return n.o || n.t;
}
function $3726ef9d8ef2a133$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $3726ef9d8ef2a133$var$rn(n);
    delete r[$3726ef9d8ef2a133$var$Q];
    for(var t = $3726ef9d8ef2a133$var$nn(r), e = 0; e < t.length; e++){
        var _$i = t[e], o = r[_$i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[_$i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[_$i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $3726ef9d8ef2a133$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $3726ef9d8ef2a133$var$y(n) || $3726ef9d8ef2a133$export$541ac630993a4c84(n) || !$3726ef9d8ef2a133$export$16e3aed3edb85946(n) || ($3726ef9d8ef2a133$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $3726ef9d8ef2a133$var$h), Object.freeze(n), e && $3726ef9d8ef2a133$var$i(n, function(n, r) {
        return $3726ef9d8ef2a133$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $3726ef9d8ef2a133$var$h() {
    $3726ef9d8ef2a133$var$n(2);
}
function $3726ef9d8ef2a133$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $3726ef9d8ef2a133$var$b(r) {
    var t = $3726ef9d8ef2a133$var$tn[r];
    return t || $3726ef9d8ef2a133$var$n(18, r), t;
}
function $3726ef9d8ef2a133$var$m(n, r) {
    $3726ef9d8ef2a133$var$tn[n] || ($3726ef9d8ef2a133$var$tn[n] = r);
}
function $3726ef9d8ef2a133$var$_() {
    return $3726ef9d8ef2a133$var$U;
}
function $3726ef9d8ef2a133$var$j(n, r) {
    r && ($3726ef9d8ef2a133$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $3726ef9d8ef2a133$var$g(n) {
    $3726ef9d8ef2a133$var$O(n), n.p.forEach($3726ef9d8ef2a133$var$S), n.p = null;
}
function $3726ef9d8ef2a133$var$O(n) {
    n === $3726ef9d8ef2a133$var$U && ($3726ef9d8ef2a133$var$U = n.l);
}
function $3726ef9d8ef2a133$var$w(n) {
    return $3726ef9d8ef2a133$var$U = {
        p: [],
        l: $3726ef9d8ef2a133$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $3726ef9d8ef2a133$var$S(n) {
    var r = n[$3726ef9d8ef2a133$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $3726ef9d8ef2a133$var$P(r, e) {
    e._ = e.p.length;
    var _$i = e.p[0], o = void 0 !== r && r !== _$i;
    return e.h.O || $3726ef9d8ef2a133$var$b("ES5").S(e, r, o), o ? (_$i[$3726ef9d8ef2a133$var$Q].P && ($3726ef9d8ef2a133$var$g(e), $3726ef9d8ef2a133$var$n(4)), $3726ef9d8ef2a133$export$16e3aed3edb85946(r) && (r = $3726ef9d8ef2a133$var$M(e, r), e.l || $3726ef9d8ef2a133$var$x(e, r)), e.u && $3726ef9d8ef2a133$var$b("Patches").M(_$i[$3726ef9d8ef2a133$var$Q].t, r, e.u, e.s)) : r = $3726ef9d8ef2a133$var$M(e, _$i, []), $3726ef9d8ef2a133$var$g(e), e.u && e.v(e.u, e.s), r !== $3726ef9d8ef2a133$export$45b790e32b2810ee ? r : void 0;
}
function $3726ef9d8ef2a133$var$M(n, r, t) {
    if ($3726ef9d8ef2a133$var$y(r)) return r;
    var e = r[$3726ef9d8ef2a133$var$Q];
    if (!e) return $3726ef9d8ef2a133$var$i(r, function(i, o) {
        return $3726ef9d8ef2a133$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $3726ef9d8ef2a133$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $3726ef9d8ef2a133$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $3726ef9d8ef2a133$var$i(u, function(r, i) {
            return $3726ef9d8ef2a133$var$A(n, e, o, r, i, t, a);
        }), $3726ef9d8ef2a133$var$x(n, o, !1), t && n.u && $3726ef9d8ef2a133$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $3726ef9d8ef2a133$var$A(e, i, o, a, c, s, v) {
    if ($3726ef9d8ef2a133$export$541ac630993a4c84(c)) {
        var p = $3726ef9d8ef2a133$var$M(e, c, s && i && 3 !== i.i && !$3726ef9d8ef2a133$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($3726ef9d8ef2a133$var$f(o, a, p), !$3726ef9d8ef2a133$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($3726ef9d8ef2a133$export$16e3aed3edb85946(c) && !$3726ef9d8ef2a133$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $3726ef9d8ef2a133$var$M(e, c), i && i.A.l || $3726ef9d8ef2a133$var$x(e, c);
    }
}
function $3726ef9d8ef2a133$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $3726ef9d8ef2a133$export$792f3d81ea979f55(r, t);
}
function $3726ef9d8ef2a133$var$z(n, r) {
    var t = n[$3726ef9d8ef2a133$var$Q];
    return (t ? $3726ef9d8ef2a133$var$p(t) : n)[r];
}
function $3726ef9d8ef2a133$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $3726ef9d8ef2a133$var$k(n) {
    n.P || (n.P = !0, n.l && $3726ef9d8ef2a133$var$k(n.l));
}
function $3726ef9d8ef2a133$var$E(n) {
    n.o || (n.o = $3726ef9d8ef2a133$var$l(n.t));
}
function $3726ef9d8ef2a133$var$N(n, r, t) {
    var e = $3726ef9d8ef2a133$var$s(r) ? $3726ef9d8ef2a133$var$b("MapSet").F(r, t) : $3726ef9d8ef2a133$var$v(r) ? $3726ef9d8ef2a133$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var _$t = Array.isArray(n), e = {
            i: _$t ? 1 : 0,
            A: r ? r.A : $3726ef9d8ef2a133$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, _$i = e, o = $3726ef9d8ef2a133$var$en;
        _$t && (_$i = [
            e
        ], o = $3726ef9d8ef2a133$var$on);
        var u = Proxy.revocable(_$i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $3726ef9d8ef2a133$var$b("ES5").J(r, t);
    return (t ? t.A : $3726ef9d8ef2a133$var$_()).p.push(e), e;
}
function $3726ef9d8ef2a133$export$97aac956da55dae9(e) {
    return $3726ef9d8ef2a133$export$541ac630993a4c84(e) || $3726ef9d8ef2a133$var$n(22, e), function n(r) {
        if (!$3726ef9d8ef2a133$export$16e3aed3edb85946(r)) return r;
        var _$e, u = r[$3726ef9d8ef2a133$var$Q], c = $3726ef9d8ef2a133$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$3726ef9d8ef2a133$var$b("ES5").K(u))) return u.t;
            u.I = !0, _$e = $3726ef9d8ef2a133$var$D(r, c), u.I = !1;
        } else _$e = $3726ef9d8ef2a133$var$D(r, c);
        return $3726ef9d8ef2a133$var$i(_$e, function(r, t) {
            u && $3726ef9d8ef2a133$var$a(u.t, r) === t || $3726ef9d8ef2a133$var$f(_$e, r, n(t));
        }), 3 === c ? new Set(_$e) : _$e;
    }(e);
}
function $3726ef9d8ef2a133$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $3726ef9d8ef2a133$var$l(n);
}
function $3726ef9d8ef2a133$export$56771cf63ee491f5() {
    var t = function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function get() {
                var _$r = this[$3726ef9d8ef2a133$var$Q];
                return $3726ef9d8ef2a133$var$en.get(_$r, n);
            },
            set: function set(r) {
                var t = this[$3726ef9d8ef2a133$var$Q];
                $3726ef9d8ef2a133$var$en.set(t, n, r);
            }
        }, t;
    };
    var e = function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$3726ef9d8ef2a133$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $3726ef9d8ef2a133$var$k(t);
                    break;
                case 4:
                    o(t) && $3726ef9d8ef2a133$var$k(t);
            }
        }
    };
    var o = function o(n) {
        for(var r = n.t, t = n.k, e = $3726ef9d8ef2a133$var$nn(t), _$i = e.length - 1; _$i >= 0; _$i--){
            var o = e[_$i];
            if (o !== $3726ef9d8ef2a133$var$Q) {
                var a = r[o];
                if (void 0 === a && !$3726ef9d8ef2a133$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$3726ef9d8ef2a133$var$Q];
                if (s ? s.t !== a : !$3726ef9d8ef2a133$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$3726ef9d8ef2a133$var$Q];
        return e.length !== $3726ef9d8ef2a133$var$nn(r).length + (v ? 0 : 1);
    };
    var a = function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    };
    var f = function f(r) {
        r.g && $3726ef9d8ef2a133$var$n(3, JSON.stringify($3726ef9d8ef2a133$var$p(r)));
    };
    var s = {};
    $3726ef9d8ef2a133$var$m("ES5", {
        J: function J(n, r) {
            var e = Array.isArray(n), _$i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), _$i = 0; _$i < r.length; _$i++)Object.defineProperty(e, "" + _$i, t(_$i, !0));
                    return e;
                }
                var o = $3726ef9d8ef2a133$var$rn(r);
                delete o[$3726ef9d8ef2a133$var$Q];
                for(var u = $3726ef9d8ef2a133$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $3726ef9d8ef2a133$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: _$i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(_$i, $3726ef9d8ef2a133$var$Q, {
                value: o,
                writable: !0
            }), _$i;
        },
        S: function S(n, t, o) {
            o ? $3726ef9d8ef2a133$export$541ac630993a4c84(t) && t[$3726ef9d8ef2a133$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var _$t = r[$3726ef9d8ef2a133$var$Q];
                    if (_$t) {
                        var e = _$t.t, _$o = _$t.k, f = _$t.R, c = _$t.i;
                        if (4 === c) $3726ef9d8ef2a133$var$i(_$o, function(r) {
                            r !== $3726ef9d8ef2a133$var$Q && (void 0 !== e[r] || $3726ef9d8ef2a133$var$u(e, r) ? f[r] || n(_$o[r]) : (f[r] = !0, $3726ef9d8ef2a133$var$k(_$t)));
                        }), $3726ef9d8ef2a133$var$i(e, function(n) {
                            void 0 !== _$o[n] || $3726ef9d8ef2a133$var$u(_$o, n) || (f[n] = !1, $3726ef9d8ef2a133$var$k(_$t));
                        });
                        else if (5 === c) {
                            if (a(_$t) && ($3726ef9d8ef2a133$var$k(_$t), f.length = !0), _$o.length < e.length) for(var s = _$o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < _$o.length; v++)f[v] = !0;
                            for(var p = Math.min(_$o.length, e.length), l = 0; l < p; l++)_$o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(_$o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function K(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $3726ef9d8ef2a133$export$d3a6659991a0696c() {
    var f = function f(n) {
        return $3726ef9d8ef2a133$export$541ac630993a4c84(n) ? e(n) : n;
    };
    function e(n) {
        if (!$3726ef9d8ef2a133$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($3726ef9d8ef2a133$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($3726ef9d8ef2a133$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var _$i in n)r[_$i] = e(n[_$i]);
        return $3726ef9d8ef2a133$var$u(n, $3726ef9d8ef2a133$export$6ee2082928bcb0ee) && (r[$3726ef9d8ef2a133$export$6ee2082928bcb0ee] = n[$3726ef9d8ef2a133$export$6ee2082928bcb0ee]), r;
    }
    var c = "add";
    $3726ef9d8ef2a133$var$m("Patches", {
        $: function $(r, t) {
            return t.forEach(function(t) {
                for(var _$i = t.path, u = t.op, f = r, s = 0; s < _$i.length - 1; s++){
                    var v = $3726ef9d8ef2a133$var$o(f), p = _$i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $3726ef9d8ef2a133$var$n(24), "function" == typeof f && "prototype" === p && $3726ef9d8ef2a133$var$n(24), "object" != typeof (f = $3726ef9d8ef2a133$var$a(f, p)) && $3726ef9d8ef2a133$var$n(15, _$i.join("/"));
                }
                var l = $3726ef9d8ef2a133$var$o(f), d = e(t.value), h = _$i[_$i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $3726ef9d8ef2a133$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $3726ef9d8ef2a133$var$n(17, u);
                }
            }), r;
        },
        N: function N(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $3726ef9d8ef2a133$var$i(n.R, function(n, i) {
                            var v = $3726ef9d8ef2a133$var$a(o, n), p = $3726ef9d8ef2a133$var$a(s, n), l = i ? $3726ef9d8ef2a133$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var _$i = n.t, o = n.R, u = n.o;
                        if (u.length < _$i.length) {
                            var a = [
                                u,
                                _$i
                            ];
                            _$i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < _$i.length; v++)if (o[v] && u[v] !== _$i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(_$i[v])
                            });
                        }
                        for(var l = _$i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        _$i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: _$i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var _$i = n.t, o = n.o, u = 0;
                        _$i.forEach(function(n) {
                            if (!o.has(n)) {
                                var _$i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: _$i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: _$i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!_$i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function M(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $3726ef9d8ef2a133$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $3726ef9d8ef2a133$export$7d9f65390203b435() {
    var r = function r(n, _r) {
        function t() {
            this.constructor = n;
        }
        a(n, _r), n.prototype = (t.prototype = _r.prototype, new t);
    };
    var e = function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    };
    var o = function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($3726ef9d8ef2a133$export$16e3aed3edb85946(r)) {
                var e = $3726ef9d8ef2a133$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    };
    var u = function u(r) {
        r.g && $3726ef9d8ef2a133$var$n(3, JSON.stringify($3726ef9d8ef2a133$var$p(r)));
    };
    var a = function a1(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        var n = function n(n, r) {
            return this[$3726ef9d8ef2a133$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $3726ef9d8ef2a133$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        };
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function get() {
                return $3726ef9d8ef2a133$var$p(this[$3726ef9d8ef2a133$var$Q]).size;
            }
        }), o.has = function(n) {
            return $3726ef9d8ef2a133$var$p(this[$3726ef9d8ef2a133$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$3726ef9d8ef2a133$var$Q];
            return u(t), $3726ef9d8ef2a133$var$p(t).has(n) && $3726ef9d8ef2a133$var$p(t).get(n) === r || (e(t), $3726ef9d8ef2a133$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$3726ef9d8ef2a133$var$Q];
            return u(r), e(r), $3726ef9d8ef2a133$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$3726ef9d8ef2a133$var$Q];
            u(n), $3726ef9d8ef2a133$var$p(n).size && (e(n), $3726ef9d8ef2a133$var$k(n), n.R = new Map, $3726ef9d8ef2a133$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $3726ef9d8ef2a133$var$p(this[$3726ef9d8ef2a133$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$3726ef9d8ef2a133$var$Q];
            u(r);
            var _$i = $3726ef9d8ef2a133$var$p(r).get(n);
            if (r.I || !$3726ef9d8ef2a133$export$16e3aed3edb85946(_$i)) return _$i;
            if (_$i !== r.t.get(n)) return _$i;
            var o = $3726ef9d8ef2a133$var$N(r.A.h, _$i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $3726ef9d8ef2a133$var$p(this[$3726ef9d8ef2a133$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$3726ef9d8ef2a133$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$3726ef9d8ef2a133$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$3726ef9d8ef2a133$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        var n = function n(n, r) {
            return this[$3726ef9d8ef2a133$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $3726ef9d8ef2a133$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        };
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function get() {
                return $3726ef9d8ef2a133$var$p(this[$3726ef9d8ef2a133$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$3726ef9d8ef2a133$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$3726ef9d8ef2a133$var$Q];
            return u(r), this.has(n) || (o(r), $3726ef9d8ef2a133$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$3726ef9d8ef2a133$var$Q];
            return u(r), o(r), $3726ef9d8ef2a133$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$3726ef9d8ef2a133$var$Q];
            u(n), $3726ef9d8ef2a133$var$p(n).size && (o(n), $3726ef9d8ef2a133$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$3726ef9d8ef2a133$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$3726ef9d8ef2a133$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$3726ef9d8ef2a133$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $3726ef9d8ef2a133$var$m("MapSet", {
        F: function F(n, r) {
            return new f(n, r);
        },
        T: function T(n, r) {
            return new c(n, r);
        }
    });
}
function $3726ef9d8ef2a133$export$cae049b67c7d1bc9() {
    $3726ef9d8ef2a133$export$56771cf63ee491f5(), $3726ef9d8ef2a133$export$7d9f65390203b435(), $3726ef9d8ef2a133$export$d3a6659991a0696c();
}
function $3726ef9d8ef2a133$export$c05b21e3257751e5(n) {
    return n;
}
function $3726ef9d8ef2a133$export$20f911b3f8cf0b74(n) {
    return n;
}
var $3726ef9d8ef2a133$var$G, $3726ef9d8ef2a133$var$U, $3726ef9d8ef2a133$var$W = "undefined" != typeof Symbol && "symbol" == (0, $5F2Q2._)(Symbol("x")), $3726ef9d8ef2a133$var$X = "undefined" != typeof Map, $3726ef9d8ef2a133$var$q = "undefined" != typeof Set, $3726ef9d8ef2a133$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $3726ef9d8ef2a133$export$45b790e32b2810ee = $3726ef9d8ef2a133$var$W ? Symbol.for("immer-nothing") : (($3726ef9d8ef2a133$var$G = {})["immer-nothing"] = !0, $3726ef9d8ef2a133$var$G), $3726ef9d8ef2a133$export$6ee2082928bcb0ee = $3726ef9d8ef2a133$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $3726ef9d8ef2a133$var$Q = $3726ef9d8ef2a133$var$W ? Symbol.for("immer-state") : "__$immer_state", $3726ef9d8ef2a133$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $3726ef9d8ef2a133$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $3726ef9d8ef2a133$var$Z = "" + Object.prototype.constructor, $3726ef9d8ef2a133$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function nn(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $3726ef9d8ef2a133$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $3726ef9d8ef2a133$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $3726ef9d8ef2a133$var$tn = {}, $3726ef9d8ef2a133$var$en = {
    get: function get(n, r) {
        if (r === $3726ef9d8ef2a133$var$Q) return n;
        var e = $3726ef9d8ef2a133$var$p(n);
        if (!$3726ef9d8ef2a133$var$u(e, r)) return function(n, r, t) {
            var e, _$i = $3726ef9d8ef2a133$var$I(r, t);
            return _$i ? "value" in _$i ? _$i.value : null === (e = _$i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var _$i = e[r];
        return n.I || !$3726ef9d8ef2a133$export$16e3aed3edb85946(_$i) ? _$i : _$i === $3726ef9d8ef2a133$var$z(n.t, r) ? ($3726ef9d8ef2a133$var$E(n), n.o[r] = $3726ef9d8ef2a133$var$N(n.A.h, _$i, n)) : _$i;
    },
    has: function has(n, r) {
        return r in $3726ef9d8ef2a133$var$p(n);
    },
    ownKeys: function ownKeys(n) {
        return Reflect.ownKeys($3726ef9d8ef2a133$var$p(n));
    },
    set: function set(n, r, t) {
        var e = $3726ef9d8ef2a133$var$I($3726ef9d8ef2a133$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var _$i = $3726ef9d8ef2a133$var$z($3726ef9d8ef2a133$var$p(n), r), o = null == _$i ? void 0 : _$i[$3726ef9d8ef2a133$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($3726ef9d8ef2a133$var$c(t, _$i) && (void 0 !== t || $3726ef9d8ef2a133$var$u(n.t, r))) return !0;
            $3726ef9d8ef2a133$var$E(n), $3726ef9d8ef2a133$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function deleteProperty(n, r) {
        return void 0 !== $3726ef9d8ef2a133$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $3726ef9d8ef2a133$var$E(n), $3726ef9d8ef2a133$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, r) {
        var t = $3726ef9d8ef2a133$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function defineProperty() {
        $3726ef9d8ef2a133$var$n(11);
    },
    getPrototypeOf: function getPrototypeOf(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function setPrototypeOf() {
        $3726ef9d8ef2a133$var$n(12);
    }
}, $3726ef9d8ef2a133$var$on = {};
$3726ef9d8ef2a133$var$i($3726ef9d8ef2a133$var$en, function(n, r) {
    $3726ef9d8ef2a133$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $3726ef9d8ef2a133$var$on.deleteProperty = function(r, t) {
    return $3726ef9d8ef2a133$var$on.set.call(this, r, t, void 0);
}, $3726ef9d8ef2a133$var$on.set = function(r, t, e) {
    return $3726ef9d8ef2a133$var$en.set.call(this, r[0], t, e, r[0]);
};
var $3726ef9d8ef2a133$export$aaadc6ff0f822719 = function() {
    var e = function e(r) {
        var e = this;
        this.O = $3726ef9d8ef2a133$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var _$r = this;
                    void 0 === n && (n = u);
                    for(var _$t = arguments.length, e = Array(_$t > 1 ? _$t - 1 : 0), _$o = 1; _$o < _$t; _$o++)e[_$o - 1] = arguments[_$o];
                    return a.produce(n, function(n) {
                        var _$t;
                        return (_$t = i).call.apply(_$t, [
                            _$r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $3726ef9d8ef2a133$var$n(6), void 0 !== o && "function" != typeof o && $3726ef9d8ef2a133$var$n(7), $3726ef9d8ef2a133$export$16e3aed3edb85946(r)) {
                var c = $3726ef9d8ef2a133$var$w(e), s = $3726ef9d8ef2a133$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $3726ef9d8ef2a133$var$g(c) : $3726ef9d8ef2a133$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $3726ef9d8ef2a133$var$j(c, o), $3726ef9d8ef2a133$var$P(n, c);
                }, function(n) {
                    throw $3726ef9d8ef2a133$var$g(c), n;
                }) : ($3726ef9d8ef2a133$var$j(c, o), $3726ef9d8ef2a133$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $3726ef9d8ef2a133$export$45b790e32b2810ee && (f = void 0), e.D && $3726ef9d8ef2a133$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $3726ef9d8ef2a133$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $3726ef9d8ef2a133$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, _$i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)_$i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(_$i));
                });
            };
            var t, _$i, o = e.produce(n, r, function(n, r) {
                t = n, _$i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    _$i
                ];
            }) : [
                o,
                t,
                _$i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    };
    var _$i = e.prototype;
    return _$i.createDraft = function(e) {
        $3726ef9d8ef2a133$export$16e3aed3edb85946(e) || $3726ef9d8ef2a133$var$n(8), $3726ef9d8ef2a133$export$541ac630993a4c84(e) && (e = $3726ef9d8ef2a133$export$97aac956da55dae9(e));
        var _$i = $3726ef9d8ef2a133$var$w(this), o = $3726ef9d8ef2a133$var$N(this, e, void 0);
        return o[$3726ef9d8ef2a133$var$Q].C = !0, $3726ef9d8ef2a133$var$O(_$i), o;
    }, _$i.finishDraft = function(r, t) {
        var e = r && r[$3726ef9d8ef2a133$var$Q];
        var _$i = e.A;
        return $3726ef9d8ef2a133$var$j(_$i, t), $3726ef9d8ef2a133$var$P(void 0, _$i);
    }, _$i.setAutoFreeze = function(n) {
        this.D = n;
    }, _$i.setUseProxies = function(r) {
        r && !$3726ef9d8ef2a133$var$B && $3726ef9d8ef2a133$var$n(20), this.O = r;
    }, _$i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var _$i = t[e];
            if (0 === _$i.path.length && "replace" === _$i.op) {
                n = _$i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $3726ef9d8ef2a133$var$b("Patches").$;
        return $3726ef9d8ef2a133$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $3726ef9d8ef2a133$var$an = new $3726ef9d8ef2a133$export$aaadc6ff0f822719, $3726ef9d8ef2a133$export$b46cabe22e78bc00 = $3726ef9d8ef2a133$var$an.produce, $3726ef9d8ef2a133$export$4da66d41c9492c78 = $3726ef9d8ef2a133$var$an.produceWithPatches.bind($3726ef9d8ef2a133$var$an), $3726ef9d8ef2a133$export$573f26f60825c493 = $3726ef9d8ef2a133$var$an.setAutoFreeze.bind($3726ef9d8ef2a133$var$an), $3726ef9d8ef2a133$export$36ccd207ae29b74e = $3726ef9d8ef2a133$var$an.setUseProxies.bind($3726ef9d8ef2a133$var$an), $3726ef9d8ef2a133$export$a8b8e03e6bbe5473 = $3726ef9d8ef2a133$var$an.applyPatches.bind($3726ef9d8ef2a133$var$an), $3726ef9d8ef2a133$export$3c3214997190395f = $3726ef9d8ef2a133$var$an.createDraft.bind($3726ef9d8ef2a133$var$an), $3726ef9d8ef2a133$export$c60f5e69c521b528 = $3726ef9d8ef2a133$var$an.finishDraft.bind($3726ef9d8ef2a133$var$an);
var $3726ef9d8ef2a133$export$2e2bcd8739ae039 = $3726ef9d8ef2a133$export$b46cabe22e78bc00;




var $5F2Q2 = parcelRequire("5F2Q2");
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $62d7bd51de5ff055$var$NOT_FOUND = "NOT_FOUND";
function $62d7bd51de5ff055$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $62d7bd51de5ff055$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $62d7bd51de5ff055$var$createLruCache(maxSize, equals) {
    var get = function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $62d7bd51de5ff055$var$NOT_FOUND;
    };
    var put = function put(key, value) {
        if (get(key) === $62d7bd51de5ff055$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    };
    var getEntries = function getEntries() {
        return entries;
    };
    var clear = function clear() {
        entries = [];
    };
    var entries = [];
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $62d7bd51de5ff055$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $62d7bd51de5ff055$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $62d7bd51de5ff055$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var memoized = function memoized() {
        var value = cache.get(arguments);
        if (value === $62d7bd51de5ff055$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    };
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $62d7bd51de5ff055$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $62d7bd51de5ff055$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $62d7bd51de5ff055$var$createSingletonCache(comparator) : $62d7bd51de5ff055$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $e79ab451a7a5c259$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep === "undefined" ? "undefined" : (0, $5F2Q2._)(dep);
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $e79ab451a7a5c259$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + (typeof resultFunc === "undefined" ? "undefined" : (0, $5F2Q2._)(resultFunc)) + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $e79ab451a7a5c259$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $e79ab451a7a5c259$export$595d22ed68ca2841 = /* #__PURE__ */ $e79ab451a7a5c259$export$5943f4447f6ef248((0, $62d7bd51de5ff055$export$281bff7f05488aa2));
var $e79ab451a7a5c259$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $e79ab451a7a5c259$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + (typeof selectors === "undefined" ? "undefined" : (0, $5F2Q2._)(selectors))));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $5248ebcbcaa47e40$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $5248ebcbcaa47e40$var$thunk = $5248ebcbcaa47e40$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$5248ebcbcaa47e40$var$thunk.withExtraArgument = $5248ebcbcaa47e40$var$createThunkMiddleware;
var $5248ebcbcaa47e40$export$2e2bcd8739ae039 = $5248ebcbcaa47e40$var$thunk;



var $eSBMZ = parcelRequire("eSBMZ");
var $ba25758a6f39d355$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ba25758a6f39d355$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $ba25758a6f39d355$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $ba25758a6f39d355$var$__defProp = Object.defineProperty;
var $ba25758a6f39d355$var$__defProps = Object.defineProperties;
var $ba25758a6f39d355$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ba25758a6f39d355$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ba25758a6f39d355$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ba25758a6f39d355$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ba25758a6f39d355$var$__defNormalProp = function __defNormalProp(obj, key, value) {
    return key in obj ? $ba25758a6f39d355$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $ba25758a6f39d355$var$__spreadValues = function __spreadValues(a, b) {
    for(var prop in b || (b = {}))if ($ba25758a6f39d355$var$__hasOwnProp.call(b, prop)) $ba25758a6f39d355$var$__defNormalProp(a, prop, b[prop]);
    if ($ba25758a6f39d355$var$__getOwnPropSymbols) for(var _i = 0, _c = $ba25758a6f39d355$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($ba25758a6f39d355$var$__propIsEnum.call(b, prop)) $ba25758a6f39d355$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ba25758a6f39d355$var$__spreadProps = function __spreadProps(a, b) {
    return $ba25758a6f39d355$var$__defProps(a, $ba25758a6f39d355$var$__getOwnPropDescs(b));
};
var $ba25758a6f39d355$var$__async = function __async(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $ba25758a6f39d355$export$a5d3c27355e35910 = function createDraftSafeSelector() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $e79ab451a7a5c259$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function wrappedSelector(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $ba25758a6f39d355$var$__spreadArray([
            (0, $3726ef9d8ef2a133$export$541ac630993a4c84)(value) ? (0, $3726ef9d8ef2a133$export$97aac956da55dae9)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $ba25758a6f39d355$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7;
    return (0, $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ba25758a6f39d355$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $ba25758a6f39d355$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $ba25758a6f39d355$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function measureTime(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function warnIfExceeded() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $ba25758a6f39d355$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $ba25758a6f39d355$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function get() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $ba25758a6f39d355$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $ba25758a6f39d355$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $ba25758a6f39d355$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $ba25758a6f39d355$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function get() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $ba25758a6f39d355$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $ba25758a6f39d355$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $ba25758a6f39d355$var$freezeDraftable(val) {
    return (0, $3726ef9d8ef2a133$export$16e3aed3edb85946)(val) ? (0, $3726ef9d8ef2a133$export$2e2bcd8739ae039)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $ba25758a6f39d355$var$isProduction = true;
var $ba25758a6f39d355$var$prefix = "Invariant failed";
function $ba25758a6f39d355$var$invariant(condition, message) {
    if (condition) return;
    if ($ba25758a6f39d355$var$isProduction) throw new Error($ba25758a6f39d355$var$prefix);
    throw new Error($ba25758a6f39d355$var$prefix + ": " + (message || ""));
}
function $ba25758a6f39d355$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $ba25758a6f39d355$var$getSerialize(serializer, decycler), indent);
}
function $ba25758a6f39d355$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function decycler(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $ba25758a6f39d355$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $ba25758a6f39d355$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $ba25758a6f39d355$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function detectMutations1() {
            return $ba25758a6f39d355$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $ba25758a6f39d355$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $ba25758a6f39d355$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $ba25758a6f39d355$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function _loop_1(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $ba25758a6f39d355$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $ba25758a6f39d355$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $ba25758a6f39d355$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $5F2Q2._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $ba25758a6f39d355$export$53b83ca8eaab0383(val);
}
function $ba25758a6f39d355$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $ba25758a6f39d355$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function _loop_2(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $ba25758a6f39d355$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $ba25758a6f39d355$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ba25758a6f39d355$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$ba25758a6f39d355$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $ba25758a6f39d355$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $ba25758a6f39d355$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $ba25758a6f39d355$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $ba25758a6f39d355$export$36c1185aeee5b0a6(options);
    };
}
function $ba25758a6f39d355$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $ba25758a6f39d355$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($ba25758a6f39d355$var$isBoolean(thunk)) middlewareArray.push((0, $5248ebcbcaa47e40$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $5248ebcbcaa47e40$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $ba25758a6f39d355$var$IS_PRODUCTION = true;
function $ba25758a6f39d355$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $ba25758a6f39d355$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($ba25758a6f39d355$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $89b24bf7e3a8e9f2$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$ba25758a6f39d355$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$ba25758a6f39d355$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $89b24bf7e3a8e9f2$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $89b24bf7e3a8e9f2$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ba25758a6f39d355$var$composeWithDevTools($ba25758a6f39d355$var$__spreadValues({
        trace: !$ba25758a6f39d355$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $ba25758a6f39d355$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $ba25758a6f39d355$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $89b24bf7e3a8e9f2$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $ba25758a6f39d355$export$309c7a02b0b0bc62(type, prepareAction) {
    var actionCreator = function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $ba25758a6f39d355$var$__spreadValues($ba25758a6f39d355$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    };
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $ba25758a6f39d355$export$b956e38827fca970(action) {
    return $ba25758a6f39d355$export$53b83ca8eaab0383(action) && "type" in action;
}
function $ba25758a6f39d355$export$ebd532f9034651f3(action) {
    return $ba25758a6f39d355$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($ba25758a6f39d355$var$isValidKey);
}
function $ba25758a6f39d355$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $ba25758a6f39d355$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $ba25758a6f39d355$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function addCase(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function addMatcher(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function addDefaultCase(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ba25758a6f39d355$var$isStateFunction(x) {
    return typeof x === "function";
}
var $ba25758a6f39d355$var$hasWarnedAboutObjectNotation = false;
function $ba25758a6f39d355$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    var reducer = function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $ba25758a6f39d355$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $3726ef9d8ef2a133$export$541ac630993a4c84)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $3726ef9d8ef2a133$export$16e3aed3edb85946)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $3726ef9d8ef2a133$export$2e2bcd8739ae039)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    };
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $ba25758a6f39d355$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($ba25758a6f39d355$var$isStateFunction(initialState)) getInitialState = function getInitialState() {
        return $ba25758a6f39d355$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $ba25758a6f39d355$var$freezeDraftable(initialState);
        getInitialState = function getInitialState() {
            return frozenInitialState_1;
        };
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $ba25758a6f39d355$var$hasWarnedAboutObjectNotation2 = false;
function $ba25758a6f39d355$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $ba25758a6f39d355$export$4d8d9bd83c24ae8b(options) {
    var buildReducer = function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $ba25758a6f39d355$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $ba25758a6f39d355$var$__spreadValues($ba25758a6f39d355$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $ba25758a6f39d355$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    };
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $eSBMZ === "undefined" ? "undefined" : (0, $5F2Q2._)($eSBMZ);
    var initialState = typeof options.initialState == "function" ? options.initialState : $ba25758a6f39d355$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $ba25758a6f39d355$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $ba25758a6f39d355$export$309c7a02b0b0bc62(type, prepareCallback) : $ba25758a6f39d355$export$309c7a02b0b0bc62(type);
    });
    var _reducer;
    return {
        name: name,
        reducer: function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $ba25758a6f39d355$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ba25758a6f39d355$var$createInitialStateFactory() {
    var getInitialState = function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($ba25758a6f39d355$var$getInitialEntityState(), additionalState);
    };
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ba25758a6f39d355$var$createSelectorsFactory() {
    var getSelectors = function getSelectors(selectState) {
        var selectIds = function selectIds(state) {
            return state.ids;
        };
        var selectEntities = function selectEntities(state) {
            return state.entities;
        };
        var selectAll = $ba25758a6f39d355$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function selectId(_, id) {
            return id;
        };
        var selectById = function selectById(entities, id) {
            return entities[id];
        };
        var selectTotal = $ba25758a6f39d355$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $ba25758a6f39d355$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $ba25758a6f39d355$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $ba25758a6f39d355$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $ba25758a6f39d355$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $ba25758a6f39d355$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $ba25758a6f39d355$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    };
    return {
        getSelectors: getSelectors
    };
}
function $ba25758a6f39d355$var$createSingleArgumentStateOperator(mutator) {
    var operator = $ba25758a6f39d355$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ba25758a6f39d355$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        var isPayloadActionArgument = function isPayloadActionArgument(arg2) {
            return $ba25758a6f39d355$export$ebd532f9034651f3(arg2);
        };
        var runMutator = function runMutator(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $3726ef9d8ef2a133$export$541ac630993a4c84)(state)) {
            runMutator(state);
            return state;
        } else return (0, $3726ef9d8ef2a133$export$2e2bcd8739ae039)(state, runMutator);
    };
}
// src/entities/utils.ts
function $ba25758a6f39d355$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $ba25758a6f39d355$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ba25758a6f39d355$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $ba25758a6f39d355$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ba25758a6f39d355$var$createUnsortedStateAdapter(selectId) {
    var addOneMutably = function addOneMutably(entity, state) {
        var key = $ba25758a6f39d355$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    };
    var addManyMutably = function addManyMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    };
    var setOneMutably = function setOneMutably(entity, state) {
        var key = $ba25758a6f39d355$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    };
    var setManyMutably = function setManyMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    };
    var setAllMutably = function setAllMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    };
    var removeOneMutably = function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    };
    var removeManyMutably = function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    };
    var removeAllMutably = function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    };
    var takeNewKey = function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $ba25758a6f39d355$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    };
    var updateOneMutably = function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    };
    var updateManyMutably = function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $ba25758a6f39d355$var$__spreadValues($ba25758a6f39d355$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    };
    var upsertOneMutably = function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    };
    var upsertManyMutably = function upsertManyMutably(newEntities, state) {
        var _c = $ba25758a6f39d355$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    };
    return {
        removeAll: $ba25758a6f39d355$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ba25758a6f39d355$var$createStateOperator(addOneMutably),
        addMany: $ba25758a6f39d355$var$createStateOperator(addManyMutably),
        setOne: $ba25758a6f39d355$var$createStateOperator(setOneMutably),
        setMany: $ba25758a6f39d355$var$createStateOperator(setManyMutably),
        setAll: $ba25758a6f39d355$var$createStateOperator(setAllMutably),
        updateOne: $ba25758a6f39d355$var$createStateOperator(updateOneMutably),
        updateMany: $ba25758a6f39d355$var$createStateOperator(updateManyMutably),
        upsertOne: $ba25758a6f39d355$var$createStateOperator(upsertOneMutably),
        upsertMany: $ba25758a6f39d355$var$createStateOperator(upsertManyMutably),
        removeOne: $ba25758a6f39d355$var$createStateOperator(removeOneMutably),
        removeMany: $ba25758a6f39d355$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ba25758a6f39d355$var$createSortedStateAdapter(selectId, sort) {
    var addOneMutably = function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    };
    var addManyMutably = function addManyMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($ba25758a6f39d355$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    };
    var setOneMutably = function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    };
    var setManyMutably = function setManyMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    };
    var setAllMutably = function setAllMutably(newEntities, state) {
        newEntities = $ba25758a6f39d355$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    };
    var updateOneMutably = function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    };
    var updateManyMutably = function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    };
    var upsertOneMutably = function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    };
    var upsertManyMutably = function upsertManyMutably(newEntities, state) {
        var _c = $ba25758a6f39d355$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    };
    var areArraysEqual = function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    };
    var merge = function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    };
    var resortEntities = function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    };
    var _c = $ba25758a6f39d355$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ba25758a6f39d355$var$createStateOperator(addOneMutably),
        updateOne: $ba25758a6f39d355$var$createStateOperator(updateOneMutably),
        upsertOne: $ba25758a6f39d355$var$createStateOperator(upsertOneMutably),
        setOne: $ba25758a6f39d355$var$createStateOperator(setOneMutably),
        setMany: $ba25758a6f39d355$var$createStateOperator(setManyMutably),
        setAll: $ba25758a6f39d355$var$createStateOperator(setAllMutably),
        addMany: $ba25758a6f39d355$var$createStateOperator(addManyMutably),
        updateMany: $ba25758a6f39d355$var$createStateOperator(updateManyMutably),
        upsertMany: $ba25758a6f39d355$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ba25758a6f39d355$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $ba25758a6f39d355$var$__spreadValues({
        sortComparer: false,
        selectId: function selectId(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $ba25758a6f39d355$var$createInitialStateFactory();
    var selectorsFactory = $ba25758a6f39d355$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $ba25758a6f39d355$var$createSortedStateAdapter(selectId, sortComparer) : $ba25758a6f39d355$var$createUnsortedStateAdapter(selectId);
    return $ba25758a6f39d355$var$__spreadValues($ba25758a6f39d355$var$__spreadValues($ba25758a6f39d355$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $ba25758a6f39d355$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ba25758a6f39d355$export$ac4959f4f1338dfc = function nanoid(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $ba25758a6f39d355$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ba25758a6f39d355$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ba25758a6f39d355$var$RejectWithValue = /** @class */ function() {
    var RejectWithValue = function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    };
    return RejectWithValue;
}();
var $ba25758a6f39d355$var$FulfillWithMeta = /** @class */ function() {
    var FulfillWithMeta = function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    };
    return FulfillWithMeta;
}();
var $ba25758a6f39d355$export$c97c53d0b2d5d81e = function miniSerializeError(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $ba25758a6f39d355$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ba25758a6f39d355$export$6abd22dc03e5063f = function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $ba25758a6f39d355$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $ba25758a6f39d355$var$__spreadProps($ba25758a6f39d355$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $ba25758a6f39d355$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $ba25758a6f39d355$var$__spreadProps($ba25758a6f39d355$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $ba25758a6f39d355$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $ba25758a6f39d355$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ba25758a6f39d355$var$__spreadProps($ba25758a6f39d355$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function addEventListener() {},
                    dispatchEvent: function dispatchEvent() {
                        return false;
                    },
                    onabort: function onabort() {},
                    removeEventListener: function removeEventListener() {},
                    reason: void 0,
                    throwIfAborted: function throwIfAborted() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ba25758a6f39d355$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $ba25758a6f39d355$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $ba25758a6f39d355$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$ba25758a6f39d355$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function rejectWithValue(value, meta) {
                                                    return new $ba25758a6f39d355$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function fulfillWithValue(value, meta) {
                                                    return new $ba25758a6f39d355$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $ba25758a6f39d355$var$RejectWithValue) throw result;
                                                if (result instanceof $ba25758a6f39d355$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $ba25758a6f39d355$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function unwrap() {
                        return promise2.then($ba25758a6f39d355$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $ba25758a6f39d355$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ba25758a6f39d355$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $ba25758a6f39d355$var$hasMatchFunction = function hasMatchFunction(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $ba25758a6f39d355$var$matches = function matches(matcher, action) {
    if ($ba25758a6f39d355$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ba25758a6f39d355$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $ba25758a6f39d355$var$matches(matcher, action);
        });
    };
}
function $ba25758a6f39d355$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $ba25758a6f39d355$var$matches(matcher, action);
        });
    };
}
function $ba25758a6f39d355$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ba25758a6f39d355$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ba25758a6f39d355$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $ba25758a6f39d355$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$ba25758a6f39d355$var$isAsyncThunkArray(asyncThunks)) return $ba25758a6f39d355$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $ba25758a6f39d355$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $ba25758a6f39d355$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $ba25758a6f39d355$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$ba25758a6f39d355$var$isAsyncThunkArray(asyncThunks)) return $ba25758a6f39d355$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $ba25758a6f39d355$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $ba25758a6f39d355$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function hasFlag(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $ba25758a6f39d355$export$9dd1fb32974da385($ba25758a6f39d355$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$ba25758a6f39d355$var$isAsyncThunkArray(asyncThunks)) return $ba25758a6f39d355$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $ba25758a6f39d355$export$9dd1fb32974da385($ba25758a6f39d355$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $ba25758a6f39d355$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $ba25758a6f39d355$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$ba25758a6f39d355$var$isAsyncThunkArray(asyncThunks)) return $ba25758a6f39d355$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $ba25758a6f39d355$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $ba25758a6f39d355$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $ba25758a6f39d355$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$ba25758a6f39d355$var$isAsyncThunkArray(asyncThunks)) return $ba25758a6f39d355$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $ba25758a6f39d355$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $ba25758a6f39d355$var$assertFunction = function assertFunction(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $ba25758a6f39d355$var$noop = function noop() {};
var $ba25758a6f39d355$var$catchRejection = function catchRejection(promise2, onError) {
    if (onError === void 0) onError = $ba25758a6f39d355$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $ba25758a6f39d355$var$addAbortSignalListener = function addAbortSignalListener(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $ba25758a6f39d355$var$abortControllerWithReason = function abortControllerWithReason(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $ba25758a6f39d355$var$task = "task";
var $ba25758a6f39d355$var$listener = "listener";
var $ba25758a6f39d355$var$completed = "completed";
var $ba25758a6f39d355$var$cancelled = "cancelled";
var $ba25758a6f39d355$var$taskCancelled = "task-" + $ba25758a6f39d355$var$cancelled;
var $ba25758a6f39d355$var$taskCompleted = "task-" + $ba25758a6f39d355$var$completed;
var $ba25758a6f39d355$var$listenerCancelled = $ba25758a6f39d355$var$listener + "-" + $ba25758a6f39d355$var$cancelled;
var $ba25758a6f39d355$var$listenerCompleted = $ba25758a6f39d355$var$listener + "-" + $ba25758a6f39d355$var$completed;
var $ba25758a6f39d355$export$cb1bdac908fed7f = /** @class */ function() {
    var TaskAbortError = function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $ba25758a6f39d355$var$task + " " + $ba25758a6f39d355$var$cancelled + " (reason: " + code + ")";
    };
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $ba25758a6f39d355$var$validateActive = function validateActive(signal) {
    if (signal.aborted) throw new $ba25758a6f39d355$export$cb1bdac908fed7f(signal.reason);
};
function $ba25758a6f39d355$var$raceWithSignal(signal, promise2) {
    var cleanup = $ba25758a6f39d355$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function notifyRejection() {
            return reject(new $ba25758a6f39d355$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ba25758a6f39d355$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $ba25758a6f39d355$var$noop;
    });
}
var $ba25758a6f39d355$var$runTask = function runTask(task2, cleanUp) {
    return $ba25758a6f39d355$var$__async(void 0, null, function() {
        var value, error_1;
        return $ba25758a6f39d355$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $ba25758a6f39d355$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $ba25758a6f39d355$var$createPause = function createPause(signal) {
    return function(promise2) {
        return $ba25758a6f39d355$var$catchRejection($ba25758a6f39d355$var$raceWithSignal(signal, promise2).then(function(output) {
            $ba25758a6f39d355$var$validateActive(signal);
            return output;
        }));
    };
};
var $ba25758a6f39d355$var$createDelay = function createDelay(signal) {
    var pause = $ba25758a6f39d355$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $ba25758a6f39d355$var$assign = Object.assign;
var $ba25758a6f39d355$var$INTERNAL_NIL_TOKEN = {};
var $ba25758a6f39d355$var$alm = "listenerMiddleware";
var $ba25758a6f39d355$var$createFork = function createFork(parentAbortSignal) {
    var linkControllers = function linkControllers(controller) {
        return $ba25758a6f39d355$var$addAbortSignalListener(parentAbortSignal, function() {
            return $ba25758a6f39d355$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $ba25758a6f39d355$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $ba25758a6f39d355$var$runTask(function() {
            return $ba25758a6f39d355$var$__async(void 0, null, function() {
                var result2;
                return $ba25758a6f39d355$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $ba25758a6f39d355$var$validateActive(parentAbortSignal);
                            $ba25758a6f39d355$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $ba25758a6f39d355$var$createPause(childAbortController.signal),
                                    delay: $ba25758a6f39d355$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $ba25758a6f39d355$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $ba25758a6f39d355$var$abortControllerWithReason(childAbortController, $ba25758a6f39d355$var$taskCompleted);
        });
        return {
            result: $ba25758a6f39d355$var$createPause(parentAbortSignal)(result),
            cancel: function cancel() {
                $ba25758a6f39d355$var$abortControllerWithReason(childAbortController, $ba25758a6f39d355$var$taskCancelled);
            }
        };
    };
};
var $ba25758a6f39d355$var$createTakePattern = function createTakePattern(startListening, signal) {
    var take = function take(predicate, timeout) {
        return $ba25758a6f39d355$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $ba25758a6f39d355$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $ba25758a6f39d355$var$validateActive(signal);
                        unsubscribe = function unsubscribe() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function effect(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function unsubscribe() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $ba25758a6f39d355$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $ba25758a6f39d355$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $ba25758a6f39d355$var$catchRejection(take(predicate, timeout));
    };
};
var $ba25758a6f39d355$var$getListenerEntryPropsFrom = function getListenerEntryPropsFrom(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $ba25758a6f39d355$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $ba25758a6f39d355$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ba25758a6f39d355$var$createListenerEntry = function createListenerEntry(options) {
    var _c = $ba25758a6f39d355$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $ba25758a6f39d355$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function unsubscribe() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $ba25758a6f39d355$var$cancelActiveListeners = function cancelActiveListeners(entry) {
    entry.pending.forEach(function(controller) {
        $ba25758a6f39d355$var$abortControllerWithReason(controller, $ba25758a6f39d355$var$listenerCancelled);
    });
};
var $ba25758a6f39d355$var$createClearListenerMiddleware = function createClearListenerMiddleware(listenerMap) {
    return function() {
        listenerMap.forEach($ba25758a6f39d355$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $ba25758a6f39d355$var$safelyNotifyError = function safelyNotifyError(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $ba25758a6f39d355$export$f03a6b845d3fb58b = $ba25758a6f39d355$export$309c7a02b0b0bc62($ba25758a6f39d355$var$alm + "/add");
var $ba25758a6f39d355$export$b1b8022855fb2b71 = $ba25758a6f39d355$export$309c7a02b0b0bc62($ba25758a6f39d355$var$alm + "/removeAll");
var $ba25758a6f39d355$export$b03e9483f936dccb = $ba25758a6f39d355$export$309c7a02b0b0bc62($ba25758a6f39d355$var$alm + "/remove");
var $ba25758a6f39d355$var$defaultErrorHandler = function defaultErrorHandler() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $ba25758a6f39d355$var$__spreadArray([
        $ba25758a6f39d355$var$alm + "/error"
    ], args));
};
function $ba25758a6f39d355$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $ba25758a6f39d355$var$defaultErrorHandler : _c;
    $ba25758a6f39d355$var$assertFunction(onError, "onError");
    var insertEntry = function insertEntry(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ba25758a6f39d355$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function findListenerEntry(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function startListening(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $ba25758a6f39d355$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function stopListening(options) {
        var _c = $ba25758a6f39d355$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ba25758a6f39d355$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function notifyListener(entry, action, api, getOriginalState) {
        return $ba25758a6f39d355$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $ba25758a6f39d355$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $ba25758a6f39d355$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $ba25758a6f39d355$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function condition(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $ba25758a6f39d355$var$createDelay(internalTaskController.signal),
                                pause: $ba25758a6f39d355$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $ba25758a6f39d355$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function subscribe() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function cancelActiveListeners() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $ba25758a6f39d355$var$abortControllerWithReason(controller, $ba25758a6f39d355$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $ba25758a6f39d355$export$cb1bdac908fed7f)) $ba25758a6f39d355$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $ba25758a6f39d355$var$abortControllerWithReason(internalTaskController, $ba25758a6f39d355$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $ba25758a6f39d355$var$createClearListenerMiddleware(listenerMap);
    var middleware = function middleware(api) {
        return function(next) {
            return function(action) {
                if (!$ba25758a6f39d355$export$b956e38827fca970(action)) return next(action);
                if ($ba25758a6f39d355$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ba25758a6f39d355$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ba25758a6f39d355$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function getOriginalState() {
                    if (originalState === $ba25758a6f39d355$var$INTERNAL_NIL_TOKEN) throw new Error($ba25758a6f39d355$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $ba25758a6f39d355$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $ba25758a6f39d355$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $ba25758a6f39d355$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ba25758a6f39d355$export$39fcd5145ec5e4e2 = function prepareAutoBatched() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$ba25758a6f39d355$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $ba25758a6f39d355$var$promise;
var $ba25758a6f39d355$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function queueMicrotaskShim(cb) {
    return ($ba25758a6f39d355$var$promise || ($ba25758a6f39d355$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $ba25758a6f39d355$var$createQueueWithTimer = function createQueueWithTimer(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $ba25758a6f39d355$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ba25758a6f39d355$var$createQueueWithTimer(10);
var $ba25758a6f39d355$export$676277d7dca0f396 = function autoBatchEnhancer(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $ba25758a6f39d355$var$queueMicrotaskShim : options.type === "raf" ? $ba25758a6f39d355$var$rAF : options.type === "callback" ? options.queueNotification : $ba25758a6f39d355$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function notifyListeners() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function subscribe(listener2) {
                    var wrappedListener = function wrappedListener() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function dispatch(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ba25758a6f39d355$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $3726ef9d8ef2a133$export$56771cf63ee491f5)();



var $27b146b8ba25b2a4$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === "function" && define.amd) define(definition);
    else if (0, $27b146b8ba25b2a4$exports) $27b146b8ba25b2a4$exports = definition();
    else root.log = definition();
})(undefined, function() {
    "use strict";
    var bindMethod = // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === "function") return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    };
    var traceForIE = // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    };
    var realMethod = // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === "debug") methodName = "log";
        if ((typeof console === "undefined" ? "undefined" : (0, $5F2Q2._)(console)) === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === "trace" && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, "log");
        else return noop;
    };
    var replaceLoggingMethods = // These private functions always need `this` to be set properly
    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */ for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
    };
    var enableLoggingWhenConsoleArrives = // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function() {
            if ((typeof console === "undefined" ? "undefined" : (0, $5F2Q2._)(console)) !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    };
    var defaultMethodFactory = // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    };
    var Logger = function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if ((typeof name === "undefined" ? "undefined" : (0, $5F2Q2._)(name)) === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || "silent").toUpperCase();
            if ((typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if ((typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if ((typeof storedLevel === "undefined" ? "undefined" : (0, $5F2Q2._)(storedLevel)) === undefinedType) try {
                var cookie = window.document.cookie;
                var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if ((typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            return currentLevel;
        };
        self.setLevel = function(level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) persistLevelIfPossible(level);
                replaceLoggingMethods.call(self, level, name);
                if ((typeof console === "undefined" ? "undefined" : (0, $5F2Q2._)(console)) === undefinedType && level < self.levels.SILENT) return "No console available for logging";
            } else throw "log.setLevel() called with invalid level: " + level;
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = level;
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            self.setLevel(defaultLevel, false);
            clearPersistedLevel();
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) initialLevel = defaultLevel;
        self.setLevel(initialLevel, false);
    };
    // Slightly dubious tricks to cut down minimized file size
    var noop = function noop() {};
    var undefinedType = "undefined";
    var isIE = (typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) !== undefinedType && (0, $5F2Q2._)(window.navigator) !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    /*
     *
     * Top-level API
     *
     */ var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if ((typeof name === "undefined" ? "undefined" : (0, $5F2Q2._)(name)) !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = (typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if ((typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
});


var $f487fa6abc092388$export$10308fe6a08904fd = {
    START: "start",
    TESTING: "testing",
    FINISHED: "finished"
};
var $f487fa6abc092388$var$initialDirectorSliceState = {
    testName: null,
    testId: null,
    sessionId: null,
    currentStep: $f487fa6abc092388$export$10308fe6a08904fd.start,
    section: null,
    title: null,
    description: null,
    text: null,
    currentSectionNo: null,
    noOfSections: null,
    currentGroupNo: null,
    noOfGroups: null,
    answeredGroups: [],
    jsonSchema: null,
    readyForNextSection: false,
    textRaed: false,
    resultHtml: false,
    modalContent: null,
    modalActive: false,
    lockIOAction: false,
    submitting: false
};
var $f487fa6abc092388$var$doNextStep = function(state) {
    if (state.sessionId) state.currentStep = $f487fa6abc092388$export$10308fe6a08904fd.TESTING;
};
var $f487fa6abc092388$var$directorSlice = (0, $ba25758a6f39d355$exports.createSlice)({
    name: "directorSlice",
    initialState: $f487fa6abc092388$var$initialDirectorSliceState,
    reducers: {
        nextStep: function(state) {
            return $f487fa6abc092388$var$doNextStep(state);
        },
        setStoreState: function(state, action) {
            //log.info("setStoreState", action, state);
            var _action_payload = action.payload, testId = _action_payload.testId, sessionId = _action_payload.sessionId, section = _action_payload.section;
            state.testId = testId ? testId : state.testId;
            state.sessionId = sessionId ? sessionId : state.sessionId;
            if (section) {
                if (section.current_section_number && state.currentSectionNo !== section.current_section_number) {
                    state.textRaed = true;
                    state.readyForNextSection = false;
                    state.title = null;
                    state.description = null;
                    state.text = null;
                }
                if (section.current_group_number && section.current_group_number === section.number_of_groups) state.readyForNextSection = true;
                state.currentSectionNo = section.current_section_number ? section.current_section_number : state.currentSectionNo;
                state.noOfSections = section.number_of_sections ? section.number_of_sections : state.noOfSections;
                state.currentGroupNo = section.current_group_number ? section.current_group_number : state.currentGroupNo;
                state.noOfGroups = section.number_of_groups ? section.number_of_groups : state.noOfGroups;
                state.answeredGroups = section.answered_groups ? section.answered_groups : state.answeredGroups;
                if (state.answeredGroups.length !== 0 || state.currentSectionNo === 1) state.textRaed = true;
                state.title = section.title ? section.title : state.title;
                state.description = section.description ? section.description : state.description;
                state.text = section.text ? section.text : state.text;
                state.jsonSchema = section.schema ? section.schema : state.jsonSchema;
            }
            $f487fa6abc092388$var$doNextStep(state);
        },
        textRaed: function(state) {
            state.textRaed = true;
        },
        // eslint-disable-next-line no-unused-vars
        cancelTest: function(state) {
            return $f487fa6abc092388$var$initialDirectorSliceState;
        },
        setResults: function(state, action) {
            var resultHtml = action.payload.resultHtml;
            state.currentStep = $f487fa6abc092388$export$10308fe6a08904fd.FINISHED;
            state.resultHtml = resultHtml;
        },
        setSubmitting: function(state, action) {
            var submitting = action.payload.submitting;
            state.submitting = submitting;
        }
    }
});
var $f487fa6abc092388$export$86d1cded24611cb8 = function(state) {
    return state.directorReducer;
};
var $f487fa6abc092388$var$_directorSlice_actions = $f487fa6abc092388$var$directorSlice.actions;
var $f487fa6abc092388$export$e16717ba5a5dc549 = $f487fa6abc092388$var$_directorSlice_actions.setStoreState, $f487fa6abc092388$export$1740d07632cd7131 = $f487fa6abc092388$var$_directorSlice_actions.nextStep, $f487fa6abc092388$export$e7257833db56af08 = $f487fa6abc092388$var$_directorSlice_actions.textRaed, $f487fa6abc092388$export$5fd37d90ba0958ec = $f487fa6abc092388$var$_directorSlice_actions.cancelTest, $f487fa6abc092388$export$2091f1cb24a0a89e = $f487fa6abc092388$var$_directorSlice_actions.setResults, $f487fa6abc092388$export$1c03665141dc142f = $f487fa6abc092388$var$_directorSlice_actions.setSubmitting;
var $f487fa6abc092388$export$2e2bcd8739ae039 = $f487fa6abc092388$var$directorSlice.reducer;






var $817d712521df1056$var$initialModalSliceState = {
    modalContent: null,
    modalActive: false,
    modalHidden: false,
    modalPayload: null
};
var $817d712521df1056$var$modalSlice = (0, $ba25758a6f39d355$exports.createSlice)({
    name: "modalSlice",
    initialState: $817d712521df1056$var$initialModalSliceState,
    reducers: {
        activateModal: function(state, action) {
            var _action_payload = action.payload, content = _action_payload.content, model = _action_payload.model;
            //console.log("activateModal", action.payload, content);
            state.modalActive = true;
            state.modalHidden = false;
            state.modalContent = content;
            if (model) state.modalPayload = {
                model: model
            };
        },
        deactivateModal: function(state) {
            //console.log("deactivateModal");
            state.modalActive = false;
            state.modalPayload = null;
        },
        hideModal: function(state) {
            //console.log("deactivateModal");
            state.modalHidden = true;
        },
        unhideModal: function(state) {
            //console.log("deactivateModal");
            state.modalHidden = false;
        }
    }
});
var $817d712521df1056$export$97564ec4f39e372c = function(state) {
    return state.modalReducer;
};
var $817d712521df1056$var$_modalSlice_actions = $817d712521df1056$var$modalSlice.actions;
var $817d712521df1056$export$923d3332dd605124 = $817d712521df1056$var$_modalSlice_actions.activateModal, $817d712521df1056$export$35f4993c69cad466 = $817d712521df1056$var$_modalSlice_actions.deactivateModal, $817d712521df1056$export$af4939467128bcd0 = $817d712521df1056$var$_modalSlice_actions.hideModal, $817d712521df1056$export$34c750e9d1412945 = $817d712521df1056$var$_modalSlice_actions.unhideModal;
var $817d712521df1056$export$2e2bcd8739ae039 = $817d712521df1056$var$modalSlice.reducer;



var $11c013bdbcf83901$export$6e25e485871219d8 = function(a, v) {
    var i = a.indexOf(v);
    if (i === -1) a.push(v);
    else a.splice(i, 1);
    return a;
};
var $11c013bdbcf83901$export$2cdf1b96a9f86d16 = function(text) {
    navigator.clipboard.writeText(text);
};
var $11c013bdbcf83901$export$d41d9ab3de2def3d = function(string) {
    var hash = 0;
    var i;
    var chr;
    if (string.length === 0) return hash;
    for(i = 0; i < string.length; i++){
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
var $11c013bdbcf83901$export$169439c91a279f79 = function(id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
};



var $a5db8fa337cb10ec$var$initialSnackbarSliceState = {
    items: []
};
var $a5db8fa337cb10ec$export$3cf918ebc7e29d7a = 10500;
var $a5db8fa337cb10ec$export$87130b6dd9721cee = {
    ERROR: "ERROR",
    INFO: "INFO",
    SUCCESS: "SUCCESS"
};
var $a5db8fa337cb10ec$var$snackbarSlice = (0, $ba25758a6f39d355$exports.createSlice)({
    name: "snackbarSlice",
    initialState: $a5db8fa337cb10ec$var$initialSnackbarSliceState,
    reducers: {
        // removeOldItems(state, action) {
        //     console.log("removeSnackbar", state, action.payload);
        //     const now = new Date();
        //     state.items = state.items.filter(aBar => aBar.timeout < now);
        // },
        removeItem: function(state, action) {
            //console.log("removeSnackbar", state, action.payload);
            var id = action.payload.id;
            state.items = state.items.filter(function(aBar) {
                return aBar.id !== id;
            });
        },
        addItem: function(state, action) {
            //console.log("addSnackbar", action.payload);
            var _action_payload = action.payload, text = _action_payload.text, type = _action_payload.type, props = _action_payload.props;
            var hash = (0, $11c013bdbcf83901$export$d41d9ab3de2def3d)(text);
            state.items.push({
                text: text,
                type: type,
                props: props,
                id: hash,
                timeout: new Date(new Date().getTime() + 1000).toISOString()
            });
        }
    }
});
var $a5db8fa337cb10ec$export$5fba9b735dabe025 = function(state) {
    return state.snackbarReducer;
};
var $a5db8fa337cb10ec$var$_snackbarSlice_actions = $a5db8fa337cb10ec$var$snackbarSlice.actions;
var $a5db8fa337cb10ec$export$fb9705de59d96855 = $a5db8fa337cb10ec$var$_snackbarSlice_actions.addItem, //removeOldItems,
$a5db8fa337cb10ec$export$fe2d9b4e03920b4c = $a5db8fa337cb10ec$var$_snackbarSlice_actions.removeItem;
var $a5db8fa337cb10ec$export$2e2bcd8739ae039 = $a5db8fa337cb10ec$var$snackbarSlice.reducer;




var $5ae2f05a62e19741$var$initialIdleTimerSliceState = {
    idleState: "active",
    // prompted, idle,
    timeLeft: 0
};
var $5ae2f05a62e19741$var$idleTimerSlice = (0, $ba25758a6f39d355$exports.createSlice)({
    name: "idleTimerSlice",
    initialState: $5ae2f05a62e19741$var$initialIdleTimerSliceState,
    reducers: {
        changeState: function(state, action) {
            //console.log("idleTimerSlice->changeState", action.payload); 
            var idleState = action.payload.idleState;
            state.idleState = idleState;
            if ([
                "active",
                "idle"
            ].includes(idleState)) //console.log("idleTimerSlice->changeState #2"); 
            state.timeLeft = 0;
        },
        setTimeleft: function(state, action) {
            var timeLeft = action.payload.timeLeft;
            //console.log("idleTimerSlice->changeState", action.payload, timeLeft);
            state.timeLeft = timeLeft;
        }
    }
});
var $5ae2f05a62e19741$export$c3aeaf078d419c4b = function(state) {
    return state.idleTimerReducer;
};
var $5ae2f05a62e19741$var$_idleTimerSlice_actions = $5ae2f05a62e19741$var$idleTimerSlice.actions;
var $5ae2f05a62e19741$export$3374cfc036197cff = $5ae2f05a62e19741$var$_idleTimerSlice_actions.changeState, $5ae2f05a62e19741$export$afe2734416016192 = $5ae2f05a62e19741$var$_idleTimerSlice_actions.setTimeleft;
var $5ae2f05a62e19741$export$2e2bcd8739ae039 = $5ae2f05a62e19741$var$idleTimerSlice.reducer;


var $aed1bdcc8b90bbbe$var$rootReducer = (0, $89b24bf7e3a8e9f2$export$66e4520cdb265d18)({
    directorReducer: (0, $f487fa6abc092388$export$2e2bcd8739ae039),
    modalReducer: (0, $817d712521df1056$export$2e2bcd8739ae039),
    snackbarReducer: (0, $a5db8fa337cb10ec$export$2e2bcd8739ae039),
    idleTimerReducer: (0, $5ae2f05a62e19741$export$2e2bcd8739ae039)
});
var $aed1bdcc8b90bbbe$export$2e2bcd8739ae039 = $aed1bdcc8b90bbbe$var$rootReducer;


var $d1f50662ab26b911$export$1e511d4a378977f5;
var $d1f50662ab26b911$export$2e2bcd8739ae039;
"use strict";
$d1f50662ab26b911$export$1e511d4a378977f5 = true;
$d1f50662ab26b911$export$2e2bcd8739ae039 = void 0;

var $d1f50662ab26b911$var$_createWebStorage = $d1f50662ab26b911$var$_interopRequireDefault((parcelRequire("jMtYM")));
function $d1f50662ab26b911$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d1f50662ab26b911$var$_default = (0, $d1f50662ab26b911$var$_createWebStorage.default)("local");
$d1f50662ab26b911$export$2e2bcd8739ae039 = $d1f50662ab26b911$var$_default;


//const sagaMiddleware = createSagaMiddleware();
var $93dee004cba920da$var$persistConfig = {
    key: "lerche",
    version: 1,
    storage: (0, $d1f50662ab26b911$export$2e2bcd8739ae039)
};
var $93dee004cba920da$var$persistedReducer = (0, $47b4cda08f368afe$export$2e2bcd8739ae039)($93dee004cba920da$var$persistConfig, (0, $aed1bdcc8b90bbbe$export$2e2bcd8739ae039));
var $93dee004cba920da$export$6f57813fe9f31bf9 = (0, $ba25758a6f39d355$exports.configureStore)({
    reducer: $93dee004cba920da$var$persistedReducer,
    middleware: function(getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    (0, $a49107eacf056432$export$2aaee4793dd13a52),
                    (0, $a49107eacf056432$export$1647ef958242c4e2),
                    (0, $a49107eacf056432$export$dd1033c27a16bbd3),
                    (0, $a49107eacf056432$export$913fe0e161ed92a2),
                    (0, $a49107eacf056432$export$5514fc3b4067675f),
                    (0, $a49107eacf056432$export$51e82cdd7353a0e1)
                ]
            }
        });
    }
});
var $93dee004cba920da$export$7b682ac9934ca3e4 = (0, $382d3e111b0c0f6e$export$2e2bcd8739ae039)($93dee004cba920da$export$6f57813fe9f31bf9);
//sagaMiddleware.run(watcherSaga);
$93dee004cba920da$export$6f57813fe9f31bf9.dispatch((0, $f487fa6abc092388$export$1740d07632cd7131)({}));



var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");

var $4CEbD = parcelRequire("4CEbD");


var $4CEbD = parcelRequire("4CEbD");

var $6fb258ca9d5a721a$export$1db569cf9469e5b3 = "/test";
var $6fb258ca9d5a721a$export$7aa67dc43ca8e63d = "/test/start";
var $6fb258ca9d5a721a$export$45f15e91356025b3 = "/test/result";
var $6fb258ca9d5a721a$export$43be4fd0f6d56954 = "/test/result/:type/:sessionId";
var $6fb258ca9d5a721a$export$500824a38b151028 = "/";
var $6fb258ca9d5a721a$export$cd0a6c3b228c8793 = "/404";
var $6fb258ca9d5a721a$export$ce029234ae8b8b29 = "/more/impress";
var $6fb258ca9d5a721a$export$2a280bdbd8b49d15 = "/more/privacypolicy";



var $4CEbD = parcelRequire("4CEbD");


var $4CEbD = parcelRequire("4CEbD");
var $06d6f6186cc10b77$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createContext(null);
var $06d6f6186cc10b77$export$2e2bcd8739ae039 = $06d6f6186cc10b77$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $affa13c823ffdae7$var$defaultNoopBatch(callback) {
    callback();
}
var $affa13c823ffdae7$var$batch = $affa13c823ffdae7$var$defaultNoopBatch; // Allow injecting another batching function later
var $affa13c823ffdae7$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $affa13c823ffdae7$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $affa13c823ffdae7$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $affa13c823ffdae7$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $2a46285cd63f83c2$var$createListenerCollection() {
    var batch = (0, $affa13c823ffdae7$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $2a46285cd63f83c2$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $2a46285cd63f83c2$export$d567d2b9af322f8f(store, parentSub) {
    var addNestedSub = function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    };
    var notifyNestedSubs = function notifyNestedSubs() {
        listeners.notify();
    };
    var handleChangeWrapper = function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    };
    var isSubscribed = function isSubscribed() {
        return Boolean(unsubscribe);
    };
    var trySubscribe = function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $2a46285cd63f83c2$var$createListenerCollection();
        }
    };
    var tryUnsubscribe = function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $2a46285cd63f83c2$var$nullListeners;
        }
    };
    var unsubscribe;
    var listeners = $2a46285cd63f83c2$var$nullListeners;
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $4CEbD = parcelRequire("4CEbD");
var $2fc3470d321be4f1$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $4CEbD.useLayoutEffect) : (0, $4CEbD.useEffect);


function $307ac207d321399d$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $4CEbD.useMemo)(function() {
        var subscription = (0, $2a46285cd63f83c2$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $4CEbD.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $2fc3470d321be4f1$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $307ac207d321399d$export$2e2bcd8739ae039 = $307ac207d321399d$var$Provider;


function $473874a05528463f$export$2e2bcd8739ae039() {
    $473874a05528463f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $473874a05528463f$export$2e2bcd8739ae039.apply(this, arguments);
}


function $62e4ff1670bafd70$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $3ee7746c78fa44e2$exports = {};
"use strict";
var $41b6a74beca8d65d$exports = {};
"use strict";

$41b6a74beca8d65d$exports = (parcelRequire("iHreN"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3ee7746c78fa44e2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3ee7746c78fa44e2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3ee7746c78fa44e2$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3ee7746c78fa44e2$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3ee7746c78fa44e2$var$TYPE_STATICS = {};
$3ee7746c78fa44e2$var$TYPE_STATICS[$41b6a74beca8d65d$exports.ForwardRef] = $3ee7746c78fa44e2$var$FORWARD_REF_STATICS;
$3ee7746c78fa44e2$var$TYPE_STATICS[$41b6a74beca8d65d$exports.Memo] = $3ee7746c78fa44e2$var$MEMO_STATICS;
function $3ee7746c78fa44e2$var$getStatics(component) {
    // React v16.11 and below
    if ($41b6a74beca8d65d$exports.isMemo(component)) return $3ee7746c78fa44e2$var$MEMO_STATICS;
     // React v16.12 and above
    return $3ee7746c78fa44e2$var$TYPE_STATICS[component["$$typeof"]] || $3ee7746c78fa44e2$var$REACT_STATICS;
}
var $3ee7746c78fa44e2$var$defineProperty = Object.defineProperty;
var $3ee7746c78fa44e2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3ee7746c78fa44e2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3ee7746c78fa44e2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3ee7746c78fa44e2$var$getPrototypeOf = Object.getPrototypeOf;
var $3ee7746c78fa44e2$var$objectPrototype = Object.prototype;
function $3ee7746c78fa44e2$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3ee7746c78fa44e2$var$objectPrototype) {
            var inheritedComponent = $3ee7746c78fa44e2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3ee7746c78fa44e2$var$objectPrototype) $3ee7746c78fa44e2$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3ee7746c78fa44e2$var$getOwnPropertyNames(sourceComponent);
        if ($3ee7746c78fa44e2$var$getOwnPropertySymbols) keys = keys.concat($3ee7746c78fa44e2$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3ee7746c78fa44e2$var$getStatics(targetComponent);
        var sourceStatics = $3ee7746c78fa44e2$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3ee7746c78fa44e2$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3ee7746c78fa44e2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3ee7746c78fa44e2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3ee7746c78fa44e2$exports = $3ee7746c78fa44e2$var$hoistNonReactStatics;



var $4CEbD = parcelRequire("4CEbD");
var $878c3d35041b7e1c$exports = {};
"use strict";

$878c3d35041b7e1c$exports = (parcelRequire("jIewG"));





var $00be0914f8a9897d$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $00be0914f8a9897d$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $00be0914f8a9897d$var$EMPTY_ARRAY = [];
var $00be0914f8a9897d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $00be0914f8a9897d$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $00be0914f8a9897d$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $00be0914f8a9897d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $2fc3470d321be4f1$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $00be0914f8a9897d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $00be0914f8a9897d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $00be0914f8a9897d$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $00be0914f8a9897d$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function getDisplayName(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref2, $00be0914f8a9897d$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var createChildSelector = function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        ;
        var ConnectFunction = function ConnectFunction(props) {
            var _useMemo = (0, $4CEbD.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(props, $00be0914f8a9897d$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $4CEbD.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $878c3d35041b7e1c$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $4CEbD.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $4CEbD.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $4CEbD.useMemo)(function() {
                if (!shouldHandleStateChanges) return $00be0914f8a9897d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $2a46285cd63f83c2$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $4CEbD.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $473874a05528463f$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $4CEbD.useReducer)($00be0914f8a9897d$var$storeStateUpdatesReducer, $00be0914f8a9897d$var$EMPTY_ARRAY, $00be0914f8a9897d$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $4CEbD.useRef)();
            var lastWrapperProps = (0, $4CEbD.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $4CEbD.useRef)();
            var renderIsScheduled = (0, $4CEbD.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $00be0914f8a9897d$var$useIsomorphicLayoutEffectWithArgs($00be0914f8a9897d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $00be0914f8a9897d$var$useIsomorphicLayoutEffectWithArgs($00be0914f8a9897d$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $4CEbD.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(WrappedComponent, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $4CEbD.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        ;
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $4CEbD.useMemo) : function usePureOnlyMemo(callback) {
            return callback();
        };
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Connect, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3ee7746c78fa44e2$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3ee7746c78fa44e2$exports)))(Connect, WrappedComponent);
    };
}




var $5F2Q2 = parcelRequire("5F2Q2");



function $3a9a7a06deb7afc5$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3a9a7a06deb7afc5$export$2e2bcd8739ae039(objA, objB) {
    if ($3a9a7a06deb7afc5$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$3a9a7a06deb7afc5$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $108ea3fe06708b0b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $6edb6e2d512325d2$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $4230347dd559d7db$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $385ac361df6bdc03$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $6edb6e2d512325d2$export$2e2bcd8739ae039)(value)) (0, $4230347dd559d7db$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $2130fe9116c56b49$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constantSelector = function constantSelector() {
            return constant;
        };
        var constant = getConstant(dispatch, options);
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2130fe9116c56b49$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2130fe9116c56b49$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2130fe9116c56b49$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2130fe9116c56b49$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $15d218e5cccb8991$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $2130fe9116c56b49$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $15d218e5cccb8991$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $2130fe9116c56b49$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $15d218e5cccb8991$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $2130fe9116c56b49$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $108ea3fe06708b0b$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $15d218e5cccb8991$export$2e2bcd8739ae039 = [
    $15d218e5cccb8991$export$a9f27b4b187c1166,
    $15d218e5cccb8991$export$ba20d1a7aa0c4a90,
    $15d218e5cccb8991$export$94a6e55709d4d961
];



function $b6d9da50c0ae27ae$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $2130fe9116c56b49$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $b6d9da50c0ae27ae$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $2130fe9116c56b49$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $b6d9da50c0ae27ae$export$2e2bcd8739ae039 = [
    $b6d9da50c0ae27ae$export$23fc470827b14aa,
    $b6d9da50c0ae27ae$export$514bc8c1a53c1d66
];




function $579d092db476db29$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $473874a05528463f$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $579d092db476db29$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $579d092db476db29$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $579d092db476db29$export$5b105939c84b5234(mergeProps) : undefined;
}
function $579d092db476db29$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $579d092db476db29$export$691c327fc30bc857;
    } : undefined;
}
var $579d092db476db29$export$2e2bcd8739ae039 = [
    $579d092db476db29$export$d61b680184bc3f00,
    $579d092db476db29$export$a13ba70ef50dda6d
];




function $2bf72bcf60e2152c$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $4230347dd559d7db$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $2bf72bcf60e2152c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $2bf72bcf60e2152c$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $2bf72bcf60e2152c$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $2bf72bcf60e2152c$var$verify(mergeProps, "mergeProps", displayName);
}


var $533ca27ab99c9c8b$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $533ca27ab99c9c8b$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $533ca27ab99c9c8b$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var handleFirstCall = function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    };
    var handleNewPropsAndNewState = function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleNewProps = function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleNewState = function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleSubsequentCalls = function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    };
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $533ca27ab99c9c8b$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref2, $533ca27ab99c9c8b$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $533ca27ab99c9c8b$export$d20c0c2ca6eb2b6f : $533ca27ab99c9c8b$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $1163c804f5ba80f5$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $1163c804f5ba80f5$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + (typeof arg === "undefined" ? "undefined" : (0, $5F2Q2._)(arg)) + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $1163c804f5ba80f5$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $1163c804f5ba80f5$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $00be0914f8a9897d$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $b6d9da50c0ae27ae$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $15d218e5cccb8991$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $579d092db476db29$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $533ca27ab99c9c8b$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $1163c804f5ba80f5$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $3a9a7a06deb7afc5$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $3a9a7a06deb7afc5$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $3a9a7a06deb7afc5$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref3, $1163c804f5ba80f5$var$_excluded);
        var initMapStateToProps = $1163c804f5ba80f5$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $1163c804f5ba80f5$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $1163c804f5ba80f5$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $473874a05528463f$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $1163c804f5ba80f5$export$2e2bcd8739ae039 = /*#__PURE__*/ $1163c804f5ba80f5$export$9f9feb656dec1fc4();




var $4CEbD = parcelRequire("4CEbD");


var $4CEbD = parcelRequire("4CEbD");

function $8087994aa33be0f3$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $4CEbD.useContext)((0, $06d6f6186cc10b77$export$cc80c08dc91f1c00));
    return contextValue;
}


function $5ec11351c57b4fe1$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00) ? (0, $8087994aa33be0f3$export$c1275ca9a6fd3ec5) : function useReduxContext() {
        return (0, $4CEbD.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $5ec11351c57b4fe1$export$6ccbb43953eebf8 = /*#__PURE__*/ $5ec11351c57b4fe1$export$671dba69185d0304();


function $b8a3fb33ebd2d3a2$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00);
    var useStore = context === (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00) ? (0, $5ec11351c57b4fe1$export$6ccbb43953eebf8) : (0, $5ec11351c57b4fe1$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8 = /*#__PURE__*/ $b8a3fb33ebd2d3a2$export$bc9b55530897c558();



var $4CEbD = parcelRequire("4CEbD");




var $2e074b94551c5d7f$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $2e074b94551c5d7f$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $4CEbD.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $4CEbD.useMemo)(function() {
        return (0, $2a46285cd63f83c2$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $4CEbD.useRef)();
    var latestSelector = (0, $4CEbD.useRef)();
    var latestStoreState = (0, $4CEbD.useRef)();
    var latestSelectedState = (0, $4CEbD.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $2fc3470d321be4f1$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $2fc3470d321be4f1$export$700979bc83e7db82)(function() {
        var checkForUpdates = function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        };
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $2e074b94551c5d7f$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $06d6f6186cc10b77$export$cc80c08dc91f1c00) ? (0, $8087994aa33be0f3$export$c1275ca9a6fd3ec5) : function useReduxContext() {
        return (0, $4CEbD.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $2e074b94551c5d7f$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $2e074b94551c5d7f$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $4CEbD.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $2e074b94551c5d7f$export$2105062e25df4afe = /*#__PURE__*/ $2e074b94551c5d7f$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ var $97c8887f441e3eff$exports = {};
"use strict";
function $97c8887f441e3eff$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97c8887f441e3eff$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97c8887f441e3eff$var$checkDCE();

$97c8887f441e3eff$exports = (parcelRequire("dTzuM"));





// with standard React renderers (ReactDOM, React Native)
(0, $affa13c823ffdae7$export$4b9874722d0da7bc)((0, $97c8887f441e3eff$exports.unstable_batchedUpdates));


function $94df4a08671d142b$export$2e2bcd8739ae039(o, p) {
    $94df4a08671d142b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $94df4a08671d142b$export$2e2bcd8739ae039(o, p);
}


function $267d38b9ce0b0b33$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $94df4a08671d142b$export$2e2bcd8739ae039)(subClass, superClass);
}



var $4CEbD = parcelRequire("4CEbD");


function $384dd2cba1e21372$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $384dd2cba1e21372$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $384dd2cba1e21372$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $384dd2cba1e21372$var$isAbsolute(to);
    var isFromAbs = from && $384dd2cba1e21372$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $384dd2cba1e21372$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $384dd2cba1e21372$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $384dd2cba1e21372$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $384dd2cba1e21372$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$384dd2cba1e21372$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $384dd2cba1e21372$export$2e2bcd8739ae039 = $384dd2cba1e21372$var$resolvePathname;


function $85f961db1862ffe8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $85f961db1862ffe8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $85f961db1862ffe8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $85f961db1862ffe8$var$valueOf(a);
        var bValue = $85f961db1862ffe8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $85f961db1862ffe8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $85f961db1862ffe8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $85f961db1862ffe8$export$2e2bcd8739ae039 = $85f961db1862ffe8$var$valueEqual;



var $ee3152882cce2e9b$var$isProduction = true;
var $ee3152882cce2e9b$var$prefix = "Invariant failed";
function $ee3152882cce2e9b$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($ee3152882cce2e9b$var$isProduction) throw new Error($ee3152882cce2e9b$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($ee3152882cce2e9b$var$prefix, ": ").concat(provided) : $ee3152882cce2e9b$var$prefix;
    throw new Error(value);
}


function $1b42263abc5a71de$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $1b42263abc5a71de$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $1b42263abc5a71de$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $1b42263abc5a71de$var$stripBasename(path, prefix) {
    return $1b42263abc5a71de$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $1b42263abc5a71de$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $1b42263abc5a71de$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $1b42263abc5a71de$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $1b42263abc5a71de$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $1b42263abc5a71de$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $384dd2cba1e21372$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $1b42263abc5a71de$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $85f961db1862ffe8$export$2e2bcd8739ae039)(a.state, b.state);
}
function $1b42263abc5a71de$var$createTransitionManager() {
    var setPrompt = function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    };
    var appendListener = function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var notifyListeners = function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    };
    var prompt = null;
    var listeners = [];
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $1b42263abc5a71de$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $1b42263abc5a71de$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $1b42263abc5a71de$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $1b42263abc5a71de$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $1b42263abc5a71de$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $1b42263abc5a71de$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $1b42263abc5a71de$var$PopStateEvent = "popstate";
var $1b42263abc5a71de$var$HashChangeEvent = "hashchange";
function $1b42263abc5a71de$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $1b42263abc5a71de$export$719fc203c4e16dee(props) {
    var getDOMLocation = function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $1b42263abc5a71de$var$stripBasename(path, basename);
        return $1b42263abc5a71de$export$90c043f1c57770b8(path, state, key);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var setState = function setState(nextState) {
        (0, $473874a05528463f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var handlePopState = function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($1b42263abc5a71de$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    };
    var handleHashChange = function handleHashChange() {
        handlePop(getDOMLocation($1b42263abc5a71de$var$getHistoryState()));
    };
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    };
    var createHref = function createHref(location) {
        return basename + $1b42263abc5a71de$export$fe53371bee54353d(location);
    };
    var push = function push(path, state) {
        var action = "PUSH";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    };
    var replace = function replace(path, state) {
        var action = "REPLACE";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        go(-1);
    };
    var goForward = function goForward() {
        go(1);
    };
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($1b42263abc5a71de$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($1b42263abc5a71de$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($1b42263abc5a71de$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($1b42263abc5a71de$var$HashChangeEvent, handleHashChange);
        }
    };
    var block = function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    if (props === void 0) props = {};
    !$1b42263abc5a71de$var$canUseDOM && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $1b42263abc5a71de$var$supportsHistory();
    var needsHashChangeListener = !$1b42263abc5a71de$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $1b42263abc5a71de$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $1b42263abc5a71de$var$stripTrailingSlash($1b42263abc5a71de$var$addLeadingSlash(props.basename)) : "";
    var transitionManager = $1b42263abc5a71de$var$createTransitionManager();
    var forceNextPop = false;
    var initialLocation = getDOMLocation($1b42263abc5a71de$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    var listenerCount = 0;
    var isBlocked = false;
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $1b42263abc5a71de$var$HashChangeEvent$1 = "hashchange";
var $1b42263abc5a71de$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $1b42263abc5a71de$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $1b42263abc5a71de$var$stripLeadingSlash,
        decodePath: $1b42263abc5a71de$var$addLeadingSlash
    },
    slash: {
        encodePath: $1b42263abc5a71de$var$addLeadingSlash,
        decodePath: $1b42263abc5a71de$var$addLeadingSlash
    }
};
function $1b42263abc5a71de$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $1b42263abc5a71de$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $1b42263abc5a71de$var$pushHashPath(path) {
    window.location.hash = path;
}
function $1b42263abc5a71de$var$replaceHashPath(path) {
    window.location.replace($1b42263abc5a71de$var$stripHash(window.location.href) + "#" + path);
}
function $1b42263abc5a71de$export$b71fdd3798280242(props) {
    var getDOMLocation = function getDOMLocation() {
        var path = decodePath($1b42263abc5a71de$var$getHashPath());
        if (basename) path = $1b42263abc5a71de$var$stripBasename(path, basename);
        return $1b42263abc5a71de$export$90c043f1c57770b8(path);
    };
    var setState = function setState(nextState) {
        (0, $473874a05528463f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var locationsAreEqual$$1 = function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    };
    var handleHashChange = function handleHashChange() {
        var path = $1b42263abc5a71de$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $1b42263abc5a71de$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $1b42263abc5a71de$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    };
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($1b42263abc5a71de$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($1b42263abc5a71de$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    ;
    var createHref = function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $1b42263abc5a71de$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $1b42263abc5a71de$export$fe53371bee54353d(location));
    };
    var push = function push(path, state) {
        var action = "PUSH";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $1b42263abc5a71de$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $1b42263abc5a71de$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $1b42263abc5a71de$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($1b42263abc5a71de$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    };
    var replace = function replace(path, state) {
        var action = "REPLACE";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $1b42263abc5a71de$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $1b42263abc5a71de$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $1b42263abc5a71de$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($1b42263abc5a71de$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        go(-1);
    };
    var goForward = function goForward() {
        go(1);
    };
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($1b42263abc5a71de$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($1b42263abc5a71de$var$HashChangeEvent$1, handleHashChange);
    };
    var block = function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    if (props === void 0) props = {};
    !$1b42263abc5a71de$var$canUseDOM && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $1b42263abc5a71de$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $1b42263abc5a71de$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $1b42263abc5a71de$var$stripTrailingSlash($1b42263abc5a71de$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $1b42263abc5a71de$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    var transitionManager = $1b42263abc5a71de$var$createTransitionManager();
    var forceNextPop = false;
    var ignorePath = null;
    var path = $1b42263abc5a71de$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $1b42263abc5a71de$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $1b42263abc5a71de$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    var listenerCount = 0;
    var isBlocked = false;
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $1b42263abc5a71de$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $1b42263abc5a71de$export$2b76ad033c6e6d08(props) {
    var setState = function setState(nextState) {
        (0, $473874a05528463f$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var push = function push(path, state) {
        var action = "PUSH";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    };
    var replace = function replace(path, state) {
        var action = "REPLACE";
        var location = $1b42263abc5a71de$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    };
    var go = function go(n) {
        var nextIndex = $1b42263abc5a71de$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    };
    var goBack = function goBack() {
        go(-1);
    };
    var goForward = function goForward() {
        go(1);
    };
    var canGo = function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    };
    var block = function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    };
    var listen = function listen(listener) {
        return transitionManager.appendListener(listener);
    };
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $1b42263abc5a71de$var$createTransitionManager();
    var index = $1b42263abc5a71de$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $1b42263abc5a71de$export$90c043f1c57770b8(entry, undefined, createKey()) : $1b42263abc5a71de$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $1b42263abc5a71de$export$fe53371bee54353d;
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $db61612178ef6309$exports = {};
var $1d542924cb4b51d0$exports = {};
$1d542924cb4b51d0$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $db61612178ef6309$exports = $db61612178ef6309$var$pathToRegexp;
$db61612178ef6309$exports.parse = $db61612178ef6309$var$parse;
$db61612178ef6309$exports.compile = $db61612178ef6309$var$compile;
$db61612178ef6309$exports.tokensToFunction = $db61612178ef6309$var$tokensToFunction;
$db61612178ef6309$exports.tokensToRegExp = $db61612178ef6309$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $db61612178ef6309$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $db61612178ef6309$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $db61612178ef6309$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $db61612178ef6309$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $db61612178ef6309$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $db61612178ef6309$var$compile(str, options) {
    return $db61612178ef6309$var$tokensToFunction($db61612178ef6309$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $db61612178ef6309$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $db61612178ef6309$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $db61612178ef6309$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $db61612178ef6309$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? $db61612178ef6309$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($1d542924cb4b51d0$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $db61612178ef6309$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $db61612178ef6309$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $db61612178ef6309$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $db61612178ef6309$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $db61612178ef6309$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $db61612178ef6309$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $db61612178ef6309$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $db61612178ef6309$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($db61612178ef6309$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $db61612178ef6309$var$flags(options));
    return $db61612178ef6309$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $db61612178ef6309$var$stringToRegexp(path, keys, options) {
    return $db61612178ef6309$var$tokensToRegExp($db61612178ef6309$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $db61612178ef6309$var$tokensToRegExp(tokens, keys, options) {
    if (!$1d542924cb4b51d0$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $db61612178ef6309$var$escapeString(token);
        else {
            var prefix = $db61612178ef6309$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $db61612178ef6309$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $db61612178ef6309$var$attachKeys(new RegExp("^" + route, $db61612178ef6309$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $db61612178ef6309$var$pathToRegexp(path, keys, options) {
    if (!$1d542924cb4b51d0$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $db61612178ef6309$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($1d542924cb4b51d0$exports(path)) return $db61612178ef6309$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $db61612178ef6309$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $77555840adebf70f$exports = {};
"use strict";

$77555840adebf70f$exports = (parcelRequire("kH3hC"));




var $876a3032fada8974$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $876a3032fada8974$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $876a3032fada8974$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $876a3032fada8974$var$commonjsGlobal[key] = ($876a3032fada8974$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $876a3032fada8974$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $876a3032fada8974$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $876a3032fada8974$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $876a3032fada8974$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $876a3032fada8974$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        var Provider = function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $876a3032fada8974$var$createEventEmitter(_this.props.value);
            return _this;
        };
        (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Provider, _React$Component);
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($876a3032fada8974$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $876a3032fada8974$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        var Consumer = function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        };
        (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $876a3032fada8974$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $876a3032fada8974$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $876a3032fada8974$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $876a3032fada8974$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createContext || $876a3032fada8974$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $876a3032fada8974$var$createNamedContext = function createNamedContext(name) {
    var context = $876a3032fada8974$var$createContext();
    context.displayName = name;
    return context;
};
var $876a3032fada8974$export$c213558b66925821 = /*#__PURE__*/ $876a3032fada8974$var$createNamedContext("Router-History");
var $876a3032fada8974$export$63baa8ccbe60bb07 = /*#__PURE__*/ $876a3032fada8974$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $876a3032fada8974$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    var Router = function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $876a3032fada8974$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    var MemoryRouter = function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $1b42263abc5a71de$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
var $876a3032fada8974$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    var Lifecycle = function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $876a3032fada8974$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $876a3032fada8974$var$messageType;
var $876a3032fada8974$var$cache = {};
var $876a3032fada8974$var$cacheLimit = 10000;
var $876a3032fada8974$var$cacheCount = 0;
function $876a3032fada8974$var$compilePath(path) {
    if ($876a3032fada8974$var$cache[path]) return $876a3032fada8974$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($db61612178ef6309$exports))).compile(path);
    if ($876a3032fada8974$var$cacheCount < $876a3032fada8974$var$cacheLimit) {
        $876a3032fada8974$var$cache[path] = generator;
        $876a3032fada8974$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $876a3032fada8974$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $876a3032fada8974$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $876a3032fada8974$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $1b42263abc5a71de$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $876a3032fada8974$export$82476f982757e71e(to, computedMatch.params) : (0, $473874a05528463f$export$2e2bcd8739ae039)({}, to, {
            pathname: $876a3032fada8974$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $1b42263abc5a71de$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $1b42263abc5a71de$export$c3e8bb440bd55b18)(prevLocation, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $876a3032fada8974$var$cache$1 = {};
var $876a3032fada8974$var$cacheLimit$1 = 10000;
var $876a3032fada8974$var$cacheCount$1 = 0;
function $876a3032fada8974$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $876a3032fada8974$var$cache$1[cacheKey] || ($876a3032fada8974$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($db61612178ef6309$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($876a3032fada8974$var$cacheCount$1 < $876a3032fada8974$var$cacheLimit$1) {
        pathCache[path] = result;
        $876a3032fada8974$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $876a3032fada8974$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $876a3032fada8974$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $876a3032fada8974$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Children.count(children) === 0;
}
function $876a3032fada8974$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $876a3032fada8974$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    var Route = function Route() {
        return _React$Component.apply(this, arguments) || this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Route, _React$Component);
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $876a3032fada8974$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $876a3032fada8974$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
function $876a3032fada8974$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $876a3032fada8974$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $473874a05528463f$export$2e2bcd8739ae039)({}, location, {
        pathname: $876a3032fada8974$var$addLeadingSlash(basename) + location.pathname
    });
}
function $876a3032fada8974$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $876a3032fada8974$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $473874a05528463f$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $876a3032fada8974$var$createURL(location) {
    return typeof location === "string" ? location : (0, $1b42263abc5a71de$export$fe53371bee54353d)(location);
}
function $876a3032fada8974$var$staticHandler(methodName) {
    return function() {
        (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
    };
}
function $876a3032fada8974$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $876a3032fada8974$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    var StaticRouter = function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $876a3032fada8974$var$noop;
        };
        _this.handleBlock = function() {
            return $876a3032fada8974$var$noop;
        };
        return _this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $876a3032fada8974$var$addBasename(basename, (0, $1b42263abc5a71de$export$90c043f1c57770b8)(location));
        context.url = $876a3032fada8974$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $876a3032fada8974$var$addLeadingSlash(basename + $876a3032fada8974$var$createURL(path));
            },
            action: "POP",
            location: $876a3032fada8974$var$stripBasename(basename, (0, $1b42263abc5a71de$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $876a3032fada8974$var$staticHandler("go"),
            goBack: $876a3032fada8974$var$staticHandler("goBack"),
            goForward: $876a3032fada8974$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$55185c17a0fcbe46, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $876a3032fada8974$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    var Switch = function Switch() {
        return _React$Component.apply(this, arguments) || this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(Switch, _React$Component);
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $876a3032fada8974$export$81336c211d5ff295(location.pathname, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $876a3032fada8974$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($876a3032fada8974$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Component, (0, $473874a05528463f$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ee7746c78fa44e2$exports)))(C, Component);
}
var $876a3032fada8974$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useContext;
function $876a3032fada8974$export$3420e1dc2c4a518c() {
    return $876a3032fada8974$var$useContext($876a3032fada8974$export$c213558b66925821);
}
function $876a3032fada8974$export$45d76561a5302f2b() {
    return $876a3032fada8974$var$useContext($876a3032fada8974$export$63baa8ccbe60bb07).location;
}
function $876a3032fada8974$export$99eaa27ddbbb95ef() {
    var match = $876a3032fada8974$var$useContext($876a3032fada8974$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $876a3032fada8974$export$632be4bb944c1bc7(path) {
    var location = $876a3032fada8974$export$45d76561a5302f2b();
    var match = $876a3032fada8974$var$useContext($876a3032fada8974$export$63baa8ccbe60bb07).match;
    return path ? $876a3032fada8974$export$81336c211d5ff295(location.pathname, path) : match;
}
var $876a3032fada8974$var$global$1, $876a3032fada8974$var$key, $876a3032fada8974$var$buildNames, $876a3032fada8974$var$initialBuildName, $876a3032fada8974$var$secondaryBuildName;


var $f5bc2b5e9093dc55$exports = {};
var $75d1c5b093a17c0b$exports = {};
function $75d1c5b093a17c0b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$75d1c5b093a17c0b$exports = $75d1c5b093a17c0b$var$_arrayWithHoles, $75d1c5b093a17c0b$exports.__esModule = true, $75d1c5b093a17c0b$exports["default"] = $75d1c5b093a17c0b$exports;


var $3ae725746688057a$exports = {};
function $3ae725746688057a$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$3ae725746688057a$exports = $3ae725746688057a$var$_iterableToArrayLimit, $3ae725746688057a$exports.__esModule = true, $3ae725746688057a$exports["default"] = $3ae725746688057a$exports;


var $d44e30ce00578ca1$exports = {};
var $f20eff34dfd88214$exports = {};
function $f20eff34dfd88214$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$f20eff34dfd88214$exports = $f20eff34dfd88214$var$_arrayLikeToArray, $f20eff34dfd88214$exports.__esModule = true, $f20eff34dfd88214$exports["default"] = $f20eff34dfd88214$exports;


function $d44e30ce00578ca1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f20eff34dfd88214$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f20eff34dfd88214$exports(o, minLen);
}
$d44e30ce00578ca1$exports = $d44e30ce00578ca1$var$_unsupportedIterableToArray, $d44e30ce00578ca1$exports.__esModule = true, $d44e30ce00578ca1$exports["default"] = $d44e30ce00578ca1$exports;


var $2fa2c79e4a35a2ca$exports = {};
function $2fa2c79e4a35a2ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$2fa2c79e4a35a2ca$exports = $2fa2c79e4a35a2ca$var$_nonIterableRest, $2fa2c79e4a35a2ca$exports.__esModule = true, $2fa2c79e4a35a2ca$exports["default"] = $2fa2c79e4a35a2ca$exports;


function $f5bc2b5e9093dc55$var$_slicedToArray(arr, i) {
    return $75d1c5b093a17c0b$exports(arr) || $3ae725746688057a$exports(arr, i) || $d44e30ce00578ca1$exports(arr, i) || $2fa2c79e4a35a2ca$exports();
}
$f5bc2b5e9093dc55$exports = $f5bc2b5e9093dc55$var$_slicedToArray, $f5bc2b5e9093dc55$exports.__esModule = true, $f5bc2b5e9093dc55$exports["default"] = $f5bc2b5e9093dc55$exports;




var $4CEbD = parcelRequire("4CEbD");

function $b127824328a411b2$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $b127824328a411b2$var$alreadyWarned = {};
function $b127824328a411b2$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $b127824328a411b2$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $b127824328a411b2$var$alreadyWarned[args[0]] = new Date();
    $b127824328a411b2$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $b127824328a411b2$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $b127824328a411b2$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $b127824328a411b2$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $b127824328a411b2$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $b127824328a411b2$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $b127824328a411b2$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $dbc25c2fc17f7e09$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dbc25c2fc17f7e09$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dbc25c2fc17f7e09$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($d1049584750a9d41$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dbc25c2fc17f7e09$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $dbc25c2fc17f7e09$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $4CEbD.useRef)();
    (0, $4CEbD.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $dbc25c2fc17f7e09$export$9fc83ad70ead8663(ns) {
    var getT = function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    };
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $4CEbD.useContext)((0, $b4ff156111e82d24$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $b4ff156111e82d24$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $b4ff156111e82d24$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $b127824328a411b2$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $b127824328a411b2$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $dbc25c2fc17f7e09$var$_objectSpread($dbc25c2fc17f7e09$var$_objectSpread($dbc25c2fc17f7e09$var$_objectSpread({}, (0, $b4ff156111e82d24$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $b127824328a411b2$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    var _useState = (0, $4CEbD.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($f5bc2b5e9093dc55$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $dbc25c2fc17f7e09$var$usePrevious(joinedNS);
    var isMounted = (0, $4CEbD.useRef)(true);
    (0, $4CEbD.useEffect)(function() {
        var boundReset = function boundReset() {
            if (isMounted.current) setT(getT);
        };
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $b127824328a411b2$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $4CEbD.useRef)(true);
    (0, $4CEbD.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $b127824328a411b2$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}


var $ceba2ca89b3ab47b$var$ErrorComponent = function(error) {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var doCancelTest = function() {
        dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
        dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
            text: t("error.systemReseted.message"),
            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).INFO,
            props: {}
        }));
        history.push((0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: t("error.errorHTML")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("code", null, JSON.stringify(error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: doCancelTest,
        className: "button is-primary button--direction-right is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("error.restartButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-circle-right"
    })));
};
var $ceba2ca89b3ab47b$export$edf27be85e5f6da0 = $ceba2ca89b3ab47b$var$ErrorComponent;




var $8e2a084d93237cf3$export$856890d3f620f53d = function(log) {
    return {
        msg: log.message,
        level: log.level.label,
        stacktrace: log.stacktrace
    };
};
//remote.apply(log, { format: customJSON, url: '/logger' });
(0, (/*@__PURE__*/$parcel$interopDefault($27b146b8ba25b2a4$exports))).enableAll();
var $8e2a084d93237cf3$export$e926676385687eaf = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $fsOl6._)(ErrorBoundary, Component);
    var _super = (0, $COJlH._)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0, $h5oKP._)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $85qwq._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                // log the error to our server with loglevel
                (0, (/*@__PURE__*/$parcel$interopDefault($27b146b8ba25b2a4$exports))).error({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $ceba2ca89b3ab47b$export$edf27be85e5f6da0), {
                    error: this.state.error
                });
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: // eslint-disable-next-line no-unused-vars
            function getDerivedStateFromError(error) {
                // Update state so the next render will show the fallback UI.
                return {
                    error: error
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, $4CEbD.Component));
$8e2a084d93237cf3$export$e926676385687eaf.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array
};
var $8e2a084d93237cf3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($27b146b8ba25b2a4$exports)));





var $4CEbD = parcelRequire("4CEbD");
var $c338a874749393df$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, $5F2Q2._)(arg);
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $c338a874749393df$exports) {
        classNames.default = classNames;
        $c338a874749393df$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $em5FP = parcelRequire("em5FP");

var $nLPsB = parcelRequire("nLPsB");

var $em5FP = parcelRequire("em5FP");

var $nLPsB = parcelRequire("nLPsB");
var $211c217de79f8f69$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $211c217de79f8f69$var$runtime = function(exports) {
    "use strict";
    var define = function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    };
    var wrap = function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    };
    var tryCatch = // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    };
    var Generator = // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var defineIteratorMethods = // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    };
    var AsyncIterator = function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    };
    var makeInvokeMethod = function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    };
    var pushTryEntry = function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    };
    var resetTryEntry = function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    };
    var Context = function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    };
    var values = function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    };
    var doneResult = function doneResult() {
        return {
            value: undefined,
            done: true
        };
    };
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    exports.wrap = wrap;
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    exports.values = values;
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            var handle = function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            };
            if (this.done) throw exception;
            var context = this;
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $211c217de79f8f69$exports));
try {
    regeneratorRuntime = $211c217de79f8f69$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $211c217de79f8f69$var$runtime;
    else Function("r", "regeneratorRuntime = r")($211c217de79f8f69$var$runtime);
}




function $c5969398abcb4057$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $be350f5be03d52fe$export$2e2bcd8739ae039)(target, key, source[key]);
        });
    }
    return target;
}


function $6b275e1774206313$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $c04b6f52cb4211ea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $9d0269e895187a7a$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $c04b6f52cb4211ea$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $c04b6f52cb4211ea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c04b6f52cb4211ea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $1ad479a963ba2c01$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $ebbabb230ecc9cae$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(self);
}


function $68539bfc51fe25da$export$2e2bcd8739ae039(o) {
    $68539bfc51fe25da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $68539bfc51fe25da$export$2e2bcd8739ae039(o);
}




function $f3b0709707b4b542$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $94df4a08671d142b$export$2e2bcd8739ae039)(subClass, superClass);
}


var $f8f1d5b7157aea63$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $f8f1d5b7157aea63$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $f8f1d5b7157aea63$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $f8f1d5b7157aea63$var$baseLogger = new $f8f1d5b7157aea63$var$Logger();
var $f8f1d5b7157aea63$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $f8f1d5b7157aea63$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $f8f1d5b7157aea63$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $f8f1d5b7157aea63$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $f8f1d5b7157aea63$var$getLastOfPath(object, path, Empty) {
    var cleanKey = function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    };
    var canNotTraverseDeeper = function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    };
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $f8f1d5b7157aea63$var$setPath(object, path, newValue) {
    var _getLastOfPath = $f8f1d5b7157aea63$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $f8f1d5b7157aea63$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $f8f1d5b7157aea63$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $f8f1d5b7157aea63$var$getPath(object, path) {
    var _getLastOfPath3 = $f8f1d5b7157aea63$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $f8f1d5b7157aea63$var$getPathWithDefaults(data, defaultData, key) {
    var value = $f8f1d5b7157aea63$var$getPath(data, key);
    if (value !== undefined) return value;
    return $f8f1d5b7157aea63$var$getPath(defaultData, key);
}
function $f8f1d5b7157aea63$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $f8f1d5b7157aea63$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $f8f1d5b7157aea63$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $f8f1d5b7157aea63$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $f8f1d5b7157aea63$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $f8f1d5b7157aea63$var$_entityMap[s];
    });
    return data;
}
var $f8f1d5b7157aea63$var$isIE10 = typeof window !== "undefined" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
function $f8f1d5b7157aea63$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (typeof mix === "string") return mix;
            if (p && typeof mix[p] === "string") return mix[p];
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $f8f1d5b7157aea63$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $f8f1d5b7157aea63$var$ResourceStore = function(_EventEmitter) {
    (0, $f3b0709707b4b542$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = (0, $ebbabb230ecc9cae$export$2e2bcd8739ae039)(this, (0, $68539bfc51fe25da$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($f8f1d5b7157aea63$var$isIE10) $f8f1d5b7157aea63$var$EventEmitter.call((0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $f8f1d5b7157aea63$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $f8f1d5b7157aea63$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $f8f1d5b7157aea63$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $f8f1d5b7157aea63$var$getPath(this.data, path) || {};
                if (deep) $f8f1d5b7157aea63$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, pack, resources);
                $f8f1d5b7157aea63$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($f8f1d5b7157aea63$var$EventEmitter);
var $f8f1d5b7157aea63$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $f8f1d5b7157aea63$var$checkedLoadedFor = {};
var $f8f1d5b7157aea63$var$Translator = function(_EventEmitter) {
    (0, $f3b0709707b4b542$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, Translator);
        _this = (0, $ebbabb230ecc9cae$export$2e2bcd8739ae039)(this, (0, $68539bfc51fe25da$export$2e2bcd8739ae039)(Translator).call(this));
        if ($f8f1d5b7157aea63$var$isIE10) $f8f1d5b7157aea63$var$EventEmitter.call((0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
        $f8f1d5b7157aea63$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $f8f1d5b7157aea63$var$baseLogger.create("translator");
        return _this;
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $f8f1d5b7157aea63$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $c5969398abcb4057$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$f8f1d5b7157aea63$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $f8f1d5b7157aea63$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($f8f1d5b7157aea63$var$EventEmitter);
function $f8f1d5b7157aea63$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $f8f1d5b7157aea63$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $f8f1d5b7157aea63$var$baseLogger.create("languageUtils");
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $f8f1d5b7157aea63$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $f8f1d5b7157aea63$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $f8f1d5b7157aea63$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $f8f1d5b7157aea63$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $f8f1d5b7157aea63$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $f8f1d5b7157aea63$var$createRules() {
    var rules = {};
    $f8f1d5b7157aea63$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $f8f1d5b7157aea63$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $f8f1d5b7157aea63$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $f8f1d5b7157aea63$var$baseLogger.create("pluralResolver");
        this.rules = $f8f1d5b7157aea63$var$createRules();
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = "plural";
                        else if (suffix === 1) suffix = "";
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === "v1") {
                        if (suffix === 1) return "";
                        if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        }
    ]);
    return PluralResolver;
}();
var $f8f1d5b7157aea63$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $f8f1d5b7157aea63$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $f8f1d5b7157aea63$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $f8f1d5b7157aea63$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $f8f1d5b7157aea63$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $f8f1d5b7157aea63$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $f8f1d5b7157aea63$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $f8f1d5b7157aea63$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $f8f1d5b7157aea63$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var regexSafe = function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                };
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $f8f1d5b7157aea63$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, data, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($f8f1d5b7157aea63$var$getPathWithDefaults(data, defaultData, k), f, lng, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, data, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $f8f1d5b7157aea63$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += safeValue.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var handleHasOptions = function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                };
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $f8f1d5b7157aea63$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $f8f1d5b7157aea63$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $f8f1d5b7157aea63$var$Connector = function(_EventEmitter) {
    (0, $f3b0709707b4b542$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, Connector);
        _this = (0, $ebbabb230ecc9cae$export$2e2bcd8739ae039)(this, (0, $68539bfc51fe25da$export$2e2bcd8739ae039)(Connector).call(this));
        if ($f8f1d5b7157aea63$var$isIE10) $f8f1d5b7157aea63$var$EventEmitter.call((0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $f8f1d5b7157aea63$var$baseLogger.create("backendConnector");
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $f8f1d5b7157aea63$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $f8f1d5b7157aea63$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($f8f1d5b7157aea63$var$EventEmitter);
function $f8f1d5b7157aea63$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $aef438142fbed70c$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $f8f1d5b7157aea63$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf("cimode") < 0) options.whitelist = options.whitelist.concat([
            "cimode"
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $f8f1d5b7157aea63$var$noop() {}
var $f8f1d5b7157aea63$var$I18n = function(_EventEmitter) {
    (0, $f3b0709707b4b542$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, I18n);
        _this = (0, $ebbabb230ecc9cae$export$2e2bcd8739ae039)(this, (0, $68539bfc51fe25da$export$2e2bcd8739ae039)(I18n).call(this));
        if ($f8f1d5b7157aea63$var$isIE10) $f8f1d5b7157aea63$var$EventEmitter.call((0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
        _this.options = $f8f1d5b7157aea63$var$transformOptions(options);
        _this.services = {};
        _this.logger = $f8f1d5b7157aea63$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $ebbabb230ecc9cae$export$2e2bcd8739ae039)(_this, (0, $1ad479a963ba2c01$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var createClassOnDemand = function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                };
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, $f8f1d5b7157aea63$var$get(), this.options, $f8f1d5b7157aea63$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $f8f1d5b7157aea63$var$noop;
                if (!this.options.isClone) {
                    if (this.modules.logger) $f8f1d5b7157aea63$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $f8f1d5b7157aea63$var$baseLogger.init(null, this.options);
                    var lu = new $f8f1d5b7157aea63$var$LanguageUtil(this.options);
                    this.store = new $f8f1d5b7157aea63$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $f8f1d5b7157aea63$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $f8f1d5b7157aea63$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $f8f1d5b7157aea63$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $f8f1d5b7157aea63$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $f8f1d5b7157aea63$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $f8f1d5b7157aea63$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f8f1d5b7157aea63$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $f8f1d5b7157aea63$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $f8f1d5b7157aea63$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $f8f1d5b7157aea63$var$postProcessor.addPostProcessor(module);
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $f8f1d5b7157aea63$var$defer();
                this.emit("languageChanging", lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $aef438142fbed70c$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $f8f1d5b7157aea63$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $f8f1d5b7157aea63$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? "rtl" : "ltr";
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f8f1d5b7157aea63$var$noop;
                var mergedOptions = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $c5969398abcb4057$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $f8f1d5b7157aea63$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages
                };
            }
        }
    ]);
    return I18n;
}($f8f1d5b7157aea63$var$EventEmitter);
var $f8f1d5b7157aea63$var$i18next = new $f8f1d5b7157aea63$var$I18n();
var $f8f1d5b7157aea63$export$2e2bcd8739ae039 = $f8f1d5b7157aea63$var$i18next;




var $84ae43476eb4deb8$var$backendHost = window.location.host.includes("localhost") ? "http://localhost:8000/api" : "https://api.lerche-lesediagnose.at";
var $84ae43476eb4deb8$export$86cc9d96db6c637c = $84ae43476eb4deb8$var$backendHost + "/pdfReport?session_id=";
var $84ae43476eb4deb8$var$apiEndPoints = {
    previousGroup: $84ae43476eb4deb8$var$backendHost + "/previousGroup",
    answersGroup: $84ae43476eb4deb8$var$backendHost + "/answersGroup",
    startTest: $84ae43476eb4deb8$var$backendHost + "/startTest",
    resumeTest: $84ae43476eb4deb8$var$backendHost + "/resumeTest",
    nextSection: $84ae43476eb4deb8$var$backendHost + "/nextSection",
    abortTest: $84ae43476eb4deb8$var$backendHost + "/abortTest",
    textResults: $84ae43476eb4deb8$var$backendHost + "/textResults"
};
var $84ae43476eb4deb8$var$defaultOptions = {
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json;charset=UTF-8"
    }
};
// eslint-disable-next-line no-unused-vars
var $84ae43476eb4deb8$var$fetchApi = function() {
    var _ref = (0, $em5FP._)(function(url) {
        var payload, options, finalUrl, defOptions, response;
        var _arguments = arguments;
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    finalUrl = url;
                    defOptions = Object.assign({}, $84ae43476eb4deb8$var$defaultOptions, options);
                    defOptions.headers["Content-Language"] = (0, $f8f1d5b7157aea63$export$2e2bcd8739ae039).language.substring(0, 2);
                    defOptions.headers["Accept-Language"] = (0, $f8f1d5b7157aea63$export$2e2bcd8739ae039).language.substring(0, 2);
                    //log.info("fetchApi", "defOptions #1", defOptions);
                    if ((options === null || options === void 0 ? void 0 : options.method) && options.method === "GET") finalUrl += "?" + new URLSearchParams(payload).toString();
                    else defOptions.body = JSON.stringify(payload);
                    //log.info("x001 fetchApi", "defOptions #2", defOptions);
                    (0, $93dee004cba920da$export$6f57813fe9f31bf9).dispatch((0, $f487fa6abc092388$export$1c03665141dc142f)({
                        submitting: true
                    }));
                    return [
                        4,
                        fetch(finalUrl, defOptions).then(function(response) {
                            return [
                                204
                            ].includes(response.status) ? {} : response.json();
                        }).catch(function(error) {
                            return {
                                error: error.error || "error.connectingToServer",
                                payload: {
                                    url: url,
                                    payload: payload,
                                    error: error
                                }
                            };
                        }).finally(function() {
                            (0, $93dee004cba920da$export$6f57813fe9f31bf9).dispatch((0, $f487fa6abc092388$export$1c03665141dc142f)({
                                submitting: false
                            }));
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (response.error) return [
                        2,
                        {
                            error: response.error || "error.connectingToServer",
                            payload: {
                                url: url,
                                payload: payload,
                                error: response.error
                            }
                        }
                    ];
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function fetchApi(url) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$e72511350a89a269 = function() {
    var _ref = (0, $em5FP._)(function(sessionId) {
        var res;
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.startTest, {
                            concrete_test_code: sessionId
                        }, {
                            method: "POST"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function startTest(sessionId) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$b96b69e966de3651 = function() {
    var _ref = (0, $em5FP._)(function(sessionId) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.resumeTest, {
                            session_id: sessionId
                        }, {
                            method: "GET"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function resumeTest(sessionId) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$d9c45e29a4259227 = function() {
    var _ref = (0, $em5FP._)(function(sessionId, answers) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.previousGroup, {
                            session_id: sessionId,
                            student_answer: answers
                        }, {
                            method: "POST"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPreviousGroup(sessionId, answers) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$ed3a631456019f00 = function() {
    var _ref = (0, $em5FP._)(function(sessionId, answers) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.nextSection, {
                            session_id: sessionId,
                            student_answer: answers
                        }, {
                            method: "POST"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getNextSection(sessionId, answers) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$c275eceb89556514 = function() {
    var _ref = (0, $em5FP._)(function(sessionId) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.textResults, {
                            session_id: sessionId,
                            type: "student"
                        }, {
                            method: "GET"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getStudentResults(sessionId) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$588d6001e05323e6 = function() {
    var _ref = (0, $em5FP._)(function(sessionId) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.textResults, {
                            session_id: sessionId,
                            type: "teacher"
                        }, {
                            method: "GET"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTeacherResults(sessionId) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$55c80b1906ad1f5b = function() {
    var _ref = (0, $em5FP._)(function(sessionId) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.abortTest, {
                            session_id: sessionId
                        }, {
                            method: "PUT"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function abortTest(sessionId) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$6c33279ba320b667 = function() {
    var _ref = (0, $em5FP._)(function(sessionId, answers) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.answersGroup, {
                            session_id: sessionId,
                            student_answer: answers
                        }, {
                            method: "POST"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function submitAnswers(sessionId, answers) {
        return _ref.apply(this, arguments);
    };
}();
var $84ae43476eb4deb8$export$302dd75f45529012 = function() {
    var _ref = (0, $em5FP._)(function(sessionId, answers) {
        return (0, $nLPsB.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $84ae43476eb4deb8$var$fetchApi($84ae43476eb4deb8$var$apiEndPoints.answersGroup, {
                            session_id: sessionId,
                            complete_test: true,
                            student_answer: answers
                        }, {
                            method: "POST"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function completeTest(sessionId, answers) {
        return _ref.apply(this, arguments);
    };
}();







var $4CEbD = parcelRequire("4CEbD");



var $5deffef8924bacef$var$Component = function() {
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var directorState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $f487fa6abc092388$export$86d1cded24611cb8));
    var removeModal = function() {
        dispatch((0, $817d712521df1056$export$35f4993c69cad466)({}));
    };
    var doCancelTest = function() {
        var _ref = (0, $em5FP._)(function() {
            var res;
            return (0, $nLPsB.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $84ae43476eb4deb8$export$55c80b1906ad1f5b(directorState.sessionId)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.error) {
                            dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
                            dispatch((0, $817d712521df1056$export$35f4993c69cad466)({}));
                            dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                                text: t("abortTest.testWasAborted.message"),
                                type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).INFO,
                                props: {}
                            }));
                            history.push((0, $6fb258ca9d5a721a$export$500824a38b151028));
                        } else dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                            text: t(res.error),
                            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                            props: {}
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function doCancelTest() {
            return _ref.apply(this, arguments);
        };
    }();
    //Todo: translate
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("header", {
        className: "modal-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "modal-card-title"
    }, t("modal.abortTest.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("section", {
        className: "modal-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "has-text-danger has-text-weight-bold"
    }, t("modal.abortTest.content.init")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, t("modal.abortTest.content"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("footer", {
        className: "modal-card-foot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: doCancelTest,
        className: "button button--direction-down is-danger is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("modal.abortTest.submitButton.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: removeModal,
        className: "button button--direction-left is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-arc-left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("modal.abortTest.cancelButton.caption")))));
};
var $5deffef8924bacef$export$6e1b820cdfe11a44 = $5deffef8924bacef$var$Component;



var $4CEbD = parcelRequire("4CEbD");



var $da5cea46f806e423$var$HelpComponent = function() {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var removeModal = function() {
        console.log("removeModal");
        dispatch((0, $817d712521df1056$export$35f4993c69cad466)({}));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("header", {
        className: "modal-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "modal-card-title"
    }, t("modal.help.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("section", {
        className: "modal-card-body",
        dangerouslySetInnerHTML: {
            __html: t("modal.help.content")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("footer", {
        className: "modal-card-foot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: removeModal,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-x"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, "Schlie\xdfen"))));
};
var $da5cea46f806e423$export$1be7516c0280bee8 = $da5cea46f806e423$var$HelpComponent;



var $em5FP = parcelRequire("em5FP");

var $nLPsB = parcelRequire("nLPsB");





var $4CEbD = parcelRequire("4CEbD");





var $227a6f2af4d48a25$var$Component = function() {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var directorState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $f487fa6abc092388$export$86d1cded24611cb8));
    var modalState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $817d712521df1056$export$97564ec4f39e372c));
    // React.useEffect(() => {
    //     //console.log("xxx", modalState);
    //     if(modalState.modalActive) document.body.classList.add('test--out');
    //     else document.body.classList.remove('test--out');
    // }, [modalState.modalActive]);
    // const sleep = (ms) => {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    //   };
    var removeModal = function() {
        dispatch((0, $817d712521df1056$export$34c750e9d1412945)({}));
        dispatch((0, $817d712521df1056$export$35f4993c69cad466)({}));
    };
    var goNextSection = function() {
        var _ref = (0, $em5FP._)(function() {
            var res, isLastSection, succF, onSubmitFailure;
            return (0, $nLPsB.__generator)(this, function(_state) {
                isLastSection = directorState.currentSectionNo === directorState.noOfSections;
                dispatch((0, $817d712521df1056$export$af4939467128bcd0)({}));
                succF = function(res) {
                    //console.log("NextSection", "onSubmitSuccess", res.error, res);
                    (0, $11c013bdbcf83901$export$169439c91a279f79)("story__top");
                    document.body.classList.remove("test--out");
                    removeModal();
                    if (isLastSection) history.push((0, $6fb258ca9d5a721a$export$45f15e91356025b3));
                    else dispatch((0, $f487fa6abc092388$export$e16717ba5a5dc549)({
                        section: res
                    }));
                };
                onSubmitFailure = function(res) {
                    //console.log("NextSection", "onSubmitFailure", res.error, res);
                    document.body.classList.remove("test--out");
                    dispatch((0, $817d712521df1056$export$34c750e9d1412945)({}));
                    dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                        text: t(res.error),
                        type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                        props: {}
                    }));
                };
                document.body.classList.add("test--out");
                if (isLastSection) res = $84ae43476eb4deb8$export$302dd75f45529012(directorState.sessionId, modalState.modalPayload.model);
                else res = $84ae43476eb4deb8$export$ed3a631456019f00(directorState.sessionId, modalState.modalPayload.model);
                res.then(succF, onSubmitFailure);
                return [
                    2,
                    res
                ];
            });
        });
        return function goNextSection() {
            return _ref.apply(this, arguments);
        };
    }();
    //Todo: translate
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("section", {
        className: "modal-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, t("modal.nextSection.content")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "mt-25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: goNextSection,
        className: "button is-success button--direction-down is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-circle-down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("modal.nextSection.submitButton.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: removeModal,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-x"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("modal.nextSection.cancelButton.caption"))))));
};
var $227a6f2af4d48a25$export$8aa9c773570601fa = $227a6f2af4d48a25$var$Component;


var $71c744b23ac990f6$export$3d96f1ad58688d8 = {
    "Help": (0, $da5cea46f806e423$export$1be7516c0280bee8),
    "AbortTest": (0, $5deffef8924bacef$export$6e1b820cdfe11a44),
    "NextSection": (0, $227a6f2af4d48a25$export$8aa9c773570601fa)
};



//import {useTranslation} from "react-i18next";
var $bb310dbd5417ffed$var$ModalComponent = function() {
    var modalState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $817d712521df1056$export$97564ec4f39e372c));
    //const history = useHistory();
    //const {t} = useTranslation();
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    // console.log("ModalComponent", history.location.pathname, testUrl);
    var location = (0, $876a3032fada8974$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {}, [
        location
    ]);
    var removeModal = function() {
        dispatch((0, $817d712521df1056$export$35f4993c69cad466)({}));
    };
    //log.info("ModalComponent", modalState.modalContent, modals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("modal", {
            "is-active": modalState.modalActive && !modalState.modalHidden
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "modal-background"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "modal-card"
    }, modalState.modalContent && (0, $71c744b23ac990f6$export$3d96f1ad58688d8)[modalState.modalContent] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $71c744b23ac990f6$export$3d96f1ad58688d8)[modalState.modalContent], {})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: removeModal,
        className: "button is-tertiary modal--close",
        "aria-label": "close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-x"
    })));
};
var $bb310dbd5417ffed$export$2b77a92f1a5ad772 = $bb310dbd5417ffed$var$ModalComponent;


var $aab47fbd9aba43d1$exports = {};

$parcel$export($aab47fbd9aba43d1$exports, "NavigationBar", function () { return $aab47fbd9aba43d1$export$214ae410b202e65a; });

var $em5FP = parcelRequire("em5FP");

var $2MVSR = parcelRequire("2MVSR");

var $nLPsB = parcelRequire("nLPsB");





var $4CEbD = parcelRequire("4CEbD");






var $aab47fbd9aba43d1$var$_this = undefined;
var $7babcdc314e6fd25$exports = {};
$7babcdc314e6fd25$exports = JSON.parse('{"name":"lerche-lesediagnose","version":"1.2.9","browserslist":"> 0.25%, not dead","scripts":{"start":"parcel src/index.html","build":"parcel build src/index.html","eslint":"eslint src/ --ext .js --ext .jsx"},"dependencies":{"@material-ui/core":"^4.12.3","@reduxjs/toolkit":"^1.6.1","@types/react":"^16.8.6 || ^17.0.0","ajv":"^8.6.2","ajv-formats":"^2.1.1","classnames":"^2.3.1","html2pdf.js":"^0.9.3","i18next":"^20.6.1","i18next-browser-languagedetector":"^6.1.2","js-snackbar":"^1.1.2","lib":"^4.3.3","logger":"^0.0.1","loglevel":"^1.7.1","loglevel-plugin-remote":"^0.6.8","react":"^16.8.0 || ^17.0.0","react-device-detect":"^2.2.2","react-dom":"^16.8.0 || ^17.0.0","react-helmet-async":"^1.1.0","react-i18next":"^11.12.0","react-idle-timer":"^5.6.2","react-redux":"^7.2.4","react-router-dom":"^5.3.0","react-tooltip":"^4.2.21","redux":"^4.1.1","redux-persist":"^6.0.0","simplebar-react":"^2.3.6","uniforms":"^3.5.5","uniforms-bridge-json-schema":"^3.5.5","uniforms-unstyled":"^3.5.5"},"devDependencies":{"@babel/core":"^7.22.10","@babel/preset-env":"^7.22.10","@babel/preset-react":"^7.14.5","babel-eslint":"^10.1.0","babel-plugin-module-resolver":"^5.0.0","babel-preset-env":"^1.7.0","buffer":"^6.0.3","eslint":"^7.32.0","eslint-plugin-react":"^7.24.0","parcel":"^2.9.3","process":"^0.11.10","serve":"^14.2.0"}}');


// eslint-disable-next-line no-undef
var $aab47fbd9aba43d1$var$APP_VERSION = $7babcdc314e6fd25$exports.version;
var $aab47fbd9aba43d1$var$NavigationBarComponent = function() {
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var idleState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $5ae2f05a62e19741$export$c3aeaf078d419c4b));
    var _React_useState = (0, $2MVSR._)((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useState(false), 2), navIsActive = _React_useState[0], setNavIsActive = _React_useState[1];
    //console.log("NavigationBarComponent", history.location.pathname, testUrl);
    var goto = function(target) {
        return history.push(target);
    };
    var location = (0, $876a3032fada8974$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        if (idleState.timeLeft > 0) document.body.classList.add("is-timeout");
        else document.body.classList.remove("is-timeout");
    }, [
        location,
        idleState.timeLeft
    ]);
    var doCancelTest = function() {
        var _ref = (0, $em5FP._)(function() {
            return (0, $nLPsB.__generator)(this, function(_state) {
                if ([
                    (0, $6fb258ca9d5a721a$export$45f15e91356025b3)
                ].includes(history.location.pathname)) {
                    dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
                    // dispatch(addItem({text: t("abortTest.testWasAborted.message"), type: MESSAGE_TYPE.INFO, props: {}}));
                    goto((0, $6fb258ca9d5a721a$export$500824a38b151028));
                } else dispatch((0, $817d712521df1056$export$923d3332dd605124)({
                    content: "AbortTest"
                }));
                return [
                    2
                ];
            });
        });
        return function doCancelTest() {
            return _ref.apply(this, arguments);
        };
    }();
    //console.log("NavigationBarComponent", idleState.timeLeft);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("nav", {
        className: "navbar is-transparent",
        role: "navigation",
        "aria-label": "main navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-brand"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "header__logo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-bird"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "header__title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "header__name"
    }, t("app.name")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "header__subname"
    }, t("app.subname")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "header__version"
    }, $aab47fbd9aba43d1$var$APP_VERSION))), idleState.timeLeft > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "header__timeout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, t("navigation.logout.message1"), " ", Math.round(idleState.timeLeft / 1000), " ", t("navigation.logout.message2")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        role: "button",
        onClick: function() {
            return setNavIsActive(!navIsActive);
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("navbar-burger", {
            "is-active": navIsActive
        }),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "navbarBasicExample"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("navbar-menu", {
            "is-active": navIsActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "buttons"
    }, ![
        (0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d),
        (0, $6fb258ca9d5a721a$export$1db569cf9469e5b3),
        (0, $6fb258ca9d5a721a$export$45f15e91356025b3)
    ].includes(history.location.pathname) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: goto.bind($aab47fbd9aba43d1$var$_this, (0, $6fb258ca9d5a721a$export$1db569cf9469e5b3)),
        className: "button is-small button--direction-right is-rounded is-primary header__launch__start header__launch__start--hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t("navigation.startTest.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-play-circle"
    })), [
        (0, $6fb258ca9d5a721a$export$1db569cf9469e5b3),
        (0, $6fb258ca9d5a721a$export$45f15e91356025b3)
    ].includes(history.location.pathname) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: doCancelTest,
        className: "button is-small is-rounded is-text header__launch__stop 0header__launch__stop--hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, t([
        (0, $6fb258ca9d5a721a$export$45f15e91356025b3)
    ].includes(history.location.pathname) ? "testResultPage.newTestButton.caption" : "navigation.cancelTest.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-x"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-item is-hoverable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        className: "navbar-link is-arrowless button is-small is-rounded is-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.more.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-list"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "navbar-dropdown is-right is-boxed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        onClick: goto.bind($aab47fbd9aba43d1$var$_this, (0, $6fb258ca9d5a721a$export$500824a38b151028)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.home.caption"))), history.location.pathname !== (0, $6fb258ca9d5a721a$export$1db569cf9469e5b3) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        onClick: goto.bind($aab47fbd9aba43d1$var$_this, (0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.startTest.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        onClick: goto.bind($aab47fbd9aba43d1$var$_this, (0, $6fb258ca9d5a721a$export$2a280bdbd8b49d15)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.privacyPolicy.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        onClick: goto.bind($aab47fbd9aba43d1$var$_this, (0, $6fb258ca9d5a721a$export$ce029234ae8b8b29)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.impress.caption"))))))));
};
$aab47fbd9aba43d1$var$NavigationBarComponent.propTypes = {
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object
};
var $aab47fbd9aba43d1$export$214ae410b202e65a = $aab47fbd9aba43d1$var$NavigationBarComponent;



var $5F2Q2 = parcelRequire("5F2Q2");

var $4CEbD = parcelRequire("4CEbD");
function $7fff4eb77929b32b$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $5F2Q2._)(Symbol.iterator) === "symbol") $7fff4eb77929b32b$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    else $7fff4eb77929b32b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    return $7fff4eb77929b32b$var$_typeof(obj);
}
function $7fff4eb77929b32b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7fff4eb77929b32b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7fff4eb77929b32b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7fff4eb77929b32b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7fff4eb77929b32b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7fff4eb77929b32b$var$_possibleConstructorReturn(self, call) {
    if (call && ($7fff4eb77929b32b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7fff4eb77929b32b$var$_assertThisInitialized(self);
}
function $7fff4eb77929b32b$var$_getPrototypeOf(o) {
    $7fff4eb77929b32b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7fff4eb77929b32b$var$_getPrototypeOf(o);
}
function $7fff4eb77929b32b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7fff4eb77929b32b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7fff4eb77929b32b$var$_setPrototypeOf(subClass, superClass);
}
function $7fff4eb77929b32b$var$_setPrototypeOf(o, p) {
    $7fff4eb77929b32b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7fff4eb77929b32b$var$_setPrototypeOf(o, p);
}
function $7fff4eb77929b32b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7fff4eb77929b32b$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $7fff4eb77929b32b$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $7fff4eb77929b32b$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7fff4eb77929b32b$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $7fff4eb77929b32b$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $7fff4eb77929b32b$var$_defineProperty($7fff4eb77929b32b$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $7fff4eb77929b32b$var$_defineProperty($7fff4eb77929b32b$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $7fff4eb77929b32b$var$_defineProperty($7fff4eb77929b32b$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $7fff4eb77929b32b$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $4CEbD.PureComponent));
$7fff4eb77929b32b$var$_defineProperty($7fff4eb77929b32b$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});




var $4CEbD = parcelRequire("4CEbD");



var $4CEbD = parcelRequire("4CEbD");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $d3480d02564f6028$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    var BrowserRouter = function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $1b42263abc5a71de$export$719fc203c4e16dee)(_this.props);
        return _this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $d3480d02564f6028$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    var HashRouter = function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $1b42263abc5a71de$export$b71fdd3798280242)(_this.props);
        return _this;
    };
    (0, $267d38b9ce0b0b33$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component);
var $d3480d02564f6028$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $d3480d02564f6028$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $1b42263abc5a71de$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $d3480d02564f6028$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $d3480d02564f6028$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).forwardRef;
if (typeof $d3480d02564f6028$var$forwardRef === "undefined") $d3480d02564f6028$var$forwardRef = $d3480d02564f6028$var$forwardRefShim;
function $d3480d02564f6028$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $d3480d02564f6028$var$LinkAnchor = $d3480d02564f6028$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$d3480d02564f6028$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($d3480d02564f6028$var$forwardRefShim !== $d3480d02564f6028$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $d3480d02564f6028$export$a6c7ac8248d6e38a = $d3480d02564f6028$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $d3480d02564f6028$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $d3480d02564f6028$var$normalizeToLocation($d3480d02564f6028$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $d3480d02564f6028$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $1b42263abc5a71de$export$fe53371bee54353d)(context.location) === (0, $1b42263abc5a71de$export$fe53371bee54353d)($d3480d02564f6028$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($d3480d02564f6028$var$forwardRefShim !== $d3480d02564f6028$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(component, props);
    });
});
var $d3480d02564f6028$var$toType, $d3480d02564f6028$var$refType;
var $d3480d02564f6028$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $d3480d02564f6028$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).forwardRef;
if (typeof $d3480d02564f6028$var$forwardRef$1 === "undefined") $d3480d02564f6028$var$forwardRef$1 = $d3480d02564f6028$var$forwardRefShim$1;
function $d3480d02564f6028$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $d3480d02564f6028$export$b0d92dbee9b5b60d = $d3480d02564f6028$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $62e4ff1670bafd70$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $ee3152882cce2e9b$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $d3480d02564f6028$var$normalizeToLocation($d3480d02564f6028$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $876a3032fada8974$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $d3480d02564f6028$var$joinClassnames(className, activeClassName);
            style = (0, $473874a05528463f$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $473874a05528463f$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($d3480d02564f6028$var$forwardRefShim$1 !== $d3480d02564f6028$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($d3480d02564f6028$export$a6c7ac8248d6e38a, props);
    });
});
var $d3480d02564f6028$var$ariaCurrentType;



function $1b39ff67acf150b6$export$c90d7ca213038c72() {
    $1b39ff67acf150b6$export$c90d7ca213038c72 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b39ff67acf150b6$export$c90d7ca213038c72.apply(this, arguments);
}


function $b3ec68312c1cbba1$export$cffab43ebdf6037(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $4CEbD = parcelRequire("4CEbD");

var $217f77d1e04369c4$export$aec9e034445ee8d0 = function(_param) {
    var content = (0, $1b39ff67acf150b6$export$c90d7ca213038c72)({}, (0, $b3ec68312c1cbba1$export$cffab43ebdf6037)(_param));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$e7b0ac011bb776c6), content);
};




var $4CEbD = parcelRequire("4CEbD");


var $1cd4a961b0de3725$var$HomePage = function() {
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        document.body.classList.add("layout--centered");
        return function() {
            document.body.classList.remove("layout--centered");
        };
    }, []);
    var goToTestPage = function() {
        history.push((0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section bg-primary-gradient-soft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-desktop"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree__show tree-home my-25",
        style: {
            "--result": "119"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree__left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-birds"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-11"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-bird tree-bird-13"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, "Als Tiny am Bach ankam, hatte Ruby bereits ein riesiges L\xf6wenzahnblatt im Maul und knabberte voller Genuss. „Das ist so gut“, m\xfcmmelte er gen\xfcsslich. Tiny war nerv\xf6s. Sie richtete sich auf den Hinterbeinen auf, spitzte die Ohren und schnupperte aufgeregt. Doch alles war ruhig, kein Fuchsgeruch lag in der Luft. Nur gut, dass F\xfcchse so stanken, dass man sie auch gegen den Wind riechen konnte. Vorsichtig knabberte auch Tiny an einer Dotterblume, nicht ohne immer wieder horchen und zu schnuppern. „Komm Tiny, du musst etwas fressen! Sonst bleibst du immer so ein Winzling. Hier, probier‘ das einmal! Du hast wieder einmal die allerbesten Delikatessen mit deiner feinen Nase gefunden.“ Nun grub auch Tiny ihre kleinen Vorderz\xe4hne in einen saftiges Blatt und genoss, dass sich ihr Magen zunehmend f\xfcllte. Doch was war das? Aus den Wipfeln der B\xe4ume hatte sich ein bedrohlicher Schatten gel\xf6st, der sich rasch n\xe4herte. Schon sp\xfcrte Tiny das Trommeln der anderen Kaninchen, die mit ihren Hinterl\xe4ufen vor der Gefahr warnten. Tiny stie\xdf einen langgezogenen, schrillen Schrei aus: „Eule, eine Eule!“ Sie fl\xfcchtete sich tiefer die steile B\xf6schung hinab und kroch zitternd unter das gro\xdfe, feuchte Blatt einer Klette. Sie kauerte sich zitternd darunter, hoffte, dass es ihren gesamten K\xf6rper bedeckte und sie nicht mehr so sehen war. Fest krallte sie sich in den Untergrund, damit ihr K\xf6rper durch die Anspannung das Zittern aufh\xf6rte. Das Wasser des Baches schwappte gegen ihren Bauch. Ruby hingegen war ihren nat\xfcrlichen Kaninchen-Instinkten gefolgt und spurtete in Richtung der Kaninchenl\xf6cher. Im Zickzack floh er \xfcber die Wiese, die nun v\xf6llig im Dunkeln lag. \xdcber sich h\xf6rte er das leise Rauschen der Schwingen der Eule. Wann w\xfcrde sie herabst\xfcrzen und ihren Schnabel in sein Fleisch schlagen? Rubys Lunge brannte, seine Hinterl\xe4ufe schmerzten. Wo war das n\xe4chste Kaninchenloch? Ruby machte einen riesigen Satz und landete tats\xe4chlich in der N\xe4he eines Eingangs des Baus. Mit letzter Kraft st\xfcrzte er sich in die Tiefe."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "tree__right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h1", null, "Hallo beim Lerche Lesetest!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h2", {
        className: "is-success"
    }, "Du bist Sch\xfcler*in"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, "und du hast bereits einen Test-Code. Dann starte den Lesetest."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: goToTestPage,
        className: "button button--direction-right is-rounded is-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, "Zum Test"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-circle-right"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h2", {
        className: "is-info"
    }, "Sie sind Lehrer*in"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, "Alle Informationen zur Lerche Lesediagnose, wie Sie Tests einrichten und Ihre Klassen verwalten, erfahren sie hier:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: function() {
            window.open("https://www.jungoesterreich.at/fachinformation/lesediagnose");
        },
        className: "button button--direction-up is-rounded is-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, "Alle Informationen"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-square-out"
    })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h3", null, "Ein Tool aus dem JUNG\xd6STERREICH Bildungsmedienverlag"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", null, "Wenn Sie interessiert sind, an weiteren spannenden Produkten aus unserem Haus, sollten Sie hier starten: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
        href: "http://www.jungoesterreich.at"
    }, "www.jungoesterreich.at")))));
};
var $1cd4a961b0de3725$export$2e2bcd8739ae039 = $1cd4a961b0de3725$var$HomePage;



var $4CEbD = parcelRequire("4CEbD");

var $07794a62b1b52936$var$ImpressPage = function() {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        document.body.classList.add("layout--centered");
        return function() {
            document.body.classList.remove("layout--centered");
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-desktop",
        dangerouslySetInnerHTML: {
            __html: t("impress.text")
        }
    })));
};
var $07794a62b1b52936$export$2e2bcd8739ae039 = $07794a62b1b52936$var$ImpressPage;



var $4CEbD = parcelRequire("4CEbD");
var $c2d8ab8fcee3b0ab$var$NotFoundPage = function() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        style: {
            textAlign: "center"
        }
    }, "Page not Found"));
};
var $c2d8ab8fcee3b0ab$export$2e2bcd8739ae039 = $c2d8ab8fcee3b0ab$var$NotFoundPage;



var $4CEbD = parcelRequire("4CEbD");

var $8cd79a29fa44d985$var$PrivacyPolicy = function() {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        document.body.classList.add("layout--centered");
        return function() {
            document.body.classList.remove("layout--centered");
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-desktop",
        dangerouslySetInnerHTML: {
            __html: t("privacyPoliy.text")
        }
    })));
};
var $8cd79a29fa44d985$export$2e2bcd8739ae039 = $8cd79a29fa44d985$var$PrivacyPolicy;



var $4CEbD = parcelRequire("4CEbD");

var $em5FP = parcelRequire("em5FP");

var $nLPsB = parcelRequire("nLPsB");


var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");


var $4CEbD = parcelRequire("4CEbD");

var $4CEbD = parcelRequire("4CEbD");
var $820ac02689a8eddd$export$a078c61943f9dbbe = (0, $4CEbD.createContext)(null);


function $1806b649c272c471$export$87c0cf8eb5a167e0() {
    var context = (0, $4CEbD.useContext)((0, $820ac02689a8eddd$export$a078c61943f9dbbe));
    (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(context !== null, "useForm must be used within a form.\n\nTwo most common reasons for this error are:\n1. Component calling this function doesn't have a parent Form component in the tree.\n2. A duplicate uniforms dependency is installed in node_modules.\n\nFor more info check FAQ: https://uniforms.tools/docs/faq/#useform-must-be-used-within-a-form\n  ");
    return context;
}




var $2MVSR = parcelRequire("2MVSR");


var $4CEbD = parcelRequire("4CEbD");

var $2MVSR = parcelRequire("2MVSR");
var $3fbdcc4ebb9f17dd$exports = {};
var $b173e02f38b4f195$exports = {};
var $4b409bb948db762f$exports = {};
var $47c989dafa9cb12c$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $47c989dafa9cb12c$var$isArray = Array.isArray;
$47c989dafa9cb12c$exports = $47c989dafa9cb12c$var$isArray;


var $2153a01d3db2c537$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");

var $415d00fe2ecafb9b$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");
var $11959fa193176326$exports = {};
var $147fb1bda7f9390b$exports = {};

var $hR1MC = parcelRequire("hR1MC");
/** Built-in value references. */ var $147fb1bda7f9390b$var$Symbol = $hR1MC.Symbol;
$147fb1bda7f9390b$exports = $147fb1bda7f9390b$var$Symbol;


var $2f6c4517a2d6f91f$exports = {};

/** Used for built-in method references. */ var $2f6c4517a2d6f91f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f6c4517a2d6f91f$var$hasOwnProperty = $2f6c4517a2d6f91f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2f6c4517a2d6f91f$var$nativeObjectToString = $2f6c4517a2d6f91f$var$objectProto.toString;
/** Built-in value references. */ var $2f6c4517a2d6f91f$var$symToStringTag = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $2f6c4517a2d6f91f$var$getRawTag(value) {
    var isOwn = $2f6c4517a2d6f91f$var$hasOwnProperty.call(value, $2f6c4517a2d6f91f$var$symToStringTag), tag = value[$2f6c4517a2d6f91f$var$symToStringTag];
    try {
        value[$2f6c4517a2d6f91f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $2f6c4517a2d6f91f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$2f6c4517a2d6f91f$var$symToStringTag] = tag;
        else delete value[$2f6c4517a2d6f91f$var$symToStringTag];
    }
    return result;
}
$2f6c4517a2d6f91f$exports = $2f6c4517a2d6f91f$var$getRawTag;


var $86eb3b21d0655007$exports = {};
/** Used for built-in method references. */ var $86eb3b21d0655007$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $86eb3b21d0655007$var$nativeObjectToString = $86eb3b21d0655007$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $86eb3b21d0655007$var$objectToString(value) {
    return $86eb3b21d0655007$var$nativeObjectToString.call(value);
}
$86eb3b21d0655007$exports = $86eb3b21d0655007$var$objectToString;


/** `Object#toString` result references. */ var $11959fa193176326$var$nullTag = "[object Null]", $11959fa193176326$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $11959fa193176326$var$symToStringTag = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $11959fa193176326$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $11959fa193176326$var$undefinedTag : $11959fa193176326$var$nullTag;
    return $11959fa193176326$var$symToStringTag && $11959fa193176326$var$symToStringTag in Object(value) ? $2f6c4517a2d6f91f$exports(value) : $86eb3b21d0655007$exports(value);
}
$11959fa193176326$exports = $11959fa193176326$var$baseGetTag;


var $52801399e0aa2349$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $52801399e0aa2349$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$52801399e0aa2349$exports = $52801399e0aa2349$var$isObjectLike;


/** `Object#toString` result references. */ var $415d00fe2ecafb9b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $415d00fe2ecafb9b$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value)) == "symbol" || $52801399e0aa2349$exports(value) && $11959fa193176326$exports(value) == $415d00fe2ecafb9b$var$symbolTag;
}
$415d00fe2ecafb9b$exports = $415d00fe2ecafb9b$var$isSymbol;


/** Used to match property names within property paths. */ var $2153a01d3db2c537$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $2153a01d3db2c537$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $2153a01d3db2c537$var$isKey(value, object) {
    if ($47c989dafa9cb12c$exports(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $415d00fe2ecafb9b$exports(value)) return true;
    return $2153a01d3db2c537$var$reIsPlainProp.test(value) || !$2153a01d3db2c537$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$2153a01d3db2c537$exports = $2153a01d3db2c537$var$isKey;


var $1df31ec9a0ef5dc8$exports = {};
var $e8ff4dbaf15c83cc$exports = {};
var $ca4770dca2739e7a$exports = {};
var $43eb751753d0c9bb$exports = {};
var $d594148ba4aec771$exports = {};
var $a804a19defb5beb6$exports = {};
var $9235e1677f015184$exports = {};
var $7cd90ea70691f93d$exports = {};
var $7aee39973226e617$exports = {};
var $0c334ddfa683247b$exports = {};
var $c41587d84cc195ae$exports = {};

var $cfc6c88de6d47f6e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $5F2Q2 = parcelRequire("5F2Q2");
function $cfc6c88de6d47f6e$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return value != null && (type == "object" || type == "function");
}
$cfc6c88de6d47f6e$exports = $cfc6c88de6d47f6e$var$isObject;


/** `Object#toString` result references. */ var $c41587d84cc195ae$var$asyncTag = "[object AsyncFunction]", $c41587d84cc195ae$var$funcTag = "[object Function]", $c41587d84cc195ae$var$genTag = "[object GeneratorFunction]", $c41587d84cc195ae$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $c41587d84cc195ae$var$isFunction(value) {
    if (!$cfc6c88de6d47f6e$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $11959fa193176326$exports(value);
    return tag == $c41587d84cc195ae$var$funcTag || tag == $c41587d84cc195ae$var$genTag || tag == $c41587d84cc195ae$var$asyncTag || tag == $c41587d84cc195ae$var$proxyTag;
}
$c41587d84cc195ae$exports = $c41587d84cc195ae$var$isFunction;


var $c5ffc1fb04537fe9$exports = {};
var $b5a2e826be8d90c6$exports = {};

var $hR1MC = parcelRequire("hR1MC");
/** Used to detect overreaching core-js shims. */ var $b5a2e826be8d90c6$var$coreJsData = $hR1MC["__core-js_shared__"];
$b5a2e826be8d90c6$exports = $b5a2e826be8d90c6$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $c5ffc1fb04537fe9$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b5a2e826be8d90c6$exports && $b5a2e826be8d90c6$exports.keys && $b5a2e826be8d90c6$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c5ffc1fb04537fe9$var$isMasked(func) {
    return !!$c5ffc1fb04537fe9$var$maskSrcKey && $c5ffc1fb04537fe9$var$maskSrcKey in func;
}
$c5ffc1fb04537fe9$exports = $c5ffc1fb04537fe9$var$isMasked;



var $c7f8c73d291ae8b1$exports = {};
/** Used for built-in method references. */ var $c7f8c73d291ae8b1$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c7f8c73d291ae8b1$var$funcToString = $c7f8c73d291ae8b1$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c7f8c73d291ae8b1$var$toSource(func) {
    if (func != null) {
        try {
            return $c7f8c73d291ae8b1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$c7f8c73d291ae8b1$exports = $c7f8c73d291ae8b1$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0c334ddfa683247b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0c334ddfa683247b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0c334ddfa683247b$var$funcProto = Function.prototype, $0c334ddfa683247b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0c334ddfa683247b$var$funcToString = $0c334ddfa683247b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0c334ddfa683247b$var$hasOwnProperty = $0c334ddfa683247b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0c334ddfa683247b$var$reIsNative = RegExp("^" + $0c334ddfa683247b$var$funcToString.call($0c334ddfa683247b$var$hasOwnProperty).replace($0c334ddfa683247b$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0c334ddfa683247b$var$baseIsNative(value) {
    if (!$cfc6c88de6d47f6e$exports(value) || $c5ffc1fb04537fe9$exports(value)) return false;
    var pattern = $c41587d84cc195ae$exports(value) ? $0c334ddfa683247b$var$reIsNative : $0c334ddfa683247b$var$reIsHostCtor;
    return pattern.test($c7f8c73d291ae8b1$exports(value));
}
$0c334ddfa683247b$exports = $0c334ddfa683247b$var$baseIsNative;


var $a797638bc13dca0e$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a797638bc13dca0e$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$a797638bc13dca0e$exports = $a797638bc13dca0e$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7aee39973226e617$var$getNative(object, key) {
    var value = $a797638bc13dca0e$exports(object, key);
    return $0c334ddfa683247b$exports(value) ? value : undefined;
}
$7aee39973226e617$exports = $7aee39973226e617$var$getNative;


/* Built-in method references that are verified to be native. */ var $7cd90ea70691f93d$var$nativeCreate = $7aee39973226e617$exports(Object, "create");
$7cd90ea70691f93d$exports = $7cd90ea70691f93d$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9235e1677f015184$var$hashClear() {
    this.__data__ = $7cd90ea70691f93d$exports ? $7cd90ea70691f93d$exports(null) : {};
    this.size = 0;
}
$9235e1677f015184$exports = $9235e1677f015184$var$hashClear;


var $7c79b09c798dbc4f$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7c79b09c798dbc4f$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7c79b09c798dbc4f$exports = $7c79b09c798dbc4f$var$hashDelete;


var $82a9811ce3c675ac$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $82a9811ce3c675ac$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $82a9811ce3c675ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $82a9811ce3c675ac$var$hasOwnProperty = $82a9811ce3c675ac$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $82a9811ce3c675ac$var$hashGet(key) {
    var data = this.__data__;
    if ($7cd90ea70691f93d$exports) {
        var result = data[key];
        return result === $82a9811ce3c675ac$var$HASH_UNDEFINED ? undefined : result;
    }
    return $82a9811ce3c675ac$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$82a9811ce3c675ac$exports = $82a9811ce3c675ac$var$hashGet;


var $e745c6d6d16205c0$exports = {};

/** Used for built-in method references. */ var $e745c6d6d16205c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e745c6d6d16205c0$var$hasOwnProperty = $e745c6d6d16205c0$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e745c6d6d16205c0$var$hashHas(key) {
    var data = this.__data__;
    return $7cd90ea70691f93d$exports ? data[key] !== undefined : $e745c6d6d16205c0$var$hasOwnProperty.call(data, key);
}
$e745c6d6d16205c0$exports = $e745c6d6d16205c0$var$hashHas;


var $46976deb3f61168c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $46976deb3f61168c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $46976deb3f61168c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $7cd90ea70691f93d$exports && value === undefined ? $46976deb3f61168c$var$HASH_UNDEFINED : value;
    return this;
}
$46976deb3f61168c$exports = $46976deb3f61168c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a804a19defb5beb6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$a804a19defb5beb6$var$Hash.prototype.clear = $9235e1677f015184$exports;
$a804a19defb5beb6$var$Hash.prototype["delete"] = $7c79b09c798dbc4f$exports;
$a804a19defb5beb6$var$Hash.prototype.get = $82a9811ce3c675ac$exports;
$a804a19defb5beb6$var$Hash.prototype.has = $e745c6d6d16205c0$exports;
$a804a19defb5beb6$var$Hash.prototype.set = $46976deb3f61168c$exports;
$a804a19defb5beb6$exports = $a804a19defb5beb6$var$Hash;


var $aedeb53a8407af13$exports = {};
var $c6c4a34139babbf2$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c6c4a34139babbf2$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$c6c4a34139babbf2$exports = $c6c4a34139babbf2$var$listCacheClear;


var $124d203b803468a7$exports = {};
var $78ea1a223674cef0$exports = {};
var $1055b4c9bc24e309$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $1055b4c9bc24e309$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$1055b4c9bc24e309$exports = $1055b4c9bc24e309$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $78ea1a223674cef0$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($1055b4c9bc24e309$exports(array[length][0], key)) return length;
    }
    return -1;
}
$78ea1a223674cef0$exports = $78ea1a223674cef0$var$assocIndexOf;


/** Used for built-in method references. */ var $124d203b803468a7$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $124d203b803468a7$var$splice = $124d203b803468a7$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $124d203b803468a7$var$listCacheDelete(key) {
    var data = this.__data__, index = $78ea1a223674cef0$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $124d203b803468a7$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$124d203b803468a7$exports = $124d203b803468a7$var$listCacheDelete;


var $7eaf33e32e45666d$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7eaf33e32e45666d$var$listCacheGet(key) {
    var data = this.__data__, index = $78ea1a223674cef0$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$7eaf33e32e45666d$exports = $7eaf33e32e45666d$var$listCacheGet;


var $2b83bc923f133e97$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2b83bc923f133e97$var$listCacheHas(key) {
    return $78ea1a223674cef0$exports(this.__data__, key) > -1;
}
$2b83bc923f133e97$exports = $2b83bc923f133e97$var$listCacheHas;


var $b599190ccea27f77$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b599190ccea27f77$var$listCacheSet(key, value) {
    var data = this.__data__, index = $78ea1a223674cef0$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b599190ccea27f77$exports = $b599190ccea27f77$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $aedeb53a8407af13$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$aedeb53a8407af13$var$ListCache.prototype.clear = $c6c4a34139babbf2$exports;
$aedeb53a8407af13$var$ListCache.prototype["delete"] = $124d203b803468a7$exports;
$aedeb53a8407af13$var$ListCache.prototype.get = $7eaf33e32e45666d$exports;
$aedeb53a8407af13$var$ListCache.prototype.has = $2b83bc923f133e97$exports;
$aedeb53a8407af13$var$ListCache.prototype.set = $b599190ccea27f77$exports;
$aedeb53a8407af13$exports = $aedeb53a8407af13$var$ListCache;


var $3fb4a7657488a32d$exports = {};


var $hR1MC = parcelRequire("hR1MC");
/* Built-in method references that are verified to be native. */ var $3fb4a7657488a32d$var$Map = $7aee39973226e617$exports($hR1MC, "Map");
$3fb4a7657488a32d$exports = $3fb4a7657488a32d$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d594148ba4aec771$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $a804a19defb5beb6$exports,
        "map": new ($3fb4a7657488a32d$exports || $aedeb53a8407af13$exports),
        "string": new $a804a19defb5beb6$exports
    };
}
$d594148ba4aec771$exports = $d594148ba4aec771$var$mapCacheClear;


var $dcf4325d5a62012f$exports = {};
var $fe11e9011e832cdc$exports = {};
var $ea44e9b69ded3604$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $5F2Q2 = parcelRequire("5F2Q2");
function $ea44e9b69ded3604$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$ea44e9b69ded3604$exports = $ea44e9b69ded3604$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $fe11e9011e832cdc$var$getMapData(map, key) {
    var data = map.__data__;
    return $ea44e9b69ded3604$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$fe11e9011e832cdc$exports = $fe11e9011e832cdc$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dcf4325d5a62012f$var$mapCacheDelete(key) {
    var result = $fe11e9011e832cdc$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$dcf4325d5a62012f$exports = $dcf4325d5a62012f$var$mapCacheDelete;


var $056c4b4342a20c88$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $056c4b4342a20c88$var$mapCacheGet(key) {
    return $fe11e9011e832cdc$exports(this, key).get(key);
}
$056c4b4342a20c88$exports = $056c4b4342a20c88$var$mapCacheGet;


var $33844e151a179dcb$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $33844e151a179dcb$var$mapCacheHas(key) {
    return $fe11e9011e832cdc$exports(this, key).has(key);
}
$33844e151a179dcb$exports = $33844e151a179dcb$var$mapCacheHas;


var $76f60583498a08e3$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $76f60583498a08e3$var$mapCacheSet(key, value) {
    var data = $fe11e9011e832cdc$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$76f60583498a08e3$exports = $76f60583498a08e3$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $43eb751753d0c9bb$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$43eb751753d0c9bb$var$MapCache.prototype.clear = $d594148ba4aec771$exports;
$43eb751753d0c9bb$var$MapCache.prototype["delete"] = $dcf4325d5a62012f$exports;
$43eb751753d0c9bb$var$MapCache.prototype.get = $056c4b4342a20c88$exports;
$43eb751753d0c9bb$var$MapCache.prototype.has = $33844e151a179dcb$exports;
$43eb751753d0c9bb$var$MapCache.prototype.set = $76f60583498a08e3$exports;
$43eb751753d0c9bb$exports = $43eb751753d0c9bb$var$MapCache;


/** Error message constants. */ var $ca4770dca2739e7a$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ca4770dca2739e7a$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($ca4770dca2739e7a$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($ca4770dca2739e7a$var$memoize.Cache || $43eb751753d0c9bb$exports);
    return memoized;
}
// Expose `MapCache`.
$ca4770dca2739e7a$var$memoize.Cache = $43eb751753d0c9bb$exports;
$ca4770dca2739e7a$exports = $ca4770dca2739e7a$var$memoize;


/** Used as the maximum memoize cache size. */ var $e8ff4dbaf15c83cc$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e8ff4dbaf15c83cc$var$memoizeCapped(func) {
    var result = $ca4770dca2739e7a$exports(func, function(key) {
        if (cache.size === $e8ff4dbaf15c83cc$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$e8ff4dbaf15c83cc$exports = $e8ff4dbaf15c83cc$var$memoizeCapped;


/** Used to match property names within property paths. */ var $1df31ec9a0ef5dc8$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $1df31ec9a0ef5dc8$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $1df31ec9a0ef5dc8$var$stringToPath = $e8ff4dbaf15c83cc$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($1df31ec9a0ef5dc8$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($1df31ec9a0ef5dc8$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$1df31ec9a0ef5dc8$exports = $1df31ec9a0ef5dc8$var$stringToPath;


var $9e1d48e296702c3c$exports = {};
var $4c3e2fc9a0ebe14e$exports = {};

var $cfbabfc9c5f422ac$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $cfbabfc9c5f422ac$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$cfbabfc9c5f422ac$exports = $cfbabfc9c5f422ac$var$arrayMap;




/** Used as references for various `Number` constants. */ var $4c3e2fc9a0ebe14e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $4c3e2fc9a0ebe14e$var$symbolProto = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.prototype : undefined, $4c3e2fc9a0ebe14e$var$symbolToString = $4c3e2fc9a0ebe14e$var$symbolProto ? $4c3e2fc9a0ebe14e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $4c3e2fc9a0ebe14e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($47c989dafa9cb12c$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $cfbabfc9c5f422ac$exports(value, $4c3e2fc9a0ebe14e$var$baseToString) + "";
    if ($415d00fe2ecafb9b$exports(value)) return $4c3e2fc9a0ebe14e$var$symbolToString ? $4c3e2fc9a0ebe14e$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$4c3e2fc9a0ebe14e$var$INFINITY ? "-0" : result;
}
$4c3e2fc9a0ebe14e$exports = $4c3e2fc9a0ebe14e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9e1d48e296702c3c$var$toString(value) {
    return value == null ? "" : $4c3e2fc9a0ebe14e$exports(value);
}
$9e1d48e296702c3c$exports = $9e1d48e296702c3c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4b409bb948db762f$var$castPath(value, object) {
    if ($47c989dafa9cb12c$exports(value)) return value;
    return $2153a01d3db2c537$exports(value, object) ? [
        value
    ] : $1df31ec9a0ef5dc8$exports($9e1d48e296702c3c$exports(value));
}
$4b409bb948db762f$exports = $4b409bb948db762f$var$castPath;


var $cc9d3d3b1be5dc06$exports = {};

/** Used as references for various `Number` constants. */ var $cc9d3d3b1be5dc06$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $cc9d3d3b1be5dc06$var$toKey(value) {
    if (typeof value == "string" || $415d00fe2ecafb9b$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$cc9d3d3b1be5dc06$var$INFINITY ? "-0" : result;
}
$cc9d3d3b1be5dc06$exports = $cc9d3d3b1be5dc06$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b173e02f38b4f195$var$baseGet(object, path) {
    path = $4b409bb948db762f$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$cc9d3d3b1be5dc06$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$b173e02f38b4f195$exports = $b173e02f38b4f195$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $3fbdcc4ebb9f17dd$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $b173e02f38b4f195$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$3fbdcc4ebb9f17dd$exports = $3fbdcc4ebb9f17dd$var$get;


var $0a4bccc0b7692b4d$exports = {};
var $bcdcbfd00300cf1b$exports = {};
var $4335a0388c803e20$exports = {};

var $4335a0388c803e20$var$defineProperty = function() {
    try {
        var func = $7aee39973226e617$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$4335a0388c803e20$exports = $4335a0388c803e20$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bcdcbfd00300cf1b$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4335a0388c803e20$exports) $4335a0388c803e20$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$bcdcbfd00300cf1b$exports = $bcdcbfd00300cf1b$var$baseAssignValue;


var $21a60f9768977d15$exports = {};
var $06cb3fd62259741f$exports = {};
var $420db97c4f373ef3$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $420db97c4f373ef3$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$420db97c4f373ef3$exports = $420db97c4f373ef3$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $06cb3fd62259741f$var$baseFor = $420db97c4f373ef3$exports();
$06cb3fd62259741f$exports = $06cb3fd62259741f$var$baseFor;


var $47b1777f638b66e2$exports = {};
var $f828f854aa056480$exports = {};
var $af83b40bcee5c39f$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $af83b40bcee5c39f$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$af83b40bcee5c39f$exports = $af83b40bcee5c39f$var$baseTimes;


var $e2c917fa60f1eb65$exports = {};
var $b8ce4743ca9a59d9$exports = {};


/** `Object#toString` result references. */ var $b8ce4743ca9a59d9$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $b8ce4743ca9a59d9$var$baseIsArguments(value) {
    return $52801399e0aa2349$exports(value) && $11959fa193176326$exports(value) == $b8ce4743ca9a59d9$var$argsTag;
}
$b8ce4743ca9a59d9$exports = $b8ce4743ca9a59d9$var$baseIsArguments;



/** Used for built-in method references. */ var $e2c917fa60f1eb65$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2c917fa60f1eb65$var$hasOwnProperty = $e2c917fa60f1eb65$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e2c917fa60f1eb65$var$propertyIsEnumerable = $e2c917fa60f1eb65$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e2c917fa60f1eb65$var$isArguments = $b8ce4743ca9a59d9$exports(function() {
    return arguments;
}()) ? $b8ce4743ca9a59d9$exports : function isArguments(value) {
    return $52801399e0aa2349$exports(value) && $e2c917fa60f1eb65$var$hasOwnProperty.call(value, "callee") && !$e2c917fa60f1eb65$var$propertyIsEnumerable.call(value, "callee");
};
$e2c917fa60f1eb65$exports = $e2c917fa60f1eb65$var$isArguments;




var $6mwXD = parcelRequire("6mwXD");
var $10483e4084521d4e$exports = {};
/** Used as references for various `Number` constants. */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $10483e4084521d4e$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $10483e4084521d4e$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $10483e4084521d4e$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    length = length == null ? $10483e4084521d4e$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $10483e4084521d4e$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$10483e4084521d4e$exports = $10483e4084521d4e$var$isIndex;


var $9f89439f13f7838a$exports = {};
var $4c303bd5d59015f0$exports = {};

var $767e0d8513a710b1$exports = {};
/** Used as references for various `Number` constants. */ var $767e0d8513a710b1$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $767e0d8513a710b1$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $767e0d8513a710b1$var$MAX_SAFE_INTEGER;
}
$767e0d8513a710b1$exports = $767e0d8513a710b1$var$isLength;



/** `Object#toString` result references. */ var $4c303bd5d59015f0$var$argsTag = "[object Arguments]", $4c303bd5d59015f0$var$arrayTag = "[object Array]", $4c303bd5d59015f0$var$boolTag = "[object Boolean]", $4c303bd5d59015f0$var$dateTag = "[object Date]", $4c303bd5d59015f0$var$errorTag = "[object Error]", $4c303bd5d59015f0$var$funcTag = "[object Function]", $4c303bd5d59015f0$var$mapTag = "[object Map]", $4c303bd5d59015f0$var$numberTag = "[object Number]", $4c303bd5d59015f0$var$objectTag = "[object Object]", $4c303bd5d59015f0$var$regexpTag = "[object RegExp]", $4c303bd5d59015f0$var$setTag = "[object Set]", $4c303bd5d59015f0$var$stringTag = "[object String]", $4c303bd5d59015f0$var$weakMapTag = "[object WeakMap]";
var $4c303bd5d59015f0$var$arrayBufferTag = "[object ArrayBuffer]", $4c303bd5d59015f0$var$dataViewTag = "[object DataView]", $4c303bd5d59015f0$var$float32Tag = "[object Float32Array]", $4c303bd5d59015f0$var$float64Tag = "[object Float64Array]", $4c303bd5d59015f0$var$int8Tag = "[object Int8Array]", $4c303bd5d59015f0$var$int16Tag = "[object Int16Array]", $4c303bd5d59015f0$var$int32Tag = "[object Int32Array]", $4c303bd5d59015f0$var$uint8Tag = "[object Uint8Array]", $4c303bd5d59015f0$var$uint8ClampedTag = "[object Uint8ClampedArray]", $4c303bd5d59015f0$var$uint16Tag = "[object Uint16Array]", $4c303bd5d59015f0$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $4c303bd5d59015f0$var$typedArrayTags = {};
$4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$float32Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$float64Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$int8Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$int16Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$int32Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$uint8Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$uint8ClampedTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$uint16Tag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$uint32Tag] = true;
$4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$argsTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$arrayTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$arrayBufferTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$boolTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$dataViewTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$dateTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$errorTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$funcTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$mapTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$numberTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$objectTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$regexpTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$setTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$stringTag] = $4c303bd5d59015f0$var$typedArrayTags[$4c303bd5d59015f0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $4c303bd5d59015f0$var$baseIsTypedArray(value) {
    return $52801399e0aa2349$exports(value) && $767e0d8513a710b1$exports(value.length) && !!$4c303bd5d59015f0$var$typedArrayTags[$11959fa193176326$exports(value)];
}
$4c303bd5d59015f0$exports = $4c303bd5d59015f0$var$baseIsTypedArray;


var $cab5da4c4851d3a4$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $cab5da4c4851d3a4$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$cab5da4c4851d3a4$exports = $cab5da4c4851d3a4$var$baseUnary;



var $fnsCs = parcelRequire("fnsCs");
/* Node.js helper references. */ var $9f89439f13f7838a$var$nodeIsTypedArray = $fnsCs && $fnsCs.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $9f89439f13f7838a$var$isTypedArray = $9f89439f13f7838a$var$nodeIsTypedArray ? $cab5da4c4851d3a4$exports($9f89439f13f7838a$var$nodeIsTypedArray) : $4c303bd5d59015f0$exports;
$9f89439f13f7838a$exports = $9f89439f13f7838a$var$isTypedArray;


/** Used for built-in method references. */ var $f828f854aa056480$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f828f854aa056480$var$hasOwnProperty = $f828f854aa056480$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $f828f854aa056480$var$arrayLikeKeys(value, inherited) {
    var isArr = $47c989dafa9cb12c$exports(value), isArg = !isArr && $e2c917fa60f1eb65$exports(value), isBuff = !isArr && !isArg && $6mwXD(value), isType = !isArr && !isArg && !isBuff && $9f89439f13f7838a$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $af83b40bcee5c39f$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $f828f854aa056480$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $10483e4084521d4e$exports(key, length)))) result.push(key);
    return result;
}
$f828f854aa056480$exports = $f828f854aa056480$var$arrayLikeKeys;


var $ea9830a0fc975eb2$exports = {};
var $8c7fbfc207c28d0e$exports = {};
/** Used for built-in method references. */ var $8c7fbfc207c28d0e$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $8c7fbfc207c28d0e$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $8c7fbfc207c28d0e$var$objectProto;
    return value === proto;
}
$8c7fbfc207c28d0e$exports = $8c7fbfc207c28d0e$var$isPrototype;


var $fc4f62313e1f46fe$exports = {};
var $44ff051709084a83$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $44ff051709084a83$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$44ff051709084a83$exports = $44ff051709084a83$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $fc4f62313e1f46fe$var$nativeKeys = $44ff051709084a83$exports(Object.keys, Object);
$fc4f62313e1f46fe$exports = $fc4f62313e1f46fe$var$nativeKeys;


/** Used for built-in method references. */ var $ea9830a0fc975eb2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea9830a0fc975eb2$var$hasOwnProperty = $ea9830a0fc975eb2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ea9830a0fc975eb2$var$baseKeys(object) {
    if (!$8c7fbfc207c28d0e$exports(object)) return $fc4f62313e1f46fe$exports(object);
    var result = [];
    for(var key in Object(object))if ($ea9830a0fc975eb2$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$ea9830a0fc975eb2$exports = $ea9830a0fc975eb2$var$baseKeys;


var $5289076331bcb123$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5289076331bcb123$var$isArrayLike(value) {
    return value != null && $767e0d8513a710b1$exports(value.length) && !$c41587d84cc195ae$exports(value);
}
$5289076331bcb123$exports = $5289076331bcb123$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $47b1777f638b66e2$var$keys(object) {
    return $5289076331bcb123$exports(object) ? $f828f854aa056480$exports(object) : $ea9830a0fc975eb2$exports(object);
}
$47b1777f638b66e2$exports = $47b1777f638b66e2$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $21a60f9768977d15$var$baseForOwn(object, iteratee) {
    return object && $06cb3fd62259741f$exports(object, iteratee, $47b1777f638b66e2$exports);
}
$21a60f9768977d15$exports = $21a60f9768977d15$var$baseForOwn;


var $cdd534dd9466bb5b$exports = {};
var $e17c789ffc2ba2d9$exports = {};
var $11fcfc74b3999e74$exports = {};
var $d70e75b56b3c7200$exports = {};

var $26043276e57f8138$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $26043276e57f8138$var$stackClear() {
    this.__data__ = new $aedeb53a8407af13$exports;
    this.size = 0;
}
$26043276e57f8138$exports = $26043276e57f8138$var$stackClear;


var $b1f8d34448945d5f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b1f8d34448945d5f$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b1f8d34448945d5f$exports = $b1f8d34448945d5f$var$stackDelete;


var $38d7870c796b85a6$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $38d7870c796b85a6$var$stackGet(key) {
    return this.__data__.get(key);
}
$38d7870c796b85a6$exports = $38d7870c796b85a6$var$stackGet;


var $6b9ff2b478afb0b1$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6b9ff2b478afb0b1$var$stackHas(key) {
    return this.__data__.has(key);
}
$6b9ff2b478afb0b1$exports = $6b9ff2b478afb0b1$var$stackHas;


var $8ba85af09b864775$exports = {};



/** Used as the size to enable large array optimizations. */ var $8ba85af09b864775$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8ba85af09b864775$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $aedeb53a8407af13$exports) {
        var pairs = data.__data__;
        if (!$3fb4a7657488a32d$exports || pairs.length < $8ba85af09b864775$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $43eb751753d0c9bb$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$8ba85af09b864775$exports = $8ba85af09b864775$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d70e75b56b3c7200$var$Stack(entries) {
    var data = this.__data__ = new $aedeb53a8407af13$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d70e75b56b3c7200$var$Stack.prototype.clear = $26043276e57f8138$exports;
$d70e75b56b3c7200$var$Stack.prototype["delete"] = $b1f8d34448945d5f$exports;
$d70e75b56b3c7200$var$Stack.prototype.get = $38d7870c796b85a6$exports;
$d70e75b56b3c7200$var$Stack.prototype.has = $6b9ff2b478afb0b1$exports;
$d70e75b56b3c7200$var$Stack.prototype.set = $8ba85af09b864775$exports;
$d70e75b56b3c7200$exports = $d70e75b56b3c7200$var$Stack;


var $f30d524bb65eb5ca$exports = {};
var $8574b66e4502ffcd$exports = {};

var $bee67fa3600b0aee$exports = {};
var $475c4fc3318677f1$exports = {};

var $897b41b1aa2b5bf2$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $897b41b1aa2b5bf2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $897b41b1aa2b5bf2$var$setCacheAdd(value) {
    this.__data__.set(value, $897b41b1aa2b5bf2$var$HASH_UNDEFINED);
    return this;
}
$897b41b1aa2b5bf2$exports = $897b41b1aa2b5bf2$var$setCacheAdd;


var $69e6bf3465f1b066$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $69e6bf3465f1b066$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$69e6bf3465f1b066$exports = $69e6bf3465f1b066$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $475c4fc3318677f1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $43eb751753d0c9bb$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$475c4fc3318677f1$var$SetCache.prototype.add = $475c4fc3318677f1$var$SetCache.prototype.push = $897b41b1aa2b5bf2$exports;
$475c4fc3318677f1$var$SetCache.prototype.has = $69e6bf3465f1b066$exports;
$475c4fc3318677f1$exports = $475c4fc3318677f1$var$SetCache;


var $ab1085a994e017de$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $ab1085a994e017de$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$ab1085a994e017de$exports = $ab1085a994e017de$var$arraySome;


var $7b02f7855a570d47$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7b02f7855a570d47$var$cacheHas(cache, key) {
    return cache.has(key);
}
$7b02f7855a570d47$exports = $7b02f7855a570d47$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $bee67fa3600b0aee$var$COMPARE_PARTIAL_FLAG = 1, $bee67fa3600b0aee$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $bee67fa3600b0aee$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $bee67fa3600b0aee$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $bee67fa3600b0aee$var$COMPARE_UNORDERED_FLAG ? new $475c4fc3318677f1$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$ab1085a994e017de$exports(other, function(othValue, othIndex) {
                if (!$7b02f7855a570d47$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$bee67fa3600b0aee$exports = $bee67fa3600b0aee$var$equalArrays;


var $fa8cb226f10a82f3$exports = {};

var $754a4d36ccbc1987$exports = {};

var $hR1MC = parcelRequire("hR1MC");
/** Built-in value references. */ var $754a4d36ccbc1987$var$Uint8Array = $hR1MC.Uint8Array;
$754a4d36ccbc1987$exports = $754a4d36ccbc1987$var$Uint8Array;




var $6124b7ac7fc8da9b$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6124b7ac7fc8da9b$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$6124b7ac7fc8da9b$exports = $6124b7ac7fc8da9b$var$mapToArray;


var $94b7647c7d0ab370$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $94b7647c7d0ab370$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$94b7647c7d0ab370$exports = $94b7647c7d0ab370$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $fa8cb226f10a82f3$var$COMPARE_PARTIAL_FLAG = 1, $fa8cb226f10a82f3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $fa8cb226f10a82f3$var$boolTag = "[object Boolean]", $fa8cb226f10a82f3$var$dateTag = "[object Date]", $fa8cb226f10a82f3$var$errorTag = "[object Error]", $fa8cb226f10a82f3$var$mapTag = "[object Map]", $fa8cb226f10a82f3$var$numberTag = "[object Number]", $fa8cb226f10a82f3$var$regexpTag = "[object RegExp]", $fa8cb226f10a82f3$var$setTag = "[object Set]", $fa8cb226f10a82f3$var$stringTag = "[object String]", $fa8cb226f10a82f3$var$symbolTag = "[object Symbol]";
var $fa8cb226f10a82f3$var$arrayBufferTag = "[object ArrayBuffer]", $fa8cb226f10a82f3$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $fa8cb226f10a82f3$var$symbolProto = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.prototype : undefined, $fa8cb226f10a82f3$var$symbolValueOf = $fa8cb226f10a82f3$var$symbolProto ? $fa8cb226f10a82f3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fa8cb226f10a82f3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $fa8cb226f10a82f3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $fa8cb226f10a82f3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $754a4d36ccbc1987$exports(object), new $754a4d36ccbc1987$exports(other))) return false;
            return true;
        case $fa8cb226f10a82f3$var$boolTag:
        case $fa8cb226f10a82f3$var$dateTag:
        case $fa8cb226f10a82f3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $1055b4c9bc24e309$exports(+object, +other);
        case $fa8cb226f10a82f3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $fa8cb226f10a82f3$var$regexpTag:
        case $fa8cb226f10a82f3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $fa8cb226f10a82f3$var$mapTag:
            var convert = $6124b7ac7fc8da9b$exports;
        case $fa8cb226f10a82f3$var$setTag:
            var isPartial = bitmask & $fa8cb226f10a82f3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $94b7647c7d0ab370$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $fa8cb226f10a82f3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $bee67fa3600b0aee$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $fa8cb226f10a82f3$var$symbolTag:
            if ($fa8cb226f10a82f3$var$symbolValueOf) return $fa8cb226f10a82f3$var$symbolValueOf.call(object) == $fa8cb226f10a82f3$var$symbolValueOf.call(other);
    }
    return false;
}
$fa8cb226f10a82f3$exports = $fa8cb226f10a82f3$var$equalByTag;


var $df0c6108b380e678$exports = {};
var $d74e3fe9ee8cee52$exports = {};
var $856a28b7c084fc39$exports = {};
var $e1a5ed0e8bfb914a$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $e1a5ed0e8bfb914a$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$e1a5ed0e8bfb914a$exports = $e1a5ed0e8bfb914a$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $856a28b7c084fc39$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $47c989dafa9cb12c$exports(object) ? result : $e1a5ed0e8bfb914a$exports(result, symbolsFunc(object));
}
$856a28b7c084fc39$exports = $856a28b7c084fc39$var$baseGetAllKeys;


var $cac7f21bc1f37396$exports = {};
var $979004aca8cfebca$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $979004aca8cfebca$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$979004aca8cfebca$exports = $979004aca8cfebca$var$arrayFilter;


var $39d96653d132c0cd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $39d96653d132c0cd$var$stubArray() {
    return [];
}
$39d96653d132c0cd$exports = $39d96653d132c0cd$var$stubArray;


/** Used for built-in method references. */ var $cac7f21bc1f37396$var$objectProto = Object.prototype;
/** Built-in value references. */ var $cac7f21bc1f37396$var$propertyIsEnumerable = $cac7f21bc1f37396$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cac7f21bc1f37396$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cac7f21bc1f37396$var$getSymbols = !$cac7f21bc1f37396$var$nativeGetSymbols ? $39d96653d132c0cd$exports : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return $979004aca8cfebca$exports($cac7f21bc1f37396$var$nativeGetSymbols(object), function(symbol) {
        return $cac7f21bc1f37396$var$propertyIsEnumerable.call(object, symbol);
    });
};
$cac7f21bc1f37396$exports = $cac7f21bc1f37396$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d74e3fe9ee8cee52$var$getAllKeys(object) {
    return $856a28b7c084fc39$exports(object, $47b1777f638b66e2$exports, $cac7f21bc1f37396$exports);
}
$d74e3fe9ee8cee52$exports = $d74e3fe9ee8cee52$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $df0c6108b380e678$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $df0c6108b380e678$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $df0c6108b380e678$var$hasOwnProperty = $df0c6108b380e678$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $df0c6108b380e678$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $df0c6108b380e678$var$COMPARE_PARTIAL_FLAG, objProps = $d74e3fe9ee8cee52$exports(object), objLength = objProps.length, othProps = $d74e3fe9ee8cee52$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $df0c6108b380e678$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$df0c6108b380e678$exports = $df0c6108b380e678$var$equalObjects;


var $50a3080f6298a726$exports = {};
var $f9c3e56188f68c46$exports = {};


var $hR1MC = parcelRequire("hR1MC");
/* Built-in method references that are verified to be native. */ var $f9c3e56188f68c46$var$DataView = $7aee39973226e617$exports($hR1MC, "DataView");
$f9c3e56188f68c46$exports = $f9c3e56188f68c46$var$DataView;



var $57eea72821acd448$exports = {};


var $hR1MC = parcelRequire("hR1MC");
/* Built-in method references that are verified to be native. */ var $57eea72821acd448$var$Promise = $7aee39973226e617$exports($hR1MC, "Promise");
$57eea72821acd448$exports = $57eea72821acd448$var$Promise;


var $3714e3a2ba543073$exports = {};


var $hR1MC = parcelRequire("hR1MC");
/* Built-in method references that are verified to be native. */ var $3714e3a2ba543073$var$Set = $7aee39973226e617$exports($hR1MC, "Set");
$3714e3a2ba543073$exports = $3714e3a2ba543073$var$Set;


var $2d22be70a37677f2$exports = {};


var $hR1MC = parcelRequire("hR1MC");
/* Built-in method references that are verified to be native. */ var $2d22be70a37677f2$var$WeakMap = $7aee39973226e617$exports($hR1MC, "WeakMap");
$2d22be70a37677f2$exports = $2d22be70a37677f2$var$WeakMap;




/** `Object#toString` result references. */ var $50a3080f6298a726$var$mapTag = "[object Map]", $50a3080f6298a726$var$objectTag = "[object Object]", $50a3080f6298a726$var$promiseTag = "[object Promise]", $50a3080f6298a726$var$setTag = "[object Set]", $50a3080f6298a726$var$weakMapTag = "[object WeakMap]";
var $50a3080f6298a726$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $50a3080f6298a726$var$dataViewCtorString = $c7f8c73d291ae8b1$exports($f9c3e56188f68c46$exports), $50a3080f6298a726$var$mapCtorString = $c7f8c73d291ae8b1$exports($3fb4a7657488a32d$exports), $50a3080f6298a726$var$promiseCtorString = $c7f8c73d291ae8b1$exports($57eea72821acd448$exports), $50a3080f6298a726$var$setCtorString = $c7f8c73d291ae8b1$exports($3714e3a2ba543073$exports), $50a3080f6298a726$var$weakMapCtorString = $c7f8c73d291ae8b1$exports($2d22be70a37677f2$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $50a3080f6298a726$var$getTag = $11959fa193176326$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($f9c3e56188f68c46$exports && $50a3080f6298a726$var$getTag(new $f9c3e56188f68c46$exports(new ArrayBuffer(1))) != $50a3080f6298a726$var$dataViewTag || $3fb4a7657488a32d$exports && $50a3080f6298a726$var$getTag(new $3fb4a7657488a32d$exports) != $50a3080f6298a726$var$mapTag || $57eea72821acd448$exports && $50a3080f6298a726$var$getTag($57eea72821acd448$exports.resolve()) != $50a3080f6298a726$var$promiseTag || $3714e3a2ba543073$exports && $50a3080f6298a726$var$getTag(new $3714e3a2ba543073$exports) != $50a3080f6298a726$var$setTag || $2d22be70a37677f2$exports && $50a3080f6298a726$var$getTag(new $2d22be70a37677f2$exports) != $50a3080f6298a726$var$weakMapTag) $50a3080f6298a726$var$getTag = function getTag(value) {
    var result = $11959fa193176326$exports(value), Ctor = result == $50a3080f6298a726$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $c7f8c73d291ae8b1$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $50a3080f6298a726$var$dataViewCtorString:
            return $50a3080f6298a726$var$dataViewTag;
        case $50a3080f6298a726$var$mapCtorString:
            return $50a3080f6298a726$var$mapTag;
        case $50a3080f6298a726$var$promiseCtorString:
            return $50a3080f6298a726$var$promiseTag;
        case $50a3080f6298a726$var$setCtorString:
            return $50a3080f6298a726$var$setTag;
        case $50a3080f6298a726$var$weakMapCtorString:
            return $50a3080f6298a726$var$weakMapTag;
    }
    return result;
};
$50a3080f6298a726$exports = $50a3080f6298a726$var$getTag;




var $6mwXD = parcelRequire("6mwXD");

/** Used to compose bitmasks for value comparisons. */ var $8574b66e4502ffcd$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $8574b66e4502ffcd$var$argsTag = "[object Arguments]", $8574b66e4502ffcd$var$arrayTag = "[object Array]", $8574b66e4502ffcd$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $8574b66e4502ffcd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8574b66e4502ffcd$var$hasOwnProperty = $8574b66e4502ffcd$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8574b66e4502ffcd$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $47c989dafa9cb12c$exports(object), othIsArr = $47c989dafa9cb12c$exports(other), objTag = objIsArr ? $8574b66e4502ffcd$var$arrayTag : $50a3080f6298a726$exports(object), othTag = othIsArr ? $8574b66e4502ffcd$var$arrayTag : $50a3080f6298a726$exports(other);
    objTag = objTag == $8574b66e4502ffcd$var$argsTag ? $8574b66e4502ffcd$var$objectTag : objTag;
    othTag = othTag == $8574b66e4502ffcd$var$argsTag ? $8574b66e4502ffcd$var$objectTag : othTag;
    var objIsObj = objTag == $8574b66e4502ffcd$var$objectTag, othIsObj = othTag == $8574b66e4502ffcd$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $6mwXD(object)) {
        if (!$6mwXD(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $d70e75b56b3c7200$exports);
        return objIsArr || $9f89439f13f7838a$exports(object) ? $bee67fa3600b0aee$exports(object, other, bitmask, customizer, equalFunc, stack) : $fa8cb226f10a82f3$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $8574b66e4502ffcd$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $8574b66e4502ffcd$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $8574b66e4502ffcd$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $d70e75b56b3c7200$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $d70e75b56b3c7200$exports);
    return $df0c6108b380e678$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$8574b66e4502ffcd$exports = $8574b66e4502ffcd$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f30d524bb65eb5ca$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$52801399e0aa2349$exports(value) && !$52801399e0aa2349$exports(other)) return value !== value && other !== other;
    return $8574b66e4502ffcd$exports(value, other, bitmask, customizer, $f30d524bb65eb5ca$var$baseIsEqual, stack);
}
$f30d524bb65eb5ca$exports = $f30d524bb65eb5ca$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $11fcfc74b3999e74$var$COMPARE_PARTIAL_FLAG = 1, $11fcfc74b3999e74$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $11fcfc74b3999e74$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $d70e75b56b3c7200$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f30d524bb65eb5ca$exports(srcValue, objValue, $11fcfc74b3999e74$var$COMPARE_PARTIAL_FLAG | $11fcfc74b3999e74$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$11fcfc74b3999e74$exports = $11fcfc74b3999e74$var$baseIsMatch;


var $0e9ad563f54c40a9$exports = {};
var $1fab5ae54574da07$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1fab5ae54574da07$var$isStrictComparable(value) {
    return value === value && !$cfc6c88de6d47f6e$exports(value);
}
$1fab5ae54574da07$exports = $1fab5ae54574da07$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $0e9ad563f54c40a9$var$getMatchData(object) {
    var result = $47b1777f638b66e2$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1fab5ae54574da07$exports(value)
        ];
    }
    return result;
}
$0e9ad563f54c40a9$exports = $0e9ad563f54c40a9$var$getMatchData;


var $5df811e29bdd2e55$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5df811e29bdd2e55$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$5df811e29bdd2e55$exports = $5df811e29bdd2e55$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e17c789ffc2ba2d9$var$baseMatches(source) {
    var matchData = $0e9ad563f54c40a9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $5df811e29bdd2e55$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $11fcfc74b3999e74$exports(object, source, matchData);
    };
}
$e17c789ffc2ba2d9$exports = $e17c789ffc2ba2d9$var$baseMatches;


var $bc1f6fee557c9c39$exports = {};


var $f651d10aaa1c115d$exports = {};
var $d6bb62773a435ded$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d6bb62773a435ded$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d6bb62773a435ded$exports = $d6bb62773a435ded$var$baseHasIn;


var $b73407a0ec4865dd$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b73407a0ec4865dd$var$hasPath(object, path, hasFunc) {
    path = $4b409bb948db762f$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $cc9d3d3b1be5dc06$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $767e0d8513a710b1$exports(length) && $10483e4084521d4e$exports(key, length) && ($47c989dafa9cb12c$exports(object) || $e2c917fa60f1eb65$exports(object));
}
$b73407a0ec4865dd$exports = $b73407a0ec4865dd$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $f651d10aaa1c115d$var$hasIn(object, path) {
    return object != null && $b73407a0ec4865dd$exports(object, path, $d6bb62773a435ded$exports);
}
$f651d10aaa1c115d$exports = $f651d10aaa1c115d$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $bc1f6fee557c9c39$var$COMPARE_PARTIAL_FLAG = 1, $bc1f6fee557c9c39$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $bc1f6fee557c9c39$var$baseMatchesProperty(path, srcValue) {
    if ($2153a01d3db2c537$exports(path) && $1fab5ae54574da07$exports(srcValue)) return $5df811e29bdd2e55$exports($cc9d3d3b1be5dc06$exports(path), srcValue);
    return function(object) {
        var objValue = $3fbdcc4ebb9f17dd$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $f651d10aaa1c115d$exports(object, path) : $f30d524bb65eb5ca$exports(srcValue, objValue, $bc1f6fee557c9c39$var$COMPARE_PARTIAL_FLAG | $bc1f6fee557c9c39$var$COMPARE_UNORDERED_FLAG);
    };
}
$bc1f6fee557c9c39$exports = $bc1f6fee557c9c39$var$baseMatchesProperty;


var $a96a5893f64584a3$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a96a5893f64584a3$var$identity(value) {
    return value;
}
$a96a5893f64584a3$exports = $a96a5893f64584a3$var$identity;



var $886bd647d4b95cd3$exports = {};
var $6d88fd066bb5ae0a$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6d88fd066bb5ae0a$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$6d88fd066bb5ae0a$exports = $6d88fd066bb5ae0a$var$baseProperty;


var $f43242e8becb88e0$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $f43242e8becb88e0$var$basePropertyDeep(path) {
    return function(object) {
        return $b173e02f38b4f195$exports(object, path);
    };
}
$f43242e8becb88e0$exports = $f43242e8becb88e0$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $886bd647d4b95cd3$var$property(path) {
    return $2153a01d3db2c537$exports(path) ? $6d88fd066bb5ae0a$exports($cc9d3d3b1be5dc06$exports(path)) : $f43242e8becb88e0$exports(path);
}
$886bd647d4b95cd3$exports = $886bd647d4b95cd3$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $cdd534dd9466bb5b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $a96a5893f64584a3$exports;
    if (typeof value == "object") return $47c989dafa9cb12c$exports(value) ? $bc1f6fee557c9c39$exports(value[0], value[1]) : $e17c789ffc2ba2d9$exports(value);
    return $886bd647d4b95cd3$exports(value);
}
$cdd534dd9466bb5b$exports = $cdd534dd9466bb5b$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $0a4bccc0b7692b4d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $cdd534dd9466bb5b$exports(iteratee, 3);
    $21a60f9768977d15$exports(object, function(value, key, object) {
        $bcdcbfd00300cf1b$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$0a4bccc0b7692b4d$exports = $0a4bccc0b7692b4d$var$mapValues;



var $4CEbD = parcelRequire("4CEbD");

var $2MVSR = parcelRequire("2MVSR");

var $h9dQc = parcelRequire("h9dQc");
var $dd253ebacef58316$var$escapeMatch = /[.[\]]/;
var $dd253ebacef58316$var$escapeRegex = /"/g;
/** @internal */ function $dd253ebacef58316$var$escape(string) {
    return string === "" || $dd253ebacef58316$var$escapeMatch.test(string) ? '["'.concat(string.replace($dd253ebacef58316$var$escapeRegex, '\\"'), '"]') : string;
}
/** @internal */ function $dd253ebacef58316$var$escapeToJoin(string, index) {
    var escaped = $dd253ebacef58316$var$escape(string);
    return escaped === string ? index ? ".".concat(string) : string : escaped;
}
var $dd253ebacef58316$var$unescapeMatch = /^\["(.*)"]$/;
var $dd253ebacef58316$var$unescapeRegex = /\\"/g;
/** @internal */ function $dd253ebacef58316$var$unescape(string) {
    var match = $dd253ebacef58316$var$unescapeMatch.exec(string);
    return match ? match[1].replace($dd253ebacef58316$var$unescapeRegex, '"') : string;
}
// This regular expression splits the string into three parts:
//   `prefix` is a dotted name, e.g., `object.nested.2.field` at the
//            front (hence prefix). It covers most standard usecases.
//   `subscript` is a `["..."]` subscript after the prefix. The content
//               within should be escaped by the user, e.g., `["\\""]`.
//   `rest` is anything following the subscript. The leading dot (`.`)
//          is stripped (`.a` -> `a`) if there is one. It is empty if
//          `subscript` is empty.
//
// All three parts can be empty!
var $dd253ebacef58316$var$nameRegex = /^([^.[\]]*(?:\.[^.[\]]+)*)(?:\.?(\["(?:(?:[^"]|\\")*?[^\\])?"])\.?(.*))?$/;
// eslint-disable-next-line complexity -- The complexity of it _is_ high.
function $dd253ebacef58316$var$joinNameImpl() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    // If the first argument is `null`, then we return an escaped array of parts.
    // Otherwise, an escaped string is returned. As we may modify `parts` later,
    // this has to be checked now.
    var returnAsParts = parts[0] === null;
    // Result parts (not escaped).
    var name = [];
    // This cannot be transformed into a `.forEach` loop and the length of it
    // can not be memoized, as we modify `parts` as we go for performance reasons.
    for(var index = 0; index !== parts.length; ++index){
        var part = parts[index];
        // All falsy values except `0` are ignored.
        if (part || part === 0) {
            if (typeof part === "string") {
                // Strings are matched against the regular expression that split it into
                // three parts (all can be empty):
                //   `prefix` is a dotted name, e.g., `object.nested.2.field` at the
                //            front (hence prefix). It covers most standard usecases.
                //   `subscript` is a `["..."]` subscript after the prefix. The content
                //               within should be escaped by the user, e.g., `["\\""]`.
                //   `rest` is anything following the subscript. The leading dot (`.`)
                //          is stripped (`.a` -> `a`) if there is one. It is empty if
                //          `subscript` is empty.
                var match = $dd253ebacef58316$var$nameRegex.exec(part);
                if (match) {
                    var _match = (0, $2MVSR._)(match, 4), prefix = _match[1], subscript = _match[2], rest = _match[3];
                    if (prefix) {
                        var _name;
                        // We could always `.split` the `prefix`, but it results in a severe
                        // performance hit.
                        if (prefix.includes(".")) (_name = name).push.apply(_name, (0, $h9dQc._)(prefix.split(".")));
                        else name.push(prefix);
                    }
                    if (subscript) {
                        // We could adjust the `nameRegex` to skip brackets and `unescape`
                        // to skip this check, but then every other call (e.g., a one in the
                        // bridge) would have to know that. The performance is not affected
                        // much by it anyway.
                        name.push($dd253ebacef58316$var$unescape(subscript));
                        // The `rest` is inlined in place as it is a single string.
                        if (rest) parts[index--] = rest;
                    }
                } else // If a string is not matching the pattern, we leave it as it is. We
                // may want to raise a warning here as it should not happen. Most
                // likely it is something that should have been escaped (e.g., `[`).
                name.push(part);
            } else if (Array.isArray(part)) // Arrays are flattened in place but only if needed, i.e., they are not
            // empty. We calculate the length of the overlapping parts to reuse the
            // `parts` array as much as possible:
            // [[], ...]              -> [[], ...]       // No change.
            // [['a'], ...]           -> ['a', ...]      // Inline in place.
            // [['a', 'b'], ...]      -> ['a', 'b', ...] // Inline with extension.
            // ['a', ['b'], ...]      -> ['a', 'b', ...] // Inline in place.
            // ['a', ['b', 'c'], ...] -> ['b', 'c', ...] // Inline with overlap.
            {
                if (part.length) {
                    var _parts;
                    var length = Math.min(index + 1, part.length);
                    index -= length;
                    (_parts = parts).splice.apply(_parts, [
                        index + 1,
                        length
                    ].concat((0, $h9dQc._)(part)));
                }
            } else // Other values -- most likely numbers and `true` -- are stringified.
            name.push("" + part);
        }
    }
    // We cannot escape the parts earlier as `escapeToJoin` depends on the index.
    return returnAsParts ? name.map($dd253ebacef58316$var$escape) : name.map($dd253ebacef58316$var$escapeToJoin).join("");
}
var $dd253ebacef58316$export$c8987bb64f9a8b89 = Object.assign($dd253ebacef58316$var$joinNameImpl, {
    escape: $dd253ebacef58316$var$escape,
    unescape: $dd253ebacef58316$var$unescape
});



function $c65a34cb0f24f11f$var$propagate(prop, schema, state, fallback) {
    var forcedFallbackInProp = prop === true || prop === undefined;
    var forcedFallbackInSchema = schema === true || schema === undefined;
    var schemaValue = forcedFallbackInSchema ? fallback : schema;
    var value = prop === "" || prop === false || prop === null || forcedFallbackInProp && (forcedFallbackInSchema || !state) ? "" : forcedFallbackInProp ? schemaValue : prop;
    return [
        value,
        schemaValue
    ];
}
function $c65a34cb0f24f11f$export$294aa081a6c6f55d(fieldName, props, options) {
    var _a;
    var context = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)();
    var name = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)((options === null || options === void 0 ? void 0 : options.absoluteName) ? "" : context.name, fieldName);
    var field = context.schema.getField(name);
    var usesInitialValue = (options === null || options === void 0 ? void 0 : options.initialValue) !== false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var onChangeCalled = usesInitialValue ? (0, $4CEbD.useRef)(false) : {
        current: false
    };
    var state = (0, (/*@__PURE__*/$parcel$interopDefault($0a4bccc0b7692b4d$exports)))(context.state, function(prev, key) {
        var next = props[key];
        return next !== null && next !== undefined ? !!next : prev;
    });
    var changed = !!(0, (/*@__PURE__*/$parcel$interopDefault($3fbdcc4ebb9f17dd$exports)))(context.changedMap, name);
    var error = context.schema.getError(name, context.error);
    var errorMessage = context.schema.getErrorMessage(name, context.error);
    var fieldType = context.schema.getType(name);
    var fields = context.schema.getSubfields(name);
    var schemaProps = context.schema.getProps(name, Object.assign(Object.assign({}, state), props));
    var _propagate = (0, $2MVSR._)($c65a34cb0f24f11f$var$propagate(props.label, schemaProps.label, state.label, ""), 2), label = _propagate[0], labelFallback = _propagate[1];
    var _propagate1 = (0, $2MVSR._)($c65a34cb0f24f11f$var$propagate(props.placeholder, schemaProps.placeholder, state.placeholder, label || labelFallback), 1), placeholder = _propagate1[0];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var id = (0, $4CEbD.useMemo)(function() {
        return context.randomId();
    }, []);
    var onChange = (0, $4CEbD.useCallback)(function(value) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : name;
        onChangeCalled.current = true;
        context.onChange(key, value);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        context.onChange,
        name
    ]);
    var valueFromModel = (0, (/*@__PURE__*/$parcel$interopDefault($3fbdcc4ebb9f17dd$exports)))(context.model, name);
    var initialValue;
    var value = (_a = props.value) !== null && _a !== void 0 ? _a : valueFromModel;
    if (usesInitialValue) {
        if (!onChangeCalled.current) {
            if (value === undefined) {
                value = context.schema.getInitialValue(name, props);
                initialValue = value;
            } else if (props.value !== undefined && props.value !== valueFromModel) initialValue = props.value;
        }
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4CEbD.useEffect)(function() {
            var _a;
            var required = (_a = props.required) !== null && _a !== void 0 ? _a : schemaProps.required;
            if (required && initialValue !== undefined) onChange(initialValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
    var fieldProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        id: id
    }, state), {
        changed: changed,
        error: error,
        errorMessage: errorMessage,
        field: field,
        fieldType: fieldType,
        fields: fields,
        onChange: onChange,
        value: value
    }), schemaProps), props), {
        label: label,
        name: name,
        // TODO: Should we assert `typeof placeholder === 'string'`?
        placeholder: placeholder
    });
    return [
        fieldProps,
        context
    ];
}


function $7def494d664dfead$export$67be0aecf20e0922(defaultComponentDetector) {
    var AutoField = function AutoField(rawProps) {
        var _a, _b;
        var _useField = (0, $2MVSR._)((0, $c65a34cb0f24f11f$export$294aa081a6c6f55d)(rawProps.name, rawProps), 2), props = _useField[0], uniforms = _useField[1];
        var componentDetector = (0, $4CEbD.useContext)(context);
        var component = (_a = props.component) !== null && _a !== void 0 ? _a : componentDetector(props, uniforms);
        (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(component, "AutoField received no component for: %s", props.name);
        return "options" in component && ((_b = component.options) === null || _b === void 0 ? void 0 : _b.kind) === "leaf" ? (0, $4CEbD.createElement)(component.Component, props) : (0, $4CEbD.createElement)(component, rawProps);
    };
    var context = (0, $4CEbD.createContext)(defaultComponentDetector);
    return Object.assign(AutoField, {
        componentDetectorContext: context,
        defaultComponentDetector: defaultComponentDetector
    });
}



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

var $2MVSR = parcelRequire("2MVSR");


var $4CEbD = parcelRequire("4CEbD");


function $cdb4333bf8d9e8f7$var$getNextContext(context, props, options) {
    // Leaf components by definition do not affect the context. `AutoField` will
    // skip most of them anyway, but if rendered directly we have to do it here.
    // An example in the core theme are the `List*Field`s.
    if ((options === null || options === void 0 ? void 0 : options.kind) === "leaf") return context;
    var changesName = props.name !== "";
    var changesState = Object.keys(context.state).some(function(key) {
        var next = props[key];
        return next !== null && next !== undefined;
    });
    // There are no other ways of affecting the context.
    if (!changesName && !changesState) return context;
    var nextContext = Object.assign({}, context);
    if (changesName) nextContext.name = nextContext.name.concat(props.name);
    if (changesState) nextContext.state = (0, (/*@__PURE__*/$parcel$interopDefault($0a4bccc0b7692b4d$exports)))(nextContext.state, function(prev, key) {
        var next = props[key];
        return next !== null && next !== undefined ? !!next : prev;
    });
    return nextContext;
}
function $cdb4333bf8d9e8f7$export$2fe409f101064a7f(Component, options) {
    var Field = function Field(props) {
        var _useField = (0, $2MVSR._)((0, $c65a34cb0f24f11f$export$294aa081a6c6f55d)(props.name, props, options), 2), fieldProps = _useField[0], context = _useField[1];
        var nextContext = $cdb4333bf8d9e8f7$var$getNextContext(context, props, options);
        var body = (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Component, Object.assign({}, props, fieldProps));
        // If the context has not changed, then don't render the `Provider`. It's
        // possible that it will change at some point, but it's extremely rare, as
        // either `name` or one of the "state props" has to change.
        if (context === nextContext) return body;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $820ac02689a8eddd$export$a078c61943f9dbbe).Provider, {
            children: body,
            value: nextContext
        });
    };
    Field.displayName = "".concat(Component.displayName || Component.name, "Field");
    return Object.assign(Field, {
        Component: Component,
        options: options
    });
}

var $31d512228acba053$var$registered = [];
var $31d512228acba053$var$registeredCache = new Set();
var $31d512228acba053$export$457c3d6518dd4c6f = Object.assign(function filterDOMProps(props) {
    var filteredProps = Object.assign({}, props);
    for(var prop in props)if ($31d512228acba053$var$registeredCache.has(prop)) delete filteredProps[prop];
    return filteredProps;
}, {
    register: function() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
            props[_key] = arguments[_key];
        }
        props.forEach(function(prop) {
            if (!$31d512228acba053$var$registeredCache.has(prop)) {
                $31d512228acba053$var$registered.push(prop);
                $31d512228acba053$var$registeredCache.add(prop);
            }
        });
        $31d512228acba053$var$registered.sort();
    },
    registered: $31d512228acba053$var$registered
});
$31d512228acba053$export$457c3d6518dd4c6f.register(// These props are provided by useField directly.
"changed", "error", "errorMessage", "field", "fieldType", "fields", "initialCount", "name", "onChange", "transform", "value", // These props are provided by useField through context.state.
"disabled", "label", "placeholder", "showInlineError", // This is used by AutoField.
"component", // These is used by AutoField and bridges.
"allowedValues");


function $87325d83fb2bdc07$var$Bool(_a) {
    var disabled = _a.disabled, id = _a.id, inputRef = _a.inputRef, label = _a.label, name = _a.name, onChange = _a.onChange, readOnly = _a.readOnly, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "readOnly",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        checked: value || false,
        disabled: disabled,
        id: id,
        name: name,
        onChange: function() {
            return !disabled && !readOnly && onChange(!value);
        },
        ref: inputRef,
        type: "checkbox"
    }), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        htmlFor: id
    }, label));
}
var $87325d83fb2bdc07$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($87325d83fb2bdc07$var$Bool, {
    kind: "leaf"
});



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

/* istanbul ignore next */ var $c7c69cc300e5d05a$var$DateConstructor = (typeof $parcel$global === "object" ? $parcel$global : window).Date;
var $c7c69cc300e5d05a$var$dateFormat = function(value) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "datetime-local";
    return value === null || value === void 0 ? void 0 : value.toISOString().slice(0, type === "datetime-local" ? -8 : -14);
};
function $c7c69cc300e5d05a$var$Date(_a) {
    var _b;
    var disabled = _a.disabled, id = _a.id, inputRef = _a.inputRef, label = _a.label, max = _a.max, min = _a.min, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, value = _a.value, _a_type = _a.type, type = _a_type === void 0 ? "datetime-local" : _a_type, props = (0, $nLPsB.__rest)(_a, [
        "disabled",
        "id",
        "inputRef",
        "label",
        "max",
        "min",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "value",
        "type"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        disabled: disabled,
        id: id,
        max: $c7c69cc300e5d05a$var$dateFormat(max),
        min: $c7c69cc300e5d05a$var$dateFormat(min),
        name: name,
        onChange: function(event) {
            var date = new $c7c69cc300e5d05a$var$DateConstructor(event.target.valueAsNumber);
            if (date.getFullYear() < 10000) onChange(date);
            else if (isNaN(event.target.valueAsNumber)) onChange(undefined);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: (_b = $c7c69cc300e5d05a$var$dateFormat(value, type)) !== null && _b !== void 0 ? _b : ""
    }));
}
var $c7c69cc300e5d05a$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($c7c69cc300e5d05a$var$Date, {
    kind: "leaf"
});



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");


var $nLPsB = parcelRequire("nLPsB");
var $97fd0f9b469320ff$exports = {};
var $aecc7c84d399924b$exports = {};

var $3ec5b32623c0c484$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $3ec5b32623c0c484$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$3ec5b32623c0c484$exports = $3ec5b32623c0c484$var$arrayEach;


var $a0c67fe3cfdd6da2$exports = {};


/** Used for built-in method references. */ var $a0c67fe3cfdd6da2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a0c67fe3cfdd6da2$var$hasOwnProperty = $a0c67fe3cfdd6da2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a0c67fe3cfdd6da2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($a0c67fe3cfdd6da2$var$hasOwnProperty.call(object, key) && $1055b4c9bc24e309$exports(objValue, value)) || value === undefined && !(key in object)) $bcdcbfd00300cf1b$exports(object, key, value);
}
$a0c67fe3cfdd6da2$exports = $a0c67fe3cfdd6da2$var$assignValue;


var $3fd2f412d84c896b$exports = {};
var $81901f18667e59d2$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $81901f18667e59d2$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $bcdcbfd00300cf1b$exports(object, key, newValue);
        else $a0c67fe3cfdd6da2$exports(object, key, newValue);
    }
    return object;
}
$81901f18667e59d2$exports = $81901f18667e59d2$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3fd2f412d84c896b$var$baseAssign(object, source) {
    return object && $81901f18667e59d2$exports(source, $47b1777f638b66e2$exports(source), object);
}
$3fd2f412d84c896b$exports = $3fd2f412d84c896b$var$baseAssign;


var $a7370e901c25f2fc$exports = {};

var $b22c556485651513$exports = {};

var $fb1dfd641780d056$exports = {};


var $5e96966f5fca9b43$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5e96966f5fca9b43$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$5e96966f5fca9b43$exports = $5e96966f5fca9b43$var$nativeKeysIn;


/** Used for built-in method references. */ var $fb1dfd641780d056$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1dfd641780d056$var$hasOwnProperty = $fb1dfd641780d056$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fb1dfd641780d056$var$baseKeysIn(object) {
    if (!$cfc6c88de6d47f6e$exports(object)) return $5e96966f5fca9b43$exports(object);
    var isProto = $8c7fbfc207c28d0e$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$fb1dfd641780d056$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$fb1dfd641780d056$exports = $fb1dfd641780d056$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b22c556485651513$var$keysIn(object) {
    return $5289076331bcb123$exports(object) ? $f828f854aa056480$exports(object, true) : $fb1dfd641780d056$exports(object);
}
$b22c556485651513$exports = $b22c556485651513$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a7370e901c25f2fc$var$baseAssignIn(object, source) {
    return object && $81901f18667e59d2$exports(source, $b22c556485651513$exports(source), object);
}
$a7370e901c25f2fc$exports = $a7370e901c25f2fc$var$baseAssignIn;



var $5c1eQ = parcelRequire("5c1eQ");
var $824dbd451a5706c8$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $824dbd451a5706c8$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$824dbd451a5706c8$exports = $824dbd451a5706c8$var$copyArray;


var $cdfe6f529dcbabc6$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $cdfe6f529dcbabc6$var$copySymbols(source, object) {
    return $81901f18667e59d2$exports(source, $cac7f21bc1f37396$exports(source), object);
}
$cdfe6f529dcbabc6$exports = $cdfe6f529dcbabc6$var$copySymbols;


var $82ea92b66ff30d81$exports = {};

var $062e5c11ed7840c8$exports = {};

var $f23977e513bc5bb8$exports = {};

/** Built-in value references. */ var $f23977e513bc5bb8$var$getPrototype = $44ff051709084a83$exports(Object.getPrototypeOf, Object);
$f23977e513bc5bb8$exports = $f23977e513bc5bb8$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $062e5c11ed7840c8$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $062e5c11ed7840c8$var$getSymbolsIn = !$062e5c11ed7840c8$var$nativeGetSymbols ? $39d96653d132c0cd$exports : function getSymbolsIn(object) {
    var result = [];
    while(object){
        $e1a5ed0e8bfb914a$exports(result, $cac7f21bc1f37396$exports(object));
        object = $f23977e513bc5bb8$exports(object);
    }
    return result;
};
$062e5c11ed7840c8$exports = $062e5c11ed7840c8$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $82ea92b66ff30d81$var$copySymbolsIn(source, object) {
    return $81901f18667e59d2$exports(source, $062e5c11ed7840c8$exports(source), object);
}
$82ea92b66ff30d81$exports = $82ea92b66ff30d81$var$copySymbolsIn;



var $f021f5c1184b311c$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f021f5c1184b311c$var$getAllKeysIn(object) {
    return $856a28b7c084fc39$exports(object, $b22c556485651513$exports, $062e5c11ed7840c8$exports);
}
$f021f5c1184b311c$exports = $f021f5c1184b311c$var$getAllKeysIn;



var $e49eb5be1618b365$exports = {};
/** Used for built-in method references. */ var $e49eb5be1618b365$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e49eb5be1618b365$var$hasOwnProperty = $e49eb5be1618b365$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $e49eb5be1618b365$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $e49eb5be1618b365$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$e49eb5be1618b365$exports = $e49eb5be1618b365$var$initCloneArray;


var $8804c3ea1f55e165$exports = {};
var $5c9d3f3551e8bb1e$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $5c9d3f3551e8bb1e$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $754a4d36ccbc1987$exports(result).set(new $754a4d36ccbc1987$exports(arrayBuffer));
    return result;
}
$5c9d3f3551e8bb1e$exports = $5c9d3f3551e8bb1e$var$cloneArrayBuffer;


var $71c3ea283b8afeb6$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $71c3ea283b8afeb6$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $5c9d3f3551e8bb1e$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$71c3ea283b8afeb6$exports = $71c3ea283b8afeb6$var$cloneDataView;


var $0c23a8a619642c7c$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $0c23a8a619642c7c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $0c23a8a619642c7c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $0c23a8a619642c7c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$0c23a8a619642c7c$exports = $0c23a8a619642c7c$var$cloneRegExp;


var $94b685dec3e28133$exports = {};

/** Used to convert symbols to primitives and strings. */ var $94b685dec3e28133$var$symbolProto = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.prototype : undefined, $94b685dec3e28133$var$symbolValueOf = $94b685dec3e28133$var$symbolProto ? $94b685dec3e28133$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $94b685dec3e28133$var$cloneSymbol(symbol) {
    return $94b685dec3e28133$var$symbolValueOf ? Object($94b685dec3e28133$var$symbolValueOf.call(symbol)) : {};
}
$94b685dec3e28133$exports = $94b685dec3e28133$var$cloneSymbol;


var $97926d9f420089fc$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $97926d9f420089fc$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $5c9d3f3551e8bb1e$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$97926d9f420089fc$exports = $97926d9f420089fc$var$cloneTypedArray;


/** `Object#toString` result references. */ var $8804c3ea1f55e165$var$boolTag = "[object Boolean]", $8804c3ea1f55e165$var$dateTag = "[object Date]", $8804c3ea1f55e165$var$mapTag = "[object Map]", $8804c3ea1f55e165$var$numberTag = "[object Number]", $8804c3ea1f55e165$var$regexpTag = "[object RegExp]", $8804c3ea1f55e165$var$setTag = "[object Set]", $8804c3ea1f55e165$var$stringTag = "[object String]", $8804c3ea1f55e165$var$symbolTag = "[object Symbol]";
var $8804c3ea1f55e165$var$arrayBufferTag = "[object ArrayBuffer]", $8804c3ea1f55e165$var$dataViewTag = "[object DataView]", $8804c3ea1f55e165$var$float32Tag = "[object Float32Array]", $8804c3ea1f55e165$var$float64Tag = "[object Float64Array]", $8804c3ea1f55e165$var$int8Tag = "[object Int8Array]", $8804c3ea1f55e165$var$int16Tag = "[object Int16Array]", $8804c3ea1f55e165$var$int32Tag = "[object Int32Array]", $8804c3ea1f55e165$var$uint8Tag = "[object Uint8Array]", $8804c3ea1f55e165$var$uint8ClampedTag = "[object Uint8ClampedArray]", $8804c3ea1f55e165$var$uint16Tag = "[object Uint16Array]", $8804c3ea1f55e165$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $8804c3ea1f55e165$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $8804c3ea1f55e165$var$arrayBufferTag:
            return $5c9d3f3551e8bb1e$exports(object);
        case $8804c3ea1f55e165$var$boolTag:
        case $8804c3ea1f55e165$var$dateTag:
            return new Ctor(+object);
        case $8804c3ea1f55e165$var$dataViewTag:
            return $71c3ea283b8afeb6$exports(object, isDeep);
        case $8804c3ea1f55e165$var$float32Tag:
        case $8804c3ea1f55e165$var$float64Tag:
        case $8804c3ea1f55e165$var$int8Tag:
        case $8804c3ea1f55e165$var$int16Tag:
        case $8804c3ea1f55e165$var$int32Tag:
        case $8804c3ea1f55e165$var$uint8Tag:
        case $8804c3ea1f55e165$var$uint8ClampedTag:
        case $8804c3ea1f55e165$var$uint16Tag:
        case $8804c3ea1f55e165$var$uint32Tag:
            return $97926d9f420089fc$exports(object, isDeep);
        case $8804c3ea1f55e165$var$mapTag:
            return new Ctor;
        case $8804c3ea1f55e165$var$numberTag:
        case $8804c3ea1f55e165$var$stringTag:
            return new Ctor(object);
        case $8804c3ea1f55e165$var$regexpTag:
            return $0c23a8a619642c7c$exports(object);
        case $8804c3ea1f55e165$var$setTag:
            return new Ctor;
        case $8804c3ea1f55e165$var$symbolTag:
            return $94b685dec3e28133$exports(object);
    }
}
$8804c3ea1f55e165$exports = $8804c3ea1f55e165$var$initCloneByTag;


var $eb927ba31caed68c$exports = {};
var $721a03e742f8d5af$exports = {};

/** Built-in value references. */ var $721a03e742f8d5af$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $721a03e742f8d5af$var$baseCreate = function() {
    var object = function object() {};
    return function(proto) {
        if (!$cfc6c88de6d47f6e$exports(proto)) return {};
        if ($721a03e742f8d5af$var$objectCreate) return $721a03e742f8d5af$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$721a03e742f8d5af$exports = $721a03e742f8d5af$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $eb927ba31caed68c$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$8c7fbfc207c28d0e$exports(object) ? $721a03e742f8d5af$exports($f23977e513bc5bb8$exports(object)) : {};
}
$eb927ba31caed68c$exports = $eb927ba31caed68c$var$initCloneObject;




var $6mwXD = parcelRequire("6mwXD");
var $171f4891a35d8c9a$exports = {};
var $a33cc83a97a4a1d6$exports = {};


/** `Object#toString` result references. */ var $a33cc83a97a4a1d6$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $a33cc83a97a4a1d6$var$baseIsMap(value) {
    return $52801399e0aa2349$exports(value) && $50a3080f6298a726$exports(value) == $a33cc83a97a4a1d6$var$mapTag;
}
$a33cc83a97a4a1d6$exports = $a33cc83a97a4a1d6$var$baseIsMap;




var $fnsCs = parcelRequire("fnsCs");
/* Node.js helper references. */ var $171f4891a35d8c9a$var$nodeIsMap = $fnsCs && $fnsCs.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $171f4891a35d8c9a$var$isMap = $171f4891a35d8c9a$var$nodeIsMap ? $cab5da4c4851d3a4$exports($171f4891a35d8c9a$var$nodeIsMap) : $a33cc83a97a4a1d6$exports;
$171f4891a35d8c9a$exports = $171f4891a35d8c9a$var$isMap;



var $d4ae2ea3fef2bc2b$exports = {};
var $64f15ac89f69c3b6$exports = {};


/** `Object#toString` result references. */ var $64f15ac89f69c3b6$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $64f15ac89f69c3b6$var$baseIsSet(value) {
    return $52801399e0aa2349$exports(value) && $50a3080f6298a726$exports(value) == $64f15ac89f69c3b6$var$setTag;
}
$64f15ac89f69c3b6$exports = $64f15ac89f69c3b6$var$baseIsSet;




var $fnsCs = parcelRequire("fnsCs");
/* Node.js helper references. */ var $d4ae2ea3fef2bc2b$var$nodeIsSet = $fnsCs && $fnsCs.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $d4ae2ea3fef2bc2b$var$isSet = $d4ae2ea3fef2bc2b$var$nodeIsSet ? $cab5da4c4851d3a4$exports($d4ae2ea3fef2bc2b$var$nodeIsSet) : $64f15ac89f69c3b6$exports;
$d4ae2ea3fef2bc2b$exports = $d4ae2ea3fef2bc2b$var$isSet;




/** Used to compose bitmasks for cloning. */ var $aecc7c84d399924b$var$CLONE_DEEP_FLAG = 1, $aecc7c84d399924b$var$CLONE_FLAT_FLAG = 2, $aecc7c84d399924b$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $aecc7c84d399924b$var$argsTag = "[object Arguments]", $aecc7c84d399924b$var$arrayTag = "[object Array]", $aecc7c84d399924b$var$boolTag = "[object Boolean]", $aecc7c84d399924b$var$dateTag = "[object Date]", $aecc7c84d399924b$var$errorTag = "[object Error]", $aecc7c84d399924b$var$funcTag = "[object Function]", $aecc7c84d399924b$var$genTag = "[object GeneratorFunction]", $aecc7c84d399924b$var$mapTag = "[object Map]", $aecc7c84d399924b$var$numberTag = "[object Number]", $aecc7c84d399924b$var$objectTag = "[object Object]", $aecc7c84d399924b$var$regexpTag = "[object RegExp]", $aecc7c84d399924b$var$setTag = "[object Set]", $aecc7c84d399924b$var$stringTag = "[object String]", $aecc7c84d399924b$var$symbolTag = "[object Symbol]", $aecc7c84d399924b$var$weakMapTag = "[object WeakMap]";
var $aecc7c84d399924b$var$arrayBufferTag = "[object ArrayBuffer]", $aecc7c84d399924b$var$dataViewTag = "[object DataView]", $aecc7c84d399924b$var$float32Tag = "[object Float32Array]", $aecc7c84d399924b$var$float64Tag = "[object Float64Array]", $aecc7c84d399924b$var$int8Tag = "[object Int8Array]", $aecc7c84d399924b$var$int16Tag = "[object Int16Array]", $aecc7c84d399924b$var$int32Tag = "[object Int32Array]", $aecc7c84d399924b$var$uint8Tag = "[object Uint8Array]", $aecc7c84d399924b$var$uint8ClampedTag = "[object Uint8ClampedArray]", $aecc7c84d399924b$var$uint16Tag = "[object Uint16Array]", $aecc7c84d399924b$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $aecc7c84d399924b$var$cloneableTags = {};
$aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$argsTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$arrayTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$arrayBufferTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$dataViewTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$boolTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$dateTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$float32Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$float64Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$int8Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$int16Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$int32Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$mapTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$numberTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$objectTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$regexpTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$setTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$stringTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$symbolTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$uint8Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$uint8ClampedTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$uint16Tag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$uint32Tag] = true;
$aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$errorTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$funcTag] = $aecc7c84d399924b$var$cloneableTags[$aecc7c84d399924b$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $aecc7c84d399924b$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $aecc7c84d399924b$var$CLONE_DEEP_FLAG, isFlat = bitmask & $aecc7c84d399924b$var$CLONE_FLAT_FLAG, isFull = bitmask & $aecc7c84d399924b$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$cfc6c88de6d47f6e$exports(value)) return value;
    var isArr = $47c989dafa9cb12c$exports(value);
    if (isArr) {
        result = $e49eb5be1618b365$exports(value);
        if (!isDeep) return $824dbd451a5706c8$exports(value, result);
    } else {
        var tag = $50a3080f6298a726$exports(value), isFunc = tag == $aecc7c84d399924b$var$funcTag || tag == $aecc7c84d399924b$var$genTag;
        if ($6mwXD(value)) return $5c1eQ(value, isDeep);
        if (tag == $aecc7c84d399924b$var$objectTag || tag == $aecc7c84d399924b$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $eb927ba31caed68c$exports(value);
            if (!isDeep) return isFlat ? $82ea92b66ff30d81$exports(value, $a7370e901c25f2fc$exports(result, value)) : $cdfe6f529dcbabc6$exports(value, $3fd2f412d84c896b$exports(result, value));
        } else {
            if (!$aecc7c84d399924b$var$cloneableTags[tag]) return object ? value : {};
            result = $8804c3ea1f55e165$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $d70e75b56b3c7200$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($d4ae2ea3fef2bc2b$exports(value)) value.forEach(function(subValue) {
        result.add($aecc7c84d399924b$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($171f4891a35d8c9a$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $aecc7c84d399924b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $f021f5c1184b311c$exports : $d74e3fe9ee8cee52$exports : isFlat ? $b22c556485651513$exports : $47b1777f638b66e2$exports;
    var props = isArr ? undefined : keysFunc(value);
    $3ec5b32623c0c484$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $a0c67fe3cfdd6da2$exports(result, key, $aecc7c84d399924b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$aecc7c84d399924b$exports = $aecc7c84d399924b$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $97fd0f9b469320ff$var$CLONE_DEEP_FLAG = 1, $97fd0f9b469320ff$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $97fd0f9b469320ff$var$cloneDeep(value) {
    return $aecc7c84d399924b$exports(value, $97fd0f9b469320ff$var$CLONE_DEEP_FLAG | $97fd0f9b469320ff$var$CLONE_SYMBOLS_FLAG);
}
$97fd0f9b469320ff$exports = $97fd0f9b469320ff$var$cloneDeep;



var $4CEbD = parcelRequire("4CEbD");

function $321aa7312912bfe4$var$ListAdd(_a) {
    var onAction = function onAction(event) {
        if (limitNotReached && !readOnly && (!("key" in event) || event.key === "Enter")) parent.onChange(parent.value.concat([
            (0, (/*@__PURE__*/$parcel$interopDefault($97fd0f9b469320ff$exports)))(value)
        ]));
    };
    var disabled = _a.disabled, initialCount = _a.initialCount, name = _a.name, readOnly = _a.readOnly, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "disabled",
        "initialCount",
        "name",
        "readOnly",
        "value"
    ]);
    var nameParts = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(null, name);
    var parentName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
    var parent = (0, $c65a34cb0f24f11f$export$294aa081a6c6f55d)(parentName, {
        initialCount: initialCount
    }, {
        absoluteName: true
    })[0];
    var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props), {
        onClick: onAction,
        onKeyDown: onAction,
        role: "button",
        tabIndex: 0
    }), "+");
}
var $321aa7312912bfe4$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($321aa7312912bfe4$var$ListAdd, {
    initialValue: false,
    kind: "leaf"
});



var $4CEbD = parcelRequire("4CEbD");



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

function $2c7a60618a76a56e$var$ListDel(_a) {
    var onAction = function onAction(event) {
        if (limitNotReached && !readOnly && (!("key" in event) || event.key === "Enter")) {
            var value = parent.value.slice();
            value.splice(nameIndex, 1);
            parent.onChange(value);
        }
    };
    var disabled = _a.disabled, name = _a.name, readOnly = _a.readOnly, props = (0, $nLPsB.__rest)(_a, [
        "disabled",
        "name",
        "readOnly"
    ]);
    var nameParts = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(null, name);
    var nameIndex = +nameParts[nameParts.length - 1];
    var parentName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
    var parent = (0, $c65a34cb0f24f11f$export$294aa081a6c6f55d)(parentName, {}, {
        absoluteName: true
    })[0];
    var limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props), {
        onClick: onAction,
        onKeyDown: onAction,
        role: "button",
        tabIndex: 0
    }), "-");
}
var $2c7a60618a76a56e$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($2c7a60618a76a56e$var$ListDel, {
    initialValue: false,
    kind: "leaf"
});


function $04a96556f32431f6$var$ListItem(param) {
    var _param_children = param.children, children = _param_children === void 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $09e5a41aaaf9fea5$export$2e2bcd8739ae039), {
        label: null,
        name: ""
    }) : _param_children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c7a60618a76a56e$export$2e2bcd8739ae039), {
        name: ""
    }), children);
}
var $04a96556f32431f6$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($04a96556f32431f6$var$ListItem, {
    initialValue: false
});


function $ad46239ef84da4a7$var$List(_a) {
    var _a_children = _a.children, children = _a_children === void 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $04a96556f32431f6$export$2e2bcd8739ae039), {
        name: "$"
    }) : _a_children, initialCount = _a.initialCount, itemProps = _a.itemProps, label = _a.label, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "children",
        "initialCount",
        "itemProps",
        "label",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("ul", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", null, label, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $321aa7312912bfe4$export$2e2bcd8739ae039), {
        initialCount: initialCount,
        name: "$"
    })), value === null || value === void 0 ? void 0 : value.map(function(item, itemIndex) {
        return (0, $4CEbD.Children).map(children, function(child, childIndex) {
            var _$_a;
            return (0, $4CEbD.isValidElement)(child) ? (0, $4CEbD.cloneElement)(child, Object.assign({
                key: "".concat(itemIndex, "-").concat(childIndex),
                name: (_$_a = child.props.name) === null || _$_a === void 0 ? void 0 : _$_a.replace("$", "" + itemIndex)
            }, itemProps)) : child;
        });
    }));
}
var $ad46239ef84da4a7$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($ad46239ef84da4a7$var$List);



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");


function $db56af5afaaf9679$var$Nest(_a) {
    var children = _a.children, fields = _a.fields, itemProps = _a.itemProps, label = _a.label, props = (0, $nLPsB.__rest)(_a, [
        "children",
        "fields",
        "itemProps",
        "label"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", null, label), children || fields.map(function(field) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $09e5a41aaaf9fea5$export$2e2bcd8739ae039), Object.assign({
            key: field,
            name: field
        }, itemProps));
    }));
}
var $db56af5afaaf9679$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($db56af5afaaf9679$var$Nest);



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

function $8e98c62fb8d35688$var$Num(_a) {
    var decimal = _a.decimal, disabled = _a.disabled, id = _a.id, inputRef = _a.inputRef, label = _a.label, max = _a.max, min = _a.min, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, step = _a.step, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "decimal",
        "disabled",
        "id",
        "inputRef",
        "label",
        "max",
        "min",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "step",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        disabled: disabled,
        id: id,
        max: max,
        min: min,
        name: name,
        onChange: function(event) {
            var parse = decimal ? parseFloat : parseInt;
            var value = parse(event.target.value);
            onChange(isNaN(value) ? undefined : value);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        step: step || (decimal ? 0.01 : 1),
        type: "number",
        value: value !== null && value !== void 0 ? value : ""
    }));
}
var $8e98c62fb8d35688$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($8e98c62fb8d35688$var$Num, {
    kind: "leaf"
});



var $nLPsB = parcelRequire("nLPsB");
var $7c9902267b7d62d2$exports = {};


var $7d4fcb2e55cd1713$exports = {};

var $b2e0f9298e3beae2$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $b2e0f9298e3beae2$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$b2e0f9298e3beae2$exports = $b2e0f9298e3beae2$var$last;


var $ecbc42bc7529eb03$exports = {};

var $51950ac2857e7c55$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $51950ac2857e7c55$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$51950ac2857e7c55$exports = $51950ac2857e7c55$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $ecbc42bc7529eb03$var$parent(object, path) {
    return path.length < 2 ? object : $b173e02f38b4f195$exports(object, $51950ac2857e7c55$exports(path, 0, -1));
}
$ecbc42bc7529eb03$exports = $ecbc42bc7529eb03$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $7d4fcb2e55cd1713$var$baseUnset(object, path) {
    path = $4b409bb948db762f$exports(path, object);
    object = $ecbc42bc7529eb03$exports(object, path);
    return object == null || delete object[$cc9d3d3b1be5dc06$exports($b2e0f9298e3beae2$exports(path))];
}
$7d4fcb2e55cd1713$exports = $7d4fcb2e55cd1713$var$baseUnset;




var $a51d61f0ce357d36$exports = {};
var $0a74a7f396812d16$exports = {};



/** `Object#toString` result references. */ var $0a74a7f396812d16$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0a74a7f396812d16$var$funcProto = Function.prototype, $0a74a7f396812d16$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0a74a7f396812d16$var$funcToString = $0a74a7f396812d16$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0a74a7f396812d16$var$hasOwnProperty = $0a74a7f396812d16$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0a74a7f396812d16$var$objectCtorString = $0a74a7f396812d16$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0a74a7f396812d16$var$isPlainObject(value) {
    if (!$52801399e0aa2349$exports(value) || $11959fa193176326$exports(value) != $0a74a7f396812d16$var$objectTag) return false;
    var proto = $f23977e513bc5bb8$exports(value);
    if (proto === null) return true;
    var Ctor = $0a74a7f396812d16$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0a74a7f396812d16$var$funcToString.call(Ctor) == $0a74a7f396812d16$var$objectCtorString;
}
$0a74a7f396812d16$exports = $0a74a7f396812d16$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a51d61f0ce357d36$var$customOmitClone(value) {
    return $0a74a7f396812d16$exports(value) ? undefined : value;
}
$a51d61f0ce357d36$exports = $a51d61f0ce357d36$var$customOmitClone;


var $d838349fe211ba01$exports = {};
var $a3e38aeda859ed79$exports = {};
var $34b536d817b489fd$exports = {};

var $920505671a4aa669$exports = {};



/** Built-in value references. */ var $920505671a4aa669$var$spreadableSymbol = $147fb1bda7f9390b$exports ? $147fb1bda7f9390b$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $920505671a4aa669$var$isFlattenable(value) {
    return $47c989dafa9cb12c$exports(value) || $e2c917fa60f1eb65$exports(value) || !!($920505671a4aa669$var$spreadableSymbol && value && value[$920505671a4aa669$var$spreadableSymbol]);
}
$920505671a4aa669$exports = $920505671a4aa669$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $34b536d817b489fd$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $920505671a4aa669$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $34b536d817b489fd$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $e1a5ed0e8bfb914a$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$34b536d817b489fd$exports = $34b536d817b489fd$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $a3e38aeda859ed79$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $34b536d817b489fd$exports(array, 1) : [];
}
$a3e38aeda859ed79$exports = $a3e38aeda859ed79$var$flatten;


var $cfa309b7dab27d6a$exports = {};
var $49ba332ff3787f0a$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $49ba332ff3787f0a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$49ba332ff3787f0a$exports = $49ba332ff3787f0a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cfa309b7dab27d6a$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $cfa309b7dab27d6a$var$overRest(func, start, transform) {
    start = $cfa309b7dab27d6a$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $cfa309b7dab27d6a$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $49ba332ff3787f0a$exports(func, this, otherArgs);
    };
}
$cfa309b7dab27d6a$exports = $cfa309b7dab27d6a$var$overRest;


var $816472c094f2f6ed$exports = {};
var $82f55f21f9187054$exports = {};
var $25c1a92ea59cab4f$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $25c1a92ea59cab4f$var$constant(value) {
    return function() {
        return value;
    };
}
$25c1a92ea59cab4f$exports = $25c1a92ea59cab4f$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $82f55f21f9187054$var$baseSetToString = !$4335a0388c803e20$exports ? $a96a5893f64584a3$exports : function baseSetToString(func, string) {
    return $4335a0388c803e20$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $25c1a92ea59cab4f$exports(string),
        "writable": true
    });
};
$82f55f21f9187054$exports = $82f55f21f9187054$var$baseSetToString;


var $ab0c7fb67d5c4847$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ab0c7fb67d5c4847$var$HOT_COUNT = 800, $ab0c7fb67d5c4847$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ab0c7fb67d5c4847$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ab0c7fb67d5c4847$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ab0c7fb67d5c4847$var$nativeNow(), remaining = $ab0c7fb67d5c4847$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ab0c7fb67d5c4847$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$ab0c7fb67d5c4847$exports = $ab0c7fb67d5c4847$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $816472c094f2f6ed$var$setToString = $ab0c7fb67d5c4847$exports($82f55f21f9187054$exports);
$816472c094f2f6ed$exports = $816472c094f2f6ed$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $d838349fe211ba01$var$flatRest(func) {
    return $816472c094f2f6ed$exports($cfa309b7dab27d6a$exports(func, undefined, $a3e38aeda859ed79$exports), func + "");
}
$d838349fe211ba01$exports = $d838349fe211ba01$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $7c9902267b7d62d2$var$CLONE_DEEP_FLAG = 1, $7c9902267b7d62d2$var$CLONE_FLAT_FLAG = 2, $7c9902267b7d62d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $7c9902267b7d62d2$var$omit = $d838349fe211ba01$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $cfbabfc9c5f422ac$exports(paths, function(path) {
        path = $4b409bb948db762f$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $81901f18667e59d2$exports(object, $f021f5c1184b311c$exports(object), result);
    if (isDeep) result = $aecc7c84d399924b$exports(result, $7c9902267b7d62d2$var$CLONE_DEEP_FLAG | $7c9902267b7d62d2$var$CLONE_FLAT_FLAG | $7c9902267b7d62d2$var$CLONE_SYMBOLS_FLAG, $a51d61f0ce357d36$exports);
    var length = paths.length;
    while(length--)$7d4fcb2e55cd1713$exports(result, paths[length]);
    return result;
});
$7c9902267b7d62d2$exports = $7c9902267b7d62d2$var$omit;



var $4CEbD = parcelRequire("4CEbD");

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $fI3zL = parcelRequire("fI3zL");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $5F2Q2 = parcelRequire("5F2Q2");

var $COJlH = parcelRequire("COJlH");
var $b4fa0ac54ada5015$export$a143d493d941bafc;
var $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a;
var $b4fa0ac54ada5015$export$f99ded8fe4b79145;
var $b4fa0ac54ada5015$export$599f31c3813fae4d;
"use strict";
var $bfa49c0062a5803d$export$a48f0734ac7c2329;
var $bfa49c0062a5803d$export$d622b2ad8d90c771;
var $bfa49c0062a5803d$export$6100ba28696e12de;
"use strict";
$bfa49c0062a5803d$export$a48f0734ac7c2329 = $bfa49c0062a5803d$var$byteLength;
$bfa49c0062a5803d$export$d622b2ad8d90c771 = $bfa49c0062a5803d$var$toByteArray;
$bfa49c0062a5803d$export$6100ba28696e12de = $bfa49c0062a5803d$var$fromByteArray;
var $bfa49c0062a5803d$var$lookup = [];
var $bfa49c0062a5803d$var$revLookup = [];
var $bfa49c0062a5803d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $bfa49c0062a5803d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $bfa49c0062a5803d$var$i = 0, $bfa49c0062a5803d$var$len = $bfa49c0062a5803d$var$code.length; $bfa49c0062a5803d$var$i < $bfa49c0062a5803d$var$len; ++$bfa49c0062a5803d$var$i){
    $bfa49c0062a5803d$var$lookup[$bfa49c0062a5803d$var$i] = $bfa49c0062a5803d$var$code[$bfa49c0062a5803d$var$i];
    $bfa49c0062a5803d$var$revLookup[$bfa49c0062a5803d$var$code.charCodeAt($bfa49c0062a5803d$var$i)] = $bfa49c0062a5803d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bfa49c0062a5803d$var$revLookup["-".charCodeAt(0)] = 62;
$bfa49c0062a5803d$var$revLookup["_".charCodeAt(0)] = 63;
function $bfa49c0062a5803d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bfa49c0062a5803d$var$byteLength(b64) {
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$toByteArray(b64) {
    var tmp;
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bfa49c0062a5803d$var$Arr($bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 18 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 2 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 10 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bfa49c0062a5803d$var$tripletToBase64(num) {
    return $bfa49c0062a5803d$var$lookup[num >> 18 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 12 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 6 & 0x3F] + $bfa49c0062a5803d$var$lookup[num & 0x3F];
}
function $bfa49c0062a5803d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bfa49c0062a5803d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $bfa49c0062a5803d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bfa49c0062a5803d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 2] + $bfa49c0062a5803d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 10] + $bfa49c0062a5803d$var$lookup[tmp >> 4 & 0x3F] + $bfa49c0062a5803d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $23e3cc2fb993da68$export$aafa59e2e03f2942;
var $23e3cc2fb993da68$export$68d8715fc104d294;
$23e3cc2fb993da68$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$23e3cc2fb993da68$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $b4fa0ac54ada5015$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$b4fa0ac54ada5015$export$a143d493d941bafc = $b4fa0ac54ada5015$var$Buffer;
$b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a = $b4fa0ac54ada5015$var$SlowBuffer;
$b4fa0ac54ada5015$export$f99ded8fe4b79145 = 50;
var $b4fa0ac54ada5015$var$K_MAX_LENGTH = 0x7fffffff;
$b4fa0ac54ada5015$export$599f31c3813fae4d = $b4fa0ac54ada5015$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT = $b4fa0ac54ada5015$var$typedArraySupport();
if (!$b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b4fa0ac54ada5015$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b4fa0ac54ada5015$var$createBuffer(length) {
    if (length > $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b4fa0ac54ada5015$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b4fa0ac54ada5015$var$allocUnsafe(arg);
    }
    return $b4fa0ac54ada5015$var$from(arg, encodingOrOffset, length);
}
$b4fa0ac54ada5015$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $b4fa0ac54ada5015$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b4fa0ac54ada5015$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value)));
    if ($b4fa0ac54ada5015$var$isInstance(value, ArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, ArrayBuffer)) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($b4fa0ac54ada5015$var$isInstance(value, SharedArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, SharedArrayBuffer))) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b4fa0ac54ada5015$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $b4fa0ac54ada5015$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $b4fa0ac54ada5015$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b4fa0ac54ada5015$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer, Uint8Array);
function $b4fa0ac54ada5015$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b4fa0ac54ada5015$var$alloc(size, fill, encoding) {
    $b4fa0ac54ada5015$var$assertSize(size);
    if (size <= 0) return $b4fa0ac54ada5015$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $b4fa0ac54ada5015$var$createBuffer(size).fill(fill, encoding) : $b4fa0ac54ada5015$var$createBuffer(size).fill(fill);
    return $b4fa0ac54ada5015$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b4fa0ac54ada5015$var$Buffer.alloc = function(size, fill, encoding) {
    return $b4fa0ac54ada5015$var$alloc(size, fill, encoding);
};
function $b4fa0ac54ada5015$var$allocUnsafe(size) {
    $b4fa0ac54ada5015$var$assertSize(size);
    return $b4fa0ac54ada5015$var$createBuffer(size < 0 ? 0 : $b4fa0ac54ada5015$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b4fa0ac54ada5015$var$Buffer.allocUnsafe = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b4fa0ac54ada5015$var$Buffer.allocUnsafeSlow = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
function $b4fa0ac54ada5015$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $b4fa0ac54ada5015$var$byteLength(string, encoding) | 0;
    var buf = $b4fa0ac54ada5015$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $b4fa0ac54ada5015$var$checked(array.length) | 0;
    var buf = $b4fa0ac54ada5015$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayView(arrayView) {
    if ($b4fa0ac54ada5015$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $b4fa0ac54ada5015$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b4fa0ac54ada5015$var$fromArrayLike(arrayView);
}
function $b4fa0ac54ada5015$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
function $b4fa0ac54ada5015$var$fromObject(obj) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(obj)) {
        var len = $b4fa0ac54ada5015$var$checked(obj.length) | 0;
        var buf = $b4fa0ac54ada5015$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $b4fa0ac54ada5015$var$numberIsNaN(obj.length)) return $b4fa0ac54ada5015$var$createBuffer(0);
        return $b4fa0ac54ada5015$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $b4fa0ac54ada5015$var$fromArrayLike(obj.data);
}
function $b4fa0ac54ada5015$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b4fa0ac54ada5015$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $b4fa0ac54ada5015$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b4fa0ac54ada5015$var$Buffer.alloc(+length);
}
$b4fa0ac54ada5015$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b4fa0ac54ada5015$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b4fa0ac54ada5015$var$Buffer.compare = function compare(a, b) {
    if ($b4fa0ac54ada5015$var$isInstance(a, Uint8Array)) a = $b4fa0ac54ada5015$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b4fa0ac54ada5015$var$isInstance(b, Uint8Array)) b = $b4fa0ac54ada5015$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(a) || !$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b4fa0ac54ada5015$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b4fa0ac54ada5015$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b4fa0ac54ada5015$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $b4fa0ac54ada5015$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($b4fa0ac54ada5015$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) buf = $b4fa0ac54ada5015$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b4fa0ac54ada5015$var$byteLength(string, encoding) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b4fa0ac54ada5015$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $5F2Q2._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b4fa0ac54ada5015$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b4fa0ac54ada5015$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b4fa0ac54ada5015$var$Buffer.byteLength = $b4fa0ac54ada5015$var$byteLength;
function $b4fa0ac54ada5015$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b4fa0ac54ada5015$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8Slice(this, start, end);
        case "ascii":
            return $b4fa0ac54ada5015$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b4fa0ac54ada5015$var$latin1Slice(this, start, end);
        case "base64":
            return $b4fa0ac54ada5015$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b4fa0ac54ada5015$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b4fa0ac54ada5015$var$Buffer.prototype._isBuffer = true;
function $b4fa0ac54ada5015$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b4fa0ac54ada5015$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$b4fa0ac54ada5015$var$swap(this, i, i + 1);
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $b4fa0ac54ada5015$var$swap(this, i, i + 3);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $b4fa0ac54ada5015$var$swap(this, i, i + 7);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 6);
        $b4fa0ac54ada5015$var$swap(this, i + 2, i + 5);
        $b4fa0ac54ada5015$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $b4fa0ac54ada5015$var$utf8Slice(this, 0, length);
    return $b4fa0ac54ada5015$var$slowToString.apply(this, arguments);
};
$b4fa0ac54ada5015$var$Buffer.prototype.toLocaleString = $b4fa0ac54ada5015$var$Buffer.prototype.toString;
$b4fa0ac54ada5015$var$Buffer.prototype.equals = function equals(b) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b4fa0ac54ada5015$var$Buffer.compare(this, b) === 0;
};
$b4fa0ac54ada5015$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $b4fa0ac54ada5015$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($b4fa0ac54ada5015$var$customInspectSymbol) $b4fa0ac54ada5015$var$Buffer.prototype[$b4fa0ac54ada5015$var$customInspectSymbol] = $b4fa0ac54ada5015$var$Buffer.prototype.inspect;
$b4fa0ac54ada5015$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b4fa0ac54ada5015$var$isInstance(target, Uint8Array)) target = $b4fa0ac54ada5015$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $5F2Q2._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b4fa0ac54ada5015$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b4fa0ac54ada5015$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b4fa0ac54ada5015$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var read = function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    };
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b4fa0ac54ada5015$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b4fa0ac54ada5015$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b4fa0ac54ada5015$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b4fa0ac54ada5015$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b4fa0ac54ada5015$var$utf8Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b4fa0ac54ada5015$var$asciiWrite(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$asciiToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$base64Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$base64ToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$ucs2Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b4fa0ac54ada5015$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b4fa0ac54ada5015$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $b4fa0ac54ada5015$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b4fa0ac54ada5015$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b4fa0ac54ada5015$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b4fa0ac54ada5015$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b4fa0ac54ada5015$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bfa49c0062a5803d$export$6100ba28696e12de(buf);
    else return $bfa49c0062a5803d$export$6100ba28696e12de(buf.slice(start, end));
}
function $b4fa0ac54ada5015$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b4fa0ac54ada5015$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b4fa0ac54ada5015$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b4fa0ac54ada5015$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b4fa0ac54ada5015$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b4fa0ac54ada5015$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $b4fa0ac54ada5015$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b4fa0ac54ada5015$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b4fa0ac54ada5015$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b4fa0ac54ada5015$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b4fa0ac54ada5015$var$Buffer.prototype.readUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $b4fa0ac54ada5015$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b4fa0ac54ada5015$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $b4fa0ac54ada5015$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b4fa0ac54ada5015$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, false, noAssert);
};
function $b4fa0ac54ada5015$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b4fa0ac54ada5015$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b4fa0ac54ada5015$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $b4fa0ac54ada5015$var$Buffer.isBuffer(val) ? val : $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $b4fa0ac54ada5015$var$errors = {};
function $b4fa0ac54ada5015$var$E(sym, getMessage, Base) {
    $b4fa0ac54ada5015$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $fsOl6._)(NodeError, Base);
        var _super = (0, $COJlH._)(NodeError);
        function NodeError() {
            (0, $h5oKP._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $fI3zL._)(_this), "message", {
                value: getMessage.apply((0, $fI3zL._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $85qwq._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$b4fa0ac54ada5015$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$b4fa0ac54ada5015$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $5F2Q2._)(actual));
}, TypeError);
$b4fa0ac54ada5015$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $b4fa0ac54ada5015$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $5F2Q2._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $b4fa0ac54ada5015$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $b4fa0ac54ada5015$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength) {
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $b4fa0ac54ada5015$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $5F2Q2._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength);
}
function $b4fa0ac54ada5015$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $b4fa0ac54ada5015$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $b4fa0ac54ada5015$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $b4fa0ac54ada5015$var$validateNumber(value, type);
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $b4fa0ac54ada5015$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $b4fa0ac54ada5015$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b4fa0ac54ada5015$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b4fa0ac54ada5015$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b4fa0ac54ada5015$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b4fa0ac54ada5015$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b4fa0ac54ada5015$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b4fa0ac54ada5015$var$base64ToBytes(str) {
    return $bfa49c0062a5803d$export$d622b2ad8d90c771($b4fa0ac54ada5015$var$base64clean(str));
}
function $b4fa0ac54ada5015$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b4fa0ac54ada5015$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b4fa0ac54ada5015$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $b4fa0ac54ada5015$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $b4fa0ac54ada5015$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $b4fa0ac54ada5015$var$BufferBigIntNotDefined : fn;
}
function $b4fa0ac54ada5015$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $4ba94d8a40aa94e3$require$Buffer = $b4fa0ac54ada5015$export$a143d493d941bafc;
var $4ba94d8a40aa94e3$var$base64 = typeof btoa === "undefined" ? /* istanbul ignore next */ /* istanbul ignore next */ function(x) {
    return $4ba94d8a40aa94e3$require$Buffer.from(x).toString("base64");
} : btoa;
var $4ba94d8a40aa94e3$var$escape = function(x) {
    return $4ba94d8a40aa94e3$var$base64(encodeURIComponent(x)).replace(/=+$/, "");
};
function $4ba94d8a40aa94e3$var$Radio(_a) {
    var allowedValues = _a.allowedValues, disabled = _a.disabled, id = _a.id, label = _a.label, name = _a.name, onChange = _a.onChange, readOnly = _a.readOnly, transform = _a.transform, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "allowedValues",
        "disabled",
        "id",
        "label",
        "name",
        "onChange",
        "readOnly",
        "transform",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, (/*@__PURE__*/$parcel$interopDefault($7c9902267b7d62d2$exports)))((0, $31d512228acba053$export$457c3d6518dd4c6f)(props), [
        "checkboxes"
    ])), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", null, label), allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.map(function(item) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            key: item
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
            checked: item === value,
            disabled: disabled,
            id: "".concat(id, "-").concat($4ba94d8a40aa94e3$var$escape(item)),
            name: name,
            onChange: function() {
                if (!readOnly) onChange(item);
            },
            type: "radio"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
            htmlFor: "".concat(id, "-").concat($4ba94d8a40aa94e3$var$escape(item))
        }, transform ? transform(item) : item));
    }));
}
var $4ba94d8a40aa94e3$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($4ba94d8a40aa94e3$var$Radio, {
    kind: "leaf"
});



var $nLPsB = parcelRequire("nLPsB");
var $d3a6a638dba26229$exports = {};

var $96b8be50b14310e9$exports = {};



/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $96b8be50b14310e9$var$baseRest(func, start) {
    return $816472c094f2f6ed$exports($cfa309b7dab27d6a$exports(func, start, $a96a5893f64584a3$exports), func + "");
}
$96b8be50b14310e9$exports = $96b8be50b14310e9$var$baseRest;


var $d6ba17c5f71130e3$exports = {};
var $511807c10d0bd39d$exports = {};

var $7cdc13cc9bbc0ee0$exports = {};
var $d1e74e88e0de4c63$exports = {};
var $27e8012f5eef1ba3$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $27e8012f5eef1ba3$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$27e8012f5eef1ba3$exports = $27e8012f5eef1ba3$var$baseFindIndex;


var $9c7432164b5eee20$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $9c7432164b5eee20$var$baseIsNaN(value) {
    return value !== value;
}
$9c7432164b5eee20$exports = $9c7432164b5eee20$var$baseIsNaN;


var $3d3fd572628b7a62$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3d3fd572628b7a62$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$3d3fd572628b7a62$exports = $3d3fd572628b7a62$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d1e74e88e0de4c63$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $3d3fd572628b7a62$exports(array, value, fromIndex) : $27e8012f5eef1ba3$exports(array, $9c7432164b5eee20$exports, fromIndex);
}
$d1e74e88e0de4c63$exports = $d1e74e88e0de4c63$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7cdc13cc9bbc0ee0$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $d1e74e88e0de4c63$exports(array, value, 0) > -1;
}
$7cdc13cc9bbc0ee0$exports = $7cdc13cc9bbc0ee0$var$arrayIncludes;


var $934501e5bd46eca1$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $934501e5bd46eca1$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$934501e5bd46eca1$exports = $934501e5bd46eca1$var$arrayIncludesWith;





/** Used as the size to enable large array optimizations. */ var $511807c10d0bd39d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $511807c10d0bd39d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $7cdc13cc9bbc0ee0$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $cfbabfc9c5f422ac$exports(values, $cab5da4c4851d3a4$exports(iteratee));
    if (comparator) {
        includes = $934501e5bd46eca1$exports;
        isCommon = false;
    } else if (values.length >= $511807c10d0bd39d$var$LARGE_ARRAY_SIZE) {
        includes = $7b02f7855a570d47$exports;
        isCommon = false;
        values = new $475c4fc3318677f1$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$511807c10d0bd39d$exports = $511807c10d0bd39d$var$baseDifference;



var $21bedd8c28c6ae61$exports = {};




var $8ffd187af3ff7382$exports = {};

var $69f743c228cfa422$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $69f743c228cfa422$var$noop() {
// No operation performed.
}
$69f743c228cfa422$exports = $69f743c228cfa422$var$noop;



/** Used as references for various `Number` constants. */ var $8ffd187af3ff7382$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $8ffd187af3ff7382$var$createSet = !($3714e3a2ba543073$exports && 1 / $94b7647c7d0ab370$exports(new $3714e3a2ba543073$exports([
    ,
    -0
]))[1] == $8ffd187af3ff7382$var$INFINITY) ? $69f743c228cfa422$exports : function createSet(values) {
    return new $3714e3a2ba543073$exports(values);
};
$8ffd187af3ff7382$exports = $8ffd187af3ff7382$var$createSet;



/** Used as the size to enable large array optimizations. */ var $21bedd8c28c6ae61$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $21bedd8c28c6ae61$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7cdc13cc9bbc0ee0$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $934501e5bd46eca1$exports;
    } else if (length >= $21bedd8c28c6ae61$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $8ffd187af3ff7382$exports(array);
        if (set) return $94b7647c7d0ab370$exports(set);
        isCommon = false;
        includes = $7b02f7855a570d47$exports;
        seen = new $475c4fc3318677f1$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$21bedd8c28c6ae61$exports = $21bedd8c28c6ae61$var$baseUniq;


/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $d6ba17c5f71130e3$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $21bedd8c28c6ae61$exports(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $511807c10d0bd39d$exports(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $21bedd8c28c6ae61$exports($34b536d817b489fd$exports(result, 1), iteratee, comparator);
}
$d6ba17c5f71130e3$exports = $d6ba17c5f71130e3$var$baseXor;


var $72ba6997667a0927$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $72ba6997667a0927$var$isArrayLikeObject(value) {
    return $52801399e0aa2349$exports(value) && $5289076331bcb123$exports(value);
}
$72ba6997667a0927$exports = $72ba6997667a0927$var$isArrayLikeObject;


/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $d3a6a638dba26229$var$xor = $96b8be50b14310e9$exports(function(arrays) {
    return $d6ba17c5f71130e3$exports($979004aca8cfebca$exports(arrays, $72ba6997667a0927$exports));
});
$d3a6a638dba26229$exports = $d3a6a638dba26229$var$xor;



var $4CEbD = parcelRequire("4CEbD");


var $dbeb5e1b2da244eb$require$Buffer = $b4fa0ac54ada5015$export$a143d493d941bafc;
var $dbeb5e1b2da244eb$var$base64 = typeof btoa === "undefined" ? /* istanbul ignore next */ /* istanbul ignore next */ function(x) {
    return $dbeb5e1b2da244eb$require$Buffer.from(x).toString("base64");
} : btoa;
var $dbeb5e1b2da244eb$var$escape = function(x) {
    return $dbeb5e1b2da244eb$var$base64(encodeURIComponent(x)).replace(/=+$/, "");
};
function $dbeb5e1b2da244eb$var$Select(_a) {
    var allowedValues = _a.allowedValues, checkboxes = _a.checkboxes, disabled = _a.disabled, fieldType = _a.fieldType, id = _a.id, inputRef = _a.inputRef, label = _a.label, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, disableItem = _a.disableItem, transform = _a.transform, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "allowedValues",
        "checkboxes",
        "disabled",
        "fieldType",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "required",
        "disableItem",
        "transform",
        "value"
    ]);
    var multiple = fieldType === Array;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        htmlFor: id
    }, label), checkboxes ? allowedValues.map(function(item) {
        var _$_a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            key: item
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
            checked: fieldType === Array ? value.includes(item) : value === item,
            disabled: (_$_a = disableItem === null || disableItem === void 0 ? void 0 : disableItem(item)) !== null && _$_a !== void 0 ? _$_a : disabled,
            id: "".concat(id, "-").concat($dbeb5e1b2da244eb$var$escape(item)),
            name: name,
            onChange: function() {
                if (!readOnly) onChange(fieldType === Array ? (0, (/*@__PURE__*/$parcel$interopDefault($d3a6a638dba26229$exports)))([
                    item
                ], value) : item);
            },
            type: "checkbox"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
            htmlFor: "".concat(id, "-").concat($dbeb5e1b2da244eb$var$escape(item))
        }, transform ? transform(item) : item));
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("select", {
        disabled: disabled,
        id: id,
        multiple: multiple,
        name: name,
        onChange: function(event) {
            if (!readOnly) {
                var item = event.target.value;
                if (multiple) {
                    var clear = event.target.selectedIndex === -1;
                    onChange(clear ? [] : (0, (/*@__PURE__*/$parcel$interopDefault($d3a6a638dba26229$exports)))([
                        item
                    ], value));
                } else onChange(item !== "" ? item : undefined);
            }
        },
        ref: inputRef,
        value: value !== null && value !== void 0 ? value : ""
    }, (!!placeholder || !required || value === undefined) && !multiple && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("option", {
        value: "",
        disabled: required,
        hidden: required
    }, placeholder || label), allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("option", {
            disabled: disableItem === null || disableItem === void 0 ? void 0 : disableItem(value),
            key: value,
            value: value
        }, transform ? transform(value) : value);
    })));
}
var $dbeb5e1b2da244eb$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($dbeb5e1b2da244eb$var$Select, {
    kind: "leaf"
});



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

function $a9a82e309e1b9fe7$var$Text(_a) {
    var autoComplete = _a.autoComplete, disabled = _a.disabled, id = _a.id, inputRef = _a.inputRef, label = _a.label, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, type = _a.type, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "autoComplete",
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "type",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: function(event) {
            return onChange(event.target.value);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : ""
    }));
}
$a9a82e309e1b9fe7$var$Text.defaultProps = {
    type: "text"
};
var $a9a82e309e1b9fe7$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($a9a82e309e1b9fe7$var$Text, {
    kind: "leaf"
});


var $09e5a41aaaf9fea5$var$AutoField = (0, $7def494d664dfead$export$67be0aecf20e0922)(function(props) {
    if (props.allowedValues) return props.checkboxes && props.fieldType !== Array ? (0, $4ba94d8a40aa94e3$export$2e2bcd8739ae039) : (0, $dbeb5e1b2da244eb$export$2e2bcd8739ae039);
    switch(props.fieldType){
        case Array:
            return 0, $ad46239ef84da4a7$export$2e2bcd8739ae039;
        case Boolean:
            return 0, $87325d83fb2bdc07$export$2e2bcd8739ae039;
        case Date:
            return 0, $c7c69cc300e5d05a$export$2e2bcd8739ae039;
        case Number:
            return 0, $8e98c62fb8d35688$export$2e2bcd8739ae039;
        case Object:
            return 0, $db56af5afaaf9679$export$2e2bcd8739ae039;
        case String:
            return 0, $a9a82e309e1b9fe7$export$2e2bcd8739ae039;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "Unsupported field type: %s", props.fieldType);
});
var $09e5a41aaaf9fea5$export$2e2bcd8739ae039 = $09e5a41aaaf9fea5$var$AutoField;


function $1f86e799894f6ddc$export$2e2bcd8739ae039(_a) {
    var _a_autoField = _a.autoField, autoField = _a_autoField === void 0 ? (0, $09e5a41aaaf9fea5$export$2e2bcd8739ae039) : _a_autoField, _a_element = _a.element, element = _a_element === void 0 ? "div" : _a_element, fields = _a.fields, _a_omitFields = _a.omitFields, omitFields = _a_omitFields === void 0 ? [] : _a_omitFields, props = (0, $nLPsB.__rest)(_a, [
        "autoField",
        "element",
        "fields",
        "omitFields"
    ]);
    var schema = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)().schema;
    return (0, $4CEbD.createElement)(element, props, (fields !== null && fields !== void 0 ? fields : schema.getSubfields()).filter(function(field) {
        return !omitFields.includes(field);
    }).map(function(field) {
        return (0, $4CEbD.createElement)(autoField, {
            key: field,
            name: field
        });
    }));
}


var $h5oKP = parcelRequire("h5oKP");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $b0PmO = parcelRequire("b0PmO");

var $l9BwU = parcelRequire("l9BwU");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");
var $f24f3a11667ff271$exports = {};

/** Used to compose bitmasks for cloning. */ var $f24f3a11667ff271$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $f24f3a11667ff271$var$clone(value) {
    return $aecc7c84d399924b$exports(value, $f24f3a11667ff271$var$CLONE_SYMBOLS_FLAG);
}
$f24f3a11667ff271$exports = $f24f3a11667ff271$var$clone;


var $95af5b22a3138aba$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $95af5b22a3138aba$var$isEqual(value, other) {
    return $f30d524bb65eb5ca$exports(value, other);
}
$95af5b22a3138aba$exports = $95af5b22a3138aba$var$isEqual;



var $b9862b4041c79ab5$exports = {};
var $fab67c410cfe5911$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $fab67c410cfe5911$var$baseSet(object, path, value, customizer) {
    if (!$cfc6c88de6d47f6e$exports(object)) return object;
    path = $4b409bb948db762f$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $cc9d3d3b1be5dc06$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $cfc6c88de6d47f6e$exports(objValue) ? objValue : $10483e4084521d4e$exports(path[index + 1]) ? [] : {};
        }
        $a0c67fe3cfdd6da2$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$fab67c410cfe5911$exports = $fab67c410cfe5911$var$baseSet;


/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */ function $b9862b4041c79ab5$var$setWith(object, path, value, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    return object == null ? object : $fab67c410cfe5911$exports(object, path, value, customizer);
}
$b9862b4041c79ab5$exports = $b9862b4041c79ab5$var$setWith;



var $fI3zL = parcelRequire("fI3zL");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");





var $4CEbD = parcelRequire("4CEbD");

var $5F2Q2 = parcelRequire("5F2Q2");


function $abd60b68b0041366$var$isObject(value) {
    return !!value && value === Object(value) && !(value instanceof Date);
}
function $abd60b68b0041366$export$59230889ac977c02(root, valueA, valueB) {
    if (!$abd60b68b0041366$var$isObject(valueA) || valueB && (typeof valueA === "undefined" ? "undefined" : (0, $5F2Q2._)(valueA)) !== (typeof valueB === "undefined" ? "undefined" : (0, $5F2Q2._)(valueB))) return (0, (/*@__PURE__*/$parcel$interopDefault($95af5b22a3138aba$exports)))(valueA, valueB) ? [] : [
        root
    ];
    var changed = [
        root
    ];
    if ($abd60b68b0041366$var$isObject(valueB)) {
        for(var key in valueA)if (!(key in valueB) || !(0, (/*@__PURE__*/$parcel$interopDefault($95af5b22a3138aba$exports)))(valueA[key], valueB[key])) changed.push((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(root, key));
        for(var key1 in valueB)if (!(key1 in valueA)) changed.push((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(root, key1));
        if (changed.length === 1) changed.pop();
    } else // eslint-disable-next-line guard-for-in
    for(var key2 in valueA)changed.push((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(root, key2));
    return changed;
}



// Workaround for SSR
// https://github.com/vazco/uniforms/issues/40
// https://github.com/facebook/react/issues/4000
function $24375cfb4f3f7b4e$var$randomIdsGenerator(prefix) {
    var counter = 0;
    return function() {
        return "".concat(prefix, "-").concat(("000" + (counter++).toString(36)).slice(-4));
    };
}
var $24375cfb4f3f7b4e$var$randomIdPrefix = $24375cfb4f3f7b4e$var$randomIdsGenerator("uniforms");
function $24375cfb4f3f7b4e$export$1a0ec2f2094a09fe() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $24375cfb4f3f7b4e$var$randomIdPrefix();
    return $24375cfb4f3f7b4e$var$randomIdsGenerator(prefix);
}


var $d475f60013557f90$export$22578b9571b69853 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $fsOl6._)(BaseForm, Component);
    var _super = (0, $COJlH._)(BaseForm);
    function BaseForm(props) {
        (0, $h5oKP._)(this, BaseForm);
        var _this;
        _this = _super.call(this, props);
        // @ts-expect-error: State may be bigger, but it'll be covered by the subclasses.
        _this.state = {
            changed: false,
            changedMap: Object.create(null),
            resetCount: 0,
            submitted: false,
            submitting: false
        };
        _this.mounted = false;
        _this.randomId = (0, $24375cfb4f3f7b4e$export$1a0ec2f2094a09fe)(_this.props.id);
        _this.onReset = _this.reset = _this.onReset.bind((0, $fI3zL._)(_this));
        _this.onChange = _this.change = _this.onChange.bind((0, $fI3zL._)(_this));
        _this.onSubmit = _this.submit = _this.onSubmit.bind((0, $fI3zL._)(_this));
        // TODO: It shouldn't be here
        var getModel = _this.getModel.bind((0, $fI3zL._)(_this));
        _this.getModel = function(mode) {
            var model = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getModel(mode);
            return mode !== undefined && _this.props.modelTransform ? _this.props.modelTransform(mode, model) : model;
        };
        return _this;
    }
    (0, $85qwq._)(BaseForm, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, snapshot) {}
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                if (this.delayId) clearTimeout(this.delayId);
                // There are at least 4 places where we'd need to check, whether or not we
                // actually perform `setState` after the component gets unmounted. Instead,
                // we override it to hide the React warning. Also because React no longer
                // will raise it in the newer versions.
                // https://github.com/facebook/react/pull/22114
                // https://github.com/vazco/uniforms/issues/1152
                this.setState = function() {};
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return {
                    changed: this.state.changed,
                    changedMap: this.state.changedMap,
                    error: this.getContextError(),
                    formRef: this,
                    model: this.getContextModel(),
                    name: this.getContextName(),
                    onChange: this.getContextOnChange(),
                    onSubmit: this.getContextOnSubmit(),
                    randomId: this.randomId,
                    schema: this.getContextSchema(),
                    state: this.getContextState(),
                    submitted: this.state.submitted,
                    submitting: this.state.submitting,
                    validating: false
                };
            }
        },
        {
            key: "getContextName",
            value: function getContextName() {
                return [];
            }
        },
        {
            key: "getContextError",
            value: function getContextError() {
                return this.props.error;
            }
        },
        {
            key: "getContextModel",
            value: function getContextModel() {
                return this.getModel("form");
            }
        },
        {
            key: "getContextState",
            value: function getContextState() {
                return {
                    disabled: !!this.props.disabled,
                    label: !!this.props.label,
                    placeholder: !!this.props.placeholder,
                    readOnly: !!this.props.readOnly,
                    showInlineError: !!this.props.showInlineError
                };
            }
        },
        {
            key: "getContextSchema",
            value: function getContextSchema() {
                return this.props.schema;
            }
        },
        {
            key: "getContextOnChange",
            value: function getContextOnChange() {
                // It's bound in constructor.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                return this.onChange;
            }
        },
        {
            key: "getContextOnSubmit",
            value: function getContextOnSubmit() {
                // It's bound in constructor.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                return this.onSubmit;
            }
        },
        {
            key: "getModel",
            value: function getModel(mode) {
                var model = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.props.model;
                return model;
            }
        },
        {
            key: "getNativeFormProps",
            value: function getNativeFormProps() {
                var props = (0, (/*@__PURE__*/$parcel$interopDefault($7c9902267b7d62d2$exports)))(this.props, [
                    "autosave",
                    "autosaveDelay",
                    "disabled",
                    "error",
                    "label",
                    "model",
                    "modelTransform",
                    "onChange",
                    "onSubmit",
                    "placeholder",
                    "readOnly",
                    "schema",
                    "showInlineError"
                ]);
                return Object.assign(Object.assign({}, props), {
                    // It's bound in constructor.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    onSubmit: this.onSubmit,
                    key: "reset-".concat(this.state.resetCount)
                });
            }
        },
        {
            key: "onChange",
            value: function onChange(key, value) {
                var _this = this;
                // Do not set `changed` before componentDidMount
                if (this.mounted) {
                    var keys = (0, $abd60b68b0041366$export$59230889ac977c02)(key, value, (0, (/*@__PURE__*/$parcel$interopDefault($3fbdcc4ebb9f17dd$exports)))(this.getModel(), key));
                    if (keys.length !== 0) this.setState(function(state) {
                        return(// If all are already marked, we can skip the update completely.
                        state.changed && keys.every(function(key) {
                            return !!(0, (/*@__PURE__*/$parcel$interopDefault($3fbdcc4ebb9f17dd$exports)))(state.changedMap, key);
                        }) ? null : {
                            changed: true,
                            changedMap: keys.reduce(function(changedMap, key) {
                                return (0, (/*@__PURE__*/$parcel$interopDefault($b9862b4041c79ab5$exports)))(changedMap, key, {}, (0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports))));
                            }, (0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports)))(state.changedMap))
                        });
                    });
                }
                if (this.props.onChange) this.props.onChange(key, value);
                // Do not call `onSubmit` before componentDidMount
                if (this.mounted && this.props.autosave) {
                    if (this.delayId) this.delayId = clearTimeout(this.delayId);
                    // Delay autosave by `autosaveDelay` milliseconds...
                    this.delayId = setTimeout(function() {
                        // ...and wait for all scheduled `setState`s to commit. This is required
                        // for AutoForm to validate correct model, waiting in `onChange`.
                        _this.setState(function() {
                            return null;
                        }, function() {
                            _this.onSubmit();
                        });
                    }, this.props.autosaveDelay);
                }
            }
        },
        {
            key: "__reset",
            value: function __reset(state) {
                return {
                    changed: false,
                    changedMap: Object.create(null),
                    resetCount: state.resetCount + 1,
                    submitted: false,
                    submitting: false
                };
            }
        },
        {
            key: "onReset",
            value: function onReset() {
                // @ts-expect-error
                // It's bound in constructor.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                this.setState(this.__reset);
            }
        },
        {
            key: "onSubmit",
            value: function onSubmit(event) {
                var _this = this;
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                this.setState(function(state) {
                    return state.submitted ? null : {
                        submitted: true
                    };
                });
                var result = this.props.onSubmit(this.getModel("submit"));
                if (!(result instanceof Promise)) return Promise.resolve();
                this.setState({
                    submitting: true
                });
                return result.finally(function() {
                    _this.setState({
                        submitting: false
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $820ac02689a8eddd$export$a078c61943f9dbbe).Provider, {
                    value: this.getContext()
                }, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("form", Object.assign({}, this.getNativeFormProps())));
            }
        }
    ]);
    return BaseForm;
}((0, $4CEbD.Component));
$d475f60013557f90$export$22578b9571b69853.displayName = "Form";
$d475f60013557f90$export$22578b9571b69853.defaultProps = {
    autosave: false,
    autosaveDelay: 0,
    error: null,
    label: true,
    model: Object.create(null),
    noValidate: true,
    onSubmit: function() {}
};



var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $b0PmO = parcelRequire("b0PmO");

var $l9BwU = parcelRequire("l9BwU");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");

var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

function $6dbca1db06694253$export$50044cd6a929afcc(Base) {
    // @ts-expect-error: Mixin class problem.
    var QuickForm = /*#__PURE__*/ function(Base) {
        "use strict";
        (0, $fsOl6._)(QuickForm, Base);
        var _super = (0, $COJlH._)(QuickForm);
        function QuickForm() {
            (0, $h5oKP._)(this, QuickForm);
            return _super.apply(this, arguments);
        }
        (0, $85qwq._)(QuickForm, [
            {
                key: "getNativeFormProps",
                value: function getNativeFormProps() {
                    var _props = (0, $b0PmO._)((0, $l9BwU._)(QuickForm.prototype), "getNativeFormProps", this).call(this);
                    var tmp = _props.autoField, AutoField = tmp === void 0 ? this.getAutoField() : tmp, tmp1 = _props.errorsField, ErrorsField = tmp1 === void 0 ? this.getErrorsField() : tmp1, tmp2 = _props.submitField, SubmitField = tmp2 === void 0 ? this.getSubmitField() : tmp2, props = (0, $nLPsB.__rest)(_props, [
                        "autoField",
                        "errorsField",
                        "submitField"
                    ]);
                    if (!props.children) props.children = this.getContextSchema().getSubfields().map(function(key) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(AutoField, {
                            key: key,
                            name: key
                        });
                    }).concat([
                        (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(ErrorsField, {
                            key: "$ErrorsField"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(SubmitField, {
                            key: "$SubmitField"
                        })
                    ]);
                    return props;
                }
            },
            {
                key: "getAutoField",
                value: function getAutoField() {
                    return function() {
                        return null;
                    };
                }
            },
            {
                key: "getErrorsField",
                value: function getErrorsField() {
                    return function() {
                        return null;
                    };
                }
            },
            {
                key: "getSubmitField",
                value: function getSubmitField() {
                    return function() {
                        return null;
                    };
                }
            }
        ]);
        return QuickForm;
    }(Base);
    QuickForm.Quick = $6dbca1db06694253$export$50044cd6a929afcc;
    QuickForm.displayName = "Quick".concat(Base.displayName);
    return QuickForm;
}
var $6dbca1db06694253$export$fdcb8eab8950da = $6dbca1db06694253$export$50044cd6a929afcc((0, $d475f60013557f90$export$22578b9571b69853));



var $fI3zL = parcelRequire("fI3zL");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $b0PmO = parcelRequire("b0PmO");

var $l9BwU = parcelRequire("l9BwU");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");







function $07dcb0bfc3c3b27c$export$a9b332c95f881e8e(Base) {
    // @ts-expect-error: Mixin class problem.
    var ValidatedForm = /*#__PURE__*/ function(Base) {
        "use strict";
        (0, $fsOl6._)(ValidatedForm, Base);
        var _super = (0, $COJlH._)(ValidatedForm);
        function ValidatedForm(props) {
            (0, $h5oKP._)(this, ValidatedForm);
            var _this;
            _this = _super.call(this, props);
            _this.state = Object.assign(Object.assign({}, _this.state), {
                error: null,
                validate: false,
                validating: false,
                validator: _this.getContextSchema().getValidator(props.validator)
            });
            _this.onValidate = _this.validate = _this.onValidate.bind((0, $fI3zL._)(_this));
            _this.onValidateModel = _this.validateModel = _this.onValidateModel.bind((0, $fI3zL._)(_this));
            return _this;
        }
        (0, $85qwq._)(ValidatedForm, [
            {
                key: "getContextError",
                value: function getContextError() {
                    var _a;
                    return (_a = (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "getContextError", this).call(this)) !== null && _a !== void 0 ? _a : this.state.error;
                }
            },
            {
                key: "getContext",
                value: function getContext() {
                    return Object.assign(Object.assign({}, (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "getContext", this).call(this)), {
                        validating: this.state.validating
                    });
                }
            },
            {
                key: "getNativeFormProps",
                value: function getNativeFormProps() {
                    var props = (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "getNativeFormProps", this).call(this);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7c9902267b7d62d2$exports)))(props, [
                        "onValidate",
                        "validate",
                        "validator"
                    ]);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState, snapshot) {
                    var _this = this;
                    (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
                    var _this_props = this.props, model = _this_props.model, schema = _this_props.schema, validate = _this_props.validate, validator = _this_props.validator;
                    if (schema !== prevProps.schema || validator !== prevProps.validator) this.setState({
                        validator: schema.getValidator(validator)
                    }, function() {
                        if ($07dcb0bfc3c3b27c$var$shouldRevalidate(validate, _this.state.validate)) _this.onValidate();
                    });
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($95af5b22a3138aba$exports)))(model, prevProps.model) && $07dcb0bfc3c3b27c$var$shouldRevalidate(validate, this.state.validate)) this.onValidateModel(model);
                }
            },
            {
                key: "onChange",
                value: function onChange(key, value) {
                    if ($07dcb0bfc3c3b27c$var$shouldRevalidate(this.props.validate, this.state.validate)) this.onValidate(key, value);
                    (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "onChange", this).call(this, key, value);
                }
            },
            {
                key: "__reset",
                value: function __reset(state) {
                    return Object.assign(Object.assign({}, (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "__reset", this).call(this, state)), {
                        error: null,
                        validate: false,
                        validating: false
                    });
                }
            },
            {
                key: "onSubmit",
                value: function onSubmit(event) {
                    var _this = this;
                    if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    this.setState({
                        submitted: true,
                        validate: true
                    });
                    var result = this.onValidate().then(function(error) {
                        if (error !== null) return Promise.reject(error);
                        // Validation failed (i.e. returned an error), so no error is present
                        // both in the props nor the state.
                        return (0, $b0PmO._)((0, $l9BwU._)(ValidatedForm.prototype), "onSubmit", _this).call(_this).catch(function(error) {
                            _this.setState({
                                error: error
                            });
                            throw error;
                        });
                    });
                    result.catch((0, (/*@__PURE__*/$parcel$interopDefault($69f743c228cfa422$exports))));
                    return result;
                }
            },
            {
                key: "onValidate",
                value: function onValidate(key, value) {
                    var model = this.getContextModel();
                    if (model && key) model = (0, (/*@__PURE__*/$parcel$interopDefault($b9862b4041c79ab5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports)))(model), key, (0, (/*@__PURE__*/$parcel$interopDefault($97fd0f9b469320ff$exports)))(value), (0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports))));
                    return this.onValidateModel(model);
                }
            },
            {
                key: "onValidateModel",
                value: function onValidateModel(originalModel) {
                    var _this = this;
                    var model = this.getModel("validate", originalModel);
                    // Using `then` allows using the same code for both synchronous and
                    // asynchronous cases. We could use `await` here, but it would make all
                    // calls asynchronous, unnecessary delaying synchronous validation.
                    var then = $07dcb0bfc3c3b27c$var$makeThen(function() {
                        _this.setState({
                            validating: true
                        });
                    });
                    return then(this.state.validator(model), function() {
                        var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                        return then(_this.props.onValidate(model, error), function() {
                            var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                            var _a;
                            // Do not copy the error from props to the state.
                            error = _this.props.error === error ? null : error;
                            // If the whole operation was synchronous and resulted in the same
                            // error, we can skip the re-render.
                            _this.setState(function(state) {
                                return state.error === error && !state.validating ? null : {
                                    error: error,
                                    validating: false
                                };
                            });
                            // A predefined error takes precedence over the validation one.
                            return Promise.resolve((_a = _this.props.error) !== null && _a !== void 0 ? _a : error);
                        });
                    });
                }
            }
        ]);
        return ValidatedForm;
    }(Base);
    ValidatedForm.Validated = $07dcb0bfc3c3b27c$export$a9b332c95f881e8e;
    ValidatedForm.displayName = "Validated".concat(Base.displayName);
    ValidatedForm.defaultProps = Object.assign(Object.assign({}, Base.defaultProps), {
        onValidate: function(model, error) {
            return error;
        },
        validate: "onChangeAfterSubmit"
    });
    return ValidatedForm;
}
function $07dcb0bfc3c3b27c$var$makeThen(callIfAsync) {
    var then = function then(value, fn) {
        if (value instanceof Promise) {
            callIfAsync();
            return value.then(fn);
        }
        return fn(value);
    };
    return then;
}
function $07dcb0bfc3c3b27c$var$shouldRevalidate(inProps, inState) {
    return inProps === "onChange" || inProps === "onChangeAfterSubmit" && inState;
}
var $07dcb0bfc3c3b27c$export$f098293515c47e17 = $07dcb0bfc3c3b27c$export$a9b332c95f881e8e((0, $d475f60013557f90$export$22578b9571b69853));


var $091c27c4c16cb5b0$export$a4ef0f595403d451 = (0, $07dcb0bfc3c3b27c$export$a9b332c95f881e8e)((0, $6dbca1db06694253$export$50044cd6a929afcc)((0, $d475f60013557f90$export$22578b9571b69853)));


function $3e85351f3250197b$export$6cc2e70440926d44(Base) {
    // @ts-expect-error: Mixin class problem.
    var AutoForm = /*#__PURE__*/ function(Base) {
        "use strict";
        (0, $fsOl6._)(AutoForm, Base);
        var _super = (0, $COJlH._)(AutoForm);
        function AutoForm(props) {
            (0, $h5oKP._)(this, AutoForm);
            var _this;
            _this = _super.call(this, props);
            _this.state = Object.assign(Object.assign({}, _this.state), {
                model: props.model
            });
            return _this;
        }
        (0, $85qwq._)(AutoForm, [
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState, snapshot) {
                    var model = this.props.model;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($95af5b22a3138aba$exports)))(model, prevProps.model)) this.setState({
                        model: model
                    });
                    (0, $b0PmO._)((0, $l9BwU._)(AutoForm.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
                }
            },
            {
                key: "getNativeFormProps",
                value: function getNativeFormProps() {
                    var props = (0, $b0PmO._)((0, $l9BwU._)(AutoForm.prototype), "getNativeFormProps", this).call(this);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7c9902267b7d62d2$exports)))(props, [
                        "onChangeModel"
                    ]);
                }
            },
            {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                key: "getModel",
                value: function getModel(mode) {
                    return this.state.model;
                }
            },
            {
                key: "onChange",
                value: function onChange(key, value) {
                    var _this = this;
                    (0, $b0PmO._)((0, $l9BwU._)(AutoForm.prototype), "onChange", this).call(this, key, value);
                    this.setState(function(state) {
                        return {
                            model: (0, (/*@__PURE__*/$parcel$interopDefault($b9862b4041c79ab5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports)))(state.model), key, value, (0, (/*@__PURE__*/$parcel$interopDefault($f24f3a11667ff271$exports))))
                        };
                    }, function() {
                        if (_this.props.onChangeModel) _this.props.onChangeModel(_this.state.model);
                    });
                }
            },
            {
                key: "__reset",
                value: function __reset(state) {
                    return Object.assign(Object.assign({}, (0, $b0PmO._)((0, $l9BwU._)(AutoForm.prototype), "__reset", this).call(this, state)), {
                        model: this.props.model
                    });
                }
            }
        ]);
        return AutoForm;
    }(Base);
    AutoForm.Auto = $3e85351f3250197b$export$6cc2e70440926d44;
    AutoForm.displayName = "Auto".concat(Base.displayName);
    return AutoForm;
}
var $3e85351f3250197b$export$2dc5b0d03dd97d36 = $3e85351f3250197b$export$6cc2e70440926d44((0, $091c27c4c16cb5b0$export$a4ef0f595403d451));



var $h5oKP = parcelRequire("h5oKP");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");

function $98120dff82d98705$var$Unstyled(parent) {
    var _ = /*#__PURE__*/ function(parent) {
        "use strict";
        (0, $fsOl6._)(_, parent);
        var _super = (0, $COJlH._)(_);
        function _() {
            (0, $h5oKP._)(this, _);
            return _super.apply(this, arguments);
        }
        return _;
    }(parent);
    _.Unstyled = $98120dff82d98705$var$Unstyled;
    _.displayName = "Unstyled".concat(parent.displayName);
    return _;
}
var $98120dff82d98705$export$2e2bcd8739ae039 = $98120dff82d98705$var$Unstyled((0, $d475f60013557f90$export$22578b9571b69853));



var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");




var $4CEbD = parcelRequire("4CEbD");

function $45ce31264a09b45d$export$2e2bcd8739ae039(props) {
    var _useForm = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)(), error = _useForm.error, schema = _useForm.schema;
    return !error && !props.children ? null : (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", Object.assign({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), props.children, (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("ul", null, schema.getErrorMessages(error).map(function(message, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("li", {
            key: index
        }, message);
    })));
}



var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");

function $65f60446b2bd633e$export$2e2bcd8739ae039(_a) {
    var disabled = _a.disabled, inputRef = _a.inputRef, readOnly = _a.readOnly, value = _a.value, props = (0, $nLPsB.__rest)(_a, [
        "disabled",
        "inputRef",
        "readOnly",
        "value"
    ]);
    var _useForm = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)(), error = _useForm.error, state = _useForm.state;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", Object.assign({
        disabled: disabled === undefined ? !!(error || state.disabled) : disabled,
        readOnly: readOnly,
        ref: inputRef,
        type: "submit"
    }, value ? {
        value: value
    } : {}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)));
}


function $6e572869da24ae86$var$Quick(parent) {
    var _ = /*#__PURE__*/ function(_QuickForm_Quick) {
        "use strict";
        (0, $fsOl6._)(_, _QuickForm_Quick);
        var _super = (0, $COJlH._)(_);
        function _() {
            (0, $h5oKP._)(this, _);
            return _super.apply(this, arguments);
        }
        (0, $85qwq._)(_, [
            {
                key: "getAutoField",
                value: function getAutoField() {
                    return 0, $09e5a41aaaf9fea5$export$2e2bcd8739ae039;
                }
            },
            {
                key: "getErrorsField",
                value: function getErrorsField() {
                    return 0, $45ce31264a09b45d$export$2e2bcd8739ae039;
                }
            },
            {
                key: "getSubmitField",
                value: function getSubmitField() {
                    return 0, $65f60446b2bd633e$export$2e2bcd8739ae039;
                }
            }
        ]);
        return _;
    }((0, $6dbca1db06694253$export$fdcb8eab8950da).Quick(parent));
    _.Quick = $6e572869da24ae86$var$Quick;
    return _;
}
var $6e572869da24ae86$export$2e2bcd8739ae039 = $6e572869da24ae86$var$Quick((0, $98120dff82d98705$export$2e2bcd8739ae039));



var $h5oKP = parcelRequire("h5oKP");

var $fsOl6 = parcelRequire("fsOl6");

var $COJlH = parcelRequire("COJlH");


function $b67221ee22c0f51b$var$Validated(parent) {
    var _ = /*#__PURE__*/ function(_ValidatedForm_Validated) {
        "use strict";
        (0, $fsOl6._)(_, _ValidatedForm_Validated);
        var _super = (0, $COJlH._)(_);
        function _() {
            (0, $h5oKP._)(this, _);
            return _super.apply(this, arguments);
        }
        return _;
    }((0, $07dcb0bfc3c3b27c$export$f098293515c47e17).Validated(parent));
    _.Validated = $b67221ee22c0f51b$var$Validated;
    return _;
}
var $b67221ee22c0f51b$export$2e2bcd8739ae039 = $b67221ee22c0f51b$var$Validated((0, $98120dff82d98705$export$2e2bcd8739ae039));


var $618f79bea0b6a45b$export$2e2bcd8739ae039 = (0, $b67221ee22c0f51b$export$2e2bcd8739ae039).Validated((0, $6e572869da24ae86$export$2e2bcd8739ae039).Quick((0, $98120dff82d98705$export$2e2bcd8739ae039)));


function $79fba9cf15c0fe25$var$Auto(parent) {
    var _ = /*#__PURE__*/ function(_AutoForm_Auto) {
        "use strict";
        (0, $fsOl6._)(_, _AutoForm_Auto);
        var _super = (0, $COJlH._)(_);
        function _() {
            (0, $h5oKP._)(this, _);
            return _super.apply(this, arguments);
        }
        return _;
    }((0, $3e85351f3250197b$export$2dc5b0d03dd97d36).Auto(parent));
    _.Auto = $79fba9cf15c0fe25$var$Auto;
    return _;
}
var $79fba9cf15c0fe25$export$2e2bcd8739ae039 = $79fba9cf15c0fe25$var$Auto((0, $618f79bea0b6a45b$export$2e2bcd8739ae039));




var $4CEbD = parcelRequire("4CEbD");
var $a49ec1ca611a122d$exports = {};

$parcel$export($a49ec1ca611a122d$exports, "default", function () { return $a49ec1ca611a122d$export$2e2bcd8739ae039; });


var $4CEbD = parcelRequire("4CEbD");

var $a49ec1ca611a122d$var$_this = undefined;
var $a49ec1ca611a122d$var$SubmitButton = function(param) {
    var cb = param.cb, caption = param.caption, buttonClasses = param.buttonClasses;
    var _useForm = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)(), error = _useForm.error, disabled = _useForm.state.disabled, submitting = _useForm.submitting, model = _useForm.model, validating = _useForm.validating;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        disabled: !!error || disabled || submitting || validating,
        onClick: cb && cb.bind($a49ec1ca611a122d$var$_this, model),
        className: buttonClasses
    }, caption || "Sent");
};
$a49ec1ca611a122d$var$SubmitButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string
};
var $a49ec1ca611a122d$export$2e2bcd8739ae039 = $a49ec1ca611a122d$var$SubmitButton;






var $4ig53 = parcelRequire("4ig53");

var $hF4Ve = parcelRequire("hF4Ve");

var $hF4Ve = parcelRequire("hF4Ve");

var $cpUXF = parcelRequire("cpUXF");
function $1880755912401988$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $535636d8023070c8$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $1880755912401988$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $4CEbD = parcelRequire("4CEbD");


var $c7366cb85585295d$var$ParentField = function(_param) {
    var //id,
    label = _param.label, description = _param.description, active = _param.active, // eslint-disable-next-line no-unused-vars
    fieldInfo = _param.fieldInfo, children = _param.children, cardClassName = _param.cardClassName, props = (0, $535636d8023070c8$export$69fdd232f62cde60)(_param, [
        "label",
        "description",
        "active",
        "fieldInfo",
        "children",
        "cardClassName"
    ]);
    //console.log("ParentField", cardClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", (0, $cpUXF._)((0, $hF4Ve._)({}, (0, $31d512228acba053$export$457c3d6518dd4c6f)(props)), {
        key: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))(cardClassName, "qanda__form", {
            "qanda__form--active": active
        })
    }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("qanda__question", {
            "qanda__question--active": active
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "qanda__question__text"
    }, label, " "), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "qanda__question__subtext is-info"
    }, description)), children);
};
$c7366cb85585295d$var$ParentField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
};
var $c7366cb85585295d$export$2e2bcd8739ae039 = $c7366cb85585295d$var$ParentField;




var $4CEbD = parcelRequire("4CEbD");



var $d7ba6eb4b61438f9$var$CheckboxSelectField = function(param) {
    var //allowedValues,
    ///checkboxes,
    disabled = param.disabled, componentClasses = param.componentClasses, //cardClassName,
    onChange = param.onChange, description = param.description, fieldType = param.fieldType, id = param.id, //inputRef,
    fieldInfo = param.fieldInfo, label = param.label, readOnly = param.readOnly, //required,
    disableItem = param.disableItem, options = param.options, value = param.value;
    //console.log("CheckboxSelectField yy01", value, fieldType);
    var multiple = fieldType === Array;
    var handleClick = function(toggleValue) {
        //console.log("handleClick yy011", value, toggleValue);
        if (readOnly) return;
        var newValue;
        if (multiple) newValue = (0, $11c013bdbcf83901$export$6e25e485871219d8)(value.slice(), toggleValue);
        else newValue = toggleValue;
        //console.log("handleClick", newValue, toggleValue);
        onChange(newValue);
    };
    var renderElements = function() {
        //console.log("checkboxSelectFiled->render yy01", value, disabled, disableItem, options);
        return options.map(function(element) {
            if (!disabled || !disableItem.includes(element.value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($d7ba6eb4b61438f9$var$CheckboxSelectFieldElement, (0, $hF4Ve._)({
                key: element.value,
                onClick: handleClick,
                active: multiple ? value.includes(element.value) : value === element.value,
                multiple: multiple
            }, element));
        });
    };
    //console.log("checkboxSelectField", componentClasses);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $c7366cb85585295d$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        description: description,
        active: multiple ? value.length > 0 : value !== "" && value !== undefined,
        fieldInfo: fieldInfo,
        cardClassName: (multiple ? "qanda__checks qanda__form " : " qanda__radio qanda__form ") + " " + componentClasses
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "qanda__answers"
    }, renderElements()));
};
$d7ba6eb4b61438f9$var$CheckboxSelectField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    allowedValues: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    disableItem: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    checkboxes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    fieldType: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    componentClasses: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string
    }))
};
var $d7ba6eb4b61438f9$var$CheckboxSelectFieldElement = function(param) {
    var title = param.title, value = param.value, label = param.label, active = param.active, multiple = param.multiple, onClick = param.onClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))({
            "radio qanda__checkradio": !multiple
        }, {
            "checkbox qanda__checkradio": multiple
        }, {
            "qanda__checkradio--active": active
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        onChange: function() {
            return onClick(value);
        },
        className: "qanda__checkradio__input",
        checked: active,
        type: multiple ? "checkbox" : "radio",
        name: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "qanda__checkradio__box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-check"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "qanda__checkradio__text"
    }, label));
};
$d7ba6eb4b61438f9$var$CheckboxSelectFieldElement.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func
};
var $d7ba6eb4b61438f9$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($d7ba6eb4b61438f9$var$CheckboxSelectField, {
    kind: "leaf"
});






var $4CEbD = parcelRequire("4CEbD");


var $fe4a11037def31c1$var$Text = function(_param) {
    var autoComplete = _param.autoComplete, disabled = _param.disabled, id = _param.id, inputRef = _param.inputRef, label = _param.label, name = _param.name, onChange = _param.onChange, placeholder = _param.placeholder, readOnly = _param.readOnly, type = _param.type, value = _param.value, inputClassName = _param.inputClassName, error = _param.error, description = _param.description, fieldInfo = _param.fieldInfo, props = (0, $535636d8023070c8$export$69fdd232f62cde60)(_param, [
        "autoComplete",
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "type",
        "value",
        "inputClassName",
        "error",
        "description",
        "fieldInfo"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $c7366cb85585295d$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        description: description,
        fieldInfo: fieldInfo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: function(event) {
            return onChange(event.target.value);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : "",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))(inputClassName, {
            invalid: error && props.showInlineError
        })
    }));
};
$fe4a11037def31c1$var$Text.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
};
$fe4a11037def31c1$var$Text.defaultProps = {
    type: "text",
    value: ""
};
var $fe4a11037def31c1$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($fe4a11037def31c1$var$Text, {
    kind: "leaf"
});



(0, $31d512228acba053$export$457c3d6518dd4c6f).register("minCount", "maxCount");



var $fI3zL = parcelRequire("fI3zL");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $2MVSR = parcelRequire("2MVSR");

var $h9dQc = parcelRequire("h9dQc");

var $COJlH = parcelRequire("COJlH");

var $nLPsB = parcelRequire("nLPsB");



var $04341c11f28e29b4$exports = {};






var $6mwXD = parcelRequire("6mwXD");


/** `Object#toString` result references. */ var $04341c11f28e29b4$var$mapTag = "[object Map]", $04341c11f28e29b4$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $04341c11f28e29b4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $04341c11f28e29b4$var$hasOwnProperty = $04341c11f28e29b4$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $04341c11f28e29b4$var$isEmpty(value) {
    if (value == null) return true;
    if ($5289076331bcb123$exports(value) && ($47c989dafa9cb12c$exports(value) || typeof value == "string" || typeof value.splice == "function" || $6mwXD(value) || $9f89439f13f7838a$exports(value) || $e2c917fa60f1eb65$exports(value))) return !value.length;
    var tag = $50a3080f6298a726$exports(value);
    if (tag == $04341c11f28e29b4$var$mapTag || tag == $04341c11f28e29b4$var$setTag) return !value.size;
    if ($8c7fbfc207c28d0e$exports(value)) return !$ea9830a0fc975eb2$exports(value).length;
    for(var key in value){
        if ($04341c11f28e29b4$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
$04341c11f28e29b4$exports = $04341c11f28e29b4$var$isEmpty;


var $93ec838255f20470$exports = {};
var $434fff1d6a6b98f0$exports = {};
var $89abdb0e63dc3c12$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $89abdb0e63dc3c12$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$89abdb0e63dc3c12$exports = $89abdb0e63dc3c12$var$arrayReduce;


var $244da22eaf92565b$exports = {};
var $977091544359c4c8$exports = {};
var $e3322aa0119ef040$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e3322aa0119ef040$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$e3322aa0119ef040$exports = $e3322aa0119ef040$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $977091544359c4c8$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $977091544359c4c8$var$deburrLetter = $e3322aa0119ef040$exports($977091544359c4c8$var$deburredLetters);
$977091544359c4c8$exports = $977091544359c4c8$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $244da22eaf92565b$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $244da22eaf92565b$var$rsComboMarksRange = "\\u0300-\\u036f", $244da22eaf92565b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $244da22eaf92565b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $244da22eaf92565b$var$rsComboRange = $244da22eaf92565b$var$rsComboMarksRange + $244da22eaf92565b$var$reComboHalfMarksRange + $244da22eaf92565b$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $244da22eaf92565b$var$rsCombo = "[" + $244da22eaf92565b$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $244da22eaf92565b$var$reComboMark = RegExp($244da22eaf92565b$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $244da22eaf92565b$var$deburr(string) {
    string = $9e1d48e296702c3c$exports(string);
    return string && string.replace($244da22eaf92565b$var$reLatin, $977091544359c4c8$exports).replace($244da22eaf92565b$var$reComboMark, "");
}
$244da22eaf92565b$exports = $244da22eaf92565b$var$deburr;


var $60a8426e0a8a31f8$exports = {};
var $15fb4ed171811085$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $15fb4ed171811085$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $15fb4ed171811085$var$asciiWords(string) {
    return string.match($15fb4ed171811085$var$reAsciiWord) || [];
}
$15fb4ed171811085$exports = $15fb4ed171811085$var$asciiWords;


var $d8d407e4b36a1832$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $d8d407e4b36a1832$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d8d407e4b36a1832$var$hasUnicodeWord(string) {
    return $d8d407e4b36a1832$var$reHasUnicodeWord.test(string);
}
$d8d407e4b36a1832$exports = $d8d407e4b36a1832$var$hasUnicodeWord;



var $f3b0bb4ce85edd82$exports = {};
/** Used to compose unicode character classes. */ var $f3b0bb4ce85edd82$var$rsAstralRange = "\ud800-\udfff", $f3b0bb4ce85edd82$var$rsComboMarksRange = "\\u0300-\\u036f", $f3b0bb4ce85edd82$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $f3b0bb4ce85edd82$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $f3b0bb4ce85edd82$var$rsComboRange = $f3b0bb4ce85edd82$var$rsComboMarksRange + $f3b0bb4ce85edd82$var$reComboHalfMarksRange + $f3b0bb4ce85edd82$var$rsComboSymbolsRange, $f3b0bb4ce85edd82$var$rsDingbatRange = "\\u2700-\\u27bf", $f3b0bb4ce85edd82$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $f3b0bb4ce85edd82$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $f3b0bb4ce85edd82$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $f3b0bb4ce85edd82$var$rsPunctuationRange = "\\u2000-\\u206f", $f3b0bb4ce85edd82$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $f3b0bb4ce85edd82$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $f3b0bb4ce85edd82$var$rsVarRange = "\\ufe0e\\ufe0f", $f3b0bb4ce85edd82$var$rsBreakRange = $f3b0bb4ce85edd82$var$rsMathOpRange + $f3b0bb4ce85edd82$var$rsNonCharRange + $f3b0bb4ce85edd82$var$rsPunctuationRange + $f3b0bb4ce85edd82$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $f3b0bb4ce85edd82$var$rsApos = "['’]", $f3b0bb4ce85edd82$var$rsBreak = "[" + $f3b0bb4ce85edd82$var$rsBreakRange + "]", $f3b0bb4ce85edd82$var$rsCombo = "[" + $f3b0bb4ce85edd82$var$rsComboRange + "]", $f3b0bb4ce85edd82$var$rsDigits = "\\d+", $f3b0bb4ce85edd82$var$rsDingbat = "[" + $f3b0bb4ce85edd82$var$rsDingbatRange + "]", $f3b0bb4ce85edd82$var$rsLower = "[" + $f3b0bb4ce85edd82$var$rsLowerRange + "]", $f3b0bb4ce85edd82$var$rsMisc = "[^" + $f3b0bb4ce85edd82$var$rsAstralRange + $f3b0bb4ce85edd82$var$rsBreakRange + $f3b0bb4ce85edd82$var$rsDigits + $f3b0bb4ce85edd82$var$rsDingbatRange + $f3b0bb4ce85edd82$var$rsLowerRange + $f3b0bb4ce85edd82$var$rsUpperRange + "]", $f3b0bb4ce85edd82$var$rsFitz = "\ud83c[\udffb-\udfff]", $f3b0bb4ce85edd82$var$rsModifier = "(?:" + $f3b0bb4ce85edd82$var$rsCombo + "|" + $f3b0bb4ce85edd82$var$rsFitz + ")", $f3b0bb4ce85edd82$var$rsNonAstral = "[^" + $f3b0bb4ce85edd82$var$rsAstralRange + "]", $f3b0bb4ce85edd82$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $f3b0bb4ce85edd82$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $f3b0bb4ce85edd82$var$rsUpper = "[" + $f3b0bb4ce85edd82$var$rsUpperRange + "]", $f3b0bb4ce85edd82$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $f3b0bb4ce85edd82$var$rsMiscLower = "(?:" + $f3b0bb4ce85edd82$var$rsLower + "|" + $f3b0bb4ce85edd82$var$rsMisc + ")", $f3b0bb4ce85edd82$var$rsMiscUpper = "(?:" + $f3b0bb4ce85edd82$var$rsUpper + "|" + $f3b0bb4ce85edd82$var$rsMisc + ")", $f3b0bb4ce85edd82$var$rsOptContrLower = "(?:" + $f3b0bb4ce85edd82$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $f3b0bb4ce85edd82$var$rsOptContrUpper = "(?:" + $f3b0bb4ce85edd82$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $f3b0bb4ce85edd82$var$reOptMod = $f3b0bb4ce85edd82$var$rsModifier + "?", $f3b0bb4ce85edd82$var$rsOptVar = "[" + $f3b0bb4ce85edd82$var$rsVarRange + "]?", $f3b0bb4ce85edd82$var$rsOptJoin = "(?:" + $f3b0bb4ce85edd82$var$rsZWJ + "(?:" + [
    $f3b0bb4ce85edd82$var$rsNonAstral,
    $f3b0bb4ce85edd82$var$rsRegional,
    $f3b0bb4ce85edd82$var$rsSurrPair
].join("|") + ")" + $f3b0bb4ce85edd82$var$rsOptVar + $f3b0bb4ce85edd82$var$reOptMod + ")*", $f3b0bb4ce85edd82$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $f3b0bb4ce85edd82$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $f3b0bb4ce85edd82$var$rsSeq = $f3b0bb4ce85edd82$var$rsOptVar + $f3b0bb4ce85edd82$var$reOptMod + $f3b0bb4ce85edd82$var$rsOptJoin, $f3b0bb4ce85edd82$var$rsEmoji = "(?:" + [
    $f3b0bb4ce85edd82$var$rsDingbat,
    $f3b0bb4ce85edd82$var$rsRegional,
    $f3b0bb4ce85edd82$var$rsSurrPair
].join("|") + ")" + $f3b0bb4ce85edd82$var$rsSeq;
/** Used to match complex or compound words. */ var $f3b0bb4ce85edd82$var$reUnicodeWord = RegExp([
    $f3b0bb4ce85edd82$var$rsUpper + "?" + $f3b0bb4ce85edd82$var$rsLower + "+" + $f3b0bb4ce85edd82$var$rsOptContrLower + "(?=" + [
        $f3b0bb4ce85edd82$var$rsBreak,
        $f3b0bb4ce85edd82$var$rsUpper,
        "$"
    ].join("|") + ")",
    $f3b0bb4ce85edd82$var$rsMiscUpper + "+" + $f3b0bb4ce85edd82$var$rsOptContrUpper + "(?=" + [
        $f3b0bb4ce85edd82$var$rsBreak,
        $f3b0bb4ce85edd82$var$rsUpper + $f3b0bb4ce85edd82$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $f3b0bb4ce85edd82$var$rsUpper + "?" + $f3b0bb4ce85edd82$var$rsMiscLower + "+" + $f3b0bb4ce85edd82$var$rsOptContrLower,
    $f3b0bb4ce85edd82$var$rsUpper + "+" + $f3b0bb4ce85edd82$var$rsOptContrUpper,
    $f3b0bb4ce85edd82$var$rsOrdUpper,
    $f3b0bb4ce85edd82$var$rsOrdLower,
    $f3b0bb4ce85edd82$var$rsDigits,
    $f3b0bb4ce85edd82$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $f3b0bb4ce85edd82$var$unicodeWords(string) {
    return string.match($f3b0bb4ce85edd82$var$reUnicodeWord) || [];
}
$f3b0bb4ce85edd82$exports = $f3b0bb4ce85edd82$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $60a8426e0a8a31f8$var$words(string, pattern, guard) {
    string = $9e1d48e296702c3c$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $d8d407e4b36a1832$exports(string) ? $f3b0bb4ce85edd82$exports(string) : $15fb4ed171811085$exports(string);
    return string.match(pattern) || [];
}
$60a8426e0a8a31f8$exports = $60a8426e0a8a31f8$var$words;


/** Used to compose unicode capture groups. */ var $434fff1d6a6b98f0$var$rsApos = "['’]";
/** Used to match apostrophes. */ var $434fff1d6a6b98f0$var$reApos = RegExp($434fff1d6a6b98f0$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $434fff1d6a6b98f0$var$createCompounder(callback) {
    return function(string) {
        return $89abdb0e63dc3c12$exports($60a8426e0a8a31f8$exports($244da22eaf92565b$exports(string).replace($434fff1d6a6b98f0$var$reApos, "")), callback, "");
    };
}
$434fff1d6a6b98f0$exports = $434fff1d6a6b98f0$var$createCompounder;


/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */ var $93ec838255f20470$var$lowerCase = $434fff1d6a6b98f0$exports(function(result, word, index) {
    return result + (index ? " " : "") + word.toLowerCase();
});
$93ec838255f20470$exports = $93ec838255f20470$var$lowerCase;



var $08a287f54fc76c80$exports = {};
var $d1bfd612aabeef1f$exports = {};
var $c33ec43add2831d0$exports = {};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $c33ec43add2831d0$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $51950ac2857e7c55$exports(array, start, end);
}
$c33ec43add2831d0$exports = $c33ec43add2831d0$var$castSlice;


var $1a2b8a9a904254f9$exports = {};
/** Used to compose unicode character classes. */ var $1a2b8a9a904254f9$var$rsAstralRange = "\ud800-\udfff", $1a2b8a9a904254f9$var$rsComboMarksRange = "\\u0300-\\u036f", $1a2b8a9a904254f9$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $1a2b8a9a904254f9$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $1a2b8a9a904254f9$var$rsComboRange = $1a2b8a9a904254f9$var$rsComboMarksRange + $1a2b8a9a904254f9$var$reComboHalfMarksRange + $1a2b8a9a904254f9$var$rsComboSymbolsRange, $1a2b8a9a904254f9$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $1a2b8a9a904254f9$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1a2b8a9a904254f9$var$reHasUnicode = RegExp("[" + $1a2b8a9a904254f9$var$rsZWJ + $1a2b8a9a904254f9$var$rsAstralRange + $1a2b8a9a904254f9$var$rsComboRange + $1a2b8a9a904254f9$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1a2b8a9a904254f9$var$hasUnicode(string) {
    return $1a2b8a9a904254f9$var$reHasUnicode.test(string);
}
$1a2b8a9a904254f9$exports = $1a2b8a9a904254f9$var$hasUnicode;


var $510b0af646f36a66$exports = {};
var $f7054ec1293af8c4$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f7054ec1293af8c4$var$asciiToArray(string) {
    return string.split("");
}
$f7054ec1293af8c4$exports = $f7054ec1293af8c4$var$asciiToArray;



var $2deb7d04bd496d2a$exports = {};
/** Used to compose unicode character classes. */ var $2deb7d04bd496d2a$var$rsAstralRange = "\ud800-\udfff", $2deb7d04bd496d2a$var$rsComboMarksRange = "\\u0300-\\u036f", $2deb7d04bd496d2a$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $2deb7d04bd496d2a$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $2deb7d04bd496d2a$var$rsComboRange = $2deb7d04bd496d2a$var$rsComboMarksRange + $2deb7d04bd496d2a$var$reComboHalfMarksRange + $2deb7d04bd496d2a$var$rsComboSymbolsRange, $2deb7d04bd496d2a$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $2deb7d04bd496d2a$var$rsAstral = "[" + $2deb7d04bd496d2a$var$rsAstralRange + "]", $2deb7d04bd496d2a$var$rsCombo = "[" + $2deb7d04bd496d2a$var$rsComboRange + "]", $2deb7d04bd496d2a$var$rsFitz = "\ud83c[\udffb-\udfff]", $2deb7d04bd496d2a$var$rsModifier = "(?:" + $2deb7d04bd496d2a$var$rsCombo + "|" + $2deb7d04bd496d2a$var$rsFitz + ")", $2deb7d04bd496d2a$var$rsNonAstral = "[^" + $2deb7d04bd496d2a$var$rsAstralRange + "]", $2deb7d04bd496d2a$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $2deb7d04bd496d2a$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $2deb7d04bd496d2a$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $2deb7d04bd496d2a$var$reOptMod = $2deb7d04bd496d2a$var$rsModifier + "?", $2deb7d04bd496d2a$var$rsOptVar = "[" + $2deb7d04bd496d2a$var$rsVarRange + "]?", $2deb7d04bd496d2a$var$rsOptJoin = "(?:" + $2deb7d04bd496d2a$var$rsZWJ + "(?:" + [
    $2deb7d04bd496d2a$var$rsNonAstral,
    $2deb7d04bd496d2a$var$rsRegional,
    $2deb7d04bd496d2a$var$rsSurrPair
].join("|") + ")" + $2deb7d04bd496d2a$var$rsOptVar + $2deb7d04bd496d2a$var$reOptMod + ")*", $2deb7d04bd496d2a$var$rsSeq = $2deb7d04bd496d2a$var$rsOptVar + $2deb7d04bd496d2a$var$reOptMod + $2deb7d04bd496d2a$var$rsOptJoin, $2deb7d04bd496d2a$var$rsSymbol = "(?:" + [
    $2deb7d04bd496d2a$var$rsNonAstral + $2deb7d04bd496d2a$var$rsCombo + "?",
    $2deb7d04bd496d2a$var$rsCombo,
    $2deb7d04bd496d2a$var$rsRegional,
    $2deb7d04bd496d2a$var$rsSurrPair,
    $2deb7d04bd496d2a$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $2deb7d04bd496d2a$var$reUnicode = RegExp($2deb7d04bd496d2a$var$rsFitz + "(?=" + $2deb7d04bd496d2a$var$rsFitz + ")|" + $2deb7d04bd496d2a$var$rsSymbol + $2deb7d04bd496d2a$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2deb7d04bd496d2a$var$unicodeToArray(string) {
    return string.match($2deb7d04bd496d2a$var$reUnicode) || [];
}
$2deb7d04bd496d2a$exports = $2deb7d04bd496d2a$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $510b0af646f36a66$var$stringToArray(string) {
    return $1a2b8a9a904254f9$exports(string) ? $2deb7d04bd496d2a$exports(string) : $f7054ec1293af8c4$exports(string);
}
$510b0af646f36a66$exports = $510b0af646f36a66$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d1bfd612aabeef1f$var$createCaseFirst(methodName) {
    return function(string) {
        string = $9e1d48e296702c3c$exports(string);
        var strSymbols = $1a2b8a9a904254f9$exports(string) ? $510b0af646f36a66$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $c33ec43add2831d0$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$d1bfd612aabeef1f$exports = $d1bfd612aabeef1f$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $08a287f54fc76c80$var$upperFirst = $d1bfd612aabeef1f$exports("toUpperCase");
$08a287f54fc76c80$exports = $08a287f54fc76c80$var$upperFirst;



var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $6d89047d2ce7d196$export$68a44d00957434e6 = /*#__PURE__*/ function() {
    "use strict";
    function Bridge() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $h5oKP._)(this, Bridge);
        (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(this.constructor !== Bridge, "Bridge cannot be instantiated (args=%o).", {
            args: args
        });
    }
    (0, $85qwq._)(Bridge, [
        {
            // Get an error for field `name` out of `error`. There is no standarized
            // format, but fields treat truthy values as a sign of being invalid. Fields
            // receive this as a `error` guaranteed prop.
            key: "getError",
            value: function getError(name, error) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getError` method (args=%o).", this.constructor.name, {
                    name: name,
                    error: error
                });
            }
        },
        {
            // Get an error message for field `name` out of `error`. If there is no error,
            // return an empty string. Fields receive this as a `errorMessage` guaranteed
            // prop.
            key: "getErrorMessage",
            value: function getErrorMessage(name, error) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getErrorMessage` method (args=%o).", this.constructor.name, {
                    name: name,
                    error: error
                });
            }
        },
        {
            // Get all error messages from `error`. Only `ErrorsField` make use of that
            // (in builtin themes).
            key: "getErrorMessages",
            value: function getErrorMessages(error) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getErrorMessages` method (args=%o).", this.constructor.name, {
                    error: error
                });
            }
        },
        {
            // Get internal field definition for field `name`. Fields receive this as a
            // `field` guaranteed prop.
            key: "getField",
            value: function getField(name) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getField` method (args=%o).", this.constructor.name, {
                    name: name
                });
            }
        },
        {
            // Get initial value of field `name`. It is used as a default when no value is
            // set (e.g. the form is rendered with an empty `model`). Additionally,
            // `props` are this field instance props. If a field is rendered multiple
            // times, this function will be called multiple times, possibly with different
            // `props`.
            key: "getInitialValue",
            value: function getInitialValue(name, props) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getInitialValue` method (args=%o).", this.constructor.name, {
                    name: name,
                    props: props
                });
            }
        },
        {
            // Get props defined in schema for a field `name`. There are no required nor
            // banned fields, however properties like `required` are often available.
            // Additionally, `props` are this field instance props. If a field is rendered
            // multiple times, this function will be called multiple times, possibly with
            // different `props`.
            key: "getProps",
            value: function getProps(name, props) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getProps` method (args=%o).", this.constructor.name, {
                    name: name,
                    props: props
                });
            }
        },
        {
            // Get a list of subfields of field `name` or top-level fields, if no `name`
            // is passed.
            key: "getSubfields",
            value: function getSubfields(name) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getSubfields` method (args=%o).", this.constructor.name, {
                    name: name
                });
            }
        },
        {
            // Get a type of field `name`. See `FieldTypeType` for details.
            key: "getType",
            value: function getType(name) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getType` method (args=%o).", this.constructor.name, {
                    name: name
                });
            }
        },
        {
            // Get a validator function. The `options` here are from the `validator` prop
            // of the form. A validator function receives a model and returns an error or
            // a promise that will resolve (not reject!) with an error. If there is no
            // error, return (or resolve with) a `null` value instead.
            // eslint-disable-next-line prettier/prettier
            key: "getValidator",
            value: function getValidator(options) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(false, "%s have not implemented `getValidator` method (args=%o).", this.constructor.name, {
                    options: options
                });
            }
        }
    ]);
    return Bridge;
}();


function $8f967e0328426a59$var$fieldInvariant(name, condition) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(condition, 'Field not found in schema: "%s"', name);
}
function $8f967e0328426a59$var$resolveRef(reference, schema) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(reference.startsWith("#"), 'Reference is not an internal reference, and only such are allowed: "%s"', reference);
    var resolvedReference = reference.split("/").filter(function(part) {
        return part && part !== "#";
    }).reduce(function(definition, next) {
        return definition[next];
    }, schema);
    (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(resolvedReference, 'Reference not found in schema: "%s"', reference);
    return resolvedReference;
}
function $8f967e0328426a59$var$resolveRefIfNeeded(partial, schema) {
    if (!("$ref" in partial)) return partial;
    var $ref = partial.$ref, partialWithoutRef = (0, $nLPsB.__rest)(partial, [
        "$ref"
    ]);
    return $8f967e0328426a59$var$resolveRefIfNeeded(Object.assign({}, partialWithoutRef, $8f967e0328426a59$var$resolveRef($ref, schema)), schema);
}
var $8f967e0328426a59$var$partialNames = [
    "allOf",
    "anyOf",
    "oneOf"
];
var $8f967e0328426a59$var$propsToRemove = [
    "default",
    "enum",
    "format",
    "isRequired",
    "title",
    "uniforms"
];
var $8f967e0328426a59$var$propsToRename = [
    [
        "maxItems",
        "maxCount"
    ],
    [
        "maximum",
        "max"
    ],
    [
        "minItems",
        "minCount"
    ],
    [
        "minimum",
        "min"
    ],
    [
        "multipleOf",
        "step"
    ]
];
function $8f967e0328426a59$var$pathToName(path) {
    path = path.startsWith("/") ? path.replace(/\//g, ".").replace(/~0/g, "~").replace(/~1/g, "/") : path.replace(/\[('|")(.+?)\1\]/g, ".$2").replace(/\[(.+?)\]/g, ".$1").replace(/\\'/g, "'");
    return path.slice(1);
}
var $8f967e0328426a59$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Bridge) {
    "use strict";
    (0, $fsOl6._)(JSONSchemaBridge, Bridge);
    var _super = (0, $COJlH._)(JSONSchemaBridge);
    function JSONSchemaBridge(schema, validator) {
        (0, $h5oKP._)(this, JSONSchemaBridge);
        var _this;
        _this = _super.call(this);
        _this.validator = validator;
        _this.schema = $8f967e0328426a59$var$resolveRefIfNeeded(schema, schema);
        _this._compiledSchema = {
            "": _this.schema
        };
        // Memoize for performance and referential equality.
        _this.getField = (0, (/*@__PURE__*/$parcel$interopDefault($ca4770dca2739e7a$exports)))(_this.getField.bind((0, $fI3zL._)(_this)));
        _this.getSubfields = (0, (/*@__PURE__*/$parcel$interopDefault($ca4770dca2739e7a$exports)))(_this.getSubfields.bind((0, $fI3zL._)(_this)));
        _this.getType = (0, (/*@__PURE__*/$parcel$interopDefault($ca4770dca2739e7a$exports)))(_this.getType.bind((0, $fI3zL._)(_this)));
        return _this;
    }
    (0, $85qwq._)(JSONSchemaBridge, [
        {
            key: "getError",
            value: function getError(name, error) {
                var details = error === null || error === void 0 ? void 0 : error.details;
                if (!Array.isArray(details)) return null;
                var nameParts = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(null, name).map((0, $dd253ebacef58316$export$c8987bb64f9a8b89).unescape);
                var unescapedName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(nameParts);
                var rootName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
                var baseName = nameParts[nameParts.length - 1];
                var scopedError = details.find(function(error) {
                    var _a;
                    var path = $8f967e0328426a59$var$pathToName((_a = error.instancePath) !== null && _a !== void 0 ? _a : error.dataPath);
                    return unescapedName === path || rootName === path && baseName === error.params.missingProperty;
                });
                return scopedError || null;
            }
        },
        {
            key: "getErrorMessage",
            value: function getErrorMessage(name, error) {
                var scopedError = this.getError(name, error);
                return (scopedError === null || scopedError === void 0 ? void 0 : scopedError.message) || "";
            }
        },
        {
            key: "getErrorMessages",
            value: function getErrorMessages(error) {
                if (!error) return [];
                var details = error.details;
                return Array.isArray(details) ? details.map(function(error) {
                    return error.message;
                }) : [
                    error.message || error
                ];
            }
        },
        {
            key: "getField",
            value: function getField(name) {
                var _this = this;
                return (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(null, name).reduce(function(definition, next, index, array) {
                    var _a, _b, _c;
                    var _d;
                    var prevName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(array.slice(0, index));
                    var nextName = (0, $dd253ebacef58316$export$c8987bb64f9a8b89)(prevName, next);
                    var definitionCache = (_a = (_d = _this._compiledSchema)[nextName]) !== null && _a !== void 0 ? _a : _d[nextName] = {};
                    definitionCache.isRequired = !!(((_b = definition.required) === null || _b === void 0 ? void 0 : _b.includes(next)) || ((_c = _this._compiledSchema[prevName].required) === null || _c === void 0 ? void 0 : _c.includes(next)));
                    if (next === "$" || next === "" + parseInt(next, 10)) {
                        $8f967e0328426a59$var$fieldInvariant(name, definition.type === "array");
                        definition = Array.isArray(definition.items) ? definition.items[parseInt(next, 10)] : definition.items;
                        $8f967e0328426a59$var$fieldInvariant(name, !!definition);
                    } else if (definition.type === "object") {
                        $8f967e0328426a59$var$fieldInvariant(name, !!definition.properties);
                        definition = definition.properties[(0, $dd253ebacef58316$export$c8987bb64f9a8b89).unescape(next)];
                        $8f967e0328426a59$var$fieldInvariant(name, !!definition);
                    } else {
                        var nextFound = false;
                        $8f967e0328426a59$var$partialNames.forEach(function(partialName) {
                            var _a;
                            (_a = definition[partialName]) === null || _a === void 0 || _a.forEach(function(partialElement) {
                                if (!nextFound) {
                                    partialElement = $8f967e0328426a59$var$resolveRefIfNeeded(partialElement, _this.schema);
                                    if (next in partialElement.properties) {
                                        definition = partialElement.properties[next];
                                        nextFound = true;
                                    }
                                }
                            });
                        });
                        $8f967e0328426a59$var$fieldInvariant(name, nextFound);
                    }
                    definition = $8f967e0328426a59$var$resolveRefIfNeeded(definition, _this.schema);
                    // Naive computation of combined type, properties and required.
                    var required = definition.required ? definition.required.slice() : [];
                    var properties = definition.properties ? Object.assign({}, definition.properties) : {};
                    $8f967e0328426a59$var$partialNames.forEach(function(partialName) {
                        var _a;
                        (_a = definition[partialName]) === null || _a === void 0 || _a.forEach(function(partial) {
                            var _required;
                            partial = $8f967e0328426a59$var$resolveRefIfNeeded(partial, _this.schema);
                            if (partial.required) (_required = required).push.apply(_required, (0, $h9dQc._)(partial.required));
                            Object.assign(properties, partial.properties);
                            if (!definitionCache.type && partial.type) definitionCache.type = partial.type;
                        });
                    });
                    if (required.length > 0) definitionCache.required = required;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($04341c11f28e29b4$exports)))(properties)) definitionCache.properties = properties;
                    return definition;
                }, this.schema);
            }
        },
        {
            key: "getInitialValue",
            value: function getInitialValue(name, props) {
                var _this = this;
                var _a;
                var field = this.getField(name);
                var _this__compiledSchema_name = this._compiledSchema[name], tmp = _this__compiledSchema_name.default, defaultValue = tmp === void 0 ? (_a = field.default) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($3fbdcc4ebb9f17dd$exports)))(this.schema.default, name) : tmp, _this__compiledSchema_name_type = _this__compiledSchema_name.type, type = _this__compiledSchema_name_type === void 0 ? field.type : _this__compiledSchema_name_type;
                if (defaultValue !== undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($97fd0f9b469320ff$exports)))(defaultValue);
                if (type === "array") {
                    var item = this.getInitialValue((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(name, "0"));
                    var items = (props === null || props === void 0 ? void 0 : props.initialCount) || 0;
                    return Array.from({
                        length: items
                    }, function() {
                        return item;
                    });
                }
                if (type === "object") {
                    var value = {};
                    this.getSubfields(name).forEach(function(key) {
                        var initialValue = _this.getInitialValue((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(name, key));
                        if (initialValue !== undefined) value[key] = initialValue;
                    });
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "getProps",
            value: function getProps(name, fieldProps) {
                var _a, _b, _c;
                var field = this.getField(name);
                var props = Object.assign({}, field, field.uniforms, this._compiledSchema[name]);
                (_a = props.label) !== null && _a !== void 0 ? _a : props.label = (_b = props.title) !== null && _b !== void 0 ? _b : (0, (/*@__PURE__*/$parcel$interopDefault($08a287f54fc76c80$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93ec838255f20470$exports)))((0, $dd253ebacef58316$export$c8987bb64f9a8b89)(null, name).slice(-1)[0]));
                if (field.type === "number") props.decimal = true;
                if (((_c = field.uniforms) === null || _c === void 0 ? void 0 : _c.type) !== undefined) props.type = field.uniforms.type;
                if (props.required === undefined) props.required = props.isRequired;
                if (props.type === field.type) delete props.type;
                var options = (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.options) || props.options;
                if (options) {
                    if (Array.isArray(options)) {
                        props.allowedValues = options.map(function(option) {
                            return option.value;
                        });
                        props.transform = function(value) {
                            return options.find(function(option) {
                                return option.value === value;
                            }).label;
                        };
                    } else {
                        props.allowedValues = Object.keys(options);
                        props.transform = function(value) {
                            return options[value];
                        };
                    }
                } else if (props.enum) props.allowedValues = props.enum;
                $8f967e0328426a59$var$propsToRename.forEach(function(param) {
                    var _param = (0, $2MVSR._)(param, 2), key = _param[0], newKey = _param[1];
                    if (key in props) {
                        props[newKey] = props[key];
                        delete props[key];
                    }
                });
                $8f967e0328426a59$var$propsToRemove.forEach(function(key) {
                    if (key in props) delete props[key];
                });
                return props;
            }
        },
        {
            key: "getSubfields",
            value: function getSubfields() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                var field = this.getField(name);
                var _this__compiledSchema_name = this._compiledSchema[name], _this__compiledSchema_name_properties = _this__compiledSchema_name.properties, properties = _this__compiledSchema_name_properties === void 0 ? field.properties : _this__compiledSchema_name_properties, _this__compiledSchema_name_type = _this__compiledSchema_name.type, type = _this__compiledSchema_name_type === void 0 ? field.type : _this__compiledSchema_name_type;
                if (type === "object" && properties) return Object.keys(properties).map((0, $dd253ebacef58316$export$c8987bb64f9a8b89).escape);
                return [];
            }
        },
        {
            key: "getType",
            value: function getType(name) {
                var _this_getField = this.getField(name), _type = _this_getField.type, fieldFormat = _this_getField.format;
                var _this__compiledSchema_name = this._compiledSchema[name], tmp = _this__compiledSchema_name.type, fieldType = tmp === void 0 ? _type : tmp;
                if (fieldFormat === "date-time") return Date;
                if (fieldType === "string") return String;
                if (fieldType === "number") return Number;
                if (fieldType === "integer") return Number;
                if (fieldType === "object") return Object;
                if (fieldType === "array") return Array;
                if (fieldType === "boolean") return Boolean;
                (0, (/*@__PURE__*/$parcel$interopDefault($6dd9c7be11585a35$exports)))(fieldType !== "null", 'Field "%s" can not be represented as a type null', name);
                return fieldType;
            }
        },
        {
            key: "getValidator",
            value: function getValidator() {
                return this.validator;
            }
        }
    ]);
    return JSONSchemaBridge;
}((0, $6d89047d2ce7d196$export$68a44d00957434e6));







var $4CEbD = parcelRequire("4CEbD");



var $c326cb665a581ca5$var$Text = function(_param) {
    var autoComplete = _param.autoComplete, disabled = _param.disabled, id = _param.id, inputRef = _param.inputRef, label = _param.label, name = _param.name, onChange = _param.onChange, placeholder = _param.placeholder, readOnly = _param.readOnly, type = _param.type, value = _param.value, // eslint-disable-next-line react/prop-types
    componentClassName = _param.componentClassName, error = _param.error, props = (0, $535636d8023070c8$export$69fdd232f62cde60)(_param, [
        "autoComplete",
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "type",
        "value",
        "componentClassName",
        "error"
    ]);
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "field mb-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        className: "label"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: function(event) {
            return onChange(event.target.value);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : "",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("input", componentClassName, {
            invalid: error && props.showInlineError
        })
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "help is-danger"
    }, t("testcodeField.helpText")), " "));
};
$c326cb665a581ca5$var$Text.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    //description: PropTypes.string,
    //fieldInfo: PropTypes.string,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
};
$c326cb665a581ca5$var$Text.defaultProps = {
    type: "text",
    value: ""
};
var $c326cb665a581ca5$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($c326cb665a581ca5$var$Text, {
    kind: "leaf"
});



var $hF4Ve = parcelRequire("hF4Ve");


var $2MVSR = parcelRequire("2MVSR");



var $4CEbD = parcelRequire("4CEbD");



var $062e11a67825664d$var$Component = function(_param) {
    var disabled = _param.disabled, id = _param.id, label = _param.label, onChange = _param.onChange, //readOnly,
    //type,
    value = _param.value, cardClassName = _param.cardClassName, //error,
    description = _param.description, fieldInfo = _param.fieldInfo, years = _param.years, props = (0, $535636d8023070c8$export$69fdd232f62cde60)(_param, [
        "disabled",
        "id",
        "label",
        "onChange",
        "value",
        "cardClassName",
        "description",
        "fieldInfo",
        "years"
    ]);
    //const {t} = useTranslation();
    var _useState = (0, $2MVSR._)((0, $4CEbD.useState)(), 2), currentMonth = _useState[0], setCurrentMonth = _useState[1];
    var _useState1 = (0, $2MVSR._)((0, $4CEbD.useState)(), 2), currentYear = _useState1[0], setCurrentYear = _useState1[1];
    (0, $4CEbD.useEffect)(function() {
        if (value) {
            var currentDate = new Date(value);
            setCurrentMonth(currentDate.getMonth() + 1);
            setCurrentYear(currentDate.getFullYear());
        }
    }, [
        value
    ]);
    //console.log("Component", value, currentMonth, currentYear);
    var isActive = value !== undefined && value !== "";
    var onChangeSelect = function(event, type) {
        //console.log("onChangeSelect", event.target.value, type);
        var newVal = Number(event.target.value);
        switch(type){
            case "student_birthmonth":
                setCurrentMonth(newVal);
                if (currentYear) {
                    var newValue = new Date(currentYear, newVal - 1, 2, 0, 0, 0, 0).toISOString();
                    onChange(newValue);
                }
                break;
            case "student_birthyear":
                setCurrentYear(newVal);
                if (currentMonth) {
                    var newValue1 = new Date(newVal, currentMonth - 1, 2, 0, 0, 0, 0).toISOString();
                    onChange(newValue1);
                }
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $c7366cb85585295d$export$2e2bcd8739ae039), (0, $hF4Ve._)({
        id: id,
        label: label,
        description: description,
        fieldInfo: fieldInfo,
        cardClassName: "qanda__birthday " + cardClassName,
        active: isActive
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "qanda__answers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("qanda__birthmonthyear", {
            "qanda__qanda__birthmonthyear--active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($062e11a67825664d$var$SelectFieldElement, {
        name: "student_birthmonth",
        onChange: onChangeSelect,
        disabled: disabled,
        currentValue: currentMonth,
        translateCaption: true,
        values: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("qanda__monthyear", {
            "qanda__qanda__monthyear--active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($062e11a67825664d$var$SelectFieldElement, {
        name: "student_birthyear",
        onChange: onChangeSelect,
        translateCaption: false,
        disabled: disabled,
        currentValue: currentYear,
        values: years
    }))));
};
$062e11a67825664d$var$Component.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    years: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
};
// Rolling birth-year range (ages ~6-20) so the list never goes stale. Replaces
// the old hardcoded 2006-2016 list, which excluded pupils born after 2016.
var $062e11a67825664d$var$BIRTH_YEARS = Array.from({
    length: 15
}, function(_, i) {
    return new Date().getFullYear() - 20 + i;
});
$062e11a67825664d$var$Component.defaultProps = {
    type: "text",
    years: $062e11a67825664d$var$BIRTH_YEARS
};
var $062e11a67825664d$var$SelectFieldElement = function(param) {
    var values = param.values, name = param.name, disabled = param.disabled, currentValue = param.currentValue, translateCaption = param.translateCaption, onChange = param.onChange;
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("select", {
        disabled: disabled,
        onChange: function(e) {
            return onChange(e, name);
        },
        name: name,
        defaultValue: currentValue || t("yearMonthField_" + name + "_caption")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("option", {
        disabled: true
    }, t("yearMonthField_" + name + "_caption")), values.map(function(aValue) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("option", {
            key: aValue,
            value: aValue
        }, !translateCaption ? aValue : t("yearMonthField_" + name + "_" + aValue));
    }), " "));
};
$062e11a67825664d$var$SelectFieldElement.propTypes = {
    values: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    currentValue: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    translateCaption: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func
};
var $062e11a67825664d$export$2e2bcd8739ae039 = (0, $cdb4333bf8d9e8f7$export$2fe409f101064a7f)($062e11a67825664d$var$Component, {
    kind: "leaf"
});



var $6i0h5 = parcelRequire("6i0h5");
var $d9b01d9d667dbe48$var$ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($4ig53)))({
    allErrors: true,
    useDefaults: true
});
(0, (/*@__PURE__*/$parcel$interopDefault($6i0h5)))($d9b01d9d667dbe48$var$ajv);
$d9b01d9d667dbe48$var$ajv.addVocabulary([
    "uniforms",
    "component",
    "componentClassName",
    "options",
    "label",
    "value",
    "fieldType"
]);
var $d9b01d9d667dbe48$export$9a4b8a3ca30b6002 = function(schema) {
    var validator = $d9b01d9d667dbe48$var$ajv.compile(schema);
    //console.log("createValidator", validator);
    return function(model) {
        var _validator_errors;
        validator(model);
        return ((_validator_errors = validator.errors) === null || _validator_errors === void 0 ? void 0 : _validator_errors.length) ? {
            details: validator.errors
        } : null;
    };
};
var $d9b01d9d667dbe48$export$4a133c2feeb87f9d = function(schemaDefinition, customValidator) {
    //console.log("createUniformSchema", schemaDefinition, customValidator);
    return new (0, $8f967e0328426a59$export$2e2bcd8739ae039)(schemaDefinition, customValidator ? customValidator : $d9b01d9d667dbe48$export$9a4b8a3ca30b6002(schemaDefinition));
};
var $d9b01d9d667dbe48$var$fixUniformsType = function(item, id) {
    var fixedItem = Object.assign({}, item);
    //console.log("fixUniformsType", item);
    var mainSettings = {};
    var uniformSettings = {};
    switch(item.fieldType){
        case "MULTIPLE_CHOICE":
            uniformSettings.component = (0, $d7ba6eb4b61438f9$export$2e2bcd8739ae039);
            mainSettings.items = {
                type: "string"
            };
            break;
        case "SINGLE_CHOICE":
            uniformSettings.component = (0, $d7ba6eb4b61438f9$export$2e2bcd8739ae039);
            break;
        case "INPUT_FIELD":
            uniformSettings.component = (0, $fe4a11037def31c1$export$2e2bcd8739ae039);
            break;
        case "TESTCODE_FIELD":
            uniformSettings.component = (0, $c326cb665a581ca5$export$2e2bcd8739ae039);
            break;
        case "YEAR_MONTH":
            uniformSettings.component = (0, $062e11a67825664d$export$2e2bcd8739ae039);
            break;
        default:
    }
    //uniformSettings.id = id;
    uniformSettings.cardClassName = "";
    fixedItem = Object.assign(fixedItem, mainSettings);
    //fieldType is used bei uniform, therefor it needs to be removed here
    delete fixedItem.fieldType;
    fixedItem.uniforms = Object.assign(fixedItem.uniforms || {}, uniformSettings);
    //console.log("fixUniformsType fixedItem", fixedItem);
    return fixedItem;
};
var $d9b01d9d667dbe48$export$af88179f1a6b6206 = function(jsonSchema) {
    var validator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var fixedSchema = JSON.parse(jsonSchema);
    var requiredFields = [];
    //console.log("fixSchema #1", fixedSchema.properties);
    delete fixedSchema.$schema;
    //console.log("fixSchema #1.1", JSON.stringify(fixedSchema));
    Object.keys(fixedSchema.properties).forEach(function(prop) {
        var _fixedSchema_properties_prop;
        //console.log("fixSchema #2", prop, fixedSchema.properties[prop]);
        if ((_fixedSchema_properties_prop = fixedSchema.properties[prop]) === null || _fixedSchema_properties_prop === void 0 ? void 0 : _fixedSchema_properties_prop.required) requiredFields.push(prop);
        fixedSchema.properties[prop] = $d9b01d9d667dbe48$var$fixUniformsType(fixedSchema.properties[prop], prop);
    });
    if (requiredFields.length > 0) fixedSchema.required = requiredFields;
    //console.log("fixSchema #3", fixedSchema);
    return $d9b01d9d667dbe48$export$4a133c2feeb87f9d(fixedSchema, validator);
};


// const createTestDefinition = {
//     type: "object",
//     properties: {
//         email: {
//             type: 'string',
//             //pattern: "/^[a-z0-9\._%+!$&*=^|~#%{}\\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,22})$",
//             format: "email",
//             title: "Email",
//             description: "get Email",
//             uniforms: {
//                 component: InputField,
//                 inputClassName: "full-width"
//             }
//         }
//     }
// };
// const editTestDefinition = {
//     type: "object",
//     properties: {
//         testId: {
//             type: 'string',
//             title: "Test type",
//             description: "Select test",
//             uniforms: {
//                 allowedValues: ["Test A", "Test B"],
//                 component: SelectField
//                 //inputClassName: "full-width"
//             }
//         },
//         active: {
//             type: 'boolean',
//             title: "Active",
//             description: "is Test acitve",
//             uniforms: {
//                 component: BoolField
//                 //inputClassName: "full-width"
//             }
//         }
//     }
// };
var $ee24619e48177745$var$startTestDefinition = JSON.stringify({
    type: "object",
    properties: {
        testOrSessionId: {
            type: "string",
            minLength: 0,
            maxLength: 1000,
            title: "Test-Code",
            uniforms: {
                placeholder: "Test-Code eingeben"
            },
            fieldType: "TESTCODE_FIELD"
        }
    }
});
var $ee24619e48177745$export$1df86cc98bcb4f8a = (0, $d9b01d9d667dbe48$export$af88179f1a6b6206)($ee24619e48177745$var$startTestDefinition);





var $717ca83bd710dc3b$var$StartTest = function() {
    // eslint-disable-next-line no-unused-vars
    var formRef;
    var directorState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $f487fa6abc092388$export$86d1cded24611cb8));
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        document.body.classList.add("layout--centered");
        return function() {
            document.body.classList.remove("layout--centered");
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect((0, $1dc662ec593f833a$export$dad4a579cd5614b0)(directorState, history), [
        directorState
    ]);
    var handleSubmit = function() {
        var _ref = (0, $em5FP._)(function(param) {
            var testOrSessionId, res, res1;
            return (0, $nLPsB.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        testOrSessionId = param.testOrSessionId;
                        if (!(testOrSessionId && testOrSessionId.length === 8)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            $84ae43476eb4deb8$export$b96b69e966de3651(testOrSessionId)
                        ];
                    case 1:
                        res = _state.sent();
                        //log.info("StartTest", "handleSubmit", res.error);
                        if (!res.error) {
                            dispatch((0, $f487fa6abc092388$export$e16717ba5a5dc549)({
                                sessionId: testOrSessionId,
                                section: res
                            }));
                            dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                                text: t("startTestPage.message.testResumed"),
                                type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).SUCCESS,
                                props: {}
                            }));
                        } else dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                            text: t(res.error),
                            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                            props: {}
                        }));
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!(testOrSessionId && testOrSessionId.length === 6)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            $84ae43476eb4deb8$export$e72511350a89a269(testOrSessionId)
                        ];
                    case 3:
                        res1 = _state.sent();
                        //log.info("StartTest", "handleSubmit", testOrSessionId, res);
                        if (!res1.error) {
                            dispatch((0, $f487fa6abc092388$export$e16717ba5a5dc549)({
                                sessionId: res1.session_id,
                                section: res1.section
                            }));
                            dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                                text: t("startTestPage.message.testStarted"),
                                type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).SUCCESS,
                                props: {}
                            }));
                        } else dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                            text: t(res1.error),
                            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                            props: {}
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                            text: t("startTestPage.error.testcode"),
                            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                            props: {}
                        }));
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSubmitCaption = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            className: "button__text"
        }, t("startTestPage.submitButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            className: "icon licon-arrow-circle-right"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-tablet",
        dangerouslySetInnerHTML: {
            __html: t("startTestPage.intro1")
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section bg-primary-gradient-soft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t("startTestPage.intro2")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h2", {
        className: "is-success"
    }, t("startTestPage.inputNumber.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        className: "mb-lh"
    }, t("startTestPage.inputNumber.text")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $79fba9cf15c0fe25$export$2e2bcd8739ae039), {
        className: "",
        schema: (0, $ee24619e48177745$export$1df86cc98bcb4f8a),
        placeholder: true,
        onSubmit: handleSubmit,
        //validate="onChange"
        //onChangeModel={model => setCurrentLayer(() => model.backgroundLayer)}
        ref: function(ref) {
            return formRef = ref;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $1f86e799894f6ddc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "field mb-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $a49ec1ca611a122d$exports.default), {
        buttonClasses: "button is-success button--direction-right is-rounded",
        caption: getSubmitCaption()
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        onClick: history.goBack,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "icon licon-arrow-arc-left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, "Zur\xfcck"))))));
};
var $717ca83bd710dc3b$export$2e2bcd8739ae039 = $717ca83bd710dc3b$var$StartTest;



var $69e9a63831f23aaa$exports = {};

$parcel$export($69e9a63831f23aaa$exports, "default", function () { return $69e9a63831f23aaa$export$2e2bcd8739ae039; });

var $em5FP = parcelRequire("em5FP");

var $h9dQc = parcelRequire("h9dQc");

var $nLPsB = parcelRequire("nLPsB");




var $4CEbD = parcelRequire("4CEbD");




var $4CEbD = parcelRequire("4CEbD");

//import {useTranslation} from "react-i18next";
var $b01a81f807cafe49$var$GroupNavigation = function(param) {
    var noOfGroups = param.noOfGroups, currentGroupNo = param.currentGroupNo, answeredGroups = param.answeredGroups;
    //console.log("GroupNavigation", noOfGroups, currentGroupNo, answeredGroups);
    var groupClasses = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten"
    ];
    //const {t} = useTranslation();
    var renderElements = function() {
        var items = [];
        for(var i = 1; i <= noOfGroups; i++){
            var classes = {
                "qanda__bubble": true,
                "qanda__bubble--answered": answeredGroups.includes(i),
                "qanda__bubble--active": currentGroupNo === i
            };
            classes["qanda__bubble-1"] = true;
            items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))(classes)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", null, i)));
        }
        return items;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "qanda__bubbles"
    }, renderElements());
};
$b01a81f807cafe49$var$GroupNavigation.propTypes = {
    noOfGroups: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
    currentGroupNo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
    answeredGroups: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array
};
var $b01a81f807cafe49$export$2e2bcd8739ae039 = $b01a81f807cafe49$var$GroupNavigation;


var $2c5b6f89dc833d43$exports = {};

$parcel$export($2c5b6f89dc833d43$exports, "default", function () { return $2c5b6f89dc833d43$export$2e2bcd8739ae039; });

var $h9dQc = parcelRequire("h9dQc");


var $4CEbD = parcelRequire("4CEbD");
var $76ce51e0141c4618$var$PlainQandaButton = function(param) {
    var cb = param.cb, classes = param.classes, iconClasses = param.iconClasses, caption = param.caption, disabled = param.disabled, dir = param.dir;
    //console.log("QandaButton", submitting, validating, error, formRef);
    var buttonClasses = [
        "button",
        "is-rounded"
    ].concat((0, $h9dQc._)(classes));
    var iClasses = [
        "icon"
    ].concat((0, $h9dQc._)(iconClasses));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
        key: caption,
        className: buttonClasses.join(" "),
        onClick: cb,
        disabled: disabled
    }, dir === "before" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: iClasses.join(" ")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "button__text"
    }, caption), dir === "after" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: iClasses.join(" ")
    }));
};
$76ce51e0141c4618$var$PlainQandaButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    iconClasses: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
};
$76ce51e0141c4618$var$PlainQandaButton.defaultProps = {
    cb: null,
    classes: [],
    iconClasses: [],
    caption: "Button caption",
    dir: "before",
    disabled: false
};
var $76ce51e0141c4618$export$2e2bcd8739ae039 = $76ce51e0141c4618$var$PlainQandaButton;




var $4CEbD = parcelRequire("4CEbD");

var $2c5b6f89dc833d43$var$_this = undefined;
var $2c5b6f89dc833d43$var$QandaButton = function(param) {
    var cb = param.cb, classes = param.classes, iconClasses = param.iconClasses, caption = param.caption, //formRef,
    dir = param.dir;
    var _useForm = (0, $1806b649c272c471$export$87c0cf8eb5a167e0)(), error = _useForm.error, disabled = _useForm.state.disabled, model = _useForm.model, submitting = _useForm.submitting, validating = _useForm.validating;
    //console.log("QandaButton", caption, error, disabled, submitting, validating);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $76ce51e0141c4618$export$2e2bcd8739ae039), {
        classes: classes,
        iconClasses: iconClasses,
        cb: cb.bind($2c5b6f89dc833d43$var$_this, model),
        dir: dir,
        caption: caption,
        disabled: !!error || disabled || submitting || validating
    });
};
$2c5b6f89dc833d43$var$QandaButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
    iconClasses: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).array,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string
};
$2c5b6f89dc833d43$var$QandaButton.defaultProps = {
    cb: null,
    classes: [],
    iconClasses: [],
    caption: "Button caption",
    dir: "before"
};
var $2c5b6f89dc833d43$export$2e2bcd8739ae039 = $2c5b6f89dc833d43$var$QandaButton;




var $4CEbD = parcelRequire("4CEbD");


var $6f74f1bddb655035$var$SectionProgress = function(param) {
    var noOfSections = param.noOfSections, currentSectionNo = param.currentSectionNo;
    var sectionsCaptions = [
        "Meta",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G"
    ];
    var sectionsCaptionsLastSection = "Result";
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var renderElements = function() {
        var items = [];
        for(var i = 0; i < noOfSections; i++){
            var classes = [
                "progress-step"
            ];
            if (currentSectionNo - 1 > i) classes.push("progress--done");
            if (currentSectionNo - 1 === i) classes.push("progress--active");
            var title = t("sectionProgress.caption") + " " + sectionsCaptions[i];
            if (i + 1 === noOfSections) title = t("sectionProgress.result.caption");
            if (i === 0) title = t("sectionProgress.first.caption");
            items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))(classes),
                "data-tip": title
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
                className: "progress-bird"
            })));
        }
        return items;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "qanda__progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "progress-caption"
    }, "Los"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "progress-steps"
    }, renderElements()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
        className: "progress-caption"
    }, "Fertig"));
};
$6f74f1bddb655035$var$SectionProgress.propTypes = {
    noOfSections: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
    currentSectionNo: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number
};
var $6f74f1bddb655035$export$2e2bcd8739ae039 = $6f74f1bddb655035$var$SectionProgress;




var $4CEbD = parcelRequire("4CEbD");
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $4CEbD = parcelRequire("4CEbD");

/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ var $97565072be87b482$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");
var $2882607b9f426a2f$exports = {};
var $2882607b9f426a2f$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$2882607b9f426a2f$exports = // eslint-disable-next-line es/no-global-this -- safe
$2882607b9f426a2f$var$check(typeof globalThis == "object" && globalThis) || $2882607b9f426a2f$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$2882607b9f426a2f$var$check(typeof self == "object" && self) || $2882607b9f426a2f$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $2882607b9f426a2f$exports || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $d976e38f2fc4ab2b$export$2d1720544b23b823;
var $b441ecc4617d98f6$exports = {};
var $1104f276c77260b3$exports = {};
$1104f276c77260b3$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$b441ecc4617d98f6$exports = !$1104f276c77260b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});


var $ea29ea351915a40c$exports = {};
var $8be7ca1e0c9f78a5$exports = {};

$8be7ca1e0c9f78a5$exports = !$1104f276c77260b3$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $ea29ea351915a40c$var$call = Function.prototype.call;
$ea29ea351915a40c$exports = $8be7ca1e0c9f78a5$exports ? $ea29ea351915a40c$var$call.bind($ea29ea351915a40c$var$call) : function() {
    return $ea29ea351915a40c$var$call.apply($ea29ea351915a40c$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $99f4654824c2631e$export$2d1720544b23b823;
"use strict";
var $99f4654824c2631e$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $99f4654824c2631e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $99f4654824c2631e$var$NASHORN_BUG = $99f4654824c2631e$var$getOwnPropertyDescriptor && !$99f4654824c2631e$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$99f4654824c2631e$export$2d1720544b23b823 = $99f4654824c2631e$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $99f4654824c2631e$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $99f4654824c2631e$var$$propertyIsEnumerable;


var $e10032196d592fc9$exports = {};
$e10032196d592fc9$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $42abcb0686b52d7e$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $a902ac574fe6ad75$exports = {};
var $d9581cc7e9a63a67$exports = {};

var $d9581cc7e9a63a67$var$FunctionPrototype = Function.prototype;
var $d9581cc7e9a63a67$var$call = $d9581cc7e9a63a67$var$FunctionPrototype.call;
var $d9581cc7e9a63a67$var$uncurryThisWithBind = $8be7ca1e0c9f78a5$exports && $d9581cc7e9a63a67$var$FunctionPrototype.bind.bind($d9581cc7e9a63a67$var$call, $d9581cc7e9a63a67$var$call);
$d9581cc7e9a63a67$exports = $8be7ca1e0c9f78a5$exports ? $d9581cc7e9a63a67$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $d9581cc7e9a63a67$var$call.apply(fn, arguments);
    };
};



var $074f4f6f4a41a7f4$exports = {};

var $074f4f6f4a41a7f4$var$toString = $d9581cc7e9a63a67$exports({}.toString);
var $074f4f6f4a41a7f4$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
$074f4f6f4a41a7f4$exports = function(it) {
    return $074f4f6f4a41a7f4$var$stringSlice($074f4f6f4a41a7f4$var$toString(it), 8, -1);
};


var $a902ac574fe6ad75$var$$Object = Object;
var $a902ac574fe6ad75$var$split = $d9581cc7e9a63a67$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$a902ac574fe6ad75$exports = $1104f276c77260b3$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$a902ac574fe6ad75$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $074f4f6f4a41a7f4$exports(it) == "String" ? $a902ac574fe6ad75$var$split(it, "") : $a902ac574fe6ad75$var$$Object(it);
} : $a902ac574fe6ad75$var$$Object;


var $c6c632a1427ebe2e$exports = {};
var $23bd47ceb739678b$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$23bd47ceb739678b$exports = function(it) {
    return it === null || it === undefined;
};


var $c6c632a1427ebe2e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c6c632a1427ebe2e$exports = function(it) {
    if ($23bd47ceb739678b$exports(it)) throw $c6c632a1427ebe2e$var$$TypeError("Can't call method on " + it);
    return it;
};


$42abcb0686b52d7e$exports = function(it) {
    return $a902ac574fe6ad75$exports($c6c632a1427ebe2e$exports(it));
};


var $c5490d21bf4c572d$exports = {};
var $f01d7b153bbe0867$exports = {};

var $2d77b55ef7fd6e5b$exports = {};
var $530c08156ef94345$exports = {};
var $0642241c24dc18df$exports = {};
var $0642241c24dc18df$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $0642241c24dc18df$var$IS_HTMLDDA = typeof $0642241c24dc18df$var$documentAll == "undefined" && $0642241c24dc18df$var$documentAll !== undefined;
$0642241c24dc18df$exports = {
    all: $0642241c24dc18df$var$documentAll,
    IS_HTMLDDA: $0642241c24dc18df$var$IS_HTMLDDA
};


var $530c08156ef94345$var$documentAll = $0642241c24dc18df$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$530c08156ef94345$exports = $0642241c24dc18df$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $530c08156ef94345$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $2d77b55ef7fd6e5b$var$documentAll = $0642241c24dc18df$exports.all;
$2d77b55ef7fd6e5b$exports = $0642241c24dc18df$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $530c08156ef94345$exports(it) || it === $2d77b55ef7fd6e5b$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $530c08156ef94345$exports(it);
};


var $7e4d2d8cc5e93d7e$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");
var $3eb28d316df83043$exports = {};


var $3eb28d316df83043$var$aFunction = function aFunction(argument) {
    return $530c08156ef94345$exports(argument) ? argument : undefined;
};
$3eb28d316df83043$exports = function(namespace, method) {
    return arguments.length < 2 ? $3eb28d316df83043$var$aFunction($2882607b9f426a2f$exports[namespace]) : $2882607b9f426a2f$exports[namespace] && $2882607b9f426a2f$exports[namespace][method];
};



var $a4c3886c6ef6d2b5$exports = {};

$a4c3886c6ef6d2b5$exports = $d9581cc7e9a63a67$exports({}.isPrototypeOf);


var $81211926db8db0c8$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $d0fcb6f8b6a24d25$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $ce7a78bbf20168dc$exports = {};

var $e50fb5015dd2178d$exports = {};
$e50fb5015dd2178d$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $ce7a78bbf20168dc$var$process = $2882607b9f426a2f$exports.process;
var $ce7a78bbf20168dc$var$Deno = $2882607b9f426a2f$exports.Deno;
var $ce7a78bbf20168dc$var$versions = $ce7a78bbf20168dc$var$process && $ce7a78bbf20168dc$var$process.versions || $ce7a78bbf20168dc$var$Deno && $ce7a78bbf20168dc$var$Deno.version;
var $ce7a78bbf20168dc$var$v8 = $ce7a78bbf20168dc$var$versions && $ce7a78bbf20168dc$var$versions.v8;
var $ce7a78bbf20168dc$var$match, $ce7a78bbf20168dc$var$version;
if ($ce7a78bbf20168dc$var$v8) {
    $ce7a78bbf20168dc$var$match = $ce7a78bbf20168dc$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $ce7a78bbf20168dc$var$version = $ce7a78bbf20168dc$var$match[0] > 0 && $ce7a78bbf20168dc$var$match[0] < 4 ? 1 : +($ce7a78bbf20168dc$var$match[0] + $ce7a78bbf20168dc$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$ce7a78bbf20168dc$var$version && $e50fb5015dd2178d$exports) {
    $ce7a78bbf20168dc$var$match = $e50fb5015dd2178d$exports.match(/Edge\/(\d+)/);
    if (!$ce7a78bbf20168dc$var$match || $ce7a78bbf20168dc$var$match[1] >= 74) {
        $ce7a78bbf20168dc$var$match = $e50fb5015dd2178d$exports.match(/Chrome\/(\d+)/);
        if ($ce7a78bbf20168dc$var$match) $ce7a78bbf20168dc$var$version = +$ce7a78bbf20168dc$var$match[1];
    }
}
$ce7a78bbf20168dc$exports = $ce7a78bbf20168dc$var$version;




var $d0fcb6f8b6a24d25$var$$String = $2882607b9f426a2f$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$d0fcb6f8b6a24d25$exports = !!Object.getOwnPropertySymbols && !$1104f276c77260b3$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$d0fcb6f8b6a24d25$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $ce7a78bbf20168dc$exports && $ce7a78bbf20168dc$exports < 41;
});


$81211926db8db0c8$exports = $d0fcb6f8b6a24d25$exports && !Symbol.sham && (0, $5F2Q2._)(Symbol.iterator) == "symbol";


var $7e4d2d8cc5e93d7e$var$$Object = Object;
$7e4d2d8cc5e93d7e$exports = $81211926db8db0c8$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $5F2Q2._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $3eb28d316df83043$exports("Symbol");
    return $530c08156ef94345$exports($Symbol) && $a4c3886c6ef6d2b5$exports($Symbol.prototype, $7e4d2d8cc5e93d7e$var$$Object(it));
};


var $86a8def7b6f243c9$exports = {};
var $1934ccccb0254b37$exports = {};

var $c313a08f63affb1d$exports = {};
var $c313a08f63affb1d$var$$String = String;
$c313a08f63affb1d$exports = function(argument) {
    try {
        return $c313a08f63affb1d$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $1934ccccb0254b37$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$1934ccccb0254b37$exports = function(argument) {
    if ($530c08156ef94345$exports(argument)) return argument;
    throw $1934ccccb0254b37$var$$TypeError($c313a08f63affb1d$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$86a8def7b6f243c9$exports = function(V, P) {
    var func = V[P];
    return $23bd47ceb739678b$exports(func) ? undefined : $1934ccccb0254b37$exports(func);
};


var $2b6ff222a760ff18$exports = {};



var $2b6ff222a760ff18$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$2b6ff222a760ff18$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $530c08156ef94345$exports(fn = input.toString) && !$2d77b55ef7fd6e5b$exports(val = $ea29ea351915a40c$exports(fn, input))) return val;
    if ($530c08156ef94345$exports(fn = input.valueOf) && !$2d77b55ef7fd6e5b$exports(val = $ea29ea351915a40c$exports(fn, input))) return val;
    if (pref !== "string" && $530c08156ef94345$exports(fn = input.toString) && !$2d77b55ef7fd6e5b$exports(val = $ea29ea351915a40c$exports(fn, input))) return val;
    throw $2b6ff222a760ff18$var$$TypeError("Can't convert object to primitive value");
};


var $12359396acd4e225$exports = {};

var $393c154836942fbd$exports = {};
var $a45e6ce82b8c6504$exports = {};
$a45e6ce82b8c6504$exports = false;


var $719e8fa2941cd50f$exports = {};

var $e5dba43558de3091$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e5dba43558de3091$var$defineProperty = Object.defineProperty;
$e5dba43558de3091$exports = function(key, value) {
    try {
        $e5dba43558de3091$var$defineProperty($2882607b9f426a2f$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $2882607b9f426a2f$exports[key] = value;
    }
    return value;
};


var $719e8fa2941cd50f$var$SHARED = "__core-js_shared__";
var $719e8fa2941cd50f$var$store = $2882607b9f426a2f$exports[$719e8fa2941cd50f$var$SHARED] || $e5dba43558de3091$exports($719e8fa2941cd50f$var$SHARED, {});
$719e8fa2941cd50f$exports = $719e8fa2941cd50f$var$store;


($393c154836942fbd$exports = function(key, value) {
    return $719e8fa2941cd50f$exports[key] || ($719e8fa2941cd50f$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.30.2",
    mode: $a45e6ce82b8c6504$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $e41bb36ebbba59e0$exports = {};

var $ff4389c250ca5a45$exports = {};

var $ff4389c250ca5a45$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$ff4389c250ca5a45$exports = function(argument) {
    return $ff4389c250ca5a45$var$$Object($c6c632a1427ebe2e$exports(argument));
};


var $e41bb36ebbba59e0$var$hasOwnProperty = $d9581cc7e9a63a67$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$e41bb36ebbba59e0$exports = Object.hasOwn || function hasOwn(it, key) {
    return $e41bb36ebbba59e0$var$hasOwnProperty($ff4389c250ca5a45$exports(it), key);
};


var $be14777b267b4408$exports = {};

var $be14777b267b4408$var$id = 0;
var $be14777b267b4408$var$postfix = Math.random();
var $be14777b267b4408$var$toString = $d9581cc7e9a63a67$exports(1.0.toString);
$be14777b267b4408$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $be14777b267b4408$var$toString(++$be14777b267b4408$var$id + $be14777b267b4408$var$postfix, 36);
};




var $12359396acd4e225$var$Symbol = $2882607b9f426a2f$exports.Symbol;
var $12359396acd4e225$var$WellKnownSymbolsStore = $393c154836942fbd$exports("wks");
var $12359396acd4e225$var$createWellKnownSymbol = $81211926db8db0c8$exports ? $12359396acd4e225$var$Symbol["for"] || $12359396acd4e225$var$Symbol : $12359396acd4e225$var$Symbol && $12359396acd4e225$var$Symbol.withoutSetter || $be14777b267b4408$exports;
$12359396acd4e225$exports = function(name) {
    if (!$e41bb36ebbba59e0$exports($12359396acd4e225$var$WellKnownSymbolsStore, name)) $12359396acd4e225$var$WellKnownSymbolsStore[name] = $d0fcb6f8b6a24d25$exports && $e41bb36ebbba59e0$exports($12359396acd4e225$var$Symbol, name) ? $12359396acd4e225$var$Symbol[name] : $12359396acd4e225$var$createWellKnownSymbol("Symbol." + name);
    return $12359396acd4e225$var$WellKnownSymbolsStore[name];
};


var $f01d7b153bbe0867$var$$TypeError = TypeError;
var $f01d7b153bbe0867$var$TO_PRIMITIVE = $12359396acd4e225$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$f01d7b153bbe0867$exports = function(input, pref) {
    if (!$2d77b55ef7fd6e5b$exports(input) || $7e4d2d8cc5e93d7e$exports(input)) return input;
    var exoticToPrim = $86a8def7b6f243c9$exports(input, $f01d7b153bbe0867$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $ea29ea351915a40c$exports(exoticToPrim, input, pref);
        if (!$2d77b55ef7fd6e5b$exports(result) || $7e4d2d8cc5e93d7e$exports(result)) return result;
        throw $f01d7b153bbe0867$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $2b6ff222a760ff18$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$c5490d21bf4c572d$exports = function(argument) {
    var key = $f01d7b153bbe0867$exports(argument, "string");
    return $7e4d2d8cc5e93d7e$exports(key) ? key : key + "";
};



var $2c98144f4865f16f$exports = {};


var $689214aa055d150d$exports = {};


var $689214aa055d150d$var$document = $2882607b9f426a2f$exports.document;
// typeof document.createElement is 'object' in old IE
var $689214aa055d150d$var$EXISTS = $2d77b55ef7fd6e5b$exports($689214aa055d150d$var$document) && $2d77b55ef7fd6e5b$exports($689214aa055d150d$var$document.createElement);
$689214aa055d150d$exports = function(it) {
    return $689214aa055d150d$var$EXISTS ? $689214aa055d150d$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$2c98144f4865f16f$exports = !$b441ecc4617d98f6$exports && !$1104f276c77260b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($689214aa055d150d$exports("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $d976e38f2fc4ab2b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$d976e38f2fc4ab2b$export$2d1720544b23b823 = $b441ecc4617d98f6$exports ? $d976e38f2fc4ab2b$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $42abcb0686b52d7e$exports(O);
    P = $c5490d21bf4c572d$exports(P);
    if ($2c98144f4865f16f$exports) try {
        return $d976e38f2fc4ab2b$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($e41bb36ebbba59e0$exports(O, P)) return $e10032196d592fc9$exports(!$ea29ea351915a40c$exports($99f4654824c2631e$export$2d1720544b23b823, O, P), O[P]);
};


var $97565072be87b482$require$getOwnPropertyDescriptor = $d976e38f2fc4ab2b$export$2d1720544b23b823;
var $b799eb4d8561c8c3$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $00895ebe3ae58406$export$2d1720544b23b823;


var $2a9098996ff929ab$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$2a9098996ff929ab$exports = $b441ecc4617d98f6$exports && $1104f276c77260b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $375e5ed2420f5bb9$exports = {};

var $375e5ed2420f5bb9$var$$String = String;
var $375e5ed2420f5bb9$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$375e5ed2420f5bb9$exports = function(argument) {
    if ($2d77b55ef7fd6e5b$exports(argument)) return argument;
    throw $375e5ed2420f5bb9$var$$TypeError($375e5ed2420f5bb9$var$$String(argument) + " is not an object");
};



var $00895ebe3ae58406$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $00895ebe3ae58406$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $00895ebe3ae58406$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $00895ebe3ae58406$var$ENUMERABLE = "enumerable";
var $00895ebe3ae58406$var$CONFIGURABLE = "configurable";
var $00895ebe3ae58406$var$WRITABLE = "writable";
$00895ebe3ae58406$export$2d1720544b23b823 = $b441ecc4617d98f6$exports ? $2a9098996ff929ab$exports ? function defineProperty(O, P, Attributes) {
    $375e5ed2420f5bb9$exports(O);
    P = $c5490d21bf4c572d$exports(P);
    $375e5ed2420f5bb9$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $00895ebe3ae58406$var$WRITABLE in Attributes && !Attributes[$00895ebe3ae58406$var$WRITABLE]) {
        var current = $00895ebe3ae58406$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$00895ebe3ae58406$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $00895ebe3ae58406$var$CONFIGURABLE in Attributes ? Attributes[$00895ebe3ae58406$var$CONFIGURABLE] : current[$00895ebe3ae58406$var$CONFIGURABLE],
                enumerable: $00895ebe3ae58406$var$ENUMERABLE in Attributes ? Attributes[$00895ebe3ae58406$var$ENUMERABLE] : current[$00895ebe3ae58406$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $00895ebe3ae58406$var$$defineProperty(O, P, Attributes);
} : $00895ebe3ae58406$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $375e5ed2420f5bb9$exports(O);
    P = $c5490d21bf4c572d$exports(P);
    $375e5ed2420f5bb9$exports(Attributes);
    if ($2c98144f4865f16f$exports) try {
        return $00895ebe3ae58406$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $00895ebe3ae58406$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$b799eb4d8561c8c3$exports = $b441ecc4617d98f6$exports ? function(object, key, value) {
    return $00895ebe3ae58406$export$2d1720544b23b823(object, key, $e10032196d592fc9$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $8650e653ce14b304$exports = {};


var $923f8638f9182ee3$exports = {};





var $a90617eefec74231$exports = {};


var $a90617eefec74231$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a90617eefec74231$var$getDescriptor = $b441ecc4617d98f6$exports && Object.getOwnPropertyDescriptor;
var $a90617eefec74231$var$EXISTS = $e41bb36ebbba59e0$exports($a90617eefec74231$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $a90617eefec74231$var$PROPER = $a90617eefec74231$var$EXISTS && (function something() {}).name === "something";
var $a90617eefec74231$var$CONFIGURABLE = $a90617eefec74231$var$EXISTS && (!$b441ecc4617d98f6$exports || $b441ecc4617d98f6$exports && $a90617eefec74231$var$getDescriptor($a90617eefec74231$var$FunctionPrototype, "name").configurable);
$a90617eefec74231$exports = {
    EXISTS: $a90617eefec74231$var$EXISTS,
    PROPER: $a90617eefec74231$var$PROPER,
    CONFIGURABLE: $a90617eefec74231$var$CONFIGURABLE
};


var $923f8638f9182ee3$require$CONFIGURABLE_FUNCTION_NAME = $a90617eefec74231$exports.CONFIGURABLE;
var $d4f907e8d08af0c1$exports = {};



var $d4f907e8d08af0c1$var$functionToString = $d9581cc7e9a63a67$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$530c08156ef94345$exports($719e8fa2941cd50f$exports.inspectSource)) $719e8fa2941cd50f$exports.inspectSource = function(it) {
    return $d4f907e8d08af0c1$var$functionToString(it);
};
$d4f907e8d08af0c1$exports = $719e8fa2941cd50f$exports.inspectSource;


var $0f915c35577af5f4$exports = {};
var $b2211da45717197a$exports = {};


var $b2211da45717197a$var$WeakMap = $2882607b9f426a2f$exports.WeakMap;
$b2211da45717197a$exports = $530c08156ef94345$exports($b2211da45717197a$var$WeakMap) && /native code/.test(String($b2211da45717197a$var$WeakMap));







var $af295684ca2687eb$exports = {};


var $af295684ca2687eb$var$keys = $393c154836942fbd$exports("keys");
$af295684ca2687eb$exports = function(key) {
    return $af295684ca2687eb$var$keys[key] || ($af295684ca2687eb$var$keys[key] = $be14777b267b4408$exports(key));
};


var $d94bcaeda9e43336$exports = {};
$d94bcaeda9e43336$exports = {};


var $0f915c35577af5f4$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $0f915c35577af5f4$var$TypeError = $2882607b9f426a2f$exports.TypeError;
var $0f915c35577af5f4$var$WeakMap = $2882607b9f426a2f$exports.WeakMap;
var $0f915c35577af5f4$var$set, $0f915c35577af5f4$var$get, $0f915c35577af5f4$var$has;
var $0f915c35577af5f4$var$enforce = function enforce(it) {
    return $0f915c35577af5f4$var$has(it) ? $0f915c35577af5f4$var$get(it) : $0f915c35577af5f4$var$set(it, {});
};
var $0f915c35577af5f4$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$2d77b55ef7fd6e5b$exports(it) || (state = $0f915c35577af5f4$var$get(it)).type !== TYPE) throw $0f915c35577af5f4$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($b2211da45717197a$exports || $719e8fa2941cd50f$exports.state) {
    var $0f915c35577af5f4$var$store = $719e8fa2941cd50f$exports.state || ($719e8fa2941cd50f$exports.state = new $0f915c35577af5f4$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $0f915c35577af5f4$var$store.get = $0f915c35577af5f4$var$store.get;
    $0f915c35577af5f4$var$store.has = $0f915c35577af5f4$var$store.has;
    $0f915c35577af5f4$var$store.set = $0f915c35577af5f4$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $0f915c35577af5f4$var$set = function set(it, metadata) {
        if ($0f915c35577af5f4$var$store.has(it)) throw $0f915c35577af5f4$var$TypeError($0f915c35577af5f4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $0f915c35577af5f4$var$store.set(it, metadata);
        return metadata;
    };
    $0f915c35577af5f4$var$get = function get(it) {
        return $0f915c35577af5f4$var$store.get(it) || {};
    };
    $0f915c35577af5f4$var$has = function has(it) {
        return $0f915c35577af5f4$var$store.has(it);
    };
} else {
    var $0f915c35577af5f4$var$STATE = $af295684ca2687eb$exports("state");
    $d94bcaeda9e43336$exports[$0f915c35577af5f4$var$STATE] = true;
    $0f915c35577af5f4$var$set = function set(it, metadata) {
        if ($e41bb36ebbba59e0$exports(it, $0f915c35577af5f4$var$STATE)) throw $0f915c35577af5f4$var$TypeError($0f915c35577af5f4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b799eb4d8561c8c3$exports(it, $0f915c35577af5f4$var$STATE, metadata);
        return metadata;
    };
    $0f915c35577af5f4$var$get = function get(it) {
        return $e41bb36ebbba59e0$exports(it, $0f915c35577af5f4$var$STATE) ? it[$0f915c35577af5f4$var$STATE] : {};
    };
    $0f915c35577af5f4$var$has = function has(it) {
        return $e41bb36ebbba59e0$exports(it, $0f915c35577af5f4$var$STATE);
    };
}
$0f915c35577af5f4$exports = {
    set: $0f915c35577af5f4$var$set,
    get: $0f915c35577af5f4$var$get,
    has: $0f915c35577af5f4$var$has,
    enforce: $0f915c35577af5f4$var$enforce,
    getterFor: $0f915c35577af5f4$var$getterFor
};


var $923f8638f9182ee3$var$enforceInternalState = $0f915c35577af5f4$exports.enforce;
var $923f8638f9182ee3$var$getInternalState = $0f915c35577af5f4$exports.get;
var $923f8638f9182ee3$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $923f8638f9182ee3$var$defineProperty = Object.defineProperty;
var $923f8638f9182ee3$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
var $923f8638f9182ee3$var$replace = $d9581cc7e9a63a67$exports("".replace);
var $923f8638f9182ee3$var$join = $d9581cc7e9a63a67$exports([].join);
var $923f8638f9182ee3$var$CONFIGURABLE_LENGTH = $b441ecc4617d98f6$exports && !$1104f276c77260b3$exports(function() {
    return $923f8638f9182ee3$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $923f8638f9182ee3$var$TEMPLATE = String(String).split("String");
var $923f8638f9182ee3$var$makeBuiltIn = $923f8638f9182ee3$exports = function makeBuiltIn(value, name, options) {
    if ($923f8638f9182ee3$var$stringSlice($923f8638f9182ee3$var$$String(name), 0, 7) === "Symbol(") name = "[" + $923f8638f9182ee3$var$replace($923f8638f9182ee3$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$e41bb36ebbba59e0$exports(value, "name") || $923f8638f9182ee3$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($b441ecc4617d98f6$exports) $923f8638f9182ee3$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($923f8638f9182ee3$var$CONFIGURABLE_LENGTH && options && $e41bb36ebbba59e0$exports(options, "arity") && value.length !== options.arity) $923f8638f9182ee3$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $e41bb36ebbba59e0$exports(options, "constructor") && options.constructor) {
            if ($b441ecc4617d98f6$exports) $923f8638f9182ee3$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $923f8638f9182ee3$var$enforceInternalState(value);
    if (!$e41bb36ebbba59e0$exports(state, "source")) state.source = $923f8638f9182ee3$var$join($923f8638f9182ee3$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $923f8638f9182ee3$var$makeBuiltIn(function toString() {
    return $530c08156ef94345$exports(this) && $923f8638f9182ee3$var$getInternalState(this).source || $d4f907e8d08af0c1$exports(this);
}, "toString");



$8650e653ce14b304$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($530c08156ef94345$exports(value)) $923f8638f9182ee3$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $e5dba43558de3091$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $00895ebe3ae58406$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $dadde62b1f045416$exports = {};

var $2a460a9557adde3e$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $fd6385a3c1e76a21$export$2d1720544b23b823;
var $2d80b1410d01c2f0$exports = {};



var $7b4fb9b287b38b40$exports = {};

var $e5b0598b07e70514$exports = {};
var $a7928c5e8e393354$exports = {};
var $c9374b0e95f3a9d1$exports = {};
var $c9374b0e95f3a9d1$var$ceil = Math.ceil;
var $c9374b0e95f3a9d1$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$c9374b0e95f3a9d1$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $c9374b0e95f3a9d1$var$floor : $c9374b0e95f3a9d1$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$a7928c5e8e393354$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $c9374b0e95f3a9d1$exports(number);
};


var $e5b0598b07e70514$var$max = Math.max;
var $e5b0598b07e70514$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$e5b0598b07e70514$exports = function(index, length) {
    var integer = $a7928c5e8e393354$exports(index);
    return integer < 0 ? $e5b0598b07e70514$var$max(integer + length, 0) : $e5b0598b07e70514$var$min(integer, length);
};


var $c8b9baef6d1b44d4$exports = {};
var $b1a33852f3411fc8$exports = {};

var $b1a33852f3411fc8$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$b1a33852f3411fc8$exports = function(argument) {
    return argument > 0 ? $b1a33852f3411fc8$var$min($a7928c5e8e393354$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$c8b9baef6d1b44d4$exports = function(obj) {
    return $b1a33852f3411fc8$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $7b4fb9b287b38b40$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $42abcb0686b52d7e$exports($this);
        var length = $c8b9baef6d1b44d4$exports(O);
        var index = $e5b0598b07e70514$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$7b4fb9b287b38b40$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $7b4fb9b287b38b40$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $7b4fb9b287b38b40$var$createMethod(false)
};


var $2d80b1410d01c2f0$require$indexOf = $7b4fb9b287b38b40$exports.indexOf;

var $2d80b1410d01c2f0$var$push = $d9581cc7e9a63a67$exports([].push);
$2d80b1410d01c2f0$exports = function(object, names) {
    var O = $42abcb0686b52d7e$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$e41bb36ebbba59e0$exports($d94bcaeda9e43336$exports, key) && $e41bb36ebbba59e0$exports(O, key) && $2d80b1410d01c2f0$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($e41bb36ebbba59e0$exports(O, key = names[i++])) ~$2d80b1410d01c2f0$require$indexOf(result, key) || $2d80b1410d01c2f0$var$push(result, key);
    return result;
};


var $b4e8086632c003f8$exports = {};
// IE8- don't enum bug keys
$b4e8086632c003f8$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $fd6385a3c1e76a21$var$hiddenKeys = $b4e8086632c003f8$exports.concat("length", "prototype");
$fd6385a3c1e76a21$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $2d80b1410d01c2f0$exports(O, $fd6385a3c1e76a21$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $8eae3d9df9090ad7$export$2d1720544b23b823;
$8eae3d9df9090ad7$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $2a460a9557adde3e$var$concat = $d9581cc7e9a63a67$exports([].concat);
// all object keys, includes non-enumerable and symbols
$2a460a9557adde3e$exports = $3eb28d316df83043$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $fd6385a3c1e76a21$export$2d1720544b23b823($375e5ed2420f5bb9$exports(it));
    var getOwnPropertySymbols = $8eae3d9df9090ad7$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $2a460a9557adde3e$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$dadde62b1f045416$exports = function(target, source, exceptions) {
    var keys = $2a460a9557adde3e$exports(source);
    var defineProperty = $00895ebe3ae58406$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $d976e38f2fc4ab2b$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$e41bb36ebbba59e0$exports(target, key) && !(exceptions && $e41bb36ebbba59e0$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $bca9e1c3de00006a$exports = {};


var $bca9e1c3de00006a$var$replacement = /#|\.prototype\./;
var $bca9e1c3de00006a$var$isForced = function isForced(feature, detection) {
    var value = $bca9e1c3de00006a$var$data[$bca9e1c3de00006a$var$normalize(feature)];
    return value == $bca9e1c3de00006a$var$POLYFILL ? true : value == $bca9e1c3de00006a$var$NATIVE ? false : $530c08156ef94345$exports(detection) ? $1104f276c77260b3$exports(detection) : !!detection;
};
var $bca9e1c3de00006a$var$normalize = $bca9e1c3de00006a$var$isForced.normalize = function normalize(string) {
    return String(string).replace($bca9e1c3de00006a$var$replacement, ".").toLowerCase();
};
var $bca9e1c3de00006a$var$data = $bca9e1c3de00006a$var$isForced.data = {};
var $bca9e1c3de00006a$var$NATIVE = $bca9e1c3de00006a$var$isForced.NATIVE = "N";
var $bca9e1c3de00006a$var$POLYFILL = $bca9e1c3de00006a$var$isForced.POLYFILL = "P";
$bca9e1c3de00006a$exports = $bca9e1c3de00006a$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $97565072be87b482$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $2882607b9f426a2f$exports;
    else if (STATIC) target = $2882607b9f426a2f$exports[TARGET] || $e5dba43558de3091$exports(TARGET, {});
    else target = ($2882607b9f426a2f$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $97565072be87b482$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $bca9e1c3de00006a$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $5F2Q2._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $5F2Q2._)(targetProperty))) continue;
            $dadde62b1f045416$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $b799eb4d8561c8c3$exports(sourceProperty, "sham", true);
        $8650e653ce14b304$exports(target, key, sourceProperty, options);
    }
};


var $d53d0b0e7fd7257c$exports = {};



var $849a2f8baae8f2af$exports = {};
var $42af2defb8a58367$exports = {};
var $67fcf73f6f11473f$exports = {};

var $67fcf73f6f11473f$var$TO_STRING_TAG = $12359396acd4e225$exports("toStringTag");
var $67fcf73f6f11473f$var$test = {};
$67fcf73f6f11473f$var$test[$67fcf73f6f11473f$var$TO_STRING_TAG] = "z";
$67fcf73f6f11473f$exports = String($67fcf73f6f11473f$var$test) === "[object z]";





var $42af2defb8a58367$var$TO_STRING_TAG = $12359396acd4e225$exports("toStringTag");
var $42af2defb8a58367$var$$Object = Object;
// ES3 wrong here
var $42af2defb8a58367$var$CORRECT_ARGUMENTS = $074f4f6f4a41a7f4$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $42af2defb8a58367$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$42af2defb8a58367$exports = $67fcf73f6f11473f$exports ? $074f4f6f4a41a7f4$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $42af2defb8a58367$var$tryGet(O = $42af2defb8a58367$var$$Object(it), $42af2defb8a58367$var$TO_STRING_TAG)) == "string" ? tag : $42af2defb8a58367$var$CORRECT_ARGUMENTS ? $074f4f6f4a41a7f4$exports(O) : (result = $074f4f6f4a41a7f4$exports(O)) == "Object" && $530c08156ef94345$exports(O.callee) ? "Arguments" : result;
};


var $849a2f8baae8f2af$var$$String = String;
$849a2f8baae8f2af$exports = function(argument) {
    if ($42af2defb8a58367$exports(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $849a2f8baae8f2af$var$$String(argument);
};


var $89a31743b1e10c0c$exports = {};



var $7626ccf859d539a7$exports = {};
// a string of all valid unicode whitespaces
$7626ccf859d539a7$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $89a31743b1e10c0c$var$replace = $d9581cc7e9a63a67$exports("".replace);
var $89a31743b1e10c0c$var$ltrim = RegExp("^[" + $7626ccf859d539a7$exports + "]+");
var $89a31743b1e10c0c$var$rtrim = RegExp("(^|[^" + $7626ccf859d539a7$exports + "])[" + $7626ccf859d539a7$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $89a31743b1e10c0c$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $849a2f8baae8f2af$exports($c6c632a1427ebe2e$exports($this));
        if (TYPE & 1) string = $89a31743b1e10c0c$var$replace(string, $89a31743b1e10c0c$var$ltrim, "");
        if (TYPE & 2) string = $89a31743b1e10c0c$var$replace(string, $89a31743b1e10c0c$var$rtrim, "$1");
        return string;
    };
};
$89a31743b1e10c0c$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $89a31743b1e10c0c$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $89a31743b1e10c0c$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $89a31743b1e10c0c$var$createMethod(3)
};


var $d53d0b0e7fd7257c$require$trim = $89a31743b1e10c0c$exports.trim;

var $d53d0b0e7fd7257c$var$$parseInt = $2882607b9f426a2f$exports.parseInt;
var $d53d0b0e7fd7257c$var$Symbol = $2882607b9f426a2f$exports.Symbol;
var $d53d0b0e7fd7257c$var$ITERATOR = $d53d0b0e7fd7257c$var$Symbol && $d53d0b0e7fd7257c$var$Symbol.iterator;
var $d53d0b0e7fd7257c$var$hex = /^[+-]?0x/i;
var $d53d0b0e7fd7257c$var$exec = $d9581cc7e9a63a67$exports($d53d0b0e7fd7257c$var$hex.exec);
var $d53d0b0e7fd7257c$var$FORCED = $d53d0b0e7fd7257c$var$$parseInt($7626ccf859d539a7$exports + "08") !== 8 || $d53d0b0e7fd7257c$var$$parseInt($7626ccf859d539a7$exports + "0x16") !== 22 || $d53d0b0e7fd7257c$var$ITERATOR && !$1104f276c77260b3$exports(function() {
    $d53d0b0e7fd7257c$var$$parseInt(Object($d53d0b0e7fd7257c$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$d53d0b0e7fd7257c$exports = $d53d0b0e7fd7257c$var$FORCED ? function parseInt(string, radix) {
    var S = $d53d0b0e7fd7257c$require$trim($849a2f8baae8f2af$exports(string));
    return $d53d0b0e7fd7257c$var$$parseInt(S, radix >>> 0 || ($d53d0b0e7fd7257c$var$exec($d53d0b0e7fd7257c$var$hex, S) ? 16 : 10));
} : $d53d0b0e7fd7257c$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$97565072be87b482$exports({
    global: true,
    forced: parseInt != $d53d0b0e7fd7257c$exports
}, {
    parseInt: $d53d0b0e7fd7257c$exports
});



var $1f26c88519aa2091$exports = {};
"use strict";




var $cef0d896b6cf58f1$exports = {};


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$cef0d896b6cf58f1$exports = Object.keys || function keys(O) {
    return $2d80b1410d01c2f0$exports(O, $b4e8086632c003f8$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $1f26c88519aa2091$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $1f26c88519aa2091$var$defineProperty = Object.defineProperty;
var $1f26c88519aa2091$var$concat = $d9581cc7e9a63a67$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$1f26c88519aa2091$exports = !$1f26c88519aa2091$var$$assign || $1104f276c77260b3$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($b441ecc4617d98f6$exports && $1f26c88519aa2091$var$$assign({
        b: 1
    }, $1f26c88519aa2091$var$$assign($1f26c88519aa2091$var$defineProperty({}, "a", {
        enumerable: true,
        get: function get() {
            $1f26c88519aa2091$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $1f26c88519aa2091$var$$assign({}, A)[symbol] != 7 || $cef0d896b6cf58f1$exports($1f26c88519aa2091$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $ff4389c250ca5a45$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $8eae3d9df9090ad7$export$2d1720544b23b823;
    var propertyIsEnumerable = $99f4654824c2631e$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $a902ac574fe6ad75$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $1f26c88519aa2091$var$concat($cef0d896b6cf58f1$exports(S), getOwnPropertySymbols(S)) : $cef0d896b6cf58f1$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$b441ecc4617d98f6$exports || $ea29ea351915a40c$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $1f26c88519aa2091$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$97565072be87b482$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $1f26c88519aa2091$exports
}, {
    assign: $1f26c88519aa2091$exports
});


"use strict";

var $1fa87cb511688ccc$exports = {};
var $8b02461159973e21$exports = {};
var $c75e88a32fc47e70$exports = {};


$c75e88a32fc47e70$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($074f4f6f4a41a7f4$exports(fn) === "Function") return $d9581cc7e9a63a67$exports(fn);
};




var $8b02461159973e21$var$bind = $c75e88a32fc47e70$exports($c75e88a32fc47e70$exports.bind);
// optional / simple context binding
$8b02461159973e21$exports = function(fn, that) {
    $1934ccccb0254b37$exports(fn);
    return that === undefined ? fn : $8be7ca1e0c9f78a5$exports ? $8b02461159973e21$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $c4515eb6fd1fdddd$exports = {};
var $d1aa971a6a255e93$exports = {};
var $0d63d1622f9abc51$exports = {};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$0d63d1622f9abc51$exports = Array.isArray || function isArray(argument) {
    return $074f4f6f4a41a7f4$exports(argument) == "Array";
};


var $728b2b28cfcdaaac$exports = {};






var $728b2b28cfcdaaac$var$noop = function noop() {};
var $728b2b28cfcdaaac$var$empty = [];
var $728b2b28cfcdaaac$var$construct = $3eb28d316df83043$exports("Reflect", "construct");
var $728b2b28cfcdaaac$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $728b2b28cfcdaaac$var$exec = $d9581cc7e9a63a67$exports($728b2b28cfcdaaac$var$constructorRegExp.exec);
var $728b2b28cfcdaaac$var$INCORRECT_TO_STRING = !$728b2b28cfcdaaac$var$constructorRegExp.exec($728b2b28cfcdaaac$var$noop);
var $728b2b28cfcdaaac$var$isConstructorModern = function isConstructor(argument) {
    if (!$530c08156ef94345$exports(argument)) return false;
    try {
        $728b2b28cfcdaaac$var$construct($728b2b28cfcdaaac$var$noop, $728b2b28cfcdaaac$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $728b2b28cfcdaaac$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$530c08156ef94345$exports(argument)) return false;
    switch($42af2defb8a58367$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $728b2b28cfcdaaac$var$INCORRECT_TO_STRING || !!$728b2b28cfcdaaac$var$exec($728b2b28cfcdaaac$var$constructorRegExp, $d4f907e8d08af0c1$exports(argument));
    } catch (error) {
        return true;
    }
};
$728b2b28cfcdaaac$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$728b2b28cfcdaaac$exports = !$728b2b28cfcdaaac$var$construct || $1104f276c77260b3$exports(function() {
    var called;
    return $728b2b28cfcdaaac$var$isConstructorModern($728b2b28cfcdaaac$var$isConstructorModern.call) || !$728b2b28cfcdaaac$var$isConstructorModern(Object) || !$728b2b28cfcdaaac$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $728b2b28cfcdaaac$var$isConstructorLegacy : $728b2b28cfcdaaac$var$isConstructorModern;




var $d1aa971a6a255e93$var$SPECIES = $12359396acd4e225$exports("species");
var $d1aa971a6a255e93$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$d1aa971a6a255e93$exports = function(originalArray) {
    var C;
    if ($0d63d1622f9abc51$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($728b2b28cfcdaaac$exports(C) && (C === $d1aa971a6a255e93$var$$Array || $0d63d1622f9abc51$exports(C.prototype))) C = undefined;
        else if ($2d77b55ef7fd6e5b$exports(C)) {
            C = C[$d1aa971a6a255e93$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $d1aa971a6a255e93$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$c4515eb6fd1fdddd$exports = function(originalArray, length) {
    return new ($d1aa971a6a255e93$exports(originalArray))(length === 0 ? 0 : length);
};


var $1fa87cb511688ccc$var$push = $d9581cc7e9a63a67$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $1fa87cb511688ccc$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $ff4389c250ca5a45$exports($this);
        var self = $a902ac574fe6ad75$exports(O);
        var boundFunction = $8b02461159973e21$exports(callbackfn, that);
        var length = $c8b9baef6d1b44d4$exports(self);
        var index = 0;
        var create = specificCreate || $c4515eb6fd1fdddd$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $1fa87cb511688ccc$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $1fa87cb511688ccc$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$1fa87cb511688ccc$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $1fa87cb511688ccc$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $1fa87cb511688ccc$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $1fa87cb511688ccc$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $1fa87cb511688ccc$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $1fa87cb511688ccc$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $1fa87cb511688ccc$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $1fa87cb511688ccc$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $1fa87cb511688ccc$var$createMethod(7)
};


var $205db1683e4d6c03$require$$filter = $1fa87cb511688ccc$exports.filter;
var $9b410e7f02245460$exports = {};



var $9b410e7f02245460$var$SPECIES = $12359396acd4e225$exports("species");
$9b410e7f02245460$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $ce7a78bbf20168dc$exports >= 51 || !$1104f276c77260b3$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$9b410e7f02245460$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $205db1683e4d6c03$var$HAS_SPECIES_SUPPORT = $9b410e7f02245460$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$97565072be87b482$exports({
    target: "Array",
    proto: true,
    forced: !$205db1683e4d6c03$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $205db1683e4d6c03$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});




var $e91976d329378054$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$e91976d329378054$exports = $67fcf73f6f11473f$exports ? ({}).toString : function toString() {
    return "[object " + $42af2defb8a58367$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$67fcf73f6f11473f$exports) $8650e653ce14b304$exports(Object.prototype, "toString", $e91976d329378054$exports, {
    unsafe: true
});


var $e31d1d8f6dfbbde7$exports = {};
"use strict";

var $88c8f16d356b0e39$exports = {};

var $b118f6b8d01a304e$exports = {};
/* global ActiveXObject -- old IE, WSH */ 
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $ad2b1fdc5c4b874c$export$2d1720544b23b823;






$ad2b1fdc5c4b874c$export$2d1720544b23b823 = $b441ecc4617d98f6$exports && !$2a9098996ff929ab$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $375e5ed2420f5bb9$exports(O);
    var props = $42abcb0686b52d7e$exports(Properties);
    var keys = $cef0d896b6cf58f1$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$00895ebe3ae58406$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $67462c3ba4d7e17d$exports = {};

$67462c3ba4d7e17d$exports = $3eb28d316df83043$exports("document", "documentElement");




var $b118f6b8d01a304e$var$GT = ">";
var $b118f6b8d01a304e$var$LT = "<";
var $b118f6b8d01a304e$var$PROTOTYPE = "prototype";
var $b118f6b8d01a304e$var$SCRIPT = "script";
var $b118f6b8d01a304e$var$IE_PROTO = $af295684ca2687eb$exports("IE_PROTO");
var $b118f6b8d01a304e$var$EmptyConstructor = function EmptyConstructor() {};
var $b118f6b8d01a304e$var$scriptTag = function scriptTag(content) {
    return $b118f6b8d01a304e$var$LT + $b118f6b8d01a304e$var$SCRIPT + $b118f6b8d01a304e$var$GT + content + $b118f6b8d01a304e$var$LT + "/" + $b118f6b8d01a304e$var$SCRIPT + $b118f6b8d01a304e$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $b118f6b8d01a304e$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($b118f6b8d01a304e$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b118f6b8d01a304e$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $689214aa055d150d$exports("iframe");
    var JS = "java" + $b118f6b8d01a304e$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $67462c3ba4d7e17d$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($b118f6b8d01a304e$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $b118f6b8d01a304e$var$activeXDocument;
var $b118f6b8d01a304e$var$NullProtoObject = function NullProtoObject1() {
    try {
        $b118f6b8d01a304e$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $b118f6b8d01a304e$var$NullProtoObject = typeof document != "undefined" ? document.domain && $b118f6b8d01a304e$var$activeXDocument ? $b118f6b8d01a304e$var$NullProtoObjectViaActiveX($b118f6b8d01a304e$var$activeXDocument) // old IE
     : $b118f6b8d01a304e$var$NullProtoObjectViaIFrame() : $b118f6b8d01a304e$var$NullProtoObjectViaActiveX($b118f6b8d01a304e$var$activeXDocument); // WSH
    var length = $b4e8086632c003f8$exports.length;
    while(length--)delete $b118f6b8d01a304e$var$NullProtoObject[$b118f6b8d01a304e$var$PROTOTYPE][$b4e8086632c003f8$exports[length]];
    return $b118f6b8d01a304e$var$NullProtoObject();
};
$d94bcaeda9e43336$exports[$b118f6b8d01a304e$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$b118f6b8d01a304e$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b118f6b8d01a304e$var$EmptyConstructor[$b118f6b8d01a304e$var$PROTOTYPE] = $375e5ed2420f5bb9$exports(O);
        result = new $b118f6b8d01a304e$var$EmptyConstructor();
        $b118f6b8d01a304e$var$EmptyConstructor[$b118f6b8d01a304e$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b118f6b8d01a304e$var$IE_PROTO] = O;
    } else result = $b118f6b8d01a304e$var$NullProtoObject();
    return Properties === undefined ? result : $ad2b1fdc5c4b874c$export$2d1720544b23b823(result, Properties);
};



var $88c8f16d356b0e39$require$defineProperty = $00895ebe3ae58406$export$2d1720544b23b823;
var $88c8f16d356b0e39$var$UNSCOPABLES = $12359396acd4e225$exports("unscopables");
var $88c8f16d356b0e39$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($88c8f16d356b0e39$var$ArrayPrototype[$88c8f16d356b0e39$var$UNSCOPABLES] == undefined) $88c8f16d356b0e39$require$defineProperty($88c8f16d356b0e39$var$ArrayPrototype, $88c8f16d356b0e39$var$UNSCOPABLES, {
    configurable: true,
    value: $b118f6b8d01a304e$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$88c8f16d356b0e39$exports = function(key) {
    $88c8f16d356b0e39$var$ArrayPrototype[$88c8f16d356b0e39$var$UNSCOPABLES][key] = true;
};


var $a8f5537c0076b483$exports = {};
$a8f5537c0076b483$exports = {};




var $e31d1d8f6dfbbde7$require$defineProperty = $00895ebe3ae58406$export$2d1720544b23b823;
var $fc0aac938e9ac9c8$exports = {};
"use strict";





var $e6e84b424a3723aa$exports = {};
"use strict";
var $929e50c6c06d2035$exports = {};
"use strict";




var $b41223d4c82da9fe$exports = {};




var $52c2cff86e08cdf2$exports = {};

$52c2cff86e08cdf2$exports = !$1104f276c77260b3$exports(function() {
    var F = function F() {};
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $b41223d4c82da9fe$var$IE_PROTO = $af295684ca2687eb$exports("IE_PROTO");
var $b41223d4c82da9fe$var$$Object = Object;
var $b41223d4c82da9fe$var$ObjectPrototype = $b41223d4c82da9fe$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$b41223d4c82da9fe$exports = $52c2cff86e08cdf2$exports ? $b41223d4c82da9fe$var$$Object.getPrototypeOf : function(O) {
    var object = $ff4389c250ca5a45$exports(O);
    if ($e41bb36ebbba59e0$exports(object, $b41223d4c82da9fe$var$IE_PROTO)) return object[$b41223d4c82da9fe$var$IE_PROTO];
    var constructor = object.constructor;
    if ($530c08156ef94345$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $b41223d4c82da9fe$var$$Object ? $b41223d4c82da9fe$var$ObjectPrototype : null;
};





var $929e50c6c06d2035$var$ITERATOR = $12359396acd4e225$exports("iterator");
var $929e50c6c06d2035$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $929e50c6c06d2035$var$IteratorPrototype, $929e50c6c06d2035$var$PrototypeOfArrayIteratorPrototype, $929e50c6c06d2035$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $929e50c6c06d2035$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $929e50c6c06d2035$var$arrayIterator)) $929e50c6c06d2035$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $929e50c6c06d2035$var$PrototypeOfArrayIteratorPrototype = $b41223d4c82da9fe$exports($b41223d4c82da9fe$exports($929e50c6c06d2035$var$arrayIterator));
        if ($929e50c6c06d2035$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $929e50c6c06d2035$var$IteratorPrototype = $929e50c6c06d2035$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $929e50c6c06d2035$var$NEW_ITERATOR_PROTOTYPE = !$2d77b55ef7fd6e5b$exports($929e50c6c06d2035$var$IteratorPrototype) || $1104f276c77260b3$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $929e50c6c06d2035$var$IteratorPrototype[$929e50c6c06d2035$var$ITERATOR].call(test) !== test;
});
if ($929e50c6c06d2035$var$NEW_ITERATOR_PROTOTYPE) $929e50c6c06d2035$var$IteratorPrototype = {};
else if ($a45e6ce82b8c6504$exports) $929e50c6c06d2035$var$IteratorPrototype = $b118f6b8d01a304e$exports($929e50c6c06d2035$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$530c08156ef94345$exports($929e50c6c06d2035$var$IteratorPrototype[$929e50c6c06d2035$var$ITERATOR])) $8650e653ce14b304$exports($929e50c6c06d2035$var$IteratorPrototype, $929e50c6c06d2035$var$ITERATOR, function() {
    return this;
});
$929e50c6c06d2035$exports = {
    IteratorPrototype: $929e50c6c06d2035$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $929e50c6c06d2035$var$BUGGY_SAFARI_ITERATORS
};


var $e6e84b424a3723aa$require$IteratorPrototype = $929e50c6c06d2035$exports.IteratorPrototype;


var $ea7e227f12ff35cf$exports = {};

var $ea7e227f12ff35cf$require$defineProperty = $00895ebe3ae58406$export$2d1720544b23b823;


var $ea7e227f12ff35cf$var$TO_STRING_TAG = $12359396acd4e225$exports("toStringTag");
$ea7e227f12ff35cf$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$e41bb36ebbba59e0$exports(target, $ea7e227f12ff35cf$var$TO_STRING_TAG)) $ea7e227f12ff35cf$require$defineProperty(target, $ea7e227f12ff35cf$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $e6e84b424a3723aa$var$returnThis = function returnThis() {
    return this;
};
$e6e84b424a3723aa$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $b118f6b8d01a304e$exports($e6e84b424a3723aa$require$IteratorPrototype, {
        next: $e10032196d592fc9$exports(+!ENUMERABLE_NEXT, next)
    });
    $ea7e227f12ff35cf$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $a8f5537c0076b483$exports[TO_STRING_TAG] = $e6e84b424a3723aa$var$returnThis;
    return IteratorConstructor;
};



var $0e623e7ed1fd79d5$exports = {};
/* eslint-disable no-proto -- safe */ var $87ed47e119772d10$exports = {};


$87ed47e119772d10$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $d9581cc7e9a63a67$exports($1934ccccb0254b37$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $e88b677e7b064880$exports = {};

var $e88b677e7b064880$var$$String = String;
var $e88b677e7b064880$var$$TypeError = TypeError;
$e88b677e7b064880$exports = function(argument) {
    if (typeof argument == "object" || $530c08156ef94345$exports(argument)) return argument;
    throw $e88b677e7b064880$var$$TypeError("Can't set " + $e88b677e7b064880$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$0e623e7ed1fd79d5$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $87ed47e119772d10$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $375e5ed2420f5bb9$exports(O);
        $e88b677e7b064880$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $fc0aac938e9ac9c8$var$PROPER_FUNCTION_NAME = $a90617eefec74231$exports.PROPER;
var $fc0aac938e9ac9c8$var$CONFIGURABLE_FUNCTION_NAME = $a90617eefec74231$exports.CONFIGURABLE;
var $fc0aac938e9ac9c8$var$IteratorPrototype = $929e50c6c06d2035$exports.IteratorPrototype;
var $fc0aac938e9ac9c8$var$BUGGY_SAFARI_ITERATORS = $929e50c6c06d2035$exports.BUGGY_SAFARI_ITERATORS;
var $fc0aac938e9ac9c8$var$ITERATOR = $12359396acd4e225$exports("iterator");
var $fc0aac938e9ac9c8$var$KEYS = "keys";
var $fc0aac938e9ac9c8$var$VALUES = "values";
var $fc0aac938e9ac9c8$var$ENTRIES = "entries";
var $fc0aac938e9ac9c8$var$returnThis = function returnThis() {
    return this;
};
$fc0aac938e9ac9c8$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $e6e84b424a3723aa$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$fc0aac938e9ac9c8$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $fc0aac938e9ac9c8$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $fc0aac938e9ac9c8$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $fc0aac938e9ac9c8$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$fc0aac938e9ac9c8$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$fc0aac938e9ac9c8$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $b41223d4c82da9fe$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$a45e6ce82b8c6504$exports && $b41223d4c82da9fe$exports(CurrentIteratorPrototype) !== $fc0aac938e9ac9c8$var$IteratorPrototype) {
                if ($0e623e7ed1fd79d5$exports) $0e623e7ed1fd79d5$exports(CurrentIteratorPrototype, $fc0aac938e9ac9c8$var$IteratorPrototype);
                else if (!$530c08156ef94345$exports(CurrentIteratorPrototype[$fc0aac938e9ac9c8$var$ITERATOR])) $8650e653ce14b304$exports(CurrentIteratorPrototype, $fc0aac938e9ac9c8$var$ITERATOR, $fc0aac938e9ac9c8$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $ea7e227f12ff35cf$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($a45e6ce82b8c6504$exports) $a8f5537c0076b483$exports[TO_STRING_TAG] = $fc0aac938e9ac9c8$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($fc0aac938e9ac9c8$var$PROPER_FUNCTION_NAME && DEFAULT == $fc0aac938e9ac9c8$var$VALUES && nativeIterator && nativeIterator.name !== $fc0aac938e9ac9c8$var$VALUES) {
        if (!$a45e6ce82b8c6504$exports && $fc0aac938e9ac9c8$var$CONFIGURABLE_FUNCTION_NAME) $b799eb4d8561c8c3$exports(IterablePrototype, "name", $fc0aac938e9ac9c8$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $ea29ea351915a40c$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($fc0aac938e9ac9c8$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($fc0aac938e9ac9c8$var$KEYS),
            entries: getIterationMethod($fc0aac938e9ac9c8$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($fc0aac938e9ac9c8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $8650e653ce14b304$exports(IterablePrototype, KEY, methods[KEY]);
        } else $97565072be87b482$exports({
            target: NAME,
            proto: true,
            forced: $fc0aac938e9ac9c8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$a45e6ce82b8c6504$exports || FORCED) && IterablePrototype[$fc0aac938e9ac9c8$var$ITERATOR] !== defaultIterator) $8650e653ce14b304$exports(IterablePrototype, $fc0aac938e9ac9c8$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $a8f5537c0076b483$exports[NAME] = defaultIterator;
    return methods;
};


var $8bf97d35dd148bee$exports = {};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$8bf97d35dd148bee$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $e31d1d8f6dfbbde7$var$ARRAY_ITERATOR = "Array Iterator";
var $e31d1d8f6dfbbde7$var$setInternalState = $0f915c35577af5f4$exports.set;
var $e31d1d8f6dfbbde7$var$getInternalState = $0f915c35577af5f4$exports.getterFor($e31d1d8f6dfbbde7$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$e31d1d8f6dfbbde7$exports = $fc0aac938e9ac9c8$exports(Array, "Array", function(iterated, kind) {
    $e31d1d8f6dfbbde7$var$setInternalState(this, {
        type: $e31d1d8f6dfbbde7$var$ARRAY_ITERATOR,
        target: $42abcb0686b52d7e$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $e31d1d8f6dfbbde7$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $8bf97d35dd148bee$exports(undefined, true);
    }
    if (kind == "keys") return $8bf97d35dd148bee$exports(index, false);
    if (kind == "values") return $8bf97d35dd148bee$exports(target[index], false);
    return $8bf97d35dd148bee$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $e31d1d8f6dfbbde7$var$values = $a8f5537c0076b483$exports.Arguments = $a8f5537c0076b483$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$88c8f16d356b0e39$exports("keys");
$88c8f16d356b0e39$exports("values");
$88c8f16d356b0e39$exports("entries");
// V8 ~ Chrome 45- bug
if (!$a45e6ce82b8c6504$exports && $b441ecc4617d98f6$exports && $e31d1d8f6dfbbde7$var$values.name !== "values") try {
    $e31d1d8f6dfbbde7$require$defineProperty($e31d1d8f6dfbbde7$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $5fac87ef7397acd2$exports = {};




var $5fac87ef7397acd2$var$charAt = $d9581cc7e9a63a67$exports("".charAt);
var $5fac87ef7397acd2$var$charCodeAt = $d9581cc7e9a63a67$exports("".charCodeAt);
var $5fac87ef7397acd2$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
var $5fac87ef7397acd2$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $849a2f8baae8f2af$exports($c6c632a1427ebe2e$exports($this));
        var position = $a7928c5e8e393354$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $5fac87ef7397acd2$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $5fac87ef7397acd2$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $5fac87ef7397acd2$var$charAt(S, position) : first : CONVERT_TO_STRING ? $5fac87ef7397acd2$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$5fac87ef7397acd2$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $5fac87ef7397acd2$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $5fac87ef7397acd2$var$createMethod(true)
};


var $9b043b696b2ec19c$require$charAt = $5fac87ef7397acd2$exports.charAt;




var $9b043b696b2ec19c$var$STRING_ITERATOR = "String Iterator";
var $9b043b696b2ec19c$var$setInternalState = $0f915c35577af5f4$exports.set;
var $9b043b696b2ec19c$var$getInternalState = $0f915c35577af5f4$exports.getterFor($9b043b696b2ec19c$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$fc0aac938e9ac9c8$exports(String, "String", function(iterated) {
    $9b043b696b2ec19c$var$setInternalState(this, {
        type: $9b043b696b2ec19c$var$STRING_ITERATOR,
        string: $849a2f8baae8f2af$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $9b043b696b2ec19c$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $8bf97d35dd148bee$exports(undefined, true);
    point = $9b043b696b2ec19c$require$charAt(string, index);
    state.index += point.length;
    return $8bf97d35dd148bee$exports(point, false);
});


// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";
var $5b9ef44dfa1cd4cc$exports = {};

$5b9ef44dfa1cd4cc$exports = !$1104f276c77260b3$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $6a994283048f2a75$exports = {};

$6a994283048f2a75$exports = function(target, src, options) {
    for(var key in src)$8650e653ce14b304$exports(target, key, src[key], options);
    return target;
};


var $bc67952134134083$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");






var $bc67952134134083$require$defineProperty = $00895ebe3ae58406$export$2d1720544b23b823;

/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $59ea5b2e9f151409$export$2d1720544b23b823;



var $59ea5b2e9f151409$require$$getOwnPropertyNames = $fd6385a3c1e76a21$export$2d1720544b23b823;
var $1d18181724b16d70$exports = {};


var $038cb3dad1429c93$exports = {};
"use strict";



$038cb3dad1429c93$exports = function(object, key, value) {
    var propertyKey = $c5490d21bf4c572d$exports(key);
    if (propertyKey in object) $00895ebe3ae58406$export$2d1720544b23b823(object, propertyKey, $e10032196d592fc9$exports(0, value));
    else object[propertyKey] = value;
};


var $1d18181724b16d70$var$$Array = Array;
var $1d18181724b16d70$var$max = Math.max;
$1d18181724b16d70$exports = function(O, start, end) {
    var length = $c8b9baef6d1b44d4$exports(O);
    var k = $e5b0598b07e70514$exports(start, length);
    var fin = $e5b0598b07e70514$exports(end === undefined ? length : end, length);
    var result = $1d18181724b16d70$var$$Array($1d18181724b16d70$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$038cb3dad1429c93$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $59ea5b2e9f151409$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $59ea5b2e9f151409$var$getWindowNames = function getWindowNames(it) {
    try {
        return $59ea5b2e9f151409$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $1d18181724b16d70$exports($59ea5b2e9f151409$var$windowNames);
    }
};
$59ea5b2e9f151409$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $59ea5b2e9f151409$var$windowNames && $074f4f6f4a41a7f4$exports(it) == "Window" ? $59ea5b2e9f151409$var$getWindowNames(it) : $59ea5b2e9f151409$require$$getOwnPropertyNames($42abcb0686b52d7e$exports(it));
};


var $e9df98880f28bdd3$exports = {};



var $026fe5acc16bf81b$exports = {};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

$026fe5acc16bf81b$exports = $1104f276c77260b3$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $e9df98880f28bdd3$var$$isExtensible = Object.isExtensible;
var $e9df98880f28bdd3$var$FAILS_ON_PRIMITIVES = $1104f276c77260b3$exports(function() {
    $e9df98880f28bdd3$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$e9df98880f28bdd3$exports = $e9df98880f28bdd3$var$FAILS_ON_PRIMITIVES || $026fe5acc16bf81b$exports ? function isExtensible(it) {
    if (!$2d77b55ef7fd6e5b$exports(it)) return false;
    if ($026fe5acc16bf81b$exports && $074f4f6f4a41a7f4$exports(it) == "ArrayBuffer") return false;
    return $e9df98880f28bdd3$var$$isExtensible ? $e9df98880f28bdd3$var$$isExtensible(it) : true;
} : $e9df98880f28bdd3$var$$isExtensible;




var $bc67952134134083$var$REQUIRED = false;
var $bc67952134134083$var$METADATA = $be14777b267b4408$exports("meta");
var $bc67952134134083$var$id = 0;
var $bc67952134134083$var$setMetadata = function setMetadata(it) {
    $bc67952134134083$require$defineProperty(it, $bc67952134134083$var$METADATA, {
        value: {
            objectID: "O" + $bc67952134134083$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $bc67952134134083$var$fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!$2d77b55ef7fd6e5b$exports(it)) return (typeof it === "undefined" ? "undefined" : (0, $5F2Q2._)(it)) == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$e41bb36ebbba59e0$exports(it, $bc67952134134083$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$e9df98880f28bdd3$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $bc67952134134083$var$setMetadata(it);
    // return object ID
    }
    return it[$bc67952134134083$var$METADATA].objectID;
};
var $bc67952134134083$var$getWeakData = function getWeakData(it, create) {
    if (!$e41bb36ebbba59e0$exports(it, $bc67952134134083$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$e9df98880f28bdd3$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $bc67952134134083$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$bc67952134134083$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $bc67952134134083$var$onFreeze = function onFreeze(it) {
    if ($5b9ef44dfa1cd4cc$exports && $bc67952134134083$var$REQUIRED && $e9df98880f28bdd3$exports(it) && !$e41bb36ebbba59e0$exports(it, $bc67952134134083$var$METADATA)) $bc67952134134083$var$setMetadata(it);
    return it;
};
var $bc67952134134083$var$enable = function enable() {
    $bc67952134134083$var$meta.enable = function() {};
    $bc67952134134083$var$REQUIRED = true;
    var getOwnPropertyNames = $fd6385a3c1e76a21$export$2d1720544b23b823;
    var splice = $d9581cc7e9a63a67$exports([].splice);
    var test = {};
    test[$bc67952134134083$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $fd6385a3c1e76a21$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $bc67952134134083$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $97565072be87b482$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $59ea5b2e9f151409$export$2d1720544b23b823
        });
    }
};
var $bc67952134134083$var$meta = $bc67952134134083$exports = {
    enable: $bc67952134134083$var$enable,
    fastKey: $bc67952134134083$var$fastKey,
    getWeakData: $bc67952134134083$var$getWeakData,
    onFreeze: $bc67952134134083$var$onFreeze
};
$d94bcaeda9e43336$exports[$bc67952134134083$var$METADATA] = true;


var $4c0aab3452876b49$exports = {};
"use strict";






var $ab4aba24c707fb95$exports = {};




var $181a54746bb3bd39$exports = {};


var $181a54746bb3bd39$var$ITERATOR = $12359396acd4e225$exports("iterator");
var $181a54746bb3bd39$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$181a54746bb3bd39$exports = function(it) {
    return it !== undefined && ($a8f5537c0076b483$exports.Array === it || $181a54746bb3bd39$var$ArrayPrototype[$181a54746bb3bd39$var$ITERATOR] === it);
};




var $8f06448be677c9bf$exports = {};




var $037408689c1558c5$exports = {};





var $037408689c1558c5$var$ITERATOR = $12359396acd4e225$exports("iterator");
$037408689c1558c5$exports = function(it) {
    if (!$23bd47ceb739678b$exports(it)) return $86a8def7b6f243c9$exports(it, $037408689c1558c5$var$ITERATOR) || $86a8def7b6f243c9$exports(it, "@@iterator") || $a8f5537c0076b483$exports[$42af2defb8a58367$exports(it)];
};


var $8f06448be677c9bf$var$$TypeError = TypeError;
$8f06448be677c9bf$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $037408689c1558c5$exports(argument) : usingIterator;
    if ($1934ccccb0254b37$exports(iteratorMethod)) return $375e5ed2420f5bb9$exports($ea29ea351915a40c$exports(iteratorMethod, argument));
    throw $8f06448be677c9bf$var$$TypeError($c313a08f63affb1d$exports(argument) + " is not iterable");
};



var $d54c18c98b1d3255$exports = {};



$d54c18c98b1d3255$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $375e5ed2420f5bb9$exports(iterator);
    try {
        innerResult = $86a8def7b6f243c9$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $ea29ea351915a40c$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $375e5ed2420f5bb9$exports(innerResult);
    return value;
};


var $ab4aba24c707fb95$var$$TypeError = TypeError;
var $ab4aba24c707fb95$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $ab4aba24c707fb95$var$ResultPrototype = $ab4aba24c707fb95$var$Result.prototype;
$ab4aba24c707fb95$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $8b02461159973e21$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $d54c18c98b1d3255$exports(iterator, "normal", condition);
        return new $ab4aba24c707fb95$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $375e5ed2420f5bb9$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $037408689c1558c5$exports(iterable);
        if (!iterFn) throw $ab4aba24c707fb95$var$$TypeError($c313a08f63affb1d$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($181a54746bb3bd39$exports(iterFn)) {
            for(index = 0, length = $c8b9baef6d1b44d4$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $a4c3886c6ef6d2b5$exports($ab4aba24c707fb95$var$ResultPrototype, result)) return result;
            }
            return new $ab4aba24c707fb95$var$Result(false);
        }
        iterator = $8f06448be677c9bf$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $ea29ea351915a40c$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $d54c18c98b1d3255$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $a4c3886c6ef6d2b5$exports($ab4aba24c707fb95$var$ResultPrototype, result)) return result;
    }
    return new $ab4aba24c707fb95$var$Result(false);
};


var $245125fc32fe0319$exports = {};

var $245125fc32fe0319$var$$TypeError = TypeError;
$245125fc32fe0319$exports = function(it, Prototype) {
    if ($a4c3886c6ef6d2b5$exports(Prototype, it)) return it;
    throw $245125fc32fe0319$var$$TypeError("Incorrect invocation");
};






var $5367aabcc1b87b69$exports = {};

var $5367aabcc1b87b69$var$ITERATOR = $12359396acd4e225$exports("iterator");
var $5367aabcc1b87b69$var$SAFE_CLOSING = false;
try {
    var $5367aabcc1b87b69$var$called = 0;
    var $5367aabcc1b87b69$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$5367aabcc1b87b69$var$called++
            };
        },
        "return": function() {
            $5367aabcc1b87b69$var$SAFE_CLOSING = true;
        }
    };
    $5367aabcc1b87b69$var$iteratorWithReturn[$5367aabcc1b87b69$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($5367aabcc1b87b69$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$5367aabcc1b87b69$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5367aabcc1b87b69$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5367aabcc1b87b69$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $c8e6e1f070f9f140$exports = {};



// makes subclassing work correct for wrapped built-ins
$c8e6e1f070f9f140$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $0e623e7ed1fd79d5$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $530c08156ef94345$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $2d77b55ef7fd6e5b$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $0e623e7ed1fd79d5$exports($this, NewTargetPrototype);
    return $this;
};


$4c0aab3452876b49$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $2882607b9f426a2f$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = $d9581cc7e9a63a67$exports(NativePrototype[KEY]);
        $8650e653ce14b304$exports(NativePrototype, KEY, KEY == "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY == "delete" ? function(key) {
            return IS_WEAK && !$2d77b55ef7fd6e5b$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "get" ? function get(key) {
            return IS_WEAK && !$2d77b55ef7fd6e5b$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "has" ? function has(key) {
            return IS_WEAK && !$2d77b55ef7fd6e5b$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $bca9e1c3de00006a$exports(CONSTRUCTOR_NAME, !$530c08156ef94345$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1104f276c77260b3$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $bc67952134134083$exports.enable();
    } else if ($bca9e1c3de00006a$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1104f276c77260b3$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $5367aabcc1b87b69$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1104f276c77260b3$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $245125fc32fe0319$exports(dummy, NativePrototype);
                var that = $c8e6e1f070f9f140$exports(new NativeConstructor(), dummy, Constructor);
                if (!$23bd47ceb739678b$exports(iterable)) $ab4aba24c707fb95$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $97565072be87b482$exports({
        global: true,
        constructor: true,
        forced: Constructor != NativeConstructor
    }, exported);
    $ea7e227f12ff35cf$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $0ccf7b0903ab81a2$exports = {};
"use strict";



var $0ccf7b0903ab81a2$require$getWeakData = $bc67952134134083$exports.getWeakData;








var $0ccf7b0903ab81a2$var$setInternalState = $0f915c35577af5f4$exports.set;
var $0ccf7b0903ab81a2$var$internalStateGetterFor = $0f915c35577af5f4$exports.getterFor;
var $0ccf7b0903ab81a2$var$find = $1fa87cb511688ccc$exports.find;
var $0ccf7b0903ab81a2$var$findIndex = $1fa87cb511688ccc$exports.findIndex;
var $0ccf7b0903ab81a2$var$splice = $d9581cc7e9a63a67$exports([].splice);
var $0ccf7b0903ab81a2$var$id = 0;
// fallback for uncaught frozen keys
var $0ccf7b0903ab81a2$var$uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new $0ccf7b0903ab81a2$var$UncaughtFrozenStore());
};
var $0ccf7b0903ab81a2$var$UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var $0ccf7b0903ab81a2$var$findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return $0ccf7b0903ab81a2$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$0ccf7b0903ab81a2$var$UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = $0ccf7b0903ab81a2$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!$0ccf7b0903ab81a2$var$findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = $0ccf7b0903ab81a2$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $0ccf7b0903ab81a2$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $0ccf7b0903ab81a2$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$0ccf7b0903ab81a2$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $245125fc32fe0319$exports(that, Prototype);
            $0ccf7b0903ab81a2$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $0ccf7b0903ab81a2$var$id++,
                frozen: undefined
            });
            if (!$23bd47ceb739678b$exports(iterable)) $ab4aba24c707fb95$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $0ccf7b0903ab81a2$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = $0ccf7b0903ab81a2$require$getWeakData($375e5ed2420f5bb9$exports(key), true);
            if (data === true) $0ccf7b0903ab81a2$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $6a994283048f2a75$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$2d77b55ef7fd6e5b$exports(key)) return false;
                var data = $0ccf7b0903ab81a2$require$getWeakData(key);
                if (data === true) return $0ccf7b0903ab81a2$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $e41bb36ebbba59e0$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$2d77b55ef7fd6e5b$exports(key)) return false;
                var data = $0ccf7b0903ab81a2$require$getWeakData(key);
                if (data === true) return $0ccf7b0903ab81a2$var$uncaughtFrozenStore(state).has(key);
                return data && $e41bb36ebbba59e0$exports(data, state.id);
            }
        });
        $6a994283048f2a75$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($2d77b55ef7fd6e5b$exports(key)) {
                    var data = $0ccf7b0903ab81a2$require$getWeakData(key);
                    if (data === true) return $0ccf7b0903ab81a2$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $88ec92041aa29253$require$enforceInternalState = $0f915c35577af5f4$exports.enforce;


var $88ec92041aa29253$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $88ec92041aa29253$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $88ec92041aa29253$var$isExtensible = $88ec92041aa29253$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $88ec92041aa29253$var$isFrozen = $88ec92041aa29253$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $88ec92041aa29253$var$isSealed = $88ec92041aa29253$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $88ec92041aa29253$var$freeze = $88ec92041aa29253$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $88ec92041aa29253$var$seal = $88ec92041aa29253$var$$Object.seal;
var $88ec92041aa29253$var$FROZEN = {};
var $88ec92041aa29253$var$SEALED = {};
var $88ec92041aa29253$var$IS_IE11 = !$2882607b9f426a2f$exports.ActiveXObject && "ActiveXObject" in $2882607b9f426a2f$exports;
var $88ec92041aa29253$var$InternalWeakMap;
var $88ec92041aa29253$var$wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $88ec92041aa29253$var$$WeakMap = $4c0aab3452876b49$exports("WeakMap", $88ec92041aa29253$var$wrapper, $0ccf7b0903ab81a2$exports);
var $88ec92041aa29253$var$WeakMapPrototype = $88ec92041aa29253$var$$WeakMap.prototype;
var $88ec92041aa29253$var$nativeSet = $d9581cc7e9a63a67$exports($88ec92041aa29253$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $88ec92041aa29253$var$hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return $5b9ef44dfa1cd4cc$exports && $1104f276c77260b3$exports(function() {
        var frozenArray = $88ec92041aa29253$var$freeze([]);
        $88ec92041aa29253$var$nativeSet(new $88ec92041aa29253$var$$WeakMap(), frozenArray, 1);
        return !$88ec92041aa29253$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($b2211da45717197a$exports) {
    if ($88ec92041aa29253$var$IS_IE11) {
        $88ec92041aa29253$var$InternalWeakMap = $0ccf7b0903ab81a2$exports.getConstructor($88ec92041aa29253$var$wrapper, "WeakMap", true);
        $bc67952134134083$exports.enable();
        var $88ec92041aa29253$var$nativeDelete = $d9581cc7e9a63a67$exports($88ec92041aa29253$var$WeakMapPrototype["delete"]);
        var $88ec92041aa29253$var$nativeHas = $d9581cc7e9a63a67$exports($88ec92041aa29253$var$WeakMapPrototype.has);
        var $88ec92041aa29253$var$nativeGet = $d9581cc7e9a63a67$exports($88ec92041aa29253$var$WeakMapPrototype.get);
        $6a994283048f2a75$exports($88ec92041aa29253$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($2d77b55ef7fd6e5b$exports(key) && !$88ec92041aa29253$var$isExtensible(key)) {
                    var state = $88ec92041aa29253$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $88ec92041aa29253$var$InternalWeakMap();
                    return $88ec92041aa29253$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $88ec92041aa29253$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($2d77b55ef7fd6e5b$exports(key) && !$88ec92041aa29253$var$isExtensible(key)) {
                    var state = $88ec92041aa29253$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $88ec92041aa29253$var$InternalWeakMap();
                    return $88ec92041aa29253$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $88ec92041aa29253$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($2d77b55ef7fd6e5b$exports(key) && !$88ec92041aa29253$var$isExtensible(key)) {
                    var state = $88ec92041aa29253$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $88ec92041aa29253$var$InternalWeakMap();
                    return $88ec92041aa29253$var$nativeHas(this, key) ? $88ec92041aa29253$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $88ec92041aa29253$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($2d77b55ef7fd6e5b$exports(key) && !$88ec92041aa29253$var$isExtensible(key)) {
                    var state = $88ec92041aa29253$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $88ec92041aa29253$var$InternalWeakMap();
                    $88ec92041aa29253$var$nativeHas(this, key) ? $88ec92041aa29253$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $88ec92041aa29253$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($88ec92041aa29253$var$hasMSEdgeFreezingBug()) $6a994283048f2a75$exports($88ec92041aa29253$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($88ec92041aa29253$var$isArray(key)) {
                if ($88ec92041aa29253$var$isFrozen(key)) arrayIntegrityLevel = $88ec92041aa29253$var$FROZEN;
                else if ($88ec92041aa29253$var$isSealed(key)) arrayIntegrityLevel = $88ec92041aa29253$var$SEALED;
            }
            $88ec92041aa29253$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $88ec92041aa29253$var$FROZEN) $88ec92041aa29253$var$freeze(key);
            if (arrayIntegrityLevel == $88ec92041aa29253$var$SEALED) $88ec92041aa29253$var$seal(key);
            return this;
        }
    });
}





var $b3db4ce112a54298$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$b3db4ce112a54298$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $e6e8294014580ed8$exports = {};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var $e6e8294014580ed8$var$classList = $689214aa055d150d$exports("span").classList;
var $e6e8294014580ed8$var$DOMTokenListPrototype = $e6e8294014580ed8$var$classList && $e6e8294014580ed8$var$classList.constructor && $e6e8294014580ed8$var$classList.constructor.prototype;
$e6e8294014580ed8$exports = $e6e8294014580ed8$var$DOMTokenListPrototype === Object.prototype ? undefined : $e6e8294014580ed8$var$DOMTokenListPrototype;





var $5af08b741bde7309$var$ITERATOR = $12359396acd4e225$exports("iterator");
var $5af08b741bde7309$var$TO_STRING_TAG = $12359396acd4e225$exports("toStringTag");
var $5af08b741bde7309$var$ArrayValues = $e31d1d8f6dfbbde7$exports.values;
var $5af08b741bde7309$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$5af08b741bde7309$var$ITERATOR] !== $5af08b741bde7309$var$ArrayValues) try {
            $b799eb4d8561c8c3$exports(CollectionPrototype, $5af08b741bde7309$var$ITERATOR, $5af08b741bde7309$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$5af08b741bde7309$var$ITERATOR] = $5af08b741bde7309$var$ArrayValues;
        }
        if (!CollectionPrototype[$5af08b741bde7309$var$TO_STRING_TAG]) $b799eb4d8561c8c3$exports(CollectionPrototype, $5af08b741bde7309$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($b3db4ce112a54298$exports[COLLECTION_NAME]) for(var METHOD_NAME in $e31d1d8f6dfbbde7$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $e31d1d8f6dfbbde7$exports[METHOD_NAME]) try {
                $b799eb4d8561c8c3$exports(CollectionPrototype, METHOD_NAME, $e31d1d8f6dfbbde7$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $e31d1d8f6dfbbde7$exports[METHOD_NAME];
            }
        }
    }
};
for(var $5af08b741bde7309$var$COLLECTION_NAME in $b3db4ce112a54298$exports)$5af08b741bde7309$var$handlePrototype($2882607b9f426a2f$exports[$5af08b741bde7309$var$COLLECTION_NAME] && $2882607b9f426a2f$exports[$5af08b741bde7309$var$COLLECTION_NAME].prototype, $5af08b741bde7309$var$COLLECTION_NAME);
$5af08b741bde7309$var$handlePrototype($e6e8294014580ed8$exports, "DOMTokenList");


var $def31092b764ac4c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $def31092b764ac4c$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $def31092b764ac4c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $def31092b764ac4c$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $def31092b764ac4c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $def31092b764ac4c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $def31092b764ac4c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $def31092b764ac4c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $def31092b764ac4c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $def31092b764ac4c$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $def31092b764ac4c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $def31092b764ac4c$var$root = $def31092b764ac4c$var$freeGlobal || $def31092b764ac4c$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $def31092b764ac4c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $def31092b764ac4c$var$objectToString = $def31092b764ac4c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $def31092b764ac4c$var$nativeMax = Math.max, $def31092b764ac4c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $def31092b764ac4c$var$now = function now() {
    return $def31092b764ac4c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $def31092b764ac4c$var$debounce(func, wait, options) {
    var invokeFunc = function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    };
    var leadingEdge = function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    };
    var remainingWait = function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $def31092b764ac4c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    };
    var shouldInvoke = function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    };
    var trailingEdge = function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    };
    var cancel = function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    };
    var flush = function flush() {
        return timerId === undefined ? result : trailingEdge($def31092b764ac4c$var$now());
    };
    var debounced = function debounced() {
        var time = $def31092b764ac4c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    };
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($def31092b764ac4c$var$FUNC_ERROR_TEXT);
    wait = $def31092b764ac4c$var$toNumber(wait) || 0;
    if ($def31092b764ac4c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $def31092b764ac4c$var$nativeMax($def31092b764ac4c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function timerExpired() {
        var time = $def31092b764ac4c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $def31092b764ac4c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($def31092b764ac4c$var$FUNC_ERROR_TEXT);
    if ($def31092b764ac4c$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $def31092b764ac4c$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $def31092b764ac4c$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $def31092b764ac4c$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $def31092b764ac4c$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value)) == "symbol" || $def31092b764ac4c$var$isObjectLike(value) && $def31092b764ac4c$var$objectToString.call(value) == $def31092b764ac4c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $def31092b764ac4c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($def31092b764ac4c$var$isSymbol(value)) return $def31092b764ac4c$var$NAN;
    if ($def31092b764ac4c$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $def31092b764ac4c$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($def31092b764ac4c$var$reTrim, "");
    var isBinary = $def31092b764ac4c$var$reIsBinary.test(value);
    return isBinary || $def31092b764ac4c$var$reIsOctal.test(value) ? $def31092b764ac4c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $def31092b764ac4c$var$reIsBadHex.test(value) ? $def31092b764ac4c$var$NAN : +value;
}
$def31092b764ac4c$exports = $def31092b764ac4c$var$throttle;


var $1d99c289d62004a8$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $1d99c289d62004a8$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $1d99c289d62004a8$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $1d99c289d62004a8$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $1d99c289d62004a8$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1d99c289d62004a8$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1d99c289d62004a8$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1d99c289d62004a8$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1d99c289d62004a8$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1d99c289d62004a8$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1d99c289d62004a8$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1d99c289d62004a8$var$root = $1d99c289d62004a8$var$freeGlobal || $1d99c289d62004a8$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $1d99c289d62004a8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1d99c289d62004a8$var$objectToString = $1d99c289d62004a8$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1d99c289d62004a8$var$nativeMax = Math.max, $1d99c289d62004a8$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1d99c289d62004a8$var$now = function now() {
    return $1d99c289d62004a8$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1d99c289d62004a8$var$debounce(func, wait, options) {
    var invokeFunc = function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    };
    var leadingEdge = function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    };
    var remainingWait = function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $1d99c289d62004a8$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    };
    var shouldInvoke = function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    };
    var trailingEdge = function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    };
    var cancel = function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    };
    var flush = function flush() {
        return timerId === undefined ? result : trailingEdge($1d99c289d62004a8$var$now());
    };
    var debounced = function debounced() {
        var time = $1d99c289d62004a8$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    };
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($1d99c289d62004a8$var$FUNC_ERROR_TEXT);
    wait = $1d99c289d62004a8$var$toNumber(wait) || 0;
    if ($1d99c289d62004a8$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $1d99c289d62004a8$var$nativeMax($1d99c289d62004a8$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function timerExpired() {
        var time = $1d99c289d62004a8$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1d99c289d62004a8$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1d99c289d62004a8$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1d99c289d62004a8$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value)) == "symbol" || $1d99c289d62004a8$var$isObjectLike(value) && $1d99c289d62004a8$var$objectToString.call(value) == $1d99c289d62004a8$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1d99c289d62004a8$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($1d99c289d62004a8$var$isSymbol(value)) return $1d99c289d62004a8$var$NAN;
    if ($1d99c289d62004a8$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $1d99c289d62004a8$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($1d99c289d62004a8$var$reTrim, "");
    var isBinary = $1d99c289d62004a8$var$reIsBinary.test(value);
    return isBinary || $1d99c289d62004a8$var$reIsOctal.test(value) ? $1d99c289d62004a8$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1d99c289d62004a8$var$reIsBadHex.test(value) ? $1d99c289d62004a8$var$NAN : +value;
}
$1d99c289d62004a8$exports = $1d99c289d62004a8$var$debounce;


var $ea2fae110626a1ef$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $5F2Q2 = parcelRequire("5F2Q2");
var $ea2fae110626a1ef$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $ea2fae110626a1ef$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $ea2fae110626a1ef$var$funcTag = "[object Function]", $ea2fae110626a1ef$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ea2fae110626a1ef$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ea2fae110626a1ef$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $ea2fae110626a1ef$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ea2fae110626a1ef$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ea2fae110626a1ef$var$root = $ea2fae110626a1ef$var$freeGlobal || $ea2fae110626a1ef$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ea2fae110626a1ef$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $ea2fae110626a1ef$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $ea2fae110626a1ef$var$arrayProto = Array.prototype, $ea2fae110626a1ef$var$funcProto = Function.prototype, $ea2fae110626a1ef$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $ea2fae110626a1ef$var$coreJsData = $ea2fae110626a1ef$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $ea2fae110626a1ef$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($ea2fae110626a1ef$var$coreJsData && $ea2fae110626a1ef$var$coreJsData.keys && $ea2fae110626a1ef$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $ea2fae110626a1ef$var$funcToString = $ea2fae110626a1ef$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ea2fae110626a1ef$var$hasOwnProperty = $ea2fae110626a1ef$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ea2fae110626a1ef$var$objectToString = $ea2fae110626a1ef$var$objectProto.toString;
/** Used to detect if a method is native. */ var $ea2fae110626a1ef$var$reIsNative = RegExp("^" + $ea2fae110626a1ef$var$funcToString.call($ea2fae110626a1ef$var$hasOwnProperty).replace($ea2fae110626a1ef$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $ea2fae110626a1ef$var$splice = $ea2fae110626a1ef$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $ea2fae110626a1ef$var$Map = $ea2fae110626a1ef$var$getNative($ea2fae110626a1ef$var$root, "Map"), $ea2fae110626a1ef$var$nativeCreate = $ea2fae110626a1ef$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ea2fae110626a1ef$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ea2fae110626a1ef$var$hashClear() {
    this.__data__ = $ea2fae110626a1ef$var$nativeCreate ? $ea2fae110626a1ef$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ea2fae110626a1ef$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea2fae110626a1ef$var$hashGet(key) {
    var data = this.__data__;
    if ($ea2fae110626a1ef$var$nativeCreate) {
        var result = data[key];
        return result === $ea2fae110626a1ef$var$HASH_UNDEFINED ? undefined : result;
    }
    return $ea2fae110626a1ef$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ea2fae110626a1ef$var$hashHas(key) {
    var data = this.__data__;
    return $ea2fae110626a1ef$var$nativeCreate ? data[key] !== undefined : $ea2fae110626a1ef$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ea2fae110626a1ef$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $ea2fae110626a1ef$var$nativeCreate && value === undefined ? $ea2fae110626a1ef$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$ea2fae110626a1ef$var$Hash.prototype.clear = $ea2fae110626a1ef$var$hashClear;
$ea2fae110626a1ef$var$Hash.prototype["delete"] = $ea2fae110626a1ef$var$hashDelete;
$ea2fae110626a1ef$var$Hash.prototype.get = $ea2fae110626a1ef$var$hashGet;
$ea2fae110626a1ef$var$Hash.prototype.has = $ea2fae110626a1ef$var$hashHas;
$ea2fae110626a1ef$var$Hash.prototype.set = $ea2fae110626a1ef$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ea2fae110626a1ef$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ea2fae110626a1ef$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ea2fae110626a1ef$var$listCacheDelete(key) {
    var data = this.__data__, index = $ea2fae110626a1ef$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ea2fae110626a1ef$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea2fae110626a1ef$var$listCacheGet(key) {
    var data = this.__data__, index = $ea2fae110626a1ef$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ea2fae110626a1ef$var$listCacheHas(key) {
    return $ea2fae110626a1ef$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ea2fae110626a1ef$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ea2fae110626a1ef$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$ea2fae110626a1ef$var$ListCache.prototype.clear = $ea2fae110626a1ef$var$listCacheClear;
$ea2fae110626a1ef$var$ListCache.prototype["delete"] = $ea2fae110626a1ef$var$listCacheDelete;
$ea2fae110626a1ef$var$ListCache.prototype.get = $ea2fae110626a1ef$var$listCacheGet;
$ea2fae110626a1ef$var$ListCache.prototype.has = $ea2fae110626a1ef$var$listCacheHas;
$ea2fae110626a1ef$var$ListCache.prototype.set = $ea2fae110626a1ef$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ea2fae110626a1ef$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ea2fae110626a1ef$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $ea2fae110626a1ef$var$Hash,
        "map": new ($ea2fae110626a1ef$var$Map || $ea2fae110626a1ef$var$ListCache),
        "string": new $ea2fae110626a1ef$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ea2fae110626a1ef$var$mapCacheDelete(key) {
    return $ea2fae110626a1ef$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea2fae110626a1ef$var$mapCacheGet(key) {
    return $ea2fae110626a1ef$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ea2fae110626a1ef$var$mapCacheHas(key) {
    return $ea2fae110626a1ef$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ea2fae110626a1ef$var$mapCacheSet(key, value) {
    $ea2fae110626a1ef$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$ea2fae110626a1ef$var$MapCache.prototype.clear = $ea2fae110626a1ef$var$mapCacheClear;
$ea2fae110626a1ef$var$MapCache.prototype["delete"] = $ea2fae110626a1ef$var$mapCacheDelete;
$ea2fae110626a1ef$var$MapCache.prototype.get = $ea2fae110626a1ef$var$mapCacheGet;
$ea2fae110626a1ef$var$MapCache.prototype.has = $ea2fae110626a1ef$var$mapCacheHas;
$ea2fae110626a1ef$var$MapCache.prototype.set = $ea2fae110626a1ef$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ea2fae110626a1ef$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ea2fae110626a1ef$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ea2fae110626a1ef$var$baseIsNative(value) {
    if (!$ea2fae110626a1ef$var$isObject(value) || $ea2fae110626a1ef$var$isMasked(value)) return false;
    var pattern = $ea2fae110626a1ef$var$isFunction(value) || $ea2fae110626a1ef$var$isHostObject(value) ? $ea2fae110626a1ef$var$reIsNative : $ea2fae110626a1ef$var$reIsHostCtor;
    return pattern.test($ea2fae110626a1ef$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ea2fae110626a1ef$var$getMapData(map, key) {
    var data = map.__data__;
    return $ea2fae110626a1ef$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ea2fae110626a1ef$var$getNative(object, key) {
    var value = $ea2fae110626a1ef$var$getValue(object, key);
    return $ea2fae110626a1ef$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ea2fae110626a1ef$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $ea2fae110626a1ef$var$isMasked(func) {
    return !!$ea2fae110626a1ef$var$maskSrcKey && $ea2fae110626a1ef$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $ea2fae110626a1ef$var$toSource(func) {
    if (func != null) {
        try {
            return $ea2fae110626a1ef$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ea2fae110626a1ef$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($ea2fae110626a1ef$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($ea2fae110626a1ef$var$memoize.Cache || $ea2fae110626a1ef$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$ea2fae110626a1ef$var$memoize.Cache = $ea2fae110626a1ef$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ea2fae110626a1ef$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $ea2fae110626a1ef$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $ea2fae110626a1ef$var$isObject(value) ? $ea2fae110626a1ef$var$objectToString.call(value) : "";
    return tag == $ea2fae110626a1ef$var$funcTag || tag == $ea2fae110626a1ef$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ea2fae110626a1ef$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5F2Q2._)(value);
    return !!value && (type == "object" || type == "function");
}
$ea2fae110626a1ef$exports = $ea2fae110626a1ef$var$memoize;


var $ba3d9668fccc14af$export$402e76927ebf6a24 = [];


var $fef596ba9b588109$export$63c81bd924f89474 = function hasActiveObservations() {
    return (0, $ba3d9668fccc14af$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $3d3f0b5b36b5aa6c$export$8ca35300535e324d = function hasSkippedObservations() {
    return (0, $ba3d9668fccc14af$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $6ef3a8b65d1c2bcb$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $6ef3a8b65d1c2bcb$export$888cb69481582149 = function deliverResizeLoopError() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $6ef3a8b65d1c2bcb$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $6ef3a8b65d1c2bcb$var$msg;
    }
    window.dispatchEvent(event);
};



var $0ace297506670307$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($0ace297506670307$export$416d111b83cd1483 || ($0ace297506670307$export$416d111b83cd1483 = {}));


var $c2f6fdfcd28989bf$export$792f3d81ea979f55 = function freeze(obj) {
    return Object.freeze(obj);
};


var $03aa4fa9f40eaae8$export$c9ad8cdf6bbd331c = function() {
    var ResizeObserverSize = function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)(this);
    };
    return ResizeObserverSize;
}();



var $69e029c163772e1d$export$51d7a67026f4e0b7 = function() {
    var DOMRectReadOnly = function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)(this);
    };
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $7f945213c68888eb$export$165b39ed277223c2 = function isSVG(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $7f945213c68888eb$export$ee695c13482bb5dd = function isHidden(target) {
    if ($7f945213c68888eb$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $7f945213c68888eb$export$45a5e7f76e0caa8d = function isElement(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $7f945213c68888eb$export$a6eb60f7e7c182ba = function isReplacedElement(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $20f3d5b529ddcbb6$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $973669b3d62faf0c$var$cache = new WeakMap();
var $973669b3d62faf0c$var$scrollRegexp = /auto|scroll/;
var $973669b3d62faf0c$var$verticalRegexp = /^tb|vertical/;
var $973669b3d62faf0c$var$IE = /msie|trident/i.test((0, $20f3d5b529ddcbb6$export$90b4d2ff6acb88af).navigator && (0, $20f3d5b529ddcbb6$export$90b4d2ff6acb88af).navigator.userAgent);
var $973669b3d62faf0c$var$parseDimension = function parseDimension(pixel) {
    return parseFloat(pixel || "0");
};
var $973669b3d62faf0c$var$size = function size(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $03aa4fa9f40eaae8$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $973669b3d62faf0c$var$zeroBoxes = (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $973669b3d62faf0c$var$size(),
    borderBoxSize: $973669b3d62faf0c$var$size(),
    contentBoxSize: $973669b3d62faf0c$var$size(),
    contentRect: new (0, $69e029c163772e1d$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $973669b3d62faf0c$export$504d039a9c501c94 = function calculateBoxSizes(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($973669b3d62faf0c$var$cache.has(target) && !forceRecalculation) return $973669b3d62faf0c$var$cache.get(target);
    if ((0, $7f945213c68888eb$export$ee695c13482bb5dd)(target)) {
        $973669b3d62faf0c$var$cache.set(target, $973669b3d62faf0c$var$zeroBoxes);
        return $973669b3d62faf0c$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $7f945213c68888eb$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$973669b3d62faf0c$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $973669b3d62faf0c$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $973669b3d62faf0c$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $973669b3d62faf0c$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $973669b3d62faf0c$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $973669b3d62faf0c$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $973669b3d62faf0c$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $973669b3d62faf0c$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $973669b3d62faf0c$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $973669b3d62faf0c$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $69e029c163772e1d$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $973669b3d62faf0c$var$cache.set(target, boxes);
    return boxes;
};
var $973669b3d62faf0c$export$1a78030b04106bdb = function calculateBoxSize(target, observedBox, forceRecalculation) {
    var _a = $973669b3d62faf0c$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $0ace297506670307$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $0ace297506670307$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $e3a5c63b3a5093ef$export$226159b441fc89f8 = function() {
    var ResizeObserverEntry = function ResizeObserverEntry(target) {
        var boxes = (0, $973669b3d62faf0c$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $c2f6fdfcd28989bf$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    };
    return ResizeObserverEntry;
}();



var $e98a79376bf721fe$export$f8c8e3b5da1f41d2 = function calculateDepthForNode(node) {
    if ((0, $7f945213c68888eb$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $82c28076c6e61e01$export$9cac928141e5443b = function broadcastActiveObservations() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $ba3d9668fccc14af$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $e3a5c63b3a5093ef$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $e98a79376bf721fe$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $973669b3d62faf0c$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $1b83d4b08bfe30f2$export$9c17b8913a2a3572 = function gatherActiveObservationsAtDepth(depth) {
    (0, $ba3d9668fccc14af$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $e98a79376bf721fe$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $9d9710f18fd794b8$export$e54fe5b0f43758f7 = function process() {
    var depth = 0;
    (0, $1b83d4b08bfe30f2$export$9c17b8913a2a3572)(depth);
    while((0, $fef596ba9b588109$export$63c81bd924f89474)()){
        depth = (0, $82c28076c6e61e01$export$9cac928141e5443b)();
        (0, $1b83d4b08bfe30f2$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $3d3f0b5b36b5aa6c$export$8ca35300535e324d)()) (0, $6ef3a8b65d1c2bcb$export$888cb69481582149)();
    return depth > 0;
};



var $02d13dfd4cefac79$var$trigger;
var $02d13dfd4cefac79$var$callbacks = [];
var $02d13dfd4cefac79$var$notify = function notify() {
    return $02d13dfd4cefac79$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $02d13dfd4cefac79$export$4c995d4933c4abb = function queueMicroTask(callback) {
    if (!$02d13dfd4cefac79$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $02d13dfd4cefac79$var$notify();
        }).observe(el_1, config);
        $02d13dfd4cefac79$var$trigger = function trigger() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $02d13dfd4cefac79$var$callbacks.push(callback);
    $02d13dfd4cefac79$var$trigger();
};


var $310f92986fc30247$export$5755c7b572e34c6 = function queueResizeObserver(cb) {
    (0, $02d13dfd4cefac79$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $14f7e266d39c3f5b$var$watching = 0;
var $14f7e266d39c3f5b$var$isWatching = function isWatching() {
    return !!$14f7e266d39c3f5b$var$watching;
};
var $14f7e266d39c3f5b$var$CATCH_PERIOD = 250;
var $14f7e266d39c3f5b$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $14f7e266d39c3f5b$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $14f7e266d39c3f5b$var$time = function time(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $14f7e266d39c3f5b$var$scheduled = false;
var $14f7e266d39c3f5b$var$Scheduler = function() {
    var Scheduler = function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    };
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $14f7e266d39c3f5b$var$CATCH_PERIOD;
        if ($14f7e266d39c3f5b$var$scheduled) return;
        $14f7e266d39c3f5b$var$scheduled = true;
        var until = $14f7e266d39c3f5b$var$time(timeout);
        (0, $310f92986fc30247$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $9d9710f18fd794b8$export$e54fe5b0f43758f7)();
            } finally{
                $14f7e266d39c3f5b$var$scheduled = false;
                timeout = until - $14f7e266d39c3f5b$var$time();
                if (!$14f7e266d39c3f5b$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function cb() {
            return _this.observer && _this.observer.observe(document.body, $14f7e266d39c3f5b$var$observerConfig);
        };
        document.body ? cb() : (0, $20f3d5b529ddcbb6$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $14f7e266d39c3f5b$var$events.forEach(function(name) {
                return (0, $20f3d5b529ddcbb6$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $14f7e266d39c3f5b$var$events.forEach(function(name) {
                return (0, $20f3d5b529ddcbb6$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $14f7e266d39c3f5b$export$d30788f2c20241cd = new $14f7e266d39c3f5b$var$Scheduler();
var $14f7e266d39c3f5b$export$1f18a74d42722835 = function updateCount(n) {
    !$14f7e266d39c3f5b$var$watching && n > 0 && $14f7e266d39c3f5b$export$d30788f2c20241cd.start();
    $14f7e266d39c3f5b$var$watching += n;
    !$14f7e266d39c3f5b$var$watching && $14f7e266d39c3f5b$export$d30788f2c20241cd.stop();
};





var $2bd7d984760afc26$var$skipNotifyOnElement = function skipNotifyOnElement(target) {
    return !(0, $7f945213c68888eb$export$165b39ed277223c2)(target) && !(0, $7f945213c68888eb$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $2bd7d984760afc26$export$fea412043713122 = function() {
    var ResizeObservation = function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $0ace297506670307$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    };
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $973669b3d62faf0c$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($2bd7d984760afc26$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $cef89329d1801b4e$export$d86966e6e4bc97e1 = function() {
    var ResizeObserverDetail = function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    };
    return ResizeObserverDetail;
}();



var $3fcffc6258b6709b$var$observerMap = new WeakMap();
var $3fcffc6258b6709b$var$getObservationIndex = function getObservationIndex(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $3fcffc6258b6709b$export$ed99c5bafbaf8300 = function() {
    var ResizeObserverController = function ResizeObserverController() {};
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $cef89329d1801b4e$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $3fcffc6258b6709b$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $3fcffc6258b6709b$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($3fcffc6258b6709b$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $ba3d9668fccc14af$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $2bd7d984760afc26$export$fea412043713122)(target, options && options.box));
            (0, $14f7e266d39c3f5b$export$1f18a74d42722835)(1);
            (0, $14f7e266d39c3f5b$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $3fcffc6258b6709b$var$observerMap.get(resizeObserver);
        var index = $3fcffc6258b6709b$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $ba3d9668fccc14af$export$402e76927ebf6a24).splice((0, $ba3d9668fccc14af$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $14f7e266d39c3f5b$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $3fcffc6258b6709b$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $b3a1ad679defc960$export$9caf76241ca21a11 = function() {
    var ResizeObserver = function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $3fcffc6258b6709b$export$ed99c5bafbaf8300).connect(this, callback);
    };
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $7f945213c68888eb$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $3fcffc6258b6709b$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $7f945213c68888eb$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $3fcffc6258b6709b$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $3fcffc6258b6709b$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






var $8bda705b86c52c04$exports = {};
var $8bda705b86c52c04$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$8bda705b86c52c04$exports = $8bda705b86c52c04$var$canUseDOM;


"use strict";

var $f34e478fd27dc6ee$exports = {};




var $f34e478fd27dc6ee$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $f34e478fd27dc6ee$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $1934ccccb0254b37$exports(callbackfn);
        var O = $ff4389c250ca5a45$exports(that);
        var self = $a902ac574fe6ad75$exports(O);
        var length = $c8b9baef6d1b44d4$exports(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $f34e478fd27dc6ee$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$f34e478fd27dc6ee$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $f34e478fd27dc6ee$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $f34e478fd27dc6ee$var$createMethod(true)
};


var $04e6208adcb123a5$require$$reduce = $f34e478fd27dc6ee$exports.left;
var $9eab6779dab7b367$exports = {};
"use strict";

$9eab6779dab7b367$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1104f276c77260b3$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $6985acedc4a529a6$exports = {};

var $eSBMZ = parcelRequire("eSBMZ");

$6985acedc4a529a6$exports = typeof $eSBMZ != "undefined" && $074f4f6f4a41a7f4$exports($eSBMZ) == "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $04e6208adcb123a5$var$CHROME_BUG = !$6985acedc4a529a6$exports && $ce7a78bbf20168dc$exports > 79 && $ce7a78bbf20168dc$exports < 83;
var $04e6208adcb123a5$var$FORCED = $04e6208adcb123a5$var$CHROME_BUG || !$9eab6779dab7b367$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$97565072be87b482$exports({
    target: "Array",
    proto: true,
    forced: $04e6208adcb123a5$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $04e6208adcb123a5$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $e8db335b6d82b402$exports = {};
"use strict";



var $4874f85ab165179e$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$4874f85ab165179e$exports = function() {
    var that = $375e5ed2420f5bb9$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $964451d6028fdaa9$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $964451d6028fdaa9$var$$RegExp = $2882607b9f426a2f$exports.RegExp;
var $964451d6028fdaa9$var$UNSUPPORTED_Y = $1104f276c77260b3$exports(function() {
    var re = $964451d6028fdaa9$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $964451d6028fdaa9$var$MISSED_STICKY = $964451d6028fdaa9$var$UNSUPPORTED_Y || $1104f276c77260b3$exports(function() {
    return !$964451d6028fdaa9$var$$RegExp("a", "y").sticky;
});
var $964451d6028fdaa9$var$BROKEN_CARET = $964451d6028fdaa9$var$UNSUPPORTED_Y || $1104f276c77260b3$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $964451d6028fdaa9$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
$964451d6028fdaa9$exports = {
    BROKEN_CARET: $964451d6028fdaa9$var$BROKEN_CARET,
    MISSED_STICKY: $964451d6028fdaa9$var$MISSED_STICKY,
    UNSUPPORTED_Y: $964451d6028fdaa9$var$UNSUPPORTED_Y
};





var $e8db335b6d82b402$require$getInternalState = $0f915c35577af5f4$exports.get;
var $8e3efff6dacc0a0b$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $8e3efff6dacc0a0b$var$$RegExp = $2882607b9f426a2f$exports.RegExp;
$8e3efff6dacc0a0b$exports = $1104f276c77260b3$exports(function() {
    var re = $8e3efff6dacc0a0b$var$$RegExp(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});


var $33be72901d6f6f25$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $33be72901d6f6f25$var$$RegExp = $2882607b9f426a2f$exports.RegExp;
$33be72901d6f6f25$exports = $1104f276c77260b3$exports(function() {
    var re = $33be72901d6f6f25$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $e8db335b6d82b402$var$nativeReplace = $393c154836942fbd$exports("native-string-replace", String.prototype.replace);
var $e8db335b6d82b402$var$nativeExec = RegExp.prototype.exec;
var $e8db335b6d82b402$var$patchedExec = $e8db335b6d82b402$var$nativeExec;
var $e8db335b6d82b402$var$charAt = $d9581cc7e9a63a67$exports("".charAt);
var $e8db335b6d82b402$var$indexOf = $d9581cc7e9a63a67$exports("".indexOf);
var $e8db335b6d82b402$var$replace = $d9581cc7e9a63a67$exports("".replace);
var $e8db335b6d82b402$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
var $e8db335b6d82b402$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $ea29ea351915a40c$exports($e8db335b6d82b402$var$nativeExec, re1, "a");
    $ea29ea351915a40c$exports($e8db335b6d82b402$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $e8db335b6d82b402$var$UNSUPPORTED_Y = $964451d6028fdaa9$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $e8db335b6d82b402$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $e8db335b6d82b402$var$PATCH = $e8db335b6d82b402$var$UPDATES_LAST_INDEX_WRONG || $e8db335b6d82b402$var$NPCG_INCLUDED || $e8db335b6d82b402$var$UNSUPPORTED_Y || $8e3efff6dacc0a0b$exports || $33be72901d6f6f25$exports;
if ($e8db335b6d82b402$var$PATCH) $e8db335b6d82b402$var$patchedExec = function exec(string) {
    var re = this;
    var state = $e8db335b6d82b402$require$getInternalState(re);
    var str = $849a2f8baae8f2af$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $ea29ea351915a40c$exports($e8db335b6d82b402$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $e8db335b6d82b402$var$UNSUPPORTED_Y && re.sticky;
    var flags = $ea29ea351915a40c$exports($4874f85ab165179e$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $e8db335b6d82b402$var$replace(flags, "y", "");
        if ($e8db335b6d82b402$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $e8db335b6d82b402$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $e8db335b6d82b402$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($e8db335b6d82b402$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($e8db335b6d82b402$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $ea29ea351915a40c$exports($e8db335b6d82b402$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $e8db335b6d82b402$var$stringSlice(match.input, charsAdded);
            match[0] = $e8db335b6d82b402$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($e8db335b6d82b402$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($e8db335b6d82b402$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $ea29ea351915a40c$exports($e8db335b6d82b402$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $b118f6b8d01a304e$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$e8db335b6d82b402$exports = $e8db335b6d82b402$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$97565072be87b482$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $e8db335b6d82b402$exports
}, {
    exec: $e8db335b6d82b402$exports
});


"use strict";

var $d7a5f3d189eff63f$exports = {};
"use strict";







var $d7a5f3d189eff63f$var$SPECIES = $12359396acd4e225$exports("species");
var $d7a5f3d189eff63f$var$RegExpPrototype = RegExp.prototype;
$d7a5f3d189eff63f$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $12359396acd4e225$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1104f276c77260b3$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1104f276c77260b3$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$d7a5f3d189eff63f$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $c75e88a32fc47e70$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $c75e88a32fc47e70$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $e8db335b6d82b402$exports || $exec === $d7a5f3d189eff63f$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $8650e653ce14b304$exports(String.prototype, KEY, methods[0]);
        $8650e653ce14b304$exports($d7a5f3d189eff63f$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $b799eb4d8561c8c3$exports($d7a5f3d189eff63f$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $c56c87fdf84503b7$exports = {};
"use strict";

var $c56c87fdf84503b7$require$charAt = $5fac87ef7397acd2$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$c56c87fdf84503b7$exports = function(S, index, unicode) {
    return index + (unicode ? $c56c87fdf84503b7$require$charAt(S, index).length : 1);
};


var $79e2dddde959140c$exports = {};





var $79e2dddde959140c$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$79e2dddde959140c$exports = function(R, S) {
    var exec = R.exec;
    if ($530c08156ef94345$exports(exec)) {
        var result = $ea29ea351915a40c$exports(exec, R, S);
        if (result !== null) $375e5ed2420f5bb9$exports(result);
        return result;
    }
    if ($074f4f6f4a41a7f4$exports(R) === "RegExp") return $ea29ea351915a40c$exports($e8db335b6d82b402$exports, R, S);
    throw $79e2dddde959140c$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$d7a5f3d189eff63f$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $c6c632a1427ebe2e$exports(this);
            var matcher = $23bd47ceb739678b$exports(regexp) ? undefined : $86a8def7b6f243c9$exports(regexp, MATCH);
            return matcher ? $ea29ea351915a40c$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($849a2f8baae8f2af$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $375e5ed2420f5bb9$exports(this);
            var S = $849a2f8baae8f2af$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $79e2dddde959140c$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $79e2dddde959140c$exports(rx, S)) !== null){
                var matchStr = $849a2f8baae8f2af$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $c56c87fdf84503b7$exports(S, $b1a33852f3411fc8$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});




var $1d07ac64d79efcd7$require$FUNCTION_NAME_EXISTS = $a90617eefec74231$exports.EXISTS;

var $32d070b2895961cf$exports = {};


$32d070b2895961cf$exports = function(target, name, descriptor) {
    if (descriptor.get) $923f8638f9182ee3$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $923f8638f9182ee3$exports(descriptor.set, name, {
        setter: true
    });
    return $00895ebe3ae58406$export$2d1720544b23b823(target, name, descriptor);
};


var $1d07ac64d79efcd7$var$FunctionPrototype = Function.prototype;
var $1d07ac64d79efcd7$var$functionToString = $d9581cc7e9a63a67$exports($1d07ac64d79efcd7$var$FunctionPrototype.toString);
var $1d07ac64d79efcd7$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $1d07ac64d79efcd7$var$regExpExec = $d9581cc7e9a63a67$exports($1d07ac64d79efcd7$var$nameRE.exec);
var $1d07ac64d79efcd7$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($b441ecc4617d98f6$exports && !$1d07ac64d79efcd7$require$FUNCTION_NAME_EXISTS) $32d070b2895961cf$exports($1d07ac64d79efcd7$var$FunctionPrototype, $1d07ac64d79efcd7$var$NAME, {
    configurable: true,
    get: function get() {
        try {
            return $1d07ac64d79efcd7$var$regExpExec($1d07ac64d79efcd7$var$nameRE, $1d07ac64d79efcd7$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $f486d3ce44af49c6$exports = {};

var $f486d3ce44af49c6$var$FunctionPrototype = Function.prototype;
var $f486d3ce44af49c6$var$apply = $f486d3ce44af49c6$var$FunctionPrototype.apply;
var $f486d3ce44af49c6$var$call = $f486d3ce44af49c6$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$f486d3ce44af49c6$exports = typeof Reflect == "object" && Reflect.apply || ($8be7ca1e0c9f78a5$exports ? $f486d3ce44af49c6$var$call.bind($f486d3ce44af49c6$var$apply) : function() {
    return $f486d3ce44af49c6$var$call.apply($f486d3ce44af49c6$var$apply, arguments);
});















var $57ba7a700f2d512e$exports = {};


var $57ba7a700f2d512e$var$floor = Math.floor;
var $57ba7a700f2d512e$var$charAt = $d9581cc7e9a63a67$exports("".charAt);
var $57ba7a700f2d512e$var$replace = $d9581cc7e9a63a67$exports("".replace);
var $57ba7a700f2d512e$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $57ba7a700f2d512e$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $57ba7a700f2d512e$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$57ba7a700f2d512e$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $57ba7a700f2d512e$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $ff4389c250ca5a45$exports(namedCaptures);
        symbols = $57ba7a700f2d512e$var$SUBSTITUTION_SYMBOLS;
    }
    return $57ba7a700f2d512e$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($57ba7a700f2d512e$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $57ba7a700f2d512e$var$stringSlice(str, 0, position);
            case "'":
                return $57ba7a700f2d512e$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$57ba7a700f2d512e$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $57ba7a700f2d512e$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $57ba7a700f2d512e$var$charAt(ch, 1) : captures[f - 1] + $57ba7a700f2d512e$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $e5855b40ef248d7a$var$REPLACE = $12359396acd4e225$exports("replace");
var $e5855b40ef248d7a$var$max = Math.max;
var $e5855b40ef248d7a$var$min = Math.min;
var $e5855b40ef248d7a$var$concat = $d9581cc7e9a63a67$exports([].concat);
var $e5855b40ef248d7a$var$push = $d9581cc7e9a63a67$exports([].push);
var $e5855b40ef248d7a$var$stringIndexOf = $d9581cc7e9a63a67$exports("".indexOf);
var $e5855b40ef248d7a$var$stringSlice = $d9581cc7e9a63a67$exports("".slice);
var $e5855b40ef248d7a$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $e5855b40ef248d7a$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $e5855b40ef248d7a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$e5855b40ef248d7a$var$REPLACE]) return /./[$e5855b40ef248d7a$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $e5855b40ef248d7a$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1104f276c77260b3$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$d7a5f3d189eff63f$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $e5855b40ef248d7a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $c6c632a1427ebe2e$exports(this);
            var replacer = $23bd47ceb739678b$exports(searchValue) ? undefined : $86a8def7b6f243c9$exports(searchValue, $e5855b40ef248d7a$var$REPLACE);
            return replacer ? $ea29ea351915a40c$exports(replacer, searchValue, O, replaceValue) : $ea29ea351915a40c$exports(nativeReplace, $849a2f8baae8f2af$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $375e5ed2420f5bb9$exports(this);
            var S = $849a2f8baae8f2af$exports(string);
            if (typeof replaceValue == "string" && $e5855b40ef248d7a$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $e5855b40ef248d7a$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $530c08156ef94345$exports(replaceValue);
            if (!functionalReplace) replaceValue = $849a2f8baae8f2af$exports(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $79e2dddde959140c$exports(rx, S);
                if (result === null) break;
                $e5855b40ef248d7a$var$push(results, result);
                if (!global) break;
                var matchStr = $849a2f8baae8f2af$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $c56c87fdf84503b7$exports(S, $b1a33852f3411fc8$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $849a2f8baae8f2af$exports(result[0]);
                var position = $e5855b40ef248d7a$var$max($e5855b40ef248d7a$var$min($a7928c5e8e393354$exports(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$e5855b40ef248d7a$var$push(captures, $e5855b40ef248d7a$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $e5855b40ef248d7a$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $e5855b40ef248d7a$var$push(replacerArgs, namedCaptures);
                    var replacement = $849a2f8baae8f2af$exports($f486d3ce44af49c6$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $57ba7a700f2d512e$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $e5855b40ef248d7a$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $e5855b40ef248d7a$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$e5855b40ef248d7a$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$e5855b40ef248d7a$var$REPLACE_KEEPS_$0 || $e5855b40ef248d7a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $04dc5d49a775f274$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $04dc5d49a775f274$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $04dc5d49a775f274$var$cachedScrollbarWidth = null;
var $04dc5d49a775f274$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($8bda705b86c52c04$exports))) window.addEventListener("resize", function() {
    if ($04dc5d49a775f274$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $04dc5d49a775f274$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $04dc5d49a775f274$var$cachedScrollbarWidth = null;
    }
});
function $04dc5d49a775f274$var$scrollbarWidth(el) {
    if ($04dc5d49a775f274$var$cachedScrollbarWidth === null) {
        var document1 = $04dc5d49a775f274$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $04dc5d49a775f274$var$cachedScrollbarWidth = 0;
            return $04dc5d49a775f274$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $04dc5d49a775f274$var$cachedScrollbarWidth = width;
    }
    return $04dc5d49a775f274$var$cachedScrollbarWidth;
}
var $04dc5d49a775f274$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $04dc5d49a775f274$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $04dc5d49a775f274$var$getElementDocument(_this.el);
            var elWindow = $04dc5d49a775f274$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($def31092b764ac4c$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($def31092b764ac4c$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($1d99c289d62004a8$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($1d99c289d62004a8$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($ea2fae110626a1ef$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $04dc5d49a775f274$var$getElementDocument(el);
        var elWindow = $04dc5d49a775f274$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($8bda705b86c52c04$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $04dc5d49a775f274$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $b3a1ad679defc960$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $04dc5d49a775f274$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $04dc5d49a775f274$var$getElementDocument(this.el);
        var elWindow = $04dc5d49a775f274$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $04dc5d49a775f274$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $04dc5d49a775f274$var$scrollbarWidth(this.el);
        } catch (e) {
            return $04dc5d49a775f274$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $04dc5d49a775f274$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$04dc5d49a775f274$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$04dc5d49a775f274$var$SimpleBar.instances = new WeakMap();
var $04dc5d49a775f274$export$2e2bcd8739ae039 = $04dc5d49a775f274$var$SimpleBar;


function $5b272591ee89cc1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b272591ee89cc1f$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b272591ee89cc1f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b272591ee89cc1f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b272591ee89cc1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b272591ee89cc1f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b272591ee89cc1f$var$_extends() {
    $5b272591ee89cc1f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5b272591ee89cc1f$var$_extends.apply(this, arguments);
}
function $5b272591ee89cc1f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5b272591ee89cc1f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5b272591ee89cc1f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $5b272591ee89cc1f$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $5b272591ee89cc1f$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $5b272591ee89cc1f$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? "div" : _ref$tag, otherProps = $5b272591ee89cc1f$var$_objectWithoutProperties(_ref, $5b272591ee89cc1f$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $4CEbD.useRef)();
    var elRef = (0, $4CEbD.useRef)();
    var contentNodeRef = (0, $4CEbD.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $04dc5d49a775f274$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== "data-simplebar-direction") deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' —> 'autoHide=\"false\"'\n      ");
    (0, $4CEbD.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $04dc5d49a775f274$export$2e2bcd8739ae039)(elRef.current, $5b272591ee89cc1f$var$_objectSpread2($5b272591ee89cc1f$var$_objectSpread2($5b272591ee89cc1f$var$_objectSpread2($5b272591ee89cc1f$var$_objectSpread2({}, $5b272591ee89cc1f$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === "function") ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === "function") ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(RootTag, $5b272591ee89cc1f$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === "function" ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", $5b272591ee89cc1f$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$5b272591ee89cc1f$var$SimpleBar.displayName = "SimpleBar";
$5b272591ee89cc1f$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string
};
var $5b272591ee89cc1f$export$2e2bcd8739ae039 = $5b272591ee89cc1f$var$SimpleBar;


//import {useTranslation} from "react-i18next";
var $d30e23ef1cc305a9$var$ScrollArea = function(param) {
    var children = param.children;
    //console.log("ScrollArea", noOfGroups, currentGroupNo, answeredGroups);
    var scroller = (0, $4CEbD.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $5b272591ee89cc1f$export$2e2bcd8739ae039), {
        key: "scroller",
        ref: scroller,
        id: "story__scrolling",
        className: "story__scrolling"
    }, children);
};
$d30e23ef1cc305a9$var$ScrollArea.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).node
    ])
};
var $d30e23ef1cc305a9$export$2e2bcd8739ae039 = $d30e23ef1cc305a9$var$ScrollArea;











var $5F2Q2 = parcelRequire("5F2Q2");

var $4CEbD = parcelRequire("4CEbD");

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $eda0e7b39b71cc2e$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var $eda0e7b39b71cc2e$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $eda0e7b39b71cc2e$export$2e2bcd8739ae039() {
    if (!$eda0e7b39b71cc2e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $eda0e7b39b71cc2e$var$getRandomValues($eda0e7b39b71cc2e$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8e8c0ca11fea0c42$var$byteToHex = [];
for(var $8e8c0ca11fea0c42$var$i = 0; $8e8c0ca11fea0c42$var$i < 256; ++$8e8c0ca11fea0c42$var$i)$8e8c0ca11fea0c42$var$byteToHex[$8e8c0ca11fea0c42$var$i] = ($8e8c0ca11fea0c42$var$i + 0x100).toString(16).substr(1);
function $8e8c0ca11fea0c42$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8e8c0ca11fea0c42$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
var $8e8c0ca11fea0c42$export$2e2bcd8739ae039 = $8e8c0ca11fea0c42$var$bytesToUuid;


function $a28248ee3b86d467$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $eda0e7b39b71cc2e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $8e8c0ca11fea0c42$export$2e2bcd8739ae039)(rnds);
}
var $a28248ee3b86d467$export$2e2bcd8739ae039 = $a28248ee3b86d467$var$v4;


function $bff1c097ab7df2f7$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bff1c097ab7df2f7$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bff1c097ab7df2f7$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            $bff1c097ab7df2f7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bff1c097ab7df2f7$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bff1c097ab7df2f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bff1c097ab7df2f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bff1c097ab7df2f7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bff1c097ab7df2f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bff1c097ab7df2f7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bff1c097ab7df2f7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bff1c097ab7df2f7$var$_extends() {
    $bff1c097ab7df2f7$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bff1c097ab7df2f7$var$_extends.apply(this, arguments);
}
function $bff1c097ab7df2f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bff1c097ab7df2f7$var$_setPrototypeOf(subClass, superClass);
}
function $bff1c097ab7df2f7$var$_getPrototypeOf(o) {
    $bff1c097ab7df2f7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bff1c097ab7df2f7$var$_getPrototypeOf(o);
}
function $bff1c097ab7df2f7$var$_setPrototypeOf(o, p) {
    $bff1c097ab7df2f7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bff1c097ab7df2f7$var$_setPrototypeOf(o, p);
}
function $bff1c097ab7df2f7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bff1c097ab7df2f7$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $bff1c097ab7df2f7$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bff1c097ab7df2f7$var$_assertThisInitialized(self1);
}
function $bff1c097ab7df2f7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bff1c097ab7df2f7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bff1c097ab7df2f7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bff1c097ab7df2f7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bff1c097ab7df2f7$var$_possibleConstructorReturn(this, result);
    };
}
function $bff1c097ab7df2f7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bff1c097ab7df2f7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bff1c097ab7df2f7$var$_arrayLikeToArray(o, minLen);
}
function $bff1c097ab7df2f7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bff1c097ab7df2f7$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $bff1c097ab7df2f7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e) {
            didErr = true;
            err = _e;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $bff1c097ab7df2f7$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $bff1c097ab7df2f7$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $bff1c097ab7df2f7$var$global$a = // eslint-disable-next-line es/no-global-this -- safe
$bff1c097ab7df2f7$var$check(typeof globalThis == "object" && globalThis) || $bff1c097ab7df2f7$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$bff1c097ab7df2f7$var$check(typeof self == "object" && self) || $bff1c097ab7df2f7$var$check(typeof $bff1c097ab7df2f7$var$commonjsGlobal == "object" && $bff1c097ab7df2f7$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $bff1c097ab7df2f7$var$objectGetOwnPropertyDescriptor = {};
var $bff1c097ab7df2f7$var$fails$9 = function fails$9(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $bff1c097ab7df2f7$var$fails$8 = $bff1c097ab7df2f7$var$fails$9;
// Detect IE8's incomplete defineProperty implementation
var $bff1c097ab7df2f7$var$descriptors = !$bff1c097ab7df2f7$var$fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});
var $bff1c097ab7df2f7$var$fails$7 = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$functionBindNative = !$bff1c097ab7df2f7$var$fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $bff1c097ab7df2f7$var$NATIVE_BIND$2 = $bff1c097ab7df2f7$var$functionBindNative;
var $bff1c097ab7df2f7$var$call$4 = Function.prototype.call;
var $bff1c097ab7df2f7$var$functionCall = $bff1c097ab7df2f7$var$NATIVE_BIND$2 ? $bff1c097ab7df2f7$var$call$4.bind($bff1c097ab7df2f7$var$call$4) : function functionCall() {
    return $bff1c097ab7df2f7$var$call$4.apply($bff1c097ab7df2f7$var$call$4, arguments);
};
var $bff1c097ab7df2f7$var$objectPropertyIsEnumerable = {};
var $bff1c097ab7df2f7$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bff1c097ab7df2f7$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $bff1c097ab7df2f7$var$NASHORN_BUG = $bff1c097ab7df2f7$var$getOwnPropertyDescriptor$1 && !$bff1c097ab7df2f7$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$bff1c097ab7df2f7$var$objectPropertyIsEnumerable.f = $bff1c097ab7df2f7$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $bff1c097ab7df2f7$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $bff1c097ab7df2f7$var$$propertyIsEnumerable;
var $bff1c097ab7df2f7$var$createPropertyDescriptor$2 = function createPropertyDescriptor$2(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $bff1c097ab7df2f7$var$NATIVE_BIND$1 = $bff1c097ab7df2f7$var$functionBindNative;
var $bff1c097ab7df2f7$var$FunctionPrototype$1 = Function.prototype;
var $bff1c097ab7df2f7$var$call$3 = $bff1c097ab7df2f7$var$FunctionPrototype$1.call;
var $bff1c097ab7df2f7$var$uncurryThisWithBind = $bff1c097ab7df2f7$var$NATIVE_BIND$1 && $bff1c097ab7df2f7$var$FunctionPrototype$1.bind.bind($bff1c097ab7df2f7$var$call$3, $bff1c097ab7df2f7$var$call$3);
var $bff1c097ab7df2f7$var$functionUncurryThisRaw = function functionUncurryThisRaw(fn) {
    return $bff1c097ab7df2f7$var$NATIVE_BIND$1 ? $bff1c097ab7df2f7$var$uncurryThisWithBind(fn) : function() {
        return $bff1c097ab7df2f7$var$call$3.apply(fn, arguments);
    };
};
var $bff1c097ab7df2f7$var$uncurryThisRaw$1 = $bff1c097ab7df2f7$var$functionUncurryThisRaw;
var $bff1c097ab7df2f7$var$toString$1 = $bff1c097ab7df2f7$var$uncurryThisRaw$1({}.toString);
var $bff1c097ab7df2f7$var$stringSlice = $bff1c097ab7df2f7$var$uncurryThisRaw$1("".slice);
var $bff1c097ab7df2f7$var$classofRaw$2 = function classofRaw$2(it) {
    return $bff1c097ab7df2f7$var$stringSlice($bff1c097ab7df2f7$var$toString$1(it), 8, -1);
};
var $bff1c097ab7df2f7$var$classofRaw$1 = $bff1c097ab7df2f7$var$classofRaw$2;
var $bff1c097ab7df2f7$var$uncurryThisRaw = $bff1c097ab7df2f7$var$functionUncurryThisRaw;
var $bff1c097ab7df2f7$var$functionUncurryThis = function functionUncurryThis(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($bff1c097ab7df2f7$var$classofRaw$1(fn) === "Function") return $bff1c097ab7df2f7$var$uncurryThisRaw(fn);
};
var $bff1c097ab7df2f7$var$uncurryThis$9 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$fails$6 = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$classof$3 = $bff1c097ab7df2f7$var$classofRaw$2;
var $bff1c097ab7df2f7$var$$Object$3 = Object;
var $bff1c097ab7df2f7$var$split = $bff1c097ab7df2f7$var$uncurryThis$9("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $bff1c097ab7df2f7$var$indexedObject = $bff1c097ab7df2f7$var$fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$bff1c097ab7df2f7$var$$Object$3("z").propertyIsEnumerable(0);
}) ? function indexedObject(it) {
    return $bff1c097ab7df2f7$var$classof$3(it) == "String" ? $bff1c097ab7df2f7$var$split(it, "") : $bff1c097ab7df2f7$var$$Object$3(it);
} : $bff1c097ab7df2f7$var$$Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $bff1c097ab7df2f7$var$isNullOrUndefined$2 = function isNullOrUndefined$2(it) {
    return it === null || it === undefined;
};
var $bff1c097ab7df2f7$var$isNullOrUndefined$1 = $bff1c097ab7df2f7$var$isNullOrUndefined$2;
var $bff1c097ab7df2f7$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $bff1c097ab7df2f7$var$requireObjectCoercible$2 = function requireObjectCoercible$2(it) {
    if ($bff1c097ab7df2f7$var$isNullOrUndefined$1(it)) throw $bff1c097ab7df2f7$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $bff1c097ab7df2f7$var$IndexedObject$1 = $bff1c097ab7df2f7$var$indexedObject;
var $bff1c097ab7df2f7$var$requireObjectCoercible$1 = $bff1c097ab7df2f7$var$requireObjectCoercible$2;
var $bff1c097ab7df2f7$var$toIndexedObject$4 = function toIndexedObject$4(it) {
    return $bff1c097ab7df2f7$var$IndexedObject$1($bff1c097ab7df2f7$var$requireObjectCoercible$1(it));
};
var $bff1c097ab7df2f7$var$documentAll$2 = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $bff1c097ab7df2f7$var$IS_HTMLDDA = typeof $bff1c097ab7df2f7$var$documentAll$2 == "undefined" && $bff1c097ab7df2f7$var$documentAll$2 !== undefined;
var $bff1c097ab7df2f7$var$documentAll_1 = {
    all: $bff1c097ab7df2f7$var$documentAll$2,
    IS_HTMLDDA: $bff1c097ab7df2f7$var$IS_HTMLDDA
};
var $bff1c097ab7df2f7$var$$documentAll$1 = $bff1c097ab7df2f7$var$documentAll_1;
var $bff1c097ab7df2f7$var$documentAll$1 = $bff1c097ab7df2f7$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $bff1c097ab7df2f7$var$isCallable$c = $bff1c097ab7df2f7$var$$documentAll$1.IS_HTMLDDA ? function isCallable$c(argument) {
    return typeof argument == "function" || argument === $bff1c097ab7df2f7$var$documentAll$1;
} : function(argument) {
    return typeof argument == "function";
};
var $bff1c097ab7df2f7$var$isCallable$b = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$$documentAll = $bff1c097ab7df2f7$var$documentAll_1;
var $bff1c097ab7df2f7$var$documentAll = $bff1c097ab7df2f7$var$$documentAll.all;
var $bff1c097ab7df2f7$var$isObject$6 = $bff1c097ab7df2f7$var$$documentAll.IS_HTMLDDA ? function isObject$6(it) {
    return typeof it == "object" ? it !== null : $bff1c097ab7df2f7$var$isCallable$b(it) || it === $bff1c097ab7df2f7$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $bff1c097ab7df2f7$var$isCallable$b(it);
};
var $bff1c097ab7df2f7$var$global$9 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$isCallable$a = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$aFunction = function aFunction(argument) {
    return $bff1c097ab7df2f7$var$isCallable$a(argument) ? argument : undefined;
};
var $bff1c097ab7df2f7$var$getBuiltIn$5 = function getBuiltIn$5(namespace, method) {
    return arguments.length < 2 ? $bff1c097ab7df2f7$var$aFunction($bff1c097ab7df2f7$var$global$9[namespace]) : $bff1c097ab7df2f7$var$global$9[namespace] && $bff1c097ab7df2f7$var$global$9[namespace][method];
};
var $bff1c097ab7df2f7$var$uncurryThis$8 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$objectIsPrototypeOf = $bff1c097ab7df2f7$var$uncurryThis$8({}.isPrototypeOf);
var $bff1c097ab7df2f7$var$getBuiltIn$4 = $bff1c097ab7df2f7$var$getBuiltIn$5;
var $bff1c097ab7df2f7$var$engineUserAgent = $bff1c097ab7df2f7$var$getBuiltIn$4("navigator", "userAgent") || "";
var $bff1c097ab7df2f7$var$global$8 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$userAgent = $bff1c097ab7df2f7$var$engineUserAgent;
var $bff1c097ab7df2f7$var$process = $bff1c097ab7df2f7$var$global$8.process;
var $bff1c097ab7df2f7$var$Deno = $bff1c097ab7df2f7$var$global$8.Deno;
var $bff1c097ab7df2f7$var$versions = $bff1c097ab7df2f7$var$process && $bff1c097ab7df2f7$var$process.versions || $bff1c097ab7df2f7$var$Deno && $bff1c097ab7df2f7$var$Deno.version;
var $bff1c097ab7df2f7$var$v8 = $bff1c097ab7df2f7$var$versions && $bff1c097ab7df2f7$var$versions.v8;
var $bff1c097ab7df2f7$var$match, $bff1c097ab7df2f7$var$version;
if ($bff1c097ab7df2f7$var$v8) {
    $bff1c097ab7df2f7$var$match = $bff1c097ab7df2f7$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $bff1c097ab7df2f7$var$version = $bff1c097ab7df2f7$var$match[0] > 0 && $bff1c097ab7df2f7$var$match[0] < 4 ? 1 : +($bff1c097ab7df2f7$var$match[0] + $bff1c097ab7df2f7$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$bff1c097ab7df2f7$var$version && $bff1c097ab7df2f7$var$userAgent) {
    $bff1c097ab7df2f7$var$match = $bff1c097ab7df2f7$var$userAgent.match(/Edge\/(\d+)/);
    if (!$bff1c097ab7df2f7$var$match || $bff1c097ab7df2f7$var$match[1] >= 74) {
        $bff1c097ab7df2f7$var$match = $bff1c097ab7df2f7$var$userAgent.match(/Chrome\/(\d+)/);
        if ($bff1c097ab7df2f7$var$match) $bff1c097ab7df2f7$var$version = +$bff1c097ab7df2f7$var$match[1];
    }
}
var $bff1c097ab7df2f7$var$engineV8Version = $bff1c097ab7df2f7$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $bff1c097ab7df2f7$var$V8_VERSION = $bff1c097ab7df2f7$var$engineV8Version;
var $bff1c097ab7df2f7$var$fails$5 = $bff1c097ab7df2f7$var$fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $bff1c097ab7df2f7$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$bff1c097ab7df2f7$var$fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $bff1c097ab7df2f7$var$V8_VERSION && $bff1c097ab7df2f7$var$V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $bff1c097ab7df2f7$var$NATIVE_SYMBOL$1 = $bff1c097ab7df2f7$var$symbolConstructorDetection;
var $bff1c097ab7df2f7$var$useSymbolAsUid = $bff1c097ab7df2f7$var$NATIVE_SYMBOL$1 && !Symbol.sham && (0, $5F2Q2._)(Symbol.iterator) == "symbol";
var $bff1c097ab7df2f7$var$getBuiltIn$3 = $bff1c097ab7df2f7$var$getBuiltIn$5;
var $bff1c097ab7df2f7$var$isCallable$9 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$isPrototypeOf = $bff1c097ab7df2f7$var$objectIsPrototypeOf;
var $bff1c097ab7df2f7$var$USE_SYMBOL_AS_UID$1 = $bff1c097ab7df2f7$var$useSymbolAsUid;
var $bff1c097ab7df2f7$var$$Object$2 = Object;
var $bff1c097ab7df2f7$var$isSymbol$2 = $bff1c097ab7df2f7$var$USE_SYMBOL_AS_UID$1 ? function isSymbol$2(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $5F2Q2._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $bff1c097ab7df2f7$var$getBuiltIn$3("Symbol");
    return $bff1c097ab7df2f7$var$isCallable$9($Symbol) && $bff1c097ab7df2f7$var$isPrototypeOf($Symbol.prototype, $bff1c097ab7df2f7$var$$Object$2(it));
};
var $bff1c097ab7df2f7$var$$String$1 = String;
var $bff1c097ab7df2f7$var$tryToString$1 = function tryToString$1(argument) {
    try {
        return $bff1c097ab7df2f7$var$$String$1(argument);
    } catch (error) {
        return "Object";
    }
};
var $bff1c097ab7df2f7$var$isCallable$8 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$tryToString = $bff1c097ab7df2f7$var$tryToString$1;
var $bff1c097ab7df2f7$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $bff1c097ab7df2f7$var$aCallable$2 = function aCallable$2(argument) {
    if ($bff1c097ab7df2f7$var$isCallable$8(argument)) return argument;
    throw $bff1c097ab7df2f7$var$$TypeError$4($bff1c097ab7df2f7$var$tryToString(argument) + " is not a function");
};
var $bff1c097ab7df2f7$var$aCallable$1 = $bff1c097ab7df2f7$var$aCallable$2;
var $bff1c097ab7df2f7$var$isNullOrUndefined = $bff1c097ab7df2f7$var$isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $bff1c097ab7df2f7$var$getMethod$1 = function getMethod$1(V, P) {
    var func = V[P];
    return $bff1c097ab7df2f7$var$isNullOrUndefined(func) ? undefined : $bff1c097ab7df2f7$var$aCallable$1(func);
};
var $bff1c097ab7df2f7$var$call$2 = $bff1c097ab7df2f7$var$functionCall;
var $bff1c097ab7df2f7$var$isCallable$7 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$isObject$5 = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $bff1c097ab7df2f7$var$ordinaryToPrimitive$1 = function ordinaryToPrimitive$1(input, pref) {
    var fn, val;
    if (pref === "string" && $bff1c097ab7df2f7$var$isCallable$7(fn = input.toString) && !$bff1c097ab7df2f7$var$isObject$5(val = $bff1c097ab7df2f7$var$call$2(fn, input))) return val;
    if ($bff1c097ab7df2f7$var$isCallable$7(fn = input.valueOf) && !$bff1c097ab7df2f7$var$isObject$5(val = $bff1c097ab7df2f7$var$call$2(fn, input))) return val;
    if (pref !== "string" && $bff1c097ab7df2f7$var$isCallable$7(fn = input.toString) && !$bff1c097ab7df2f7$var$isObject$5(val = $bff1c097ab7df2f7$var$call$2(fn, input))) return val;
    throw $bff1c097ab7df2f7$var$$TypeError$3("Can't convert object to primitive value");
};
var $bff1c097ab7df2f7$var$shared$3 = {
    exports: {}
};
var $bff1c097ab7df2f7$var$global$7 = $bff1c097ab7df2f7$var$global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bff1c097ab7df2f7$var$defineProperty$2 = Object.defineProperty;
var $bff1c097ab7df2f7$var$defineGlobalProperty$3 = function defineGlobalProperty$3(key, value) {
    try {
        $bff1c097ab7df2f7$var$defineProperty$2($bff1c097ab7df2f7$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $bff1c097ab7df2f7$var$global$7[key] = value;
    }
    return value;
};
var $bff1c097ab7df2f7$var$global$6 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$defineGlobalProperty$2 = $bff1c097ab7df2f7$var$defineGlobalProperty$3;
var $bff1c097ab7df2f7$var$SHARED = "__core-js_shared__";
var $bff1c097ab7df2f7$var$store$3 = $bff1c097ab7df2f7$var$global$6[$bff1c097ab7df2f7$var$SHARED] || $bff1c097ab7df2f7$var$defineGlobalProperty$2($bff1c097ab7df2f7$var$SHARED, {});
var $bff1c097ab7df2f7$var$sharedStore = $bff1c097ab7df2f7$var$store$3;
var $bff1c097ab7df2f7$var$store$2 = $bff1c097ab7df2f7$var$sharedStore;
($bff1c097ab7df2f7$var$shared$3.exports = function(key, value) {
    return $bff1c097ab7df2f7$var$store$2[key] || ($bff1c097ab7df2f7$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.25.5",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $bff1c097ab7df2f7$var$requireObjectCoercible = $bff1c097ab7df2f7$var$requireObjectCoercible$2;
var $bff1c097ab7df2f7$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $bff1c097ab7df2f7$var$toObject$2 = function toObject$2(argument) {
    return $bff1c097ab7df2f7$var$$Object$1($bff1c097ab7df2f7$var$requireObjectCoercible(argument));
};
var $bff1c097ab7df2f7$var$uncurryThis$7 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$toObject$1 = $bff1c097ab7df2f7$var$toObject$2;
var $bff1c097ab7df2f7$var$hasOwnProperty = $bff1c097ab7df2f7$var$uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $bff1c097ab7df2f7$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $bff1c097ab7df2f7$var$hasOwnProperty($bff1c097ab7df2f7$var$toObject$1(it), key);
};
var $bff1c097ab7df2f7$var$uncurryThis$6 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$id = 0;
var $bff1c097ab7df2f7$var$postfix = Math.random();
var $bff1c097ab7df2f7$var$toString = $bff1c097ab7df2f7$var$uncurryThis$6(1.0.toString);
var $bff1c097ab7df2f7$var$uid$2 = function uid$2(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $bff1c097ab7df2f7$var$toString(++$bff1c097ab7df2f7$var$id + $bff1c097ab7df2f7$var$postfix, 36);
};
var $bff1c097ab7df2f7$var$global$5 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$shared$2 = $bff1c097ab7df2f7$var$shared$3.exports;
var $bff1c097ab7df2f7$var$hasOwn$6 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$uid$1 = $bff1c097ab7df2f7$var$uid$2;
var $bff1c097ab7df2f7$var$NATIVE_SYMBOL = $bff1c097ab7df2f7$var$symbolConstructorDetection;
var $bff1c097ab7df2f7$var$USE_SYMBOL_AS_UID = $bff1c097ab7df2f7$var$useSymbolAsUid;
var $bff1c097ab7df2f7$var$WellKnownSymbolsStore = $bff1c097ab7df2f7$var$shared$2("wks");
var $bff1c097ab7df2f7$var$Symbol$1 = $bff1c097ab7df2f7$var$global$5.Symbol;
var $bff1c097ab7df2f7$var$symbolFor = $bff1c097ab7df2f7$var$Symbol$1 && $bff1c097ab7df2f7$var$Symbol$1["for"];
var $bff1c097ab7df2f7$var$createWellKnownSymbol = $bff1c097ab7df2f7$var$USE_SYMBOL_AS_UID ? $bff1c097ab7df2f7$var$Symbol$1 : $bff1c097ab7df2f7$var$Symbol$1 && $bff1c097ab7df2f7$var$Symbol$1.withoutSetter || $bff1c097ab7df2f7$var$uid$1;
var $bff1c097ab7df2f7$var$wellKnownSymbol$5 = function wellKnownSymbol$5(name) {
    if (!$bff1c097ab7df2f7$var$hasOwn$6($bff1c097ab7df2f7$var$WellKnownSymbolsStore, name) || !($bff1c097ab7df2f7$var$NATIVE_SYMBOL || typeof $bff1c097ab7df2f7$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($bff1c097ab7df2f7$var$NATIVE_SYMBOL && $bff1c097ab7df2f7$var$hasOwn$6($bff1c097ab7df2f7$var$Symbol$1, name)) $bff1c097ab7df2f7$var$WellKnownSymbolsStore[name] = $bff1c097ab7df2f7$var$Symbol$1[name];
        else if ($bff1c097ab7df2f7$var$USE_SYMBOL_AS_UID && $bff1c097ab7df2f7$var$symbolFor) $bff1c097ab7df2f7$var$WellKnownSymbolsStore[name] = $bff1c097ab7df2f7$var$symbolFor(description);
        else $bff1c097ab7df2f7$var$WellKnownSymbolsStore[name] = $bff1c097ab7df2f7$var$createWellKnownSymbol(description);
    }
    return $bff1c097ab7df2f7$var$WellKnownSymbolsStore[name];
};
var $bff1c097ab7df2f7$var$call$1 = $bff1c097ab7df2f7$var$functionCall;
var $bff1c097ab7df2f7$var$isObject$4 = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$isSymbol$1 = $bff1c097ab7df2f7$var$isSymbol$2;
var $bff1c097ab7df2f7$var$getMethod = $bff1c097ab7df2f7$var$getMethod$1;
var $bff1c097ab7df2f7$var$ordinaryToPrimitive = $bff1c097ab7df2f7$var$ordinaryToPrimitive$1;
var $bff1c097ab7df2f7$var$wellKnownSymbol$4 = $bff1c097ab7df2f7$var$wellKnownSymbol$5;
var $bff1c097ab7df2f7$var$$TypeError$2 = TypeError;
var $bff1c097ab7df2f7$var$TO_PRIMITIVE = $bff1c097ab7df2f7$var$wellKnownSymbol$4("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $bff1c097ab7df2f7$var$toPrimitive$1 = function toPrimitive$1(input, pref) {
    if (!$bff1c097ab7df2f7$var$isObject$4(input) || $bff1c097ab7df2f7$var$isSymbol$1(input)) return input;
    var exoticToPrim = $bff1c097ab7df2f7$var$getMethod(input, $bff1c097ab7df2f7$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $bff1c097ab7df2f7$var$call$1(exoticToPrim, input, pref);
        if (!$bff1c097ab7df2f7$var$isObject$4(result) || $bff1c097ab7df2f7$var$isSymbol$1(result)) return result;
        throw $bff1c097ab7df2f7$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $bff1c097ab7df2f7$var$ordinaryToPrimitive(input, pref);
};
var $bff1c097ab7df2f7$var$toPrimitive = $bff1c097ab7df2f7$var$toPrimitive$1;
var $bff1c097ab7df2f7$var$isSymbol = $bff1c097ab7df2f7$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $bff1c097ab7df2f7$var$toPropertyKey$2 = function toPropertyKey$2(argument) {
    var key = $bff1c097ab7df2f7$var$toPrimitive(argument, "string");
    return $bff1c097ab7df2f7$var$isSymbol(key) ? key : key + "";
};
var $bff1c097ab7df2f7$var$global$4 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$isObject$3 = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$document$1 = $bff1c097ab7df2f7$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $bff1c097ab7df2f7$var$EXISTS$1 = $bff1c097ab7df2f7$var$isObject$3($bff1c097ab7df2f7$var$document$1) && $bff1c097ab7df2f7$var$isObject$3($bff1c097ab7df2f7$var$document$1.createElement);
var $bff1c097ab7df2f7$var$documentCreateElement$1 = function documentCreateElement$1(it) {
    return $bff1c097ab7df2f7$var$EXISTS$1 ? $bff1c097ab7df2f7$var$document$1.createElement(it) : {};
};
var $bff1c097ab7df2f7$var$DESCRIPTORS$7 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$fails$4 = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$createElement = $bff1c097ab7df2f7$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $bff1c097ab7df2f7$var$ie8DomDefine = !$bff1c097ab7df2f7$var$DESCRIPTORS$7 && !$bff1c097ab7df2f7$var$fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($bff1c097ab7df2f7$var$createElement("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});
var $bff1c097ab7df2f7$var$DESCRIPTORS$6 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$call = $bff1c097ab7df2f7$var$functionCall;
var $bff1c097ab7df2f7$var$propertyIsEnumerableModule = $bff1c097ab7df2f7$var$objectPropertyIsEnumerable;
var $bff1c097ab7df2f7$var$createPropertyDescriptor$1 = $bff1c097ab7df2f7$var$createPropertyDescriptor$2;
var $bff1c097ab7df2f7$var$toIndexedObject$3 = $bff1c097ab7df2f7$var$toIndexedObject$4;
var $bff1c097ab7df2f7$var$toPropertyKey$1 = $bff1c097ab7df2f7$var$toPropertyKey$2;
var $bff1c097ab7df2f7$var$hasOwn$5 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$IE8_DOM_DEFINE$1 = $bff1c097ab7df2f7$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bff1c097ab7df2f7$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$bff1c097ab7df2f7$var$objectGetOwnPropertyDescriptor.f = $bff1c097ab7df2f7$var$DESCRIPTORS$6 ? $bff1c097ab7df2f7$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $bff1c097ab7df2f7$var$toIndexedObject$3(O);
    P = $bff1c097ab7df2f7$var$toPropertyKey$1(P);
    if ($bff1c097ab7df2f7$var$IE8_DOM_DEFINE$1) try {
        return $bff1c097ab7df2f7$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($bff1c097ab7df2f7$var$hasOwn$5(O, P)) return $bff1c097ab7df2f7$var$createPropertyDescriptor$1(!$bff1c097ab7df2f7$var$call($bff1c097ab7df2f7$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $bff1c097ab7df2f7$var$objectDefineProperty = {};
var $bff1c097ab7df2f7$var$DESCRIPTORS$5 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$fails$3 = $bff1c097ab7df2f7$var$fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $bff1c097ab7df2f7$var$v8PrototypeDefineBug = $bff1c097ab7df2f7$var$DESCRIPTORS$5 && $bff1c097ab7df2f7$var$fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $bff1c097ab7df2f7$var$isObject$2 = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$$String = String;
var $bff1c097ab7df2f7$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $bff1c097ab7df2f7$var$anObject$4 = function anObject$4(argument) {
    if ($bff1c097ab7df2f7$var$isObject$2(argument)) return argument;
    throw $bff1c097ab7df2f7$var$$TypeError$1($bff1c097ab7df2f7$var$$String(argument) + " is not an object");
};
var $bff1c097ab7df2f7$var$DESCRIPTORS$4 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$IE8_DOM_DEFINE = $bff1c097ab7df2f7$var$ie8DomDefine;
var $bff1c097ab7df2f7$var$V8_PROTOTYPE_DEFINE_BUG$1 = $bff1c097ab7df2f7$var$v8PrototypeDefineBug;
var $bff1c097ab7df2f7$var$anObject$3 = $bff1c097ab7df2f7$var$anObject$4;
var $bff1c097ab7df2f7$var$toPropertyKey = $bff1c097ab7df2f7$var$toPropertyKey$2;
var $bff1c097ab7df2f7$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bff1c097ab7df2f7$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bff1c097ab7df2f7$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $bff1c097ab7df2f7$var$ENUMERABLE = "enumerable";
var $bff1c097ab7df2f7$var$CONFIGURABLE$1 = "configurable";
var $bff1c097ab7df2f7$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$bff1c097ab7df2f7$var$objectDefineProperty.f = $bff1c097ab7df2f7$var$DESCRIPTORS$4 ? $bff1c097ab7df2f7$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $bff1c097ab7df2f7$var$anObject$3(O);
    P = $bff1c097ab7df2f7$var$toPropertyKey(P);
    $bff1c097ab7df2f7$var$anObject$3(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $bff1c097ab7df2f7$var$WRITABLE in Attributes && !Attributes[$bff1c097ab7df2f7$var$WRITABLE]) {
        var current = $bff1c097ab7df2f7$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$bff1c097ab7df2f7$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $bff1c097ab7df2f7$var$CONFIGURABLE$1 in Attributes ? Attributes[$bff1c097ab7df2f7$var$CONFIGURABLE$1] : current[$bff1c097ab7df2f7$var$CONFIGURABLE$1],
                enumerable: $bff1c097ab7df2f7$var$ENUMERABLE in Attributes ? Attributes[$bff1c097ab7df2f7$var$ENUMERABLE] : current[$bff1c097ab7df2f7$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $bff1c097ab7df2f7$var$$defineProperty(O, P, Attributes);
} : $bff1c097ab7df2f7$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $bff1c097ab7df2f7$var$anObject$3(O);
    P = $bff1c097ab7df2f7$var$toPropertyKey(P);
    $bff1c097ab7df2f7$var$anObject$3(Attributes);
    if ($bff1c097ab7df2f7$var$IE8_DOM_DEFINE) try {
        return $bff1c097ab7df2f7$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $bff1c097ab7df2f7$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $bff1c097ab7df2f7$var$DESCRIPTORS$3 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$definePropertyModule$3 = $bff1c097ab7df2f7$var$objectDefineProperty;
var $bff1c097ab7df2f7$var$createPropertyDescriptor = $bff1c097ab7df2f7$var$createPropertyDescriptor$2;
var $bff1c097ab7df2f7$var$createNonEnumerableProperty$2 = $bff1c097ab7df2f7$var$DESCRIPTORS$3 ? function createNonEnumerableProperty$2(object, key, value) {
    return $bff1c097ab7df2f7$var$definePropertyModule$3.f(object, key, $bff1c097ab7df2f7$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $bff1c097ab7df2f7$var$makeBuiltIn$2 = {
    exports: {}
};
var $bff1c097ab7df2f7$var$DESCRIPTORS$2 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$hasOwn$4 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bff1c097ab7df2f7$var$getDescriptor = $bff1c097ab7df2f7$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $bff1c097ab7df2f7$var$EXISTS = $bff1c097ab7df2f7$var$hasOwn$4($bff1c097ab7df2f7$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $bff1c097ab7df2f7$var$PROPER = $bff1c097ab7df2f7$var$EXISTS && (function something() {}).name === "something";
var $bff1c097ab7df2f7$var$CONFIGURABLE = $bff1c097ab7df2f7$var$EXISTS && (!$bff1c097ab7df2f7$var$DESCRIPTORS$2 || $bff1c097ab7df2f7$var$DESCRIPTORS$2 && $bff1c097ab7df2f7$var$getDescriptor($bff1c097ab7df2f7$var$FunctionPrototype, "name").configurable);
var $bff1c097ab7df2f7$var$functionName = {
    EXISTS: $bff1c097ab7df2f7$var$EXISTS,
    PROPER: $bff1c097ab7df2f7$var$PROPER,
    CONFIGURABLE: $bff1c097ab7df2f7$var$CONFIGURABLE
};
var $bff1c097ab7df2f7$var$uncurryThis$5 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$isCallable$6 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$store$1 = $bff1c097ab7df2f7$var$sharedStore;
var $bff1c097ab7df2f7$var$functionToString = $bff1c097ab7df2f7$var$uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$bff1c097ab7df2f7$var$isCallable$6($bff1c097ab7df2f7$var$store$1.inspectSource)) $bff1c097ab7df2f7$var$store$1.inspectSource = function(it) {
    return $bff1c097ab7df2f7$var$functionToString(it);
};
var $bff1c097ab7df2f7$var$inspectSource$2 = $bff1c097ab7df2f7$var$store$1.inspectSource;
var $bff1c097ab7df2f7$var$global$3 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$isCallable$5 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$WeakMap$1 = $bff1c097ab7df2f7$var$global$3.WeakMap;
var $bff1c097ab7df2f7$var$weakMapBasicDetection = $bff1c097ab7df2f7$var$isCallable$5($bff1c097ab7df2f7$var$WeakMap$1) && /native code/.test(String($bff1c097ab7df2f7$var$WeakMap$1));
var $bff1c097ab7df2f7$var$shared$1 = $bff1c097ab7df2f7$var$shared$3.exports;
var $bff1c097ab7df2f7$var$uid = $bff1c097ab7df2f7$var$uid$2;
var $bff1c097ab7df2f7$var$keys = $bff1c097ab7df2f7$var$shared$1("keys");
var $bff1c097ab7df2f7$var$sharedKey$2 = function sharedKey$2(key) {
    return $bff1c097ab7df2f7$var$keys[key] || ($bff1c097ab7df2f7$var$keys[key] = $bff1c097ab7df2f7$var$uid(key));
};
var $bff1c097ab7df2f7$var$hiddenKeys$4 = {};
var $bff1c097ab7df2f7$var$NATIVE_WEAK_MAP = $bff1c097ab7df2f7$var$weakMapBasicDetection;
var $bff1c097ab7df2f7$var$global$2 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$isObject$1 = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$createNonEnumerableProperty$1 = $bff1c097ab7df2f7$var$createNonEnumerableProperty$2;
var $bff1c097ab7df2f7$var$hasOwn$3 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$shared = $bff1c097ab7df2f7$var$sharedStore;
var $bff1c097ab7df2f7$var$sharedKey$1 = $bff1c097ab7df2f7$var$sharedKey$2;
var $bff1c097ab7df2f7$var$hiddenKeys$3 = $bff1c097ab7df2f7$var$hiddenKeys$4;
var $bff1c097ab7df2f7$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $bff1c097ab7df2f7$var$TypeError$1 = $bff1c097ab7df2f7$var$global$2.TypeError;
var $bff1c097ab7df2f7$var$WeakMap = $bff1c097ab7df2f7$var$global$2.WeakMap;
var $bff1c097ab7df2f7$var$set, $bff1c097ab7df2f7$var$get, $bff1c097ab7df2f7$var$has;
var $bff1c097ab7df2f7$var$enforce = function enforce(it) {
    return $bff1c097ab7df2f7$var$has(it) ? $bff1c097ab7df2f7$var$get(it) : $bff1c097ab7df2f7$var$set(it, {});
};
var $bff1c097ab7df2f7$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$bff1c097ab7df2f7$var$isObject$1(it) || (state = $bff1c097ab7df2f7$var$get(it)).type !== TYPE) throw $bff1c097ab7df2f7$var$TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($bff1c097ab7df2f7$var$NATIVE_WEAK_MAP || $bff1c097ab7df2f7$var$shared.state) {
    var $bff1c097ab7df2f7$var$store = $bff1c097ab7df2f7$var$shared.state || ($bff1c097ab7df2f7$var$shared.state = new $bff1c097ab7df2f7$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $bff1c097ab7df2f7$var$store.get = $bff1c097ab7df2f7$var$store.get;
    $bff1c097ab7df2f7$var$store.has = $bff1c097ab7df2f7$var$store.has;
    $bff1c097ab7df2f7$var$store.set = $bff1c097ab7df2f7$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $bff1c097ab7df2f7$var$set = function set(it, metadata) {
        if ($bff1c097ab7df2f7$var$store.has(it)) throw $bff1c097ab7df2f7$var$TypeError$1($bff1c097ab7df2f7$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $bff1c097ab7df2f7$var$store.set(it, metadata);
        return metadata;
    };
    $bff1c097ab7df2f7$var$get = function get(it) {
        return $bff1c097ab7df2f7$var$store.get(it) || {};
    };
    $bff1c097ab7df2f7$var$has = function has(it) {
        return $bff1c097ab7df2f7$var$store.has(it);
    };
} else {
    var $bff1c097ab7df2f7$var$STATE = $bff1c097ab7df2f7$var$sharedKey$1("state");
    $bff1c097ab7df2f7$var$hiddenKeys$3[$bff1c097ab7df2f7$var$STATE] = true;
    $bff1c097ab7df2f7$var$set = function set(it, metadata) {
        if ($bff1c097ab7df2f7$var$hasOwn$3(it, $bff1c097ab7df2f7$var$STATE)) throw $bff1c097ab7df2f7$var$TypeError$1($bff1c097ab7df2f7$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $bff1c097ab7df2f7$var$createNonEnumerableProperty$1(it, $bff1c097ab7df2f7$var$STATE, metadata);
        return metadata;
    };
    $bff1c097ab7df2f7$var$get = function get(it) {
        return $bff1c097ab7df2f7$var$hasOwn$3(it, $bff1c097ab7df2f7$var$STATE) ? it[$bff1c097ab7df2f7$var$STATE] : {};
    };
    $bff1c097ab7df2f7$var$has = function has(it) {
        return $bff1c097ab7df2f7$var$hasOwn$3(it, $bff1c097ab7df2f7$var$STATE);
    };
}
var $bff1c097ab7df2f7$var$internalState = {
    set: $bff1c097ab7df2f7$var$set,
    get: $bff1c097ab7df2f7$var$get,
    has: $bff1c097ab7df2f7$var$has,
    enforce: $bff1c097ab7df2f7$var$enforce,
    getterFor: $bff1c097ab7df2f7$var$getterFor
};
var $bff1c097ab7df2f7$var$fails$2 = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$isCallable$4 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$hasOwn$2 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$DESCRIPTORS$1 = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$CONFIGURABLE_FUNCTION_NAME = $bff1c097ab7df2f7$var$functionName.CONFIGURABLE;
var $bff1c097ab7df2f7$var$inspectSource$1 = $bff1c097ab7df2f7$var$inspectSource$2;
var $bff1c097ab7df2f7$var$InternalStateModule = $bff1c097ab7df2f7$var$internalState;
var $bff1c097ab7df2f7$var$enforceInternalState = $bff1c097ab7df2f7$var$InternalStateModule.enforce;
var $bff1c097ab7df2f7$var$getInternalState = $bff1c097ab7df2f7$var$InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $bff1c097ab7df2f7$var$defineProperty$1 = Object.defineProperty;
var $bff1c097ab7df2f7$var$CONFIGURABLE_LENGTH = $bff1c097ab7df2f7$var$DESCRIPTORS$1 && !$bff1c097ab7df2f7$var$fails$2(function() {
    return $bff1c097ab7df2f7$var$defineProperty$1(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $bff1c097ab7df2f7$var$TEMPLATE = String(String).split("String");
var $bff1c097ab7df2f7$var$makeBuiltIn$1 = $bff1c097ab7df2f7$var$makeBuiltIn$2.exports = function makeBuiltIn$1(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$bff1c097ab7df2f7$var$hasOwn$2(value, "name") || $bff1c097ab7df2f7$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($bff1c097ab7df2f7$var$DESCRIPTORS$1) $bff1c097ab7df2f7$var$defineProperty$1(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($bff1c097ab7df2f7$var$CONFIGURABLE_LENGTH && options && $bff1c097ab7df2f7$var$hasOwn$2(options, "arity") && value.length !== options.arity) $bff1c097ab7df2f7$var$defineProperty$1(value, "length", {
        value: options.arity
    });
    try {
        if (options && $bff1c097ab7df2f7$var$hasOwn$2(options, "constructor") && options.constructor) {
            if ($bff1c097ab7df2f7$var$DESCRIPTORS$1) $bff1c097ab7df2f7$var$defineProperty$1(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $bff1c097ab7df2f7$var$enforceInternalState(value);
    if (!$bff1c097ab7df2f7$var$hasOwn$2(state, "source")) state.source = $bff1c097ab7df2f7$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $bff1c097ab7df2f7$var$makeBuiltIn$1(function toString() {
    return $bff1c097ab7df2f7$var$isCallable$4(this) && $bff1c097ab7df2f7$var$getInternalState(this).source || $bff1c097ab7df2f7$var$inspectSource$1(this);
}, "toString");
var $bff1c097ab7df2f7$var$isCallable$3 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$definePropertyModule$2 = $bff1c097ab7df2f7$var$objectDefineProperty;
var $bff1c097ab7df2f7$var$makeBuiltIn = $bff1c097ab7df2f7$var$makeBuiltIn$2.exports;
var $bff1c097ab7df2f7$var$defineGlobalProperty$1 = $bff1c097ab7df2f7$var$defineGlobalProperty$3;
var $bff1c097ab7df2f7$var$defineBuiltIn$1 = function defineBuiltIn$1(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($bff1c097ab7df2f7$var$isCallable$3(value)) $bff1c097ab7df2f7$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $bff1c097ab7df2f7$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $bff1c097ab7df2f7$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $bff1c097ab7df2f7$var$objectGetOwnPropertyNames = {};
var $bff1c097ab7df2f7$var$ceil = Math.ceil;
var $bff1c097ab7df2f7$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $bff1c097ab7df2f7$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $bff1c097ab7df2f7$var$floor : $bff1c097ab7df2f7$var$ceil)(n);
};
var $bff1c097ab7df2f7$var$trunc = $bff1c097ab7df2f7$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $bff1c097ab7df2f7$var$toIntegerOrInfinity$2 = function toIntegerOrInfinity$2(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $bff1c097ab7df2f7$var$trunc(number);
};
var $bff1c097ab7df2f7$var$toIntegerOrInfinity$1 = $bff1c097ab7df2f7$var$toIntegerOrInfinity$2;
var $bff1c097ab7df2f7$var$max = Math.max;
var $bff1c097ab7df2f7$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $bff1c097ab7df2f7$var$toAbsoluteIndex$1 = function toAbsoluteIndex$1(index, length) {
    var integer = $bff1c097ab7df2f7$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $bff1c097ab7df2f7$var$max(integer + length, 0) : $bff1c097ab7df2f7$var$min$1(integer, length);
};
var $bff1c097ab7df2f7$var$toIntegerOrInfinity = $bff1c097ab7df2f7$var$toIntegerOrInfinity$2;
var $bff1c097ab7df2f7$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $bff1c097ab7df2f7$var$toLength$1 = function toLength$1(argument) {
    return argument > 0 ? $bff1c097ab7df2f7$var$min($bff1c097ab7df2f7$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $bff1c097ab7df2f7$var$toLength = $bff1c097ab7df2f7$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $bff1c097ab7df2f7$var$lengthOfArrayLike$2 = function lengthOfArrayLike$2(obj) {
    return $bff1c097ab7df2f7$var$toLength(obj.length);
};
var $bff1c097ab7df2f7$var$toIndexedObject$2 = $bff1c097ab7df2f7$var$toIndexedObject$4;
var $bff1c097ab7df2f7$var$toAbsoluteIndex = $bff1c097ab7df2f7$var$toAbsoluteIndex$1;
var $bff1c097ab7df2f7$var$lengthOfArrayLike$1 = $bff1c097ab7df2f7$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $bff1c097ab7df2f7$var$createMethod$1 = function createMethod$1(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bff1c097ab7df2f7$var$toIndexedObject$2($this);
        var length = $bff1c097ab7df2f7$var$lengthOfArrayLike$1(O);
        var index = $bff1c097ab7df2f7$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $bff1c097ab7df2f7$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $bff1c097ab7df2f7$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $bff1c097ab7df2f7$var$createMethod$1(false)
};
var $bff1c097ab7df2f7$var$uncurryThis$4 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$hasOwn$1 = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$toIndexedObject$1 = $bff1c097ab7df2f7$var$toIndexedObject$4;
var $bff1c097ab7df2f7$var$indexOf = $bff1c097ab7df2f7$var$arrayIncludes.indexOf;
var $bff1c097ab7df2f7$var$hiddenKeys$2 = $bff1c097ab7df2f7$var$hiddenKeys$4;
var $bff1c097ab7df2f7$var$push$1 = $bff1c097ab7df2f7$var$uncurryThis$4([].push);
var $bff1c097ab7df2f7$var$objectKeysInternal = function objectKeysInternal(object, names) {
    var O = $bff1c097ab7df2f7$var$toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$bff1c097ab7df2f7$var$hasOwn$1($bff1c097ab7df2f7$var$hiddenKeys$2, key) && $bff1c097ab7df2f7$var$hasOwn$1(O, key) && $bff1c097ab7df2f7$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($bff1c097ab7df2f7$var$hasOwn$1(O, key = names[i++])) ~$bff1c097ab7df2f7$var$indexOf(result, key) || $bff1c097ab7df2f7$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $bff1c097ab7df2f7$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $bff1c097ab7df2f7$var$internalObjectKeys$1 = $bff1c097ab7df2f7$var$objectKeysInternal;
var $bff1c097ab7df2f7$var$enumBugKeys$2 = $bff1c097ab7df2f7$var$enumBugKeys$3;
var $bff1c097ab7df2f7$var$hiddenKeys$1 = $bff1c097ab7df2f7$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$bff1c097ab7df2f7$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $bff1c097ab7df2f7$var$internalObjectKeys$1(O, $bff1c097ab7df2f7$var$hiddenKeys$1);
};
var $bff1c097ab7df2f7$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$bff1c097ab7df2f7$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $bff1c097ab7df2f7$var$getBuiltIn$2 = $bff1c097ab7df2f7$var$getBuiltIn$5;
var $bff1c097ab7df2f7$var$uncurryThis$3 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$getOwnPropertyNamesModule = $bff1c097ab7df2f7$var$objectGetOwnPropertyNames;
var $bff1c097ab7df2f7$var$getOwnPropertySymbolsModule = $bff1c097ab7df2f7$var$objectGetOwnPropertySymbols;
var $bff1c097ab7df2f7$var$anObject$2 = $bff1c097ab7df2f7$var$anObject$4;
var $bff1c097ab7df2f7$var$concat = $bff1c097ab7df2f7$var$uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var $bff1c097ab7df2f7$var$ownKeys$1 = $bff1c097ab7df2f7$var$getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $bff1c097ab7df2f7$var$getOwnPropertyNamesModule.f($bff1c097ab7df2f7$var$anObject$2(it));
    var getOwnPropertySymbols = $bff1c097ab7df2f7$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $bff1c097ab7df2f7$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $bff1c097ab7df2f7$var$hasOwn = $bff1c097ab7df2f7$var$hasOwnProperty_1;
var $bff1c097ab7df2f7$var$ownKeys = $bff1c097ab7df2f7$var$ownKeys$1;
var $bff1c097ab7df2f7$var$getOwnPropertyDescriptorModule = $bff1c097ab7df2f7$var$objectGetOwnPropertyDescriptor;
var $bff1c097ab7df2f7$var$definePropertyModule$1 = $bff1c097ab7df2f7$var$objectDefineProperty;
var $bff1c097ab7df2f7$var$copyConstructorProperties$1 = function copyConstructorProperties$1(target, source, exceptions) {
    var keys = $bff1c097ab7df2f7$var$ownKeys(source);
    var defineProperty = $bff1c097ab7df2f7$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $bff1c097ab7df2f7$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$bff1c097ab7df2f7$var$hasOwn(target, key) && !(exceptions && $bff1c097ab7df2f7$var$hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $bff1c097ab7df2f7$var$fails$1 = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$isCallable$2 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$replacement = /#|\.prototype\./;
var $bff1c097ab7df2f7$var$isForced$1 = function isForced$1(feature, detection) {
    var value = $bff1c097ab7df2f7$var$data[$bff1c097ab7df2f7$var$normalize(feature)];
    return value == $bff1c097ab7df2f7$var$POLYFILL ? true : value == $bff1c097ab7df2f7$var$NATIVE ? false : $bff1c097ab7df2f7$var$isCallable$2(detection) ? $bff1c097ab7df2f7$var$fails$1(detection) : !!detection;
};
var $bff1c097ab7df2f7$var$normalize = $bff1c097ab7df2f7$var$isForced$1.normalize = function normalize(string) {
    return String(string).replace($bff1c097ab7df2f7$var$replacement, ".").toLowerCase();
};
var $bff1c097ab7df2f7$var$data = $bff1c097ab7df2f7$var$isForced$1.data = {};
var $bff1c097ab7df2f7$var$NATIVE = $bff1c097ab7df2f7$var$isForced$1.NATIVE = "N";
var $bff1c097ab7df2f7$var$POLYFILL = $bff1c097ab7df2f7$var$isForced$1.POLYFILL = "P";
var $bff1c097ab7df2f7$var$isForced_1 = $bff1c097ab7df2f7$var$isForced$1;
var $bff1c097ab7df2f7$var$global$1 = $bff1c097ab7df2f7$var$global$a;
var $bff1c097ab7df2f7$var$getOwnPropertyDescriptor = $bff1c097ab7df2f7$var$objectGetOwnPropertyDescriptor.f;
var $bff1c097ab7df2f7$var$createNonEnumerableProperty = $bff1c097ab7df2f7$var$createNonEnumerableProperty$2;
var $bff1c097ab7df2f7$var$defineBuiltIn = $bff1c097ab7df2f7$var$defineBuiltIn$1;
var $bff1c097ab7df2f7$var$defineGlobalProperty = $bff1c097ab7df2f7$var$defineGlobalProperty$3;
var $bff1c097ab7df2f7$var$copyConstructorProperties = $bff1c097ab7df2f7$var$copyConstructorProperties$1;
var $bff1c097ab7df2f7$var$isForced = $bff1c097ab7df2f7$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $bff1c097ab7df2f7$var$_export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $bff1c097ab7df2f7$var$global$1;
    else if (STATIC) target = $bff1c097ab7df2f7$var$global$1[TARGET] || $bff1c097ab7df2f7$var$defineGlobalProperty(TARGET, {});
    else target = ($bff1c097ab7df2f7$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $bff1c097ab7df2f7$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $bff1c097ab7df2f7$var$isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $5F2Q2._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $5F2Q2._)(targetProperty))) continue;
            $bff1c097ab7df2f7$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $bff1c097ab7df2f7$var$createNonEnumerableProperty(sourceProperty, "sham", true);
        $bff1c097ab7df2f7$var$defineBuiltIn(target, key, sourceProperty, options);
    }
};
var $bff1c097ab7df2f7$var$uncurryThis$2 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$aCallable = $bff1c097ab7df2f7$var$aCallable$2;
var $bff1c097ab7df2f7$var$NATIVE_BIND = $bff1c097ab7df2f7$var$functionBindNative;
var $bff1c097ab7df2f7$var$bind$1 = $bff1c097ab7df2f7$var$uncurryThis$2($bff1c097ab7df2f7$var$uncurryThis$2.bind);
// optional / simple context binding
var $bff1c097ab7df2f7$var$functionBindContext = function functionBindContext(fn, that) {
    $bff1c097ab7df2f7$var$aCallable(fn);
    return that === undefined ? fn : $bff1c097ab7df2f7$var$NATIVE_BIND ? $bff1c097ab7df2f7$var$bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $bff1c097ab7df2f7$var$classof$2 = $bff1c097ab7df2f7$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $bff1c097ab7df2f7$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $bff1c097ab7df2f7$var$classof$2(argument) == "Array";
};
var $bff1c097ab7df2f7$var$wellKnownSymbol$3 = $bff1c097ab7df2f7$var$wellKnownSymbol$5;
var $bff1c097ab7df2f7$var$TO_STRING_TAG$1 = $bff1c097ab7df2f7$var$wellKnownSymbol$3("toStringTag");
var $bff1c097ab7df2f7$var$test = {};
$bff1c097ab7df2f7$var$test[$bff1c097ab7df2f7$var$TO_STRING_TAG$1] = "z";
var $bff1c097ab7df2f7$var$toStringTagSupport = String($bff1c097ab7df2f7$var$test) === "[object z]";
var $bff1c097ab7df2f7$var$TO_STRING_TAG_SUPPORT = $bff1c097ab7df2f7$var$toStringTagSupport;
var $bff1c097ab7df2f7$var$isCallable$1 = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$classofRaw = $bff1c097ab7df2f7$var$classofRaw$2;
var $bff1c097ab7df2f7$var$wellKnownSymbol$2 = $bff1c097ab7df2f7$var$wellKnownSymbol$5;
var $bff1c097ab7df2f7$var$TO_STRING_TAG = $bff1c097ab7df2f7$var$wellKnownSymbol$2("toStringTag");
var $bff1c097ab7df2f7$var$$Object = Object;
// ES3 wrong here
var $bff1c097ab7df2f7$var$CORRECT_ARGUMENTS = $bff1c097ab7df2f7$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $bff1c097ab7df2f7$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $bff1c097ab7df2f7$var$classof$1 = $bff1c097ab7df2f7$var$TO_STRING_TAG_SUPPORT ? $bff1c097ab7df2f7$var$classofRaw : function classof$1(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $bff1c097ab7df2f7$var$tryGet(O = $bff1c097ab7df2f7$var$$Object(it), $bff1c097ab7df2f7$var$TO_STRING_TAG)) == "string" ? tag : $bff1c097ab7df2f7$var$CORRECT_ARGUMENTS ? $bff1c097ab7df2f7$var$classofRaw(O) : (result = $bff1c097ab7df2f7$var$classofRaw(O)) == "Object" && $bff1c097ab7df2f7$var$isCallable$1(O.callee) ? "Arguments" : result;
};
var $bff1c097ab7df2f7$var$uncurryThis$1 = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$fails = $bff1c097ab7df2f7$var$fails$9;
var $bff1c097ab7df2f7$var$isCallable = $bff1c097ab7df2f7$var$isCallable$c;
var $bff1c097ab7df2f7$var$classof = $bff1c097ab7df2f7$var$classof$1;
var $bff1c097ab7df2f7$var$getBuiltIn$1 = $bff1c097ab7df2f7$var$getBuiltIn$5;
var $bff1c097ab7df2f7$var$inspectSource = $bff1c097ab7df2f7$var$inspectSource$2;
var $bff1c097ab7df2f7$var$noop = function noop() {};
var $bff1c097ab7df2f7$var$empty = [];
var $bff1c097ab7df2f7$var$construct = $bff1c097ab7df2f7$var$getBuiltIn$1("Reflect", "construct");
var $bff1c097ab7df2f7$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $bff1c097ab7df2f7$var$exec = $bff1c097ab7df2f7$var$uncurryThis$1($bff1c097ab7df2f7$var$constructorRegExp.exec);
var $bff1c097ab7df2f7$var$INCORRECT_TO_STRING = !$bff1c097ab7df2f7$var$constructorRegExp.exec($bff1c097ab7df2f7$var$noop);
var $bff1c097ab7df2f7$var$isConstructorModern = function isConstructor(argument) {
    if (!$bff1c097ab7df2f7$var$isCallable(argument)) return false;
    try {
        $bff1c097ab7df2f7$var$construct($bff1c097ab7df2f7$var$noop, $bff1c097ab7df2f7$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $bff1c097ab7df2f7$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$bff1c097ab7df2f7$var$isCallable(argument)) return false;
    switch($bff1c097ab7df2f7$var$classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $bff1c097ab7df2f7$var$INCORRECT_TO_STRING || !!$bff1c097ab7df2f7$var$exec($bff1c097ab7df2f7$var$constructorRegExp, $bff1c097ab7df2f7$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$bff1c097ab7df2f7$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $bff1c097ab7df2f7$var$isConstructor$1 = !$bff1c097ab7df2f7$var$construct || $bff1c097ab7df2f7$var$fails(function() {
    var called;
    return $bff1c097ab7df2f7$var$isConstructorModern($bff1c097ab7df2f7$var$isConstructorModern.call) || !$bff1c097ab7df2f7$var$isConstructorModern(Object) || !$bff1c097ab7df2f7$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $bff1c097ab7df2f7$var$isConstructorLegacy : $bff1c097ab7df2f7$var$isConstructorModern;
var $bff1c097ab7df2f7$var$isArray = $bff1c097ab7df2f7$var$isArray$1;
var $bff1c097ab7df2f7$var$isConstructor = $bff1c097ab7df2f7$var$isConstructor$1;
var $bff1c097ab7df2f7$var$isObject = $bff1c097ab7df2f7$var$isObject$6;
var $bff1c097ab7df2f7$var$wellKnownSymbol$1 = $bff1c097ab7df2f7$var$wellKnownSymbol$5;
var $bff1c097ab7df2f7$var$SPECIES = $bff1c097ab7df2f7$var$wellKnownSymbol$1("species");
var $bff1c097ab7df2f7$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $bff1c097ab7df2f7$var$arraySpeciesConstructor$1 = function arraySpeciesConstructor$1(originalArray) {
    var C;
    if ($bff1c097ab7df2f7$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($bff1c097ab7df2f7$var$isConstructor(C) && (C === $bff1c097ab7df2f7$var$$Array || $bff1c097ab7df2f7$var$isArray(C.prototype))) C = undefined;
        else if ($bff1c097ab7df2f7$var$isObject(C)) {
            C = C[$bff1c097ab7df2f7$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $bff1c097ab7df2f7$var$$Array : C;
};
var $bff1c097ab7df2f7$var$arraySpeciesConstructor = $bff1c097ab7df2f7$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $bff1c097ab7df2f7$var$arraySpeciesCreate$1 = function arraySpeciesCreate$1(originalArray, length) {
    return new ($bff1c097ab7df2f7$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $bff1c097ab7df2f7$var$bind = $bff1c097ab7df2f7$var$functionBindContext;
var $bff1c097ab7df2f7$var$uncurryThis = $bff1c097ab7df2f7$var$functionUncurryThis;
var $bff1c097ab7df2f7$var$IndexedObject = $bff1c097ab7df2f7$var$indexedObject;
var $bff1c097ab7df2f7$var$toObject = $bff1c097ab7df2f7$var$toObject$2;
var $bff1c097ab7df2f7$var$lengthOfArrayLike = $bff1c097ab7df2f7$var$lengthOfArrayLike$2;
var $bff1c097ab7df2f7$var$arraySpeciesCreate = $bff1c097ab7df2f7$var$arraySpeciesCreate$1;
var $bff1c097ab7df2f7$var$push = $bff1c097ab7df2f7$var$uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $bff1c097ab7df2f7$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $bff1c097ab7df2f7$var$toObject($this);
        var _$self = $bff1c097ab7df2f7$var$IndexedObject(O);
        var boundFunction = $bff1c097ab7df2f7$var$bind(callbackfn, that);
        var length = $bff1c097ab7df2f7$var$lengthOfArrayLike(_$self);
        var index = 0;
        var create = specificCreate || $bff1c097ab7df2f7$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in _$self) {
            value = _$self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $bff1c097ab7df2f7$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $bff1c097ab7df2f7$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $bff1c097ab7df2f7$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $bff1c097ab7df2f7$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $bff1c097ab7df2f7$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $bff1c097ab7df2f7$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $bff1c097ab7df2f7$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $bff1c097ab7df2f7$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $bff1c097ab7df2f7$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $bff1c097ab7df2f7$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $bff1c097ab7df2f7$var$createMethod(7)
};
var $bff1c097ab7df2f7$var$objectDefineProperties = {};
var $bff1c097ab7df2f7$var$internalObjectKeys = $bff1c097ab7df2f7$var$objectKeysInternal;
var $bff1c097ab7df2f7$var$enumBugKeys$1 = $bff1c097ab7df2f7$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $bff1c097ab7df2f7$var$objectKeys$1 = Object.keys || function keys(O) {
    return $bff1c097ab7df2f7$var$internalObjectKeys(O, $bff1c097ab7df2f7$var$enumBugKeys$1);
};
var $bff1c097ab7df2f7$var$DESCRIPTORS = $bff1c097ab7df2f7$var$descriptors;
var $bff1c097ab7df2f7$var$V8_PROTOTYPE_DEFINE_BUG = $bff1c097ab7df2f7$var$v8PrototypeDefineBug;
var $bff1c097ab7df2f7$var$definePropertyModule = $bff1c097ab7df2f7$var$objectDefineProperty;
var $bff1c097ab7df2f7$var$anObject$1 = $bff1c097ab7df2f7$var$anObject$4;
var $bff1c097ab7df2f7$var$toIndexedObject = $bff1c097ab7df2f7$var$toIndexedObject$4;
var $bff1c097ab7df2f7$var$objectKeys = $bff1c097ab7df2f7$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$bff1c097ab7df2f7$var$objectDefineProperties.f = $bff1c097ab7df2f7$var$DESCRIPTORS && !$bff1c097ab7df2f7$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $bff1c097ab7df2f7$var$anObject$1(O);
    var props = $bff1c097ab7df2f7$var$toIndexedObject(Properties);
    var keys = $bff1c097ab7df2f7$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$bff1c097ab7df2f7$var$definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var $bff1c097ab7df2f7$var$getBuiltIn = $bff1c097ab7df2f7$var$getBuiltIn$5;
var $bff1c097ab7df2f7$var$html$1 = $bff1c097ab7df2f7$var$getBuiltIn("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $bff1c097ab7df2f7$var$anObject = $bff1c097ab7df2f7$var$anObject$4;
var $bff1c097ab7df2f7$var$definePropertiesModule = $bff1c097ab7df2f7$var$objectDefineProperties;
var $bff1c097ab7df2f7$var$enumBugKeys = $bff1c097ab7df2f7$var$enumBugKeys$3;
var $bff1c097ab7df2f7$var$hiddenKeys = $bff1c097ab7df2f7$var$hiddenKeys$4;
var $bff1c097ab7df2f7$var$html = $bff1c097ab7df2f7$var$html$1;
var $bff1c097ab7df2f7$var$documentCreateElement = $bff1c097ab7df2f7$var$documentCreateElement$1;
var $bff1c097ab7df2f7$var$sharedKey = $bff1c097ab7df2f7$var$sharedKey$2;
var $bff1c097ab7df2f7$var$GT = ">";
var $bff1c097ab7df2f7$var$LT = "<";
var $bff1c097ab7df2f7$var$PROTOTYPE = "prototype";
var $bff1c097ab7df2f7$var$SCRIPT = "script";
var $bff1c097ab7df2f7$var$IE_PROTO = $bff1c097ab7df2f7$var$sharedKey("IE_PROTO");
var $bff1c097ab7df2f7$var$EmptyConstructor = function EmptyConstructor() {};
var $bff1c097ab7df2f7$var$scriptTag = function scriptTag(content) {
    return $bff1c097ab7df2f7$var$LT + $bff1c097ab7df2f7$var$SCRIPT + $bff1c097ab7df2f7$var$GT + content + $bff1c097ab7df2f7$var$LT + "/" + $bff1c097ab7df2f7$var$SCRIPT + $bff1c097ab7df2f7$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $bff1c097ab7df2f7$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($bff1c097ab7df2f7$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $bff1c097ab7df2f7$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $bff1c097ab7df2f7$var$documentCreateElement("iframe");
    var JS = "java" + $bff1c097ab7df2f7$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $bff1c097ab7df2f7$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($bff1c097ab7df2f7$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $bff1c097ab7df2f7$var$activeXDocument;
var $bff1c097ab7df2f7$var$NullProtoObject = function NullProtoObject1() {
    try {
        $bff1c097ab7df2f7$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $bff1c097ab7df2f7$var$NullProtoObject = typeof document != "undefined" ? document.domain && $bff1c097ab7df2f7$var$activeXDocument ? $bff1c097ab7df2f7$var$NullProtoObjectViaActiveX($bff1c097ab7df2f7$var$activeXDocument) // old IE
     : $bff1c097ab7df2f7$var$NullProtoObjectViaIFrame() : $bff1c097ab7df2f7$var$NullProtoObjectViaActiveX($bff1c097ab7df2f7$var$activeXDocument); // WSH
    var length = $bff1c097ab7df2f7$var$enumBugKeys.length;
    while(length--)delete $bff1c097ab7df2f7$var$NullProtoObject[$bff1c097ab7df2f7$var$PROTOTYPE][$bff1c097ab7df2f7$var$enumBugKeys[length]];
    return $bff1c097ab7df2f7$var$NullProtoObject();
};
$bff1c097ab7df2f7$var$hiddenKeys[$bff1c097ab7df2f7$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $bff1c097ab7df2f7$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $bff1c097ab7df2f7$var$EmptyConstructor[$bff1c097ab7df2f7$var$PROTOTYPE] = $bff1c097ab7df2f7$var$anObject(O);
        result = new $bff1c097ab7df2f7$var$EmptyConstructor();
        $bff1c097ab7df2f7$var$EmptyConstructor[$bff1c097ab7df2f7$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$bff1c097ab7df2f7$var$IE_PROTO] = O;
    } else result = $bff1c097ab7df2f7$var$NullProtoObject();
    return Properties === undefined ? result : $bff1c097ab7df2f7$var$definePropertiesModule.f(result, Properties);
};
var $bff1c097ab7df2f7$var$wellKnownSymbol = $bff1c097ab7df2f7$var$wellKnownSymbol$5;
var $bff1c097ab7df2f7$var$create = $bff1c097ab7df2f7$var$objectCreate;
var $bff1c097ab7df2f7$var$defineProperty = $bff1c097ab7df2f7$var$objectDefineProperty.f;
var $bff1c097ab7df2f7$var$UNSCOPABLES = $bff1c097ab7df2f7$var$wellKnownSymbol("unscopables");
var $bff1c097ab7df2f7$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($bff1c097ab7df2f7$var$ArrayPrototype[$bff1c097ab7df2f7$var$UNSCOPABLES] == undefined) $bff1c097ab7df2f7$var$defineProperty($bff1c097ab7df2f7$var$ArrayPrototype, $bff1c097ab7df2f7$var$UNSCOPABLES, {
    configurable: true,
    value: $bff1c097ab7df2f7$var$create(null)
});
// add a key to Array.prototype[@@unscopables]
var $bff1c097ab7df2f7$var$addToUnscopables$1 = function addToUnscopables$1(key) {
    $bff1c097ab7df2f7$var$ArrayPrototype[$bff1c097ab7df2f7$var$UNSCOPABLES][key] = true;
};
var $bff1c097ab7df2f7$var$$ = $bff1c097ab7df2f7$var$_export;
var $bff1c097ab7df2f7$var$$find = $bff1c097ab7df2f7$var$arrayIteration.find;
var $bff1c097ab7df2f7$var$addToUnscopables = $bff1c097ab7df2f7$var$addToUnscopables$1;
var $bff1c097ab7df2f7$var$FIND = "find";
var $bff1c097ab7df2f7$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($bff1c097ab7df2f7$var$FIND in []) Array(1)[$bff1c097ab7df2f7$var$FIND](function() {
    $bff1c097ab7df2f7$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$bff1c097ab7df2f7$var$$({
    target: "Array",
    proto: true,
    forced: $bff1c097ab7df2f7$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $bff1c097ab7df2f7$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$bff1c097ab7df2f7$var$addToUnscopables($bff1c097ab7df2f7$var$FIND);
var $bff1c097ab7df2f7$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $bff1c097ab7df2f7$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $bff1c097ab7df2f7$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $bff1c097ab7df2f7$var$dispatchGlobalEvent($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $bff1c097ab7df2f7$var$dispatchGlobalEvent($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $bff1c097ab7df2f7$var$dispatchGlobalEvent($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $bff1c097ab7df2f7$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($bff1c097ab7df2f7$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $bff1c097ab7df2f7$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var _$isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!_$isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $bff1c097ab7df2f7$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $bff1c097ab7df2f7$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $bff1c097ab7df2f7$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $bff1c097ab7df2f7$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $bff1c097ab7df2f7$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $bff1c097ab7df2f7$var$customListeners.get(ele, event));
            var customListener = $bff1c097ab7df2f7$var$checkStatus.bind(_this, dataEventOff);
            $bff1c097ab7df2f7$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $bff1c097ab7df2f7$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $bff1c097ab7df2f7$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $bff1c097ab7df2f7$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $bff1c097ab7df2f7$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $bff1c097ab7df2f7$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, _$customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute("data-tip") || null;
        forId = target.getAttribute("data-for") || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !_$customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $bff1c097ab7df2f7$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $bff1c097ab7df2f7$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $bff1c097ab7df2f7$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $bff1c097ab7df2f7$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $bff1c097ab7df2f7$var$getBody();
        var customEvents = $bff1c097ab7df2f7$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $bff1c097ab7df2f7$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $bff1c097ab7df2f7$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $bff1c097ab7df2f7$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $bff1c097ab7df2f7$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $bff1c097ab7df2f7$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $bff1c097ab7df2f7$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $bff1c097ab7df2f7$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $bff1c097ab7df2f7$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $bff1c097ab7df2f7$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $bff1c097ab7df2f7$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $bff1c097ab7df2f7$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $bff1c097ab7df2f7$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var choose = function choose() {
        var allPlaces = desiredPlace.split(",").concat(place, [
            "top",
            "bottom",
            "left",
            "right"
        ]);
        var _iterator = $bff1c097ab7df2f7$var$_createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    };
    var _getDimensions = $bff1c097ab7df2f7$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $bff1c097ab7df2f7$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $bff1c097ab7df2f7$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $bff1c097ab7df2f7$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $bff1c097ab7df2f7$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $bff1c097ab7df2f7$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside("top"),
        bottom: inside("bottom"),
        left: inside("left"),
        right: inside("right")
    };
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $bff1c097ab7df2f7$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var $bff1c097ab7df2f7$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $bff1c097ab7df2f7$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $bff1c097ab7df2f7$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var $bff1c097ab7df2f7$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffsetY -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffsetY += parseInt(offset[key], 10);
        else if (key === "left") extraOffsetX -= parseInt(offset[key], 10);
        else if (key === "right") extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var $bff1c097ab7df2f7$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $bff1c097ab7df2f7$var$TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $bff1c097ab7df2f7$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $bff1c097ab7df2f7$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $bff1c097ab7df2f7$var$generateUUID() {
    return "t" + (0, $a28248ee3b86d467$export$2e2bcd8739ae039)();
}
var $bff1c097ab7df2f7$var$baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
/**
 * Default pop-up style values (text color, background color).
 */ var $bff1c097ab7df2f7$var$defaultColors = {
    dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
    },
    success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
    },
    warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
    },
    error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
    },
    info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
    },
    light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
    }
};
function $bff1c097ab7df2f7$var$getDefaultPopupColors(type) {
    return $bff1c097ab7df2f7$var$defaultColors[type] ? $bff1c097ab7df2f7$var$_objectSpread2({}, $bff1c097ab7df2f7$var$defaultColors[type]) : undefined;
}
var $bff1c097ab7df2f7$var$DEFAULT_PADDING = "8px 21px";
var $bff1c097ab7df2f7$var$DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function $bff1c097ab7df2f7$var$generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return $bff1c097ab7df2f7$var$generateStyle(uuid, $bff1c097ab7df2f7$var$getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $bff1c097ab7df2f7$var$generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $bff1c097ab7df2f7$var$DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $bff1c097ab7df2f7$var$DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n	    border-radius: ").concat(tooltipRadius, "px;\n	    padding: ").concat(padding, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(uuid, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(uuid, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function $bff1c097ab7df2f7$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $bff1c097ab7df2f7$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === "light" ? "black" : "white";
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $bff1c097ab7df2f7$var$_class, $bff1c097ab7df2f7$var$_class2;
/* Polyfill */ var $bff1c097ab7df2f7$export$2e2bcd8739ae039 = $bff1c097ab7df2f7$var$staticMethods($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$windowListener($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$customEvent($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$isCapture($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$getEffect($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$bodyMode($bff1c097ab7df2f7$var$_class = $bff1c097ab7df2f7$var$trackRemoval($bff1c097ab7df2f7$var$_class = ($bff1c097ab7df2f7$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $bff1c097ab7df2f7$var$_inherits(ReactTooltip, _React$Component);
    var _super = $bff1c097ab7df2f7$var$_createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        $bff1c097ab7df2f7$var$_classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || $bff1c097ab7df2f7$var$generateUUID(),
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: props.type || "dark",
            // Color theme of tooltip
            effect: props.effect || "float",
            // float or fixed
            show: false,
            border: false,
            borderClass: "border",
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $bff1c097ab7df2f7$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $bff1c097ab7df2f7$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case "Document":
                    case "HTMLDocument":
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case "ShadowRoot":
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector("style[data-react-tooltip]")) {
                    var style = document.createElement("style");
                    style.textContent = $bff1c097ab7df2f7$var$baseCss;
                    style.setAttribute("data-react-tooltip", "true");
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = "[data-tip]:not([data-for])";
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                }
                // Scan document for shadow DOM elements
                $bff1c097ab7df2f7$var$nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($bff1c097ab7df2f7$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($bff1c097ab7df2f7$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, _$isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                    target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, _$isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $bff1c097ab7df2f7$var$TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $bff1c097ab7df2f7$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(",")[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(",")[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var _$self = this;
                var updateState = function updateState() {
                    _$self.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || _$self.props.type || "dark",
                        customColors: {
                            text: target.getAttribute("data-text-color") || _$self.props.textColor || null,
                            background: target.getAttribute("data-background-color") || _$self.props.backgroundColor || null,
                            border: target.getAttribute("data-border-color") || _$self.props.borderColor || null,
                            arrow: target.getAttribute("data-arrow-color") || _$self.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute("data-tooltip-radius") || _$self.props.tooltipRadius || "3",
                            arrow: target.getAttribute("data-arrow-radius") || _$self.props.arrowRadius || "0"
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute("data-padding") || _$self.props.padding,
                        html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : _$self.props.html) || false,
                        delayShow: target.getAttribute("data-delay-show") || _$self.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || _$self.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || _$self.props.delayUpdate || 0,
                        border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : _$self.props.border) || false,
                        borderClass: target.getAttribute("data-border-class") || _$self.props.borderClass || "border",
                        extraClass: target.getAttribute("data-class") || _$self.props["class"] || _$self.props.className || "",
                        disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : _$self.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) _$self.addScrollListener(_$self.state.currentTarget);
                        _$self.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) _$self.intervalUpdateContent = setInterval(function() {
                            if (_$self.mount) {
                                var _getContent = _$self.props.getContent;
                                var placeholder = $bff1c097ab7df2f7$var$TipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = _$self.isEmptyTip(placeholder);
                                _$self.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                _$self.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute("aria-describedby");
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $bff1c097ab7df2f7$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === "function") callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== "border" && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors["border"]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? "" : $bff1c097ab7df2f7$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? '\n<style aria-hidden="true">'.concat(style, "</style>") : "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Wrapper, $bff1c097ab7df2f7$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(Wrapper, $bff1c097ab7df2f7$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).object,
                    padding: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    borderClass: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    arrowRadius: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    tooltipRadius: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool,
                    disableInternalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $bff1c097ab7df2f7$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $bff1c097ab7df2f7$var$_objectSpread2($bff1c097ab7df2f7$var$_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Component), $bff1c097ab7df2f7$var$_defineProperty($bff1c097ab7df2f7$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $bff1c097ab7df2f7$var$_defineProperty($bff1c097ab7df2f7$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $bff1c097ab7df2f7$var$_defineProperty($bff1c097ab7df2f7$var$_class2, "displayName", "ReactTooltip"), $bff1c097ab7df2f7$var$_class2)) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class) || $bff1c097ab7df2f7$var$_class;



var $69e9a63831f23aaa$var$_this = undefined;
var $69e9a63831f23aaa$var$TestPage = function() {
    var directorState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $f487fa6abc092388$export$86d1cded24611cb8));
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var formRef;
    (0, $4CEbD.useEffect)((0, $1dc662ec593f833a$export$dad4a579cd5614b0)(directorState, history), [
        directorState
    ]);
    (0, $4CEbD.useEffect)(function() {
        if (directorState === null || directorState === void 0 ? void 0 : directorState.sessionId) $84ae43476eb4deb8$export$b96b69e966de3651(directorState.sessionId).then(function(res) {
            if ((res === null || res === void 0 ? void 0 : res.error.includes("Can't find the session.")) || (res === null || res === void 0 ? void 0 : res.error.includes("Die Session wurde nicht gefunden."))) {
                dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
                history.push((0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d));
            }
        }).catch(function(err) {
            if ((err === null || err === void 0 ? void 0 : err.error.includes("Can't find the session.")) || (err === null || err === void 0 ? void 0 : err.error.includes("Die Session wurde nicht gefunden."))) {
                dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
                history.push((0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d));
            }
        });
    }, []);
    (0, $4CEbD.useEffect)(function() {
        (0, $bff1c097ab7df2f7$export$2e2bcd8739ae039).rebuild();
        document.body.classList.add("layout--test", "test--in");
        return function() {
            document.body.classList.remove("layout--test", "test--in");
        };
    }, []);
    var onSubmitSuccess = function(res) {
        //log.info("TestPage", "cbBackward", res.error, res);
        dispatch((0, $f487fa6abc092388$export$e16717ba5a5dc549)({
            section: res
        }));
    };
    var onSubmitFailure = function(res) {
        dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
            text: t(res.error),
            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    var cbForeward = function(model) {
        //log.info("x001 TestPage", "cbForeward", directorState.submitting, model);
        if (directorState.submitting) //console.log("x001 cbForeward submitting");
        return;
        var res = $84ae43476eb4deb8$export$6c33279ba320b667(directorState.sessionId, model);
        res.then(onSubmitSuccess, onSubmitFailure);
        return res;
    };
    var cbBackward = function() {
        var _ref = (0, $em5FP._)(function(model) {
            var res;
            return (0, $nLPsB.__generator)(this, function(_state) {
                //log.info("x001 TestPage", "cbBackward", directorState.submitting, model);
                if (directorState.submitting) //console.log("x001 cbBackward submitting");
                return [
                    2
                ];
                res = $84ae43476eb4deb8$export$d9c45e29a4259227(directorState.sessionId, model);
                res.then(onSubmitSuccess, onSubmitFailure);
                return [
                    2,
                    res
                ];
            });
        });
        return function cbBackward(model) {
            return _ref.apply(this, arguments);
        };
    }();
    var nextSection = function() {
        var _ref = (0, $em5FP._)(function(model) {
            return (0, $nLPsB.__generator)(this, function(_state) {
                if (directorState.submitting) //console.log("x001 nextSection submitting");
                return [
                    2
                ];
                dispatch((0, $817d712521df1056$export$923d3332dd605124)({
                    content: "NextSection",
                    model: model
                }));
                return [
                    2
                ];
            });
        });
        return function nextSection(model) {
            return _ref.apply(this, arguments);
        };
    }();
    // const finishTest = async (model) => {
    //     if (directorState.submitting) {
    //         //console.log("x001 nextSection submitting");
    //         //return;
    //     }
    //     const res = ioCalls.submitAnswers(directorState.sessionId, model);
    //     const succF = (res) => {
    //         if (!res.error) {
    //             history.push(testResultUrl);
    //         } else dispatch(addItem({ text: t(res.error), type: MESSAGE_TYPE.ERROR, props: {} }));
    //     };
    //     res.then(succF, onSubmitFailure);
    //     return res;
    // };
    var onClickCard = function(selectedCardIndex) {
        //console.log("xxx", directorState.currentGroupNo, selectedCardIndex);
        if (directorState.currentGroupNo - 1 > selectedCardIndex) cbBackward();
        if (directorState.currentGroupNo - 1 < selectedCardIndex) cbForeward();
    };
    var getForm = function(uniformSchema) {
        var nextSectionCaption = t("testPage.nextSectionButton.caption");
        var nextSectionInfo = t("testPage.answeredAllQuestions.text");
        // meta section
        if (directorState.currentSectionNo === 1) {
            nextSectionCaption = t("testPage.meta.nextSectionButton.caption");
            nextSectionInfo = t("testPage.answeredAllQuestionsMeta.text");
        }
        var showFinishTestButton = directorState.currentSectionNo === directorState.noOfSections;
        var introElement = null;
        if (directorState.description) introElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__intro"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "qanda__intro__text"
        }, directorState.description));
        //console.log("getForm /showFinishTestButton / directorState.readyForNextSection yyy01", showFinishTestButton, directorState.readyForNextSection);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, directorState.noOfGroups > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $b01a81f807cafe49$export$2e2bcd8739ae039), {
            noOfGroups: directorState.noOfGroups,
            currentGroupNo: directorState.currentGroupNo,
            answeredGroups: directorState.answeredGroups
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $79fba9cf15c0fe25$export$2e2bcd8739ae039), {
            className: "",
            schema: uniformSchema,
            placeholder: true,
            //onSubmit={handleSubmit}
            validate: "onChange",
            //onChangeModel={model => setCurrentLayer(() => model.backgroundLayer)}
            ref: function(ref) {
                return formRef = ref;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__cards",
            key: "cards"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__cards-holder is-multiple is-active-card-id-" + (directorState.currentGroupNo - 1)
        }, (0, $h9dQc._)(Array(directorState.noOfGroups)).map(function(x, i) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
                key: "card-" + i,
                onClick: onClickCard.bind($69e9a63831f23aaa$var$_this, i),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("card-id-" + i, "qanda__card", {
                    "qanda__card--test": directorState.currentSectionNo !== 1
                }, {
                    "qanda__card--meta": directorState.currentSectionNo === 1
                }, "qanda__card--active")
            }, introElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
                className: "qanda__forms"
            }, i === directorState.currentGroupNo - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $1f86e799894f6ddc$export$2e2bcd8739ae039), {
                element: "span"
            })));
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__controls",
            key: "controls"
        }, directorState.noOfGroups !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__backforward",
            key: "foreward"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c5b6f89dc833d43$exports.default), {
            cb: cbBackward,
            dir: "before",
            formRef: formRef,
            classes: [
                "button--direction-left",
                "qanda__back",
                "qanda__back--active",
                directorState.currentGroupNo > 1 ? "" : "qanda__back--invisible"
            ],
            iconClasses: [
                "licon-caret-left"
            ],
            caption: t("testPage.prevButton.caption")
        }), directorState.noOfGroups !== directorState.currentGroupNo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c5b6f89dc833d43$exports.default), {
            cb: cbForeward,
            dir: "after",
            formRef: formRef,
            classes: [
                "button--direction-right",
                "is-primary",
                "qanda__forward",
                "qanda__forward--active",
                directorState.currentGroupNo < directorState.noOfGroups ? "" : "qanda__forward--invisible"
            ],
            iconClasses: [
                "licon-caret-right"
            ],
            caption: t("testPage.nextButton.caption")
        })), directorState.readyForNextSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__complete"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "little-info"
        }, nextSectionInfo), directorState.currentSectionNo !== 1 && !showFinishTestButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c5b6f89dc833d43$exports.default), {
            cb: nextSection,
            dir: "after",
            formRef: formRef,
            classes: [
                "button--direction-down",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-down"
            ],
            caption: nextSectionCaption
        }), directorState.currentSectionNo !== 1 && showFinishTestButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c5b6f89dc833d43$exports.default), {
            cb: nextSection,
            formRef: formRef,
            dir: "after",
            classes: [
                "button--direction-right",
                "is-rounded",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-right"
            ],
            caption: t("testPage.finishTestButton.caption")
        }), directorState.currentSectionNo === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $2c5b6f89dc833d43$exports.default), {
            cb: nextSection,
            formRef: formRef,
            dir: "after",
            classes: [
                "button--direction-down",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-down"
            ],
            caption: nextSectionCaption
        })))));
    };
    // const copySessionID = () => {
    //     copyToClipboard(directorState.sessionId);
    //     dispatch(addItem({ text: t("testPage.session-Code.copied"), type: MESSAGE_TYPE.INFO, props: {} }));
    // };
    var getIntro = function() {
        var inForm = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, noIcon = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var intro = [];
        var introText = t("testPage.default.section.intro");
        var className = "qanda__card--test";
        // eslint-disable-next-line react/jsx-key
        var iconElement = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
                key: "icon-info",
                className: "icon licon-info is-info"
            })
        ];
        if (directorState.currentSectionNo === 1) {
            introText = t("testPage.meta.section.intro");
            className = "qanda__card--meta";
            iconElement = [];
        }
        intro.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__intro",
            key: "intro"
        }, !noIcon && iconElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "qanda__intro__text is-info"
        }, introText)));
        if (inForm) return intro;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__cards"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__cards-holder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("qanda__card", "qanda__card--active", className)
        }, intro)));
    };
    var triggerRead = function() {
        //console.log("triggerRead");
        dispatch((0, $f487fa6abc092388$export$e7257833db56af08)({}));
        (0, $11c013bdbcf83901$export$169439c91a279f79)("story__top");
    };
    var getTestForm = function(jsonSchema) {
        var uniformSchema = (0, $d9b01d9d667dbe48$export$af88179f1a6b6206)(jsonSchema);
        //log.info("TestPage", "getTestForm", jsonSchema, uniformSchema);
        //console.log("getTestForm yyy01");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "layout__left"
        }, !directorState.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "metabg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: "icon-bird",
            className: "icon licon-bird metabg__icon"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: "text",
            className: "metabg__text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", null, "zwitscher"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", null, "zwitscher"))), directorState.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "story"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $d30e23ef1cc305a9$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
            id: "story__top"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "story__header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("h2", {
            className: "story__title"
        }, directorState.title), directorState.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "little-info"
        }, directorState.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "story__text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            dangerouslySetInnerHTML: {
                __html: directorState.text
            }
        })), !directorState.textRaed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("story__complete", {
                "story__complete--invisible": directorState.textRaed
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "little-info"
        }, t("testPage.textRaedButton.info"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: "trigger",
            className: "helper-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("a", {
            onClick: function() {
                dispatch((0, $817d712521df1056$export$923d3332dd605124)({
                    content: "Help"
                }));
            },
            className: "icon licon-info is-info",
            title: "Tooltipp und/oder Modal"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("button", {
            onClick: triggerRead,
            className: "button button--direction-right is-rounded is-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: "text",
            className: "button__text"
        }, t("testPage.textRaedButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            key: "icon",
            className: "icon licon-arrow-circle-right"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "layout__right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
            className: "qanda__header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
            className: "qanda__header__item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("span", {
            className: "qanda__header--title"
        }, "Test-Code: ", directorState.sessionId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $6f74f1bddb655035$export$2e2bcd8739ae039), {
            noOfSections: directorState.noOfSections + 1,
            currentSectionNo: directorState.currentSectionNo
        }), directorState.textRaed && uniformSchema && getForm(uniformSchema), !directorState.textRaed && getIntro(false, true)))));
    };
    //log.info("TestPage", directorState.jsonSchema);
    //console.log("render yyy01");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, directorState.jsonSchema && getTestForm(directorState.jsonSchema));
};
var $69e9a63831f23aaa$export$2e2bcd8739ae039 = $69e9a63831f23aaa$var$TestPage;



var $em5FP = parcelRequire("em5FP");

var $nLPsB = parcelRequire("nLPsB");


var $e816e75411cf0909$exports = {};
"use strict";
Object.defineProperty($e816e75411cf0909$exports, "__esModule", {
    value: true
});
function $e816e75411cf0909$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $4CEbD = parcelRequire("4CEbD");
var $e816e75411cf0909$var$React__default = $e816e75411cf0909$var$_interopDefault($4CEbD);

var $asuNP = parcelRequire("asuNP");
var $e816e75411cf0909$var$ClientUAInstance = new $asuNP();
var $e816e75411cf0909$var$browser = $e816e75411cf0909$var$ClientUAInstance.getBrowser();
var $e816e75411cf0909$var$cpu = $e816e75411cf0909$var$ClientUAInstance.getCPU();
var $e816e75411cf0909$var$device = $e816e75411cf0909$var$ClientUAInstance.getDevice();
var $e816e75411cf0909$var$engine = $e816e75411cf0909$var$ClientUAInstance.getEngine();
var $e816e75411cf0909$var$os = $e816e75411cf0909$var$ClientUAInstance.getOS();
var $e816e75411cf0909$var$ua = $e816e75411cf0909$var$ClientUAInstance.getUA();
var $e816e75411cf0909$var$setUa = function setUa(userAgentString) {
    return $e816e75411cf0909$var$ClientUAInstance.setUA(userAgentString);
};
var $e816e75411cf0909$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $asuNP(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $e816e75411cf0909$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $e816e75411cf0909$var$ClientUAInstance,
    browser: $e816e75411cf0909$var$browser,
    cpu: $e816e75411cf0909$var$cpu,
    device: $e816e75411cf0909$var$device,
    engine: $e816e75411cf0909$var$engine,
    os: $e816e75411cf0909$var$os,
    ua: $e816e75411cf0909$var$ua,
    setUa: $e816e75411cf0909$var$setUa,
    parseUserAgent: $e816e75411cf0909$var$parseUserAgent
});
function $e816e75411cf0909$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e816e75411cf0909$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e816e75411cf0909$var$ownKeys(Object(source), true).forEach(function(key) {
            $e816e75411cf0909$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e816e75411cf0909$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e816e75411cf0909$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e816e75411cf0909$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e816e75411cf0909$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e816e75411cf0909$var$_typeof(obj);
}
function $e816e75411cf0909$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e816e75411cf0909$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e816e75411cf0909$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e816e75411cf0909$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e816e75411cf0909$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e816e75411cf0909$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e816e75411cf0909$var$_extends() {
    $e816e75411cf0909$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e816e75411cf0909$var$_extends.apply(this, arguments);
}
function $e816e75411cf0909$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e816e75411cf0909$var$_setPrototypeOf(subClass, superClass);
}
function $e816e75411cf0909$var$_getPrototypeOf(o) {
    $e816e75411cf0909$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e816e75411cf0909$var$_getPrototypeOf(o);
}
function $e816e75411cf0909$var$_setPrototypeOf(o, p) {
    $e816e75411cf0909$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e816e75411cf0909$var$_setPrototypeOf(o, p);
}
function $e816e75411cf0909$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e816e75411cf0909$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e816e75411cf0909$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e816e75411cf0909$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e816e75411cf0909$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e816e75411cf0909$var$_assertThisInitialized(self);
}
function $e816e75411cf0909$var$_slicedToArray(arr, i) {
    return $e816e75411cf0909$var$_arrayWithHoles(arr) || $e816e75411cf0909$var$_iterableToArrayLimit(arr, i) || $e816e75411cf0909$var$_unsupportedIterableToArray(arr, i) || $e816e75411cf0909$var$_nonIterableRest();
}
function $e816e75411cf0909$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e816e75411cf0909$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e816e75411cf0909$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e816e75411cf0909$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e816e75411cf0909$var$_arrayLikeToArray(o, minLen);
}
function $e816e75411cf0909$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e816e75411cf0909$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e816e75411cf0909$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $e816e75411cf0909$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $e816e75411cf0909$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $e816e75411cf0909$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $e816e75411cf0909$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $e816e75411cf0909$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $e816e75411cf0909$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $e816e75411cf0909$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $e816e75411cf0909$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $e816e75411cf0909$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $e816e75411cf0909$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $e816e75411cf0909$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $e816e75411cf0909$var$InitialDeviceTypes;
    }
};
var $e816e75411cf0909$var$setUserAgent = function setUserAgent(userAgent) {
    return $e816e75411cf0909$var$setUa(userAgent);
};
var $e816e75411cf0909$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $e816e75411cf0909$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $e816e75411cf0909$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $e816e75411cf0909$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $e816e75411cf0909$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $e816e75411cf0909$var$setDefaults(browser.major),
        browserFullVersion: $e816e75411cf0909$var$setDefaults(browser.version),
        browserName: $e816e75411cf0909$var$setDefaults(browser.name),
        engineName: $e816e75411cf0909$var$setDefaults(engine.name),
        engineVersion: $e816e75411cf0909$var$setDefaults(engine.version),
        osName: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        userAgent: $e816e75411cf0909$var$setDefaults(ua)
    };
};
var $e816e75411cf0909$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $e816e75411cf0909$var$_objectSpread2({}, type, {
        vendor: $e816e75411cf0909$var$setDefaults(device.vendor),
        model: $e816e75411cf0909$var$setDefaults(device.model),
        os: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        ua: $e816e75411cf0909$var$setDefaults(ua)
    });
};
var $e816e75411cf0909$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $e816e75411cf0909$var$setDefaults(engine.name),
        engineVersion: $e816e75411cf0909$var$setDefaults(engine.version),
        osName: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        userAgent: $e816e75411cf0909$var$setDefaults(ua)
    };
};
var $e816e75411cf0909$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $e816e75411cf0909$var$setDefaults(engine.name),
        engineVersion: $e816e75411cf0909$var$setDefaults(engine.version),
        osName: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        userAgent: $e816e75411cf0909$var$setDefaults(ua)
    };
};
var $e816e75411cf0909$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $e816e75411cf0909$var$setDefaults(engine.name),
        engineVersion: $e816e75411cf0909$var$setDefaults(engine.version),
        osName: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        userAgent: $e816e75411cf0909$var$setDefaults(ua)
    };
};
var $e816e75411cf0909$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $e816e75411cf0909$var$setDefaults(device.vendor),
        model: $e816e75411cf0909$var$setDefaults(device.model),
        engineName: $e816e75411cf0909$var$setDefaults(engine.name),
        engineVersion: $e816e75411cf0909$var$setDefaults(engine.version),
        osName: $e816e75411cf0909$var$setDefaults(os.name),
        osVersion: $e816e75411cf0909$var$setDefaults(os.version),
        userAgent: $e816e75411cf0909$var$setDefaults(ua)
    };
};
function $e816e75411cf0909$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $e816e75411cf0909$var$parseUserAgent(userAgent) : $e816e75411cf0909$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $e816e75411cf0909$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $e816e75411cf0909$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $e816e75411cf0909$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $e816e75411cf0909$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $e816e75411cf0909$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $e816e75411cf0909$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $e816e75411cf0909$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $e816e75411cf0909$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $e816e75411cf0909$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Mobile;
};
var $e816e75411cf0909$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Tablet;
};
var $e816e75411cf0909$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Mobile || type === $e816e75411cf0909$var$DeviceTypes.Tablet;
};
var $e816e75411cf0909$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $e816e75411cf0909$var$DeviceTypes.SmartTv;
};
var $e816e75411cf0909$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Browser;
};
var $e816e75411cf0909$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Wearable;
};
var $e816e75411cf0909$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Console;
};
var $e816e75411cf0909$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $e816e75411cf0909$var$DeviceTypes.Embedded;
};
var $e816e75411cf0909$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $e816e75411cf0909$var$setDefaults(vendor);
};
var $e816e75411cf0909$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $e816e75411cf0909$var$setDefaults(model);
};
var $e816e75411cf0909$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $e816e75411cf0909$var$setDefaults(type, "browser");
}; // os types
var $e816e75411cf0909$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $e816e75411cf0909$var$OsTypes.Android;
};
var $e816e75411cf0909$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $e816e75411cf0909$var$OsTypes.Windows;
};
var $e816e75411cf0909$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $e816e75411cf0909$var$OsTypes.MAC_OS;
};
var $e816e75411cf0909$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $e816e75411cf0909$var$OsTypes.WindowsPhone;
};
var $e816e75411cf0909$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $e816e75411cf0909$var$OsTypes.IOS;
};
var $e816e75411cf0909$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $e816e75411cf0909$var$setDefaults(version);
};
var $e816e75411cf0909$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $e816e75411cf0909$var$setDefaults(name);
}; // browser types
var $e816e75411cf0909$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Chrome;
};
var $e816e75411cf0909$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Firefox;
};
var $e816e75411cf0909$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Chromium;
};
var $e816e75411cf0909$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Edge;
};
var $e816e75411cf0909$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Yandex;
};
var $e816e75411cf0909$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Safari || name === $e816e75411cf0909$var$BrowserTypes.MobileSafari;
};
var $e816e75411cf0909$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $e816e75411cf0909$var$BrowserTypes.MobileSafari;
};
var $e816e75411cf0909$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $e816e75411cf0909$var$BrowserTypes.Opera;
};
var $e816e75411cf0909$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $e816e75411cf0909$var$BrowserTypes.InternetExplorer || name === $e816e75411cf0909$var$BrowserTypes.Ie;
};
var $e816e75411cf0909$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $e816e75411cf0909$var$BrowserTypes.MIUI;
};
var $e816e75411cf0909$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $e816e75411cf0909$var$BrowserTypes.SamsungBrowser;
};
var $e816e75411cf0909$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $e816e75411cf0909$var$setDefaults(version);
};
var $e816e75411cf0909$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $e816e75411cf0909$var$setDefaults(major);
};
var $e816e75411cf0909$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $e816e75411cf0909$var$setDefaults(name);
}; // engine types
var $e816e75411cf0909$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $e816e75411cf0909$var$setDefaults(name);
};
var $e816e75411cf0909$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $e816e75411cf0909$var$setDefaults(version);
};
var $e816e75411cf0909$var$isElectronType = function isElectronType() {
    var nav = $e816e75411cf0909$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $e816e75411cf0909$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $e816e75411cf0909$var$getIOS13 = function getIOS13() {
    var nav = $e816e75411cf0909$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $e816e75411cf0909$var$getIPad13 = function getIPad13() {
    return $e816e75411cf0909$var$isIOS13Check("iPad");
};
var $e816e75411cf0909$var$getIphone13 = function getIphone13() {
    return $e816e75411cf0909$var$isIOS13Check("iPhone");
};
var $e816e75411cf0909$var$getIPod13 = function getIPod13() {
    return $e816e75411cf0909$var$isIOS13Check("iPod");
};
var $e816e75411cf0909$var$getUseragent = function getUseragent(userAg) {
    return $e816e75411cf0909$var$setDefaults(userAg);
};
function $e816e75411cf0909$var$buildSelectorsObject(options) {
    var _ref = options ? options : $e816e75411cf0909$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $e816e75411cf0909$var$isSmartTVType(device),
        isConsole: $e816e75411cf0909$var$isConsoleType(device),
        isWearable: $e816e75411cf0909$var$isWearableType(device),
        isEmbedded: $e816e75411cf0909$var$isEmbeddedType(device),
        isMobileSafari: $e816e75411cf0909$var$isMobileSafariType(browser) || $e816e75411cf0909$var$getIPad13(),
        isChromium: $e816e75411cf0909$var$isChromiumType(browser),
        isMobile: $e816e75411cf0909$var$isMobileAndTabletType(device) || $e816e75411cf0909$var$getIPad13(),
        isMobileOnly: $e816e75411cf0909$var$isMobileType(device),
        isTablet: $e816e75411cf0909$var$isTabletType(device) || $e816e75411cf0909$var$getIPad13(),
        isBrowser: $e816e75411cf0909$var$isBrowserType(device),
        isDesktop: $e816e75411cf0909$var$isBrowserType(device),
        isAndroid: $e816e75411cf0909$var$isAndroidType(os),
        isWinPhone: $e816e75411cf0909$var$isWinPhoneType(os),
        isIOS: $e816e75411cf0909$var$isIOSType(os) || $e816e75411cf0909$var$getIPad13(),
        isChrome: $e816e75411cf0909$var$isChromeType(browser),
        isFirefox: $e816e75411cf0909$var$isFirefoxType(browser),
        isSafari: $e816e75411cf0909$var$isSafariType(browser),
        isOpera: $e816e75411cf0909$var$isOperaType(browser),
        isIE: $e816e75411cf0909$var$isIEType(browser),
        osVersion: $e816e75411cf0909$var$getOsVersion(os),
        osName: $e816e75411cf0909$var$getOsName(os),
        fullBrowserVersion: $e816e75411cf0909$var$getBrowserFullVersion(browser),
        browserVersion: $e816e75411cf0909$var$getBrowserVersion(browser),
        browserName: $e816e75411cf0909$var$getBrowserName(browser),
        mobileVendor: $e816e75411cf0909$var$getMobileVendor(device),
        mobileModel: $e816e75411cf0909$var$getMobileModel(device),
        engineName: $e816e75411cf0909$var$getEngineName(engine),
        engineVersion: $e816e75411cf0909$var$getEngineVersion(engine),
        getUA: $e816e75411cf0909$var$getUseragent(ua),
        isEdge: $e816e75411cf0909$var$isEdgeType(browser) || $e816e75411cf0909$var$isEdgeChromiumType(ua),
        isYandex: $e816e75411cf0909$var$isYandexType(browser),
        deviceType: $e816e75411cf0909$var$getDeviceType(device),
        isIOS13: $e816e75411cf0909$var$getIOS13(),
        isIPad13: $e816e75411cf0909$var$getIPad13(),
        isIPhone13: $e816e75411cf0909$var$getIphone13(),
        isIPod13: $e816e75411cf0909$var$getIPod13(),
        isElectron: $e816e75411cf0909$var$isElectronType(),
        isEdgeChromium: $e816e75411cf0909$var$isEdgeChromiumType(ua),
        isLegacyEdge: $e816e75411cf0909$var$isEdgeType(browser) && !$e816e75411cf0909$var$isEdgeChromiumType(ua),
        isWindows: $e816e75411cf0909$var$isWindowsType(os),
        isMacOs: $e816e75411cf0909$var$isMacOsType(os),
        isMIUI: $e816e75411cf0909$var$isMIUIType(browser),
        isSamsungBrowser: $e816e75411cf0909$var$isSamsungBrowserType(browser)
    };
}
var $e816e75411cf0909$var$isSmartTV = $e816e75411cf0909$var$isSmartTVType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isConsole = $e816e75411cf0909$var$isConsoleType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isWearable = $e816e75411cf0909$var$isWearableType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isEmbedded = $e816e75411cf0909$var$isEmbeddedType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isMobileSafari = $e816e75411cf0909$var$isMobileSafariType($e816e75411cf0909$var$browser) || $e816e75411cf0909$var$getIPad13();
var $e816e75411cf0909$var$isChromium = $e816e75411cf0909$var$isChromiumType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isMobile = $e816e75411cf0909$var$isMobileAndTabletType($e816e75411cf0909$var$device) || $e816e75411cf0909$var$getIPad13();
var $e816e75411cf0909$var$isMobileOnly = $e816e75411cf0909$var$isMobileType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isTablet = $e816e75411cf0909$var$isTabletType($e816e75411cf0909$var$device) || $e816e75411cf0909$var$getIPad13();
var $e816e75411cf0909$var$isBrowser = $e816e75411cf0909$var$isBrowserType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isDesktop = $e816e75411cf0909$var$isBrowserType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isAndroid = $e816e75411cf0909$var$isAndroidType($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$isWinPhone = $e816e75411cf0909$var$isWinPhoneType($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$isIOS = $e816e75411cf0909$var$isIOSType($e816e75411cf0909$var$os) || $e816e75411cf0909$var$getIPad13();
var $e816e75411cf0909$var$isChrome = $e816e75411cf0909$var$isChromeType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isFirefox = $e816e75411cf0909$var$isFirefoxType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isSafari = $e816e75411cf0909$var$isSafariType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isOpera = $e816e75411cf0909$var$isOperaType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isIE = $e816e75411cf0909$var$isIEType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$osVersion = $e816e75411cf0909$var$getOsVersion($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$osName = $e816e75411cf0909$var$getOsName($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$fullBrowserVersion = $e816e75411cf0909$var$getBrowserFullVersion($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$browserVersion = $e816e75411cf0909$var$getBrowserVersion($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$browserName = $e816e75411cf0909$var$getBrowserName($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$mobileVendor = $e816e75411cf0909$var$getMobileVendor($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$mobileModel = $e816e75411cf0909$var$getMobileModel($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$engineName = $e816e75411cf0909$var$getEngineName($e816e75411cf0909$var$engine);
var $e816e75411cf0909$var$engineVersion = $e816e75411cf0909$var$getEngineVersion($e816e75411cf0909$var$engine);
var $e816e75411cf0909$var$getUA = $e816e75411cf0909$var$getUseragent($e816e75411cf0909$var$ua);
var $e816e75411cf0909$var$isEdge = $e816e75411cf0909$var$isEdgeType($e816e75411cf0909$var$browser) || $e816e75411cf0909$var$isEdgeChromiumType($e816e75411cf0909$var$ua);
var $e816e75411cf0909$var$isYandex = $e816e75411cf0909$var$isYandexType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$deviceType = $e816e75411cf0909$var$getDeviceType($e816e75411cf0909$var$device);
var $e816e75411cf0909$var$isIOS13 = $e816e75411cf0909$var$getIOS13();
var $e816e75411cf0909$var$isIPad13 = $e816e75411cf0909$var$getIPad13();
var $e816e75411cf0909$var$isIPhone13 = $e816e75411cf0909$var$getIphone13();
var $e816e75411cf0909$var$isIPod13 = $e816e75411cf0909$var$getIPod13();
var $e816e75411cf0909$var$isElectron = $e816e75411cf0909$var$isElectronType();
var $e816e75411cf0909$var$isEdgeChromium = $e816e75411cf0909$var$isEdgeChromiumType($e816e75411cf0909$var$ua);
var $e816e75411cf0909$var$isLegacyEdge = $e816e75411cf0909$var$isEdgeType($e816e75411cf0909$var$browser) && !$e816e75411cf0909$var$isEdgeChromiumType($e816e75411cf0909$var$ua);
var $e816e75411cf0909$var$isWindows = $e816e75411cf0909$var$isWindowsType($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$isMacOs = $e816e75411cf0909$var$isMacOsType($e816e75411cf0909$var$os);
var $e816e75411cf0909$var$isMIUI = $e816e75411cf0909$var$isMIUIType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$isSamsungBrowser = $e816e75411cf0909$var$isSamsungBrowserType($e816e75411cf0909$var$browser);
var $e816e75411cf0909$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $e816e75411cf0909$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $e816e75411cf0909$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $e816e75411cf0909$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isAndroid ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isBrowser ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isIE ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isIOS ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isMobile ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isTablet ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isWinPhone ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $e816e75411cf0909$var$isMobileOnly ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isSmartTV ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isConsole ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $e816e75411cf0909$var$isWearable ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
var $e816e75411cf0909$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $e816e75411cf0909$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $e816e75411cf0909$var$React__default.createElement($4CEbD.Fragment, null, children) : $e816e75411cf0909$var$React__default.createElement("div", props, children) : null;
};
function $e816e75411cf0909$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $e816e75411cf0909$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $e816e75411cf0909$var$_classCallCheck(this, _class);
            _this = $e816e75411cf0909$var$_possibleConstructorReturn(this, $e816e75411cf0909$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($e816e75411cf0909$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($e816e75411cf0909$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($e816e75411cf0909$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $e816e75411cf0909$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $e816e75411cf0909$var$_typeof(window)) !== undefined && $e816e75411cf0909$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $e816e75411cf0909$var$React__default.createElement(WrappedComponent, $e816e75411cf0909$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($e816e75411cf0909$var$React__default.Component);
}
function $e816e75411cf0909$var$useMobileOrientation() {
    var _useState = $4CEbD.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $e816e75411cf0909$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $4CEbD.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $4CEbD.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $e816e75411cf0909$var$_typeof(window)) !== undefined && $e816e75411cf0909$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $e816e75411cf0909$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $e816e75411cf0909$var$parseUserAgent(hookUserAgent);
}
function $e816e75411cf0909$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $e816e75411cf0909$var$useDeviceData(hookUserAgent);
    var selectors = $e816e75411cf0909$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$e816e75411cf0909$exports.AndroidView = $e816e75411cf0909$var$AndroidView;
$e816e75411cf0909$exports.BrowserTypes = $e816e75411cf0909$var$BrowserTypes;
$e816e75411cf0909$exports.BrowserView = $e816e75411cf0909$var$BrowserView;
$e816e75411cf0909$exports.ConsoleView = $e816e75411cf0909$var$ConsoleView;
$e816e75411cf0909$exports.CustomView = $e816e75411cf0909$var$CustomView;
$e816e75411cf0909$exports.IEView = $e816e75411cf0909$var$IEView;
$e816e75411cf0909$exports.IOSView = $e816e75411cf0909$var$IOSView;
$e816e75411cf0909$exports.MobileOnlyView = $e816e75411cf0909$var$MobileOnlyView;
$e816e75411cf0909$exports.MobileView = $e816e75411cf0909$var$MobileView;
$e816e75411cf0909$exports.OsTypes = $e816e75411cf0909$var$OsTypes;
$e816e75411cf0909$exports.SmartTVView = $e816e75411cf0909$var$SmartTVView;
$e816e75411cf0909$exports.TabletView = $e816e75411cf0909$var$TabletView;
$e816e75411cf0909$exports.WearableView = $e816e75411cf0909$var$WearableView;
$e816e75411cf0909$exports.WinPhoneView = $e816e75411cf0909$var$WinPhoneView;
$e816e75411cf0909$exports.browserName = $e816e75411cf0909$var$browserName;
$e816e75411cf0909$exports.browserVersion = $e816e75411cf0909$var$browserVersion;
$e816e75411cf0909$exports.deviceDetect = $e816e75411cf0909$var$deviceDetect;
$e816e75411cf0909$exports.deviceType = $e816e75411cf0909$var$deviceType;
$e816e75411cf0909$exports.engineName = $e816e75411cf0909$var$engineName;
$e816e75411cf0909$exports.engineVersion = $e816e75411cf0909$var$engineVersion;
$e816e75411cf0909$exports.fullBrowserVersion = $e816e75411cf0909$var$fullBrowserVersion;
$e816e75411cf0909$exports.getSelectorsByUserAgent = $e816e75411cf0909$var$getSelectorsByUserAgent;
$e816e75411cf0909$exports.getUA = $e816e75411cf0909$var$getUA;
$e816e75411cf0909$exports.isAndroid = $e816e75411cf0909$var$isAndroid;
$e816e75411cf0909$exports.isBrowser = $e816e75411cf0909$var$isBrowser;
$e816e75411cf0909$exports.isChrome = $e816e75411cf0909$var$isChrome;
$e816e75411cf0909$exports.isChromium = $e816e75411cf0909$var$isChromium;
$e816e75411cf0909$exports.isConsole = $e816e75411cf0909$var$isConsole;
$e816e75411cf0909$exports.isDesktop = $e816e75411cf0909$var$isDesktop;
$e816e75411cf0909$exports.isEdge = $e816e75411cf0909$var$isEdge;
$e816e75411cf0909$exports.isEdgeChromium = $e816e75411cf0909$var$isEdgeChromium;
$e816e75411cf0909$exports.isElectron = $e816e75411cf0909$var$isElectron;
$e816e75411cf0909$exports.isEmbedded = $e816e75411cf0909$var$isEmbedded;
$e816e75411cf0909$exports.isFirefox = $e816e75411cf0909$var$isFirefox;
$e816e75411cf0909$exports.isIE = $e816e75411cf0909$var$isIE;
$e816e75411cf0909$exports.isIOS = $e816e75411cf0909$var$isIOS;
$e816e75411cf0909$exports.isIOS13 = $e816e75411cf0909$var$isIOS13;
$e816e75411cf0909$exports.isIPad13 = $e816e75411cf0909$var$isIPad13;
$e816e75411cf0909$exports.isIPhone13 = $e816e75411cf0909$var$isIPhone13;
$e816e75411cf0909$exports.isIPod13 = $e816e75411cf0909$var$isIPod13;
$e816e75411cf0909$exports.isLegacyEdge = $e816e75411cf0909$var$isLegacyEdge;
$e816e75411cf0909$exports.isMIUI = $e816e75411cf0909$var$isMIUI;
$e816e75411cf0909$exports.isMacOs = $e816e75411cf0909$var$isMacOs;
$e816e75411cf0909$exports.isMobile = $e816e75411cf0909$var$isMobile;
$e816e75411cf0909$exports.isMobileOnly = $e816e75411cf0909$var$isMobileOnly;
$e816e75411cf0909$exports.isMobileSafari = $e816e75411cf0909$var$isMobileSafari;
$e816e75411cf0909$exports.isOpera = $e816e75411cf0909$var$isOpera;
$e816e75411cf0909$exports.isSafari = $e816e75411cf0909$var$isSafari;
$e816e75411cf0909$exports.isSamsungBrowser = $e816e75411cf0909$var$isSamsungBrowser;
$e816e75411cf0909$exports.isSmartTV = $e816e75411cf0909$var$isSmartTV;
$e816e75411cf0909$exports.isTablet = $e816e75411cf0909$var$isTablet;
$e816e75411cf0909$exports.isWearable = $e816e75411cf0909$var$isWearable;
$e816e75411cf0909$exports.isWinPhone = $e816e75411cf0909$var$isWinPhone;
$e816e75411cf0909$exports.isWindows = $e816e75411cf0909$var$isWindows;
$e816e75411cf0909$exports.isYandex = $e816e75411cf0909$var$isYandex;
$e816e75411cf0909$exports.mobileModel = $e816e75411cf0909$var$mobileModel;
$e816e75411cf0909$exports.mobileVendor = $e816e75411cf0909$var$mobileVendor;
$e816e75411cf0909$exports.osName = $e816e75411cf0909$var$osName;
$e816e75411cf0909$exports.osVersion = $e816e75411cf0909$var$osVersion;
$e816e75411cf0909$exports.parseUserAgent = $e816e75411cf0909$var$parseUserAgent;
$e816e75411cf0909$exports.setUserAgent = $e816e75411cf0909$var$setUserAgent;
$e816e75411cf0909$exports.useDeviceData = $e816e75411cf0909$var$useDeviceData;
$e816e75411cf0909$exports.useDeviceSelectors = $e816e75411cf0909$var$useDeviceSelectors;
$e816e75411cf0909$exports.useMobileOrientation = $e816e75411cf0909$var$useMobileOrientation;
$e816e75411cf0909$exports.withOrientationChange = $e816e75411cf0909$var$withOrientationChange;




var $4CEbD = parcelRequire("4CEbD");






var $fde87559cfb8bc55$exports = {};

var $5F2Q2 = parcelRequire("5F2Q2");

var $eSBMZ = parcelRequire("eSBMZ");


/**
 * html2pdf.js v0.9.3
 * Copyright (c) 2021 Erik Koopmans
 * Released under the MIT License.
 */ (function(global1, factory) {
    $fde87559cfb8bc55$exports = factory((parcelRequire("akmwF")), (parcelRequire("bTsa4")));
})(undefined, function(jsPDF, html2canvas) {
    "use strict";
    var commonjsRequire = function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs");
    };
    var createCommonjsModule = function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    };
    jsPDF = jsPDF && jsPDF.hasOwnProperty("default") ? jsPDF["default"] : jsPDF;
    html2canvas = html2canvas && html2canvas.hasOwnProperty("default") ? html2canvas["default"] : html2canvas;
    var _typeof = typeof Symbol === "function" && (0, $5F2Q2._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $5F2Q2._)(obj);
    };
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Determine the type of a variable/object.
    var objType = function objType(obj) {
        var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
        if (type === "undefined") return "undefined";
        else if (type === "string" || obj instanceof String) return "string";
        else if (type === "number" || obj instanceof Number) return "number";
        else if (type === "function" || obj instanceof Function) return "function";
        else if (!!obj && obj.constructor === Array) return "array";
        else if (obj && obj.nodeType === 1) return "element";
        else if (type === "object") return "object";
        else return "unknown";
    };
    // Create an HTML element with optional className, innerHTML, and style.
    var createElement = function createElement(tagName, opt) {
        var el = document.createElement(tagName);
        if (opt.className) el.className = opt.className;
        if (opt.innerHTML) {
            el.innerHTML = opt.innerHTML;
            var scripts = el.getElementsByTagName("script");
            for(var i = scripts.length; i-- > 0;)scripts[i].parentNode.removeChild(scripts[i]);
        }
        for(var key in opt.style)el.style[key] = opt.style[key];
        return el;
    };
    // Deep-clone a node and preserve contents/properties.
    var cloneNode = function cloneNode(node, javascriptEnabled) {
        // Recursively clone the node.
        var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);
        for(var child = node.firstChild; child; child = child.nextSibling)if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== "SCRIPT") clone.appendChild(cloneNode(child, javascriptEnabled));
        if (node.nodeType === 1) {
            // Preserve contents/properties of special nodes.
            if (node.nodeName === "CANVAS") {
                clone.width = node.width;
                clone.height = node.height;
                clone.getContext("2d").drawImage(node, 0, 0);
            } else if (node.nodeName === "TEXTAREA" || node.nodeName === "SELECT") clone.value = node.value;
            // Preserve the node's scroll position when it loads.
            clone.addEventListener("load", function() {
                clone.scrollTop = node.scrollTop;
                clone.scrollLeft = node.scrollLeft;
            }, true);
        }
        // Return the cloned node.
        return clone;
    };
    // Convert units from px using the conversion value 'k' from jsPDF.
    var unitConvert = function unitConvert(obj, k) {
        if (objType(obj) === "number") return obj * 72 / 96 / k;
        else {
            var newObj = {};
            for(var key in obj)newObj[key] = obj[key] * 72 / 96 / k;
            return newObj;
        }
    };
    // Convert units to px using the conversion value 'k' from jsPDF.
    var toPx = function toPx(val, k) {
        return Math.floor(val * k / 72 * 96);
    };
    var commonjsGlobal = typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    var es6Promise = createCommonjsModule(function(module1, exports) {
        /*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */ (function(global1, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            var objectOrFunction = function objectOrFunction(x) {
                var type = typeof x === "undefined" ? "undefined" : (0, $5F2Q2._)(x);
                return x !== null && (type === "object" || type === "function");
            };
            var isFunction = function isFunction(x) {
                return typeof x === "function";
            };
            var setScheduler = function setScheduler(scheduleFn) {
                customSchedulerFn = scheduleFn;
            };
            var setAsap = function setAsap(asapFn) {
                asap = asapFn;
            };
            var useNextTick = // node
            function useNextTick() {
                // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                // see https://github.com/cujojs/when/issues/410 for details
                return function() {
                    return $eSBMZ.nextTick(flush);
                };
            };
            var useVertxTimer = // vertx
            function useVertxTimer() {
                if (typeof vertxNext !== "undefined") return function() {
                    vertxNext(flush);
                };
                return useSetTimeout();
            };
            var useMutationObserver = function useMutationObserver() {
                var iterations = 0;
                var observer = new BrowserMutationObserver(flush);
                var node = document.createTextNode("");
                observer.observe(node, {
                    characterData: true
                });
                return function() {
                    node.data = iterations = ++iterations % 2;
                };
            };
            var useMessageChannel = // web worker
            function useMessageChannel() {
                var channel = new MessageChannel();
                channel.port1.onmessage = flush;
                return function() {
                    return channel.port2.postMessage(0);
                };
            };
            var useSetTimeout = function useSetTimeout() {
                // Store setTimeout reference so es6-promise will be unaffected by
                // other code modifying setTimeout (like sinon.useFakeTimers())
                var globalSetTimeout = setTimeout;
                return function() {
                    return globalSetTimeout(flush, 1);
                };
            };
            var flush = function flush() {
                for(var i = 0; i < len; i += 2){
                    var callback = queue[i];
                    var arg = queue[i + 1];
                    callback(arg);
                    queue[i] = undefined;
                    queue[i + 1] = undefined;
                }
                len = 0;
            };
            var attemptVertx = function attemptVertx() {
                try {
                    var vertx = Function("return this")().require("vertx");
                    vertxNext = vertx.runOnLoop || vertx.runOnContext;
                    return useVertxTimer();
                } catch (e) {
                    return useSetTimeout();
                }
            };
            var then = function then(onFulfillment, onRejection) {
                var parent = this;
                var child = new this.constructor(noop);
                if (child[PROMISE_ID] === undefined) makePromise(child);
                var _state = parent._state;
                if (_state) {
                    var callback = arguments[_state - 1];
                    asap(function() {
                        return invokeCallback(_state, child, callback, parent._result);
                    });
                } else subscribe(parent, child, onFulfillment, onRejection);
                return child;
            };
            var resolve$1 = /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
                /*jshint validthis:true */ var Constructor = this;
                if (object && typeof object === "object" && object.constructor === Constructor) return object;
                var promise = new Constructor(noop);
                resolve(promise, object);
                return promise;
            };
            var noop = function noop() {};
            var selfFulfillment = function selfFulfillment() {
                return new TypeError("You cannot resolve a promise with itself");
            };
            var cannotReturnOwn = function cannotReturnOwn() {
                return new TypeError("A promises callback cannot return that same promise.");
            };
            var getThen = function getThen(promise) {
                try {
                    return promise.then;
                } catch (error) {
                    TRY_CATCH_ERROR.error = error;
                    return TRY_CATCH_ERROR;
                }
            };
            var tryThen = function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                try {
                    then$$1.call(value, fulfillmentHandler, rejectionHandler);
                } catch (e) {
                    return e;
                }
            };
            var handleForeignThenable = function handleForeignThenable(promise, thenable, then$$1) {
                asap(function(promise) {
                    var sealed = false;
                    var error = tryThen(then$$1, thenable, function(value) {
                        if (sealed) return;
                        sealed = true;
                        if (thenable !== value) resolve(promise, value);
                        else fulfill(promise, value);
                    }, function(reason) {
                        if (sealed) return;
                        sealed = true;
                        reject(promise, reason);
                    }, "Settle: " + (promise._label || " unknown promise"));
                    if (!sealed && error) {
                        sealed = true;
                        reject(promise, error);
                    }
                }, promise);
            };
            var handleOwnThenable = function handleOwnThenable(promise, thenable) {
                if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                else if (thenable._state === REJECTED) reject(promise, thenable._result);
                else subscribe(thenable, undefined, function(value) {
                    return resolve(promise, value);
                }, function(reason) {
                    return reject(promise, reason);
                });
            };
            var handleMaybeThenable = function handleMaybeThenable(promise, maybeThenable, then$$1) {
                if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                else {
                    if (then$$1 === TRY_CATCH_ERROR) {
                        reject(promise, TRY_CATCH_ERROR.error);
                        TRY_CATCH_ERROR.error = null;
                    } else if (then$$1 === undefined) fulfill(promise, maybeThenable);
                    else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                    else fulfill(promise, maybeThenable);
                }
            };
            var resolve = function resolve(promise, value) {
                if (promise === value) reject(promise, selfFulfillment());
                else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
                else fulfill(promise, value);
            };
            var publishRejection = function publishRejection(promise) {
                if (promise._onerror) promise._onerror(promise._result);
                publish(promise);
            };
            var fulfill = function fulfill(promise, value) {
                if (promise._state !== PENDING) return;
                promise._result = value;
                promise._state = FULFILLED;
                if (promise._subscribers.length !== 0) asap(publish, promise);
            };
            var reject = function reject(promise, reason) {
                if (promise._state !== PENDING) return;
                promise._state = REJECTED;
                promise._result = reason;
                asap(publishRejection, promise);
            };
            var subscribe = function subscribe(parent, child, onFulfillment, onRejection) {
                var _subscribers = parent._subscribers;
                var length = _subscribers.length;
                parent._onerror = null;
                _subscribers[length] = child;
                _subscribers[length + FULFILLED] = onFulfillment;
                _subscribers[length + REJECTED] = onRejection;
                if (length === 0 && parent._state) asap(publish, parent);
            };
            var publish = function publish(promise) {
                var subscribers = promise._subscribers;
                var settled = promise._state;
                if (subscribers.length === 0) return;
                var child = void 0, callback = void 0, detail = promise._result;
                for(var i = 0; i < subscribers.length; i += 3){
                    child = subscribers[i];
                    callback = subscribers[i + settled];
                    if (child) invokeCallback(settled, child, callback, detail);
                    else callback(detail);
                }
                promise._subscribers.length = 0;
            };
            var tryCatch = function tryCatch(callback, detail) {
                try {
                    return callback(detail);
                } catch (e) {
                    TRY_CATCH_ERROR.error = e;
                    return TRY_CATCH_ERROR;
                }
            };
            var invokeCallback = function invokeCallback(settled, promise, callback, detail) {
                var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = void 0, failed = void 0;
                if (hasCallback) {
                    value = tryCatch(callback, detail);
                    if (value === TRY_CATCH_ERROR) {
                        failed = true;
                        error = value.error;
                        value.error = null;
                    } else succeeded = true;
                    if (promise === value) {
                        reject(promise, cannotReturnOwn());
                        return;
                    }
                } else {
                    value = detail;
                    succeeded = true;
                }
                if (promise._state !== PENDING) ;
                else if (hasCallback && succeeded) resolve(promise, value);
                else if (failed) reject(promise, error);
                else if (settled === FULFILLED) fulfill(promise, value);
                else if (settled === REJECTED) reject(promise, value);
            };
            var initializePromise = function initializePromise(promise, resolver) {
                try {
                    resolver(function resolvePromise(value) {
                        resolve(promise, value);
                    }, function rejectPromise(reason) {
                        reject(promise, reason);
                    });
                } catch (e) {
                    reject(promise, e);
                }
            };
            var nextId = function nextId() {
                return id++;
            };
            var makePromise = function makePromise(promise) {
                promise[PROMISE_ID] = id++;
                promise._state = undefined;
                promise._result = undefined;
                promise._subscribers = [];
            };
            var validationError = function validationError() {
                return new Error("Array Methods must be provided an Array");
            };
            var all = /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
                return new Enumerator(this, entries).promise;
            };
            var race = /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
                /*jshint validthis:true */ var Constructor = this;
                if (!isArray(entries)) return new Constructor(function(_, reject) {
                    return reject(new TypeError("You must pass an array to race."));
                });
                else return new Constructor(function(resolve, reject) {
                    var length = entries.length;
                    for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
                });
            };
            var reject$1 = /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
                /*jshint validthis:true */ var Constructor = this;
                var promise = new Constructor(noop);
                reject(promise, reason);
                return promise;
            };
            var needsResolver = function needsResolver() {
                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            };
            var needsNew = function needsNew() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            };
            var polyfill = /*global self*/ function polyfill() {
                var local = void 0;
                if (typeof commonjsGlobal !== "undefined") local = commonjsGlobal;
                else if (typeof self !== "undefined") local = self;
                else try {
                    local = Function("return this")();
                } catch (e) {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                }
                var P = local.Promise;
                if (P) {
                    var promiseToString = null;
                    try {
                        promiseToString = Object.prototype.toString.call(P.resolve());
                    } catch (e) {
                    // silently ignored
                    }
                    if (promiseToString === "[object Promise]" && !P.cast) return;
                }
                local.Promise = Promise$1;
            };
            var _isArray = void 0;
            if (Array.isArray) _isArray = Array.isArray;
            else _isArray = function _isArray(x) {
                return Object.prototype.toString.call(x) === "[object Array]";
            };
            var isArray = _isArray;
            var len = 0;
            var vertxNext = void 0;
            var customSchedulerFn = void 0;
            var asap = function asap(callback, arg) {
                queue[len] = callback;
                queue[len + 1] = arg;
                len += 2;
                if (len === 2) {
                    // If len is 2, that means that we need to schedule an async flush.
                    // If additional callbacks are queued before the queue is flushed, they
                    // will be processed by this flush that we are scheduling.
                    if (customSchedulerFn) customSchedulerFn(flush);
                    else scheduleFlush();
                }
            };
            var browserWindow = typeof window !== "undefined" ? window : undefined;
            var browserGlobal = browserWindow || {};
            var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
            var isNode = typeof self === "undefined" && typeof $eSBMZ !== "undefined" && ({}).toString.call($eSBMZ) === "[object process]";
            // test for web worker but not in IE10
            var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
            var queue = new Array(1000);
            var scheduleFlush = void 0;
            // Decide what async method to use to triggering processing of queued callbacks:
            if (isNode) scheduleFlush = useNextTick();
            else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
            else if (isWorker) scheduleFlush = useMessageChannel();
            else if (browserWindow === undefined && typeof commonjsRequire === "function") scheduleFlush = attemptVertx();
            else scheduleFlush = useSetTimeout();
            var PROMISE_ID = Math.random().toString(36).substring(2);
            var PENDING = void 0;
            var FULFILLED = 1;
            var REJECTED = 2;
            var TRY_CATCH_ERROR = {
                error: null
            };
            var id = 0;
            var Enumerator = function() {
                var Enumerator = function Enumerator(Constructor, input) {
                    this._instanceConstructor = Constructor;
                    this.promise = new Constructor(noop);
                    if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                    if (isArray(input)) {
                        this.length = input.length;
                        this._remaining = input.length;
                        this._result = new Array(this.length);
                        if (this.length === 0) fulfill(this.promise, this._result);
                        else {
                            this.length = this.length || 0;
                            this._enumerate(input);
                            if (this._remaining === 0) fulfill(this.promise, this._result);
                        }
                    } else reject(this.promise, validationError());
                };
                Enumerator.prototype._enumerate = function _enumerate(input) {
                    for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                };
                Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
                    var c = this._instanceConstructor;
                    var resolve$$1 = c.resolve;
                    if (resolve$$1 === resolve$1) {
                        var _then = getThen(entry);
                        if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                        else if (typeof _then !== "function") {
                            this._remaining--;
                            this._result[i] = entry;
                        } else if (c === Promise$1) {
                            var promise = new c(noop);
                            handleMaybeThenable(promise, entry, _then);
                            this._willSettleAt(promise, i);
                        } else this._willSettleAt(new c(function(resolve$$1) {
                            return resolve$$1(entry);
                        }), i);
                    } else this._willSettleAt(resolve$$1(entry), i);
                };
                Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
                    var promise = this.promise;
                    if (promise._state === PENDING) {
                        this._remaining--;
                        if (state === REJECTED) reject(promise, value);
                        else this._result[i] = value;
                    }
                    if (this._remaining === 0) fulfill(promise, this._result);
                };
                Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
                    var enumerator = this;
                    subscribe(promise, undefined, function(value) {
                        return enumerator._settledAt(FULFILLED, i, value);
                    }, function(reason) {
                        return enumerator._settledAt(REJECTED, i, reason);
                    });
                };
                return Enumerator;
            }();
            /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
                function Promise(resolver) {
                    this[PROMISE_ID] = nextId();
                    this._result = this._state = undefined;
                    this._subscribers = [];
                    if (noop !== resolver) {
                        typeof resolver !== "function" && needsResolver();
                        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
                    }
                }
                /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
                    return this.then(null, onRejection);
                };
                /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
                    var promise = this;
                    var constructor = promise.constructor;
                    if (isFunction(callback)) return promise.then(function(value) {
                        return constructor.resolve(callback()).then(function() {
                            return value;
                        });
                    }, function(reason) {
                        return constructor.resolve(callback()).then(function() {
                            throw reason;
                        });
                    });
                    return promise.then(callback, callback);
                };
                return Promise;
            }();
            Promise$1.prototype.then = then;
            Promise$1.all = all;
            Promise$1.race = race;
            Promise$1.resolve = resolve$1;
            Promise$1.reject = reject$1;
            Promise$1._setScheduler = setScheduler;
            Promise$1._setAsap = setAsap;
            Promise$1._asap = asap;
            // Strange compat..
            Promise$1.polyfill = polyfill;
            Promise$1.Promise = Promise$1;
            return Promise$1;
        });
    });
    var Promise$1 = es6Promise.Promise;
    /* ----- CONSTRUCTOR ----- */ var Worker = function Worker(opt) {
        // Create the root parent for the proto chain, and the starting Worker.
        var root = _extends(Worker.convert(Promise$1.resolve()), JSON.parse(JSON.stringify(Worker.template)));
        var _$self = Worker.convert(Promise$1.resolve(), root);
        // Set progress, optional settings, and return.
        _$self = _$self.setProgress(1, Worker, 1, [
            Worker
        ]);
        _$self = _$self.set(opt);
        return _$self;
    };
    // Boilerplate for subclassing Promise.
    Worker.prototype = Object.create(Promise$1.prototype);
    Worker.prototype.constructor = Worker;
    // Converts/casts promises into Workers.
    Worker.convert = function convert(promise, inherit) {
        // Uses prototypal inheritance to receive changes made to ancestors' properties.
        promise.__proto__ = inherit || Worker.prototype;
        return promise;
    };
    Worker.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            image: {
                type: "jpeg",
                quality: 0.95
            },
            enableLinks: true,
            html2canvas: {},
            jsPDF: {}
        }
    };
    /* ----- FROM / TO ----- */ Worker.prototype.from = function from(src, type) {
        var getType = function getType(src) {
            switch(objType(src)){
                case "string":
                    return "string";
                case "element":
                    return src.nodeName.toLowerCase === "canvas" ? "canvas" : "element";
                default:
                    return "unknown";
            }
        };
        return this.then(function from_main() {
            type = type || getType(src);
            switch(type){
                case "string":
                    return this.set({
                        src: createElement("div", {
                            innerHTML: src
                        })
                    });
                case "element":
                    return this.set({
                        src: src
                    });
                case "canvas":
                    return this.set({
                        canvas: src
                    });
                case "img":
                    return this.set({
                        img: src
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    };
    Worker.prototype.to = function to(target) {
        // Route the 'to' request to the appropriate method.
        switch(target){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    };
    Worker.prototype.toContainer = function toContainer() {
        // Set up function prerequisites.
        var prereqs = [
            function checkSrc() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function checkPageSize() {
                return this.prop.pageSize || this.setPageSize();
            }
        ];
        return this.thenList(prereqs).then(function toContainer_main() {
            // Define the CSS styles for the container and its overlay parent.
            var overlayCSS = {
                position: "fixed",
                overflow: "hidden",
                zIndex: 1000,
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                backgroundColor: "rgba(0,0,0,0.8)"
            };
            var containerCSS = {
                position: "absolute",
                width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
                left: 0,
                right: 0,
                top: 0,
                height: "auto",
                margin: "auto",
                backgroundColor: "white"
            };
            // Set the overlay to hidden (could be changed in the future to provide a print preview).
            overlayCSS.opacity = 0;
            // Create and attach the elements.
            var source = cloneNode(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            this.prop.overlay = createElement("div", {
                className: "html2pdf__overlay",
                style: overlayCSS
            });
            this.prop.container = createElement("div", {
                className: "html2pdf__container",
                style: containerCSS
            });
            this.prop.container.appendChild(source);
            this.prop.overlay.appendChild(this.prop.container);
            document.body.appendChild(this.prop.overlay);
        });
    };
    Worker.prototype.toCanvas = function toCanvas() {
        // Set up function prerequisites.
        var prereqs = [
            function checkContainer() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        // Fulfill prereqs then create the canvas.
        return this.thenList(prereqs).then(function toCanvas_main() {
            // Handle old-fashioned 'onrendered' argument.
            var options = _extends({}, this.opt.html2canvas);
            delete options.onrendered;
            return html2canvas(this.prop.container, options);
        }).then(function toCanvas_post(canvas) {
            // Handle old-fashioned 'onrendered' argument.
            var onRendered = this.opt.html2canvas.onrendered || function() {};
            onRendered(canvas);
            this.prop.canvas = canvas;
            document.body.removeChild(this.prop.overlay);
        });
    };
    Worker.prototype.toImg = function toImg() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toImg_main() {
            var imgData = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img");
            this.prop.img.src = imgData;
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toPdf_main() {
            // Create local copies of frequently used properties.
            var canvas = this.prop.canvas;
            var opt = this.opt;
            // Calculate the number of pages.
            var pxFullHeight = canvas.height;
            var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
            var nPages = Math.ceil(pxFullHeight / pxPageHeight);
            // Define pageHeight separately so it can be trimmed on the final page.
            var pageHeight = this.prop.pageSize.inner.height;
            // Create a one-page canvas to split up the full image.
            var pageCanvas = document.createElement("canvas");
            var pageCtx = pageCanvas.getContext("2d");
            pageCanvas.width = canvas.width;
            pageCanvas.height = pxPageHeight;
            // Initialize the PDF.
            this.prop.pdf = this.prop.pdf || new jsPDF(opt.jsPDF);
            for(var page = 0; page < nPages; page++){
                // Trim the final page to reduce file size.
                if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                    pageCanvas.height = pxFullHeight % pxPageHeight;
                    pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
                }
                // Display the page.
                var w = pageCanvas.width;
                var h = pageCanvas.height;
                pageCtx.fillStyle = "white";
                pageCtx.fillRect(0, 0, w, h);
                pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                // Add the page to the PDF.
                if (page) this.prop.pdf.addPage();
                var imgData = pageCanvas.toDataURL("image/" + opt.image.type, opt.image.quality);
                this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
            }
        });
    };
    /* ----- OUTPUT / SAVE ----- */ Worker.prototype.output = function output(type, options, src) {
        // Redirect requests to the correct function (outputPdf / outputImg).
        src = src || "pdf";
        if (src.toLowerCase() === "img" || src.toLowerCase() === "image") return this.outputImg(type, options);
        else return this.outputPdf(type, options);
    };
    Worker.prototype.outputPdf = function outputPdf(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputPdf_main() {
            /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */ return this.prop.pdf.output(type, options);
        });
    };
    Worker.prototype.outputImg = function outputImg(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkImg() {
                return this.prop.img || this.toImg();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputImg_main() {
            switch(type){
                case undefined:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + type + '" is not supported.';
            }
        });
    };
    Worker.prototype.save = function save(filename) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs, update the filename (if provided), and save the PDF.
        return this.thenList(prereqs).set(filename ? {
            filename: filename
        } : null).then(function save_main() {
            this.prop.pdf.save(this.opt.filename);
        });
    };
    /* ----- SET / GET ----- */ Worker.prototype.set = function set$$1(opt) {
        // TODO: Implement ordered pairs?
        // Silently ignore invalid or empty input.
        if (objType(opt) !== "object") return this;
        // Build an array of setter functions to queue.
        var fns = Object.keys(opt || {}).map(function(key) {
            if (key in Worker.template.prop) // Set pre-defined properties.
            return function set_prop() {
                this.prop[key] = opt[key];
            };
            else switch(key){
                case "margin":
                    return this.setMargin.bind(this, opt.margin);
                case "jsPDF":
                    return function set_jsPDF() {
                        this.opt.jsPDF = opt.jsPDF;
                        return this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, opt.pageSize);
                default:
                    // Set any other properties in opt.
                    return function set_opt() {
                        this.opt[key] = opt[key];
                    };
            }
        }, this);
        // Set properties within the promise chain.
        return this.then(function set_main() {
            return this.thenList(fns);
        });
    };
    Worker.prototype.get = function get$$1(key, cbk) {
        return this.then(function get_main() {
            // Fetch the requested property, either as a predefined prop or in opt.
            var val = key in Worker.template.prop ? this.prop[key] : this.opt[key];
            return cbk ? cbk(val) : val;
        });
    };
    Worker.prototype.setMargin = function setMargin(margin) {
        return this.then(function setMargin_main() {
            // Parse the margin property: [top, left, bottom, right].
            switch(objType(margin)){
                case "number":
                    margin = [
                        margin,
                        margin,
                        margin,
                        margin
                    ];
                case "array":
                    if (margin.length === 2) margin = [
                        margin[0],
                        margin[1],
                        margin[0],
                        margin[1]
                    ];
                    if (margin.length === 4) break;
                default:
                    return this.error("Invalid margin array.");
            }
            // Set the margin property, then update pageSize.
            this.opt.margin = margin;
        }).then(this.setPageSize);
    };
    Worker.prototype.setPageSize = function setPageSize(pageSize) {
        return this.then(function setPageSize_main() {
            // Retrieve page-size based on jsPDF settings, if not explicitly provided.
            pageSize = pageSize || jsPDF.getPageSize(this.opt.jsPDF);
            // Add 'inner' field if not present.
            if (!pageSize.hasOwnProperty("inner")) {
                pageSize.inner = {
                    width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
                    height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
                };
                pageSize.inner.px = {
                    width: toPx(pageSize.inner.width, pageSize.k),
                    height: toPx(pageSize.inner.height, pageSize.k)
                };
                pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
            }
            // Attach pageSize to this.
            this.prop.pageSize = pageSize;
        });
    };
    Worker.prototype.setProgress = function setProgress(val, state, n, stack) {
        // Immediately update all progress values.
        if (val != null) this.progress.val = val;
        if (state != null) this.progress.state = state;
        if (n != null) this.progress.n = n;
        if (stack != null) this.progress.stack = stack;
        this.progress.ratio = this.progress.val / this.progress.state;
        // Return this for command chaining.
        return this;
    };
    Worker.prototype.updateProgress = function updateProgress(val, state, n, stack) {
        // Immediately update all progress values, using setProgress.
        return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
    };
    /* ----- PROMISE MAPPING ----- */ Worker.prototype.then = function then(onFulfilled, onRejected) {
        // Wrap `this` for encapsulation.
        var _$self = this;
        return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
            // Update progress while queuing, calling, and resolving `then`.
            _$self.updateProgress(null, null, 1, [
                onFulfilled
            ]);
            return Promise$1.prototype.then.call(this, function then_pre(val) {
                _$self.updateProgress(null, onFulfilled);
                return val;
            }).then(onFulfilled, onRejected).then(function then_post(val) {
                _$self.updateProgress(1);
                return val;
            });
        });
    };
    Worker.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
        // Handle optional thenBase parameter.
        thenBase = thenBase || Promise$1.prototype.then;
        // Wrap `this` for encapsulation and bind it to the promise handlers.
        var _$self = this;
        if (onFulfilled) onFulfilled = onFulfilled.bind(_$self);
        if (onRejected) onRejected = onRejected.bind(_$self);
        // Cast self into a Promise to avoid polyfills recursively defining `then`.
        var isNative = Promise$1.toString().indexOf("[native code]") !== -1 && Promise$1.name === "Promise";
        var selfPromise = isNative ? _$self : Worker.convert(_extends({}, _$self), Promise$1.prototype);
        // Return the promise, after casting it into a Worker and preserving props.
        var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
        return Worker.convert(returnVal, _$self.__proto__);
    };
    Worker.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
        // Call `then` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype.then.call(this, onFulfilled, onRejected);
    };
    Worker.prototype.thenList = function thenList(fns) {
        // Queue a series of promise 'factories' into the promise chain.
        var _$self = this;
        fns.forEach(function thenList_forEach(fn) {
            _$self = _$self.thenCore(fn);
        });
        return _$self;
    };
    Worker.prototype["catch"] = function(onRejected) {
        // Bind `this` to the promise handler, call `catch`, and return a Worker.
        if (onRejected) onRejected = onRejected.bind(this);
        var returnVal = Promise$1.prototype["catch"].call(this, onRejected);
        return Worker.convert(returnVal, this);
    };
    Worker.prototype.catchExternal = function catchExternal(onRejected) {
        // Call `catch` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype["catch"].call(this, onRejected);
    };
    Worker.prototype.error = function error(msg) {
        // Throw the error in the Promise chain.
        return this.then(function error_main() {
            throw new Error(msg);
        });
    };
    /* ----- ALIASES ----- */ Worker.prototype.using = Worker.prototype.set;
    Worker.prototype.saveAs = Worker.prototype.save;
    Worker.prototype.export = Worker.prototype.output;
    Worker.prototype.run = Worker.prototype.then;
    // Import dependencies.
    // Get dimensions of a PDF page, as determined by jsPDF.
    jsPDF.getPageSize = function(orientation, unit, format) {
        // Decode options object
        if ((typeof orientation === "undefined" ? "undefined" : _typeof(orientation)) === "object") {
            var options = orientation;
            orientation = options.orientation;
            unit = options.unit || unit;
            format = options.format || format;
        }
        // Default options
        unit = unit || "mm";
        format = format || "a4";
        orientation = ("" + (orientation || "P")).toLowerCase();
        var format_as_string = ("" + format).toLowerCase();
        // Size in pt of various paper formats
        var pageFormats = {
            "a0": [
                2383.94,
                3370.39
            ],
            "a1": [
                1683.78,
                2383.94
            ],
            "a2": [
                1190.55,
                1683.78
            ],
            "a3": [
                841.89,
                1190.55
            ],
            "a4": [
                595.28,
                841.89
            ],
            "a5": [
                419.53,
                595.28
            ],
            "a6": [
                297.64,
                419.53
            ],
            "a7": [
                209.76,
                297.64
            ],
            "a8": [
                147.40,
                209.76
            ],
            "a9": [
                104.88,
                147.40
            ],
            "a10": [
                73.70,
                104.88
            ],
            "b0": [
                2834.65,
                4008.19
            ],
            "b1": [
                2004.09,
                2834.65
            ],
            "b2": [
                1417.32,
                2004.09
            ],
            "b3": [
                1000.63,
                1417.32
            ],
            "b4": [
                708.66,
                1000.63
            ],
            "b5": [
                498.90,
                708.66
            ],
            "b6": [
                354.33,
                498.90
            ],
            "b7": [
                249.45,
                354.33
            ],
            "b8": [
                175.75,
                249.45
            ],
            "b9": [
                124.72,
                175.75
            ],
            "b10": [
                87.87,
                124.72
            ],
            "c0": [
                2599.37,
                3676.54
            ],
            "c1": [
                1836.85,
                2599.37
            ],
            "c2": [
                1298.27,
                1836.85
            ],
            "c3": [
                918.43,
                1298.27
            ],
            "c4": [
                649.13,
                918.43
            ],
            "c5": [
                459.21,
                649.13
            ],
            "c6": [
                323.15,
                459.21
            ],
            "c7": [
                229.61,
                323.15
            ],
            "c8": [
                161.57,
                229.61
            ],
            "c9": [
                113.39,
                161.57
            ],
            "c10": [
                79.37,
                113.39
            ],
            "dl": [
                311.81,
                623.62
            ],
            "letter": [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            "legal": [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            "ledger": [
                1224,
                792
            ],
            "tabloid": [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        // Unit conversion
        switch(unit){
            case "pt":
                var k = 1;
                break;
            case "mm":
                var k = 72 / 25.4;
                break;
            case "cm":
                var k = 72 / 2.54;
                break;
            case "in":
                var k = 72;
                break;
            case "px":
                var k = 0.75;
                break;
            case "pc":
                var k = 12;
                break;
            case "em":
                var k = 12;
                break;
            case "ex":
                var k = 6;
                break;
            default:
                throw "Invalid unit: " + unit;
        }
        // Dimensions are stored as user units and converted to points on output
        if (pageFormats.hasOwnProperty(format_as_string)) {
            var pageHeight = pageFormats[format_as_string][1] / k;
            var pageWidth = pageFormats[format_as_string][0] / k;
        } else try {
            var pageHeight = format[1];
            var pageWidth = format[0];
        } catch (err) {
            throw new Error("Invalid format: " + format);
        }
        // Handle page orientation
        if (orientation === "p" || orientation === "portrait") {
            orientation = "p";
            if (pageWidth > pageHeight) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else if (orientation === "l" || orientation === "landscape") {
            orientation = "l";
            if (pageHeight > pageWidth) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else throw "Invalid orientation: " + orientation;
        // Return information (k is the unit conversion ratio from pts)
        var info = {
            "width": pageWidth,
            "height": pageHeight,
            "unit": unit,
            "k": k
        };
        return info;
    };
    /* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/ // Refs to original functions.
    var orig = {
        toContainer: Worker.prototype.toContainer
    };
    // Add pagebreak default options to the Worker template.
    Worker.template.opt.pagebreak = {
        mode: [
            "css",
            "legacy"
        ],
        before: [],
        after: [],
        avoid: []
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig.toContainer.call(this).then(function toContainer_pagebreak() {
            // Setup root element and inner page height.
            var root = this.prop.container;
            var pxPageHeight = this.prop.pageSize.inner.px.height;
            // Check all requested modes.
            var modeSrc = [].concat(this.opt.pagebreak.mode);
            var mode = {
                avoidAll: modeSrc.indexOf("avoid-all") !== -1,
                css: modeSrc.indexOf("css") !== -1,
                legacy: modeSrc.indexOf("legacy") !== -1
            };
            // Get arrays of all explicitly requested elements.
            var select = {};
            var _$self = this;
            [
                "before",
                "after",
                "avoid"
            ].forEach(function(key) {
                var all = mode.avoidAll && key === "avoid";
                select[key] = all ? [] : [].concat(_$self.opt.pagebreak[key] || []);
                if (select[key].length > 0) select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(", ")));
            });
            // Get all legacy page-break elements.
            var legacyEls = root.querySelectorAll(".html2pdf__page-break");
            legacyEls = Array.prototype.slice.call(legacyEls);
            // Loop through all elements.
            var els = root.querySelectorAll("*");
            Array.prototype.forEach.call(els, function pagebreak_loop(el) {
                // Setup pagebreak rules based on legacy and avoidAll modes.
                var rules = {
                    before: false,
                    after: mode.legacy && legacyEls.indexOf(el) !== -1,
                    avoid: mode.avoidAll
                };
                // Add rules for css mode.
                if (mode.css) {
                    // TODO: Check if this is valid with iFrames.
                    var style = window.getComputedStyle(el);
                    // TODO: Handle 'left' and 'right' correctly.
                    // TODO: Add support for 'avoid' on breakBefore/After.
                    var breakOpt = [
                        "always",
                        "page",
                        "left",
                        "right"
                    ];
                    var avoidOpt = [
                        "avoid",
                        "avoid-page"
                    ];
                    rules = {
                        before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
                        after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
                        avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
                    };
                }
                // Add rules for explicit requests.
                Object.keys(rules).forEach(function(key) {
                    rules[key] = rules[key] || select[key].indexOf(el) !== -1;
                });
                // Get element position on the screen.
                // TODO: Subtract the top of the container from clientRect.top/bottom?
                var clientRect = el.getBoundingClientRect();
                // Avoid: Check if a break happens mid-element.
                if (rules.avoid && !rules.before) {
                    var startPage = Math.floor(clientRect.top / pxPageHeight);
                    var endPage = Math.floor(clientRect.bottom / pxPageHeight);
                    var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight;
                    // Turn on rules.before if the el is broken and is at most one page long.
                    if (endPage !== startPage && nPages <= 1) rules.before = true;
                }
                // Before: Create a padding div to push the element to the next page.
                if (rules.before) {
                    var pad = createElement("div", {
                        style: {
                            display: "block",
                            height: pxPageHeight - clientRect.top % pxPageHeight + "px"
                        }
                    });
                    el.parentNode.insertBefore(pad, el);
                }
                // After: Create a padding div to fill the remaining page.
                if (rules.after) {
                    var pad = createElement("div", {
                        style: {
                            display: "block",
                            height: pxPageHeight - clientRect.bottom % pxPageHeight + "px"
                        }
                    });
                    el.parentNode.insertBefore(pad, el.nextSibling);
                }
            });
        });
    };
    // Add hyperlink functionality to the PDF creation.
    // Main link array, and refs to original functions.
    var linkInfo = [];
    var orig$1 = {
        toContainer: Worker.prototype.toContainer,
        toPdf: Worker.prototype.toPdf
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig$1.toContainer.call(this).then(function toContainer_hyperlink() {
            // Retrieve hyperlink info if the option is enabled.
            if (this.opt.enableLinks) {
                // Find all anchor tags and get the container's bounds for reference.
                var container = this.prop.container;
                var links = container.querySelectorAll("a");
                var containerRect = unitConvert(container.getBoundingClientRect(), this.prop.pageSize.k);
                linkInfo = [];
                // Loop through each anchor tag.
                Array.prototype.forEach.call(links, function(link) {
                    // Treat each client rect as a separate link (for text-wrapping).
                    var clientRects = link.getClientRects();
                    for(var i = 0; i < clientRects.length; i++){
                        var clientRect = unitConvert(clientRects[i], this.prop.pageSize.k);
                        clientRect.left -= containerRect.left;
                        clientRect.top -= containerRect.top;
                        var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
                        var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
                        var left = this.opt.margin[1] + clientRect.left;
                        linkInfo.push({
                            page: page,
                            top: top,
                            left: left,
                            clientRect: clientRect,
                            link: link
                        });
                    }
                }, this);
            }
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        return orig$1.toPdf.call(this).then(function toPdf_hyperlink() {
            // Add hyperlinks if the option is enabled.
            if (this.opt.enableLinks) {
                // Attach each anchor tag based on info from toContainer().
                linkInfo.forEach(function(l) {
                    this.prop.pdf.setPage(l.page);
                    this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
                        url: l.link.href
                    });
                }, this);
                // Reset the active page of the PDF to the final page.
                var nPages = this.prop.pdf.internal.getNumberOfPages();
                this.prop.pdf.setPage(nPages);
            }
        });
    };
    /**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */ var html2pdf = function html2pdf(src, opt) {
        // Create a new worker with the given options.
        var worker = new html2pdf.Worker(opt);
        if (src) // If src is specified, perform the traditional 'simple' operation.
        return worker.from(src).save();
        else // Otherwise, return the worker for new Promise-based operation.
        return worker;
    };
    html2pdf.Worker = Worker;
    return html2pdf;
});


var $09bef5f5baf828b1$var$testResult = function() {
    var formRef;
    var _useParams = (0, $876a3032fada8974$export$99eaa27ddbbb95ef)(), type = _useParams.type, sessionId = _useParams.sessionId;
    var directorState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $f487fa6abc092388$export$86d1cded24611cb8));
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var onSubmitFailure = function(res) {
        dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
            text: t(res.error),
            type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    var printResult = function() {
        var el = document.body;
        el.classList.add("layout--result-print");
        var opt = {
            margin: [
                0,
                0,
                0,
                0
            ],
            filename: "Lerche_Lesetest.pdf",
            image: {
                type: "jpeg",
                quality: 0.98
            },
            html2canvas: {
                height: el.offsetHeight,
                width: el.offsetWidth,
                scale: 2,
                logging: false,
                dpi: 192
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            }
        };
        var clonedElement = el.cloneNode(true);
        el.classList.remove("layout--result-print");
        console.log("xxx", (0, $e816e75411cf0909$exports.isSafari));
        if (0, $e816e75411cf0909$exports.isSafari) (0, (/*@__PURE__*/$parcel$interopDefault($fde87559cfb8bc55$exports)))().set(opt).from(clonedElement).output("dataurlnewwindow", "Lerche_Lesetest.pdf");
        else (0, (/*@__PURE__*/$parcel$interopDefault($fde87559cfb8bc55$exports)))().set(opt).from(clonedElement).save();
        clonedElement.remove();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        var successF = function(res) {
            //log.info("testResult", "useEffect", res);
            if (res.error) dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                text: t(res.error),
                type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).ERROR,
                props: {}
            }));
            else dispatch((0, $f487fa6abc092388$export$2091f1cb24a0a89e)({
                resultHtml: res.result_html
            }));
        };
        var resultRes;
        if (type === "teacher") resultRes = $84ae43476eb4deb8$export$588d6001e05323e6(directorState.sessionId || sessionId);
        else resultRes = $84ae43476eb4deb8$export$c275eceb89556514(directorState.sessionId || sessionId);
        resultRes.then(successF, onSubmitFailure);
        document.body.classList.add("layout--centered", "layout--result");
        return function() {
            document.body.classList.remove("layout--centered", "layout--result");
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        var dlButton = document.querySelector("#dl-button");
        //console.log("xxx directorState.resultHtml", dlButton);
        if (dlButton) dlButton.onclick = printResult;
    }, [
        directorState.resultHtml
    ]);
    var doCancelTest = function() {
        var _ref = (0, $em5FP._)(function() {
            return (0, $nLPsB.__generator)(this, function(_state) {
                dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)({}));
                dispatch((0, $a5db8fa337cb10ec$export$fb9705de59d96855)({
                    text: t("abortTest.testWasFinished.message"),
                    type: (0, $a5db8fa337cb10ec$export$87130b6dd9721cee).INFO,
                    props: {}
                }));
                history.push((0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d));
                return [
                    2
                ];
            });
        });
        return function doCancelTest() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, directorState.resultHtml && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: directorState.resultHtml
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "section section-result-controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "controls"
    }, !sessionId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $76ce51e0141c4618$export$2e2bcd8739ae039), {
        cb: printResult,
        formRef: formRef,
        classes: [
            "button--direction-down",
            "is-rounded",
            "is-success"
        ],
        iconClasses: [
            "icon licon-cloud-arrow-down"
        ],
        caption: t("testResultPage.pdfButton.caption")
    }), " ", !sessionId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $76ce51e0141c4618$export$2e2bcd8739ae039), {
        cb: doCancelTest,
        dir: "after",
        formRef: formRef,
        classes: [
            "button--direction-right",
            "is-rounded",
            "is-text"
        ],
        iconClasses: [
            "icon licon-arrow-arc-right"
        ],
        caption: t("testResultPage.newTestButton.caption")
    }))))));
};
var $09bef5f5baf828b1$export$2e2bcd8739ae039 = $09bef5f5baf828b1$var$testResult;



var $1dc662ec593f833a$export$3565eb3d00ca5a74 = function() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $876a3032fada8974$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$1db569cf9469e5b3),
        component: (0, $69e9a63831f23aaa$exports.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d),
        component: (0, $717ca83bd710dc3b$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$45f15e91356025b3),
        component: (0, $09bef5f5baf828b1$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$43be4fd0f6d56954),
        component: (0, $09bef5f5baf828b1$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$500824a38b151028),
        component: (0, $1cd4a961b0de3725$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$ce029234ae8b8b29),
        component: (0, $07794a62b1b52936$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $6fb258ca9d5a721a$export$2a280bdbd8b49d15),
        component: (0, $8cd79a29fa44d985$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $217f77d1e04369c4$export$aec9e034445ee8d0), {
        path: (0, $6fb258ca9d5a721a$export$cd0a6c3b228c8793),
        component: (0, $c2d8ab8fcee3b0ab$export$2e2bcd8739ae039)
    }));
};
var $1dc662ec593f833a$export$dad4a579cd5614b0 = function(directorState, history) {
    //log.info("create autoRoute", directorState.sessionId, directorState.currentStep);
    return function() {
        if (directorState.sessionId) {
            if (directorState.currentStep === (0, $f487fa6abc092388$export$10308fe6a08904fd).FINISHED) {
                //log.info("autoRoute to testResultUrl");
                history.push((0, $6fb258ca9d5a721a$export$45f15e91356025b3));
                return;
            } else {
                //log.info("autoRoute to testUrl");
                history.push((0, $6fb258ca9d5a721a$export$1db569cf9469e5b3));
                return;
            }
        }
    };
};






var $4CEbD = parcelRequire("4CEbD");


var $ec338fd80aa0d890$export$48db0aa9830045c5 = {
    ERROR: "is-danger",
    INFO: "",
    SUCCESS: "is-success"
};
var $ec338fd80aa0d890$var$SnackbarComponent = function() {
    var snackbarState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $a5db8fa337cb10ec$export$5fba9b735dabe025));
    var dispatch1 = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var shownSnacks = new Set();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {}, [
        snackbarState.items
    ]);
    var getSnackbars = function() {
        var bars = [];
        snackbarState.items.forEach(function(aBar) {
            if (!shownSnacks.has(aBar.id)) setTimeout(function() {
                // console.log("remove id", shownSnacks, aBar.id);
                shownSnacks.delete(aBar.id);
                dispatch1((0, $a5db8fa337cb10ec$export$fe2d9b4e03920b4c)({
                    id: aBar.id
                }));
            }, (0, $a5db8fa337cb10ec$export$3cf918ebc7e29d7a));
            bars.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($ec338fd80aa0d890$var$SnackbarItemComponent, {
                key: aBar.id,
                id: aBar.id,
                classname: $ec338fd80aa0d890$export$48db0aa9830045c5[aBar.type],
                text: aBar.text
            }));
            shownSnacks.add(aBar.id);
        });
        return bars;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c338a874749393df$exports)))("snackbars")
    }, getSnackbars(), " ");
};
var $ec338fd80aa0d890$var$SnackbarItemComponent = function(param) {
    var id = param.id, classname = param.classname, text = param.text;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        key: id,
        className: "snackbar notification " + classname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("p", {
        onClick: function() {
            dispatch((0, $a5db8fa337cb10ec$export$fe2d9b4e03920b4c)({
                id: id
            }));
        }
    }, text, " "));
};
$ec338fd80aa0d890$var$SnackbarItemComponent.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).any,
    classname: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($301b25c3bc3e558a$exports))).string
};
var $ec338fd80aa0d890$export$9689b5d1b3e00abd = $ec338fd80aa0d890$var$SnackbarComponent;








var $4CEbD = parcelRequire("4CEbD");

var $fI3zL = parcelRequire("fI3zL");

var $em5FP = parcelRequire("em5FP");

var $h5oKP = parcelRequire("h5oKP");

var $85qwq = parcelRequire("85qwq");

var $fsOl6 = parcelRequire("fsOl6");

var $hF4Ve = parcelRequire("hF4Ve");

var $h9dQc = parcelRequire("h9dQc");

var $5F2Q2 = parcelRequire("5F2Q2");

var $COJlH = parcelRequire("COJlH");

var $nLPsB = parcelRequire("nLPsB");

var $4CEbD = parcelRequire("4CEbD");
var $af8327ccbf59904d$var$bt = Object.create, $af8327ccbf59904d$var$ke = Object.defineProperty;
var $af8327ccbf59904d$var$gt = Object.getOwnPropertyDescriptor;
var $af8327ccbf59904d$var$yt = Object.getOwnPropertyNames;
var $af8327ccbf59904d$var$wt = Object.getPrototypeOf, $af8327ccbf59904d$var$Lt = Object.prototype.hasOwnProperty;
var $af8327ccbf59904d$var$Pt = function(t) {
    return $af8327ccbf59904d$var$ke(t, "__esModule", {
        value: !0
    });
};
var $af8327ccbf59904d$var$Mt = function(t, e) {
    return function() {
        return e || t((e = {
            exports: {}
        }).exports, e), e.exports;
    };
};
var $af8327ccbf59904d$var$kt = function(t, e, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (e && typeof e == "object" || typeof e == "function") try {
        var _loop = function() {
            var i = _step.value;
            !$af8327ccbf59904d$var$Lt.call(t, i) && i !== "default" && $af8327ccbf59904d$var$ke(t, i, {
                get: function() {
                    return e[i];
                },
                enumerable: !(n = $af8327ccbf59904d$var$gt(e, i)) || n.enumerable
            });
        };
        for(var _iterator = $af8327ccbf59904d$var$yt(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}, $af8327ccbf59904d$var$xt = function(t) {
    return $af8327ccbf59904d$var$kt($af8327ccbf59904d$var$Pt($af8327ccbf59904d$var$ke(t != null ? $af8327ccbf59904d$var$bt($af8327ccbf59904d$var$wt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
        get: function() {
            return t.default;
        },
        enumerable: !0
    } : {
        value: t,
        enumerable: !0
    })), t);
};
var $af8327ccbf59904d$var$Je = $af8327ccbf59904d$var$Mt(function(he, Ye) {
    (function(t, e) {
        typeof he == "object" && typeof Ye != "undefined" ? e(he) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
    })(he, function(t) {
        "use strict";
        var e = function e(d) {
            return function(h) {
                var o = d(h);
                return h.add(o), o;
            };
        }, n = function n(d) {
            return function(h, o) {
                return d.set(h, o), o;
            };
        }, i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, l = 536870912, m = l * 2, g = function g(d, h) {
            return function(o) {
                var V = h.get(o), w = V === void 0 ? o.size : V < m ? V + 1 : 0;
                if (!o.has(w)) return d(o, w);
                if (o.size < l) {
                    for(; o.has(w);)w = Math.floor(Math.random() * m);
                    return d(o, w);
                }
                if (o.size > i) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; o.has(w);)w = Math.floor(Math.random() * i);
                return d(o, w);
            };
        }, R = new WeakMap, B = n(R), p = g(B, R), c = e(p);
        t.addUniqueNumber = c, t.generateUniqueNumber = p, Object.defineProperty(t, "__esModule", {
            value: !0
        });
    });
});
function $af8327ccbf59904d$export$1b06ce49faf19067(t) {
    return (0, $4CEbD.forwardRef)(function(n, i) {
        var l = (0, $hF4Ve._)({}, n), m = $af8327ccbf59904d$export$3e1c2ef16041091f(l);
        return typeof i == "function" ? i(m) : i && (i.current = m), (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement(t, (0, $hF4Ve._)({}, n, m));
    });
}
var $af8327ccbf59904d$var$je = /*#__PURE__*/ function(St) {
    "use strict";
    (0, $fsOl6._)(je, St);
    var _super = (0, $COJlH._)(je);
    function je() {
        (0, $h5oKP._)(this, je);
        return _super.apply(this, arguments);
    }
    return je;
}((0, $4CEbD.Component)), $af8327ccbf59904d$export$c0b73c5063fae2ae = /*#__PURE__*/ function(je) {
    "use strict";
    (0, $fsOl6._)($e, je);
    var _super = (0, $COJlH._)($e);
    function $e(e) {
        (0, $h5oKP._)(this, $e);
        var _this;
        _this = _super.call(this, e);
        _this.onPresenceChange && e.setOnPresenceChange(_this.onPresenceChange.bind((0, $fI3zL._)(_this))), _this.onPrompt && e.setOnPrompt(_this.onPrompt.bind((0, $fI3zL._)(_this))), _this.onIdle && e.setOnIdle(_this.onIdle.bind((0, $fI3zL._)(_this))), _this.onActive && e.setOnActive(_this.onActive.bind((0, $fI3zL._)(_this))), _this.onAction && e.setOnAction(_this.onAction.bind((0, $fI3zL._)(_this))), _this.onMessage && e.setOnMessage(_this.onMessage.bind((0, $fI3zL._)(_this)));
        return _this;
    }
    return $e;
}($af8327ccbf59904d$var$je);
var $af8327ccbf59904d$var$se = $af8327ccbf59904d$var$xt($af8327ccbf59904d$var$Je());
var $af8327ccbf59904d$var$ze = function(t) {
    return t.method !== void 0 && t.method === "call";
};
var $af8327ccbf59904d$var$Xe = function(t) {
    return t.error === null && typeof t.id == "number";
};
var $af8327ccbf59904d$var$Ke = function(t) {
    var e = new Map([
        [
            0,
            function() {}
        ]
    ]), n = new Map([
        [
            0,
            function() {}
        ]
    ]), i = new Map, l = new Worker(t);
    return l.addEventListener("message", function(param) {
        var p = param.data;
        if ($af8327ccbf59904d$var$ze(p)) {
            var _p_params = p.params, c = _p_params.timerId, f = _p_params.timerType;
            if (f === "interval") {
                var d = e.get(c);
                if (typeof d == "number") {
                    var h = i.get(d);
                    if (h === void 0 || h.timerId !== c || h.timerType !== f) throw new Error("The timer is in an undefined state.");
                } else if (typeof d != "undefined") d();
                else throw new Error("The timer is in an undefined state.");
            } else if (f === "timeout") {
                var d1 = n.get(c);
                if (typeof d1 == "number") {
                    var h1 = i.get(d1);
                    if (h1 === void 0 || h1.timerId !== c || h1.timerType !== f) throw new Error("The timer is in an undefined state.");
                } else if (typeof d1 != "undefined") d1(), n.delete(c);
                else throw new Error("The timer is in an undefined state.");
            }
        } else if ($af8327ccbf59904d$var$Xe(p)) {
            var c1 = p.id, f1 = i.get(c1);
            if (f1 === void 0) throw new Error("The timer is in an undefined state.");
            var d2 = f1.timerId, h2 = f1.timerType;
            i.delete(c1), h2 === "interval" ? e.delete(d2) : n.delete(d2);
        } else {
            var _p_error = p.error, c2 = _p_error.message;
            throw new Error(c2);
        }
    }), {
        clearInterval: function(p) {
            var c = (0, $af8327ccbf59904d$var$se.generateUniqueNumber)(i);
            i.set(c, {
                timerId: p,
                timerType: "interval"
            }), e.set(p, c), l.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: p,
                    timerType: "interval"
                }
            });
        },
        clearTimeout: function(p) {
            var c = (0, $af8327ccbf59904d$var$se.generateUniqueNumber)(i);
            i.set(c, {
                timerId: p,
                timerType: "timeout"
            }), n.set(p, c), l.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: p,
                    timerType: "timeout"
                }
            });
        },
        setInterval: function(p, c) {
            var f = (0, $af8327ccbf59904d$var$se.generateUniqueNumber)(e);
            return e.set(f, function() {
                p(), typeof e.get(f) == "function" && l.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: c,
                        now: performance.now(),
                        timerId: f,
                        timerType: "interval"
                    }
                });
            }), l.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: f,
                    timerType: "interval"
                }
            }), f;
        },
        setTimeout: function(p, c) {
            var f = (0, $af8327ccbf59904d$var$se.generateUniqueNumber)(n);
            return n.set(f, p), l.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: f,
                    timerType: "timeout"
                }
            }), f;
        }
    };
};
var $af8327ccbf59904d$var$ae = null, $af8327ccbf59904d$var$Qe = function(t, e) {
    return function() {
        if ($af8327ccbf59904d$var$ae !== null) return $af8327ccbf59904d$var$ae;
        var n = new Blob([
            e
        ], {
            type: "application/javascript; charset=utf-8"
        }), i = URL.createObjectURL(n);
        return $af8327ccbf59904d$var$ae = t(i), $af8327ccbf59904d$var$ae.setTimeout(function() {
            return URL.revokeObjectURL(i);
        }, 0), $af8327ccbf59904d$var$ae;
    };
};
var $af8327ccbf59904d$var$Ze = '(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error(\'There is no interval scheduled with the given id "\'.concat(t,\'".\'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error(\'The given type "\'.concat(i,\'" is not supported\'));(e=>{const r=t.get(e);if(void 0===r)throw new Error(\'There is no timeout scheduled with the given id "\'.concat(e,\'".\'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error(\'The given method "\'.concat(s.method,\'" is not supported\'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error(\'The given type "\'.concat(d,\'" is not supported\'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();';
var $af8327ccbf59904d$var$ve = $af8327ccbf59904d$var$Qe($af8327ccbf59904d$var$Ke, $af8327ccbf59904d$var$Ze), $af8327ccbf59904d$var$et = function(t) {
    return $af8327ccbf59904d$var$ve().clearInterval(t);
}, $af8327ccbf59904d$var$tt = function(t) {
    return $af8327ccbf59904d$var$ve().clearTimeout(t);
}, $af8327ccbf59904d$var$rt = function(t, e) {
    return $af8327ccbf59904d$var$ve().setInterval(t, e);
}, $af8327ccbf59904d$var$nt = function(t, e) {
    return $af8327ccbf59904d$var$ve().setTimeout(t, e);
};
var $af8327ccbf59904d$var$A = (typeof window == "undefined" ? "undefined" : typeof window === "undefined" ? "undefined" : (0, $5F2Q2._)(window)) == "object";
var $af8327ccbf59904d$var$E = {
    setTimeout: $af8327ccbf59904d$var$A ? setTimeout.bind(window) : setTimeout,
    clearTimeout: $af8327ccbf59904d$var$A ? clearTimeout.bind(window) : clearTimeout,
    setInterval: $af8327ccbf59904d$var$A ? setInterval.bind(window) : setInterval,
    clearInterval: $af8327ccbf59904d$var$A ? clearInterval.bind(window) : clearInterval
}, $af8327ccbf59904d$export$427b263b93108fff = {
    setTimeout: $af8327ccbf59904d$var$nt,
    clearTimeout: $af8327ccbf59904d$var$tt,
    setInterval: $af8327ccbf59904d$var$rt,
    clearInterval: $af8327ccbf59904d$var$et
};
function $af8327ccbf59904d$export$5ca7e2fccac21705() {
    $af8327ccbf59904d$var$E.setTimeout = setTimeout, $af8327ccbf59904d$var$E.clearTimeout = clearTimeout, $af8327ccbf59904d$var$E.setInterval = setInterval, $af8327ccbf59904d$var$E.clearInterval = clearInterval, $af8327ccbf59904d$export$427b263b93108fff.setTimeout = setTimeout, $af8327ccbf59904d$export$427b263b93108fff.clearTimeout = clearTimeout, $af8327ccbf59904d$export$427b263b93108fff.setInterval = setInterval, $af8327ccbf59904d$export$427b263b93108fff.clearInterval = clearInterval;
}
function $af8327ccbf59904d$var$it(t) {
    $af8327ccbf59904d$var$E.setTimeout = t.setTimeout, $af8327ccbf59904d$var$E.clearTimeout = t.clearTimeout, $af8327ccbf59904d$var$E.setInterval = t.setInterval, $af8327ccbf59904d$var$E.clearInterval = t.clearInterval;
}
var $af8327ccbf59904d$var$Q = {}, $af8327ccbf59904d$var$ot = /*#__PURE__*/ function() {
    "use strict";
    function ot(e) {
        (0, $h5oKP._)(this, ot);
        this.closed = !1;
        this.mc = new MessageChannel;
        this.name = e, $af8327ccbf59904d$var$Q[e] = $af8327ccbf59904d$var$Q[e] || [], $af8327ccbf59904d$var$Q[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
    (0, $85qwq._)(ot, [
        {
            key: "onStorage",
            value: function onStorage(e) {
                if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
                var n = JSON.parse(e.newValue);
                this.mc.port2.postMessage(n);
            }
        },
        {
            key: "postMessage",
            value: function postMessage(e) {
                var _this = this;
                if (this.closed) throw new Error("InvalidStateError");
                var n = JSON.stringify(e), i = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
                window.localStorage.setItem(i, n), $af8327ccbf59904d$var$E.setTimeout(function() {
                    window.localStorage.removeItem(i);
                }, 500), $af8327ccbf59904d$var$Q[this.name].forEach(function(l) {
                    l !== _this && l.mc.port2.postMessage(JSON.parse(n));
                });
            }
        },
        {
            key: "close",
            value: function close() {
                if (this.closed) return;
                this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
                var e = $af8327ccbf59904d$var$Q[this.name].indexOf(this);
                $af8327ccbf59904d$var$Q[this.name].splice(e, 1);
            }
        },
        {
            key: "onmessage",
            get: function get() {
                return this.mc.port1.onmessage;
            },
            set: function set(e) {
                this.mc.port1.onmessage = e;
            }
        },
        {
            key: "onmessageerror",
            get: function get() {
                return this.mc.port1.onmessageerror;
            },
            set: function set(e) {
                this.mc.port1.onmessageerror = e;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(e, n) {
                return this.mc.port1.addEventListener(e, n);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(e, n) {
                return this.mc.port1.removeEventListener(e, n);
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(e) {
                return this.mc.port1.dispatchEvent(e);
            }
        }
    ]);
    return ot;
}(), $af8327ccbf59904d$var$st = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : $af8327ccbf59904d$var$ot;
function $af8327ccbf59904d$var$at() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Promise(function(e) {
        return $af8327ccbf59904d$var$E.setTimeout(e, t);
    });
}
function $af8327ccbf59904d$var$Te() {
    return Math.random().toString(36).substring(2);
}
var $af8327ccbf59904d$var$a;
(function(o) {
    o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})($af8327ccbf59904d$var$a || ($af8327ccbf59904d$var$a = {}));
var $af8327ccbf59904d$var$xe = /*#__PURE__*/ function() {
    "use strict";
    function xe(e, n) {
        (0, $h5oKP._)(this, xe);
        this.token = $af8327ccbf59904d$var$Te();
        this.isLeader = !1;
        this.isDead = !1;
        this.isApplying = !1;
        this.reApply = !1;
        this.intervals = [];
        this.listeners = [];
        this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
    }
    (0, $85qwq._)(xe, [
        {
            key: "apply",
            value: function apply() {
                var _this = this;
                return (0, $em5FP._)(function() {
                    var e, n, e1;
                    return (0, $nLPsB.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isLeader || _this.isDead) return [
                                    2,
                                    !1
                                ];
                                if (_this.isApplying) return [
                                    2,
                                    (_this.reApply = !0, !1)
                                ];
                                _this.isApplying = !0;
                                e = !1, n = function(i) {
                                    var _i_data = i.data, l = _i_data.token, m = _i_data.action;
                                    l !== _this.token && (m === $af8327ccbf59904d$var$a.APPLY && l > _this.token && (e = !0), m === $af8327ccbf59904d$var$a.TELL && (e = !0));
                                };
                                _this.channel.addEventListener("message", n);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _this.sendAction($af8327ccbf59904d$var$a.APPLY);
                                return [
                                    4,
                                    $af8327ccbf59904d$var$at(_this.options.responseTime)
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), _this.channel.removeEventListener("message", n), _this.isApplying = !1, e ? _this.reApply ? _this.apply() : !1 : (_this.assumeLead(), !0))
                                ];
                            case 3:
                                e1 = _state.sent();
                                return [
                                    2,
                                    !1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "awaitLeadership",
            value: function awaitLeadership() {
                var _this = this;
                if (this.isLeader) return Promise.resolve();
                var e = !1, n = null;
                return new Promise(function(i) {
                    var l = function() {
                        if (e) return;
                        e = !0;
                        try {
                            $af8327ccbf59904d$var$E.clearInterval(n);
                        } catch (e) {}
                        var g = _this.intervals.indexOf(n);
                        g >= 0 && _this.intervals.splice(g, 1), _this.channel.removeEventListener("message", m), i();
                    };
                    n = $af8327ccbf59904d$var$E.setInterval(function() {
                        _this.apply().then(function() {
                            _this.isLeader && l();
                        });
                    }, _this.options.fallbackInterval), _this.intervals.push(n);
                    var m = function(g) {
                        var _g_data = g.data, R = _g_data.action;
                        R === $af8327ccbf59904d$var$a.CLOSE && _this.apply().then(function() {
                            _this.isLeader && l();
                        });
                    };
                    _this.channel.addEventListener("message", m);
                });
            }
        },
        {
            key: "sendAction",
            value: function sendAction(e) {
                this.channel.postMessage({
                    action: e,
                    token: this.token
                });
            }
        },
        {
            key: "assumeLead",
            value: function assumeLead() {
                var _this = this;
                this.isLeader = !0;
                var e = function(n) {
                    var _n_data = n.data, i = _n_data.action;
                    i === $af8327ccbf59904d$var$a.APPLY && _this.sendAction($af8327ccbf59904d$var$a.TELL);
                };
                return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction($af8327ccbf59904d$var$a.TELL);
            }
        },
        {
            key: "waitForLeadership",
            value: function waitForLeadership() {
                return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                if (!this.isDead) {
                    this.isDead = !0, this.isLeader = !1, this.sendAction($af8327ccbf59904d$var$a.CLOSE);
                    try {
                        this.listeners.forEach(function(e) {
                            return _this.channel.removeEventListener("message", e);
                        }), this.intervals.forEach(function(e) {
                            return $af8327ccbf59904d$var$E.clearInterval(e);
                        });
                    } catch (e) {}
                }
            }
        }
    ]);
    return xe;
}();
var $af8327ccbf59904d$var$k;
(function(i) {
    i[i.PROMPTED = 0] = "PROMPTED", i[i.ACTIVE = 1] = "ACTIVE", i[i.IDLE = 2] = "IDLE";
})($af8327ccbf59904d$var$k || ($af8327ccbf59904d$var$k = {}));
var $af8327ccbf59904d$var$Ae = /*#__PURE__*/ function() {
    "use strict";
    function Ae(e) {
        var _this = this;
        (0, $h5oKP._)(this, Ae);
        this.token = $af8327ccbf59904d$var$Te();
        this.registry = new Map;
        this.allIdle = !1;
        this.isLastActive = !1;
        var n = e.channelName;
        if (this.options = e, this.channel = new $af8327ccbf59904d$var$st(n), this.registry.set(this.token, 1), e.leaderElection) {
            var i = {
                fallbackInterval: 2e3,
                responseTime: 100
            };
            this.elector = new $af8327ccbf59904d$var$xe(this.channel, i), this.elector.waitForLeadership();
        }
        this.channel.addEventListener("message", function(i) {
            var _i_data = i.data, l = _i_data.action, m = _i_data.token, g = _i_data.data;
            switch(l){
                case $af8327ccbf59904d$var$a.REGISTER:
                    _this.registry.set(m, 2);
                    break;
                case $af8327ccbf59904d$var$a.DEREGISTER:
                    _this.registry.delete(m);
                    break;
                case $af8327ccbf59904d$var$a.IDLE:
                    _this.idle(m);
                    break;
                case $af8327ccbf59904d$var$a.ACTIVE:
                    _this.active(m);
                    break;
                case $af8327ccbf59904d$var$a.PROMPT:
                    _this.prompt(m);
                    break;
                case $af8327ccbf59904d$var$a.START:
                    _this.start(m);
                    break;
                case $af8327ccbf59904d$var$a.RESET:
                    _this.reset(m);
                    break;
                case $af8327ccbf59904d$var$a.ACTIVATE:
                    _this.activate(m);
                    break;
                case $af8327ccbf59904d$var$a.PAUSE:
                    _this.pause(m);
                    break;
                case $af8327ccbf59904d$var$a.RESUME:
                    _this.resume(m);
                    break;
                case $af8327ccbf59904d$var$a.MESSAGE:
                    _this.options.onMessage(g);
                    break;
            }
        }), this.send($af8327ccbf59904d$var$a.REGISTER);
    }
    (0, $85qwq._)(Ae, [
        {
            key: "isLeader",
            get: function get() {
                if (!this.elector) throw new Error('❌ Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
                return this.elector.isLeader;
            }
        },
        {
            key: "prompt",
            value: function prompt() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.registry.set(e, 0);
                var n = (0, $h9dQc._)(this.registry.values()).every(function(i) {
                    return i === 0;
                });
                e === this.token && this.send($af8327ccbf59904d$var$a.PROMPT), n && this.options.onPrompt();
            }
        },
        {
            key: "idle",
            value: function idle() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.registry.set(e, 2);
                var n = (0, $h9dQc._)(this.registry.values()).every(function(i) {
                    return i === 2;
                });
                e === this.token && this.send($af8327ccbf59904d$var$a.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
            }
        },
        {
            key: "active",
            value: function active() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(e, 1);
                var n = (0, $h9dQc._)(this.registry.values()).some(function(i) {
                    return i === 1;
                });
                e === this.token && this.send($af8327ccbf59904d$var$a.ACTIVE), n && this.options.onActive(), this.isLastActive = e === this.token;
            }
        },
        {
            key: "start",
            value: function start() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($af8327ccbf59904d$var$a.START) : this.options.start(!0), this.isLastActive = e === this.token;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($af8327ccbf59904d$var$a.RESET) : this.options.reset(!0), this.isLastActive = e === this.token;
            }
        },
        {
            key: "activate",
            value: function activate() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($af8327ccbf59904d$var$a.ACTIVATE) : this.options.activate(!0), this.isLastActive = e === this.token;
            }
        },
        {
            key: "pause",
            value: function pause() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                e === this.token ? this.send($af8327ccbf59904d$var$a.PAUSE) : this.options.pause(!0);
            }
        },
        {
            key: "resume",
            value: function resume() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.token;
                e === this.token ? this.send($af8327ccbf59904d$var$a.RESUME) : this.options.resume(!0);
            }
        },
        {
            key: "message",
            value: function message(e) {
                try {
                    this.channel.postMessage({
                        action: $af8327ccbf59904d$var$a.MESSAGE,
                        token: this.token,
                        data: e
                    });
                } catch (e) {}
            }
        },
        {
            key: "send",
            value: function send(e) {
                try {
                    this.channel.postMessage({
                        action: e,
                        token: this.token
                    });
                } catch (e) {}
            }
        },
        {
            key: "close",
            value: function close() {
                this.options.leaderElection && this.elector.close(), this.send($af8327ccbf59904d$var$a.DEREGISTER), this.channel.close();
            }
        }
    ]);
    return Ae;
}();
var $af8327ccbf59904d$var$lt = $af8327ccbf59904d$var$A ? document : null, $af8327ccbf59904d$export$1b94debb2480fd98 = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange",
    "focus"
];
function $af8327ccbf59904d$var$ct(t, e) {
    var i = function i() {
        for(var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++){
            l[_key] = arguments[_key];
        }
        n && clearTimeout(n), n = setTimeout(function() {
            t.apply(void 0, (0, $h9dQc._)(l)), n = null;
        }, e);
    };
    var n;
    return i.cancel = function() {
        clearTimeout(n);
    }, i;
}
function $af8327ccbf59904d$var$Ie(t, e) {
    var n = 0;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var l = new Date().getTime();
        if (!(l - n < e)) return n = l, t.apply(void 0, (0, $h9dQc._)(i));
    };
}
var $af8327ccbf59904d$var$T = function() {
    return Date.now();
};
var $af8327ccbf59904d$var$Z = 2147483647;
function $af8327ccbf59904d$export$3e1c2ef16041091f() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.timeout, t = tmp === void 0 ? 1200000 : tmp, tmp1 = _ref.promptTimeout, e = tmp1 === void 0 ? 0 : tmp1, tmp2 = _ref.promptBeforeIdle, n = tmp2 === void 0 ? 0 : tmp2, tmp3 = _ref.element, i = tmp3 === void 0 ? $af8327ccbf59904d$var$lt : tmp3, tmp4 = _ref.events, l = tmp4 === void 0 ? $af8327ccbf59904d$export$1b94debb2480fd98 : tmp4, m = _ref.timers, tmp5 = _ref.immediateEvents, g = tmp5 === void 0 ? [] : tmp5, tmp6 = _ref.onPresenceChange, R = tmp6 === void 0 ? function() {} : tmp6, tmp7 = _ref.onPrompt, B = tmp7 === void 0 ? function() {} : tmp7, tmp8 = _ref.onIdle, p = tmp8 === void 0 ? function() {} : tmp8, tmp9 = _ref.onActive, c = tmp9 === void 0 ? function() {} : tmp9, tmp10 = _ref.onAction, f = tmp10 === void 0 ? function() {} : tmp10, tmp11 = _ref.onMessage, d = tmp11 === void 0 ? function() {} : tmp11, tmp12 = _ref.debounce, h = tmp12 === void 0 ? 0 : tmp12, tmp13 = _ref.throttle, o = tmp13 === void 0 ? 0 : tmp13, tmp14 = _ref.eventsThrottle, V = tmp14 === void 0 ? 200 : tmp14, tmp15 = _ref.startOnMount, w = tmp15 === void 0 ? !0 : tmp15, tmp16 = _ref.startManually, _ = tmp16 === void 0 ? !1 : tmp16, tmp17 = _ref.stopOnIdle, ce = tmp17 === void 0 ? !1 : tmp17, tmp18 = _ref.crossTab, Y = tmp18 === void 0 ? !1 : tmp18, tmp19 = _ref.name, Oe = tmp19 === void 0 ? "idle-timer" : tmp19, tmp20 = _ref.syncTimers, ee = tmp20 === void 0 ? 0 : tmp20, tmp21 = _ref.leaderElection, Ce = tmp21 === void 0 ? !1 : tmp21;
    var Re = (0, $4CEbD.useRef)($af8327ccbf59904d$var$T()), ue = (0, $4CEbD.useRef)($af8327ccbf59904d$var$T()), L = (0, $4CEbD.useRef)(null), S = (0, $4CEbD.useRef)(null), F = (0, $4CEbD.useRef)(0), te = (0, $4CEbD.useRef)(0), D = (0, $4CEbD.useRef)(0), x = (0, $4CEbD.useRef)(0), v = (0, $4CEbD.useRef)(!1), b = (0, $4CEbD.useRef)(!1), H = (0, $4CEbD.useRef)(!1), U = (0, $4CEbD.useRef)(!0), re = (0, $4CEbD.useRef)(!1), N = (0, $4CEbD.useRef)(null), s = (0, $4CEbD.useRef)(null), O = (0, $4CEbD.useRef)(t), G = (0, $4CEbD.useRef)(0);
    (0, $4CEbD.useEffect)(function() {
        if (e && console.warn("⚠️ IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), n && e) throw new Error("❌ Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
        if (t >= $af8327ccbf59904d$var$Z) throw new Error("❌ The value for the timeout property must fit in a 32 bit signed integer, ".concat($af8327ccbf59904d$var$Z, "."));
        if (e >= $af8327ccbf59904d$var$Z) throw new Error("❌ The value for the promptTimeout property must fit in a 32 bit signed integer, ".concat($af8327ccbf59904d$var$Z, "."));
        if (n >= $af8327ccbf59904d$var$Z) throw new Error("❌ The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ".concat($af8327ccbf59904d$var$Z, "."));
        if (n >= t) throw new Error("❌ The value for the promptBeforeIdle property must be less than the timeout property, ".concat(t, "."));
        if (n ? (O.current = t - n, G.current = n) : (O.current = t, G.current = e), !U.current) {
            if (_) return;
            v.current && (J.current(null, P), s.current && s.current.active()), X();
        }
    }, [
        t,
        e,
        n,
        _
    ]);
    var De = (0, $4CEbD.useRef)(ce);
    (0, $4CEbD.useEffect)(function() {
        De.current = ce;
    }, [
        ce
    ]);
    var He = (0, $4CEbD.useRef)(g), ne = (0, $4CEbD.useRef)(i), be = (0, $4CEbD.useRef)((0, $h9dQc._)(new Set((0, $h9dQc._)(l).concat((0, $h9dQc._)(g))).values())), ie = (0, $4CEbD.useRef)(R);
    (0, $4CEbD.useEffect)(function() {
        ie.current = R;
    }, [
        R
    ]);
    var me = (0, $4CEbD.useRef)(B);
    (0, $4CEbD.useEffect)(function() {
        me.current = B;
    }, [
        B
    ]);
    var de = (0, $4CEbD.useRef)(p);
    (0, $4CEbD.useEffect)(function() {
        de.current = p;
    }, [
        p
    ]);
    var J = (0, $4CEbD.useRef)(c);
    (0, $4CEbD.useEffect)(function() {
        J.current = c;
    }, [
        c
    ]);
    var pe = (0, $4CEbD.useRef)(f);
    (0, $4CEbD.useEffect)(function() {
        pe.current = f;
    }, [
        f
    ]);
    var z = (0, $4CEbD.useRef)(d);
    (0, $4CEbD.useEffect)(function() {
        z.current = d;
    }, [
        d
    ]);
    var q = (0, $4CEbD.useMemo)(function() {
        var r = function(M, K) {
            return pe.current(M, K);
        };
        return h > 0 ? $af8327ccbf59904d$var$ct(r, h) : o > 0 ? $af8327ccbf59904d$var$Ie(r, o) : r;
    }, [
        o,
        h
    ]), Ne = (0, $4CEbD.useRef)();
    (0, $4CEbD.useEffect)(function() {
        Y && ee && (Ne.current = $af8327ccbf59904d$var$Ie(function() {
            s.current.active();
        }, ee));
    }, [
        Y,
        ee
    ]);
    var C = function() {
        N.current !== null && ($af8327ccbf59904d$var$E.clearTimeout(N.current), N.current = null);
    }, j = function(r) {
        var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        C(), N.current = $af8327ccbf59904d$var$E.setTimeout(ye, r || O.current), M && (S.current = $af8327ccbf59904d$var$T());
    }, _e = function(r) {
        !b.current && !v.current && (me.current(r, P), ie.current({
            type: "active",
            prompted: !0
        }, P)), x.current = 0, D.current = $af8327ccbf59904d$var$T(), b.current = !0, j(G.current, !1);
    }, Fe = function() {
        C(), v.current || (de.current(null, P), ie.current({
            type: "idle"
        }, P)), v.current = !0, L.current = $af8327ccbf59904d$var$T(), De.current ? $() : b.current && (D.current = 0, b.current = !1);
    }, ge = function(r) {
        C(), (v.current || b.current) && (J.current(r, P), ie.current({
            type: "active",
            prompted: !1
        }, P)), b.current = !1, D.current = 0, v.current = !1, F.current += $af8327ccbf59904d$var$T() - L.current, te.current += $af8327ccbf59904d$var$T() - L.current, W(), j();
    }, ye = function(r) {
        if (!v.current) {
            q.cancel && q.cancel();
            var K = $af8327ccbf59904d$var$T() - S.current;
            if (!(O.current + G.current < K) && G.current > 0 && !b.current) {
                s.current ? s.current.prompt() : _e(r);
                return;
            }
            s.current ? s.current.idle() : Fe();
            return;
        }
        s.current ? s.current.active() : ge(r);
    }, we = function(r) {
        if (!w && !S.current && (S.current = $af8327ccbf59904d$var$T(), J.current(null, P)), q(r, P), b.current) return;
        if (C(), !v.current && He.current.includes(r.type)) {
            ye(r);
            return;
        }
        var M = $af8327ccbf59904d$var$T() - S.current;
        if (v.current && !ce || !v.current && M >= O.current) {
            ye(r);
            return;
        }
        H.current = !1, x.current = 0, D.current = 0, j(), Y && ee && Ne.current();
    }, fe = (0, $4CEbD.useRef)(we);
    (0, $4CEbD.useEffect)(function() {
        var r = re.current;
        r && $(), V > 0 ? fe.current = $af8327ccbf59904d$var$Ie(we, V) : fe.current = we, r && W();
    }, [
        V,
        o,
        h,
        pe,
        Y,
        ee
    ]);
    var W = function() {
        !$af8327ccbf59904d$var$A || !ne.current || re.current || (be.current.forEach(function(r) {
            ne.current.addEventListener(r, fe.current, {
                capture: !0,
                passive: !0
            });
        }), re.current = !0);
    }, $ = function() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        !$af8327ccbf59904d$var$A || !ne.current || (re.current || r) && (be.current.forEach(function(M) {
            ne.current.removeEventListener(M, fe.current, {
                capture: !0
            });
        }), re.current = !1);
    }, X = (0, $4CEbD.useCallback)(function(r) {
        C(), W(), v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, s.current && !r && s.current.start(), j();
    }, [
        N,
        v,
        O,
        s
    ]), Le = (0, $4CEbD.useCallback)(function(r) {
        C(), W(), ue.current = $af8327ccbf59904d$var$T(), F.current += $af8327ccbf59904d$var$T() - L.current, te.current += $af8327ccbf59904d$var$T() - L.current, F.current = 0, v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, s.current && !r && s.current.reset(), _ || j();
    }, [
        N,
        v,
        O,
        _,
        s
    ]), Ue = (0, $4CEbD.useCallback)(function(r) {
        C(), W(), (v.current || b.current) && ge(), v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, ue.current = $af8327ccbf59904d$var$T(), s.current && !r && s.current.activate(), j();
    }, [
        N,
        v,
        b,
        O,
        s
    ]), Pe = (0, $4CEbD.useCallback)(function() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        return H.current ? !1 : (x.current = We(), H.current = !0, $(), C(), s.current && !r && s.current.pause(), !0);
    }, [
        N,
        s
    ]), Me = (0, $4CEbD.useCallback)(function() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
        return H.current ? (H.current = !1, b.current || W(), v.current || j(x.current), D.current && (D.current = $af8327ccbf59904d$var$T()), s.current && !r && s.current.resume(), !0) : !1;
    }, [
        N,
        O,
        x,
        s
    ]), ut = (0, $4CEbD.useCallback)(function(r, M) {
        s.current ? (M && z.current(r, P), s.current.message(r)) : M && z.current(r, P);
    }, [
        d
    ]), mt = (0, $4CEbD.useCallback)(function() {
        return v.current;
    }, [
        v
    ]), dt = (0, $4CEbD.useCallback)(function() {
        return b.current;
    }, [
        b
    ]), pt = (0, $4CEbD.useCallback)(function() {
        return s.current ? s.current.isLeader : null;
    }, [
        s
    ]), ft = (0, $4CEbD.useCallback)(function() {
        return s.current ? s.current.isLastActive : null;
    }, [
        s
    ]), ht = (0, $4CEbD.useCallback)(function() {
        return s.current ? s.current.token : null;
    }, [
        s
    ]), We = (0, $4CEbD.useCallback)(function() {
        if (H.current) return x.current;
        var r = x.current ? x.current : G.current + O.current, M = S.current ? $af8327ccbf59904d$var$T() - S.current : 0, K = Math.floor(r - M);
        return K < 0 ? 0 : Math.abs(K);
    }, [
        O,
        G,
        b,
        x,
        S
    ]), Be = (0, $4CEbD.useCallback)(function() {
        return Math.round($af8327ccbf59904d$var$T() - ue.current);
    }, [
        ue
    ]), Ve = (0, $4CEbD.useCallback)(function() {
        return Math.round($af8327ccbf59904d$var$T() - Re.current);
    }, [
        Re
    ]), vt = (0, $4CEbD.useCallback)(function() {
        return L.current ? new Date(L.current) : null;
    }, [
        L
    ]), Tt = (0, $4CEbD.useCallback)(function() {
        return S.current ? new Date(S.current) : null;
    }, [
        S
    ]), Ge = (0, $4CEbD.useCallback)(function() {
        return v.current ? Math.round($af8327ccbf59904d$var$T() - L.current + F.current) : Math.round(F.current);
    }, [
        L,
        F
    ]), qe = (0, $4CEbD.useCallback)(function() {
        return v.current ? Math.round($af8327ccbf59904d$var$T() - L.current + te.current) : Math.round(te.current);
    }, [
        L,
        te
    ]), It = (0, $4CEbD.useCallback)(function() {
        var r = Math.round(Be() - Ge());
        return r >= 0 ? r : 0;
    }, [
        L,
        F
    ]), Et = (0, $4CEbD.useCallback)(function() {
        var r = Math.round(Ve() - qe());
        return r >= 0 ? r : 0;
    }, [
        L,
        F
    ]);
    (0, $4CEbD.useEffect)(function() {
        if (h > 0 && o > 0) throw new Error("❌ onAction can either be throttled or debounced, not both.");
        m && $af8327ccbf59904d$var$it(m);
        var r = function() {
            s.current && s.current.close(), q.cancel && q.cancel(), C(), $(!0);
        };
        return $af8327ccbf59904d$var$A && window.addEventListener("beforeunload", r), function() {
            $af8327ccbf59904d$var$A && window.removeEventListener("beforeunload", r), s.current && s.current.close(), q.cancel && q.cancel(), C(), $(!0);
        };
    }, []), (0, $4CEbD.useEffect)(function() {
        s.current && s.current.close(), Y ? s.current = new $af8327ccbf59904d$var$Ae({
            channelName: Oe,
            leaderElection: Ce,
            onPrompt: function() {
                _e();
            },
            onIdle: function() {
                Fe();
            },
            onActive: function() {
                ge();
            },
            onMessage: function(r) {
                z.current(r, P);
            },
            start: X,
            reset: Le,
            activate: Ue,
            pause: Pe,
            resume: Me
        }) : s.current = null;
    }, [
        Y,
        Oe,
        Ce,
        me,
        de,
        J,
        z,
        X,
        Le,
        Pe,
        Me
    ]), (0, $4CEbD.useEffect)(function() {
        U.current || (C(), $(!0)), !_ && (w ? X() : W());
    }, [
        _,
        w,
        U
    ]), (0, $4CEbD.useEffect)(function() {
        if (!U.current) {
            var r = (0, $h9dQc._)(new Set((0, $h9dQc._)(l).concat((0, $h9dQc._)(g))).values());
            if ($(), be.current = r, ne.current = i, He.current = g, _) return;
            w ? X() : W();
        }
    }, [
        i,
        JSON.stringify(l),
        JSON.stringify(g),
        U,
        _,
        w
    ]), (0, $4CEbD.useEffect)(function() {
        U.current && (U.current = !1);
    }, [
        U
    ]);
    var P = {
        message: ut,
        start: X,
        reset: Le,
        activate: Ue,
        pause: Pe,
        resume: Me,
        isIdle: mt,
        isPrompted: dt,
        isLeader: pt,
        isLastActiveTab: ft,
        getTabId: ht,
        getRemainingTime: We,
        getElapsedTime: Be,
        getTotalElapsedTime: Ve,
        getLastIdleTime: vt,
        getLastActiveTime: Tt,
        getIdleTime: Ge,
        getTotalIdleTime: qe,
        getActiveTime: It,
        getTotalActiveTime: Et,
        setOnPresenceChange: function(r) {
            R = r, ie.current = r;
        },
        setOnPrompt: function(r) {
            B = r, me.current = r;
        },
        setOnIdle: function(r) {
            p = r, de.current = r;
        },
        setOnActive: function(r) {
            c = r, J.current = r;
        },
        setOnAction: function(r) {
            f = r, pe.current = r;
        },
        setOnMessage: function(r) {
            d = r, z.current = r;
        }
    };
    return P;
}
var $af8327ccbf59904d$export$e28ea38f1e83b132 = (0, $4CEbD.createContext)(null);
function $af8327ccbf59904d$export$17ce2adb9f89ccf5(t) {
    var e = $af8327ccbf59904d$export$3e1c2ef16041091f(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement($af8327ccbf59904d$export$e28ea38f1e83b132.Provider, {
        value: e
    }, t.children);
}
var $af8327ccbf59904d$export$ee38aa87a63cd016 = $af8327ccbf59904d$export$e28ea38f1e83b132.Consumer;
function $af8327ccbf59904d$export$1f7d3dee7d83ab6e() {
    return (0, $4CEbD.useContext)($af8327ccbf59904d$export$e28ea38f1e83b132);
}




var $cbe964fae20ec3ab$var$idleTime = 840000;
var $cbe964fae20ec3ab$var$promptTime = 60000;
//import {useTranslation} from "react-i18next";
var $cbe964fae20ec3ab$var$countDownId;
var $cbe964fae20ec3ab$var$IdleTimerComponent = function(param) {
    var children = param.children;
    var dispatch = (0, $b8a3fb33ebd2d3a2$export$8ad76b76a4c905f8)();
    var idleTimerState = (0, $2e074b94551c5d7f$export$2105062e25df4afe)((0, $5ae2f05a62e19741$export$c3aeaf078d419c4b));
    var history = (0, $876a3032fada8974$export$3420e1dc2c4a518c)();
    var location = (0, $876a3032fada8974$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).useEffect(function() {
        if ([
            (0, $6fb258ca9d5a721a$export$500824a38b151028),
            (0, $6fb258ca9d5a721a$export$7aa67dc43ca8e63d)
        ].includes(location.pathname)) {
            dispatch((0, $5ae2f05a62e19741$export$3374cfc036197cff)({
                idleState: "active"
            }));
            pause();
        } else start();
    }, [
        location
    ]);
    var onIdle = function() {
        // Close Modal Prompt
        // Do some idle action like log out your user
        //console.log("onIdle", event);
        dispatch((0, $5ae2f05a62e19741$export$3374cfc036197cff)({
            idleState: "idle"
        }));
        if ($cbe964fae20ec3ab$var$countDownId) clearInterval($cbe964fae20ec3ab$var$countDownId);
        console.log("onIdle CANCEL TEST");
        dispatch((0, $f487fa6abc092388$export$5fd37d90ba0958ec)());
        history.push((0, $6fb258ca9d5a721a$export$500824a38b151028));
    };
    var onActive = function(event) {
        // Close Modal Prompt
        // Do some active action
        //console.log("onActive", event);
        dispatch((0, $5ae2f05a62e19741$export$3374cfc036197cff)({
            idleState: "active"
        }));
    };
    var onAction = function(event) {
        // Close Modal Prompt
        // Do some active action
        //console.log("onAction", idleTimerState);
        if (idleTimerState.idleState === "prompted") {
            reset();
            if ($cbe964fae20ec3ab$var$countDownId) clearInterval($cbe964fae20ec3ab$var$countDownId);
            dispatch((0, $5ae2f05a62e19741$export$3374cfc036197cff)({
                idleState: "active"
            }));
        }
    };
    var onPrompt = function(event) {
        // Close Modal Prompt
        // Do some active action
        //console.log("onPrompt", event);
        dispatch((0, $5ae2f05a62e19741$export$3374cfc036197cff)({
            idleState: "prompted"
        }));
        $cbe964fae20ec3ab$var$countDownId = setInterval(function() {
            // eslint-disable-next-line no-use-before-define
            dispatch((0, $5ae2f05a62e19741$export$afe2734416016192)({
                timeLeft: getRemainingTime()
            }));
        }, 1000);
    };
    var _useIdleTimer = (0, $af8327ccbf59904d$export$3e1c2ef16041091f)({
        onIdle: onIdle,
        onActive: onActive,
        onAction: onAction,
        onPrompt: onPrompt,
        crossTab: true,
        timers: (0, $af8327ccbf59904d$export$427b263b93108fff),
        timeout: $cbe964fae20ec3ab$var$idleTime,
        promptTimeout: $cbe964fae20ec3ab$var$promptTime
    }), start = _useIdleTimer.start, pause = _useIdleTimer.pause, reset = _useIdleTimer.reset, getRemainingTime = _useIdleTimer.getRemainingTime;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).Fragment, null, children);
};
var $cbe964fae20ec3ab$export$32e97eb3036d7c1e = $cbe964fae20ec3ab$var$IdleTimerComponent;


var $616d8b7699cc647c$var$App = function() {
    var t = (0, $dbc25c2fc17f7e09$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $307ac207d321399d$export$2e2bcd8739ae039), {
        store: (0, $93dee004cba920da$export$6f57813fe9f31bf9)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $7fff4eb77929b32b$export$311ca220e7478cda), {
        loading: null,
        persistor: (0, $93dee004cba920da$export$7b682ac9934ca3e4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $5e43d30989714aad$export$4719288a8f5f7e71), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $5e43d30989714aad$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("title", null, t("app.name") + " – " + t("app.subname")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "IE=edge,chrome=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "theme-color",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "msapplication-navbutton-color",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "apple-mobile-web-app-status-bar-style",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "author",
        content: "Transporter – Creating Your Web"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "publisher",
        content: "Transporter – Creating Your Web"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("meta", {
        name: "copyright",
        content: "Transporter – Creating Your Web"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $d3480d02564f6028$export$9ba4e89fdfa1fc54), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $8e2a084d93237cf3$export$e926676385687eaf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $cbe964fae20ec3ab$export$32e97eb3036d7c1e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "modals"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $bb310dbd5417ffed$export$2b77a92f1a5ad772), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "header",
        id: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $aab47fbd9aba43d1$exports.NavigationBar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement("div", {
        className: "layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $1dc662ec593f833a$export$3565eb3d00ca5a74), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $bff1c097ab7df2f7$export$2e2bcd8739ae039), {
        type: "light",
        className: "tooltip",
        multiline: true,
        delayShow: 100,
        delayHide: 0,
        padding: "100px 100px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $ec338fd80aa0d890$export$9689b5d1b3e00abd), null))))));
};
var $616d8b7699cc647c$export$2e2bcd8739ae039 = $616d8b7699cc647c$var$App;




var $91b08b60dac0174e$var$arr = [];
var $91b08b60dac0174e$var$each = $91b08b60dac0174e$var$arr.forEach;
var $91b08b60dac0174e$var$slice = $91b08b60dac0174e$var$arr.slice;
function $91b08b60dac0174e$var$defaults(obj) {
    $91b08b60dac0174e$var$each.call($91b08b60dac0174e$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $91b08b60dac0174e$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $91b08b60dac0174e$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$91b08b60dac0174e$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$91b08b60dac0174e$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $91b08b60dac0174e$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $91b08b60dac0174e$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $91b08b60dac0174e$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $91b08b60dac0174e$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $91b08b60dac0174e$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $91b08b60dac0174e$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $91b08b60dac0174e$var$hasLocalStorageSupport = null;
var $91b08b60dac0174e$var$localStorageAvailable = function localStorageAvailable() {
    if ($91b08b60dac0174e$var$hasLocalStorageSupport !== null) return $91b08b60dac0174e$var$hasLocalStorageSupport;
    try {
        $91b08b60dac0174e$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $91b08b60dac0174e$var$hasLocalStorageSupport = false;
    }
    return $91b08b60dac0174e$var$hasLocalStorageSupport;
};
var $91b08b60dac0174e$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $91b08b60dac0174e$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $91b08b60dac0174e$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $91b08b60dac0174e$var$hasSessionStorageSupport = null;
var $91b08b60dac0174e$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($91b08b60dac0174e$var$hasSessionStorageSupport !== null) return $91b08b60dac0174e$var$hasSessionStorageSupport;
    try {
        $91b08b60dac0174e$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $91b08b60dac0174e$var$hasSessionStorageSupport = false;
    }
    return $91b08b60dac0174e$var$hasSessionStorageSupport;
};
var $91b08b60dac0174e$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $91b08b60dac0174e$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $91b08b60dac0174e$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $91b08b60dac0174e$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $91b08b60dac0174e$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $91b08b60dac0174e$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $91b08b60dac0174e$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $91b08b60dac0174e$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $91b08b60dac0174e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6b275e1774206313$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $c04b6f52cb4211ea$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $91b08b60dac0174e$var$defaults(options, this.options || {}, $91b08b60dac0174e$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($91b08b60dac0174e$var$cookie$1);
                this.addDetector($91b08b60dac0174e$var$querystring);
                this.addDetector($91b08b60dac0174e$var$localStorage);
                this.addDetector($91b08b60dac0174e$var$sessionStorage);
                this.addDetector($91b08b60dac0174e$var$navigator$1);
                this.addDetector($91b08b60dac0174e$var$htmlTag);
                this.addDetector($91b08b60dac0174e$var$path);
                this.addDetector($91b08b60dac0174e$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$91b08b60dac0174e$export$2e2bcd8739ae039.type = "languageDetector";



var $4CEbD = parcelRequire("4CEbD");

var $56e7953809b2ff81$exports = {};
$56e7953809b2ff81$exports = JSON.parse('{"app.name":"Lerche","app.subname":"Lesediagnose","error.errorHTML":"<h2>Leider ist ein Fehler aufgetreten. Bitte konktatieren sie einen Adminstrator und \xfcbermitteln folgende Informationen</h2>","error.connectingToServer":"Fehler bei der Kommunikation mit dem Server","error.communicatingWithServer":"Fehler bei der Kommunikation mit dem Server","error.restartButton.caption":"Die Seite neu starten","error.systemReseted.message":"Seite wurde neu gestartet","Can\'t find the session.":"Der Test mit diesem Session–Code ist nicht vorhanden","No test found.":"Der Test mit diesem Test–Code ist nicht vorhanden","sectionProgress.first.caption":"Deine Daten","sectionProgress.result.caption":"Ergebnis","sectionProgress.caption":"Abschnitt","testPage.testName.caption":"Test","testPage.testId.caption":"Session–Code","testPage.nextSectionButton.caption":"Zum n\xe4chsten Abschnitt","testPage.meta.nextSectionButton.caption":"Los geht\'s!","testPage.finishTestButton.caption":"Zum Ergebnis","testPage.session-Code.copied":"Session-Code wurde in die Zwischenablage kopiert","testPage.textRaedButton.info":"Hast du alles gelesen?","testPage.textRaedButton.caption":"Zu den Fragen","testPage.prevButton.caption":"Zur vorherigen Frage","testPage.nextButton.caption":"Zur n\xe4chsten Frage","testPage.answeredAllQuestions.text":"Hast du alle Fragen beantwortet?","testPage.answeredAllQuestionsMeta.text":"Hast du alles ausgef\xfcllt","testPage.default.section.intro":"Bitte lies dir den Text auf der linken Seite gut durch. Klicke anschlie\xdfend auf den Button unter dem Text.","testPage.meta.section.intro":"Bevor der Test beginnt, braucht es noch ein paar Daten von dir. Bitte w\xe4hle sorgf\xe4ltig aus!","modal.help.caption":"Hilfe","modal.help.content":"<p class=\\"mb-lh\\">Bei diesem Test musst du Fragen zu verschiedenen Texten beantworten. Im linken Bereich erscheint der Text, im rechten die Fragen. Insgesamt sind es f\xfcnf Abschnitte (A, B, C, D, E), die du bearbeiten musst.</p><div class=\\"content notification is-info is-light\\"><p class=\\"has-text-weight-bold\\">Diese Tipps sollen dir dabei helfen:</p><ul><li>Wechsle nicht von einem Abschnitt zum n\xe4chsten, ohne die Fragen zu beantworten!</li><li>Es ist nicht schlimm, wenn du mal eine Frage nicht beantworten kannst. Klicke einfach weiter.</li><li>Auch mehrere L\xf6sungen k\xf6nnen richtig sein. \xdcberlege genau!</li><li>Versuche, den gesamten Test ohne Unterbrechung durchzuf\xfchren.</li></ul></div>","modal.nextSection.content":"Hast du alle Fragen beantwortet und m\xf6chtest nichts mehr \xe4ndern?","modal.nextSection.submitButton.caption":"Ok, weiter","modal.nextSection.cancelButton.caption":"Hoppla, zur\xfcck","modal.abortTest.caption":"Test abbrechen","modal.abortTest.content.init":"Achtung!","modal.abortTest.content":"Wenn du den Test abbrichst, geht dein Fortschritt verloren!","modal.abortTest.submitButton.caption":"Test abbrechen","modal.abortTest.cancelButton.caption":"Zur\xfcck zum Test","navigation.home.caption":"Startseite","navigation.startTest.caption":"Test starten","navigation.toTest.caption":"Zum Test","navigation.cancelTest.caption":"Test abbrechen","navigation.finishTest.caption":"Test abschlie\xdfen","navigation.logout.message1":"Du wirst in  ","navigation.logout.message2":" Sekunden automatisch abgemeldet.","navigation.more.caption":"Mehr","navigation.impress.caption":"Impressum","navigation.privacyPolicy.caption":"Datenschutzerkl\xe4rung","navigation.help.caption":"Hilfe","startTestPage.intro1":"<h1>Bevor du mit dem Test startest!</h1><div class=\'notification is-info 0is-light my-lh\'><p>Bitte lies dir die Anleitung gut durch. Ganz unten kannst du den Test starten.</p></div>","startTestPage.intro2":"<div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-one\'></span> Deine Daten</p><h2 class=\'is-info\'>Wer bist du?</h2><p>Am Beginn des Tests fragen wir dich nach einigen wichtigen Daten. Die brauchen wir f\xfcr die Auswertung.</p></div><div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-two\'></span> Der Lesetest</p><h2 class=\'is-info\'>Lesen und Fragen beantworten</h2><p>W\xe4hrend des Tests siehst du auf der linken Seite einen Text und auf der rechten Seite die Fragen. Versuche, die passende Antwort zu finden. Die Antwort ergibt sich direkt aus dem Text, aber manchmal musst du auch kombinieren.</p><p>Diese Punkte sind wichtig:</p><div class=\'notification is-info is-light\'><p class=\'has-text-weight-bold\'>Es k\xf6nnen eine oder auch mehrere Antworten richtig sein.<br/>Ist eine Frage zu schwer, kannst du auch ohne Antwort weiterklicken.</p></div></div><div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-three\'></span> Dein Ergebnis</p><h2 class=\'is-info\'>So gut kannst du lesen</h2><p>Am Ende des Tests zeigen wir dir dein Ergebnis und geben dir Tipps wie du im Lesen noch besser werden kannst.</p></div>","startTestPage.inputNumber.caption":"Jetzt gehts los!","startTestPage.inputNumber.text":"Bitte gib den Test-Code ein, den dir deine Lehrerin oder dein Lehrer gegeben hat.","startTestPage.submitButton.caption":"Test starten","startTestPage.message.testStarted":"Der Test wurde erfolgreich gestartet!","startTestPage.message.testResumed":"Der Test wird fortgef\xfchrt!","startTestPage.error.testcode":"Dieser Testcode ist ung\xfcltig. Bitte gib den Test-Code ein, den dir deine Lehrerin oder dein Lehrer gegeben hat.","abortTest.testWasAborted.message":"Der Test wurde abgebrochen","abortTest.testWasFinished.message":"Der Test wurde abgeschlossen","testcodeField.helpText":"Bitte gib einen g\xfcltigen Test-Code ein.","testResultPage.intro":"<h1>Geschafft!</h1>","testResultPage.nextStep.info":"Was willst du machen?","testResultPage.printButton.caption":"Mein Ergebnis drucken","testResultPage.pdfButton.caption":"Ergebnis herunterladen","testResultPage.newTestButton.caption":"Zur Startseite","help.caption":"Hilfe","privacyPoliy.text":"<div class=“content is-max-tablet”><h1>Datenschutzerkl\xe4rung</h1><h3>1. Datenschutzrechtlicher Verantwortlicher</h3><p><span class=“is-uppercase”>Jung\xf6sterreich</span> Zeitschriftenverlag GmbH &amp; Co KG<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Tel: +43 512 587205-0<br/>E-Mail: <a href=\'mailto:datenschutz@jungoesterreich.at\'>datenschutz@jungoesterreich.at</a></p><p>Rechtsform: Kommanditgesellschaft<br/>FN 209942 p Landesgericht Innsbruck</p><h3>2. Allgemeines</h3><p>Es ist uns wichtig, dass Sie bei der Nutzung unseres Angebots auf die Einhaltung des Datenschutzes gem\xe4\xdf den gesetzlichen Bestimmungen bzw. der EU-Datenschutz-Grundverordnung (DSGVO) vertrauen k\xf6nnen und wissen, welche personenbezogenen Daten wir w\xe4hrend Ihres Besuchs dieser Website und bei der Inanspruchnahme unseres Angebots erheben und wie wir diese nutzen. Dar\xfcber informieren wir Sie in den nachfolgenden Hinweisen. </p><h3>3. Verarbeitungszwecke</h3><p>\xdcber die Internetseite lerche-lesediagnose.at stellen wir Ihnen das Werkzeug „LERCHE – Die Lesediagnose” in Form einer Website zur Verf\xfcgung. Dazu verarbeiten wir Ihre personenbezogenen Daten zu folgenden Zwecken:</p><p>A) Anzeige der Website<br/>B) Testaktivierung<br/>C) Testdurchf\xfchrung</p><p>Die Verarbeitungen st\xfctzen sich auf den Rechtm\xe4\xdfigkeitsgrund „Vertragserf\xfcllung” gem. Art. 6 Abs. 1 lit. b DSGVO. Wenn Sie uns die f\xfcr die Verarbeitung notwendigen Daten nicht zur Verf\xfcgung stellen, k\xf6nnen Sie „LERCHE – Die Lesediagnose” nicht nutzen.</p><h4>A) Anzeige der Website</h4><p>Wir erheben bei der Nutzung der Website folgende personenbezogenen Daten:</p><ul><li>IP-Adresse des Nutzers</li><li>Datum, Uhrzeit der Anfrage</li><li>Inhalt (angezeigte Seite)</li><li>Zugriffsstatus (http-Statuscode)</li><li>\xdcbertragene Datenmenge</li><li>Verwendetes Betriebssystem</li><li>Sprache, Version der verwendeten Browser-Software</li></ul><p>Die Verarbeitung dieser Daten ist zur Anzeige der Website und f\xfcr die Aufrechterhaltung der IT-Sicherheit notwendig.</p><h4>B) Testaktivierung</h4><p>Wir verarbeiten bei der Testaktivierung nur den eingegebenen Test-Code, um jeden Test eindeutig zuzuordnen.</p><h4>C) Testdurchf\xfchrung</h4><p>Vor und w\xe4hrend der Durchf\xfchrung des Tests verarbeiten wir folgende Daten:</p><ul><li>Test-Code</li><li>Schulstufe</li><li>Schultyp</li><li>Geschlecht</li><li>Alter</li><li>Sprache</li><li>Sozio Economic Status</li></ul><p>Wir speichern die Eingaben und das Ergebnis eines Tests in einer Datenbank. Dies erfolgt pseudonymisiert durch die Zuordnung zu einem Test-Code.</p><h3>4. Verwendung von Cookies</h3><p>Wir verwenden ausschlie\xdflich Cookies, die dazu dienen, die Funktionen der Website und die erfolgreiche Durchf\xfchrung des Tests zu gew\xe4hrleisten.</p><h3>5. Empf\xe4nger von Daten</h3><p>Die erhobenen und berechneten Daten der durchgef\xfchrten Tests (siehe Punkt 6.) bleiben auf der Testplattform pseudonymisiert gespeichert (siehe Punkt C).</p><h5>Auftragsverarbeiter</h5><p>F\xfcr den Schutz Ihrer Daten bleiben wir auch bei Heranziehung eines Auftragsverarbeiters verantwortlich. Als Auftragsverarbeiter ziehen wir als Webhoster Amazon Web Services (<a href=\'http://aws.amazon.com/de/\'>aws.amazon.com/de/</a>) und als Dienstleister f\xfcr die Erstellung und Fehlerbehebung der Lesediagnose-Applikation die Transporter Werbeagentur (<a href=\'http://transporter.at\'>transporter.at</a>) hinzu.</p><h3>6. Datensicherheit</h3><p>Die von uns erhobenen und verarbeiteten Daten werden vertraulich behandelt und durch geeignete und angemessene technische und organisatorische Vorkehrungen vor Verlust und Ver\xe4nderungen sowie dem unberechtigten Zugriff Dritter gesch\xfctzt.</p><h3>7. Automatisierte Entscheidung und Profiling</h3><p>Es finden weder eine automatisierte Entscheidungsfindung noch Profiling statt. Die Beurteilung der Teilnehmer erfolgt in pseudonymisierter Form. Nach Durchf\xfchrung des Tests wird das Ergebnis online angezeigt. Ein sp\xe4terer R\xfcckschluss auf die Testperson ist nicht m\xf6glich.</p><h3>8. Betroffenenrechte</h3><p>Soweit die gesetzlichen Voraussetzungen nach den Art. 15. bis 22. DSGVO vorliegen, haben Sie hinsichtlich Ihrer bei uns verarbeiteten personenbezogenen Daten folgende Rechte (sog. Betroffenenrechte):</p><p>Sie k\xf6nnen jederzeit bei uns Auskunft dar\xfcber verlangen, ob personenbezogene Daten und welche Kategorien personenbezogener Daten \xfcber Sie bei uns gespeichert sind, zu welchen Zwecken diese verarbeitet werden und welche Empf\xe4nger oder Kategorien von Empf\xe4ngern diese ggf. erhalten. Ferner k\xf6nnen Sie die weiteren in Art. 15. DSGVO aufgez\xe4hlten Informationen zu Ihren personenbezogenen Daten bei uns erfragen (Recht auf Auskunft).</p><p>Gem\xe4\xdf den gesetzlichen Voraussetzungen haben Sie au\xdferdem ein Recht auf Berichtigung (Art. 16. DSGVO), ein Recht auf L\xf6schung (Art. 17. DSGVO), ein Recht auf Einschr\xe4nkung der Verarbeitung (Sperrung) (Art. 18. DSGVO) sowie ein Recht auf Widerspruch (Art. 21 DSGVO) Ihrer personenbezogenen Daten.</p><p>Sie haben weiter gem\xe4\xdf Art. 20. DSGVO das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von uns zu erhalten; Sie k\xf6nnen diese personenbezogenen Daten auch an andere Verantwortliche \xfcbermitteln oder \xfcbermitteln lassen (Recht auf Daten\xfcbertragbarkeit).</p><p>Sie haben auch Anspruch auf jederzeitigen Widerruf Ihrer erteilten Einwilligungen.</p><p>Dar\xfcber hinaus haben Sie das Recht, bei Datenverarbeitungen, die nach Art. 6 Abs. 1. lit. f) DSGVO auf den berechtigten Interessen des Verantwortlichen oder eines Dritten beruhen (vgl. Ziffern 3. a. bis e. sowie Ziffern 4. a. bis e.), bei Vorliegen der gesetzlichen Voraussetzungen nach Art. 21. DSGVO der Datenverarbeitung zu widersprechen.</p><p>Zur Geltendmachung Ihrer Betroffenenrechte k\xf6nnen Sie sich jederzeit unter <a href=\'mailto:datenschutz@jungoesterreich.at”>datenschutz@jungoesterreich.at</a> an uns wenden.</p><p>Sie haben gem\xe4\xdf Art. 77. Abs. 1 DSGVO au\xdferdem das Recht, sich bei einer Aufsichtsbeh\xf6rde zu beschweren, wenn Sie der Ansicht sein sollten, dass die Verarbeitung Ihrer personenbezogenen Daten gegen das Datenschutzrecht verst\xf6\xdft. In \xd6sterreich ist dies die Datenschutzbeh\xf6rde:</p><p>\xd6sterreichische Datenschutzbeh\xf6rde<br/>Barichgasse 40-42<br/>1030 Wien</p></div>","impress.text":"<div class=“content is-max-tablet”><h1>Impressum</h1><p>lerche-lesediagnose.at, eine Website bzw. ein Dienst von</p><h3>„Jung\xf6sterreich”</h3><p>Zeitschriftenverlag GmbH &amp; Co KG<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Tel: +43 512 587205<br/>E-Mail: <a href=“mailto:info@jungoesterreich.at”>info@jungoesterreich.at</a></p><p>Rechtsform: Kommanditgesellschaft<br/>FN 209942 p Landesgericht Innsbruck<br/>UID-Nr. ATU52100006</p><h3>Unbeschr\xe4nkt haftende Gesellschafterin</h3><p>„Jung\xf6sterreich”<br/>Zeitschriftenverlag GmbH<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Rechtsform: Gesellschaft mit beschr\xe4nkter Haftung<br/>FN 209506 y Landesgericht Innsbruck </p><h3>Herausgeberin</h3><p>Kathrin-Theresa Madl</p><h3>Gesch\xe4ftsf\xfchrung</h3><p>Kathrin-Theresa Madl, Dr. Christoph Schreder</p><h3>Mitherausgeber</h3><p>SOS-Kinderdorf (Gemeinn\xfctziger Verein), Mag. Nora Deinhammer, Stafflerstra\xdfe 10a, 6020 Innsbruck<br/>WWF \xd6sterreich (Gemeinn\xfctziger Verein), Mag. Andrea Johanides, Ottakringer Stra\xdfe 114–116, 1160 Wien</p></div>","yearMonthField_student_birthmonth_caption":"Monat","yearMonthField_student_birthyear_caption":"Jahr","yearMonthField_student_birthmonth_1":"J\xe4nner","yearMonthField_student_birthmonth_2":"Februar","yearMonthField_student_birthmonth_3":"M\xe4rz","yearMonthField_student_birthmonth_4":"April","yearMonthField_student_birthmonth_5":"Mai","yearMonthField_student_birthmonth_6":"Juni","yearMonthField_student_birthmonth_7":"Juli","yearMonthField_student_birthmonth_8":"August","yearMonthField_student_birthmonth_9":"September","yearMonthField_student_birthmonth_10":"Oktober","yearMonthField_student_birthmonth_11":"November","yearMonthField_student_birthmonth_12":"Dezember"}');



//import common_en from "./translations/en/common.json";
(0, $f8f1d5b7157aea63$export$2e2bcd8739ae039).use((0, $b4ff156111e82d24$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.use((0, $91b08b60dac0174e$export$2e2bcd8739ae039)) // options see https://github.com/i18next/i18next-browser-languageDetector
.init({
    resources: {
        de: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($56e7953809b2ff81$exports)))
        }
    },
    //lng: "de", // if you're using a language detector, do not define the lng option
    fallbackLng: "de",
    debug: false,
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});
//console.log("i18n.language", i18n.language);
(0, (/*@__PURE__*/$parcel$interopDefault($97c8887f441e3eff$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).StrictMode, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $ab097cf8c16e418a$export$1325e8699caa160f), {
    i18n: (0, $f8f1d5b7157aea63$export$2e2bcd8739ae039)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4CEbD))).createElement((0, $616d8b7699cc647c$export$2e2bcd8739ae039), null))), document.getElementById("root"));

})();
//# sourceMappingURL=index.9d3b525e.js.map
